var ca = Object.defineProperty;
var fa = (t, e, i) => e in t ? ca(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i;
var Ge = (t, e, i) => fa(t, typeof e != "symbol" ? e + "" : e, i);
function ve() {
}
const Gt = (t) => t;
function oi(t, e) {
  for (const i in e) t[i] = e[i];
  return (
    /** @type {T & S} */
    t
  );
}
function vr(t) {
  return t();
}
function Zi() {
  return /* @__PURE__ */ Object.create(null);
}
function He(t) {
  t.forEach(vr);
}
function ot(t) {
  return typeof t == "function";
}
function ce(t, e) {
  return t != t ? e == e : t !== e || t && typeof t == "object" || typeof t == "function";
}
let ei;
function Ot(t, e) {
  return t === e ? !0 : (ei || (ei = document.createElement("a")), ei.href = e, t === ei.href);
}
function ga(t) {
  return Object.keys(t).length === 0;
}
function ha(t, ...e) {
  if (t == null) {
    for (const n of e)
      n(void 0);
    return ve;
  }
  const i = t.subscribe(...e);
  return i.unsubscribe ? () => i.unsubscribe() : i;
}
function ma(t, e, i) {
  t.$$.on_destroy.push(ha(e, i));
}
function oe(t, e, i, n) {
  if (t) {
    const l = br(t, e, i, n);
    return t[0](l);
  }
}
function br(t, e, i, n) {
  return t[1] && n ? oi(i.ctx.slice(), t[1](n(e))) : i.ctx;
}
function re(t, e, i, n) {
  if (t[2] && n) {
    const l = t[2](n(i));
    if (e.dirty === void 0)
      return l;
    if (typeof l == "object") {
      const o = [], r = Math.max(e.dirty.length, l.length);
      for (let a = 0; a < r; a += 1)
        o[a] = e.dirty[a] | l[a];
      return o;
    }
    return e.dirty | l;
  }
  return e.dirty;
}
function ae(t, e, i, n, l, o) {
  if (l) {
    const r = br(e, i, n, o);
    t.p(r, l);
  }
}
function se(t) {
  if (t.ctx.length > 32) {
    const e = [], i = t.ctx.length / 32;
    for (let n = 0; n < i; n++)
      e[n] = -1;
    return e;
  }
  return -1;
}
function pt(t) {
  const e = {};
  for (const i in t)
    e[i] = !0;
  return e;
}
function Ee(t) {
  return t ?? "";
}
function Fi(t) {
  return t && ot(t.destroy) ? t.destroy : ve;
}
function Ui(t) {
  const e = typeof t == "string" && t.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return e ? [parseFloat(e[1]), e[2] || "px"] : [
    /** @type {number} */
    t,
    "px"
  ];
}
const pr = typeof window < "u";
let _i = pr ? () => window.performance.now() : () => Date.now(), Ai = pr ? (t) => requestAnimationFrame(t) : ve;
const Pt = /* @__PURE__ */ new Set();
function _r(t) {
  Pt.forEach((e) => {
    e.c(t) || (Pt.delete(e), e.f());
  }), Pt.size !== 0 && Ai(_r);
}
function wi(t) {
  let e;
  return Pt.size === 0 && Ai(_r), {
    promise: new Promise((i) => {
      Pt.add(e = { c: t, f: i });
    }),
    abort() {
      Pt.delete(e);
    }
  };
}
const Vi = typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : (
  // @ts-ignore Node typings have this
  global
);
function _(t, e) {
  t.appendChild(e);
}
function _e(t, e, i) {
  const n = Ii(t);
  if (!n.getElementById(e)) {
    const l = C("style");
    l.id = e, l.textContent = i, wr(n, l);
  }
}
function Ii(t) {
  if (!t) return document;
  const e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
  return e && /** @type {ShadowRoot} */
  e.host ? (
    /** @type {ShadowRoot} */
    e
  ) : t.ownerDocument;
}
function va(t) {
  const e = C("style");
  return e.textContent = "/* empty */", wr(Ii(t), e), e.sheet;
}
function wr(t, e) {
  return _(
    /** @type {Document} */
    t.head || t,
    e
  ), e.sheet;
}
function D(t, e, i) {
  t.insertBefore(e, i || null);
}
function P(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function Ye(t, e) {
  for (let i = 0; i < t.length; i += 1)
    t[i] && t[i].d(e);
}
function C(t) {
  return document.createElement(t);
}
function kt(t) {
  return document.createElementNS("http://www.w3.org/2000/svg", t);
}
function le(t) {
  return document.createTextNode(t);
}
function x() {
  return le(" ");
}
function Ne() {
  return le("");
}
function te(t, e, i, n) {
  return t.addEventListener(e, i, n), () => t.removeEventListener(e, i, n);
}
function f(t, e, i) {
  i == null ? t.removeAttribute(e) : t.getAttribute(e) !== i && t.setAttribute(e, i);
}
const ba = ["width", "height"];
function pa(t, e) {
  const i = Object.getOwnPropertyDescriptors(t.__proto__);
  for (const n in e)
    e[n] == null ? t.removeAttribute(n) : n === "style" ? t.style.cssText = e[n] : n === "__value" ? t.value = t[n] = e[n] : i[n] && i[n].set && ba.indexOf(n) === -1 ? t[n] = e[n] : f(t, n, e[n]);
}
function _a(t, e) {
  Object.keys(e).forEach((i) => {
    p(t, i, e[i]);
  });
}
function p(t, e, i) {
  const n = e.toLowerCase();
  n in t ? t[n] = typeof t[n] == "boolean" && i === "" ? !0 : i : e in t ? t[e] = typeof t[e] == "boolean" && i === "" ? !0 : i : f(t, e, i);
}
function Gi(t) {
  return /-/.test(t) ? _a : pa;
}
function wa(t) {
  return Array.from(t.childNodes);
}
function pe(t, e) {
  e = "" + e, t.data !== e && (t.data = /** @type {string} */
  e);
}
function ri(t, e) {
  t.value = e ?? "";
}
function Be(t, e, i, n) {
  i == null ? t.style.removeProperty(e) : t.style.setProperty(e, i, "");
}
let ti;
function ka() {
  if (ti === void 0) {
    ti = !1;
    try {
      typeof window < "u" && window.parent && window.parent.document;
    } catch {
      ti = !0;
    }
  }
  return ti;
}
function ki(t, e) {
  getComputedStyle(t).position === "static" && (t.style.position = "relative");
  const n = C("iframe");
  n.setAttribute(
    "style",
    "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden; border: 0; opacity: 0; pointer-events: none; z-index: -1;"
  ), n.setAttribute("aria-hidden", "true"), n.tabIndex = -1;
  const l = ka();
  let o;
  return l ? (n.src = "data:text/html,<script>onresize=function(){parent.postMessage(0,'*')}<\/script>", o = te(
    window,
    "message",
    /** @param {MessageEvent} event */
    (r) => {
      r.source === n.contentWindow && e();
    }
  )) : (n.src = "about:blank", n.onload = () => {
    o = te(n.contentWindow, "resize", e), e();
  }), _(t, n), () => {
    (l || o && n.contentWindow) && o(), P(n);
  };
}
function G(t, e, i) {
  t.classList.toggle(e, !!i);
}
function ya(t, e, { bubbles: i = !1, cancelable: n = !1 } = {}) {
  return new CustomEvent(t, { detail: e, bubbles: i, cancelable: n });
}
function Ca(t) {
  const e = {};
  return t.childNodes.forEach(
    /** @param {Element} node */
    (i) => {
      e[i.slot || "default"] = !0;
    }
  ), e;
}
const ai = /* @__PURE__ */ new Map();
let si = 0;
function za(t) {
  let e = 5381, i = t.length;
  for (; i--; ) e = (e << 5) - e ^ t.charCodeAt(i);
  return e >>> 0;
}
function ja(t, e) {
  const i = { stylesheet: va(e), rules: {} };
  return ai.set(t, i), i;
}
function ui(t, e, i, n, l, o, r, a = 0) {
  const s = 16.666 / n;
  let d = `{
`;
  for (let b = 0; b <= 1; b += s) {
    const w = e + (i - e) * o(b);
    d += b * 100 + `%{${r(w, 1 - w)}}
`;
  }
  const u = d + `100% {${r(i, 1 - i)}}
}`, c = `__svelte_${za(u)}_${a}`, g = Ii(t), { stylesheet: h, rules: m } = ai.get(g) || ja(g, t);
  m[c] || (m[c] = !0, h.insertRule(`@keyframes ${c} ${u}`, h.cssRules.length));
  const v = t.style.animation || "";
  return t.style.animation = `${v ? `${v}, ` : ""}${c} ${n}ms linear ${l}ms 1 both`, si += 1, c;
}
function di(t, e) {
  const i = (t.style.animation || "").split(", "), n = i.filter(
    e ? (o) => o.indexOf(e) < 0 : (o) => o.indexOf("__svelte") === -1
    // remove all Svelte animations
  ), l = i.length - n.length;
  l && (t.style.animation = n.join(", "), si -= l, si || Ea());
}
function Ea() {
  Ai(() => {
    si || (ai.forEach((t) => {
      const { ownerNode: e } = t.stylesheet;
      e && P(e);
    }), ai.clear());
  });
}
let Zt;
function Rt(t) {
  Zt = t;
}
function kr() {
  if (!Zt) throw new Error("Function called outside component initialization");
  return Zt;
}
function ke(t) {
  kr().$$.on_mount.push(t);
}
function ct(t) {
  kr().$$.on_destroy.push(t);
}
const Tt = [], ue = [];
let Dt = [];
const Ki = [], yr = /* @__PURE__ */ Promise.resolve();
let Pi = !1;
function Cr() {
  Pi || (Pi = !0, yr.then(k));
}
function Pe() {
  return Cr(), yr;
}
function We(t) {
  Dt.push(t);
}
const Mi = /* @__PURE__ */ new Set();
let Lt = 0;
function k() {
  if (Lt !== 0)
    return;
  const t = Zt;
  do {
    try {
      for (; Lt < Tt.length; ) {
        const e = Tt[Lt];
        Lt++, Rt(e), Ma(e.$$);
      }
    } catch (e) {
      throw Tt.length = 0, Lt = 0, e;
    }
    for (Rt(null), Tt.length = 0, Lt = 0; ue.length; ) ue.pop()();
    for (let e = 0; e < Dt.length; e += 1) {
      const i = Dt[e];
      Mi.has(i) || (Mi.add(i), i());
    }
    Dt.length = 0;
  } while (Tt.length);
  for (; Ki.length; )
    Ki.pop()();
  Pi = !1, Mi.clear(), Rt(t);
}
function Ma(t) {
  if (t.fragment !== null) {
    t.update(), He(t.before_update);
    const e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(We);
  }
}
function La(t) {
  const e = [], i = [];
  Dt.forEach((n) => t.indexOf(n) === -1 ? e.push(n) : i.push(n)), i.forEach((n) => n()), Dt = e;
}
let Bt;
function xi() {
  return Bt || (Bt = Promise.resolve(), Bt.then(() => {
    Bt = null;
  })), Bt;
}
function yt(t, e, i) {
  t.dispatchEvent(ya(`${e ? "intro" : "outro"}${i}`));
}
const ni = /* @__PURE__ */ new Set();
let nt;
function Oe() {
  nt = {
    r: 0,
    c: [],
    p: nt
    // parent group
  };
}
function Fe() {
  nt.r || He(nt.c), nt = nt.p;
}
function Y(t, e) {
  t && t.i && (ni.delete(t), t.i(e));
}
function U(t, e, i, n) {
  if (t && t.o) {
    if (ni.has(t)) return;
    ni.add(t), nt.c.push(() => {
      ni.delete(t), n && (i && t.d(1), n());
    }), t.o(e);
  } else n && n();
}
const Bi = { duration: 0 };
function Xi(t, e, i) {
  const n = { direction: "in" };
  let l = e(t, i, n), o = !1, r, a, s = 0;
  function d() {
    r && di(t, r);
  }
  function u() {
    const {
      delay: g = 0,
      duration: h = 300,
      easing: m = Gt,
      tick: v = ve,
      css: b
    } = l || Bi;
    b && (r = ui(t, 0, 1, h, g, m, b, s++)), v(0, 1);
    const w = _i() + g, y = w + h;
    a && a.abort(), o = !0, We(() => yt(t, !0, "start")), a = wi((j) => {
      if (o) {
        if (j >= y)
          return v(1, 0), yt(t, !0, "end"), d(), o = !1;
        if (j >= w) {
          const E = m((j - w) / h);
          v(E, 1 - E);
        }
      }
      return o;
    });
  }
  let c = !1;
  return {
    start() {
      c || (c = !0, di(t), ot(l) ? (l = l(n), xi().then(u)) : u());
    },
    invalidate() {
      c = !1;
    },
    end() {
      o && (d(), o = !1);
    }
  };
}
function Ji(t, e, i) {
  const n = { direction: "out" };
  let l = e(t, i, n), o = !0, r;
  const a = nt;
  a.r += 1;
  let s;
  function d() {
    const {
      delay: u = 0,
      duration: c = 300,
      easing: g = Gt,
      tick: h = ve,
      css: m
    } = l || Bi;
    m && (r = ui(t, 1, 0, c, u, g, m));
    const v = _i() + u, b = v + c;
    We(() => yt(t, !1, "start")), "inert" in t && (s = /** @type {HTMLElement} */
    t.inert, t.inert = !0), wi((w) => {
      if (o) {
        if (w >= b)
          return h(0, 1), yt(t, !1, "end"), --a.r || He(a.c), !1;
        if (w >= v) {
          const y = g((w - v) / c);
          h(1 - y, y);
        }
      }
      return o;
    });
  }
  return ot(l) ? xi().then(() => {
    l = l(n), d();
  }) : d(), {
    end(u) {
      u && "inert" in t && (t.inert = s), u && l.tick && l.tick(1, 0), o && (r && di(t, r), o = !1);
    }
  };
}
function ci(t, e, i, n) {
  let o = e(t, i, { direction: "both" }), r = n ? 0 : 1, a = null, s = null, d = null, u;
  function c() {
    d && di(t, d);
  }
  function g(m, v) {
    const b = (
      /** @type {Program['d']} */
      m.b - r
    );
    return v *= Math.abs(b), {
      a: r,
      b: m.b,
      d: b,
      duration: v,
      start: m.start,
      end: m.start + v,
      group: m.group
    };
  }
  function h(m) {
    const {
      delay: v = 0,
      duration: b = 300,
      easing: w = Gt,
      tick: y = ve,
      css: j
    } = o || Bi, E = {
      start: _i() + v,
      b: m
    };
    m || (E.group = nt, nt.r += 1), "inert" in t && (m ? u !== void 0 && (t.inert = u) : (u = /** @type {HTMLElement} */
    t.inert, t.inert = !0)), a || s ? s = E : (j && (c(), d = ui(t, r, m, b, v, w, j)), m && y(0, 1), a = g(E, b), We(() => yt(t, m, "start")), wi((M) => {
      if (s && M > s.start && (a = g(s, b), s = null, yt(t, a.b, "start"), j && (c(), d = ui(
        t,
        r,
        a.b,
        a.duration,
        0,
        w,
        o.css
      ))), a) {
        if (M >= a.end)
          y(r = a.b, 1 - r), yt(t, a.b, "end"), s || (a.b ? c() : --a.group.r || He(a.group.c)), a = null;
        else if (M >= a.start) {
          const L = M - a.start;
          r = a.a + a.d * w(L / a.duration), y(r, 1 - r);
        }
      }
      return !!(a || s);
    }));
  }
  return {
    run(m) {
      ot(o) ? xi().then(() => {
        o = o({ direction: m ? "in" : "out" }), h(m);
      }) : h(m);
    },
    end() {
      c(), a = s = null;
    }
  };
}
function Le(t) {
  return (t == null ? void 0 : t.length) !== void 0 ? t : Array.from(t);
}
function qa(t, e) {
  t.d(1), e.delete(t.key);
}
function Sa(t, e, i, n, l, o, r, a, s, d, u, c) {
  let g = t.length, h = o.length, m = g;
  const v = {};
  for (; m--; ) v[t[m].key] = m;
  const b = [], w = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), j = [];
  for (m = h; m--; ) {
    const z = c(l, o, m), V = i(z);
    let T = r.get(V);
    T ? j.push(() => T.p(z, e)) : (T = d(V, z), T.c()), w.set(V, b[m] = T), V in v && y.set(V, Math.abs(m - v[V]));
  }
  const E = /* @__PURE__ */ new Set(), M = /* @__PURE__ */ new Set();
  function L(z) {
    Y(z, 1), z.m(a, u), r.set(z.key, z), u = z.first, h--;
  }
  for (; g && h; ) {
    const z = b[h - 1], V = t[g - 1], T = z.key, S = V.key;
    z === V ? (u = z.first, g--, h--) : w.has(S) ? !r.has(T) || E.has(T) ? L(z) : M.has(S) ? g-- : y.get(T) > y.get(S) ? (M.add(T), L(z)) : (E.add(S), g--) : (s(V, r), g--);
  }
  for (; g--; ) {
    const z = t[g];
    w.has(z.key) || s(z, r);
  }
  for (; h; ) L(b[h - 1]);
  return He(j), b;
}
function Ta(t, e) {
  const i = {}, n = {}, l = { $$scope: 1 };
  let o = t.length;
  for (; o--; ) {
    const r = t[o], a = e[o];
    if (a) {
      for (const s in r)
        s in a || (n[s] = 1);
      for (const s in a)
        l[s] || (i[s] = a[s], l[s] = 1);
      t[o] = a;
    } else
      for (const s in r)
        l[s] = 1;
  }
  for (const r in n)
    r in i || (i[r] = void 0);
  return i;
}
function et(t) {
  t && t.c();
}
function Ke(t, e, i) {
  const { fragment: n, after_update: l } = t.$$;
  n && n.m(e, i), We(() => {
    const o = t.$$.on_mount.map(vr).filter(ot);
    t.$$.on_destroy ? t.$$.on_destroy.push(...o) : He(o), t.$$.on_mount = [];
  }), l.forEach(We);
}
function Xe(t, e) {
  const i = t.$$;
  i.fragment !== null && (La(i.after_update), He(i.on_destroy), i.fragment && i.fragment.d(e), i.on_destroy = i.fragment = null, i.ctx = []);
}
function Pa(t, e) {
  t.$$.dirty[0] === -1 && (Tt.push(t), Cr(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
}
function ge(t, e, i, n, l, o, r = null, a = [-1]) {
  const s = Zt;
  Rt(t);
  const d = t.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: o,
    update: ve,
    not_equal: l,
    bound: Zi(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (s ? s.$$.context : [])),
    // everything else
    callbacks: Zi(),
    dirty: a,
    skip_bound: !1,
    root: e.target || s.$$.root
  };
  r && r(d.root);
  let u = !1;
  if (d.ctx = i ? i(t, e.props || {}, (c, g, ...h) => {
    const m = h.length ? h[0] : g;
    return d.ctx && l(d.ctx[c], d.ctx[c] = m) && (!d.skip_bound && d.bound[c] && d.bound[c](m), u && Pa(t, c)), g;
  }) : [], d.update(), u = !0, He(d.before_update), d.fragment = n ? n(d.ctx) : !1, e.target) {
    if (e.hydrate) {
      const c = wa(e.target);
      d.fragment && d.fragment.l(c), c.forEach(P);
    } else
      d.fragment && d.fragment.c();
    e.intro && Y(t.$$.fragment), Ke(t, e.target, e.anchor), k();
  }
  Rt(s);
}
let zr;
typeof HTMLElement == "function" && (zr = class extends HTMLElement {
  constructor(e, i, n) {
    super();
    /** The Svelte component constructor */
    Ge(this, "$$ctor");
    /** Slots */
    Ge(this, "$$s");
    /** The Svelte component instance */
    Ge(this, "$$c");
    /** Whether or not the custom element is connected */
    Ge(this, "$$cn", !1);
    /** Component props data */
    Ge(this, "$$d", {});
    /** `true` if currently in the process of reflecting component props back to attributes */
    Ge(this, "$$r", !1);
    /** @type {Record<string, CustomElementPropDefinition>} Props definition (name, reflected, type etc) */
    Ge(this, "$$p_d", {});
    /** @type {Record<string, Function[]>} Event listeners */
    Ge(this, "$$l", {});
    /** @type {Map<Function, Function>} Event listener unsubscribe functions */
    Ge(this, "$$l_u", /* @__PURE__ */ new Map());
    this.$$ctor = e, this.$$s = i, n && this.attachShadow({ mode: "open" });
  }
  addEventListener(e, i, n) {
    if (this.$$l[e] = this.$$l[e] || [], this.$$l[e].push(i), this.$$c) {
      const l = this.$$c.$on(e, i);
      this.$$l_u.set(i, l);
    }
    super.addEventListener(e, i, n);
  }
  removeEventListener(e, i, n) {
    if (super.removeEventListener(e, i, n), this.$$c) {
      const l = this.$$l_u.get(i);
      l && (l(), this.$$l_u.delete(i));
    }
  }
  async connectedCallback() {
    if (this.$$cn = !0, !this.$$c) {
      let e = function(o) {
        return () => {
          let r;
          return {
            c: function() {
              r = C("slot"), o !== "default" && f(r, "name", o);
            },
            /**
             * @param {HTMLElement} target
             * @param {HTMLElement} [anchor]
             */
            m: function(d, u) {
              D(d, r, u);
            },
            d: function(d) {
              d && P(r);
            }
          };
        };
      };
      if (await Promise.resolve(), !this.$$cn || this.$$c)
        return;
      const i = {}, n = Ca(this);
      for (const o of this.$$s)
        o in n && (i[o] = [e(o)]);
      for (const o of this.attributes) {
        const r = this.$$g_p(o.name);
        r in this.$$d || (this.$$d[r] = li(r, o.value, this.$$p_d, "toProp"));
      }
      for (const o in this.$$p_d)
        !(o in this.$$d) && this[o] !== void 0 && (this.$$d[o] = this[o], delete this[o]);
      this.$$c = new this.$$ctor({
        target: this.shadowRoot || this,
        props: {
          ...this.$$d,
          $$slots: i,
          $$scope: {
            ctx: []
          }
        }
      });
      const l = () => {
        this.$$r = !0;
        for (const o in this.$$p_d)
          if (this.$$d[o] = this.$$c.$$.ctx[this.$$c.$$.props[o]], this.$$p_d[o].reflect) {
            const r = li(
              o,
              this.$$d[o],
              this.$$p_d,
              "toAttribute"
            );
            r == null ? this.removeAttribute(this.$$p_d[o].attribute || o) : this.setAttribute(this.$$p_d[o].attribute || o, r);
          }
        this.$$r = !1;
      };
      this.$$c.$$.after_update.push(l), l();
      for (const o in this.$$l)
        for (const r of this.$$l[o]) {
          const a = this.$$c.$on(o, r);
          this.$$l_u.set(r, a);
        }
      this.$$l = {};
    }
  }
  // We don't need this when working within Svelte code, but for compatibility of people using this outside of Svelte
  // and setting attributes through setAttribute etc, this is helpful
  attributeChangedCallback(e, i, n) {
    var l;
    this.$$r || (e = this.$$g_p(e), this.$$d[e] = li(e, n, this.$$p_d, "toProp"), (l = this.$$c) == null || l.$set({ [e]: this.$$d[e] }));
  }
  disconnectedCallback() {
    this.$$cn = !1, Promise.resolve().then(() => {
      !this.$$cn && this.$$c && (this.$$c.$destroy(), this.$$c = void 0);
    });
  }
  $$g_p(e) {
    return Object.keys(this.$$p_d).find(
      (i) => this.$$p_d[i].attribute === e || !this.$$p_d[i].attribute && i.toLowerCase() === e
    ) || e;
  }
});
function li(t, e, i, n) {
  var o;
  const l = (o = i[t]) == null ? void 0 : o.type;
  if (e = l === "Boolean" && typeof e != "boolean" ? e != null : e, !n || !i[t])
    return e;
  if (n === "toAttribute")
    switch (l) {
      case "Object":
      case "Array":
        return e == null ? null : JSON.stringify(e);
      case "Boolean":
        return e ? "" : null;
      case "Number":
        return e ?? null;
      default:
        return e;
    }
  else
    switch (l) {
      case "Object":
      case "Array":
        return e && JSON.parse(e);
      case "Boolean":
        return e;
      case "Number":
        return e != null ? +e : e;
      default:
        return e;
    }
}
function he(t, e, i, n, l, o) {
  let r = class extends zr {
    constructor() {
      super(t, i, l), this.$$p_d = e;
    }
    static get observedAttributes() {
      return Object.keys(e).map(
        (a) => (e[a].attribute || a).toLowerCase()
      );
    }
  };
  return Object.keys(e).forEach((a) => {
    Object.defineProperty(r.prototype, a, {
      get() {
        return this.$$c && a in this.$$c ? this.$$c[a] : this.$$d[a];
      },
      set(s) {
        var d;
        s = li(a, s, e), this.$$d[a] = s, (d = this.$$c) == null || d.$set({ [a]: s });
      }
    });
  }), n.forEach((a) => {
    Object.defineProperty(r.prototype, a, {
      get() {
        var s;
        return (s = this.$$c) == null ? void 0 : s[a];
      }
    });
  }), t.element = /** @type {any} */
  r, r;
}
class me {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    Ge(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    Ge(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    Xe(this, 1), this.$destroy = ve;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(e, i) {
    if (!ot(i))
      return ve;
    const n = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
    return n.push(i), () => {
      const l = n.indexOf(i);
      l !== -1 && n.splice(l, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(e) {
    this.$$set && !ga(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
  }
}
const Da = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(Da);
class Ha extends me {
  constructor(e) {
    super(), ge(this, e, null, null, ce, {});
  }
}
he(Ha, {}, [], [], !0);
const Oa = {
  0: "none",
  1: "3xs",
  2: "2xs",
  3: "xs",
  4: "s",
  5: "m",
  6: "l",
  7: "xl",
  8: "2xl",
  9: "3xl",
  10: "4xl",
  none: "none",
  "3xs": "3xs",
  "2xs": "2xs",
  xs: "xs",
  s: "s",
  m: "m",
  l: "l",
  xl: "xl",
  "2xl": "2xl",
  "3xl": "3xl",
  "4xl": "4xl"
};
function ii(t) {
  return t ? Number.isInteger(+t) ? Oa[t] || "none" : t : "none";
}
function be(t, e, i, n) {
  return t = ii(t), i = ii(i), n = ii(n), e = ii(e), [
    t && t !== "none" && `margin-top:var(--goa-space-${t});` || "",
    e && e !== "none" && `margin-right:var(--goa-space-${e});` || "",
    i && i !== "none" && `margin-bottom:var(--goa-space-${i});` || "",
    n && n !== "none" && `margin-left:var(--goa-space-${n});` || ""
  ].join(" ");
}
function jr(t, e, i, n) {
  if (!t) return;
  const l = document.createElement("style"), o = Object.entries(i).map((r) => `${r[0]}: ${r[1]};`).join(" ");
  l.innerHTML = `${e} {${o}}`, t.appendChild(l);
}
function Ue(...t) {
  return t.filter((e) => !!e).map(
    (e) => typeof e == "string" ? e.replace(/;$/, "") : e
  ).join(";");
}
function ze(t, e) {
  return e ? `${t}: ${e}` : "";
}
function Re(t, e) {
  t || console.warn("receive() el is null | undefined"), t == null || t.addEventListener("msg", (i) => {
    const n = i;
    e(n.detail.action, n.detail.data, i);
  });
}
function je(t, e, i, n) {
  if (!t) {
    console.warn("relay() el is null | undefined");
    return;
  }
  const l = () => {
    t == null || t.dispatchEvent(
      new CustomEvent("msg", {
        composed: !0,
        bubbles: n == null ? void 0 : n.bubbles,
        cancelable: n == null ? void 0 : n.cancelable,
        detail: {
          action: e,
          data: i
        }
      })
    );
  };
  n != null && n.timeout ? setTimeout(l, n.timeout) : l();
}
function qe(t, e, i, n) {
  const l = () => {
    t == null || t.dispatchEvent(
      new CustomEvent(e, {
        composed: !0,
        bubbles: n == null ? void 0 : n.bubbles,
        cancelable: n == null ? void 0 : n.cancelable,
        detail: i
      })
    );
  };
  n != null && n.timeout ? setTimeout(l, n.timeout) : l();
}
function lt(t, e) {
  const i = t == null ? void 0 : t.querySelector("slot");
  return i ? i.assignedElements() : e ? [
    // @ts-expect-error testing
    ...t.querySelector(e).children
  ] : [...t.children];
}
function Ce(t) {
  return t === "false" ? !1 : t === "" ? !0 : !!t;
}
function vt(t) {
  return t ? "true" : "false";
}
function Li(t) {
  return !isNaN(t.getDate());
}
function Kt(t, e) {
  Object.entries(e).forEach((i) => {
    i[1] || console.warn(`${t}: ${i[0]} is required`);
  });
}
function Me(t, e, i = !1) {
  return [e, (l) => {
    if (!(!i && !l)) {
      if (i && !l) {
        console.error(`[${l}] is an invalid ${t.toLowerCase()}`);
        return;
      }
      e.includes(l || "") || console.error(`[${l}] is an invalid ${t.toLowerCase()}`);
    }
  }];
}
function Fa(t) {
  const e = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ], i = /* @__PURE__ */ new Date(), n = i.getHours(), l = i.getMinutes(), o = i.getDate(), r = e[i.getMonth()], a = i.getFullYear(), s = n === 0 && 12 || n > 12 && n - 12 || n, d = n === 0 && "AM" || n >= 12 && "PM" || "AM", u = l < 10 && `0${l}` || l, c = o % 10 === 1 && o !== 11 && "st" || o % 10 === 2 && o !== 12 && "nd" || o % 10 === 3 && o !== 13 && "rd" || "th";
  return `${r} ${o}${c} ${a}, ${s}:${u} ${d}`;
}
function Ft(t, e) {
  return e === 1 ? t : `${t}s`;
}
function Aa(t, e, i) {
  return t > i ? i : t < e ? e : t;
}
function fi() {
  return `${Math.random().toString(36).substring(2, 9)}`;
}
function qi(t, e, i) {
  if (t = t + "", e - t.length <= 0)
    return t;
  let l = "";
  for (let o = 0; o < e - t.length; o++)
    l += i;
  return `${l}${t}`;
}
function Qi(t, e, i = 100) {
  return t && clearTimeout(t), setTimeout(e, i);
}
function yi(t) {
  t.querySelector("slot") || t.appendChild(document.createElement("slot"));
}
function Va(t) {
  _e(t, "svelte-1g8h5ss", ':host{box-sizing:border-box;font-family:var(--goa-font-family-sans);font-size:var(--goa-font-size-4)}.goa-accordion.svelte-1g8h5ss.svelte-1g8h5ss{border-radius:var(--goa-accordion-border-radius);box-shadow:var(--goa-accordion-shadow)}.goa-accordion.svelte-1g8h5ss.svelte-1g8h5ss,.goa-accordion.svelte-1g8h5ss .svelte-1g8h5ss{box-sizing:border-box}.goa-accordion.svelte-1g8h5ss.svelte-1g8h5ss{container:self / inline-size}summary.svelte-1g8h5ss.svelte-1g8h5ss{min-height:3.5rem;padding:var(--goa-accordion-padding-heading-icon-left);border:var(--goa-accordion-border);border-radius:var(--goa-accordion-border-radius);background-color:var(--goa-accordion-color-bg-heading);color:var(--goa-accordion-color-heading);cursor:pointer;list-style:none;display:flex;align-items:flex-start;position:relative}summary.iconRight.svelte-1g8h5ss.svelte-1g8h5ss{padding:var(--goa-accordion-padding-heading-icon-right)}summary.svelte-1g8h5ss.svelte-1g8h5ss:hover{background-color:var(--goa-accordion-color-bg-heading-hover);color:var(--goa-accordion-color-heading-hover)}summary.svelte-1g8h5ss.svelte-1g8h5ss:focus-visible,summary.svelte-1g8h5ss.svelte-1g8h5ss:active{background-color:var(--goa-accordion-color-bg-heading);outline:none}summary.svelte-1g8h5ss.svelte-1g8h5ss:focus-visible::before{content:"";position:absolute;top:-1px;right:-1px;bottom:-1px;left:-1px;border:var(--goa-border-width-l) solid var(--goa-color-interactive-focus);border-radius:var(--goa-accordion-border-radius)}summary.svelte-1g8h5ss.svelte-1g8h5ss::marker,summary.svelte-1g8h5ss.svelte-1g8h5ss::-webkit-details-marker{display:none}summary.svelte-1g8h5ss goa-icon.svelte-1g8h5ss{padding:0.125rem 1rem}.title.svelte-1g8h5ss.svelte-1g8h5ss{display:flex;flex:1}.title.svelte-1g8h5ss span.svelte-1g8h5ss{padding-bottom:var(--goa-space-2xs, 0)}.heading.svelte-1g8h5ss.svelte-1g8h5ss{font:var(--goa-accordion-heading-s);padding-right:1rem}.secondary-text.svelte-1g8h5ss.svelte-1g8h5ss{font:var(--goa-typography-body-s);line-height:1.5rem;padding-right:1rem}.heading-content.svelte-1g8h5ss.svelte-1g8h5ss{flex:1}goa-icon.svelte-1g8h5ss.svelte-1g8h5ss{padding:0.125rem 1rem}.container-medium.svelte-1g8h5ss.svelte-1g8h5ss{min-height:4rem}.container-medium.svelte-1g8h5ss goa-icon.svelte-1g8h5ss{padding:0.375rem 1rem}.content.svelte-1g8h5ss.svelte-1g8h5ss{border-bottom:var(--goa-accordion-border);border-left:var(--goa-accordion-border);border-right:var(--goa-accordion-border);border-bottom-left-radius:var(--goa-accordion-border-radius);border-bottom-right-radius:var(--goa-accordion-border-radius);background-color:var(--goa-accordion-color-bg-content)}.content.svelte-1g8h5ss ::slotted(*:last-child){margin-bottom:0 !important}details[open].svelte-1g8h5ss goa-icon.svelte-1g8h5ss{transform:rotate(var(--icon-rotate))}details[open].svelte-1g8h5ss summary.svelte-1g8h5ss{border-bottom-left-radius:var(--goa-border-radius-none);border-bottom-right-radius:var(--goa-border-radius-none);border-bottom:var(--goa-accordion-divider)}.heading-medium.svelte-1g8h5ss.svelte-1g8h5ss{line-height:2rem;font:var(--goa-accordion-heading-m)}@container self (max-width: 623px){.content.svelte-1g8h5ss.svelte-1g8h5ss{padding:var(--goa-accordion-padding-content-narrow)}.title.svelte-1g8h5ss.svelte-1g8h5ss{display:flex;flex-direction:column;align-items:flex-start}}@container self (min-width: 624px){.content.svelte-1g8h5ss.svelte-1g8h5ss{padding:var(--goa-accordion-padding-content-wide)}.title.svelte-1g8h5ss.svelte-1g8h5ss{align-items:center}}');
}
const Ia = (t) => ({}), $i = (t) => ({});
function en(t) {
  let e, i;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", "chevron-forward"), p(e, "fillcolor", i = /*_hovering*/
      t[11] ? "var(--goa-color-interactive-hover)" : "var(--goa-color-interactive-default)"), p(e, "class", "svelte-1g8h5ss");
    },
    m(n, l) {
      D(n, e, l);
    },
    p(n, l) {
      l[0] & /*_hovering*/
      2048 && i !== (i = /*_hovering*/
      n[11] ? "var(--goa-color-interactive-hover)" : "var(--goa-color-interactive-default)") && p(e, "fillcolor", i);
    },
    d(n) {
      n && P(e);
    }
  };
}
function tn(t) {
  let e, i;
  return {
    c() {
      e = C("span"), i = le(
        /*secondarytext*/
        t[2]
      ), f(e, "class", "secondary-text svelte-1g8h5ss");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l[0] & /*secondarytext*/
      4 && pe(
        i,
        /*secondarytext*/
        n[2]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function nn(t) {
  let e, i;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", "chevron-down"), p(e, "fillcolor", i = /*_hovering*/
      t[11] ? "var(--goa-color-interactive-hover)" : "var(--goa-color-interactive-default)"), p(e, "class", "svelte-1g8h5ss");
    },
    m(n, l) {
      D(n, e, l);
    },
    p(n, l) {
      l[0] & /*_hovering*/
      2048 && i !== (i = /*_hovering*/
      n[11] ? "var(--goa-color-interactive-hover)" : "var(--goa-color-interactive-default)") && p(e, "fillcolor", i);
    },
    d(n) {
      n && P(e);
    }
  };
}
function xa(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v, b, w, y, j, E, M, L, z, V, T, S = (
    /*iconposition*/
    t[10] === "left" && en(t)
  ), A = (
    /*secondarytext*/
    t[2] && tn(t)
  );
  const R = (
    /*#slots*/
    t[21].headingcontent
  ), I = oe(
    R,
    t,
    /*$$scope*/
    t[20],
    $i
  );
  let B = (
    /*iconposition*/
    t[10] === "right" && nn(t)
  );
  const N = (
    /*#slots*/
    t[21].default
  ), F = oe(
    N,
    t,
    /*$$scope*/
    t[20],
    null
  );
  return {
    c() {
      e = C("div"), i = C("details"), n = C("summary"), S && S.c(), l = x(), o = C("div"), r = C("span"), a = le(
        /*heading*/
        t[1]
      ), u = x(), A && A.c(), c = x(), g = C("div"), I && I.c(), m = x(), B && B.c(), y = x(), j = C("div"), F && F.c(), f(r, "class", s = "heading heading-" + /*headingsize*/
      t[3] + " svelte-1g8h5ss"), f(r, "data-testid", d = `${/*testid*/
      t[5]}-heading`), f(g, "class", "heading-content svelte-1g8h5ss"), G(
        g,
        "heading-content-top",
        /*_headingSlotChildren*/
        t[15].length
      ), f(o, "class", "title svelte-1g8h5ss"), f(o, "id", h = `${/*_accordionId*/
      t[16]}-heading`), f(n, "class", v = Ee(`container-${/*headingsize*/
      t[3]}`) + " svelte-1g8h5ss"), f(n, "aria-controls", b = `${/*_accordionId*/
      t[16]}-content`), f(n, "aria-expanded", w = /*open*/
      t[0] === "true"), G(
        n,
        "iconRight",
        /*iconposition*/
        t[10] === "right"
      ), f(j, "class", "content svelte-1g8h5ss"), f(j, "role", "region"), f(j, "aria-labelledby", E = `${/*_accordionId*/
      t[16]}-heading`), f(j, "id", M = `${/*_accordionId*/
      t[16]}-content`), i.open = /*isOpen*/
      t[17], f(i, "class", "svelte-1g8h5ss"), f(e, "style", L = `
    ${be(
        /*mt*/
        t[6],
        /*mr*/
        t[7],
        /*mb*/
        t[8],
        /*ml*/
        t[9]
      )};
    max-width: ${/*maxwidth*/
      t[4]};
    --icon-rotate: ${/*iconposition*/
      t[10] === "right" ? "180deg" : "90deg"}
  `), f(e, "class", "goa-accordion svelte-1g8h5ss"), f(
        e,
        "data-testid",
        /*testid*/
        t[5]
      );
    },
    m(q, H) {
      D(q, e, H), _(e, i), _(i, n), S && S.m(n, null), _(n, l), _(n, o), _(o, r), _(r, a), _(o, u), A && A.m(o, null), _(o, c), _(o, g), I && I.m(g, null), t[22](o), _(n, m), B && B.m(n, null), _(i, y), _(i, j), F && F.m(j, null), t[27](j), t[29](e), z = !0, V || (T = [
        te(
          n,
          "mouseover",
          /*mouseover_handler*/
          t[23]
        ),
        te(
          n,
          "mouseout",
          /*mouseout_handler*/
          t[24]
        ),
        te(
          n,
          "focus",
          /*focus_handler*/
          t[25]
        ),
        te(
          n,
          "blur",
          /*blur_handler*/
          t[26]
        ),
        te(
          i,
          "toggle",
          /*toggle_handler*/
          t[28]
        )
      ], V = !0);
    },
    p(q, H) {
      /*iconposition*/
      q[10] === "left" ? S ? S.p(q, H) : (S = en(q), S.c(), S.m(n, l)) : S && (S.d(1), S = null), (!z || H[0] & /*heading*/
      2) && pe(
        a,
        /*heading*/
        q[1]
      ), (!z || H[0] & /*headingsize*/
      8 && s !== (s = "heading heading-" + /*headingsize*/
      q[3] + " svelte-1g8h5ss")) && f(r, "class", s), (!z || H[0] & /*testid*/
      32 && d !== (d = `${/*testid*/
      q[5]}-heading`)) && f(r, "data-testid", d), /*secondarytext*/
      q[2] ? A ? A.p(q, H) : (A = tn(q), A.c(), A.m(o, c)) : A && (A.d(1), A = null), I && I.p && (!z || H[0] & /*$$scope*/
      1048576) && ae(
        I,
        R,
        q,
        /*$$scope*/
        q[20],
        z ? re(
          R,
          /*$$scope*/
          q[20],
          H,
          Ia
        ) : se(
          /*$$scope*/
          q[20]
        ),
        $i
      ), (!z || H[0] & /*_headingSlotChildren*/
      32768) && G(
        g,
        "heading-content-top",
        /*_headingSlotChildren*/
        q[15].length
      ), (!z || H[0] & /*_accordionId*/
      65536 && h !== (h = `${/*_accordionId*/
      q[16]}-heading`)) && f(o, "id", h), /*iconposition*/
      q[10] === "right" ? B ? B.p(q, H) : (B = nn(q), B.c(), B.m(n, null)) : B && (B.d(1), B = null), (!z || H[0] & /*headingsize*/
      8 && v !== (v = Ee(`container-${/*headingsize*/
      q[3]}`) + " svelte-1g8h5ss")) && f(n, "class", v), (!z || H[0] & /*_accordionId*/
      65536 && b !== (b = `${/*_accordionId*/
      q[16]}-content`)) && f(n, "aria-controls", b), (!z || H[0] & /*open*/
      1 && w !== (w = /*open*/
      q[0] === "true")) && f(n, "aria-expanded", w), (!z || H[0] & /*headingsize, iconposition*/
      1032) && G(
        n,
        "iconRight",
        /*iconposition*/
        q[10] === "right"
      ), F && F.p && (!z || H[0] & /*$$scope*/
      1048576) && ae(
        F,
        N,
        q,
        /*$$scope*/
        q[20],
        z ? re(
          N,
          /*$$scope*/
          q[20],
          H,
          null
        ) : se(
          /*$$scope*/
          q[20]
        ),
        null
      ), (!z || H[0] & /*_accordionId*/
      65536 && E !== (E = `${/*_accordionId*/
      q[16]}-heading`)) && f(j, "aria-labelledby", E), (!z || H[0] & /*_accordionId*/
      65536 && M !== (M = `${/*_accordionId*/
      q[16]}-content`)) && f(j, "id", M), (!z || H[0] & /*isOpen*/
      131072) && (i.open = /*isOpen*/
      q[17]), (!z || H[0] & /*mt, mr, mb, ml, maxwidth, iconposition*/
      2e3 && L !== (L = `
    ${be(
        /*mt*/
        q[6],
        /*mr*/
        q[7],
        /*mb*/
        q[8],
        /*ml*/
        q[9]
      )};
    max-width: ${/*maxwidth*/
      q[4]};
    --icon-rotate: ${/*iconposition*/
      q[10] === "right" ? "180deg" : "90deg"}
  `)) && f(e, "style", L), (!z || H[0] & /*testid*/
      32) && f(
        e,
        "data-testid",
        /*testid*/
        q[5]
      );
    },
    i(q) {
      z || (Y(I, q), Y(F, q), z = !0);
    },
    o(q) {
      U(I, q), U(F, q), z = !1;
    },
    d(q) {
      q && P(e), S && S.d(), A && A.d(), I && I.d(q), t[22](null), B && B.d(), F && F.d(q), t[27](null), t[29](null), V = !1, He(T);
    }
  };
}
function Ba(t, e, i) {
  let n, { $$slots: l = {}, $$scope: o } = e;
  const [r, a] = Me("Accordion heading size", ["small", "medium"]);
  let { open: s = "false" } = e, { heading: d = "" } = e, { secondarytext: u = "" } = e, { headingsize: c = "small" } = e, { id: g = "" } = e, { maxwidth: h = "none" } = e, { testid: m = "" } = e, { mt: v = null } = e, { mr: b = null } = e, { mb: w = "xs" } = e, { ml: y = null } = e, { iconposition: j = "left" } = e, E = !1, M, L, z, V = [], T = "";
  ke(() => {
    Kt("GoAAccordion", { heading: d }), a(c), yi(z), i(15, V = S()), i(16, T = `accordion-${fi()}`);
  });
  function S() {
    if (M) {
      const W = M.querySelector("slot");
      return W ? W.assignedElements() : [...M.children];
    }
    return [];
  }
  function A(W) {
    L && L.dispatchEvent(new CustomEvent(
      "_change",
      {
        composed: !0,
        bubbles: !0,
        detail: { open: W }
      }
    ));
  }
  function R(W) {
    ue[W ? "unshift" : "push"](() => {
      M = W, i(12, M);
    });
  }
  const I = () => i(11, E = !0), B = () => i(11, E = !1), N = () => i(11, E = !1), F = () => i(11, E = !1);
  function q(W) {
    ue[W ? "unshift" : "push"](() => {
      z = W, i(14, z);
    });
  }
  const H = ({ target: W }) => {
    i(0, s = `${W == null ? void 0 : W.open}`), A(W == null ? void 0 : W.open);
  };
  function O(W) {
    ue[W ? "unshift" : "push"](() => {
      L = W, i(13, L);
    });
  }
  return t.$$set = (W) => {
    "open" in W && i(0, s = W.open), "heading" in W && i(1, d = W.heading), "secondarytext" in W && i(2, u = W.secondarytext), "headingsize" in W && i(3, c = W.headingsize), "id" in W && i(19, g = W.id), "maxwidth" in W && i(4, h = W.maxwidth), "testid" in W && i(5, m = W.testid), "mt" in W && i(6, v = W.mt), "mr" in W && i(7, b = W.mr), "mb" in W && i(8, w = W.mb), "ml" in W && i(9, y = W.ml), "iconposition" in W && i(10, j = W.iconposition), "$$scope" in W && i(20, o = W.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*open*/
    1 && i(17, n = Ce(s));
  }, [
    s,
    d,
    u,
    c,
    h,
    m,
    v,
    b,
    w,
    y,
    j,
    E,
    M,
    L,
    z,
    V,
    T,
    n,
    A,
    g,
    o,
    l,
    R,
    I,
    B,
    N,
    F,
    q,
    H,
    O
  ];
}
class Na extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Ba,
      xa,
      ce,
      {
        open: 0,
        heading: 1,
        secondarytext: 2,
        headingsize: 3,
        id: 19,
        maxwidth: 4,
        testid: 5,
        mt: 6,
        mr: 7,
        mb: 8,
        ml: 9,
        iconposition: 10
      },
      Va,
      [-1, -1]
    );
  }
  get open() {
    return this.$$.ctx[0];
  }
  set open(e) {
    this.$$set({ open: e }), k();
  }
  get heading() {
    return this.$$.ctx[1];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get secondarytext() {
    return this.$$.ctx[2];
  }
  set secondarytext(e) {
    this.$$set({ secondarytext: e }), k();
  }
  get headingsize() {
    return this.$$.ctx[3];
  }
  set headingsize(e) {
    this.$$set({ headingsize: e }), k();
  }
  get id() {
    return this.$$.ctx[19];
  }
  set id(e) {
    this.$$set({ id: e }), k();
  }
  get maxwidth() {
    return this.$$.ctx[4];
  }
  set maxwidth(e) {
    this.$$set({ maxwidth: e }), k();
  }
  get testid() {
    return this.$$.ctx[5];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[6];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[7];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[8];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[9];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get iconposition() {
    return this.$$.ctx[10];
  }
  set iconposition(e) {
    this.$$set({ iconposition: e }), k();
  }
}
customElements.define("goa-accordion", he(Na, { open: {}, heading: {}, secondarytext: {}, headingsize: {}, id: {}, maxwidth: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {}, iconposition: {} }, ["headingcontent", "default"], [], !0));
const gi = 624, Er = 1024;
function Ni(t, e) {
  if (e === void 0) return -1;
  const i = t.pathname.replace(/^\//, "").split("/"), n = e.replace(/^\//, "").split("/");
  if (i.length < n.length)
    return -1;
  if (t.hash.length > 0 && t.hash === e)
    return 1;
  let l = -1, o = 0;
  for (const r of n) {
    if (i[o] !== r)
      return -1;
    l += 1, o++;
  }
  return l >= 0 ? l + 1 : l;
}
function Mr(t, e) {
  const i = t.map((o) => o.getAttribute("target") ? -1 : Ni(
    e,
    o.getAttribute("href") || ""
  )), n = Math.max(...i);
  if (i.filter((o) => o === n).length > 1)
    return null;
  const l = i.indexOf(n);
  return l > -1 ? t[l] : null;
}
const { window: Lr } = Vi;
function Wa(t) {
  _e(t, "svelte-8925d2", `.svelte-8925d2{font:var(--goa-typography-body-m)}button.svelte-8925d2{padding:var(--goa-app-header-padding-nav-item-with-children);border:none;color:var(--goa-app-header-color-text-nav-item);cursor:pointer;display:flex;align-items:center;gap:6px;background:none;border-top:var(--goa-app-header-border-nav-item-default);border-bottom:var(--goa-app-header-border-nav-item-default)}button.svelte-8925d2:active,button.svelte-8925d2:hover{background:var(--goa-app-header-color-bg-nav-item-hover);color:var(--goa-app-header-color-text-nav-item-hover);border-top:var(--goa-app-header-border-nav-item-default);border-bottom:var(--goa-app-header-border-nav-item-hover)}button.svelte-8925d2:focus-visible{outline:var(--goa-app-header-border-focus) !important;position:relative;z-index:100;background-color:var(--goa-app-header-color-bg-nav-item-focus);color:var(--goa-app-header-color-text-nav-item-focus);border-top:var(--goa-app-header-border-nav-item-default);border-bottom:var(--goa-app-header-border-nav-item-focus)}button.open.svelte-8925d2{background-color:var(--goa-app-header-color-bg-menu-button-focus);color:var(--goa-app-header-color-menu-button-focus)}button.current.svelte-8925d2{border-top:var(--goa-app-header-border-nav-item-default);border-bottom:var(--goa-app-header-border-nav-item-current)}button.current.svelte-8925d2:hover{border-top:var(--goa-app-header-border-nav-item-default);border-bottom:var(--goa-app-header-border-nav-item-hover)}::slotted(a),::slotted(a:visited){box-shadow:var(--goa-app-header-border-top-menu-item);color:var(--goa-app-header-color-text-nav-item);display:block;padding:var(--goa-app-header-padding-nav-item-in-menu) !important;text-decoration:none}::slotted(a:hover){background:var(--goa-app-header-color-bg-nav-item-child-hover);color:var(--goa-app-header-color-text-nav-item-hover) !important}::slotted(a:focus-visible){outline:var(--goa-app-header-border-focus);outline-offset:-3px;background:var(--goa-app-header-color-bg-nav-item-child-focus);color:var(--goa-app-header-color-text-nav-item-focus) !important}::slotted(a.current){background-color:var(--goa-app-header-color-bg-nav-item-in-menu-current)}::slotted(a.current:hover){background:var(--goa-app-header-color-bg-nav-item-in-menu-current-hover)}::slotted(a.interactive){color:var(--goa-app-header-nav-color-text-link-item) !important;text-decoration:underline !important;white-space:nowrap}::slotted(a.interactive:hover){color:var(--goa-app-header-nav-color-text-link-item-hover) !important}::slotted(a.interactive:focus-visible){color:var(--goa-app-header-nav-color-text-link-item-focus) !important;background-color:var(--goa-app-header-color-bg-nav-item-focus)}.not-desktop.svelte-8925d2 ::slotted(a){padding:var(
      --goa-app-header-padding-secondary-nav-item-in-menu
    ) !important}@media not (min-width: 1024px){button.svelte-8925d2{box-shadow:var(--goa-app-header-border-top-menu-item);padding:9px var(--goa-space-m);width:100%;border-top:none;border-bottom:none;display:flex;align-items:center}button.svelte-8925d2:active,button.svelte-8925d2:hover,button.svelte-8925d2:focus-visible{background:var(--goa-app-header-color-bg-nav-item-child-hover);color:var(--goa-app-header-color-text-nav-item-hover);border-top:none;border-bottom:none}button.svelte-8925d2:focus-visible{outline:var(--goa-app-header-border-focus) !important;outline-offset:-3px;border-top:none;border-bottom:none}button.open.svelte-8925d2{box-shadow:var(--goa-app-header-border-top-menu-item),
        var(--goa-app-header-border-bottom-menu-item);background:var(--goa-app-header-color-bg-nav-item-child-hover);color:var(--goa-app-header-color-text-nav-item-hover)}button.open.svelte-8925d2:hover,button.open.svelte-8925d2:focus-visible{box-shadow:var(--goa-app-header-border-top-menu-item),
        var(--goa-app-header-border-bottom-menu-item)}.heading.svelte-8925d2{flex:0 0 auto}}@media(max-width: 623px){.not-desktop.svelte-8925d2 ::slotted(a){padding:var(
        --goa-app-header-padding-secondary-nav-item-in-menu-mobile
      ) !important}button.svelte-8925d2{padding:9px var(--goa-space-2xl)}}@media(min-width: 1024px){button[slot="target"].svelte-8925d2{font-weight:var(--goa-font-weight-bold);white-space:nowrap}button.secondary.svelte-8925d2{font-weight:var(--goa-font-weight-regular)}button.open.svelte-8925d2{background-color:var(--goa-app-header-color-bg-menu-button-focus);color:var(--goa-app-header-color-menu-button-focus);border-bottom:var(--goa-app-header-border-nav-item-focus)}}`);
}
function Ra(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v, b = (
    /*leadingicon*/
    t[1] && ln(t)
  ), w = (
    /*_open*/
    t[10] && on(t)
  );
  return {
    c() {
      e = C("button"), b && b.c(), i = x(), n = C("span"), l = le(
        /*heading*/
        t[0]
      ), o = x(), r = C("goa-spacer"), a = x(), s = C("goa-icon"), c = x(), w && w.c(), g = Ne(), f(n, "class", "heading svelte-8925d2"), p(r, "hspacing", "fill"), p(r, "class", "svelte-8925d2"), p(s, "type", d = /*_open*/
      t[10] ? "chevron-up" : "chevron-down"), p(s, "mt", "2"), p(s, "class", "svelte-8925d2"), f(e, "class", u = Ee(
        /*type*/
        t[2]
      ) + " svelte-8925d2"), G(
        e,
        "open",
        /*_open*/
        t[10]
      );
    },
    m(y, j) {
      D(y, e, j), b && b.m(e, null), _(e, i), _(e, n), _(n, l), _(e, o), _(e, r), _(e, a), _(e, s), D(y, c, j), w && w.m(y, j), D(y, g, j), h = !0, m || (v = te(
        e,
        "click",
        /*toggleMenu*/
        t[11]
      ), m = !0);
    },
    p(y, j) {
      /*leadingicon*/
      y[1] ? b ? b.p(y, j) : (b = ln(y), b.c(), b.m(e, i)) : b && (b.d(1), b = null), (!h || j & /*heading*/
      1) && pe(
        l,
        /*heading*/
        y[0]
      ), (!h || j & /*_open*/
      1024 && d !== (d = /*_open*/
      y[10] ? "chevron-up" : "chevron-down")) && p(s, "type", d), (!h || j & /*type*/
      4 && u !== (u = Ee(
        /*type*/
        y[2]
      ) + " svelte-8925d2")) && f(e, "class", u), (!h || j & /*type, _open*/
      1028) && G(
        e,
        "open",
        /*_open*/
        y[10]
      ), /*_open*/
      y[10] ? w ? (w.p(y, j), j & /*_open*/
      1024 && Y(w, 1)) : (w = on(y), w.c(), Y(w, 1), w.m(g.parentNode, g)) : w && (Oe(), U(w, 1, 1, () => {
        w = null;
      }), Fe());
    },
    i(y) {
      h || (Y(w), h = !0);
    },
    o(y) {
      U(w), h = !1;
    },
    d(y) {
      y && (P(e), P(c), P(g)), b && b.d(), w && w.d(y), m = !1, v();
    }
  };
}
function Ya(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g = (
    /*leadingicon*/
    t[1] && rn(t)
  );
  const h = (
    /*#slots*/
    t[13].default
  ), m = oe(
    h,
    t,
    /*$$scope*/
    t[12],
    null
  );
  return {
    c() {
      e = C("goa-popover"), i = C("button"), g && g.c(), n = x(), l = le(
        /*heading*/
        t[0]
      ), o = x(), r = C("goa-icon"), d = x(), u = C("div"), m && m.c(), p(r, "type", a = /*_open*/
      t[10] ? "chevron-up" : "chevron-down"), p(r, "mt", "2"), p(r, "class", "svelte-8925d2"), f(i, "slot", "target"), f(i, "class", s = Ee(
        /*type*/
        t[2]
      ) + " svelte-8925d2"), G(
        i,
        "open",
        /*_open*/
        t[10]
      ), G(
        i,
        "current",
        /*_hasCurrentLink*/
        t[9]
      ), f(u, "class", "desktop svelte-8925d2"), p(e, "context", "app-header-menu"), p(e, "focusborderwidth", "0"), p(e, "borderradius", "0"), p(e, "padded", "false"), p(e, "tabindex", "-1"), p(e, "maxwidth", "16rem"), p(e, "minwidth", "8rem"), p(e, "position", "below"), p(
        e,
        "open",
        /*_open*/
        t[10]
      ), p(e, "class", "svelte-8925d2");
    },
    m(v, b) {
      D(v, e, b), _(e, i), g && g.m(i, null), _(i, n), _(i, l), _(i, o), _(i, r), _(e, d), _(e, u), m && m.m(u, null), t[15](u), t[16](e), c = !0;
    },
    p(v, b) {
      /*leadingicon*/
      v[1] ? g ? g.p(v, b) : (g = rn(v), g.c(), g.m(i, n)) : g && (g.d(1), g = null), (!c || b & /*heading*/
      1) && pe(
        l,
        /*heading*/
        v[0]
      ), (!c || b & /*_open*/
      1024 && a !== (a = /*_open*/
      v[10] ? "chevron-up" : "chevron-down")) && p(r, "type", a), (!c || b & /*type*/
      4 && s !== (s = Ee(
        /*type*/
        v[2]
      ) + " svelte-8925d2")) && f(i, "class", s), (!c || b & /*type, _open*/
      1028) && G(
        i,
        "open",
        /*_open*/
        v[10]
      ), (!c || b & /*type, _hasCurrentLink*/
      516) && G(
        i,
        "current",
        /*_hasCurrentLink*/
        v[9]
      ), m && m.p && (!c || b & /*$$scope*/
      4096) && ae(
        m,
        h,
        v,
        /*$$scope*/
        v[12],
        c ? re(
          h,
          /*$$scope*/
          v[12],
          b,
          null
        ) : se(
          /*$$scope*/
          v[12]
        ),
        null
      ), (!c || b & /*_open*/
      1024) && p(
        e,
        "open",
        /*_open*/
        v[10]
      );
    },
    i(v) {
      c || (Y(m, v), c = !0);
    },
    o(v) {
      U(m, v), c = !1;
    },
    d(v) {
      v && P(e), g && g.d(), m && m.d(v), t[15](null), t[16](null);
    }
  };
}
function ln(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(
        e,
        "type",
        /*leadingicon*/
        t[1]
      ), p(e, "mt", "1"), p(e, "class", "svelte-8925d2");
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*leadingicon*/
      2 && p(
        e,
        "type",
        /*leadingicon*/
        i[1]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function on(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[13].default
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[12],
    null
  );
  return {
    c() {
      e = C("div"), l && l.c(), f(e, "class", "not-desktop svelte-8925d2");
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null), t[17](e), i = !0;
    },
    p(o, r) {
      l && l.p && (!i || r & /*$$scope*/
      4096) && ae(
        l,
        n,
        o,
        /*$$scope*/
        o[12],
        i ? re(
          n,
          /*$$scope*/
          o[12],
          r,
          null
        ) : se(
          /*$$scope*/
          o[12]
        ),
        null
      );
    },
    i(o) {
      i || (Y(l, o), i = !0);
    },
    o(o) {
      U(l, o), i = !1;
    },
    d(o) {
      o && P(e), l && l.d(o), t[17](null);
    }
  };
}
function rn(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(
        e,
        "type",
        /*leadingicon*/
        t[1]
      ), p(e, "mt", "1"), p(e, "class", "svelte-8925d2");
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*leadingicon*/
      2 && p(
        e,
        "type",
        /*leadingicon*/
        i[1]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function Za(t) {
  let e, i, n, l, o, r;
  We(
    /*onwindowresize*/
    t[14]
  );
  const a = [Ya, Ra], s = [];
  function d(u, c) {
    return (
      /*_desktop*/
      u[5] ? 0 : 1
    );
  }
  return i = d(t), n = s[i] = a[i](t), {
    c() {
      e = C("div"), n.c(), f(
        e,
        "data-testid",
        /*testid*/
        t[3]
      ), f(e, "class", "svelte-8925d2");
    },
    m(u, c) {
      D(u, e, c), s[i].m(e, null), t[18](e), l = !0, o || (r = te(
        Lr,
        "resize",
        /*onwindowresize*/
        t[14]
      ), o = !0);
    },
    p(u, [c]) {
      let g = i;
      i = d(u), i === g ? s[i].p(u, c) : (Oe(), U(s[g], 1, 1, () => {
        s[g] = null;
      }), Fe(), n = s[i], n ? n.p(u, c) : (n = s[i] = a[i](u), n.c()), Y(n, 1), n.m(e, null)), (!l || c & /*testid*/
      8) && f(
        e,
        "data-testid",
        /*testid*/
        u[3]
      );
    },
    i(u) {
      l || (Y(n), l = !0);
    },
    o(u) {
      U(n), l = !1;
    },
    d(u) {
      u && P(e), s[i].d(), t[18](null), o = !1, r();
    }
  };
}
function Ua(t, e, i) {
  let n, { $$slots: l = {}, $$scope: o } = e, { heading: r } = e, { leadingicon: a } = e, { type: s = "primary" } = e, { testid: d = "rootEl" } = e, u = window.innerWidth, c, g, h, m = !1, v = !1;
  ke(() => {
    Kt("GoaAppHeaderMenu", { heading: r }), b(), w();
  });
  function b() {
    if (!g) return;
    const R = lt(g);
    if (R.length === 0) return;
    const I = R.filter((B) => B.tagName === "A").map((B) => (B.classList.remove("current"), B));
    setTimeout(
      () => {
        h == null || h.dispatchEvent(new CustomEvent(
          "app-header-menu:mounted",
          {
            detail: { el: h, links: I },
            composed: !0,
            bubbles: !0
          }
        ));
      },
      1
    );
  }
  function w() {
    h == null || h.addEventListener("app-header:changed", (R) => {
      const I = R.detail;
      y(I);
    });
  }
  function y(R) {
    if (!g) return;
    const I = lt(g);
    if (I.length === 0) return;
    const N = I.filter((F) => F.tagName === "A").map((F) => (F.classList.remove("current"), F)).find((F) => F.getAttribute("href") === R);
    N && N.classList.add("current"), i(9, m = !!N), M();
  }
  async function j() {
    await Pe(), c && (c.removeEventListener("_close", M), c.removeEventListener("_open", E), c.addEventListener("_close", M), c.addEventListener("_open", E));
  }
  async function E() {
    i(10, v = !0), await Pe(), g && g.addEventListener("click", M);
  }
  function M() {
    g && g.removeEventListener("click", M), setTimeout(
      () => {
        i(10, v = !1);
      },
      1
    );
  }
  function L() {
    v ? M() : E();
  }
  function z() {
    i(4, u = Lr.innerWidth);
  }
  function V(R) {
    ue[R ? "unshift" : "push"](() => {
      g = R, i(7, g);
    });
  }
  function T(R) {
    ue[R ? "unshift" : "push"](() => {
      c = R, i(6, c);
    });
  }
  function S(R) {
    ue[R ? "unshift" : "push"](() => {
      g = R, i(7, g);
    });
  }
  function A(R) {
    ue[R ? "unshift" : "push"](() => {
      h = R, i(8, h);
    });
  }
  return t.$$set = (R) => {
    "heading" in R && i(0, r = R.heading), "leadingicon" in R && i(1, a = R.leadingicon), "type" in R && i(2, s = R.type), "testid" in R && i(3, d = R.testid), "$$scope" in R && i(12, o = R.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*_innerWidth*/
    16 && i(5, n = u >= Er), t.$$.dirty & /*_desktop*/
    32 && n && j();
  }, [
    r,
    a,
    s,
    d,
    u,
    n,
    c,
    g,
    h,
    m,
    v,
    L,
    o,
    l,
    z,
    V,
    T,
    S,
    A
  ];
}
class Ga extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Ua,
      Za,
      ce,
      {
        heading: 0,
        leadingicon: 1,
        type: 2,
        testid: 3
      },
      Wa
    );
  }
  get heading() {
    return this.$$.ctx[0];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get leadingicon() {
    return this.$$.ctx[1];
  }
  set leadingicon(e) {
    this.$$set({ leadingicon: e }), k();
  }
  get type() {
    return this.$$.ctx[2];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get testid() {
    return this.$$.ctx[3];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-app-header-menu", he(Ga, { heading: {}, leadingicon: {}, type: {}, testid: {} }, ["default"], [], !0));
const { window: qr } = Vi;
function Ka(t) {
  _e(t, "svelte-a37shb", `.svelte-a37shb.svelte-a37shb,::slotted(*){font:var(--goa-app-header-typography-service-name)}.container.svelte-a37shb.svelte-a37shb{border-bottom:var(--goa-app-header-border-bottom);background-color:var(--goa-app-header-color-bg)}@media(min-width: 1024px){.container.tablet.svelte-a37shb.svelte-a37shb{padding:0 var(--goa-space-3xl)}.container.desktop.svelte-a37shb.svelte-a37shb{padding:0 var(--desktop-padding)}}@media(min-width: 624px) and (max-width: 1023px){.container.svelte-a37shb.svelte-a37shb{padding:0 var(--goa-space-xl)}}.layout.svelte-a37shb.svelte-a37shb{width:100%;display:grid;grid-template-columns:1fr auto;grid-template-areas:"header menu"
      "links links"}.content-area.svelte-a37shb.svelte-a37shb{grid-area:links}.desktop.svelte-a37shb .layout.svelte-a37shb{display:grid;grid-template-columns:auto 1fr auto;grid-template-rows:auto;grid-template-areas:"header . menu";margin:0 auto;width:min(var(--max-content-width), 100%)}.title.svelte-a37shb.svelte-a37shb{color:var(--goa-app-header-color-service-name)}.header-logo-title-area.svelte-a37shb.svelte-a37shb{grid-area:header;display:flex;text-decoration:none;align-items:flex-start}.header-logo-title-area.svelte-a37shb.svelte-a37shb:focus-visible{outline:var(--goa-app-header-service-name-border-focus);z-index:100;position:relative}::slotted(a){display:flex;align-items:center;margin:0;padding:var(--goa-app-header-padding-nav-item-in-menu);cursor:pointer;white-space:nowrap;text-decoration:none;overflow:hidden}::slotted(a:focus-visible){outline:var(--goa-app-header-border-focus);outline-offset:0px;z-index:100;position:relative}::slotted(a.inside-collapse-menu){color:var(--goa-app-header-color-text-nav-item);background-color:var(--goa-app-header-color-bg-nav-item)}::slotted(a.inside-collapse-menu:hover){color:var(--goa-app-header-color-text-nav-item-hover) !important;background-color:var(--goa-app-header-color-bg-nav-item-child-hover)}::slotted(a.inside-collapse-menu:focus-visible){outline-offset:-3px;background-color:var(
      --goa-app-header-color-bg-nav-item-child-focus
    ) !important;color:var(--goa-app-header-color-text-nav-item-focus) !important}::slotted(a.interactive){color:var(--goa-app-header-nav-color-text-link-item) !important;text-decoration:underline !important;white-space:nowrap}::slotted(a.interactive:hover){color:var(--goa-app-header-nav-color-text-link-item-hover) !important}::slotted(a.interactive:focus-visible){color:var(--goa-app-header-nav-color-text-link-item-focus) !important;background-color:var(
      --goa-app-header-color-bg-nav-item-child-focus
    ) !important}::slotted(a.inside-collapse-menu.current){color:var(app-header-color-text-nav-item-in-menu-current);background-color:var(--goa-app-header-color-bg-nav-item-in-menu-current) !important}::slotted(a.inside-collapse-menu.current:hover){color:var(app-header-color-text-nav-item-in-menu-current-hover) !important;background-color:var(--goa-app-header-color-bg-nav-item-in-menu-current-hover) !important}.desktop.svelte-a37shb .content-area.svelte-a37shb{grid-area:menu;display:flex;align-items:stretch}.desktop.svelte-a37shb .menu-toggle-area.svelte-a37shb{display:none}.desktop.svelte-a37shb .title.svelte-a37shb{padding-top:5.5px;max-width:var(--goa-app-header-max-width-service-name);min-width:var(--goa-app-header-min-width-service-name);font:var(--goa-app-header-typography-service-name)}.desktop.svelte-a37shb .header-logo-title-area.svelte-a37shb{grid-area:header;display:flex;align-items:flex-start;color:inherit;flex:1 1 auto;min-height:var(--goa-app-header-size-logo);margin:var(--goa-app-header-padding-logo);gap:var(--goa-app-header-space-btw-logo-service-name)}.desktop.svelte-a37shb .image-desktop.svelte-a37shb{display:block}.desktop.svelte-a37shb .image-mobile.svelte-a37shb{display:none}.desktop.svelte-a37shb ::slotted(a),.desktop.svelte-a37shb ::slotted(a:visited){font:var(--goa-app-header-typography-nav-item);display:block;align-items:center;padding:var(--goa-app-header-padding-nav-item);text-decoration:none;height:var(--goa-app-header-height-nav-item);border-top:var(--goa-app-header-border-nav-item-default);border-bottom:var(--goa-app-header-border-nav-item-default)}.desktop.svelte-a37shb ::slotted(a:hover){cursor:pointer;color:var(--goa-app-header-color-text-nav-item-hover) !important;background:var(--goa-app-header-color-bg-nav-item-hover);border-top:var(--goa-app-header-border-nav-item-default);border-bottom:var(--goa-app-header-border-nav-item-hover)}.desktop.svelte-a37shb ::slotted(a:focus-visible){cursor:pointer;color:var(--goa-app-header-color-text-nav-item-focus) !important;background:var(--goa-app-header-color-bg-nav-item-focus);border-top:var(--goa-app-header-border-nav-item-default);border-bottom:var(--goa-app-header-border-nav-item-focus)}.desktop.svelte-a37shb ::slotted(a.current){border-top:var(--goa-app-header-border-nav-item-default) !important;border-bottom:var(--goa-app-header-border-nav-item-current)}.desktop.svelte-a37shb ::slotted(a.current:hover){border-top:var(--goa-app-header-border-nav-item-default) !important;border-bottom:var(--goa-app-header-border-nav-item-current-hover)}.desktop.svelte-a37shb ::slotted(a.current:focus-visible){border-top:var(--goa-app-header-border-nav-item-default) !important;border-bottom:var(--goa-app-header-border-nav-item-current-focus)}.desktop.svelte-a37shb ::slotted(goa-app-header-menu){height:var(--goa-app-header-height-nav-item)}.desktop.svelte-a37shb ::slotted(goa-app-header-menu:hover){background:var(--goa-app-header-color-bg-nav-item-hover);cursor:pointer;color:var(--goa-app-header-color-text-nav-item-hover) !important;overflow:hidden !important}.desktop.svelte-a37shb ::slotted(a.interactive){font:var(--goa-app-header-typography-link-item);padding:var(--goa-app-header-padding-link-item)}.desktop.svelte-a37shb ::slotted(a.interactive:hover){border-top:var(--goa-app-header-border-nav-item-default);border-bottom:var(--goa-app-header-border-nav-item-default);background-color:var(--goa-app-header-nav-color-bg-link-item-hover)}.desktop.svelte-a37shb ::slotted(a.interactive:focus-visible){border-top:var(--goa-app-header-border-nav-item-default) !important;border-bottom:var(--goa-app-header-border-nav-item-default) !important;background-color:var(
      --goa-app-header-nav-color-bg-link-item-focus
    ) !important}.desktop.svelte-a37shb ::slotted(a.interactive.current){border-top:var(--goa-app-header-border-nav-item-default) !important;border-bottom:var(--goa-app-header-border-nav-item-default) !important}.tablet.svelte-a37shb .header-logo-title-area.svelte-a37shb{margin:var(--goa-app-header-padding-logo);min-height:var(--goa-app-header-size-logo);gap:var(--goa-app-header-space-btw-logo-service-name)}.tablet.svelte-a37shb .title.svelte-a37shb{padding-top:5.5px;font:var(--goa-app-header-typography-service-name);max-width:var(--goa-app-header-max-width-service-name);min-width:var(--goa-app-header-min-width-service-name)}.tablet.svelte-a37shb .image-desktop.svelte-a37shb{display:block}.tablet.svelte-a37shb .image-mobile.svelte-a37shb{display:none}.menu-toggle-area.svelte-a37shb.svelte-a37shb{grid-area:menu;display:flex;position:relative}.menu-toggle-area.svelte-a37shb button.svelte-a37shb{display:flex;background:transparent;border:none;cursor:pointer;height:var(--goa-app-header-height-nav-item);align-items:center;gap:6px;font:var(--goa-app-header-typography-menu-button);padding:var(--goa-app-header-padding-menu-button);text-decoration:none;color:var(--goa-app-header-color-menu-button)}.menu-toggle-area.svelte-a37shb button.svelte-a37shb:hover{color:var(--goa-app-header-color-menu-button-hover);box-shadow:inset 0 -4px 0 0 var(--goa-color-interactive-hover)}.menu-toggle-area.svelte-a37shb button.svelte-a37shb:focus-visible{outline:var(--goa-app-header-border-focus);z-index:100;position:relative;color:var(--goa-app-header-color-menu-button-focus);box-shadow:inset 0 -4px 0 0 var(--goa-color-interactive-hover)}.menu-toggle-area.svelte-a37shb button.menu-open.svelte-a37shb{background-color:var(--goa-app-header-color-bg-menu-button-focus);color:var(--goa-app-header-color-menu-button-focus);box-shadow:inset 0 -4px 0 0 var(--goa-color-interactive-hover)}.menu-toggle-area.svelte-a37shb goa-icon.svelte-a37shb{scale:1}.tablet.svelte-a37shb .menu-toggle-area.svelte-a37shb{padding-left:var(--goa-app-header-space-btw-service-name-nav-items-in-menu);height:100%;display:flex;align-items:end}::slotted(a.interactive:focus-visible){color:var(--goa-app-header-nav-color-text-link-item-focus) !important;background-color:var(--goa-app-header-nav-color-bg-link-item-in-menu-focus) !important;border-top:none !important;border-bottom:none}.tablet.svelte-a37shb ::slotted(a:not(:first-child)){box-shadow:inset 0 var(--goa-border-width-s) 0 0
      var(--goa-color-greyscale-200)}.mobile.svelte-a37shb .title.svelte-a37shb{margin-top:-1px;color:var(--goa-app-header-color-service-name);max-width:var(--goa-app-header-max-width-service-name);min-width:var(--goa-app-header-min-width-service-name);font:var(--goa-app-header-typography-service-name-mobile)}.mobile.svelte-a37shb .header-logo-title-area.svelte-a37shb{display:flex;align-items:start;padding:var(--goa-app-header-padding-logo-mobile);gap:var(--goa-app-header-space-btw-logo-service-name-mobile)}.mobile.svelte-a37shb .image-desktop.svelte-a37shb{display:none}.mobile.svelte-a37shb .image-mobile.svelte-a37shb{display:block;width:var(--goa-app-header-size-logo-mobile)}.mobile.svelte-a37shb .menu-toggle-area button.svelte-a37shb{height:var(--goa-app-header-height-nav-item-mobile);font:var(--goa-app-header-typography-menu-button-mobile);display:flex;align-items:center}.mobile.svelte-a37shb .menu-toggle-area.svelte-a37shb{display:flex;align-items:end;position:relative}.mobile.svelte-a37shb .menu-toggle-area button.menu-open.svelte-a37shb{background-color:var(--goa-app-header-color-bg-menu-button-focus);color:var(--goa-app-header-color-menu-button-focus);box-shadow:inset 0 -4px 0 0 var(--goa-color-interactive-hover)}.mobile.svelte-a37shb .menu-toggle-area goa-icon.svelte-a37shb{scale:0.8}.mobile.svelte-a37shb ::slotted(a){box-shadow:inset 0 var(--goa-border-width-s) 0 0
      var(--goa-color-greyscale-200);font:var(--goa-app-header-typography-menu-item);padding-left:var(--goa-space-2xl);padding-right:var(--goa-space-xl)}.mobile.show-menu.svelte-a37shb.svelte-a37shb{border-bottom:var(--goa-border-width-m) solid
      var(--goa-color-greyscale-200)}`);
}
function Xa(t) {
  let e, i, n, l, o, r, a, s = (
    /*heading*/
    t[0] && an(t)
  );
  return {
    c() {
      e = C("div"), i = C("img"), l = x(), o = C("img"), a = x(), s && s.c(), f(i, "alt", "GoA Logo"), f(i, "class", "image-mobile svelte-a37shb"), Ot(i.src, n = Sr) || f(i, "src", n), f(o, "alt", "GoA Logo"), f(o, "class", "image-desktop svelte-a37shb"), Ot(o.src, r = Tr) || f(o, "src", r), f(e, "class", "header-logo-title-area svelte-a37shb");
    },
    m(d, u) {
      D(d, e, u), _(e, i), _(e, l), _(e, o), _(e, a), s && s.m(e, null);
    },
    p(d, u) {
      /*heading*/
      d[0] ? s ? s.p(d, u) : (s = an(d), s.c(), s.m(e, null)) : s && (s.d(1), s = null);
    },
    d(d) {
      d && P(e), s && s.d();
    }
  };
}
function Ja(t) {
  let e, i, n, l, o, r, a, s = (
    /*heading*/
    t[0] && sn(t)
  );
  return {
    c() {
      e = C("a"), i = C("img"), l = x(), o = C("img"), a = x(), s && s.c(), f(i, "alt", "GoA Logo"), f(i, "class", "image-mobile svelte-a37shb"), Ot(i.src, n = Sr) || f(i, "src", n), f(o, "alt", "GoA Logo"), f(o, "class", "image-desktop svelte-a37shb"), Ot(o.src, r = Tr) || f(o, "src", r), f(
        e,
        "href",
        /*url*/
        t[1]
      ), f(e, "class", "header-logo-title-area svelte-a37shb"), f(e, "data-testid", "url");
    },
    m(d, u) {
      D(d, e, u), _(e, i), _(e, l), _(e, o), _(e, a), s && s.m(e, null);
    },
    p(d, u) {
      /*heading*/
      d[0] ? s ? s.p(d, u) : (s = sn(d), s.c(), s.m(e, null)) : s && (s.d(1), s = null), u[0] & /*url*/
      2 && f(
        e,
        "href",
        /*url*/
        d[1]
      );
    },
    d(d) {
      d && P(e), s && s.d();
    }
  };
}
function an(t) {
  let e, i;
  return {
    c() {
      e = C("span"), i = le(
        /*heading*/
        t[0]
      ), f(e, "data-testid", "title"), f(e, "class", "title svelte-a37shb");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l[0] & /*heading*/
      1 && pe(
        i,
        /*heading*/
        n[0]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function sn(t) {
  let e, i;
  return {
    c() {
      e = C("span"), i = le(
        /*heading*/
        t[0]
      ), f(e, "data-testid", "title"), f(e, "class", "title svelte-a37shb");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l[0] & /*heading*/
      1 && pe(
        i,
        /*heading*/
        n[0]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function un(t) {
  let e, i, n, l, o, r = !/*_hasMenuClickHandler*/
  t[11] && dn(t);
  return {
    c() {
      e = C("div"), i = C("button"), n = le(`Menu
          `), r && r.c(), f(i, "data-testid", "menu-toggle"), f(i, "class", "svelte-a37shb"), G(
        i,
        "menu-open",
        /*_showMenu*/
        t[9]
      ), f(e, "class", "menu-toggle-area svelte-a37shb");
    },
    m(a, s) {
      D(a, e, s), _(e, i), _(i, n), r && r.m(i, null), t[22](i), l || (o = te(i, "click", function() {
        ot(
          /*_hasMenuClickHandler*/
          t[11] ? (
            /*dispatchMenuClick*/
            t[16]
          ) : (
            /*toggleMenu*/
            t[14]
          )
        ) && /*_hasMenuClickHandler*/
        (t[11] ? (
          /*dispatchMenuClick*/
          t[16]
        ) : (
          /*toggleMenu*/
          t[14]
        )).apply(this, arguments);
      }), l = !0);
    },
    p(a, s) {
      t = a, /*_hasMenuClickHandler*/
      t[11] ? r && (r.d(1), r = null) : r ? r.p(t, s) : (r = dn(t), r.c(), r.m(i, null)), s[0] & /*_showMenu*/
      512 && G(
        i,
        "menu-open",
        /*_showMenu*/
        t[9]
      );
    },
    d(a) {
      a && P(e), r && r.d(), t[22](null), l = !1, o();
    }
  };
}
function dn(t) {
  let e, i;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", i = /*_showMenu*/
      t[9] ? "chevron-up" : "chevron-down"), p(e, "mt", "2"), p(e, "class", "svelte-a37shb");
    },
    m(n, l) {
      D(n, e, l);
    },
    p(n, l) {
      l[0] & /*_showMenu*/
      512 && i !== (i = /*_showMenu*/
      n[9] ? "chevron-up" : "chevron-down") && p(e, "type", i);
    },
    d(n) {
      n && P(e);
    }
  };
}
function cn(t) {
  let e, i, n, l, o, r, a, s, d = !/*_hasMenuClickHandler*/
  t[11] && fn(t), u = (
    /*_showMenu*/
    t[9] && gn(t)
  );
  return {
    c() {
      e = C("goa-popover"), i = C("div"), n = C("button"), l = le(`Menu
            `), d && d.c(), o = x(), u && u.c(), f(n, "data-testid", "menu-toggle"), f(n, "class", "svelte-a37shb"), G(
        n,
        "menu-open",
        /*_showMenu*/
        t[9]
      ), f(i, "slot", "target"), f(i, "class", "menu-toggle-area svelte-a37shb"), p(e, "class", "menu svelte-a37shb"), p(
        e,
        "open",
        /*_showMenu*/
        t[9]
      ), p(e, "minwidth", "16rem"), p(e, "context", "menu-toggle-area"), p(e, "focusborderwidth", "0"), p(e, "borderradius", "4"), p(e, "padded", "false"), p(e, "tabindex", "-1"), p(e, "height", "full"), p(e, "position", "below");
    },
    m(c, g) {
      D(c, e, g), _(e, i), _(i, n), _(n, l), d && d.m(n, null), t[23](n), _(e, o), u && u.m(e, null), r = !0, a || (s = [
        te(n, "click", function() {
          ot(
            /*_hasMenuClickHandler*/
            t[11] ? (
              /*dispatchMenuClick*/
              t[16]
            ) : (
              /*toggleMenu*/
              t[14]
            )
          ) && /*_hasMenuClickHandler*/
          (t[11] ? (
            /*dispatchMenuClick*/
            t[16]
          ) : (
            /*toggleMenu*/
            t[14]
          )).apply(this, arguments);
        }),
        te(
          e,
          "_close",
          /*hideMenu*/
          t[15]
        )
      ], a = !0);
    },
    p(c, g) {
      t = c, /*_hasMenuClickHandler*/
      t[11] ? d && (d.d(1), d = null) : d ? d.p(t, g) : (d = fn(t), d.c(), d.m(n, null)), (!r || g[0] & /*_showMenu*/
      512) && G(
        n,
        "menu-open",
        /*_showMenu*/
        t[9]
      ), /*_showMenu*/
      t[9] ? u ? (u.p(t, g), g[0] & /*_showMenu*/
      512 && Y(u, 1)) : (u = gn(t), u.c(), Y(u, 1), u.m(e, null)) : u && (Oe(), U(u, 1, 1, () => {
        u = null;
      }), Fe()), (!r || g[0] & /*_showMenu*/
      512) && p(
        e,
        "open",
        /*_showMenu*/
        t[9]
      );
    },
    i(c) {
      r || (Y(u), r = !0);
    },
    o(c) {
      U(u), r = !1;
    },
    d(c) {
      c && P(e), d && d.d(), t[23](null), u && u.d(), a = !1, He(s);
    }
  };
}
function fn(t) {
  let e, i;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", i = /*_showMenu*/
      t[9] ? "chevron-up" : "chevron-down"), p(e, "mt", "2"), p(e, "class", "svelte-a37shb");
    },
    m(n, l) {
      D(n, e, l);
    },
    p(n, l) {
      l[0] & /*_showMenu*/
      512 && i !== (i = /*_showMenu*/
      n[9] ? "chevron-up" : "chevron-down") && p(e, "type", i);
    },
    d(n) {
      n && P(e);
    }
  };
}
function gn(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[20].default
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[19],
    null
  );
  return {
    c() {
      e = C("div"), l && l.c(), f(e, "data-testid", "slot"), f(e, "class", "svelte-a37shb");
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null), t[24](e), i = !0;
    },
    p(o, r) {
      l && l.p && (!i || r[0] & /*$$scope*/
      524288) && ae(
        l,
        n,
        o,
        /*$$scope*/
        o[19],
        i ? re(
          n,
          /*$$scope*/
          o[19],
          r,
          null
        ) : se(
          /*$$scope*/
          o[19]
        ),
        null
      );
    },
    i(o) {
      i || (Y(l, o), i = !0);
    },
    o(o) {
      U(l, o), i = !1;
    },
    d(o) {
      o && P(e), l && l.d(o), t[24](null);
    }
  };
}
function hn(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[20].default
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[19],
    null
  );
  return {
    c() {
      e = C("div"), l && l.c(), Be(e, "display", "none"), f(e, "class", "svelte-a37shb");
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null), t[25](e), i = !0;
    },
    p(o, r) {
      l && l.p && (!i || r[0] & /*$$scope*/
      524288) && ae(
        l,
        n,
        o,
        /*$$scope*/
        o[19],
        i ? re(
          n,
          /*$$scope*/
          o[19],
          r,
          null
        ) : se(
          /*$$scope*/
          o[19]
        ),
        null
      );
    },
    i(o) {
      i || (Y(l, o), i = !0);
    },
    o(o) {
      U(l, o), i = !1;
    },
    d(o) {
      o && P(e), l && l.d(o), t[25](null);
    }
  };
}
function mn(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[20].default
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[19],
    null
  );
  return {
    c() {
      e = C("div"), l && l.c(), f(e, "data-testid", "slot"), f(e, "class", "content-area svelte-a37shb");
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null), t[26](e), i = !0;
    },
    p(o, r) {
      l && l.p && (!i || r[0] & /*$$scope*/
      524288) && ae(
        l,
        n,
        o,
        /*$$scope*/
        o[19],
        i ? re(
          n,
          /*$$scope*/
          o[19],
          r,
          null
        ) : se(
          /*$$scope*/
          o[19]
        ),
        null
      );
    },
    i(o) {
      i || (Y(l, o), i = !0);
    },
    o(o) {
      U(l, o), i = !1;
    },
    d(o) {
      o && P(e), l && l.d(o), t[26](null);
    }
  };
}
function Qa(t) {
  let e, i, n, l, o, r, a, s, d, u;
  We(
    /*onwindowresize*/
    t[21]
  );
  function c(y, j) {
    return (
      /*url*/
      y[1] ? Ja : Xa
    );
  }
  let g = c(t), h = g(t), m = (
    /*_showToggleMenu*/
    t[8] && /*_mobile*/
    t[13] && un(t)
  ), v = (
    /*_showToggleMenu*/
    t[8] && /*_tablet*/
    t[12] && cn(t)
  ), b = !/*_showMenu*/
  t[9] && /*_mobile*/
  (t[13] || /*_tablet*/
  t[12]) && hn(t), w = (
    /*_showMenu*/
    (t[9] && /*_mobile*/
    t[13] && !/*_hasMenuClickHandler*/
    t[11] || /*_desktop*/
    t[5]) && mn(t)
  );
  return {
    c() {
      e = C("div"), i = C("div"), h.c(), n = x(), m && m.c(), l = x(), v && v.c(), o = x(), b && b.c(), r = x(), w && w.c(), f(i, "class", "layout svelte-a37shb"), f(e, "class", "container svelte-a37shb"), f(
        e,
        "data-testid",
        /*testid*/
        t[2]
      ), f(e, "style", a = `
  --max-content-width: ${/*maxcontentwidth*/
      t[3] || "100%"};
  --desktop-padding: ${/*maxcontentwidth*/
      t[3] && /*maxcontentwidth*/
      t[3] !== "100%" && /*_windowWidth*/
      t[4] > +/*maxcontentwidth*/
      t[3] ? "0" : "var(--goa-space-3xl)"};
`), G(
        e,
        "show-menu",
        /*_showMenu*/
        t[9]
      ), G(
        e,
        "mobile",
        /*_mobile*/
        t[13]
      ), G(
        e,
        "tablet",
        /*_tablet*/
        t[12]
      ), G(
        e,
        "desktop",
        /*_desktop*/
        t[5]
      );
    },
    m(y, j) {
      D(y, e, j), _(e, i), h.m(i, null), _(i, n), m && m.m(i, null), _(i, l), v && v.m(i, null), _(i, o), b && b.m(i, null), _(i, r), w && w.m(i, null), t[27](e), s = !0, d || (u = te(
        qr,
        "resize",
        /*onwindowresize*/
        t[21]
      ), d = !0);
    },
    p(y, j) {
      g === (g = c(y)) && h ? h.p(y, j) : (h.d(1), h = g(y), h && (h.c(), h.m(i, n))), /*_showToggleMenu*/
      y[8] && /*_mobile*/
      y[13] ? m ? m.p(y, j) : (m = un(y), m.c(), m.m(i, l)) : m && (m.d(1), m = null), /*_showToggleMenu*/
      y[8] && /*_tablet*/
      y[12] ? v ? (v.p(y, j), j[0] & /*_showToggleMenu, _tablet*/
      4352 && Y(v, 1)) : (v = cn(y), v.c(), Y(v, 1), v.m(i, o)) : v && (Oe(), U(v, 1, 1, () => {
        v = null;
      }), Fe()), !/*_showMenu*/
      y[9] && /*_mobile*/
      (y[13] || /*_tablet*/
      y[12]) ? b ? (b.p(y, j), j[0] & /*_showMenu, _mobile, _tablet*/
      12800 && Y(b, 1)) : (b = hn(y), b.c(), Y(b, 1), b.m(i, r)) : b && (Oe(), U(b, 1, 1, () => {
        b = null;
      }), Fe()), /*_showMenu*/
      y[9] && /*_mobile*/
      y[13] && !/*_hasMenuClickHandler*/
      y[11] || /*_desktop*/
      y[5] ? w ? (w.p(y, j), j[0] & /*_showMenu, _mobile, _hasMenuClickHandler, _desktop*/
      10784 && Y(w, 1)) : (w = mn(y), w.c(), Y(w, 1), w.m(i, null)) : w && (Oe(), U(w, 1, 1, () => {
        w = null;
      }), Fe()), (!s || j[0] & /*testid*/
      4) && f(
        e,
        "data-testid",
        /*testid*/
        y[2]
      ), (!s || j[0] & /*maxcontentwidth, _windowWidth*/
      24 && a !== (a = `
  --max-content-width: ${/*maxcontentwidth*/
      y[3] || "100%"};
  --desktop-padding: ${/*maxcontentwidth*/
      y[3] && /*maxcontentwidth*/
      y[3] !== "100%" && /*_windowWidth*/
      y[4] > +/*maxcontentwidth*/
      y[3] ? "0" : "var(--goa-space-3xl)"};
`)) && f(e, "style", a), (!s || j[0] & /*_showMenu*/
      512) && G(
        e,
        "show-menu",
        /*_showMenu*/
        y[9]
      ), (!s || j[0] & /*_mobile*/
      8192) && G(
        e,
        "mobile",
        /*_mobile*/
        y[13]
      ), (!s || j[0] & /*_tablet*/
      4096) && G(
        e,
        "tablet",
        /*_tablet*/
        y[12]
      ), (!s || j[0] & /*_desktop*/
      32) && G(
        e,
        "desktop",
        /*_desktop*/
        y[5]
      );
    },
    i(y) {
      s || (Y(v), Y(b), Y(w), s = !0);
    },
    o(y) {
      U(v), U(b), U(w), s = !1;
    },
    d(y) {
      y && P(e), h.d(), m && m.d(), v && v.d(), b && b.d(), w && w.d(), t[27](null), d = !1, u();
    }
  };
}
const Sr = "data:image/svg+xml,%3Csvg width='35' height='35' viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_252_21401)'%3E%3Cpath d='M17.5 0C20.9612 0 24.3446 1.02636 27.2225 2.94928C30.1003 4.87221 32.3434 7.60533 33.6679 10.803C34.9924 14.0007 35.339 17.5194 34.6637 20.9141C33.9885 24.3087 32.3218 27.4269 29.8744 29.8744C27.4269 32.3218 24.3087 33.9885 20.9141 34.6637C17.5194 35.339 14.0007 34.9924 10.803 33.6679C7.60533 32.3434 4.87221 30.1003 2.94928 27.2225C1.02636 24.3446 0 20.9612 0 17.5C0 12.8587 1.84374 8.40752 5.12563 5.12563C8.40752 1.84374 12.8587 0 17.5 0V0Z' fill='%2300B6ED'/%3E%3Cpath d='M23.8045 24.8037C22.2993 24.2487 20.8302 23.6001 19.4059 22.8618C20.6989 22.3869 21.9597 21.8286 23.1803 21.1903C23.3048 22.4081 23.5131 23.6159 23.8036 24.8051M31.8873 9.83681C31.2574 9.7572 31.5846 10.0501 31.4091 10.8801C30.6504 14.4588 27.7236 17.0381 24.7854 18.7685C24.4775 14.6704 24.6033 10.1205 25.3748 7.33228C26.0258 4.97862 26.7999 5.41055 25.8397 4.91616C24.828 4.39581 23.7438 5.0833 22.8654 6.83656C21.987 8.58982 17.9421 18.1074 11.4762 24.5341C8.16898 27.8238 5.17753 26.1295 4.57844 25.6236C4.09108 25.2119 3.91118 25.8475 4.51598 26.4985C7.19074 29.3826 11.0984 27.7279 12.5213 26.3058C16.4536 22.3753 21.0255 13.9143 22.8751 10.3242C22.6597 13.451 22.7093 16.5904 23.0233 19.7089C21.5336 20.4399 19.98 21.0325 18.382 21.4793C17.4653 21.7195 16.8983 22.0929 16.8816 22.5174C16.8636 22.9823 17.4789 23.3747 18.3688 23.7969C19.9522 24.5491 24.5918 26.7409 25.735 27.4037C26.7137 27.9716 27.1914 27.5286 27.4812 26.9155C27.8599 26.1163 26.8215 25.6544 25.8151 25.3536C25.3709 23.6667 25.0692 21.9455 24.9129 20.2081C27.2714 18.7566 29.5934 16.8213 30.9319 14.4078C31.3641 13.5596 31.6853 12.6593 31.8877 11.7291C32.0278 11.1562 32.0661 10.5632 32.0007 9.97712C32.0007 9.97712 31.9831 9.84913 31.8877 9.83681' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_252_21401'%3E%3Crect width='35' height='35' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A", Tr = "data:image/svg+xml,%3Csvg width='118' height='32' viewBox='0 0 155 42' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_74_4890)'%3E%3Cpath d='M155 21H140.6V35.4004H155V21Z' fill='%2300B6ED'/%3E%3Cpath d='M65.5539 33.211C64.116 33.349 62.6147 33.4882 61.0366 33.5566C61.6106 29.2005 63.9758 23.1883 66.915 24.1484C68.6357 24.7016 67.7035 29.8197 65.5527 33.2086L65.5539 33.211ZM61.8957 36.1823C61.4683 36.2514 61.0326 36.2514 60.6053 36.1823C60.7165 36.1047 60.8073 36.0013 60.8699 35.881C60.9325 35.7606 60.965 35.6268 60.9647 35.4911V34.9378C61.7531 34.9378 62.9717 34.7998 64.4779 34.6606C63.8154 35.4471 62.9038 35.9839 61.8957 36.1823ZM79.8198 25.8116C81.6842 24.1484 82.6164 24.29 82.8273 24.7052C83.3294 25.6736 81.1786 29.0625 76.9489 30.9297C77.3845 28.9796 78.3814 27.2002 79.8162 25.8116H79.8198ZM149 27.4712C148.784 24.0824 145.702 23.5291 145.272 24.4976C145.128 24.8432 146.419 24.7052 146.419 27.1256C146.419 31.0677 142.261 36.2543 136.953 36.2543C135.111 36.3656 133.298 35.7577 131.894 34.5583C130.49 33.3589 129.605 31.6613 129.425 29.8221C129.209 28.3701 129.568 26.3636 126.988 26.6408C125.19 26.8484 123.618 30.1677 121.324 33.001C119.387 35.4215 118.527 35.2139 118.957 33.139C119.531 30.5109 121.754 24.4256 124.335 24.0104C125.553 23.8027 125.983 25.8104 126.491 24.5636C126.674 24.1246 126.746 23.6475 126.701 23.1742C126.655 22.7009 126.495 22.246 126.233 21.8497C125.97 21.4533 125.615 21.1276 125.197 20.9012C124.78 20.6749 124.313 20.5549 123.839 20.5519C121.974 20.5519 119.751 22.4887 117.888 24.632C116.311 26.5688 108.209 38.0483 104.768 35.5595C103.191 34.3834 103.33 29.6793 104.338 24.1484C105.794 23.5168 107.361 23.1795 108.948 23.1559C110.536 23.1322 112.112 23.4226 113.587 24.0104C114.519 24.4256 114.665 24.356 114.233 23.3875C113.659 21.9355 110.433 19.653 105.343 20.6899C105.199 20.6899 105.127 20.7595 104.984 20.7595C105.414 18.9594 105.844 17.0946 106.421 15.2957C106.923 13.6361 108.286 10.8004 104.624 10.3168C103.477 10.1092 103.979 10.6624 103.546 12.184C102.827 14.9501 101.969 18.5442 101.323 22.2115C98.0002 24.1064 95.2885 26.9143 93.5082 30.3033C93.9222 28.7349 94.2336 27.141 94.4404 25.532C94.4806 25.1343 94.3704 24.7359 94.1314 24.4157C93.8924 24.0955 93.5422 23.8768 93.1499 23.8027C92.3615 23.5951 91.3526 23.9408 90.4252 25.2548C88.2025 28.2981 85.4071 33.0694 81.1055 35.0747C78.0225 36.5267 76.6601 35.0747 76.5894 32.7946C77.1289 32.6525 77.6562 32.4675 78.1663 32.2414C83.7583 29.8905 85.6228 26.294 84.2604 24.0812C82.898 22.0063 79.0985 22.6291 76.0155 25.7408C74.3913 27.5384 73.4079 29.8245 73.2188 32.2414C71.9284 32.5186 70.4941 32.7214 68.8454 32.9326C71.4263 28.8525 71.2118 23.3191 67.4075 22.3519C62.9621 21.2455 60.7395 25.3952 59.8084 28.8525C60.1679 24.98 60.7407 21.1063 61.4572 17.3034C61.8167 15.6437 62.9621 12.808 59.3004 12.3244C58.1537 12.1168 58.2963 12.67 58.3682 14.1917C58.512 16.2665 56.1455 28.6461 57.3641 34.0402C55.7872 34.5202 55.1414 35.6999 57.1484 36.8759C58.3625 37.3816 59.673 37.6128 60.9865 37.5531C62.3 37.4933 63.5842 37.1441 64.7475 36.5303C65.8289 36.0016 66.8016 35.2742 67.6148 34.3858C69.4792 34.1782 71.4143 33.8326 73.2069 33.5554C73.4932 35.9759 75.1432 37.7735 78.8708 37.4279C84.1765 36.9479 88.9083 30.6501 90.7008 27.608C90.3413 30.8589 88.1917 37.9811 91.9194 37.6355C93.3572 37.4975 92.7797 37.2899 92.8516 36.0455C93.211 31.7578 96.8668 28.0929 100.52 25.8788C99.8743 31.1349 100.09 35.8391 102.599 37.2899C107.187 40.056 113.569 32.7946 117.153 28.3689C115.355 32.311 114.356 37.2899 117.009 38.0507C120.164 38.9496 122.673 33.8326 125.612 29.9589C125.971 32.725 127.907 37.5659 135.649 37.5659C143.966 37.4963 149.2 32.6554 148.984 27.4688L149 27.4712ZM36.7117 36.1091C33.9173 35.1299 31.1875 33.9747 28.5387 32.6506C30.939 31.8034 33.2854 30.8103 35.565 29.6769C35.8138 31.8427 36.1968 33.9909 36.7117 36.1091ZM57.8817 39.9888C57.8098 39.7812 57.2359 40.0584 56.735 39.9888C55.2289 39.7812 53.2219 37.7759 52.6479 34.525C51.5695 28.6449 52.2178 22.8379 54.0103 14.1929C54.3698 12.5332 55.5164 9.69756 51.8535 9.14435C50.7068 9.00634 51.2796 9.55956 50.9932 11.0116C49.5553 17.4438 44.1106 22.0771 38.6624 25.1888C38.0884 17.8578 38.3029 9.62796 39.7408 4.64903C40.9629 0.430912 42.396 1.19173 40.6035 0.292908C38.8109 -0.605916 36.732 0.568916 35.0833 3.7478C33.4346 6.92669 25.9122 24.014 13.8629 35.5631C7.69931 41.4408 2.10485 38.3987 1.02886 37.4999C0.0966476 36.7391 -0.189725 37.9151 0.885072 39.09C5.8325 44.3461 13.1452 41.37 15.7968 38.8128C23.1059 31.759 31.6408 16.5438 35.0881 10.1128C34.6816 15.735 34.7775 21.3824 35.3745 26.9876C32.6035 28.2941 29.7251 29.3585 26.7713 30.1689C25.0507 30.5841 23.9747 31.2753 23.9747 32.0362C23.9747 32.797 25.1213 33.5578 26.7713 34.3162C29.7105 35.6999 38.3856 39.5724 40.4645 40.8168C42.2618 41.8536 43.1892 41.0244 43.6913 39.918C44.4102 38.4659 42.4727 37.6379 40.6083 37.1519C39.7869 34.1144 39.2115 31.0154 38.8876 27.8853C43.2611 25.2572 47.6346 21.7999 50.0718 17.445C49.4271 21.0451 47.8491 33.421 51.8691 38.6076C52.4249 39.3234 53.1422 39.8971 53.9622 40.2815C54.7822 40.666 55.6816 40.8502 56.5864 40.8192C57.5905 40.7496 58.0243 40.128 57.8769 39.9888' fill='%23545860'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_74_4890'%3E%3Crect width='154.804' height='42' fill='white' transform='translate(0.195801)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A";
function $a(t, e, i) {
  let n, l, o, r, { $$slots: a = {}, $$scope: s } = e, { heading: d = "" } = e, { url: u = "" } = e, { testid: c = "" } = e, { maxcontentwidth: g = "" } = e, { fullmenubreakpoint: h = Er } = e, { hasmenuclickhandler: m = "false" } = e, v, b, w = window.innerWidth, y = !1, j = !1, E = [], M = [], L;
  ke(() => {
    S(), A();
  }), ct(() => {
    window.removeEventListener("popstate", R, !0);
  });
  const z = () => i(9, j = !j), V = () => i(9, j = !1), T = () => {
    r && L.dispatchEvent(new CustomEvent("_menuClick", { composed: !0, bubbles: !0 }));
  };
  function S() {
    if (!v) return;
    const Z = lt(v);
    Z.length !== 0 && (E = Z.filter((Q) => Q.tagName === "A").map((Q) => (Q.classList.remove("current"), Q)));
  }
  function A() {
    if (!b) return;
    b.addEventListener("app-header-menu:mounted", (X) => {
      const ee = X.detail;
      M = [...M, ee], I();
    });
    let Z = document.location.href;
    new MutationObserver((X) => {
      Ni(document.location, Z) && (Z = document.location.href, R());
    }).observe(document.body, { childList: !0, subtree: !0 }), window.addEventListener("popstate", R, !0);
  }
  function R() {
    I(), V();
  }
  function I() {
    let Z = [...E];
    M.forEach((X) => {
      Z = [...Z, ...X.links];
    }), Z.forEach((X) => X.classList.remove("current"));
    const Q = Mr(Z, window.location);
    Q && Q.classList.add("current"), B((Q == null ? void 0 : Q.getAttribute("href")) || "");
  }
  function B(Z) {
    M.forEach((Q) => {
      Q.el.dispatchEvent(new CustomEvent("app-header:changed", { composed: !0, detail: Z }));
    });
  }
  function N() {
    if (!v) return;
    const Z = v.querySelector("slot");
    Z && Z.assignedElements().filter((Q) => Q.tagName === "A").map((Q) => {
      y ? Q.classList.add("inside-collapse-menu") : Q.classList.remove("inside-collapse-menu");
    });
  }
  async function F() {
    var X;
    if (await Pe(), !v) return !1;
    const Z = v == null ? void 0 : v.childNodes[0], Q = (X = Z == null ? void 0 : Z.assignedElements) == null ? void 0 : X.call(Z);
    return Q ? Q.length > 0 : [...v == null ? void 0 : v.querySelectorAll("a")].length > 0;
  }
  function q() {
    i(4, w = qr.innerWidth);
  }
  function H(Z) {
    ue[Z ? "unshift" : "push"](() => {
      L = Z, i(10, L);
    });
  }
  function O(Z) {
    ue[Z ? "unshift" : "push"](() => {
      L = Z, i(10, L);
    });
  }
  function W(Z) {
    ue[Z ? "unshift" : "push"](() => {
      v = Z, i(6, v);
    });
  }
  function K(Z) {
    ue[Z ? "unshift" : "push"](() => {
      v = Z, i(6, v);
    });
  }
  function $(Z) {
    ue[Z ? "unshift" : "push"](() => {
      v = Z, i(6, v);
    });
  }
  function ye(Z) {
    ue[Z ? "unshift" : "push"](() => {
      b = Z, i(7, b);
    });
  }
  return t.$$set = (Z) => {
    "heading" in Z && i(0, d = Z.heading), "url" in Z && i(1, u = Z.url), "testid" in Z && i(2, c = Z.testid), "maxcontentwidth" in Z && i(3, g = Z.maxcontentwidth), "fullmenubreakpoint" in Z && i(17, h = Z.fullmenubreakpoint), "hasmenuclickhandler" in Z && i(18, m = Z.hasmenuclickhandler), "$$scope" in Z && i(19, s = Z.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*_windowWidth*/
    16 && i(13, n = w < gi), t.$$.dirty[0] & /*_windowWidth, fullmenubreakpoint*/
    131088 && i(12, l = w >= gi && w < h), t.$$.dirty[0] & /*_windowWidth, fullmenubreakpoint*/
    131088 && i(5, o = w >= +h), t.$$.dirty[0] & /*_desktop*/
    32 && (async () => (i(8, y = o ? !1 : await F()), N()))(), t.$$.dirty[0] & /*hasmenuclickhandler*/
    262144 && i(11, r = Ce(m));
  }, [
    d,
    u,
    c,
    g,
    w,
    o,
    v,
    b,
    y,
    j,
    L,
    r,
    l,
    n,
    z,
    V,
    T,
    h,
    m,
    s,
    a,
    q,
    H,
    O,
    W,
    K,
    $,
    ye
  ];
}
class es extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      $a,
      Qa,
      ce,
      {
        heading: 0,
        url: 1,
        testid: 2,
        maxcontentwidth: 3,
        fullmenubreakpoint: 17,
        hasmenuclickhandler: 18
      },
      Ka,
      [-1, -1]
    );
  }
  get heading() {
    return this.$$.ctx[0];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get url() {
    return this.$$.ctx[1];
  }
  set url(e) {
    this.$$set({ url: e }), k();
  }
  get testid() {
    return this.$$.ctx[2];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get maxcontentwidth() {
    return this.$$.ctx[3];
  }
  set maxcontentwidth(e) {
    this.$$set({ maxcontentwidth: e }), k();
  }
  get fullmenubreakpoint() {
    return this.$$.ctx[17];
  }
  set fullmenubreakpoint(e) {
    this.$$set({ fullmenubreakpoint: e }), k();
  }
  get hasmenuclickhandler() {
    return this.$$.ctx[18];
  }
  set hasmenuclickhandler(e) {
    this.$$set({ hasmenuclickhandler: e }), k();
  }
}
customElements.define("goa-app-header", he(es, { heading: {}, url: {}, testid: {}, maxcontentwidth: {}, fullmenubreakpoint: {}, hasmenuclickhandler: {} }, ["default"], [], !0));
function ts(t) {
  _e(t, "svelte-19poqsl", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans);height:var(--goa-badge-height)}.goa-badge.svelte-19poqsl{display:inline-flex;height:var(--goa-badge-height);width:auto;vertical-align:top;align-items:center;border-radius:var(--goa-badge-border-radius);padding:var(--goa-badge-padding);gap:var(--goa-badge-gap);font-weight:var(--goa-font-weight-regular);box-shadow:var(--goa-badge-border)}.icon-only.svelte-19poqsl{padding:0 3px}.goa-badge-no-icon.svelte-19poqsl{margin-left:-0.25rem}.goa-badge-content.svelte-19poqsl{font-size:var(--goa-badge-font-size);line-height:var(--goa-badge-line-height);white-space:nowrap;padding-bottom:3px}.goa-badge.badge-information.svelte-19poqsl{background-color:var(--goa-badge-info-color-bg);color:var(--goa-badge-info-color-content)}.goa-badge.badge-success.svelte-19poqsl{background-color:var(--goa-badge-success-color-bg);color:var(--goa-badge-success-color-content)}.goa-badge.badge-important.svelte-19poqsl{background-color:var(--goa-badge-important-color-bg);color:var(--goa-badge-important-color-content)}.goa-badge.badge-emergency.svelte-19poqsl{background-color:var(--goa-badge-emergency-color-bg);color:var(--goa-badge-emergency-color-content)}.goa-badge.badge-dark.svelte-19poqsl{background-color:var(--goa-badge-dark-color-bg);color:var(--goa-badge-dark-color-content)}.goa-badge.badge-midtone.svelte-19poqsl{background-color:var(--goa-badge-midtone-color-bg);color:var(--goa-badge-midtone-color-content)}.goa-badge.badge-light.svelte-19poqsl{background-color:var(--goa-badge-light-color-bg);color:var(--goa-badge-light-color-content)}");
}
function is(t) {
  let e;
  return {
    c() {
      e = C("div"), f(e, "class", "goa-badge-no-icon svelte-19poqsl");
    },
    m(i, n) {
      D(i, e, n);
    },
    p: ve,
    d(i) {
      i && P(e);
    }
  };
}
function ns(t) {
  let e, i, n;
  return {
    c() {
      e = C("goa-icon"), p(e, "arialabel", i = /*showIconOnly*/
      t[9] && /*arialabel*/
      t[3] ? (
        /*arialabel*/
        t[3]
      ) : null), p(e, "role", n = /*showIconOnly*/
      t[9] && /*arialabel*/
      t[3] ? "presentation" : null), p(
        e,
        "type",
        /*iconType*/
        t[10]
      ), p(e, "size", "1");
    },
    m(l, o) {
      D(l, e, o);
    },
    p(l, o) {
      o & /*showIconOnly, arialabel*/
      520 && i !== (i = /*showIconOnly*/
      l[9] && /*arialabel*/
      l[3] ? (
        /*arialabel*/
        l[3]
      ) : null) && p(e, "arialabel", i), o & /*showIconOnly, arialabel*/
      520 && n !== (n = /*showIconOnly*/
      l[9] && /*arialabel*/
      l[3] ? "presentation" : null) && p(e, "role", n), o & /*iconType*/
      1024 && p(
        e,
        "type",
        /*iconType*/
        l[10]
      );
    },
    d(l) {
      l && P(e);
    }
  };
}
function vn(t) {
  let e, i;
  return {
    c() {
      e = C("div"), i = le(
        /*content*/
        t[2]
      ), f(e, "class", "goa-badge-content svelte-19poqsl");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l & /*content*/
      4 && pe(
        i,
        /*content*/
        n[2]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function ls(t) {
  let e, i, n, l;
  function o(d, u) {
    return (
      /*showIcon*/
      d[8] ? ns : is
    );
  }
  let r = o(t), a = r(t), s = (
    /*content*/
    t[2] && vn(t)
  );
  return {
    c() {
      e = C("div"), a.c(), i = x(), s && s.c(), f(e, "style", n = be(
        /*mt*/
        t[4],
        /*mr*/
        t[5],
        /*mb*/
        t[6],
        /*ml*/
        t[7]
      )), f(
        e,
        "data-testid",
        /*testid*/
        t[1]
      ), f(e, "data-type", "goa-badge"), f(e, "class", l = "goa-badge badge-" + /*type*/
      t[0] + " svelte-19poqsl"), G(
        e,
        "icon-only",
        /*showIconOnly*/
        t[9]
      );
    },
    m(d, u) {
      D(d, e, u), a.m(e, null), _(e, i), s && s.m(e, null);
    },
    p(d, [u]) {
      r === (r = o(d)) && a ? a.p(d, u) : (a.d(1), a = r(d), a && (a.c(), a.m(e, i))), /*content*/
      d[2] ? s ? s.p(d, u) : (s = vn(d), s.c(), s.m(e, null)) : s && (s.d(1), s = null), u & /*mt, mr, mb, ml*/
      240 && n !== (n = be(
        /*mt*/
        d[4],
        /*mr*/
        d[5],
        /*mb*/
        d[6],
        /*ml*/
        d[7]
      )) && f(e, "style", n), u & /*testid*/
      2 && f(
        e,
        "data-testid",
        /*testid*/
        d[1]
      ), u & /*type*/
      1 && l !== (l = "goa-badge badge-" + /*type*/
      d[0] + " svelte-19poqsl") && f(e, "class", l), u & /*type, showIconOnly*/
      513 && G(
        e,
        "icon-only",
        /*showIconOnly*/
        d[9]
      );
    },
    i: ve,
    o: ve,
    d(d) {
      d && P(e), a.d(), s && s.d();
    }
  };
}
function os(t, e, i) {
  let n, l, o;
  const [r, a] = Me("Badge type", ["information", "important", "emergency", "success", "dark", "midtone", "light"], !0);
  let { type: s } = e, { testid: d = "" } = e, { content: u = "" } = e, { icon: c = "false" } = e, { arialabel: g = "" } = e, { mt: h = null } = e, { mr: m = null } = e, { mb: v = null } = e, { ml: b = null } = e;
  return ke(() => {
    setTimeout(() => a(s), 1), !n && !u && console.warn("GoABadge must have either then content or icon property set"), l && !g && console.warn("GoABadge with icon only requires an arialabel");
  }), t.$$set = (w) => {
    "type" in w && i(0, s = w.type), "testid" in w && i(1, d = w.testid), "content" in w && i(2, u = w.content), "icon" in w && i(11, c = w.icon), "arialabel" in w && i(3, g = w.arialabel), "mt" in w && i(4, h = w.mt), "mr" in w && i(5, m = w.mr), "mb" in w && i(6, v = w.mb), "ml" in w && i(7, b = w.ml);
  }, t.$$.update = () => {
    t.$$.dirty & /*icon*/
    2048 && i(8, n = Ce(c)), t.$$.dirty & /*showIcon, content*/
    260 && i(9, l = n && !u), t.$$.dirty & /*type*/
    1 && i(10, o = {
      success: "checkmark-circle",
      important: "alert-circle",
      information: "information-circle",
      emergency: "warning",
      dark: "information-circle",
      midtone: "information-circle",
      light: "information-circle"
    }[s]);
  }, [
    s,
    d,
    u,
    g,
    h,
    m,
    v,
    b,
    n,
    l,
    o,
    c
  ];
}
class rs extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      os,
      ls,
      ce,
      {
        type: 0,
        testid: 1,
        content: 2,
        icon: 11,
        arialabel: 3,
        mt: 4,
        mr: 5,
        mb: 6,
        ml: 7
      },
      ts
    );
  }
  get type() {
    return this.$$.ctx[0];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get testid() {
    return this.$$.ctx[1];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get content() {
    return this.$$.ctx[2];
  }
  set content(e) {
    this.$$set({ content: e }), k();
  }
  get icon() {
    return this.$$.ctx[11];
  }
  set icon(e) {
    this.$$set({ icon: e }), k();
  }
  get arialabel() {
    return this.$$.ctx[3];
  }
  set arialabel(e) {
    this.$$set({ arialabel: e }), k();
  }
  get mt() {
    return this.$$.ctx[4];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[5];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[6];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[7];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-badge", he(rs, { type: {}, testid: {}, content: {}, icon: {}, arialabel: {}, mt: {}, mr: {}, mb: {}, ml: {} }, [], [], !0));
function as(t) {
  _e(t, "svelte-lif1us", ".block.svelte-lif1us{display:flex;flex-direction:var(--direction);align-items:var(--alignment);gap:var(--gap)}");
}
function ss(t) {
  let e, i, n;
  const l = (
    /*#slots*/
    t[10].default
  ), o = oe(
    l,
    t,
    /*$$scope*/
    t[9],
    null
  );
  return {
    c() {
      e = C("div"), o && o.c(), f(e, "class", "block svelte-lif1us"), f(e, "style", i = `
    ${be(
        /*mt*/
        t[3],
        /*mr*/
        t[4],
        /*mb*/
        t[5],
        /*ml*/
        t[6]
      )};
    --gap: var(--goa-space-${/*gap*/
      t[0]});
    --alignment: ${/*_alignment*/
      t[7]};
    --direction: ${/*direction*/
      t[1]};
  `), f(
        e,
        "data-testid",
        /*testid*/
        t[2]
      );
    },
    m(r, a) {
      D(r, e, a), o && o.m(e, null), n = !0;
    },
    p(r, [a]) {
      o && o.p && (!n || a & /*$$scope*/
      512) && ae(
        o,
        l,
        r,
        /*$$scope*/
        r[9],
        n ? re(
          l,
          /*$$scope*/
          r[9],
          a,
          null
        ) : se(
          /*$$scope*/
          r[9]
        ),
        null
      ), (!n || a & /*mt, mr, mb, ml, gap, _alignment, direction*/
      251 && i !== (i = `
    ${be(
        /*mt*/
        r[3],
        /*mr*/
        r[4],
        /*mb*/
        r[5],
        /*ml*/
        r[6]
      )};
    --gap: var(--goa-space-${/*gap*/
      r[0]});
    --alignment: ${/*_alignment*/
      r[7]};
    --direction: ${/*direction*/
      r[1]};
  `)) && f(e, "style", i), (!n || a & /*testid*/
      4) && f(
        e,
        "data-testid",
        /*testid*/
        r[2]
      );
    },
    i(r) {
      n || (Y(o, r), n = !0);
    },
    o(r) {
      U(o, r), n = !1;
    },
    d(r) {
      r && P(e), o && o.d(r);
    }
  };
}
function us(t, e, i) {
  let n, { $$slots: l = {}, $$scope: o } = e, { gap: r = "m" } = e, { direction: a = "row" } = e, { alignment: s = "normal" } = e, { testid: d = "" } = e, { mt: u = null } = e, { mr: c = null } = e, { mb: g = null } = e, { ml: h = null } = e;
  return t.$$set = (m) => {
    "gap" in m && i(0, r = m.gap), "direction" in m && i(1, a = m.direction), "alignment" in m && i(8, s = m.alignment), "testid" in m && i(2, d = m.testid), "mt" in m && i(3, u = m.mt), "mr" in m && i(4, c = m.mr), "mb" in m && i(5, g = m.mb), "ml" in m && i(6, h = m.ml), "$$scope" in m && i(9, o = m.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*alignment*/
    256 && i(7, n = s === "start" ? "flex-start" : s === "end" ? "flex-end" : s === "center" ? "center" : "normal");
  }, [r, a, d, u, c, g, h, n, s, o, l];
}
class ds extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      us,
      ss,
      ce,
      {
        gap: 0,
        direction: 1,
        alignment: 8,
        testid: 2,
        mt: 3,
        mr: 4,
        mb: 5,
        ml: 6
      },
      as
    );
  }
  get gap() {
    return this.$$.ctx[0];
  }
  set gap(e) {
    this.$$set({ gap: e }), k();
  }
  get direction() {
    return this.$$.ctx[1];
  }
  set direction(e) {
    this.$$set({ direction: e }), k();
  }
  get alignment() {
    return this.$$.ctx[8];
  }
  set alignment(e) {
    this.$$set({ alignment: e }), k();
  }
  get testid() {
    return this.$$.ctx[2];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[3];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[4];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[5];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[6];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-block", he(ds, { gap: {}, direction: {}, alignment: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function cs(t) {
  _e(t, "svelte-13jjhik", `button.svelte-13jjhik{display:inline-flex;box-sizing:border-box;border-radius:var(--goa-button-border-radius);cursor:pointer;font:var(--goa-button-text);height:var(--goa-button-height);letter-spacing:var(--goa-letter-spacing-button);padding:0 var(--goa-button-padding-lr);white-space:nowrap;gap:var(--goa-button-gap);align-items:center;justify-content:center;transition:transform 0.1s ease-in-out,
      background-color 0.2s ease-in-out,
      border-color 0.2s ease-in-out,
      color 0.2s ease-in-out;width:var(--width, auto)}button.svelte-13jjhik:active{transform:translateY(2px)}button.svelte-13jjhik:focus-visible{box-shadow:0 0 0 var(--goa-border-width-l)
      var(--goa-color-interactive-focus)}@media(max-width: 623px){:host{width:100%}button.svelte-13jjhik{width:100%;display:flex}button.tertiary.svelte-13jjhik{background-color:var(--goa-button-tertiary-color-bg-mobile) !important}button.tertiary.svelte-13jjhik:hover{background-color:var(--goa-color-greyscale-200) !important}button.tertiary.inverse.svelte-13jjhik{background-color:var(--goa-button-tertiary-color-bg) !important}button.tertiary.inverse.svelte-13jjhik:hover{background-color:var(--goa-color-greyscale-200) !important}}.icon.svelte-13jjhik{width:var(--goa-button-icon-size);height:var(--goa-button-icon-size)}.icon.compact.svelte-13jjhik{width:var(--goa-button-compact-icon-size);height:var(--goa-button-compact-icon-size)}.text.svelte-13jjhik{padding-bottom:0.2rem}button.compact.svelte-13jjhik{height:var(--goa-button-height-compact);font:var(--goa-button-text-compact);padding:var(--goa-button-padding-lr-compact);gap:var(--goa-button-compact-gap)}button.start.svelte-13jjhik{height:var(--goa-button-start-height);font:var(--goa-button-text-start);padding:var(--goa-button-padding-lr-start);letter-spacing:var(--goa-letter-spacing-button)}button.start.svelte-13jjhik,button.submit.svelte-13jjhik,button.primary.svelte-13jjhik{border:var(--goa-button-primary-border);background-color:var(--goa-button-primary-color-bg);color:var(--goa-button-primary-color-text)}button.svelte-13jjhik:hover{background-color:var(--goa-button-primary-hover-color-bg)}button.svelte-13jjhik:focus,button.svelte-13jjhik:active{border-color:var(--goa-button-primary-hover-border);background-color:var(--goa-button-primary-focus-color-bg);outline:none}button.secondary.svelte-13jjhik{border:var(--goa-button-secondary-border);background-color:var(--goa-button-secondary-color-bg);color:var(--goa-button-secondary-color-text)}button.secondary.svelte-13jjhik:hover{border:var(--goa-button-secondary-hover-border);color:var(--goa-button-secondary-hover-color-text);background-color:var(--goa-button-secondary-hover-color-bg)}button.secondary.svelte-13jjhik:focus,button.secondary.svelte-13jjhik:active{border:var(--goa-button-secondary-focus-border);background-color:var(--goa-button-secondary-focus-color-bg);color:var(--goa-button-secondary-focus-color-text);outline:none}button.tertiary.svelte-13jjhik{border:var(--goa-button-tertiary-border);background-color:var(--goa-button-tertiary-color-bg);color:var(--goa-button-tertiary-color-text);text-decoration:underline}button.tertiary.svelte-13jjhik:hover{background-color:var(--goa-button-tertiary-hover-color-bg);color:var(--goa-button-tertiary-hover-color-text)}button.tertiary.svelte-13jjhik:focus,button.tertiary.svelte-13jjhik:active{background-color:var(--goa-button-tertiary-focus-color-bg);color:var(--goa-button-tertiary-focus-color-text);outline:none}.submit.destructive.svelte-13jjhik,.primary.destructive.svelte-13jjhik{background-color:var(--goa-button-primary-destructive-color-bg)}.submit.destructive.svelte-13jjhik:hover,.primary.destructive.svelte-13jjhik:hover{background-color:var(--goa-button-primary-destructive-hover-color-bg)}.submit.destructive.svelte-13jjhik:focus,.submit.destructive.svelte-13jjhik:active,.primary.destructive.svelte-13jjhik:focus,.primary.destructive.svelte-13jjhik:active{background-color:var(--goa-button-primary-destructive-focus-color-bg)}.secondary.destructive.svelte-13jjhik{color:var(--goa-button-secondary-destructive-color-text);border:var(--goa-button-secondary-destructive-border)}.secondary.destructive.svelte-13jjhik:hover{color:var(--goa-button-secondary-destructive-hover-color-text);border:var(--goa-button-secondary-destructive-hover-border)}.secondary.destructive.svelte-13jjhik:focus,.secondary.destructive.svelte-13jjhik:active{color:var(--goa-button-secondary-destructive-focus-color-text);border:var(--goa-button-secondary-destructive-focus-border)}.tertiary.destructive.svelte-13jjhik{color:var(--goa-button-tertiary-destructive-color-text)}.tertiary.destructive.svelte-13jjhik:hover{color:var(--goa-button-tertiary-destructive-hover-color-text)}.tertiary.destructive.svelte-13jjhik:focus,.tertiary.destructive.svelte-13jjhik:active{color:var(--goa-button-tertiary-destructive-focus-color-text)}.submit.inverse.svelte-13jjhik,.primary.inverse.svelte-13jjhik{background-color:var(--goa-button-primary-inverse-color-bg);color:var(--goa-button-primary-inverse-color-text)}.submit.inverse.svelte-13jjhik:hover,.primary.inverse.svelte-13jjhik:hover{background-color:var(--goa-button-primary-inverse-hover-color-bg);color:var(--goa-button-primary-inverse-hover-color-text)}.submit.inverse.svelte-13jjhik:focus,.submit.inverse.svelte-13jjhik:active,.primary.inverse.svelte-13jjhik:focus,.primary.inverse.svelte-13jjhik:active{background-color:var(--goa-button-primary-inverse-focus-color-bg)}.secondary.inverse.svelte-13jjhik{color:var(--goa-button-secondary-inverse-color-text);border:var(--goa-button-secondary-inverse-border);background-color:var(--goa-button-secondary-inverse-color-bg)}.secondary.inverse.svelte-13jjhik:hover{color:var(--goa-button-secondary-inverse-hover-color-text);border:var(--goa-button-secondary-inverse-hover-border)}.secondary.inverse.svelte-13jjhik:focus,.secondary.inverse.svelte-13jjhik:active{color:var(--goa-button-secondary-inverse-focus-color-text);border:var(--goa-button-secondary-inverse-focus-border)}.tertiary.inverse.svelte-13jjhik{color:var(--goa-button-tertiary-inverse-color-text)}.tertiary.inverse.svelte-13jjhik:hover{color:var(--goa-button-tertiary-inverse-hover-color-text)}.tertiary.inverse.svelte-13jjhik:focus,.tertiary.inverse.svelte-13jjhik:active{color:var(--goa-button-tertiary-inverse-focus-color-text)}button.svelte-13jjhik:disabled{pointer-events:none;opacity:0.5}`);
}
function fs(t) {
  let e, i, n, l, o, r = (
    /*leadingicon*/
    t[3] && bn(t)
  );
  const a = (
    /*#slots*/
    t[16].default
  ), s = oe(
    a,
    t,
    /*$$scope*/
    t[15],
    null
  );
  let d = (
    /*trailingicon*/
    t[4] && pn(t)
  );
  return {
    c() {
      r && r.c(), e = x(), i = C("span"), s && s.c(), n = x(), d && d.c(), l = Ne(), f(i, "class", "text svelte-13jjhik");
    },
    m(u, c) {
      r && r.m(u, c), D(u, e, c), D(u, i, c), s && s.m(i, null), D(u, n, c), d && d.m(u, c), D(u, l, c), o = !0;
    },
    p(u, c) {
      /*leadingicon*/
      u[3] ? r ? r.p(u, c) : (r = bn(u), r.c(), r.m(e.parentNode, e)) : r && (r.d(1), r = null), s && s.p && (!o || c & /*$$scope*/
      32768) && ae(
        s,
        a,
        u,
        /*$$scope*/
        u[15],
        o ? re(
          a,
          /*$$scope*/
          u[15],
          c,
          null
        ) : se(
          /*$$scope*/
          u[15]
        ),
        null
      ), /*trailingicon*/
      u[4] ? d ? d.p(u, c) : (d = pn(u), d.c(), d.m(l.parentNode, l)) : d && (d.d(1), d = null);
    },
    i(u) {
      o || (Y(s, u), o = !0);
    },
    o(u) {
      U(s, u), o = !1;
    },
    d(u) {
      u && (P(e), P(i), P(n), P(l)), r && r.d(u), s && s.d(u), d && d.d(u);
    }
  };
}
function gs(t) {
  let e, i, n, l;
  const o = (
    /*#slots*/
    t[16].default
  ), r = oe(
    o,
    t,
    /*$$scope*/
    t[15],
    null
  );
  return {
    c() {
      e = C("span"), r && r.c(), i = x(), n = C("goa-icon"), f(e, "class", "text svelte-13jjhik"), p(n, "id", "trailing-icon"), p(n, "size", "4"), p(n, "type", "arrow-forward"), p(n, "inverted", "true");
    },
    m(a, s) {
      D(a, e, s), r && r.m(e, null), D(a, i, s), D(a, n, s), l = !0;
    },
    p(a, s) {
      r && r.p && (!l || s & /*$$scope*/
      32768) && ae(
        r,
        o,
        a,
        /*$$scope*/
        a[15],
        l ? re(
          o,
          /*$$scope*/
          a[15],
          s,
          null
        ) : se(
          /*$$scope*/
          a[15]
        ),
        null
      );
    },
    i(a) {
      l || (Y(r, a), l = !0);
    },
    o(a) {
      U(r, a), l = !1;
    },
    d(a) {
      a && (P(e), P(i), P(n)), r && r.d(a);
    }
  };
}
function bn(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "id", "leading-icon"), p(e, "size", "3"), p(
        e,
        "type",
        /*leadingicon*/
        t[3]
      ), p(
        e,
        "inverted",
        /*isButtonDark*/
        t[12]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*leadingicon*/
      8 && p(
        e,
        "type",
        /*leadingicon*/
        i[3]
      ), n & /*isButtonDark*/
      4096 && p(
        e,
        "inverted",
        /*isButtonDark*/
        i[12]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function pn(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "id", "trailing-icon"), p(e, "size", "3"), p(
        e,
        "type",
        /*trailingicon*/
        t[4]
      ), p(
        e,
        "inverted",
        /*isButtonDark*/
        t[12]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*trailingicon*/
      16 && p(
        e,
        "type",
        /*trailingicon*/
        i[4]
      ), n & /*isButtonDark*/
      4096 && p(
        e,
        "inverted",
        /*isButtonDark*/
        i[12]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function hs(t) {
  let e, i, n, l, o, r, a, s, d;
  const u = [gs, fs], c = [];
  function g(h, m) {
    return (
      /*type*/
      h[0] === "start" ? 0 : 1
    );
  }
  return i = g(t), n = c[i] = u[i](t), {
    c() {
      e = C("button"), n.c(), f(e, "class", l = /*type*/
      t[0] + " " + /*size*/
      t[1] + " " + /*variant*/
      t[2] + " svelte-13jjhik"), f(e, "style", o = `
      ${be(
        /*mt*/
        t[7],
        /*mr*/
        t[8],
        /*mb*/
        t[9],
        /*ml*/
        t[10]
      )};
      --width: ${/*width*/
      t[6]};
    `), e.disabled = /*isDisabled*/
      t[11], f(
        e,
        "data-testid",
        /*testid*/
        t[5]
      ), f(e, "type", r = /*type*/
      t[0] == "submit" ? (
        /*type*/
        t[0]
      ) : "button");
    },
    m(h, m) {
      D(h, e, m), c[i].m(e, null), a = !0, s || (d = te(
        e,
        "click",
        /*clickHandler*/
        t[13]
      ), s = !0);
    },
    p(h, [m]) {
      let v = i;
      i = g(h), i === v ? c[i].p(h, m) : (Oe(), U(c[v], 1, 1, () => {
        c[v] = null;
      }), Fe(), n = c[i], n ? n.p(h, m) : (n = c[i] = u[i](h), n.c()), Y(n, 1), n.m(e, null)), (!a || m & /*type, size, variant*/
      7 && l !== (l = /*type*/
      h[0] + " " + /*size*/
      h[1] + " " + /*variant*/
      h[2] + " svelte-13jjhik")) && f(e, "class", l), (!a || m & /*mt, mr, mb, ml, width*/
      1984 && o !== (o = `
      ${be(
        /*mt*/
        h[7],
        /*mr*/
        h[8],
        /*mb*/
        h[9],
        /*ml*/
        h[10]
      )};
      --width: ${/*width*/
      h[6]};
    `)) && f(e, "style", o), (!a || m & /*isDisabled*/
      2048) && (e.disabled = /*isDisabled*/
      h[11]), (!a || m & /*testid*/
      32) && f(
        e,
        "data-testid",
        /*testid*/
        h[5]
      ), (!a || m & /*type*/
      1 && r !== (r = /*type*/
      h[0] == "submit" ? (
        /*type*/
        h[0]
      ) : "button")) && f(e, "type", r);
    },
    i(h) {
      a || (Y(n), a = !0);
    },
    o(h) {
      U(n), a = !1;
    },
    d(h) {
      h && P(e), c[i].d(), s = !1, d();
    }
  };
}
function ms(t, e, i) {
  let n, l, { $$slots: o = {}, $$scope: r } = e;
  const [a, s] = Me("Button type", ["primary", "submit", "secondary", "tertiary", "start"], !0), [d, u] = Me("Button size", ["normal", "compact"], !0), [c, g] = Me("Button variant", ["normal", "destructive", "inverse"], !0);
  let { type: h = "primary" } = e, { size: m = "normal" } = e, { variant: v = "normal" } = e, { disabled: b = "false" } = e, { leadingicon: w = null } = e, { trailingicon: y = null } = e, { testid: j = "" } = e, { width: E = "" } = e, { mt: M = null } = e, { mr: L = null } = e, { mb: z = null } = e, { ml: V = null } = e;
  ke(() => {
    s(h), u(m), g(v);
  });
  function T(S) {
    !n && S.target && qe(S.target, "_click", null, { bubbles: !0 });
  }
  return t.$$set = (S) => {
    "type" in S && i(0, h = S.type), "size" in S && i(1, m = S.size), "variant" in S && i(2, v = S.variant), "disabled" in S && i(14, b = S.disabled), "leadingicon" in S && i(3, w = S.leadingicon), "trailingicon" in S && i(4, y = S.trailingicon), "testid" in S && i(5, j = S.testid), "width" in S && i(6, E = S.width), "mt" in S && i(7, M = S.mt), "mr" in S && i(8, L = S.mr), "mb" in S && i(9, z = S.mb), "ml" in S && i(10, V = S.ml), "$$scope" in S && i(15, r = S.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*disabled*/
    16384 && i(11, n = Ce(b)), t.$$.dirty & /*type*/
    1 && i(12, l = h === "primary" || h === "start");
  }, [
    h,
    m,
    v,
    w,
    y,
    j,
    E,
    M,
    L,
    z,
    V,
    n,
    l,
    T,
    b,
    r,
    o
  ];
}
class vs extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      ms,
      hs,
      ce,
      {
        type: 0,
        size: 1,
        variant: 2,
        disabled: 14,
        leadingicon: 3,
        trailingicon: 4,
        testid: 5,
        width: 6,
        mt: 7,
        mr: 8,
        mb: 9,
        ml: 10
      },
      cs
    );
  }
  get type() {
    return this.$$.ctx[0];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get size() {
    return this.$$.ctx[1];
  }
  set size(e) {
    this.$$set({ size: e }), k();
  }
  get variant() {
    return this.$$.ctx[2];
  }
  set variant(e) {
    this.$$set({ variant: e }), k();
  }
  get disabled() {
    return this.$$.ctx[14];
  }
  set disabled(e) {
    this.$$set({ disabled: e }), k();
  }
  get leadingicon() {
    return this.$$.ctx[3];
  }
  set leadingicon(e) {
    this.$$set({ leadingicon: e }), k();
  }
  get trailingicon() {
    return this.$$.ctx[4];
  }
  set trailingicon(e) {
    this.$$set({ trailingicon: e }), k();
  }
  get testid() {
    return this.$$.ctx[5];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get width() {
    return this.$$.ctx[6];
  }
  set width(e) {
    this.$$set({ width: e }), k();
  }
  get mt() {
    return this.$$.ctx[7];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[8];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[9];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[10];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-button", he(vs, { type: {}, size: {}, variant: {}, disabled: {}, leadingicon: {}, trailingicon: {}, testid: {}, width: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function bs(t) {
  _e(t, "svelte-l0zt91", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}div.svelte-l0zt91{display:flex;flex-direction:row;justify-content:var(--alignment);align-items:center;flex-wrap:wrap;gap:var(--gap-size);padding:3px 0;line-height:100%}");
}
function ps(t) {
  let e, i, n;
  const l = (
    /*#slots*/
    t[9].default
  ), o = oe(
    l,
    t,
    /*$$scope*/
    t[8],
    null
  );
  return {
    c() {
      e = C("div"), o && o.c(), f(
        e,
        "data-testid",
        /*testid*/
        t[1]
      ), f(e, "style", i = be(
        /*mt*/
        t[2],
        /*mr*/
        t[3],
        /*mb*/
        t[4],
        /*ml*/
        t[5]
      ) + "; --alignment: " + /*_alignment*/
      t[6] + "; --gap-size: " + /*gap*/
      (t[0] === "relaxed" ? "var(--goa-button-group-gap)" : "var(--goa-button-group-compact-gap)")), f(e, "class", "svelte-l0zt91");
    },
    m(r, a) {
      D(r, e, a), o && o.m(e, null), n = !0;
    },
    p(r, [a]) {
      o && o.p && (!n || a & /*$$scope*/
      256) && ae(
        o,
        l,
        r,
        /*$$scope*/
        r[8],
        n ? re(
          l,
          /*$$scope*/
          r[8],
          a,
          null
        ) : se(
          /*$$scope*/
          r[8]
        ),
        null
      ), (!n || a & /*testid*/
      2) && f(
        e,
        "data-testid",
        /*testid*/
        r[1]
      ), (!n || a & /*mt, mr, mb, ml, _alignment, gap*/
      125 && i !== (i = be(
        /*mt*/
        r[2],
        /*mr*/
        r[3],
        /*mb*/
        r[4],
        /*ml*/
        r[5]
      ) + "; --alignment: " + /*_alignment*/
      r[6] + "; --gap-size: " + /*gap*/
      (r[0] === "relaxed" ? "var(--goa-button-group-gap)" : "var(--goa-button-group-compact-gap)"))) && f(e, "style", i);
    },
    i(r) {
      n || (Y(o, r), n = !0);
    },
    o(r) {
      U(o, r), n = !1;
    },
    d(r) {
      r && P(e), o && o.d(r);
    }
  };
}
function _s(t, e, i) {
  let n, { $$slots: l = {}, $$scope: o } = e, { alignment: r = "start" } = e, { gap: a = "relaxed" } = e, { testid: s = "" } = e, { mt: d = null } = e, { mr: u = null } = e, { mb: c = null } = e, { ml: g = null } = e;
  const [h, m] = Me("alignment", ["start", "end", "center"]), [v, b] = Me("gap", ["relaxed", "compact"]);
  return ke(() => {
    m(r), b(a);
  }), t.$$set = (w) => {
    "alignment" in w && i(7, r = w.alignment), "gap" in w && i(0, a = w.gap), "testid" in w && i(1, s = w.testid), "mt" in w && i(2, d = w.mt), "mr" in w && i(3, u = w.mr), "mb" in w && i(4, c = w.mb), "ml" in w && i(5, g = w.ml), "$$scope" in w && i(8, o = w.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*alignment*/
    128 && i(6, n = {
      start: "flex-start",
      end: "flex-end",
      center: "center"
    }[r]);
  }, [a, s, d, u, c, g, n, r, o, l];
}
class ws extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      _s,
      ps,
      ce,
      {
        alignment: 7,
        gap: 0,
        testid: 1,
        mt: 2,
        mr: 3,
        mb: 4,
        ml: 5
      },
      bs
    );
  }
  get alignment() {
    return this.$$.ctx[7];
  }
  set alignment(e) {
    this.$$set({ alignment: e }), k();
  }
  get gap() {
    return this.$$.ctx[0];
  }
  set gap(e) {
    this.$$set({ gap: e }), k();
  }
  get testid() {
    return this.$$.ctx[1];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[2];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[3];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[4];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[5];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-button-group", he(ws, { alignment: {}, gap: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function Ve(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function tt(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Ze(t, e) {
  const i = Ve(t);
  return isNaN(e) ? tt(t, NaN) : (e && i.setDate(i.getDate() + e), i);
}
function st(t, e) {
  const i = Ve(t);
  if (isNaN(e)) return tt(t, NaN);
  if (!e)
    return i;
  const n = i.getDate(), l = tt(t, i.getTime());
  l.setMonth(i.getMonth() + e + 1, 0);
  const o = l.getDate();
  return n >= o ? l : (i.setFullYear(
    l.getFullYear(),
    l.getMonth(),
    n
  ), i);
}
const Pr = 6048e5, ks = 864e5;
let ys = {};
function Ci() {
  return ys;
}
function Ut(t, e) {
  var a, s, d, u;
  const i = Ci(), n = (e == null ? void 0 : e.weekStartsOn) ?? ((s = (a = e == null ? void 0 : e.locale) == null ? void 0 : a.options) == null ? void 0 : s.weekStartsOn) ?? i.weekStartsOn ?? ((u = (d = i.locale) == null ? void 0 : d.options) == null ? void 0 : u.weekStartsOn) ?? 0, l = Ve(t), o = l.getDay(), r = (o < n ? 7 : 0) + o - n;
  return l.setDate(l.getDate() - r), l.setHours(0, 0, 0, 0), l;
}
function hi(t) {
  return Ut(t, { weekStartsOn: 1 });
}
function Dr(t) {
  const e = Ve(t), i = e.getFullYear(), n = tt(t, 0);
  n.setFullYear(i + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const l = hi(n), o = tt(t, 0);
  o.setFullYear(i, 0, 4), o.setHours(0, 0, 0, 0);
  const r = hi(o);
  return e.getTime() >= l.getTime() ? i + 1 : e.getTime() >= r.getTime() ? i : i - 1;
}
function mt(t) {
  const e = Ve(t);
  return e.setHours(0, 0, 0, 0), e;
}
function _n(t) {
  const e = Ve(t), i = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return i.setUTCFullYear(e.getFullYear()), +t - +i;
}
function Cs(t, e) {
  const i = mt(t), n = mt(e), l = +i - _n(i), o = +n - _n(n);
  return Math.round((l - o) / ks);
}
function zs(t) {
  const e = Dr(t), i = tt(t, 0);
  return i.setFullYear(e, 0, 4), i.setHours(0, 0, 0, 0), hi(i);
}
function ht(t, e) {
  return st(t, e * 12);
}
function it(t, e) {
  const i = mt(t), n = mt(e);
  return +i == +n;
}
function js(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Es(t) {
  if (!js(t) && typeof t != "number")
    return !1;
  const e = Ve(t);
  return !isNaN(Number(e));
}
function Ms(t) {
  const e = Ve(t), i = tt(t, 0);
  return i.setFullYear(e.getFullYear(), 0, 1), i.setHours(0, 0, 0, 0), i;
}
const Ls = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, qs = (t, e, i) => {
  let n;
  const l = Ls[t];
  return typeof l == "string" ? n = l : e === 1 ? n = l.one : n = l.other.replace("{{count}}", e.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Si(t) {
  return (e = {}) => {
    const i = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[i] || t.formats[t.defaultWidth];
  };
}
const Ss = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Ts = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ps = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ds = {
  date: Si({
    formats: Ss,
    defaultWidth: "full"
  }),
  time: Si({
    formats: Ts,
    defaultWidth: "full"
  }),
  dateTime: Si({
    formats: Ps,
    defaultWidth: "full"
  })
}, Hs = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Os = (t, e, i, n) => Hs[t];
function Nt(t) {
  return (e, i) => {
    const n = i != null && i.context ? String(i.context) : "standalone";
    let l;
    if (n === "formatting" && t.formattingValues) {
      const r = t.defaultFormattingWidth || t.defaultWidth, a = i != null && i.width ? String(i.width) : r;
      l = t.formattingValues[a] || t.formattingValues[r];
    } else {
      const r = t.defaultWidth, a = i != null && i.width ? String(i.width) : t.defaultWidth;
      l = t.values[a] || t.values[r];
    }
    const o = t.argumentCallback ? t.argumentCallback(e) : e;
    return l[o];
  };
}
const Fs = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, As = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Vs = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Is = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, xs = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Bs = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ns = (t, e) => {
  const i = Number(t), n = i % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return i + "st";
      case 2:
        return i + "nd";
      case 3:
        return i + "rd";
    }
  return i + "th";
}, Ws = {
  ordinalNumber: Ns,
  era: Nt({
    values: Fs,
    defaultWidth: "wide"
  }),
  quarter: Nt({
    values: As,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Nt({
    values: Vs,
    defaultWidth: "wide"
  }),
  day: Nt({
    values: Is,
    defaultWidth: "wide"
  }),
  dayPeriod: Nt({
    values: xs,
    defaultWidth: "wide",
    formattingValues: Bs,
    defaultFormattingWidth: "wide"
  })
};
function Wt(t) {
  return (e, i = {}) => {
    const n = i.width, l = n && t.matchPatterns[n] || t.matchPatterns[t.defaultMatchWidth], o = e.match(l);
    if (!o)
      return null;
    const r = o[0], a = n && t.parsePatterns[n] || t.parsePatterns[t.defaultParseWidth], s = Array.isArray(a) ? Ys(a, (c) => c.test(r)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Rs(a, (c) => c.test(r))
    );
    let d;
    d = t.valueCallback ? t.valueCallback(s) : s, d = i.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      i.valueCallback(d)
    ) : d;
    const u = e.slice(r.length);
    return { value: d, rest: u };
  };
}
function Rs(t, e) {
  for (const i in t)
    if (Object.prototype.hasOwnProperty.call(t, i) && e(t[i]))
      return i;
}
function Ys(t, e) {
  for (let i = 0; i < t.length; i++)
    if (e(t[i]))
      return i;
}
function Zs(t) {
  return (e, i = {}) => {
    const n = e.match(t.matchPattern);
    if (!n) return null;
    const l = n[0], o = e.match(t.parsePattern);
    if (!o) return null;
    let r = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    r = i.valueCallback ? i.valueCallback(r) : r;
    const a = e.slice(l.length);
    return { value: r, rest: a };
  };
}
const Us = /^(\d+)(th|st|nd|rd)?/i, Gs = /\d+/i, Ks = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Xs = {
  any: [/^b/i, /^(a|c)/i]
}, Js = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Qs = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $s = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, eu = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, tu = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, iu = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, nu = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, lu = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ou = {
  ordinalNumber: Zs({
    matchPattern: Us,
    parsePattern: Gs,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Wt({
    matchPatterns: Ks,
    defaultMatchWidth: "wide",
    parsePatterns: Xs,
    defaultParseWidth: "any"
  }),
  quarter: Wt({
    matchPatterns: Js,
    defaultMatchWidth: "wide",
    parsePatterns: Qs,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Wt({
    matchPatterns: $s,
    defaultMatchWidth: "wide",
    parsePatterns: eu,
    defaultParseWidth: "any"
  }),
  day: Wt({
    matchPatterns: tu,
    defaultMatchWidth: "wide",
    parsePatterns: iu,
    defaultParseWidth: "any"
  }),
  dayPeriod: Wt({
    matchPatterns: nu,
    defaultMatchWidth: "any",
    parsePatterns: lu,
    defaultParseWidth: "any"
  })
}, ru = {
  code: "en-US",
  formatDistance: qs,
  formatLong: Ds,
  formatRelative: Os,
  localize: Ws,
  match: ou,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function au(t) {
  const e = Ve(t);
  return Cs(e, Ms(e)) + 1;
}
function su(t) {
  const e = Ve(t), i = +hi(e) - +zs(e);
  return Math.round(i / Pr) + 1;
}
function Hr(t, e) {
  var u, c, g, h;
  const i = Ve(t), n = i.getFullYear(), l = Ci(), o = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((c = (u = e == null ? void 0 : e.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? l.firstWeekContainsDate ?? ((h = (g = l.locale) == null ? void 0 : g.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, r = tt(t, 0);
  r.setFullYear(n + 1, 0, o), r.setHours(0, 0, 0, 0);
  const a = Ut(r, e), s = tt(t, 0);
  s.setFullYear(n, 0, o), s.setHours(0, 0, 0, 0);
  const d = Ut(s, e);
  return i.getTime() >= a.getTime() ? n + 1 : i.getTime() >= d.getTime() ? n : n - 1;
}
function uu(t, e) {
  var a, s, d, u;
  const i = Ci(), n = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((s = (a = e == null ? void 0 : e.locale) == null ? void 0 : a.options) == null ? void 0 : s.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((u = (d = i.locale) == null ? void 0 : d.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, l = Hr(t, e), o = tt(t, 0);
  return o.setFullYear(l, 0, n), o.setHours(0, 0, 0, 0), Ut(o, e);
}
function du(t, e) {
  const i = Ve(t), n = +Ut(i, e) - +uu(i, e);
  return Math.round(n / Pr) + 1;
}
function Te(t, e) {
  const i = t < 0 ? "-" : "", n = Math.abs(t).toString().padStart(e, "0");
  return i + n;
}
const gt = {
  // Year
  y(t, e) {
    const i = t.getFullYear(), n = i > 0 ? i : 1 - i;
    return Te(e === "yy" ? n % 100 : n, e.length);
  },
  // Month
  M(t, e) {
    const i = t.getMonth();
    return e === "M" ? String(i + 1) : Te(i + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return Te(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const i = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return i.toUpperCase();
      case "aaa":
        return i;
      case "aaaaa":
        return i[0];
      case "aaaa":
      default:
        return i === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return Te(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return Te(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return Te(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return Te(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const i = e.length, n = t.getMilliseconds(), l = Math.trunc(
      n * Math.pow(10, i - 3)
    );
    return Te(l, e.length);
  }
}, qt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, wn = {
  // Era
  G: function(t, e, i) {
    const n = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return i.era(n, { width: "abbreviated" });
      case "GGGGG":
        return i.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return i.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, i) {
    if (e === "yo") {
      const n = t.getFullYear(), l = n > 0 ? n : 1 - n;
      return i.ordinalNumber(l, { unit: "year" });
    }
    return gt.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, i, n) {
    const l = Hr(t, n), o = l > 0 ? l : 1 - l;
    if (e === "YY") {
      const r = o % 100;
      return Te(r, 2);
    }
    return e === "Yo" ? i.ordinalNumber(o, { unit: "year" }) : Te(o, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const i = Dr(t);
    return Te(i, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const i = t.getFullYear();
    return Te(i, e.length);
  },
  // Quarter
  Q: function(t, e, i) {
    const n = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(n);
      case "QQ":
        return Te(n, 2);
      case "Qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, i) {
    const n = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(n);
      case "qq":
        return Te(n, 2);
      case "qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, i) {
    const n = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return gt.M(t, e);
      case "Mo":
        return i.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return i.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return i.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return i.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, i) {
    const n = t.getMonth();
    switch (e) {
      case "L":
        return String(n + 1);
      case "LL":
        return Te(n + 1, 2);
      case "Lo":
        return i.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return i.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return i.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return i.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, i, n) {
    const l = du(t, n);
    return e === "wo" ? i.ordinalNumber(l, { unit: "week" }) : Te(l, e.length);
  },
  // ISO week of year
  I: function(t, e, i) {
    const n = su(t);
    return e === "Io" ? i.ordinalNumber(n, { unit: "week" }) : Te(n, e.length);
  },
  // Day of the month
  d: function(t, e, i) {
    return e === "do" ? i.ordinalNumber(t.getDate(), { unit: "date" }) : gt.d(t, e);
  },
  // Day of year
  D: function(t, e, i) {
    const n = au(t);
    return e === "Do" ? i.ordinalNumber(n, { unit: "dayOfYear" }) : Te(n, e.length);
  },
  // Day of week
  E: function(t, e, i) {
    const n = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return i.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return i.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, i, n) {
    const l = t.getDay(), o = (l - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(o);
      case "ee":
        return Te(o, 2);
      case "eo":
        return i.ordinalNumber(o, { unit: "day" });
      case "eee":
        return i.day(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return i.day(l, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return i.day(l, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return i.day(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, i, n) {
    const l = t.getDay(), o = (l - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(o);
      case "cc":
        return Te(o, e.length);
      case "co":
        return i.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return i.day(l, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return i.day(l, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return i.day(l, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return i.day(l, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, i) {
    const n = t.getDay(), l = n === 0 ? 7 : n;
    switch (e) {
      case "i":
        return String(l);
      case "ii":
        return Te(l, e.length);
      case "io":
        return i.ordinalNumber(l, { unit: "day" });
      case "iii":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return i.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return i.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, i) {
    const l = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return i.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return i.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return i.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return i.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, i) {
    const n = t.getHours();
    let l;
    switch (n === 12 ? l = qt.noon : n === 0 ? l = qt.midnight : l = n / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return i.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return i.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return i.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return i.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, i) {
    const n = t.getHours();
    let l;
    switch (n >= 17 ? l = qt.evening : n >= 12 ? l = qt.afternoon : n >= 4 ? l = qt.morning : l = qt.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return i.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return i.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return i.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, i) {
    if (e === "ho") {
      let n = t.getHours() % 12;
      return n === 0 && (n = 12), i.ordinalNumber(n, { unit: "hour" });
    }
    return gt.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, i) {
    return e === "Ho" ? i.ordinalNumber(t.getHours(), { unit: "hour" }) : gt.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, i) {
    const n = t.getHours() % 12;
    return e === "Ko" ? i.ordinalNumber(n, { unit: "hour" }) : Te(n, e.length);
  },
  // Hour [1-24]
  k: function(t, e, i) {
    let n = t.getHours();
    return n === 0 && (n = 24), e === "ko" ? i.ordinalNumber(n, { unit: "hour" }) : Te(n, e.length);
  },
  // Minute
  m: function(t, e, i) {
    return e === "mo" ? i.ordinalNumber(t.getMinutes(), { unit: "minute" }) : gt.m(t, e);
  },
  // Second
  s: function(t, e, i) {
    return e === "so" ? i.ordinalNumber(t.getSeconds(), { unit: "second" }) : gt.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return gt.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, i) {
    const n = t.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (e) {
      case "X":
        return yn(n);
      case "XXXX":
      case "XX":
        return wt(n);
      case "XXXXX":
      case "XXX":
      default:
        return wt(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, i) {
    const n = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return yn(n);
      case "xxxx":
      case "xx":
        return wt(n);
      case "xxxxx":
      case "xxx":
      default:
        return wt(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, i) {
    const n = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + kn(n, ":");
      case "OOOO":
      default:
        return "GMT" + wt(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, i) {
    const n = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + kn(n, ":");
      case "zzzz":
      default:
        return "GMT" + wt(n, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, i) {
    const n = Math.trunc(t.getTime() / 1e3);
    return Te(n, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, i) {
    const n = t.getTime();
    return Te(n, e.length);
  }
};
function kn(t, e = "") {
  const i = t > 0 ? "-" : "+", n = Math.abs(t), l = Math.trunc(n / 60), o = n % 60;
  return o === 0 ? i + String(l) : i + String(l) + e + Te(o, 2);
}
function yn(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Te(Math.abs(t) / 60, 2) : wt(t, e);
}
function wt(t, e = "") {
  const i = t > 0 ? "-" : "+", n = Math.abs(t), l = Te(Math.trunc(n / 60), 2), o = Te(n % 60, 2);
  return i + l + e + o;
}
const Cn = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, Or = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, cu = (t, e) => {
  const i = t.match(/(P+)(p+)?/) || [], n = i[1], l = i[2];
  if (!l)
    return Cn(t, e);
  let o;
  switch (n) {
    case "P":
      o = e.dateTime({ width: "short" });
      break;
    case "PP":
      o = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = e.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Cn(n, e)).replace("{{time}}", Or(l, e));
}, fu = {
  p: Or,
  P: cu
}, gu = /^D+$/, hu = /^Y+$/, mu = ["D", "DD", "YY", "YYYY"];
function vu(t) {
  return gu.test(t);
}
function bu(t) {
  return hu.test(t);
}
function pu(t, e, i) {
  const n = _u(t, e, i);
  if (console.warn(n), mu.includes(t)) throw new RangeError(n);
}
function _u(t, e, i) {
  const n = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${n} to the input \`${i}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const wu = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ku = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, yu = /^'([^]*?)'?$/, Cu = /''/g, zu = /[a-zA-Z]/;
function xe(t, e, i) {
  var u, c, g, h;
  const n = Ci(), l = n.locale ?? ru, o = n.firstWeekContainsDate ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, r = n.weekStartsOn ?? ((h = (g = n.locale) == null ? void 0 : g.options) == null ? void 0 : h.weekStartsOn) ?? 0, a = Ve(t);
  if (!Es(a))
    throw new RangeError("Invalid time value");
  let s = e.match(ku).map((m) => {
    const v = m[0];
    if (v === "p" || v === "P") {
      const b = fu[v];
      return b(m, l.formatLong);
    }
    return m;
  }).join("").match(wu).map((m) => {
    if (m === "''")
      return { isToken: !1, value: "'" };
    const v = m[0];
    if (v === "'")
      return { isToken: !1, value: ju(m) };
    if (wn[v])
      return { isToken: !0, value: m };
    if (v.match(zu))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + v + "`"
      );
    return { isToken: !1, value: m };
  });
  l.localize.preprocessor && (s = l.localize.preprocessor(a, s));
  const d = {
    firstWeekContainsDate: o,
    weekStartsOn: r,
    locale: l
  };
  return s.map((m) => {
    if (!m.isToken) return m.value;
    const v = m.value;
    (bu(v) || vu(v)) && pu(v, e, String(t));
    const b = wn[v[0]];
    return b(a, v, l.localize, d);
  }).join("");
}
function ju(t) {
  const e = t.match(yu);
  return e ? e[1].replace(Cu, "'") : t;
}
function Eu(t) {
  const e = Ve(t), i = e.getFullYear(), n = e.getMonth(), l = tt(t, 0);
  return l.setFullYear(i, n + 1, 0), l.setHours(0, 0, 0, 0), l.getDate();
}
function zn(t) {
  const e = Ve(t), i = e.getMonth();
  return e.setFullYear(e.getFullYear(), i + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function At(t, e) {
  const i = Ve(t), n = Ve(e);
  return i.getTime() > n.getTime();
}
function Vt(t, e) {
  const i = Ve(t), n = Ve(e);
  return +i < +n;
}
function jn(t, e) {
  const i = Ve(t), n = Ve(e);
  return i.getFullYear() === n.getFullYear() && i.getMonth() === n.getMonth();
}
function En(t, e) {
  const i = Ve(t);
  return i.setDate(e), i;
}
function Mu(t) {
  _e(t, "svelte-19yfw1j", ".bordered.svelte-19yfw1j.svelte-19yfw1j{display:inline-block;border:1px solid var(--goa-color-greyscale-700);border-radius:var(--goa-date-input-calendar-border-radius);padding:1rem}.calendar.svelte-19yfw1j.svelte-19yfw1j{display:grid;justify-items:center;grid-template-columns:repeat(7, 1fr);gap:0px;width:var(--goa-date-input-calendar-width);font:var(--goa-date-input-day-font)}h5.svelte-19yfw1j.svelte-19yfw1j{margin:var(--goa-date-input-day-of-week-margin);font:var(--goa-date-input-day-of-week-font)}.day.svelte-19yfw1j.svelte-19yfw1j{align-items:center;background-color:var(--goa-date-input-day-color-bg);border:none;border-radius:var(--goa-date-input-day-border-radius);color:var(--goa-date-input-day-color-text);display:inline-flex;font:var(--goa-date-input-day-font);justify-content:center;margin:0;width:var(--goa-date-input-day-size);height:var(--goa-date-input-day-size)}.day.other-month.svelte-19yfw1j.svelte-19yfw1j{color:var(--goa-date-input-day-color-text-other-month)}.day.today.svelte-19yfw1j.svelte-19yfw1j{font:var(--goa-date-input-day-font-today)}.day.svelte-19yfw1j.svelte-19yfw1j:focus-within{outline:var(--goa-date-input-day-border-focus);z-index:1000;background-color:none}.day.svelte-19yfw1j.svelte-19yfw1j:hover{background-color:var(--goa-date-input-day-color-bg-hover);color:var(--goa-date-input-day-color-text-hover);cursor:pointer}.day.svelte-19yfw1j.svelte-19yfw1j:focus-within:hover{background-color:transparent}.day.selected.svelte-19yfw1j.svelte-19yfw1j{background-color:var(--goa-date-input-day-color-bg-selected);color:var(--goa-date-input-day-color-text-selected)}.day.selected.svelte-19yfw1j.svelte-19yfw1j:hover{background-color:var(--goa-date-input-day-color-bg-selected-hover);color:var(--goa-date-input-day-color-text-selected-hover)}.day.selected.svelte-19yfw1j.svelte-19yfw1j:focus-within:hover{background-color:var(--goa-date-input-day-color-bg-selected)}.day.today.selected.svelte-19yfw1j.svelte-19yfw1j:hover{background-color:var(--goa-date-input-day-color-bg-selected-hover);color:var(--goa-date-input-day-color-text-selected-hover)}.day.today.selected.svelte-19yfw1j.svelte-19yfw1j:focus-within:hover{background-color:var(--goa-date-input-day-color-bg-selected)}.day.disabled.svelte-19yfw1j.svelte-19yfw1j{color:var(--goa-date-input-day-color-text-disabled);cursor:default}.day.disabled.svelte-19yfw1j.svelte-19yfw1j:hover{background-color:transparent}.day-num.svelte-19yfw1j.svelte-19yfw1j{width:var(--goa-date-input-day-underline-today-width);pointer-events:none;margin-bottom:1px}.selected.svelte-19yfw1j .day-num.svelte-19yfw1j{width:var(--goa-date-input-day-underline-today-width);border-bottom:none}.today.svelte-19yfw1j .day-num.svelte-19yfw1j{padding-top:2px;border-bottom:var(--goa-date-input-day-underline-today)}.today.selected.svelte-19yfw1j .day-num.svelte-19yfw1j{border-bottom:var(--goa-date-input-day-underline-today-selected)}");
}
function Mn(t, e, i) {
  const n = t.slice();
  return n[28] = e[i], n;
}
function Ln(t, e, i) {
  const n = t.slice();
  return n[28] = e[i], n;
}
function qn(t, e, i) {
  const n = t.slice();
  return n[28] = e[i], n;
}
function Sn(t, e, i) {
  const n = t.slice();
  return n[35] = e[i], n;
}
function Tn(t, e, i) {
  const n = t.slice();
  return n[38] = e[i], n[40] = i, n;
}
function Pn(t) {
  let e;
  return {
    c() {
      e = C("goa-dropdown-item"), p(
        e,
        "value",
        /*i*/
        t[40]
      ), p(
        e,
        "label",
        /*month*/
        t[38]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p: ve,
    d(i) {
      i && P(e);
    }
  };
}
function Dn(t) {
  let e, i;
  return {
    c() {
      e = C("goa-dropdown-item"), p(e, "value", i = /*year*/
      t[35]);
    },
    m(n, l) {
      D(n, e, l);
    },
    p(n, l) {
      l[0] & /*_years*/
      32768 && i !== (i = /*year*/
      n[35]) && p(e, "value", i);
    },
    d(n) {
      n && P(e);
    }
  };
}
function Hn(t) {
  let e, i, n = (
    /*d*/
    t[28].getDate() + ""
  ), l, o, r, a, s, d, u;
  return {
    c() {
      e = C("button"), i = C("div"), l = le(n), f(i, "class", "day-num svelte-19yfw1j"), f(i, "data-testid", "date"), f(e, "aria-label", o = xe(
        /*d*/
        t[28],
        "PPPP"
      )), f(e, "data-date", r = xe(
        /*d*/
        t[28],
        "T"
      )), f(e, "data-day", a = xe(
        /*d*/
        t[28],
        "eee"
      )), f(e, "class", "day other-month svelte-19yfw1j"), f(e, "tabindex", s = it(
        /*d*/
        t[28],
        /*_calendarDate*/
        t[9]
      ) ? 0 : -1), G(e, "disabled", Vt(
        /*d*/
        t[28],
        /*_min*/
        t[10]
      ) || At(
        /*d*/
        t[28],
        /*_max*/
        t[11]
      ));
    },
    m(c, g) {
      D(c, e, g), _(e, i), _(i, l), d || (u = te(
        e,
        "click",
        /*onDateClick*/
        t[20]
      ), d = !0);
    },
    p(c, g) {
      g[0] & /*_previousMonthDays*/
      8192 && n !== (n = /*d*/
      c[28].getDate() + "") && pe(l, n), g[0] & /*_previousMonthDays*/
      8192 && o !== (o = xe(
        /*d*/
        c[28],
        "PPPP"
      )) && f(e, "aria-label", o), g[0] & /*_previousMonthDays*/
      8192 && r !== (r = xe(
        /*d*/
        c[28],
        "T"
      )) && f(e, "data-date", r), g[0] & /*_previousMonthDays*/
      8192 && a !== (a = xe(
        /*d*/
        c[28],
        "eee"
      )) && f(e, "data-day", a), g[0] & /*_previousMonthDays, _calendarDate*/
      8704 && s !== (s = it(
        /*d*/
        c[28],
        /*_calendarDate*/
        c[9]
      ) ? 0 : -1) && f(e, "tabindex", s), g[0] & /*_previousMonthDays, _min, _max*/
      11264 && G(e, "disabled", Vt(
        /*d*/
        c[28],
        /*_min*/
        c[10]
      ) || At(
        /*d*/
        c[28],
        /*_max*/
        c[11]
      ));
    },
    d(c) {
      c && P(e), d = !1, u();
    }
  };
}
function On(t) {
  let e, i, n = (
    /*d*/
    t[28].getDate() + ""
  ), l, o, r, a, s, d, u;
  return {
    c() {
      e = C("button"), i = C("div"), l = le(n), f(i, "class", "day-num svelte-19yfw1j"), f(i, "data-testid", "date"), f(e, "aria-label", o = xe(
        /*d*/
        t[28],
        "PPPP"
      )), f(e, "data-date", r = xe(
        /*d*/
        t[28],
        "T"
      )), f(e, "data-day", a = xe(
        /*d*/
        t[28],
        "eee"
      )), f(e, "class", "day svelte-19yfw1j"), f(e, "tabindex", s = it(
        /*d*/
        t[28],
        /*_calendarDate*/
        t[9]
      ) ? 0 : -1), G(e, "today", it(
        /*d*/
        t[28],
        /* @__PURE__ */ new Date()
      )), G(
        e,
        "selected",
        /*value*/
        t[0] && /*_selectedDate*/
        t[8] && it(
          /*d*/
          t[28],
          /*_selectedDate*/
          t[8]
        )
      ), G(e, "disabled", Vt(
        /*d*/
        t[28],
        /*_min*/
        t[10]
      ) || At(
        /*d*/
        t[28],
        /*_max*/
        t[11]
      ));
    },
    m(c, g) {
      D(c, e, g), _(e, i), _(i, l), d || (u = te(
        e,
        "click",
        /*onDateClick*/
        t[20]
      ), d = !0);
    },
    p(c, g) {
      g[0] & /*_monthDays*/
      4096 && n !== (n = /*d*/
      c[28].getDate() + "") && pe(l, n), g[0] & /*_monthDays*/
      4096 && o !== (o = xe(
        /*d*/
        c[28],
        "PPPP"
      )) && f(e, "aria-label", o), g[0] & /*_monthDays*/
      4096 && r !== (r = xe(
        /*d*/
        c[28],
        "T"
      )) && f(e, "data-date", r), g[0] & /*_monthDays*/
      4096 && a !== (a = xe(
        /*d*/
        c[28],
        "eee"
      )) && f(e, "data-day", a), g[0] & /*_monthDays, _calendarDate*/
      4608 && s !== (s = it(
        /*d*/
        c[28],
        /*_calendarDate*/
        c[9]
      ) ? 0 : -1) && f(e, "tabindex", s), g[0] & /*_monthDays*/
      4096 && G(e, "today", it(
        /*d*/
        c[28],
        /* @__PURE__ */ new Date()
      )), g[0] & /*value, _selectedDate, _monthDays*/
      4353 && G(
        e,
        "selected",
        /*value*/
        c[0] && /*_selectedDate*/
        c[8] && it(
          /*d*/
          c[28],
          /*_selectedDate*/
          c[8]
        )
      ), g[0] & /*_monthDays, _min, _max*/
      7168 && G(e, "disabled", Vt(
        /*d*/
        c[28],
        /*_min*/
        c[10]
      ) || At(
        /*d*/
        c[28],
        /*_max*/
        c[11]
      ));
    },
    d(c) {
      c && P(e), d = !1, u();
    }
  };
}
function Fn(t) {
  let e, i, n = (
    /*d*/
    t[28].getDate() + ""
  ), l, o, r, a, s, d, u, c;
  return {
    c() {
      e = C("button"), i = C("div"), l = le(n), o = x(), f(i, "class", "day-num svelte-19yfw1j"), f(i, "data-testid", "date"), f(e, "aria-label", r = xe(
        /*d*/
        t[28],
        "PPPP"
      )), f(e, "data-date", a = xe(
        /*d*/
        t[28],
        "T"
      )), f(e, "data-day", s = xe(
        /*d*/
        t[28],
        "eee"
      )), f(e, "class", "day other-month svelte-19yfw1j"), f(e, "tabindex", d = it(
        /*d*/
        t[28],
        /*_calendarDate*/
        t[9]
      ) ? 0 : -1), G(e, "disabled", Vt(
        /*d*/
        t[28],
        /*_min*/
        t[10]
      ) || At(
        /*d*/
        t[28],
        /*_max*/
        t[11]
      ));
    },
    m(g, h) {
      D(g, e, h), _(e, i), _(i, l), _(e, o), u || (c = te(
        e,
        "click",
        /*onDateClick*/
        t[20]
      ), u = !0);
    },
    p(g, h) {
      h[0] & /*_nextMonthDays*/
      16384 && n !== (n = /*d*/
      g[28].getDate() + "") && pe(l, n), h[0] & /*_nextMonthDays*/
      16384 && r !== (r = xe(
        /*d*/
        g[28],
        "PPPP"
      )) && f(e, "aria-label", r), h[0] & /*_nextMonthDays*/
      16384 && a !== (a = xe(
        /*d*/
        g[28],
        "T"
      )) && f(e, "data-date", a), h[0] & /*_nextMonthDays*/
      16384 && s !== (s = xe(
        /*d*/
        g[28],
        "eee"
      )) && f(e, "data-day", s), h[0] & /*_nextMonthDays, _calendarDate*/
      16896 && d !== (d = it(
        /*d*/
        g[28],
        /*_calendarDate*/
        g[9]
      ) ? 0 : -1) && f(e, "tabindex", d), h[0] & /*_nextMonthDays, _min, _max*/
      19456 && G(e, "disabled", Vt(
        /*d*/
        g[28],
        /*_min*/
        g[10]
      ) || At(
        /*d*/
        g[28],
        /*_max*/
        g[11]
      ));
    },
    d(g) {
      g && P(e), u = !1, c();
    }
  };
}
function Lu(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v, b, w, y, j, E, M, L, z, V, T, S, A, R, I, B, N, F, q = Le(
    /*_months*/
    t[17]
  ), H = [];
  for (let ee = 0; ee < q.length; ee += 1)
    H[ee] = Pn(Tn(t, q, ee));
  let O = Le(
    /*_years*/
    t[15]
  ), W = [];
  for (let ee = 0; ee < O.length; ee += 1)
    W[ee] = Dn(Sn(t, O, ee));
  let K = Le(
    /*_previousMonthDays*/
    t[13]
  ), $ = [];
  for (let ee = 0; ee < K.length; ee += 1)
    $[ee] = Hn(qn(t, K, ee));
  let ye = Le(
    /*_monthDays*/
    t[12]
  ), Z = [];
  for (let ee = 0; ee < ye.length; ee += 1)
    Z[ee] = On(Ln(t, ye, ee));
  let Q = Le(
    /*_nextMonthDays*/
    t[14]
  ), X = [];
  for (let ee = 0; ee < Q.length; ee += 1)
    X[ee] = Fn(Mn(t, Q, ee));
  return {
    c() {
      var ee, ie;
      e = C("div"), i = C("goa-block"), n = C("goa-form-item"), l = C("goa-dropdown");
      for (let J = 0; J < H.length; J += 1)
        H[J].c();
      a = x(), s = C("goa-form-item"), d = C("goa-dropdown");
      for (let J = 0; J < W.length; J += 1)
        W[J].c();
      g = x(), h = C("div"), m = C("h5"), m.textContent = "Sun", v = x(), b = C("h5"), b.textContent = "Mon", w = x(), y = C("h5"), y.textContent = "Tue", j = x(), E = C("h5"), E.textContent = "Wed", M = x(), L = C("h5"), L.textContent = "Thu", z = x(), V = C("h5"), V.textContent = "Fri", T = x(), S = C("h5"), S.textContent = "Sat", A = x();
      for (let J = 0; J < $.length; J += 1)
        $[J].c();
      R = x();
      for (let J = 0; J < Z.length; J += 1)
        Z[J].c();
      I = x();
      for (let J = 0; J < X.length; J += 1)
        X[J].c();
      p(l, "name", "month"), p(l, "arialabel", o = `${/*name*/
      t[1]} month`), p(l, "data-testid", "months"), p(l, "width", "160px"), p(l, "maxheight", "240px"), p(l, "relative", "true"), p(l, "value", r = /*_calendarDate*/
      (ee = t[9]) == null ? void 0 : ee.getMonth()), p(n, "label", "Month"), p(n, "mt", "0"), p(d, "name", "year"), p(d, "arialabel", u = `${/*name*/
      t[1]} year`), p(d, "data-testid", "years"), p(d, "width", "104px"), p(d, "maxheight", "240px"), p(d, "relative", "true"), p(d, "value", c = /*_calendarDate*/
      (ie = t[9]) == null ? void 0 : ie.getFullYear()), p(s, "label", "Year"), p(s, "mt", "0"), p(i, "mb", "m"), f(m, "class", "svelte-19yfw1j"), f(b, "class", "svelte-19yfw1j"), f(y, "class", "svelte-19yfw1j"), f(E, "class", "svelte-19yfw1j"), f(L, "class", "svelte-19yfw1j"), f(V, "class", "svelte-19yfw1j"), f(S, "class", "svelte-19yfw1j"), f(h, "data-testid", "calendar"), f(h, "class", "calendar svelte-19yfw1j"), f(e, "style", B = be(
        /*mt*/
        t[3],
        /*mr*/
        t[4],
        /*mb*/
        t[5],
        /*ml*/
        t[6]
      )), f(
        e,
        "data-testid",
        /*testid*/
        t[2]
      ), f(e, "class", "svelte-19yfw1j"), G(
        e,
        "bordered",
        /*bordered*/
        t[7] === "true"
      );
    },
    m(ee, ie) {
      D(ee, e, ie), _(e, i), _(i, n), _(n, l);
      for (let J = 0; J < H.length; J += 1)
        H[J] && H[J].m(l, null);
      _(i, a), _(i, s), _(s, d);
      for (let J = 0; J < W.length; J += 1)
        W[J] && W[J].m(d, null);
      _(e, g), _(e, h), _(h, m), _(h, v), _(h, b), _(h, w), _(h, y), _(h, j), _(h, E), _(h, M), _(h, L), _(h, z), _(h, V), _(h, T), _(h, S), _(h, A);
      for (let J = 0; J < $.length; J += 1)
        $[J] && $[J].m(h, null);
      _(h, R);
      for (let J = 0; J < Z.length; J += 1)
        Z[J] && Z[J].m(h, null);
      _(h, I);
      for (let J = 0; J < X.length; J += 1)
        X[J] && X[J].m(h, null);
      t[23](h), N || (F = [
        te(
          l,
          "_change",
          /*setMonth*/
          t[18]
        ),
        te(
          d,
          "_change",
          /*setYear*/
          t[19]
        )
      ], N = !0);
    },
    p(ee, ie) {
      var J, De;
      if (ie[0] & /*_months*/
      131072) {
        q = Le(
          /*_months*/
          ee[17]
        );
        let fe;
        for (fe = 0; fe < q.length; fe += 1) {
          const Ae = Tn(ee, q, fe);
          H[fe] ? H[fe].p(Ae, ie) : (H[fe] = Pn(Ae), H[fe].c(), H[fe].m(l, null));
        }
        for (; fe < H.length; fe += 1)
          H[fe].d(1);
        H.length = q.length;
      }
      if (ie[0] & /*name*/
      2 && o !== (o = `${/*name*/
      ee[1]} month`) && p(l, "arialabel", o), ie[0] & /*_calendarDate*/
      512 && r !== (r = /*_calendarDate*/
      (J = ee[9]) == null ? void 0 : J.getMonth()) && p(l, "value", r), ie[0] & /*_years*/
      32768) {
        O = Le(
          /*_years*/
          ee[15]
        );
        let fe;
        for (fe = 0; fe < O.length; fe += 1) {
          const Ae = Sn(ee, O, fe);
          W[fe] ? W[fe].p(Ae, ie) : (W[fe] = Dn(Ae), W[fe].c(), W[fe].m(d, null));
        }
        for (; fe < W.length; fe += 1)
          W[fe].d(1);
        W.length = O.length;
      }
      if (ie[0] & /*name*/
      2 && u !== (u = `${/*name*/
      ee[1]} year`) && p(d, "arialabel", u), ie[0] & /*_calendarDate*/
      512 && c !== (c = /*_calendarDate*/
      (De = ee[9]) == null ? void 0 : De.getFullYear()) && p(d, "value", c), ie[0] & /*_previousMonthDays, _calendarDate, _min, _max, onDateClick*/
      1060352) {
        K = Le(
          /*_previousMonthDays*/
          ee[13]
        );
        let fe;
        for (fe = 0; fe < K.length; fe += 1) {
          const Ae = qn(ee, K, fe);
          $[fe] ? $[fe].p(Ae, ie) : ($[fe] = Hn(Ae), $[fe].c(), $[fe].m(h, R));
        }
        for (; fe < $.length; fe += 1)
          $[fe].d(1);
        $.length = K.length;
      }
      if (ie[0] & /*_monthDays, _calendarDate, value, _selectedDate, _min, _max, onDateClick*/
      1056513) {
        ye = Le(
          /*_monthDays*/
          ee[12]
        );
        let fe;
        for (fe = 0; fe < ye.length; fe += 1) {
          const Ae = Ln(ee, ye, fe);
          Z[fe] ? Z[fe].p(Ae, ie) : (Z[fe] = On(Ae), Z[fe].c(), Z[fe].m(h, I));
        }
        for (; fe < Z.length; fe += 1)
          Z[fe].d(1);
        Z.length = ye.length;
      }
      if (ie[0] & /*_nextMonthDays, _calendarDate, _min, _max, onDateClick*/
      1068544) {
        Q = Le(
          /*_nextMonthDays*/
          ee[14]
        );
        let fe;
        for (fe = 0; fe < Q.length; fe += 1) {
          const Ae = Mn(ee, Q, fe);
          X[fe] ? X[fe].p(Ae, ie) : (X[fe] = Fn(Ae), X[fe].c(), X[fe].m(h, null));
        }
        for (; fe < X.length; fe += 1)
          X[fe].d(1);
        X.length = Q.length;
      }
      ie[0] & /*mt, mr, mb, ml*/
      120 && B !== (B = be(
        /*mt*/
        ee[3],
        /*mr*/
        ee[4],
        /*mb*/
        ee[5],
        /*ml*/
        ee[6]
      )) && f(e, "style", B), ie[0] & /*testid*/
      4 && f(
        e,
        "data-testid",
        /*testid*/
        ee[2]
      ), ie[0] & /*bordered*/
      128 && G(
        e,
        "bordered",
        /*bordered*/
        ee[7] === "true"
      );
    },
    i: ve,
    o: ve,
    d(ee) {
      ee && P(e), Ye(H, ee), Ye(W, ee), Ye($, ee), Ye(Z, ee), Ye(X, ee), t[23](null), N = !1, He(F);
    }
  };
}
function qu(t, e, i) {
  let { name: n = "" } = e, { value: l = "" } = e, { min: o = "" } = e, { max: r = "" } = e, { testid: a = "" } = e, { mt: s = null } = e, { mr: d = null } = e, { mb: u = null } = e, { ml: c = null } = e, { bordered: g = "true" } = e, h, m, v, b, w = [], y = [], j = [], E, M = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ], L = [], z;
  ke(async () => {
    i(9, m = i(8, h = mt(l ? new Date(l) : /* @__PURE__ */ new Date()))), i(10, v = o && new Date(o) || ht(h, -5)), i(11, b = r && new Date(r) || ht(h, 5));
    const N = b.getFullYear() - v.getFullYear() + 1;
    let F = v.getFullYear();
    i(15, L = new Array(N).fill(void 0).map((q, H) => `${F + H}`).sort()), T(), await Pe(), V({ type: "date", value: h });
  });
  function V(N) {
    switch (N.type) {
      case "date":
        i(9, m = N.value);
        break;
      case "month":
        m.setMonth(N.value);
        break;
      case "year":
        m.setFullYear(N.value);
        break;
    }
    if (!Li(m))
      return;
    const F = Eu(m);
    i(12, w = new Array(F).fill(void 0).map((O, W) => new Date(m.getFullYear(), m.getMonth(), W + 1)));
    const q = zn(st(m, -1)), H = En(m, 1);
    i(13, y = []);
    for (let O = 0; O < H.getDay(); O++)
      i(13, y = [...y, Ze(q, -O)]);
    if (y.reverse(), i(14, j = []), E = 7 - (y.length + w.length) % 7, E < 7) {
      const O = En(st(m, 1), 1);
      for (let W = 0; W < E; W++)
        i(14, j = [...j, Ze(O, W)]);
    }
  }
  function T() {
    const N = async (F, q) => {
      if (F.stopPropagation(), F.preventDefault(), q < v || q > b)
        return;
      jn(q, m) || V({ type: "date", value: q }), i(9, m = q), await Pe();
      const H = z.querySelector(`[data-date="${q.getTime()}"]`);
      H == null || H.focus();
    };
    z.addEventListener("keydown", (F) => {
      switch (F.key) {
        case "ArrowUp":
          N(F, Ze(m, -7));
          break;
        case "ArrowDown":
          N(F, Ze(m, 7));
          break;
        case "ArrowLeft":
          N(F, Ze(m, -1));
          break;
        case "ArrowRight":
          N(F, Ze(m, 1));
          break;
        case "Delete":
        case "Backspace":
          i(8, h = null);
          break;
        case "Home": {
          let q = new Date(m);
          q.setDate(1), N(F, q);
          break;
        }
        case "End":
          N(F, zn(m));
          break;
        case "PageUp":
          F.shiftKey ? N(F, ht(m, -1)) : N(F, st(m, -1));
          break;
        case "PageDown":
          F.shiftKey ? N(F, ht(m, 1)) : N(F, st(m, 1));
          break;
        case "Enter":
          i(8, h = m), S(), F.stopPropagation(), F.preventDefault();
          break;
        case "Escape":
          F.stopPropagation(), F.preventDefault();
          break;
      }
    });
  }
  function S() {
    h && Li(h) && (i(0, l = h.toISOString()), z.dispatchEvent(new CustomEvent(
      "_change",
      {
        composed: !0,
        detail: { type: "date", name: n, value: h }
      }
    )));
  }
  function A(N) {
    V({ type: "month", value: +N.detail.value }), N.preventDefault(), N.stopPropagation();
  }
  function R(N) {
    V({ type: "year", value: +N.detail.value }), N.preventDefault(), N.stopPropagation();
  }
  function I(N) {
    const F = N.target, q = parseInt(F.dataset.date || "0");
    if (!q) return;
    const H = new Date(q);
    H < v || H > b || (jn(H, m) || V({ type: "date", value: H }), i(8, h = i(9, m = H)), S());
  }
  function B(N) {
    ue[N ? "unshift" : "push"](() => {
      z = N, i(16, z);
    });
  }
  return t.$$set = (N) => {
    "name" in N && i(1, n = N.name), "value" in N && i(0, l = N.value), "min" in N && i(21, o = N.min), "max" in N && i(22, r = N.max), "testid" in N && i(2, a = N.testid), "mt" in N && i(3, s = N.mt), "mr" in N && i(4, d = N.mr), "mb" in N && i(5, u = N.mb), "ml" in N && i(6, c = N.ml), "bordered" in N && i(7, g = N.bordered);
  }, t.$$.update = () => {
    if (t.$$.dirty[0] & /*value, _selectedDate*/
    257 && l) {
      const N = mt(new Date(l));
      Li(N) && (V({
        type: "date",
        value: h || N
      }), i(8, h = N), i(9, m = N));
    }
  }, [
    l,
    n,
    a,
    s,
    d,
    u,
    c,
    g,
    h,
    m,
    v,
    b,
    w,
    y,
    j,
    L,
    z,
    M,
    A,
    R,
    I,
    o,
    r,
    B
  ];
}
class Su extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      qu,
      Lu,
      ce,
      {
        name: 1,
        value: 0,
        min: 21,
        max: 22,
        testid: 2,
        mt: 3,
        mr: 4,
        mb: 5,
        ml: 6,
        bordered: 7
      },
      Mu,
      [-1, -1]
    );
  }
  get name() {
    return this.$$.ctx[1];
  }
  set name(e) {
    this.$$set({ name: e }), k();
  }
  get value() {
    return this.$$.ctx[0];
  }
  set value(e) {
    this.$$set({ value: e }), k();
  }
  get min() {
    return this.$$.ctx[21];
  }
  set min(e) {
    this.$$set({ min: e }), k();
  }
  get max() {
    return this.$$.ctx[22];
  }
  set max(e) {
    this.$$set({ max: e }), k();
  }
  get testid() {
    return this.$$.ctx[2];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[3];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[4];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[5];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[6];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get bordered() {
    return this.$$.ctx[7];
  }
  set bordered(e) {
    this.$$set({ bordered: e }), k();
  }
}
customElements.define("goa-calendar", he(Su, { name: {}, value: {}, min: {}, max: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {}, bordered: {} }, [], [], !0));
function Tu(t) {
  _e(t, "svelte-txr655", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}.notification.svelte-txr655.svelte-txr655{display:flex;align-items:stretch;overflow:hidden;font:var(--goa-callout-l-text-size);border:var(--goa-callout-l-border-width) solid;border-radius:var(--goa-callout-border-radius)}h3.svelte-txr655.svelte-txr655{font:var(--goa-callout-l-heading-size);margin-top:var(--goa-space-none);margin-bottom:var(--goa-callout-l-content-gap)}.icon.information.svelte-txr655.svelte-txr655{background-color:var(--goa-callout-info-color-bg-statusbar)}.icon.information.svelte-txr655>.svelte-txr655{fill:var(--fill-color, var(--goa-callout-info-icon-color));color:var(--fill-color, var(--goa-callout-info-icon-color))}.icon.important.svelte-txr655>.svelte-txr655{fill:var(--fill-color, var(--goa-callout-warning-icon-color));color:var(--fill-color, var(--goa-callout-warning-icon-color))}.icon.success.svelte-txr655>.svelte-txr655{fill:var(--fill-color, var(--goa-callout-success-icon-color));color:var(--fill-color, var(--goa-callout-success-icon-color))}.icon.emergency.svelte-txr655>.svelte-txr655{fill:var(--fill-color, var(--goa-callout-emergency-icon-color));color:var(--fill-color, var(--goa-callout-emergency-icon-color))}.icon.event.svelte-txr655>.svelte-txr655{fill:var(--fill-color, var(--goa-callout-event-icon-color));color:var(--fill-color, var(--goa-callout-event-icon-color))}.icon.emergency.svelte-txr655.svelte-txr655{background-color:var(--goa-color-emergency-default)}.icon.important.svelte-txr655.svelte-txr655{background-color:var(--goa-callout-warning-color-bg-statusbar)}.icon.information.svelte-txr655.svelte-txr655{background-color:var(--goa-color-info-default)}.icon.event.svelte-txr655.svelte-txr655{background-color:var(--goa-color-info-default)}.icon.success.svelte-txr655.svelte-txr655{background-color:var(--goa-callout-success-color-bg-statusbar)}.icon.emergency.svelte-txr655.svelte-txr655{background-color:var(--goa-callout-emergency-color-bg-statusbar)}.icon.svelte-txr655.svelte-txr655{text-align:center;padding:var(--goa-callout-l-statusbar-padding)}.content.information.svelte-txr655.svelte-txr655{background-color:var(--goa-callout-info-color-bg-content)}.content.important.svelte-txr655.svelte-txr655{background-color:var(--goa-callout-warning-color-bg-content)}.content.success.svelte-txr655.svelte-txr655{background-color:var(--goa-callout-success-color-bg-content)}.content.emergency.svelte-txr655.svelte-txr655{background-color:var(--goa-callout-emergency-color-bg-content)}.content.svelte-txr655.svelte-txr655{flex:1 1 auto;background-color:var(--goa-color-greyscale-100);padding:var(--goa-callout-l-content-padding)}.notification.information.svelte-txr655.svelte-txr655{border-color:var(--goa-callout-info-border-color)}.notification.important.svelte-txr655.svelte-txr655{border-color:var(--goa-callout-warning-border-color)}.notification.success.svelte-txr655.svelte-txr655{border-color:var(--goa-callout-success-border-color)}.notification.emergency.svelte-txr655.svelte-txr655{border-color:var(--goa-callout-emergency-border-color)}.notification.medium.svelte-txr655.svelte-txr655{font:var(--goa-callout-m-text-size);border-width:var(--goa-callout-m-border-width)}h3.medium.svelte-txr655.svelte-txr655{font:var(--goa-callout-m-heading-size);margin-bottom:var(--goa-callout-m-content-gap)}.notification.medium.svelte-txr655 .content.svelte-txr655{padding:var(--goa-callout-m-content-padding);margin-top:calc(-1 * var(--goa-space-3xs))}.notification.medium.svelte-txr655 .icon.svelte-txr655{padding:var(--goa-callout-m-statusbar-padding)}");
}
function An(t) {
  let e, i;
  return {
    c() {
      e = C("h3"), i = le(
        /*heading*/
        t[5]
      ), f(e, "class", "svelte-txr655"), G(
        e,
        "medium",
        /*isMediumCallout*/
        t[12]
      );
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l & /*heading*/
      32 && pe(
        i,
        /*heading*/
        n[5]
      ), l & /*isMediumCallout*/
      4096 && G(
        e,
        "medium",
        /*isMediumCallout*/
        n[12]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function Pu(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h;
  We(
    /*onwindowresize*/
    t[17]
  );
  let m = (
    /*heading*/
    t[5] && An(t)
  );
  const v = (
    /*#slots*/
    t[16].default
  ), b = oe(
    v,
    t,
    /*$$scope*/
    t[15],
    null
  );
  return {
    c() {
      e = C("div"), i = C("span"), n = C("goa-icon"), o = x(), r = C("span"), m && m.c(), a = x(), b && b.c(), p(
        n,
        "type",
        /*iconType*/
        t[13]
      ), p(
        n,
        "size",
        /*iconSize*/
        t[11]
      ), p(
        n,
        "theme",
        /*icontheme*/
        t[9]
      ), p(n, "class", "svelte-txr655"), f(i, "class", l = "icon " + /*type*/
      t[4] + " svelte-txr655"), f(r, "class", s = "content " + /*type*/
      t[4] + " svelte-txr655"), f(e, "role", "region"), f(e, "style", d = `
    ${be(
        /*mt*/
        t[0],
        /*mr*/
        t[1],
        /*mb*/
        t[2],
        /*ml*/
        t[3]
      )};
    max-width: ${/*maxwidth*/
      t[6]};
  `), f(e, "class", u = "notification " + /*type*/
      t[4] + " svelte-txr655"), f(
        e,
        "data-testid",
        /*testid*/
        t[7]
      ), f(
        e,
        "aria-live",
        /*arialive*/
        t[8]
      ), G(
        e,
        "medium",
        /*isMediumCallout*/
        t[12]
      );
    },
    m(w, y) {
      D(w, e, y), _(e, i), _(i, n), _(e, o), _(e, r), m && m.m(r, null), _(r, a), b && b.m(r, null), c = !0, g || (h = te(
        window,
        "resize",
        /*onwindowresize*/
        t[17]
      ), g = !0);
    },
    p(w, [y]) {
      (!c || y & /*iconType*/
      8192) && p(
        n,
        "type",
        /*iconType*/
        w[13]
      ), (!c || y & /*iconSize*/
      2048) && p(
        n,
        "size",
        /*iconSize*/
        w[11]
      ), (!c || y & /*icontheme*/
      512) && p(
        n,
        "theme",
        /*icontheme*/
        w[9]
      ), (!c || y & /*type*/
      16 && l !== (l = "icon " + /*type*/
      w[4] + " svelte-txr655")) && f(i, "class", l), /*heading*/
      w[5] ? m ? m.p(w, y) : (m = An(w), m.c(), m.m(r, a)) : m && (m.d(1), m = null), b && b.p && (!c || y & /*$$scope*/
      32768) && ae(
        b,
        v,
        w,
        /*$$scope*/
        w[15],
        c ? re(
          v,
          /*$$scope*/
          w[15],
          y,
          null
        ) : se(
          /*$$scope*/
          w[15]
        ),
        null
      ), (!c || y & /*type*/
      16 && s !== (s = "content " + /*type*/
      w[4] + " svelte-txr655")) && f(r, "class", s), (!c || y & /*mt, mr, mb, ml, maxwidth*/
      79 && d !== (d = `
    ${be(
        /*mt*/
        w[0],
        /*mr*/
        w[1],
        /*mb*/
        w[2],
        /*ml*/
        w[3]
      )};
    max-width: ${/*maxwidth*/
      w[6]};
  `)) && f(e, "style", d), (!c || y & /*type*/
      16 && u !== (u = "notification " + /*type*/
      w[4] + " svelte-txr655")) && f(e, "class", u), (!c || y & /*testid*/
      128) && f(
        e,
        "data-testid",
        /*testid*/
        w[7]
      ), (!c || y & /*arialive*/
      256) && f(
        e,
        "aria-live",
        /*arialive*/
        w[8]
      ), (!c || y & /*type, isMediumCallout*/
      4112) && G(
        e,
        "medium",
        /*isMediumCallout*/
        w[12]
      );
    },
    i(w) {
      c || (Y(b, w), c = !0);
    },
    o(w) {
      U(b, w), c = !1;
    },
    d(w) {
      w && P(e), m && m.d(), b && b.d(w), g = !1, h();
    }
  };
}
function Du(t, e, i) {
  let n, l, { $$slots: o = {}, $$scope: r } = e;
  const [a, s] = Me("Callout type", ["emergency", "important", "information", "event", "success"], !0), [d, u] = Me("Callout size", ["medium", "large"]), [c, g] = Me("Aria live", ["off", "assertive", "polite"]);
  let { mt: h = null } = e, { mr: m = null } = e, { mb: v = "l" } = e, { ml: b = null } = e, { size: w = "large" } = e, { type: y } = e, { heading: j = "" } = e, { maxwidth: E = "none" } = e, { testid: M = "" } = e, { arialive: L = "off" } = e, { icontheme: z = "outline" } = e, V = 0, T = "medium";
  ke(() => {
    u(w), g(L), setTimeout(() => {
      s(y), i(11, T = n ? "small" : "medium");
    });
  });
  function S() {
    i(10, V = window.innerWidth);
  }
  return t.$$set = (A) => {
    "mt" in A && i(0, h = A.mt), "mr" in A && i(1, m = A.mr), "mb" in A && i(2, v = A.mb), "ml" in A && i(3, b = A.ml), "size" in A && i(14, w = A.size), "type" in A && i(4, y = A.type), "heading" in A && i(5, j = A.heading), "maxwidth" in A && i(6, E = A.maxwidth), "testid" in A && i(7, M = A.testid), "arialive" in A && i(8, L = A.arialive), "icontheme" in A && i(9, z = A.icontheme), "$$scope" in A && i(15, r = A.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*screenSize, size*/
    17408 && i(12, n = V < gi || w === "medium"), t.$$.dirty & /*type*/
    16 && i(13, l = y === "emergency" ? "warning" : y === "important" ? "alert-circle" : y === "information" ? "information-circle" : y === "success" ? "checkmark-circle" : y === "event" ? "calendar" : "");
  }, [
    h,
    m,
    v,
    b,
    y,
    j,
    E,
    M,
    L,
    z,
    V,
    T,
    n,
    l,
    w,
    r,
    o,
    S
  ];
}
class Hu extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Du,
      Pu,
      ce,
      {
        mt: 0,
        mr: 1,
        mb: 2,
        ml: 3,
        size: 14,
        type: 4,
        heading: 5,
        maxwidth: 6,
        testid: 7,
        arialive: 8,
        icontheme: 9
      },
      Tu
    );
  }
  get mt() {
    return this.$$.ctx[0];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[1];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[2];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[3];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get size() {
    return this.$$.ctx[14];
  }
  set size(e) {
    this.$$set({ size: e }), k();
  }
  get type() {
    return this.$$.ctx[4];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get heading() {
    return this.$$.ctx[5];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get maxwidth() {
    return this.$$.ctx[6];
  }
  set maxwidth(e) {
    this.$$set({ maxwidth: e }), k();
  }
  get testid() {
    return this.$$.ctx[7];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get arialive() {
    return this.$$.ctx[8];
  }
  set arialive(e) {
    this.$$set({ arialive: e }), k();
  }
  get icontheme() {
    return this.$$.ctx[9];
  }
  set icontheme(e) {
    this.$$set({ icontheme: e }), k();
  }
}
customElements.define("goa-callout", he(Hu, { mt: {}, mr: {}, mb: {}, ml: {}, size: {}, type: {}, heading: {}, maxwidth: {}, testid: {}, arialive: {}, icontheme: {} }, ["default"], [], !0));
function Ou(t) {
  let e, i, n;
  const l = (
    /*#slots*/
    t[1].default
  ), o = oe(
    l,
    t,
    /*$$scope*/
    t[0],
    null
  );
  return {
    c() {
      e = C("goa-card-content"), i = C("goa-button-group"), o && o.c(), p(i, "alignment", "end");
    },
    m(r, a) {
      D(r, e, a), _(e, i), o && o.m(i, null), n = !0;
    },
    p(r, [a]) {
      o && o.p && (!n || a & /*$$scope*/
      1) && ae(
        o,
        l,
        r,
        /*$$scope*/
        r[0],
        n ? re(
          l,
          /*$$scope*/
          r[0],
          a,
          null
        ) : se(
          /*$$scope*/
          r[0]
        ),
        null
      );
    },
    i(r) {
      n || (Y(o, r), n = !0);
    },
    o(r) {
      U(o, r), n = !1;
    },
    d(r) {
      r && P(e), o && o.d(r);
    }
  };
}
function Fu(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e;
  return t.$$set = (o) => {
    "$$scope" in o && i(0, l = o.$$scope);
  }, [l, n];
}
class Au extends me {
  constructor(e) {
    super(), ge(this, e, Fu, Ou, ce, {});
  }
}
customElements.define("goa-card-actions", he(Au, {}, ["default"], [], !0));
function Vu(t) {
  _e(t, "svelte-1r6ywx6", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}.card-content.svelte-1r6ywx6{padding:1rem}");
}
function Iu(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[1].default
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[0],
    null
  );
  return {
    c() {
      e = C("div"), l && l.c(), f(e, "class", "card-content svelte-1r6ywx6");
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null), i = !0;
    },
    p(o, [r]) {
      l && l.p && (!i || r & /*$$scope*/
      1) && ae(
        l,
        n,
        o,
        /*$$scope*/
        o[0],
        i ? re(
          n,
          /*$$scope*/
          o[0],
          r,
          null
        ) : se(
          /*$$scope*/
          o[0]
        ),
        null
      );
    },
    i(o) {
      i || (Y(l, o), i = !0);
    },
    o(o) {
      U(l, o), i = !1;
    },
    d(o) {
      o && P(e), l && l.d(o);
    }
  };
}
function xu(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e;
  return t.$$set = (o) => {
    "$$scope" in o && i(0, l = o.$$scope);
  }, [l, n];
}
class Bu extends me {
  constructor(e) {
    super(), ge(this, e, xu, Iu, ce, {}, Vu);
  }
}
customElements.define("goa-card-content", he(Bu, {}, ["default"], [], !0));
function Nu(t) {
  _e(t, "svelte-2vgflm", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}#container.svelte-2vgflm{container:self / inline-size}.card.svelte-2vgflm{background-color:var(--goa-color-greyscale-white);border-radius:4px;overflow:hidden;height:var(--height)}@container self (min-width: 624px){.card.svelte-2vgflm{margin:0 auto}}");
}
function Wu(t) {
  let e, i, n, l;
  const o = (
    /*#slots*/
    t[9].default
  ), r = oe(
    o,
    t,
    /*$$scope*/
    t[8],
    null
  );
  return {
    c() {
      e = C("div"), i = C("div"), r && r.c(), f(
        i,
        "data-testid",
        /*testid*/
        t[7]
      ), f(i, "class", "card svelte-2vgflm"), f(i, "style", n = "--width: " + /*width*/
      t[1] + "; --height: " + /*height*/
      (t[2] === "auto" ? "auto" : "100%") + "; " + be(
        /*mt*/
        t[3],
        /*mr*/
        t[4],
        /*mb*/
        t[5],
        /*ml*/
        t[6]
      ) + " " + /*elevation*/
      (t[0] === 0 ? "border: 1px solid var(--goa-color-greyscale-200);" : `box-shadow: var(--shadow-${/*elevation*/
      t[0]});`)), f(e, "id", "container"), f(e, "class", "svelte-2vgflm");
    },
    m(a, s) {
      D(a, e, s), _(e, i), r && r.m(i, null), l = !0;
    },
    p(a, [s]) {
      r && r.p && (!l || s & /*$$scope*/
      256) && ae(
        r,
        o,
        a,
        /*$$scope*/
        a[8],
        l ? re(
          o,
          /*$$scope*/
          a[8],
          s,
          null
        ) : se(
          /*$$scope*/
          a[8]
        ),
        null
      ), (!l || s & /*testid*/
      128) && f(
        i,
        "data-testid",
        /*testid*/
        a[7]
      ), (!l || s & /*width, height, mt, mr, mb, ml, elevation*/
      127 && n !== (n = "--width: " + /*width*/
      a[1] + "; --height: " + /*height*/
      (a[2] === "auto" ? "auto" : "100%") + "; " + be(
        /*mt*/
        a[3],
        /*mr*/
        a[4],
        /*mb*/
        a[5],
        /*ml*/
        a[6]
      ) + " " + /*elevation*/
      (a[0] === 0 ? "border: 1px solid var(--goa-color-greyscale-200);" : `box-shadow: var(--shadow-${/*elevation*/
      a[0]});`))) && f(i, "style", n);
    },
    i(a) {
      l || (Y(r, a), l = !0);
    },
    o(a) {
      U(r, a), l = !1;
    },
    d(a) {
      a && P(e), r && r.d(a);
    }
  };
}
function Ru(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { elevation: o = 0 } = e, { width: r = "100%" } = e, { height: a = "auto" } = e, { mt: s = null } = e, { mr: d = null } = e, { mb: u = null } = e, { ml: c = null } = e, { testid: g = "" } = e;
  return t.$$set = (h) => {
    "elevation" in h && i(0, o = h.elevation), "width" in h && i(1, r = h.width), "height" in h && i(2, a = h.height), "mt" in h && i(3, s = h.mt), "mr" in h && i(4, d = h.mr), "mb" in h && i(5, u = h.mb), "ml" in h && i(6, c = h.ml), "testid" in h && i(7, g = h.testid), "$$scope" in h && i(8, l = h.$$scope);
  }, [o, r, a, s, d, u, c, g, l, n];
}
class Yu extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Ru,
      Wu,
      ce,
      {
        elevation: 0,
        width: 1,
        height: 2,
        mt: 3,
        mr: 4,
        mb: 5,
        ml: 6,
        testid: 7
      },
      Nu
    );
  }
  get elevation() {
    return this.$$.ctx[0];
  }
  set elevation(e) {
    this.$$set({ elevation: e }), k();
  }
  get width() {
    return this.$$.ctx[1];
  }
  set width(e) {
    this.$$set({ width: e }), k();
  }
  get height() {
    return this.$$.ctx[2];
  }
  set height(e) {
    this.$$set({ height: e }), k();
  }
  get mt() {
    return this.$$.ctx[3];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[4];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[5];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[6];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get testid() {
    return this.$$.ctx[7];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-card", he(Yu, { elevation: {}, width: {}, height: {}, mt: {}, mr: {}, mb: {}, ml: {}, testid: {} }, ["default"], [], !0));
function Zu(t) {
  _e(t, "svelte-i7mj8i", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}.card-group.svelte-i7mj8i{display:flex;flex-wrap:wrap;justify-content:space-around;gap:1rem;width:100%}");
}
function Uu(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[1].default
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[0],
    null
  );
  return {
    c() {
      e = C("div"), l && l.c(), f(e, "class", "card-group svelte-i7mj8i");
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null), i = !0;
    },
    p(o, [r]) {
      l && l.p && (!i || r & /*$$scope*/
      1) && ae(
        l,
        n,
        o,
        /*$$scope*/
        o[0],
        i ? re(
          n,
          /*$$scope*/
          o[0],
          r,
          null
        ) : se(
          /*$$scope*/
          o[0]
        ),
        null
      );
    },
    i(o) {
      i || (Y(l, o), i = !0);
    },
    o(o) {
      U(l, o), i = !1;
    },
    d(o) {
      o && P(e), l && l.d(o);
    }
  };
}
function Gu(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e;
  return t.$$set = (o) => {
    "$$scope" in o && i(0, l = o.$$scope);
  }, [l, n];
}
class Ku extends me {
  constructor(e) {
    super(), ge(this, e, Gu, Uu, ce, {}, Zu);
  }
}
customElements.define("goa-card-group", he(Ku, {}, ["default"], [], !0));
function Xu(t) {
  _e(t, "svelte-1fm1ezr", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}");
}
function Ju(t) {
  let e;
  return {
    c() {
      e = C("div"), f(e, "style", `
    background-image: url({src}); 
    height: {height}; 
    background-size: cover; 
    background-position: center;
  `);
    },
    m(i, n) {
      D(i, e, n);
    },
    p: ve,
    i: ve,
    o: ve,
    d(i) {
      i && P(e);
    }
  };
}
function Qu(t, e, i) {
  let { src: n } = e, { height: l = "100%" } = e;
  return t.$$set = (o) => {
    "src" in o && i(0, n = o.src), "height" in o && i(1, l = o.height);
  }, [n, l];
}
class $u extends me {
  constructor(e) {
    super(), ge(this, e, Qu, Ju, ce, { src: 0, height: 1 }, Xu);
  }
  get src() {
    return this.$$.ctx[0];
  }
  set src(e) {
    this.$$set({ src: e }), k();
  }
  get height() {
    return this.$$.ctx[1];
  }
  set height(e) {
    this.$$set({ height: e }), k();
  }
}
customElements.define("goa-card-image", he($u, { src: {}, height: {} }, [], [], !0));
const Yt = "_stateChange", Fr = "form::reset:errors", mi = "form::reset:form", Ar = "form::bind", Wi = "form::toggle:active", Ri = "form::set:fieldset", Ht = "form::dispatch:state", Vr = "form::edit", Ir = "subform::bind", ed = "subform::indexContinueToParent", xr = "subform::indexContinueToSubForm", ut = "fieldset::reset:errors", zi = "fieldset::reset:fields", Br = "fieldset::submit", Nr = "form-page:continue", vi = "form-page:back", Wr = "form=page::bind", It = "fieldset::bind", dt = "fieldset::set:error", bi = "fieldset::change", bt = "fieldset::set:value", Rr = "form-item::bind", td = "external::alter:state", Di = "external::continue", id = "external::set:error", Yr = "external::init:state", Qe = "form-field::bind", Zr = "form-summary::bind", Ur = "form-summary::edit:page";
function nd(t) {
  _e(t, "svelte-1c13hou", ':host{box-sizing:border-box;font-family:var(--goa-font-family-sans);display:block}.root.svelte-1c13hou.svelte-1c13hou{display:block;height:auto;min-height:0;padding:0}input[type="checkbox"].svelte-1c13hou.svelte-1c13hou{position:absolute;opacity:0;transform:scale(0);margin:0;cursor:pointer}input[type="checkbox"][disabled].svelte-1c13hou.svelte-1c13hou:hover{cursor:default}label.svelte-1c13hou.svelte-1c13hou{display:flex;cursor:pointer}label.svelte-1c13hou:hover .container.svelte-1c13hou{border:var(--goa-checkbox-border-hover)}label.svelte-1c13hou:hover .container.selected.svelte-1c13hou{background-color:var(--goa-checkbox-color-bg-checked-hover);border:none}.text.svelte-1c13hou.svelte-1c13hou{padding-left:var(--goa-checkbox-gap);-webkit-user-select:none;-moz-user-select:none;user-select:none;font:var(--goa-checkbox-label-font-size);color:var(--goa-checkbox-color-label)}.description.svelte-1c13hou.svelte-1c13hou{font:var(--goa-checkbox-description-font-size);margin-left:var(--goa-space-xl);margin-top:var(--goa-space-2xs)}.reveal.svelte-1c13hou.svelte-1c13hou{display:none;height:0}.reveal.visible.svelte-1c13hou.svelte-1c13hou{border-left:4px solid var(--goa-color-greyscale-200);padding:var(--goa-space-m);margin:var(--goa-space-2xs) 0 0 calc(var(--goa-space-s) - 2px);display:block;height:-moz-fit-content;height:fit-content}.container.svelte-1c13hou.svelte-1c13hou{box-sizing:border-box;border:var(--goa-checkbox-border);border-radius:var(--goa-checkbox-border-radius);background-color:var(--goa-checkbox-color-bg);height:var(--goa-checkbox-size);width:var(--goa-checkbox-size);margin-top:3px;display:flex;justify-content:center;flex:0 0 auto}.container.svelte-1c13hou.svelte-1c13hou:hover{border:var(--goa-checkbox-border-hover)}.container.svelte-1c13hou svg.svelte-1c13hou{fill:var(--goa-checkbox-color-bg);margin:3px}.container.selected.svelte-1c13hou.svelte-1c13hou{background-color:var(--goa-checkbox-color-bg-checked);border:none}.container.selected.svelte-1c13hou.svelte-1c13hou:hover{background-color:var(--goa-checkbox-color-bg-checked-hover)}.error.svelte-1c13hou .container.svelte-1c13hou,.error.svelte-1c13hou .container.svelte-1c13hou:hover{border:var(--goa-checkbox-border-error);background-color:var(--goa-checkbox-color-bg);box-shadow:none}.error.svelte-1c13hou .container.selected.svelte-1c13hou,.error.svelte-1c13hou .container.selected.svelte-1c13hou:hover{border:var(--goa-checkbox-border-error);background-color:var(--goa-checkbox-color-bg)}label:hover.error.svelte-1c13hou .container.svelte-1c13hou{border:var(--goa-checkbox-border-error)}label:hover.error.svelte-1c13hou .container.selected.svelte-1c13hou{border:var(--goa-checkbox-border-error);background-color:var(--goa-checkbox-color-bg)}.error.svelte-1c13hou .container svg.svelte-1c13hou{fill:var(--goa-checkbox-color-bg-checked-error);margin:1px}.error.svelte-1c13hou .container.svelte-1c13hou:has(:focus-visible){outline:none;box-shadow:0 0 0 3px var(--goa-color-interactive-focus)}.error.svelte-1c13hou .container.svelte-1c13hou:has(:focus-visible):hover{outline:none;border:var(--goa-checkbox-border-error)}.error.svelte-1c13hou .container.selected.svelte-1c13hou:has(:focus-visible):hover{outline:none;border:none;background-color:var(--goa-checkbox-color-bg)}label:hover.error.svelte-1c13hou .container.selected.svelte-1c13hou:has(:focus-visible){outline:none;border:var(--goa-checkbox-border-error);background-color:var(--goa-checkbox-color-bg)}label:hover.error.svelte-1c13hou .container.svelte-1c13hou:has(:focus-visible){outline:none;border:var(--goa-checkbox-border-error)}.container.svelte-1c13hou.svelte-1c13hou:has(:focus-visible){outline:none;box-shadow:0 0 0 3px var(--goa-color-interactive-focus)}.container.svelte-1c13hou.svelte-1c13hou:has(:focus-visible):hover{outline:none;border:var(--goa-checkbox-border)}.container.selected.svelte-1c13hou.svelte-1c13hou:has(:focus-visible):hover{outline:none;border:none;background-color:var(--goa-checkbox-color-bg-checked)}label.svelte-1c13hou:hover .container.selected.svelte-1c13hou:has(:focus-visible){outline:none;border:none;background-color:var(--goa-checkbox-color-bg-checked)}label.svelte-1c13hou:hover .container.svelte-1c13hou:has(:focus-visible){outline:none;border:var(--goa-checkbox-border)}.disabled.svelte-1c13hou.svelte-1c13hou{cursor:default}.disabled.svelte-1c13hou .text.svelte-1c13hou{color:var(--goa-checkbox-color-label-disabled)}label.disabled.svelte-1c13hou+.description.svelte-1c13hou{color:var(--goa-checkbox-color-label-disabled);cursor:default}.disabled.svelte-1c13hou:not(.error) .container.svelte-1c13hou{border:var(--goa-checkbox-border-disabled);box-shadow:none}.disabled.svelte-1c13hou:not(.error) .container.selected.svelte-1c13hou{border:none;background-color:var(--goa-checkbox-color-bg-checked-disabled)}.disabled.error.svelte-1c13hou .container.selected.svelte-1c13hou{border:var(--goa-checkbox-border-disabled-error)}.disabled.error.svelte-1c13hou .container.svelte-1c13hou{border:var(--goa-checkbox-border-disabled-error)}label:hover.disabled.error.svelte-1c13hou .container.svelte-1c13hou{border:var(--goa-checkbox-border-disabled-error)}.disabled.error.svelte-1c13hou .container svg.svelte-1c13hou{fill:#F58185}');
}
const ld = (t) => ({}), Vn = (t) => ({}), od = (t) => ({}), In = (t) => ({});
function rd(t) {
  let e, i;
  return {
    c() {
      e = kt("svg"), i = kt("path"), f(i, "d", "M5.09,9.64,1.27,5.82,0,7.09l5.09,5.09L16,1.27,14.73,0Z"), f(e, "id", "checkmark"), f(e, "data-testid", "checkmark"), f(e, "xmlns", "http://www.w3.org/2000/svg"), f(e, "viewBox", "0 0 16 12.18"), f(e, "class", "svelte-1c13hou");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    d(n) {
      n && P(e);
    }
  };
}
function ad(t) {
  let e, i;
  return {
    c() {
      e = kt("svg"), i = kt("rect"), f(i, "width", "15"), f(i, "height", "2"), f(e, "id", "dashmark"), f(e, "data-testid", "dashmark"), f(e, "xmlns", "http://www.w3.org/2000/svg"), f(e, "viewBox", "0 0 15 2"), f(e, "class", "svelte-1c13hou");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    d(n) {
      n && P(e);
    }
  };
}
function xn(t) {
  let e, i, n, l;
  const o = (
    /*#slots*/
    t[27].description
  ), r = oe(
    o,
    t,
    /*$$scope*/
    t[26],
    In
  );
  return {
    c() {
      e = C("div"), r && r.c(), i = x(), n = le(
        /*description*/
        t[5]
      ), f(e, "class", "description svelte-1c13hou"), f(
        e,
        "id",
        /*_descriptionId*/
        t[15]
      ), f(e, "data-testid", "description");
    },
    m(a, s) {
      D(a, e, s), r && r.m(e, null), _(e, i), _(e, n), l = !0;
    },
    p(a, s) {
      r && r.p && (!l || s[0] & /*$$scope*/
      67108864) && ae(
        r,
        o,
        a,
        /*$$scope*/
        a[26],
        l ? re(
          o,
          /*$$scope*/
          a[26],
          s,
          od
        ) : se(
          /*$$scope*/
          a[26]
        ),
        In
      ), (!l || s[0] & /*description*/
      32) && pe(
        n,
        /*description*/
        a[5]
      ), (!l || s[0] & /*_descriptionId*/
      32768) && f(
        e,
        "id",
        /*_descriptionId*/
        a[15]
      );
    },
    i(a) {
      l || (Y(r, a), l = !0);
    },
    o(a) {
      U(r, a), l = !1;
    },
    d(a) {
      a && P(e), r && r.d(a);
    }
  };
}
function sd(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v, b, w, y, j, E;
  function M(I, B) {
    if (
      /*isIndeterminate*/
      I[17]
    ) return ad;
    if (
      /*isChecked*/
      I[16]
    ) return rd;
  }
  let L = M(t), z = L && L(t);
  const V = (
    /*#slots*/
    t[27].default
  ), T = oe(
    V,
    t,
    /*$$scope*/
    t[26],
    null
  );
  let S = (
    /*$$slots*/
    (t[21].description || /*description*/
    t[5]) && xn(t)
  );
  const A = (
    /*#slots*/
    t[27].reveal
  ), R = oe(
    A,
    t,
    /*$$scope*/
    t[26],
    Vn
  );
  return {
    c() {
      e = C("div"), i = C("label"), n = C("div"), l = C("input"), d = x(), z && z.c(), u = x(), c = C("div"), T && T.c(), g = x(), h = le(
        /*text*/
        t[2]
      ), m = x(), S && S.c(), v = x(), b = C("div"), R && R.c(), f(
        l,
        "id",
        /*name*/
        t[1]
      ), f(
        l,
        "name",
        /*name*/
        t[1]
      ), l.checked = /*isChecked*/
      t[16], l.disabled = /*isDisabled*/
      t[18], f(l, "type", "checkbox"), l.value = o = `${/*value*/
      t[0]}`, f(l, "aria-label", r = /*arialabel*/
      t[4] || /*text*/
      t[2] || /*name*/
      t[1]), f(l, "aria-describedby", a = /*description*/
      t[5] ? (
        /*_descriptionId*/
        t[15]
      ) : null), f(l, "aria-invalid", s = /*_error*/
      t[12] ? "true" : "false"), f(l, "class", "svelte-1c13hou"), f(n, "class", "container svelte-1c13hou"), G(
        n,
        "selected",
        /*isChecked*/
        t[16]
      ), f(c, "class", "text svelte-1c13hou"), f(c, "data-testid", "text"), f(
        i,
        "data-testid",
        /*testid*/
        t[3]
      ), f(
        i,
        "for",
        /*name*/
        t[1]
      ), f(i, "class", "svelte-1c13hou"), G(
        i,
        "disabled",
        /*isDisabled*/
        t[18]
      ), G(
        i,
        "error",
        /*_error*/
        t[12]
      ), f(b, "class", "reveal svelte-1c13hou"), G(
        b,
        "visible",
        /*$$slots*/
        t[21].reveal && /*isChecked*/
        t[16]
      ), f(e, "class", "root svelte-1c13hou"), f(e, "style", w = `
    ${be(
        /*mt*/
        t[7],
        /*mr*/
        t[8],
        /*mb*/
        t[9],
        /*ml*/
        t[10]
      )}
    max-width: ${/*maxwidth*/
      t[6]};
  `);
    },
    m(I, B) {
      D(I, e, B), _(e, i), _(i, n), _(n, l), t[28](l), _(n, d), z && z.m(n, null), _(i, u), _(i, c), T && T.m(c, null), _(c, g), _(c, h), _(e, m), S && S.m(e, null), _(e, v), _(e, b), R && R.m(b, null), t[29](b), t[30](e), y = !0, j || (E = [
        te(
          l,
          "change",
          /*onChange*/
          t[19]
        ),
        te(
          l,
          "focus",
          /*onFocus*/
          t[20]
        )
      ], j = !0);
    },
    p(I, B) {
      (!y || B[0] & /*name*/
      2) && f(
        l,
        "id",
        /*name*/
        I[1]
      ), (!y || B[0] & /*name*/
      2) && f(
        l,
        "name",
        /*name*/
        I[1]
      ), (!y || B[0] & /*isChecked*/
      65536) && (l.checked = /*isChecked*/
      I[16]), (!y || B[0] & /*isDisabled*/
      262144) && (l.disabled = /*isDisabled*/
      I[18]), (!y || B[0] & /*value*/
      1 && o !== (o = `${/*value*/
      I[0]}`)) && (l.value = o), (!y || B[0] & /*arialabel, text, name*/
      22 && r !== (r = /*arialabel*/
      I[4] || /*text*/
      I[2] || /*name*/
      I[1])) && f(l, "aria-label", r), (!y || B[0] & /*description, _descriptionId*/
      32800 && a !== (a = /*description*/
      I[5] ? (
        /*_descriptionId*/
        I[15]
      ) : null)) && f(l, "aria-describedby", a), (!y || B[0] & /*_error*/
      4096 && s !== (s = /*_error*/
      I[12] ? "true" : "false")) && f(l, "aria-invalid", s), L !== (L = M(I)) && (z && z.d(1), z = L && L(I), z && (z.c(), z.m(n, null))), (!y || B[0] & /*isChecked*/
      65536) && G(
        n,
        "selected",
        /*isChecked*/
        I[16]
      ), T && T.p && (!y || B[0] & /*$$scope*/
      67108864) && ae(
        T,
        V,
        I,
        /*$$scope*/
        I[26],
        y ? re(
          V,
          /*$$scope*/
          I[26],
          B,
          null
        ) : se(
          /*$$scope*/
          I[26]
        ),
        null
      ), (!y || B[0] & /*text*/
      4) && pe(
        h,
        /*text*/
        I[2]
      ), (!y || B[0] & /*testid*/
      8) && f(
        i,
        "data-testid",
        /*testid*/
        I[3]
      ), (!y || B[0] & /*name*/
      2) && f(
        i,
        "for",
        /*name*/
        I[1]
      ), (!y || B[0] & /*isDisabled*/
      262144) && G(
        i,
        "disabled",
        /*isDisabled*/
        I[18]
      ), (!y || B[0] & /*_error*/
      4096) && G(
        i,
        "error",
        /*_error*/
        I[12]
      ), /*$$slots*/
      I[21].description || /*description*/
      I[5] ? S ? (S.p(I, B), B[0] & /*$$slots, description*/
      2097184 && Y(S, 1)) : (S = xn(I), S.c(), Y(S, 1), S.m(e, v)) : S && (Oe(), U(S, 1, 1, () => {
        S = null;
      }), Fe()), R && R.p && (!y || B[0] & /*$$scope*/
      67108864) && ae(
        R,
        A,
        I,
        /*$$scope*/
        I[26],
        y ? re(
          A,
          /*$$scope*/
          I[26],
          B,
          ld
        ) : se(
          /*$$scope*/
          I[26]
        ),
        Vn
      ), (!y || B[0] & /*$$slots, isChecked*/
      2162688) && G(
        b,
        "visible",
        /*$$slots*/
        I[21].reveal && /*isChecked*/
        I[16]
      ), (!y || B[0] & /*mt, mr, mb, ml, maxwidth*/
      1984 && w !== (w = `
    ${be(
        /*mt*/
        I[7],
        /*mr*/
        I[8],
        /*mb*/
        I[9],
        /*ml*/
        I[10]
      )}
    max-width: ${/*maxwidth*/
      I[6]};
  `)) && f(e, "style", w);
    },
    i(I) {
      y || (Y(T, I), Y(S), Y(R, I), y = !0);
    },
    o(I) {
      U(T, I), U(S), U(R, I), y = !1;
    },
    d(I) {
      I && P(e), t[28](null), z && z.d(), T && T.d(I), S && S.d(), R && R.d(I), t[29](null), t[30](null), j = !1, He(E);
    }
  };
}
function ud(t, e, i) {
  let n, l, o, { $$slots: r = {}, $$scope: a } = e;
  const s = pt(r);
  let { name: d } = e, { checked: u = "false" } = e, { text: c = "" } = e, { value: g = "" } = e, { disabled: h = "false" } = e, { error: m = "false" } = e, { testid: v = "" } = e, { arialabel: b = "" } = e, { description: w = "" } = e, { maxwidth: y = "none" } = e, { mt: j = null } = e, { mr: E = null } = e, { mb: M = "m" } = e, { ml: L = null } = e, z, V, T = [], S, A, R, I, B;
  ke(() => {
    z = g, i(15, R = `description_${d}`), N(), q(), $();
  });
  function N() {
    Re(V, (ie, J) => {
      switch (ie) {
        case bt:
          K(J);
          break;
        case dt:
          F(J);
          break;
        case ut:
          i(23, m = "false");
          break;
        case Qe:
          O(J);
          break;
      }
    });
  }
  function F(ie) {
    i(23, m = ie.error ? "true" : "false");
  }
  function q() {
    Re(S, (ie, J) => {
      switch (ie) {
        case Qe:
          H(J);
          break;
      }
    });
  }
  function H(ie) {
    setTimeout(
      () => {
        i(22, u = !u && !!ie.el.value);
      },
      1e3
    );
  }
  function O(ie) {
    s.reveal && ie.name === d && (T = [...T, ie.el]);
  }
  function W() {
    for (const ie of T)
      je(ie, zi);
  }
  function K(ie) {
    i(0, g = ie.value), i(22, u = ie.value ? "true" : "false"), qe(A, "_change", { name: d, value: g }, { bubbles: !0 });
  }
  function $() {
    d && je(V, Qe, { name: d, el: V }, { bubbles: !0, timeout: 10 });
  }
  function ye(ie) {
    var fe;
    A.focus();
    const J = !l, De = J ? `${z || "checked"}` : "";
    i(22, u = vt(J)), (fe = ie.target) == null || fe.dispatchEvent(new CustomEvent(
      "_change",
      {
        composed: !0,
        detail: {
          name: d,
          checked: J,
          value: De
        },
        bubbles: !0
      }
    )), s.reveal && !J && W();
  }
  function Z() {
    qe(V, "help-text::announce", void 0, { bubbles: !0 });
  }
  function Q(ie) {
    ue[ie ? "unshift" : "push"](() => {
      A = ie, i(14, A);
    });
  }
  function X(ie) {
    ue[ie ? "unshift" : "push"](() => {
      S = ie, i(13, S);
    });
  }
  function ee(ie) {
    ue[ie ? "unshift" : "push"](() => {
      V = ie, i(11, V);
    });
  }
  return t.$$set = (ie) => {
    "name" in ie && i(1, d = ie.name), "checked" in ie && i(22, u = ie.checked), "text" in ie && i(2, c = ie.text), "value" in ie && i(0, g = ie.value), "disabled" in ie && i(24, h = ie.disabled), "error" in ie && i(23, m = ie.error), "testid" in ie && i(3, v = ie.testid), "arialabel" in ie && i(4, b = ie.arialabel), "description" in ie && i(5, w = ie.description), "maxwidth" in ie && i(6, y = ie.maxwidth), "mt" in ie && i(7, j = ie.mt), "mr" in ie && i(8, E = ie.mr), "mb" in ie && i(9, M = ie.mb), "ml" in ie && i(10, L = ie.ml), "$$scope" in ie && i(26, a = ie.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*disabled*/
    16777216 && i(18, n = Ce(h)), t.$$.dirty[0] & /*error, _error, _prevError, _rootEl*/
    41949184 && (i(12, I = Ce(m)), I !== B && (qe(V, "error::change", { isError: I }, { bubbles: !0 }), i(25, B = I))), t.$$.dirty[0] & /*checked*/
    4194304 && i(16, l = Ce(u));
  }, i(17, o = !1), [
    g,
    d,
    c,
    v,
    b,
    w,
    y,
    j,
    E,
    M,
    L,
    V,
    I,
    S,
    A,
    R,
    l,
    o,
    n,
    ye,
    Z,
    s,
    u,
    m,
    h,
    B,
    a,
    r,
    Q,
    X,
    ee
  ];
}
class dd extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      ud,
      sd,
      ce,
      {
        name: 1,
        checked: 22,
        text: 2,
        value: 0,
        disabled: 24,
        error: 23,
        testid: 3,
        arialabel: 4,
        description: 5,
        maxwidth: 6,
        mt: 7,
        mr: 8,
        mb: 9,
        ml: 10
      },
      nd,
      [-1, -1]
    );
  }
  get name() {
    return this.$$.ctx[1];
  }
  set name(e) {
    this.$$set({ name: e }), k();
  }
  get checked() {
    return this.$$.ctx[22];
  }
  set checked(e) {
    this.$$set({ checked: e }), k();
  }
  get text() {
    return this.$$.ctx[2];
  }
  set text(e) {
    this.$$set({ text: e }), k();
  }
  get value() {
    return this.$$.ctx[0];
  }
  set value(e) {
    this.$$set({ value: e }), k();
  }
  get disabled() {
    return this.$$.ctx[24];
  }
  set disabled(e) {
    this.$$set({ disabled: e }), k();
  }
  get error() {
    return this.$$.ctx[23];
  }
  set error(e) {
    this.$$set({ error: e }), k();
  }
  get testid() {
    return this.$$.ctx[3];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get arialabel() {
    return this.$$.ctx[4];
  }
  set arialabel(e) {
    this.$$set({ arialabel: e }), k();
  }
  get description() {
    return this.$$.ctx[5];
  }
  set description(e) {
    this.$$set({ description: e }), k();
  }
  get maxwidth() {
    return this.$$.ctx[6];
  }
  set maxwidth(e) {
    this.$$set({ maxwidth: e }), k();
  }
  get mt() {
    return this.$$.ctx[7];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[8];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[9];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[10];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-checkbox", he(dd, { name: {}, checked: {}, text: {}, value: {}, disabled: {}, error: {}, testid: {}, arialabel: {}, description: {}, maxwidth: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default", "description", "reveal"], [], !0));
function cd(t) {
  _e(t, "svelte-vpqbh0", `.leading-icon.svelte-vpqbh0{margin-left:-0.25rem}.chip.svelte-vpqbh0{vertical-align:middle;align-items:center;background-color:var(--goa-color-greyscale-white);border-radius:1rem;border:var(--goa-border-width-s) solid var(--goa-color-greyscale-500);box-sizing:border-box;color:var(--goa-color-text-default);display:inline-flex;flex-direction:row;font-size:var(--goa-font-size-3);font-weight:var(--goa-font-weight-regular);gap:0.25rem;min-height:2rem;justify-content:center;padding:0 0.75rem;cursor:default;white-space:normal;word-wrap:break-word}.text.svelte-vpqbh0{padding-bottom:var(
      --font-valign-fix,
      0
    )}.chip.svelte-vpqbh0:focus{outline:var(--goa-border-width-m) solid var(--goa-color-interactive-focus);background-color:var(--goa-color-greyscale-white)}.chip.svelte-vpqbh0:hover{background-color:var(--goa-color-greyscale-200)}.deletable.svelte-vpqbh0{cursor:pointer}.delete-icon.svelte-vpqbh0{margin-right:-0.25rem}.error.svelte-vpqbh0,.error.svelte-vpqbh0:hover{background-color:var(--goa-color-emergency-light)}`);
}
function Bn(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "class", "leading-icon svelte-vpqbh0"), p(e, "size", "medium"), p(
        e,
        "type",
        /*leadingicon*/
        t[4]
      ), p(
        e,
        "theme",
        /*icontheme*/
        t[5]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*leadingicon*/
      16 && p(
        e,
        "type",
        /*leadingicon*/
        i[4]
      ), n & /*icontheme*/
      32 && p(
        e,
        "theme",
        /*icontheme*/
        i[5]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function Nn(t) {
  let e, i, n;
  return {
    c() {
      e = C("goa-icon"), p(e, "class", "delete-icon svelte-vpqbh0"), p(e, "size", "medium"), p(e, "theme", "filled"), p(e, "type", "close-circle"), p(e, "fillcolor", i = /*_error*/
      t[11] ? "var(--goa-color-emergency-default)" : (
        /*_hovering*/
        t[10] ? "var(--goa-color-interactive-hover)" : "var(--goa-color-greyscale-700)"
      )), p(e, "opacity", n = /*_error*/
      t[11] ? (
        /*_hovering*/
        t[10] ? 1 : 0.5
      ) : 1);
    },
    m(l, o) {
      D(l, e, o);
    },
    p(l, o) {
      o & /*_error, _hovering*/
      3072 && i !== (i = /*_error*/
      l[11] ? "var(--goa-color-emergency-default)" : (
        /*_hovering*/
        l[10] ? "var(--goa-color-interactive-hover)" : "var(--goa-color-greyscale-700)"
      )) && p(e, "fillcolor", i), o & /*_error, _hovering*/
      3072 && n !== (n = /*_error*/
      l[11] ? (
        /*_hovering*/
        l[10] ? 1 : 0.5
      ) : 1) && p(e, "opacity", n);
    },
    d(l) {
      l && P(e);
    }
  };
}
function fd(t) {
  let e, i, n, l, o, r, a, s, d = (
    /*leadingicon*/
    t[4] && Bn(t)
  ), u = (
    /*_deletable*/
    t[12] && Nn(t)
  );
  return {
    c() {
      e = C("div"), d && d.c(), i = x(), n = C("div"), l = le(
        /*content*/
        t[6]
      ), o = x(), u && u.c(), f(n, "class", "text svelte-vpqbh0"), f(
        e,
        "data-testid",
        /*testid*/
        t[8]
      ), f(e, "class", "chip svelte-vpqbh0"), f(e, "style", r = be(
        /*mt*/
        t[0],
        /*mr*/
        t[1],
        /*mb*/
        t[2],
        /*ml*/
        t[3]
      )), f(e, "tabindex", "0"), G(
        e,
        "deletable",
        /*_deletable*/
        t[12]
      ), G(
        e,
        "error",
        /*_error*/
        t[11]
      ), G(
        e,
        "variant",
        /*variant*/
        t[7]
      );
    },
    m(c, g) {
      D(c, e, g), d && d.m(e, null), _(e, i), _(e, n), _(n, l), _(e, o), u && u.m(e, null), t[16](e), a || (s = [
        te(
          e,
          "click",
          /*click_handler*/
          t[17]
        ),
        te(
          e,
          "mouseover",
          /*mouseover_handler*/
          t[18]
        ),
        te(
          e,
          "mouseout",
          /*mouseout_handler*/
          t[19]
        ),
        te(
          e,
          "focus",
          /*focus_handler*/
          t[20]
        ),
        te(
          e,
          "blur",
          /*blur_handler*/
          t[21]
        )
      ], a = !0);
    },
    p(c, [g]) {
      /*leadingicon*/
      c[4] ? d ? d.p(c, g) : (d = Bn(c), d.c(), d.m(e, i)) : d && (d.d(1), d = null), g & /*content*/
      64 && pe(
        l,
        /*content*/
        c[6]
      ), /*_deletable*/
      c[12] ? u ? u.p(c, g) : (u = Nn(c), u.c(), u.m(e, null)) : u && (u.d(1), u = null), g & /*testid*/
      256 && f(
        e,
        "data-testid",
        /*testid*/
        c[8]
      ), g & /*mt, mr, mb, ml*/
      15 && r !== (r = be(
        /*mt*/
        c[0],
        /*mr*/
        c[1],
        /*mb*/
        c[2],
        /*ml*/
        c[3]
      )) && f(e, "style", r), g & /*_deletable*/
      4096 && G(
        e,
        "deletable",
        /*_deletable*/
        c[12]
      ), g & /*_error*/
      2048 && G(
        e,
        "error",
        /*_error*/
        c[11]
      ), g & /*variant*/
      128 && G(
        e,
        "variant",
        /*variant*/
        c[7]
      );
    },
    i: ve,
    o: ve,
    d(c) {
      c && P(e), d && d.d(), u && u.d(), t[16](null), a = !1, He(s);
    }
  };
}
function gd(t, e, i) {
  let { mt: n = null } = e, { mr: l = null } = e, { mb: o = null } = e, { ml: r = null } = e, { leadingicon: a = null } = e, { icontheme: s = "outline" } = e, { error: d = "false" } = e, { deletable: u = "false" } = e, { content: c } = e, { variant: g } = e, { testid: h = "" } = e, m, v = !1, b, w;
  ke(async () => {
    console.warn("GoAChip is deprecated. Instead use GoAFilterChip.");
  });
  function y(T) {
    m.dispatchEvent(new CustomEvent("_click", { composed: !0, bubbles: !0 })), T.stopPropagation();
  }
  function j(T) {
    ue[T ? "unshift" : "push"](() => {
      m = T, i(9, m);
    });
  }
  const E = (T) => w && y(T), M = () => i(10, v = !0), L = () => i(10, v = !1), z = () => i(10, v = !1), V = () => i(10, v = !1);
  return t.$$set = (T) => {
    "mt" in T && i(0, n = T.mt), "mr" in T && i(1, l = T.mr), "mb" in T && i(2, o = T.mb), "ml" in T && i(3, r = T.ml), "leadingicon" in T && i(4, a = T.leadingicon), "icontheme" in T && i(5, s = T.icontheme), "error" in T && i(14, d = T.error), "deletable" in T && i(15, u = T.deletable), "content" in T && i(6, c = T.content), "variant" in T && i(7, g = T.variant), "testid" in T && i(8, h = T.testid);
  }, t.$$.update = () => {
    t.$$.dirty & /*error*/
    16384 && i(11, b = Ce(d)), t.$$.dirty & /*deletable*/
    32768 && i(12, w = Ce(u));
  }, [
    n,
    l,
    o,
    r,
    a,
    s,
    c,
    g,
    h,
    m,
    v,
    b,
    w,
    y,
    d,
    u,
    j,
    E,
    M,
    L,
    z,
    V
  ];
}
class hd extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      gd,
      fd,
      ce,
      {
        mt: 0,
        mr: 1,
        mb: 2,
        ml: 3,
        leadingicon: 4,
        icontheme: 5,
        error: 14,
        deletable: 15,
        content: 6,
        variant: 7,
        testid: 8
      },
      cd
    );
  }
  get mt() {
    return this.$$.ctx[0];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[1];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[2];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[3];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get leadingicon() {
    return this.$$.ctx[4];
  }
  set leadingicon(e) {
    this.$$set({ leadingicon: e }), k();
  }
  get icontheme() {
    return this.$$.ctx[5];
  }
  set icontheme(e) {
    this.$$set({ icontheme: e }), k();
  }
  get error() {
    return this.$$.ctx[14];
  }
  set error(e) {
    this.$$set({ error: e }), k();
  }
  get deletable() {
    return this.$$.ctx[15];
  }
  set deletable(e) {
    this.$$set({ deletable: e }), k();
  }
  get content() {
    return this.$$.ctx[6];
  }
  set content(e) {
    this.$$set({ content: e }), k();
  }
  get variant() {
    return this.$$.ctx[7];
  }
  set variant(e) {
    this.$$set({ variant: e }), k();
  }
  get testid() {
    return this.$$.ctx[8];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-chip", he(hd, { mt: {}, mr: {}, mb: {}, ml: {}, leadingicon: {}, icontheme: {}, error: {}, deletable: {}, content: {}, variant: {}, testid: {} }, [], [], !0));
function md(t) {
  const e = t - 1;
  return e * e * e + 1;
}
function vd(t) {
  return Math.pow(t - 1, 3) * (1 - t) + 1;
}
function xt(t, { delay: e = 0, duration: i = 400, easing: n = Gt } = {}) {
  const l = +getComputedStyle(t).opacity;
  return {
    delay: e,
    duration: i,
    easing: n,
    css: (o) => `opacity: ${o * l}`
  };
}
function Wn(t, { delay: e = 0, duration: i = 400, easing: n = md, x: l = 0, y: o = 0, opacity: r = 0 } = {}) {
  const a = getComputedStyle(t), s = +a.opacity, d = a.transform === "none" ? "" : a.transform, u = s * (1 - r), [c, g] = Ui(l), [h, m] = Ui(o);
  return {
    delay: e,
    duration: i,
    easing: n,
    css: (v, b) => `
			transform: ${d} translate(${(1 - v) * c}${g}, ${(1 - v) * h}${m});
			opacity: ${s - u * b}`
  };
}
function Yi(t, e) {
  let i = !1;
  function n() {
    return document.body.style.overflow !== "hidden";
  }
  function l() {
    i && (i = !1, setTimeout(() => {
      document.body.style.overflow = "", document.body.style.borderRight = "";
    }, 200));
  }
  function o() {
    if (!n())
      return;
    const a = r();
    i = !0, document.body.style.overflow = "hidden", document.body.style.borderRight = `${a}px solid #eee`;
  }
  function r() {
    var u;
    if (document.body.clientHeight <= document.documentElement.clientHeight)
      return 0;
    const a = document.createElement("div");
    a.style.visibility = "hidden", a.style.overflow = "scroll", document.body.appendChild(a);
    const s = document.createElement("div");
    a.appendChild(s);
    const d = a.offsetWidth - s.offsetWidth;
    return (u = a.parentNode) == null || u.removeChild(a), d;
  }
  return {
    update(a) {
      a.enable ? o() : l();
    },
    destroy() {
      l();
    }
  };
}
function bd(t) {
  _e(t, "svelte-1lljkl3", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}.fullscreen.svelte-1lljkl3.svelte-1lljkl3{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;flex-direction:column;background-color:var(--goa-circular-progress-color-background)}.inline.svelte-1lljkl3.svelte-1lljkl3{margin:3.5rem;display:inline-flex;flex-direction:column;align-items:center;justify-content:center}.spinner-large.svelte-1lljkl3 .message.svelte-1lljkl3{margin-top:var(--goa-circular-progress-small-margin-top);font:var(--goa-circular-progress-medium-text)}.spinner-xlarge.svelte-1lljkl3 .message.svelte-1lljkl3{margin-top:var(--goa-circular-progress-large-margin-top);font:var(--goa-circular-progress-large-text)}");
}
function Rn(t) {
  let e, i, n;
  const l = [_d, pd], o = [];
  function r(a, s) {
    return (
      /*fullscreen*/
      a[4] ? 0 : (
        /*inline*/
        a[5] ? 1 : -1
      )
    );
  }
  return ~(e = r(t)) && (i = o[e] = l[e](t)), {
    c() {
      i && i.c(), n = Ne();
    },
    m(a, s) {
      ~e && o[e].m(a, s), D(a, n, s);
    },
    p(a, s) {
      let d = e;
      e = r(a), e === d ? ~e && o[e].p(a, s) : (i && (Oe(), U(o[d], 1, 1, () => {
        o[d] = null;
      }), Fe()), ~e ? (i = o[e], i ? i.p(a, s) : (i = o[e] = l[e](a), i.c()), Y(i, 1), i.m(n.parentNode, n)) : i = null);
    },
    d(a) {
      a && P(n), ~e && o[e].d(a);
    }
  };
}
function pd(t) {
  let e, i, n, l, o = (
    /*message*/
    t[0] && Yn(t)
  );
  return {
    c() {
      e = C("div"), i = C("goa-spinner"), n = x(), o && o.c(), p(
        i,
        "size",
        /*spinnerSize*/
        t[3]
      ), p(
        i,
        "progress",
        /*progress*/
        t[1]
      ), f(e, "class", l = Ee("spinner-" + /*spinnerSize*/
      t[3]) + " svelte-1lljkl3"), f(
        e,
        "data-testid",
        /*testid*/
        t[2]
      ), G(
        e,
        "inline",
        /*inline*/
        t[5]
      );
    },
    m(r, a) {
      D(r, e, a), _(e, i), _(e, n), o && o.m(e, null);
    },
    p(r, a) {
      a & /*spinnerSize*/
      8 && p(
        i,
        "size",
        /*spinnerSize*/
        r[3]
      ), a & /*progress*/
      2 && p(
        i,
        "progress",
        /*progress*/
        r[1]
      ), /*message*/
      r[0] ? o ? o.p(r, a) : (o = Yn(r), o.c(), o.m(e, null)) : o && (o.d(1), o = null), a & /*spinnerSize*/
      8 && l !== (l = Ee("spinner-" + /*spinnerSize*/
      r[3]) + " svelte-1lljkl3") && f(e, "class", l), a & /*testid*/
      4 && f(
        e,
        "data-testid",
        /*testid*/
        r[2]
      ), a & /*spinnerSize, inline*/
      40 && G(
        e,
        "inline",
        /*inline*/
        r[5]
      );
    },
    i: ve,
    o: ve,
    d(r) {
      r && P(e), o && o.d();
    }
  };
}
function _d(t) {
  let e, i, n, l, o, r, a, s = (
    /*message*/
    t[0] && Zn(t)
  );
  return {
    c() {
      e = C("div"), i = C("goa-spinner"), n = x(), s && s.c(), p(
        i,
        "size",
        /*spinnerSize*/
        t[3]
      ), p(
        i,
        "progress",
        /*progress*/
        t[1]
      ), f(
        e,
        "data-testid",
        /*testid*/
        t[2]
      ), f(e, "class", "svelte-1lljkl3"), G(
        e,
        "fullscreen",
        /*fullscreen*/
        t[4]
      );
    },
    m(d, u) {
      D(d, e, u), _(e, i), _(e, n), s && s.m(e, null), o = !0, r || (a = Fi(Yi.call(null, e, { enable: !0 })), r = !0);
    },
    p(d, u) {
      (!o || u & /*spinnerSize*/
      8) && p(
        i,
        "size",
        /*spinnerSize*/
        d[3]
      ), (!o || u & /*progress*/
      2) && p(
        i,
        "progress",
        /*progress*/
        d[1]
      ), /*message*/
      d[0] ? s ? s.p(d, u) : (s = Zn(d), s.c(), s.m(e, null)) : s && (s.d(1), s = null), (!o || u & /*testid*/
      4) && f(
        e,
        "data-testid",
        /*testid*/
        d[2]
      ), (!o || u & /*fullscreen*/
      16) && G(
        e,
        "fullscreen",
        /*fullscreen*/
        d[4]
      );
    },
    i(d) {
      o || (d && We(() => {
        o && (l || (l = ci(e, xt, { duration: 300 }, !0)), l.run(1));
      }), o = !0);
    },
    o(d) {
      d && (l || (l = ci(e, xt, { duration: 300 }, !1)), l.run(0)), o = !1;
    },
    d(d) {
      d && P(e), s && s.d(), d && l && l.end(), r = !1, a();
    }
  };
}
function Yn(t) {
  let e, i;
  return {
    c() {
      e = C("div"), i = le(
        /*message*/
        t[0]
      ), f(e, "class", "message svelte-1lljkl3");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l & /*message*/
      1 && pe(
        i,
        /*message*/
        n[0]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function Zn(t) {
  let e, i;
  return {
    c() {
      e = C("div"), i = le(
        /*message*/
        t[0]
      ), f(e, "class", "message");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l & /*message*/
      1 && pe(
        i,
        /*message*/
        n[0]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function wd(t) {
  let e, i = (
    /*isVisible*/
    t[6] && Rn(t)
  );
  return {
    c() {
      i && i.c(), e = Ne();
    },
    m(n, l) {
      i && i.m(n, l), D(n, e, l);
    },
    p(n, [l]) {
      /*isVisible*/
      n[6] ? i ? i.p(n, l) : (i = Rn(n), i.c(), i.m(e.parentNode, e)) : i && (i.d(1), i = null);
    },
    i: ve,
    o: ve,
    d(n) {
      n && P(e), i && i.d(n);
    }
  };
}
function kd(t, e, i) {
  let n;
  const [l, o] = Me("Circular progress variant", ["fullscreen", "inline"]), [r, a] = Me("Button size", ["small", "large"]);
  let { variant: s = "inline" } = e, { size: d = "large" } = e, { message: u = "" } = e, { progress: c = -1 } = e, { visible: g = "false" } = e, { testid: h = "" } = e, m, v, b;
  return ke(async () => {
    o(s), a(d), await Pe(), i(3, m = d === "small" ? "large" : "xlarge"), i(4, v = s === "fullscreen"), i(5, b = s === "inline");
  }), t.$$set = (w) => {
    "variant" in w && i(7, s = w.variant), "size" in w && i(8, d = w.size), "message" in w && i(0, u = w.message), "progress" in w && i(1, c = w.progress), "visible" in w && i(9, g = w.visible), "testid" in w && i(2, h = w.testid);
  }, t.$$.update = () => {
    t.$$.dirty & /*visible*/
    512 && i(6, n = Ce(g));
  }, [
    u,
    c,
    h,
    m,
    v,
    b,
    n,
    s,
    d,
    g
  ];
}
class yd extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      kd,
      wd,
      ce,
      {
        variant: 7,
        size: 8,
        message: 0,
        progress: 1,
        visible: 9,
        testid: 2
      },
      bd
    );
  }
  get variant() {
    return this.$$.ctx[7];
  }
  set variant(e) {
    this.$$set({ variant: e }), k();
  }
  get size() {
    return this.$$.ctx[8];
  }
  set size(e) {
    this.$$set({ size: e }), k();
  }
  get message() {
    return this.$$.ctx[0];
  }
  set message(e) {
    this.$$set({ message: e }), k();
  }
  get progress() {
    return this.$$.ctx[1];
  }
  set progress(e) {
    this.$$set({ progress: e }), k();
  }
  get visible() {
    return this.$$.ctx[9];
  }
  set visible(e) {
    this.$$set({ visible: e }), k();
  }
  get testid() {
    return this.$$.ctx[2];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-circular-progress", he(yd, { variant: {}, size: {}, message: {}, progress: {}, visible: {}, testid: {} }, [], [], !0));
function Cd(t) {
  _e(t, "svelte-9lkkgw", ":host{display:flex;flex:1 1 auto}.goa-container.svelte-9lkkgw.svelte-9lkkgw{box-sizing:border-box;display:flex;flex:1 1 auto;flex-direction:column}.goa-container.svelte-9lkkgw .svelte-9lkkgw{box-sizing:border-box}header.svelte-9lkkgw.svelte-9lkkgw{display:flex;align-items:center;justify-content:space-between;gap:var(--goa-container-heading-gap);font:var(--goa-container-heading);border:var(--goa-container-border);border-top-left-radius:var(--goa-container-border-radius);border-top-right-radius:var(--goa-container-border-radius)}.content.svelte-9lkkgw.svelte-9lkkgw{border-bottom:var(--goa-container-border);border-left:var(--goa-container-border);border-right:var(--goa-container-border);border-bottom-left-radius:var(--goa-container-border-radius);border-bottom-right-radius:var(--goa-container-border-radius);display:flex;flex:1 1 auto;flex-direction:column}.content.svelte-9lkkgw ::slotted(*:last-child){margin-bottom:0 !important}.title.svelte-9lkkgw.svelte-9lkkgw,.actions.svelte-9lkkgw.svelte-9lkkgw{padding:var(--goa-container-heading-padding) 0}.actions.svelte-9lkkgw ::slotted(div){display:flex;align-items:center;gap:var(--goa-space-m)}.padding--relaxed.svelte-9lkkgw header.svelte-9lkkgw{padding:0 var(--goa-container-padding)}.padding--relaxed.svelte-9lkkgw .content.svelte-9lkkgw{padding:var(--goa-container-padding)}.padding--compact.svelte-9lkkgw header.svelte-9lkkgw,.padding--compact.svelte-9lkkgw .content.svelte-9lkkgw{padding:0 var(--goa-container-padding-compact)}.padding--compact.svelte-9lkkgw header.svelte-9lkkgw{padding:0 var(--goa-container-padding-compact)}.padding--compact.svelte-9lkkgw .content.svelte-9lkkgw{padding:var(--goa-container-padding-compact)}@media(max-width: 623px){.padding--relaxed.svelte-9lkkgw header.svelte-9lkkgw{padding:0 var(--goa-container-padding-compact)}.padding--relaxed.svelte-9lkkgw .content.svelte-9lkkgw{padding:var(--goa-container-padding-compact)}}.goa-container--interactive.svelte-9lkkgw header.svelte-9lkkgw{background-color:var(--goa-container-interactive-heading-bg-color);border:var(--goa-container-interactive-border);color:var(--goa-container-interactive-heading-text-color)}.goa-container--non-interactive.svelte-9lkkgw header.svelte-9lkkgw{background-color:var(--goa-container-non-interactive-heading-bg-color);border:var(--goa-container-non-interactive-border);color:var(--goa-container-non-interactive-heading-text-color)}.goa-container--non-interactive.accent--filled.svelte-9lkkgw .content.svelte-9lkkgw{border:var(--goa-container-non-interactive-border);background-color:var(--goa-container-non-interactive-bg-color)}.goa-container--info.svelte-9lkkgw header.svelte-9lkkgw{background-color:var(--goa-container-info-heading-bg-color);border:var(--goa-container-info-border);color:var(--goa-container-info-heading-text-color)}.goa-container--info.accent--filled.svelte-9lkkgw .content.svelte-9lkkgw{border:var(--goa-container-info-border);background-color:var(--goa-container-info-bg-color)}.goa-container--error.svelte-9lkkgw header.svelte-9lkkgw{background-color:var(--goa-container-error-heading-bg-color);border:var(--goa-container-error-border);color:var(--goa-container-error-heading-text-color)}.goa-container--error.accent--filled.svelte-9lkkgw .content.svelte-9lkkgw{border:var(--goa-container-error-border);background-color:var(--goa-container-error-bg-color)}.goa-container--success.svelte-9lkkgw header.svelte-9lkkgw{background-color:var(--goa-container-success-heading-bg-color);border:var(--goa-container-success-border);color:var(--goa-container-success-heading-text-color)}.goa-container--success.accent--filled.svelte-9lkkgw .content.svelte-9lkkgw{border:var(--goa-container-success-border);background-color:var(--goa-container-success-bg-color)}.goa-container--important.svelte-9lkkgw header.svelte-9lkkgw{background-color:var(--goa-container-important-heading-bg-color);border:var(--goa-container-important-border);color:var(--goa-container-important-heading-text-color)}.goa-container--important.accent--filled.svelte-9lkkgw .content.svelte-9lkkgw{border:var(--goa-container-important-border);background-color:var(--goa-container-important-bg-color)}.heading--thick.svelte-9lkkgw.svelte-9lkkgw{min-height:var(--goa-container-accent-thick-height)}.heading--thin.svelte-9lkkgw.svelte-9lkkgw{height:var(--goa-container-accent-thin-height)}.heading--filled.svelte-9lkkgw.svelte-9lkkgw{display:none}.heading--filled.svelte-9lkkgw~.content.svelte-9lkkgw{border-top:var(--goa-container-border);border-top-left-radius:var(--goa-container-border-radius);border-top-right-radius:var(--goa-container-border-radius)}.heading--thin.svelte-9lkkgw .title.svelte-9lkkgw,.heading--thin.svelte-9lkkgw .actions.svelte-9lkkgw{display:none}.actions.svelte-9lkkgw.svelte-9lkkgw{display:flex;align-items:center}.width--content.svelte-9lkkgw.svelte-9lkkgw{flex-grow:0}");
}
const zd = (t) => ({}), Un = (t) => ({}), jd = (t) => ({}), Gn = (t) => ({});
function Kn(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[13].title
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[12],
    Gn
  );
  return {
    c() {
      e = C("div"), l && l.c(), f(e, "class", "title svelte-9lkkgw");
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null), i = !0;
    },
    p(o, r) {
      l && l.p && (!i || r & /*$$scope*/
      4096) && ae(
        l,
        n,
        o,
        /*$$scope*/
        o[12],
        i ? re(
          n,
          /*$$scope*/
          o[12],
          r,
          jd
        ) : se(
          /*$$scope*/
          o[12]
        ),
        Gn
      );
    },
    i(o) {
      i || (Y(l, o), i = !0);
    },
    o(o) {
      U(l, o), i = !1;
    },
    d(o) {
      o && P(e), l && l.d(o);
    }
  };
}
function Xn(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[13].actions
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[12],
    Un
  );
  return {
    c() {
      e = C("div"), l && l.c(), f(e, "class", "actions svelte-9lkkgw");
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null), i = !0;
    },
    p(o, r) {
      l && l.p && (!i || r & /*$$scope*/
      4096) && ae(
        l,
        n,
        o,
        /*$$scope*/
        o[12],
        i ? re(
          n,
          /*$$scope*/
          o[12],
          r,
          zd
        ) : se(
          /*$$scope*/
          o[12]
        ),
        Un
      );
    },
    i(o) {
      i || (Y(l, o), i = !0);
    },
    o(o) {
      U(l, o), i = !1;
    },
    d(o) {
      o && P(e), l && l.d(o);
    }
  };
}
function Ed(t) {
  let e, i, n, l, o, r, a, s, d, u = (
    /*$$slots*/
    t[11].title && Kn(t)
  ), c = (
    /*$$slots*/
    t[11].actions && Xn(t)
  );
  return {
    c() {
      e = C("div"), i = C("header"), u && u.c(), n = x(), c && c.c(), o = x(), r = C("div"), r.innerHTML = "", f(i, "class", l = "heading--" + /*accent*/
      t[1] + " svelte-9lkkgw"), f(r, "class", "content svelte-9lkkgw"), f(
        e,
        "data-testid",
        /*testid*/
        t[5]
      ), f(e, "style", a = `
    ${be(
        /*mt*/
        t[6],
        /*mr*/
        t[7],
        /*mb*/
        t[8],
        /*ml*/
        t[9]
      )}
    max-width: ${/*maxwidth*/
      t[4]};
  `), f(e, "class", s = Ee(`
    goa-container
    goa-container--${/*type*/
      t[0]}
    padding--${/*padding*/
      t[2]}
    accent--${/*accent*/
      t[1]}
    width--${/*width*/
      t[3]}
  `) + " svelte-9lkkgw");
    },
    m(g, h) {
      D(g, e, h), _(e, i), u && u.m(i, null), _(i, n), c && c.m(i, null), _(e, o), _(e, r), t[14](r), d = !0;
    },
    p(g, [h]) {
      /*$$slots*/
      g[11].title ? u ? (u.p(g, h), h & /*$$slots*/
      2048 && Y(u, 1)) : (u = Kn(g), u.c(), Y(u, 1), u.m(i, n)) : u && (Oe(), U(u, 1, 1, () => {
        u = null;
      }), Fe()), /*$$slots*/
      g[11].actions ? c ? (c.p(g, h), h & /*$$slots*/
      2048 && Y(c, 1)) : (c = Xn(g), c.c(), Y(c, 1), c.m(i, null)) : c && (Oe(), U(c, 1, 1, () => {
        c = null;
      }), Fe()), (!d || h & /*accent*/
      2 && l !== (l = "heading--" + /*accent*/
      g[1] + " svelte-9lkkgw")) && f(i, "class", l), (!d || h & /*testid*/
      32) && f(
        e,
        "data-testid",
        /*testid*/
        g[5]
      ), (!d || h & /*mt, mr, mb, ml, maxwidth*/
      976 && a !== (a = `
    ${be(
        /*mt*/
        g[6],
        /*mr*/
        g[7],
        /*mb*/
        g[8],
        /*ml*/
        g[9]
      )}
    max-width: ${/*maxwidth*/
      g[4]};
  `)) && f(e, "style", a), (!d || h & /*type, padding, accent, width*/
      15 && s !== (s = Ee(`
    goa-container
    goa-container--${/*type*/
      g[0]}
    padding--${/*padding*/
      g[2]}
    accent--${/*accent*/
      g[1]}
    width--${/*width*/
      g[3]}
  `) + " svelte-9lkkgw")) && f(e, "class", s);
    },
    i(g) {
      d || (Y(u), Y(c), d = !0);
    },
    o(g) {
      U(u), U(c), d = !1;
    },
    d(g) {
      g && P(e), u && u.d(), c && c.d(), t[14](null);
    }
  };
}
function Md(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e;
  const o = pt(n), [r, a] = Me("Container type", ["interactive", "info", "error", "success", "important", "non-interactive"]), [s, d] = Me("Container accent", ["thick", "thin", "filled"]), [u, c] = Me("Container padding", ["relaxed", "compact"]), [g, h] = Me("Container width", ["full", "content"]);
  let { type: m = "interactive" } = e, { accent: v = "filled" } = e, { padding: b = "relaxed" } = e, { width: w = "full" } = e, { maxwidth: y = "none" } = e, { testid: j = "" } = e, { mt: E = null } = e, { mr: M = null } = e, { mb: L = "m" } = e, { ml: z = null } = e, V;
  ke(() => {
    a(m), d(v), c(b), h(w), yi(V);
  });
  function T(S) {
    ue[S ? "unshift" : "push"](() => {
      V = S, i(10, V);
    });
  }
  return t.$$set = (S) => {
    "type" in S && i(0, m = S.type), "accent" in S && i(1, v = S.accent), "padding" in S && i(2, b = S.padding), "width" in S && i(3, w = S.width), "maxwidth" in S && i(4, y = S.maxwidth), "testid" in S && i(5, j = S.testid), "mt" in S && i(6, E = S.mt), "mr" in S && i(7, M = S.mr), "mb" in S && i(8, L = S.mb), "ml" in S && i(9, z = S.ml), "$$scope" in S && i(12, l = S.$$scope);
  }, [
    m,
    v,
    b,
    w,
    y,
    j,
    E,
    M,
    L,
    z,
    V,
    o,
    l,
    n,
    T
  ];
}
class Ld extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Md,
      Ed,
      ce,
      {
        type: 0,
        accent: 1,
        padding: 2,
        width: 3,
        maxwidth: 4,
        testid: 5,
        mt: 6,
        mr: 7,
        mb: 8,
        ml: 9
      },
      Cd
    );
  }
  get type() {
    return this.$$.ctx[0];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get accent() {
    return this.$$.ctx[1];
  }
  set accent(e) {
    this.$$set({ accent: e }), k();
  }
  get padding() {
    return this.$$.ctx[2];
  }
  set padding(e) {
    this.$$set({ padding: e }), k();
  }
  get width() {
    return this.$$.ctx[3];
  }
  set width(e) {
    this.$$set({ width: e }), k();
  }
  get maxwidth() {
    return this.$$.ctx[4];
  }
  set maxwidth(e) {
    this.$$set({ maxwidth: e }), k();
  }
  get testid() {
    return this.$$.ctx[5];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[6];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[7];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[8];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[9];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-container", he(Ld, { type: {}, accent: {}, padding: {}, width: {}, maxwidth: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["title", "actions"], [], !0));
function qd(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v, b, w, y, j, E, M, L, z, V, T, S, A, R, I, B, N, F, q, H, O, W, K, $, ye;
  return {
    c() {
      e = C("goa-form-item"), i = C("goa-block"), n = C("goa-form-item"), l = C("goa-input"), r = x(), a = C("goa-form-item"), s = C("goa-dropdown"), d = C("goa-dropdown-item"), u = x(), c = C("goa-dropdown-item"), g = x(), h = C("goa-dropdown-item"), m = x(), v = C("goa-dropdown-item"), b = x(), w = C("goa-dropdown-item"), y = x(), j = C("goa-dropdown-item"), E = x(), M = C("goa-dropdown-item"), L = x(), z = C("goa-dropdown-item"), V = x(), T = C("goa-dropdown-item"), S = x(), A = C("goa-dropdown-item"), R = x(), I = C("goa-dropdown-item"), B = x(), N = C("goa-dropdown-item"), q = x(), H = C("goa-form-item"), O = C("goa-input"), p(l, "name", "day"), p(l, "type", "number"), p(l, "width", "7ch"), p(l, "value", o = /*_inputDate*/
      t[15].day), p(l, "min", "1"), p(l, "max", "31"), p(
        l,
        "_error",
        /*_error*/
        t[17]
      ), p(n, "label", "Day"), p(n, "helptext", "Day (DD)"), p(d, "value", "0"), p(d, "label", "January"), p(c, "value", "1"), p(c, "label", "February"), p(h, "value", "2"), p(h, "label", "March"), p(v, "value", "3"), p(v, "label", "April"), p(w, "value", "4"), p(w, "label", "May"), p(j, "value", "5"), p(j, "label", "June"), p(M, "value", "6"), p(M, "label", "July"), p(z, "value", "7"), p(z, "label", "August"), p(T, "value", "8"), p(T, "label", "September"), p(A, "value", "9"), p(A, "label", "October"), p(I, "value", "10"), p(I, "label", "November"), p(N, "value", "11"), p(N, "label", "December"), p(s, "name", "month"), p(
        s,
        "error",
        /*error*/
        t[1]
      ), p(s, "value", F = /*_inputDate*/
      t[15].month + ""), p(a, "label", "Month"), p(a, "helptext", "Month"), p(O, "name", "year"), p(O, "type", "number"), p(O, "width", "10ch"), p(O, "value", W = /*_inputDate*/
      t[15].year), p(O, "min", "1800"), p(O, "max", "2200"), p(
        O,
        "error",
        /*error*/
        t[1]
      ), p(H, "label", "Year"), p(H, "helptext", "Year (YYYY)"), p(i, "direction", "row"), p(e, "error", K = /*_error*/
      t[17] && /*error*/
      t[1]);
    },
    m(Z, Q) {
      D(Z, e, Q), _(e, i), _(i, n), _(n, l), _(i, r), _(i, a), _(a, s), _(s, d), _(s, u), _(s, c), _(s, g), _(s, h), _(s, m), _(s, v), _(s, b), _(s, w), _(s, y), _(s, j), _(s, E), _(s, M), _(s, L), _(s, z), _(s, V), _(s, T), _(s, S), _(s, A), _(s, R), _(s, I), _(s, B), _(s, N), _(i, q), _(i, H), _(H, O), t[27](e), $ || (ye = [
        te(
          l,
          "_change",
          /*onInputChange*/
          t[23]
        ),
        te(
          s,
          "_change",
          /*onInputChange*/
          t[23]
        ),
        te(
          O,
          "_change",
          /*onInputChange*/
          t[23]
        )
      ], $ = !0);
    },
    p(Z, Q) {
      Q[0] & /*_inputDate*/
      32768 && o !== (o = /*_inputDate*/
      Z[15].day) && p(l, "value", o), Q[0] & /*error*/
      2 && p(
        s,
        "error",
        /*error*/
        Z[1]
      ), Q[0] & /*_inputDate*/
      32768 && F !== (F = /*_inputDate*/
      Z[15].month + "") && p(s, "value", F), Q[0] & /*_inputDate*/
      32768 && W !== (W = /*_inputDate*/
      Z[15].year) && p(O, "value", W), Q[0] & /*error*/
      2 && p(
        O,
        "error",
        /*error*/
        Z[1]
      ), Q[0] & /*error*/
      2 && K !== (K = /*_error*/
      Z[17] && /*error*/
      Z[1]) && p(e, "error", K);
    },
    d(Z) {
      Z && P(e), t[27](null), $ = !1, He(ye);
    }
  };
}
function Sd(t) {
  let e, i, n, l, o, r, a;
  return {
    c() {
      e = C("goa-popover"), i = C("goa-input"), l = x(), o = C("goa-calendar"), p(i, "slot", "target"), p(i, "readonly", "true"), p(i, "trailingicon", "calendar"), p(i, "value", n = /*formatDate*/
      t[20](
        /*_date*/
        t[13]
      )), p(
        i,
        "error",
        /*error*/
        t[1]
      ), p(
        i,
        "disabled",
        /*isDisabled*/
        t[16]
      ), p(
        o,
        "name",
        /*name*/
        t[3]
      ), p(
        o,
        "value",
        /*value*/
        t[0]
      ), p(
        o,
        "min",
        /*min*/
        t[4]
      ), p(
        o,
        "max",
        /*max*/
        t[5]
      ), p(o, "bordered", "false"), p(e, "tabindex", "-1"), p(
        e,
        "testid",
        /*testid*/
        t[7]
      ), p(
        e,
        "relative",
        /*relative*/
        t[6]
      ), p(
        e,
        "mt",
        /*mt*/
        t[8]
      ), p(
        e,
        "mb",
        /*mb*/
        t[10]
      ), p(
        e,
        "ml",
        /*ml*/
        t[11]
      ), p(
        e,
        "mr",
        /*mr*/
        t[9]
      ), p(
        e,
        "disabled",
        /*isDisabled*/
        t[16]
      ), p(
        e,
        "open",
        /*_showPopover*/
        t[14]
      );
    },
    m(s, d) {
      D(s, e, d), _(e, i), _(e, l), _(e, o), t[25](e), r || (a = [
        te(
          i,
          "click",
          /*showCalendar*/
          t[21]
        ),
        te(
          i,
          "keydown",
          /*handleKeyDown*/
          t[22]
        ),
        te(
          o,
          "_change",
          /*onCalendarChange*/
          t[18]
        ),
        te(
          e,
          "_close",
          /*close_handler*/
          t[26]
        )
      ], r = !0);
    },
    p(s, d) {
      d[0] & /*_date*/
      8192 && n !== (n = /*formatDate*/
      s[20](
        /*_date*/
        s[13]
      )) && p(i, "value", n), d[0] & /*error*/
      2 && p(
        i,
        "error",
        /*error*/
        s[1]
      ), d[0] & /*isDisabled*/
      65536 && p(
        i,
        "disabled",
        /*isDisabled*/
        s[16]
      ), d[0] & /*name*/
      8 && p(
        o,
        "name",
        /*name*/
        s[3]
      ), d[0] & /*value*/
      1 && p(
        o,
        "value",
        /*value*/
        s[0]
      ), d[0] & /*min*/
      16 && p(
        o,
        "min",
        /*min*/
        s[4]
      ), d[0] & /*max*/
      32 && p(
        o,
        "max",
        /*max*/
        s[5]
      ), d[0] & /*testid*/
      128 && p(
        e,
        "testid",
        /*testid*/
        s[7]
      ), d[0] & /*relative*/
      64 && p(
        e,
        "relative",
        /*relative*/
        s[6]
      ), d[0] & /*mt*/
      256 && p(
        e,
        "mt",
        /*mt*/
        s[8]
      ), d[0] & /*mb*/
      1024 && p(
        e,
        "mb",
        /*mb*/
        s[10]
      ), d[0] & /*ml*/
      2048 && p(
        e,
        "ml",
        /*ml*/
        s[11]
      ), d[0] & /*mr*/
      512 && p(
        e,
        "mr",
        /*mr*/
        s[9]
      ), d[0] & /*isDisabled*/
      65536 && p(
        e,
        "disabled",
        /*isDisabled*/
        s[16]
      ), d[0] & /*_showPopover*/
      16384 && p(
        e,
        "open",
        /*_showPopover*/
        s[14]
      );
    },
    d(s) {
      s && P(e), t[25](null), r = !1, He(a);
    }
  };
}
function Td(t) {
  let e;
  function i(o, r) {
    if (
      /*type*/
      o[2] === "calendar"
    ) return Sd;
    if (
      /*type*/
      o[2] === "input"
    ) return qd;
  }
  let n = i(t), l = n && n(t);
  return {
    c() {
      l && l.c(), e = Ne();
    },
    m(o, r) {
      l && l.m(o, r), D(o, e, r);
    },
    p(o, r) {
      n === (n = i(o)) && l ? l.p(o, r) : (l && l.d(1), l = n && n(o), l && (l.c(), l.m(e.parentNode, e)));
    },
    i: ve,
    o: ve,
    d(o) {
      o && P(e), l && l.d(o);
    }
  };
}
function Pd(t, e, i) {
  let n, { type: l = "calendar" } = e, { name: o = "" } = e, { value: r = "" } = e, { error: a = "false" } = e, { min: s = "" } = e, { max: d = "" } = e, { relative: u = "false" } = e, { disabled: c = "false" } = e, { testid: g = "" } = e, { mt: h = null } = e, { mr: m = null } = e, { mb: v = null } = e, { ml: b = null } = e, w = Ce(a), y, j, E = !1, M = { day: "", month: "", year: "" };
  ke(async () => {
    await Pe(), S(r), L(), T();
  });
  function L() {
    Re(y, (K, $) => {
      switch (K) {
        case bt:
          V($);
          break;
        case dt:
          z($);
          break;
        case ut:
          i(1, a = "false");
          break;
      }
    });
  }
  function z(K) {
    i(1, a = K.error ? "true" : "false");
  }
  function V(K) {
    i(0, r = K.value), qe(y, "_change", { name: o, value: K.value }, { bubbles: !0 });
  }
  function T() {
    je(y, Qe, { name: o, el: y }, { bubbles: !0, timeout: 5 });
  }
  function S(K) {
    if (!K || !new Date(K).getDate()) {
      i(13, j = null), i(15, M = { day: "", month: "", year: "" });
      return;
    }
    if (l === "input") {
      const [$, ye, Z] = K.split("-");
      i(15, M = { year: $, month: `${+ye - 1}`, day: Z });
    } else l === "calendar" && i(13, j = mt(new Date(K)));
  }
  function A(K) {
    i(13, j = K.detail.value), j ? i(0, r = j.toISOString()) : i(0, r = ""), B(), R(j), K.stopPropagation(), K.preventDefault();
  }
  function R(K) {
    K ? i(0, r = K.toISOString()) : i(0, r = ""), y.dispatchEvent(new CustomEvent(
      "_change",
      {
        composed: !0,
        bubbles: !0,
        detail: { name: o, type: "date", value: K }
      }
    ));
  }
  function I(K) {
    return K ? xe(typeof K == "string" ? new Date(K) : K, "PPP") : "";
  }
  function B() {
    i(14, E = !1);
  }
  function N() {
    i(14, E = !n);
  }
  function F(K) {
    if (["Space", "Enter"].includes(K.key)) {
      N();
      return;
    }
    switch (K.key) {
      case "ArrowLeft":
        i(13, j || (j = Ze(
          /* @__PURE__ */ new Date(),
          1
        ))), i(13, j = Ze(j, -1));
        break;
      case "ArrowRight":
        i(13, j || (j = Ze(
          /* @__PURE__ */ new Date(),
          -1
        ))), i(13, j = Ze(j, 1));
        break;
      case "ArrowDown":
        i(13, j || (j = Ze(
          /* @__PURE__ */ new Date(),
          -7
        ))), i(13, j = Ze(j, 7));
        break;
      case "ArrowUp":
        i(13, j || (j = Ze(
          /* @__PURE__ */ new Date(),
          7
        ))), i(13, j = Ze(j, -7));
        break;
      case "PageUp":
        i(13, j || (j = K.shiftKey ? ht(/* @__PURE__ */ new Date(), 1) : st(
          /* @__PURE__ */ new Date(),
          1
        ))), i(13, j = K.shiftKey ? ht(j, -1) : st(j, -1));
        break;
      case "PageDown":
        i(13, j || (j = K.shiftKey ? ht(/* @__PURE__ */ new Date(), -1) : st(/* @__PURE__ */ new Date(), -1))), i(13, j = K.shiftKey ? ht(j, 1) : st(j, 1));
        break;
      default:
        return;
    }
    R(j), K.preventDefault(), K.stopPropagation();
  }
  function q(K) {
    K.stopPropagation();
    const { name: $, value: ye } = K.detail;
    if (i(15, M = { ...M, [$]: +ye }), !new Date(+M.year, +M.month, +M.day))
      return;
    const Z = `${qi(M.year, 4, 0)}-${qi(+M.month + 1, 2, 0)}-${qi(M.day, 2, 0)}`;
    qe(y, "_change", { name: o, type: "string", value: Z }, { bubbles: !0 });
  }
  function H(K) {
    ue[K ? "unshift" : "push"](() => {
      y = K, i(12, y);
    });
  }
  const O = () => R(j);
  function W(K) {
    ue[K ? "unshift" : "push"](() => {
      y = K, i(12, y);
    });
  }
  return t.$$set = (K) => {
    "type" in K && i(2, l = K.type), "name" in K && i(3, o = K.name), "value" in K && i(0, r = K.value), "error" in K && i(1, a = K.error), "min" in K && i(4, s = K.min), "max" in K && i(5, d = K.max), "relative" in K && i(6, u = K.relative), "disabled" in K && i(24, c = K.disabled), "testid" in K && i(7, g = K.testid), "mt" in K && i(8, h = K.mt), "mr" in K && i(9, m = K.mr), "mb" in K && i(10, v = K.mb), "ml" in K && i(11, b = K.ml);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*disabled*/
    16777216 && i(16, n = Ce(c)), t.$$.dirty[0] & /*value*/
    1 && S(r);
  }, [
    r,
    a,
    l,
    o,
    s,
    d,
    u,
    g,
    h,
    m,
    v,
    b,
    y,
    j,
    E,
    M,
    n,
    w,
    A,
    R,
    I,
    N,
    F,
    q,
    c,
    H,
    O,
    W
  ];
}
class Dd extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Pd,
      Td,
      ce,
      {
        type: 2,
        name: 3,
        value: 0,
        error: 1,
        min: 4,
        max: 5,
        relative: 6,
        disabled: 24,
        testid: 7,
        mt: 8,
        mr: 9,
        mb: 10,
        ml: 11
      },
      null,
      [-1, -1]
    );
  }
  get type() {
    return this.$$.ctx[2];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get name() {
    return this.$$.ctx[3];
  }
  set name(e) {
    this.$$set({ name: e }), k();
  }
  get value() {
    return this.$$.ctx[0];
  }
  set value(e) {
    this.$$set({ value: e }), k();
  }
  get error() {
    return this.$$.ctx[1];
  }
  set error(e) {
    this.$$set({ error: e }), k();
  }
  get min() {
    return this.$$.ctx[4];
  }
  set min(e) {
    this.$$set({ min: e }), k();
  }
  get max() {
    return this.$$.ctx[5];
  }
  set max(e) {
    this.$$set({ max: e }), k();
  }
  get relative() {
    return this.$$.ctx[6];
  }
  set relative(e) {
    this.$$set({ relative: e }), k();
  }
  get disabled() {
    return this.$$.ctx[24];
  }
  set disabled(e) {
    this.$$set({ disabled: e }), k();
  }
  get testid() {
    return this.$$.ctx[7];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[8];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[9];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[10];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[11];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-date-picker", he(Dd, { type: {}, name: {}, value: {}, error: {}, min: {}, max: {}, relative: {}, disabled: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {} }, [], [], !0));
function Hd(t) {
  _e(t, "svelte-jlah7k", ":host{font-family:var(--goa-font-family-serif)}details.svelte-jlah7k.svelte-jlah7k{position:relative}details.svelte-jlah7k ::slotted(*){font:var(--goa-typography-body-m)}details[open].svelte-jlah7k goa-icon.svelte-jlah7k{transform:translateX(-1px) translateY(-0px) rotate(90deg);margin-top:var(--goa-space-2xs)}details.svelte-jlah7k summary.svelte-jlah7k::-webkit-details-marker{display:none}summary.svelte-jlah7k.svelte-jlah7k{padding-top:var(--goa-details-padding-top);padding-right:var(--goa-details-padding-right);padding-left:var(--goa-details-padding-left);padding-bottom:var(--goa-details-padding-bottom);margin-bottom:var(--goa-details-margin-bottom);cursor:pointer;list-style:none;display:flex;align-items:flex-start;border-radius:var(--goa-details-border-radius)}summary.svelte-jlah7k.svelte-jlah7k:focus-visible{outline:var(--goa-details-focus-border);color:var(--goa-color-interactive-hover)}summary.svelte-jlah7k.svelte-jlah7k:focus,summary.svelte-jlah7k.svelte-jlah7k:active{border-radius:var(--goa-details-border-radius);color:var(--goa-details-color-text-hover);background-color:var(--goa-details-color-bg-hover)}summary.svelte-jlah7k.svelte-jlah7k:hover{background-color:var(--goa-details-color-bg-hover)}summary.svelte-jlah7k span.svelte-jlah7k{margin-left:var(--goa-space-xl);-webkit-text-decoration:var(--goa-details-text-decoration);text-decoration:var(--goa-details-text-decoration);color:var(--goa-details-color-text);font:var(--goa-details-typeface)}summary.svelte-jlah7k:hover span.svelte-jlah7k{color:var(--goa-details-color-text-hover)}.content.svelte-jlah7k.svelte-jlah7k{border-left:var(--goa-details-content-left-border);padding-left:var(--goa-details-content-padding-left);padding-top:var(--goa-details-content-padding-top);padding-bottom:var(--goa-details-content-padding-bottom);padding-right:var(--goa-details-content-padding-right);margin-left:var(--goa-details-content-margin-left);margin-bottom:var(--goa-details-margin-bottom)}.content.svelte-jlah7k ::slotted(p:last-child){margin-bottom:0 !important}goa-icon.svelte-jlah7k.svelte-jlah7k{position:absolute}");
}
function Od(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v, b, w, y;
  const j = (
    /*#slots*/
    t[13].default
  ), E = oe(
    j,
    t,
    /*$$scope*/
    t[12],
    null
  );
  return {
    c() {
      e = C("details"), i = C("summary"), n = C("goa-icon"), o = x(), r = C("span"), a = le(
        /*heading*/
        t[1]
      ), c = x(), g = C("div"), E && E.c(), p(n, "mt", "2"), p(n, "mr", "2"), p(n, "type", "chevron-forward"), p(n, "fillcolor", l = /*_isMouseOver*/
      t[8] ? "var(--goa-color-interactive-hover)" : "var(--goa-color-interactive-default)"), p(n, "class", "svelte-jlah7k"), f(r, "id", s = `${/*_detailsId*/
      t[10]}-heading`), f(r, "class", "svelte-jlah7k"), f(i, "aria-expanded", d = /*open*/
      t[0] === "true"), f(i, "aria-controls", u = `${/*_detailsId*/
      t[10]}-content`), f(i, "class", "svelte-jlah7k"), f(g, "class", "content svelte-jlah7k"), f(g, "role", "region"), f(g, "aria-labelledby", h = `${/*_detailsId*/
      t[10]}-heading`), f(g, "id", m = `${/*_detailsId*/
      t[10]}-content`), e.open = /*_isOpen*/
      t[11], f(e, "style", v = `
    ${be(
        /*mt*/
        t[3],
        /*mr*/
        t[4],
        /*mb*/
        t[5],
        /*ml*/
        t[6]
      )}
    max-width: ${/*maxwidth*/
      t[2]};
  `), f(
        e,
        "data-testid",
        /*testid*/
        t[7]
      ), f(e, "class", "svelte-jlah7k");
    },
    m(M, L) {
      D(M, e, L), _(e, i), _(i, n), _(i, o), _(i, r), _(r, a), t[14](i), _(e, c), _(e, g), E && E.m(g, null), b = !0, w || (y = te(
        e,
        "toggle",
        /*toggle_handler*/
        t[15]
      ), w = !0);
    },
    p(M, [L]) {
      (!b || L & /*_isMouseOver*/
      256 && l !== (l = /*_isMouseOver*/
      M[8] ? "var(--goa-color-interactive-hover)" : "var(--goa-color-interactive-default)")) && p(n, "fillcolor", l), (!b || L & /*heading*/
      2) && pe(
        a,
        /*heading*/
        M[1]
      ), (!b || L & /*_detailsId*/
      1024 && s !== (s = `${/*_detailsId*/
      M[10]}-heading`)) && f(r, "id", s), (!b || L & /*open*/
      1 && d !== (d = /*open*/
      M[0] === "true")) && f(i, "aria-expanded", d), (!b || L & /*_detailsId*/
      1024 && u !== (u = `${/*_detailsId*/
      M[10]}-content`)) && f(i, "aria-controls", u), E && E.p && (!b || L & /*$$scope*/
      4096) && ae(
        E,
        j,
        M,
        /*$$scope*/
        M[12],
        b ? re(
          j,
          /*$$scope*/
          M[12],
          L,
          null
        ) : se(
          /*$$scope*/
          M[12]
        ),
        null
      ), (!b || L & /*_detailsId*/
      1024 && h !== (h = `${/*_detailsId*/
      M[10]}-heading`)) && f(g, "aria-labelledby", h), (!b || L & /*_detailsId*/
      1024 && m !== (m = `${/*_detailsId*/
      M[10]}-content`)) && f(g, "id", m), (!b || L & /*_isOpen*/
      2048) && (e.open = /*_isOpen*/
      M[11]), (!b || L & /*mt, mr, mb, ml, maxwidth*/
      124 && v !== (v = `
    ${be(
        /*mt*/
        M[3],
        /*mr*/
        M[4],
        /*mb*/
        M[5],
        /*ml*/
        M[6]
      )}
    max-width: ${/*maxwidth*/
      M[2]};
  `)) && f(e, "style", v), (!b || L & /*testid*/
      128) && f(
        e,
        "data-testid",
        /*testid*/
        M[7]
      );
    },
    i(M) {
      b || (Y(E, M), b = !0);
    },
    o(M) {
      U(E, M), b = !1;
    },
    d(M) {
      M && P(e), t[14](null), E && E.d(M), w = !1, y();
    }
  };
}
function Fd(t, e, i) {
  let n, { $$slots: l = {}, $$scope: o } = e, { heading: r } = e, { maxwidth: a = "75ch" } = e, { mt: s = null } = e, { mr: d = null } = e, { mb: u = null } = e, { ml: c = null } = e, { open: g = "false" } = e, { testid: h = "" } = e, m = !1, v, b = "";
  ke(() => {
    Kt("Details", { heading: r }), i(10, b = `details-${fi()}`), v.addEventListener("mouseover", () => {
      i(8, m = !0);
    }), v.addEventListener("mouseout", () => {
      i(8, m = !1);
    });
  });
  function w(j) {
    ue[j ? "unshift" : "push"](() => {
      v = j, i(9, v);
    });
  }
  const y = ({ target: j }) => i(0, g = `${j == null ? void 0 : j.open}`);
  return t.$$set = (j) => {
    "heading" in j && i(1, r = j.heading), "maxwidth" in j && i(2, a = j.maxwidth), "mt" in j && i(3, s = j.mt), "mr" in j && i(4, d = j.mr), "mb" in j && i(5, u = j.mb), "ml" in j && i(6, c = j.ml), "open" in j && i(0, g = j.open), "testid" in j && i(7, h = j.testid), "$$scope" in j && i(12, o = j.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*open*/
    1 && i(11, n = Ce(g));
  }, [
    g,
    r,
    a,
    s,
    d,
    u,
    c,
    h,
    m,
    v,
    b,
    n,
    o,
    l,
    w,
    y
  ];
}
class Ad extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Fd,
      Od,
      ce,
      {
        heading: 1,
        maxwidth: 2,
        mt: 3,
        mr: 4,
        mb: 5,
        ml: 6,
        open: 0,
        testid: 7
      },
      Hd
    );
  }
  get heading() {
    return this.$$.ctx[1];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get maxwidth() {
    return this.$$.ctx[2];
  }
  set maxwidth(e) {
    this.$$set({ maxwidth: e }), k();
  }
  get mt() {
    return this.$$.ctx[3];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[4];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[5];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[6];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get open() {
    return this.$$.ctx[0];
  }
  set open(e) {
    this.$$set({ open: e }), k();
  }
  get testid() {
    return this.$$.ctx[7];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-details", he(Ad, { heading: {}, maxwidth: {}, mt: {}, mr: {}, mb: {}, ml: {}, open: {}, testid: {} }, ["default"], [], !0));
function Vd(t) {
  _e(t, "svelte-rg4408", "hr.svelte-rg4408{padding:0;margin:0;height:1px;background-color:var(--goa-divider-color);border:none}");
}
function Id(t) {
  let e, i;
  return {
    c() {
      e = C("hr"), f(
        e,
        "data-testid",
        /*testid*/
        t[0]
      ), f(e, "style", i = be(
        /*mt*/
        t[1],
        /*mr*/
        t[2],
        /*mb*/
        t[3],
        /*ml*/
        t[4]
      )), f(e, "class", "svelte-rg4408");
    },
    m(n, l) {
      D(n, e, l);
    },
    p(n, [l]) {
      l & /*testid*/
      1 && f(
        e,
        "data-testid",
        /*testid*/
        n[0]
      ), l & /*mt, mr, mb, ml*/
      30 && i !== (i = be(
        /*mt*/
        n[1],
        /*mr*/
        n[2],
        /*mb*/
        n[3],
        /*ml*/
        n[4]
      )) && f(e, "style", i);
    },
    i: ve,
    o: ve,
    d(n) {
      n && P(e);
    }
  };
}
function xd(t, e, i) {
  let { testid: n = "" } = e, { mt: l = null } = e, { mr: o = null } = e, { mb: r = null } = e, { ml: a = null } = e;
  return t.$$set = (s) => {
    "testid" in s && i(0, n = s.testid), "mt" in s && i(1, l = s.mt), "mr" in s && i(2, o = s.mr), "mb" in s && i(3, r = s.mb), "ml" in s && i(4, a = s.ml);
  }, [n, l, o, r, a];
}
class Bd extends me {
  constructor(e) {
    super(), ge(this, e, xd, Id, ce, { testid: 0, mt: 1, mr: 2, mb: 3, ml: 4 }, Vd);
  }
  get testid() {
    return this.$$.ctx[0];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[1];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[2];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[3];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[4];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-divider", he(Bd, { testid: {}, mt: {}, mr: {}, mb: {}, ml: {} }, [], [], !0));
function Nd(t) {
  _e(t, "svelte-1gx4pzb", ":host .svelte-1gx4pzb{box-sizing:border-box}.root.svelte-1gx4pzb{position:fixed;inset:0;z-index:998;transition:opacity 200ms ease-out}.background.svelte-1gx4pzb{position:fixed;inset:0;z-index:999;border:none;background-color:var(--goa-drawer-overlay-color)}.drawer.svelte-1gx4pzb{font-family:var(--goa-font-family-sans);position:fixed;z-index:9999;transition:all var(--goa-drawer-transition-time) ease-out;display:flex;flex-direction:column;background-color:#f8f8f8}.topbar.svelte-1gx4pzb{border-bottom:1px solid var(--goa-color-greyscale-200);display:flex;padding:var(--goa-space-m);justify-content:space-between}.heading.svelte-1gx4pzb{font:var(--goa-typography-heading-s)}.drawer-content.svelte-1gx4pzb{flex:1 1 auto}.scroll-content.svelte-1gx4pzb{padding:var(--goa-space-m)}.drawer-actions.svelte-1gx4pzb{width:100%;padding:var(--goa-space-l) var(--goa-space-xl) var(--goa-space-xl);border-top:var(--goa-border-width-s) solid var(--goa-color-greyscale-200);box-shadow:0 -2px 4px rgba(0, 0, 0, 0.1);background:var(--goa-color-greyscale-white)}.drawer-close.svelte-1gx4pzb{padding-left:var(--goa-space-m);margin-top:var(--goa-space-2xs)}.drawer-bottom.svelte-1gx4pzb{bottom:var(--drawer-offset);width:100%;border-top-left-radius:0.5rem;border-top-right-radius:0.5rem;box-shadow:var(--goa-drawer-bottom-shadow)}.drawer-open-bottom.svelte-1gx4pzb{bottom:0}.drawer-right.svelte-1gx4pzb{right:var(--drawer-offset);height:100%;box-shadow:var(--goa-drawer-right-shadow)}.drawer-open-right.svelte-1gx4pzb{right:0}.drawer-left.svelte-1gx4pzb{left:var(--drawer-offset);height:100%;box-shadow:var(--goa-drawer-left-shadow)}.drawer-open-left.svelte-1gx4pzb{left:0}");
}
const Wd = (t) => ({}), Jn = (t) => ({});
function Qn(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[10].actions
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[9],
    Jn
  );
  return {
    c() {
      e = C("section"), l && l.c(), f(e, "class", "drawer-actions svelte-1gx4pzb"), f(e, "data-testid", "drawer-actions");
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null), i = !0;
    },
    p(o, r) {
      l && l.p && (!i || r & /*$$scope*/
      512) && ae(
        l,
        n,
        o,
        /*$$scope*/
        o[9],
        i ? re(
          n,
          /*$$scope*/
          o[9],
          r,
          Wd
        ) : se(
          /*$$scope*/
          o[9]
        ),
        Jn
      );
    },
    i(o) {
      i || (Y(l, o), i = !0);
    },
    o(o) {
      U(l, o), i = !1;
    },
    d(o) {
      o && P(e), l && l.d(o);
    }
  };
}
function Rd(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v, b, w, y, j, E, M, L;
  const z = (
    /*#slots*/
    t[10].default
  ), V = oe(
    z,
    t,
    /*$$scope*/
    t[9],
    null
  );
  let T = (
    /*$$slots*/
    t[8].actions && Qn(t)
  );
  return {
    c() {
      e = C("div"), i = C("button"), l = x(), o = C("div"), r = C("div"), a = C("div"), s = le(
        /*heading*/
        t[3]
      ), d = x(), u = C("goa-icon-button"), c = x(), g = C("div"), h = C("goa-scrollable"), m = C("div"), V && V.c(), v = x(), T && T.c(), f(i, "class", "background svelte-1gx4pzb"), f(i, "data-testid", "background"), f(i, "style", n = ze(
        "opacity",
        /*open*/
        t[1] ? "1" : "0"
      )), f(a, "class", "heading svelte-1gx4pzb"), p(u, "data-ignore-focus", "true"), p(u, "data-testid", "drawer-close-button"), p(u, "arialabel", "Close the drawer"), p(u, "variant", "dark"), p(u, "icon", "close"), p(u, "class", "svelte-1gx4pzb"), f(r, "class", "topbar svelte-1gx4pzb"), f(m, "class", "scroll-content svelte-1gx4pzb"), p(h, "direction", "vertical"), p(
        h,
        "maxheight",
        /*scrollableHeight*/
        t[7]()
      ), p(h, "class", "svelte-1gx4pzb"), f(g, "data-testid", "drawer-content"), f(g, "class", "drawer-content svelte-1gx4pzb"), f(o, "style", b = Ue(
        ze("--drawer-offset", `-${/*_drawerSize*/
        t[5]}px`),
        ze(
          "height",
          /*position*/
          t[2] === "bottom" ? "unset" : "100vh"
        ),
        ze(
          "max-width",
          /*position*/
          t[2] === "bottom" ? "unset" : (
            /*maxsize*/
            t[0]
          )
        ),
        ze(
          "width",
          /*position*/
          t[2] === "bottom" ? "100%" : (
            /*maxsize*/
            t[0]
          )
        )
      )), f(o, "class", w = Ee(`drawer drawer-${/*position*/
      t[2]}`) + " svelte-1gx4pzb"), G(
        o,
        "drawer-open-bottom",
        /*position*/
        t[2] === "bottom" && /*open*/
        t[1]
      ), G(
        o,
        "drawer-open-right",
        /*position*/
        t[2] === "right" && /*open*/
        t[1]
      ), G(
        o,
        "drawer-open-left",
        /*position*/
        t[2] === "left" && /*open*/
        t[1]
      ), f(e, "class", "root svelte-1gx4pzb"), f(e, "style", j = ze(
        "visibility",
        /*open*/
        t[1] ? "visible" : "hidden"
      )), f(e, "data-testid", "drawer");
    },
    m(S, A) {
      D(S, e, A), _(e, i), _(e, l), _(e, o), _(o, r), _(r, a), _(a, s), _(r, d), _(r, u), _(o, c), _(o, g), _(g, h), _(h, m), V && V.m(m, null), _(o, v), T && T.m(o, null), t[11](o), E = !0, M || (L = [
        te(
          i,
          "click",
          /*close*/
          t[6]
        ),
        te(
          u,
          "click",
          /*close*/
          t[6]
        ),
        Fi(y = Yi.call(null, o, { enable: (
          /*open*/
          t[1]
        ) }))
      ], M = !0);
    },
    p(S, [A]) {
      (!E || A & /*open*/
      2 && n !== (n = ze(
        "opacity",
        /*open*/
        S[1] ? "1" : "0"
      ))) && f(i, "style", n), (!E || A & /*heading*/
      8) && pe(
        s,
        /*heading*/
        S[3]
      ), V && V.p && (!E || A & /*$$scope*/
      512) && ae(
        V,
        z,
        S,
        /*$$scope*/
        S[9],
        E ? re(
          z,
          /*$$scope*/
          S[9],
          A,
          null
        ) : se(
          /*$$scope*/
          S[9]
        ),
        null
      ), /*$$slots*/
      S[8].actions ? T ? (T.p(S, A), A & /*$$slots*/
      256 && Y(T, 1)) : (T = Qn(S), T.c(), Y(T, 1), T.m(o, null)) : T && (Oe(), U(T, 1, 1, () => {
        T = null;
      }), Fe()), (!E || A & /*_drawerSize, position, maxsize*/
      37 && b !== (b = Ue(
        ze("--drawer-offset", `-${/*_drawerSize*/
        S[5]}px`),
        ze(
          "height",
          /*position*/
          S[2] === "bottom" ? "unset" : "100vh"
        ),
        ze(
          "max-width",
          /*position*/
          S[2] === "bottom" ? "unset" : (
            /*maxsize*/
            S[0]
          )
        ),
        ze(
          "width",
          /*position*/
          S[2] === "bottom" ? "100%" : (
            /*maxsize*/
            S[0]
          )
        )
      ))) && f(o, "style", b), (!E || A & /*position*/
      4 && w !== (w = Ee(`drawer drawer-${/*position*/
      S[2]}`) + " svelte-1gx4pzb")) && f(o, "class", w), y && ot(y.update) && A & /*open*/
      2 && y.update.call(null, { enable: (
        /*open*/
        S[1]
      ) }), (!E || A & /*position, position, open*/
      6) && G(
        o,
        "drawer-open-bottom",
        /*position*/
        S[2] === "bottom" && /*open*/
        S[1]
      ), (!E || A & /*position, position, open*/
      6) && G(
        o,
        "drawer-open-right",
        /*position*/
        S[2] === "right" && /*open*/
        S[1]
      ), (!E || A & /*position, position, open*/
      6) && G(
        o,
        "drawer-open-left",
        /*position*/
        S[2] === "left" && /*open*/
        S[1]
      ), (!E || A & /*open*/
      2 && j !== (j = ze(
        "visibility",
        /*open*/
        S[1] ? "visible" : "hidden"
      ))) && f(e, "style", j);
    },
    i(S) {
      E || (Y(V, S), Y(T), E = !0);
    },
    o(S) {
      U(V, S), U(T), E = !1;
    },
    d(S) {
      S && P(e), V && V.d(S), T && T.d(), t[11](null), M = !1, He(L);
    }
  };
}
function Yd(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e;
  const o = pt(n);
  let { open: r = !1 } = e, { position: a = void 0 } = e, { heading: s = "" } = e, { maxsize: d = void 0 } = e, u = null, c;
  ke(async () => {
    await Pe(), a === "bottom" ? i(5, c = (u == null ? void 0 : u.getBoundingClientRect().height) ?? 0) : i(5, c = (u == null ? void 0 : u.getBoundingClientRect().width) ?? 0), window.addEventListener("keydown", h);
  }), ct(() => {
    window.removeEventListener("keydown", h);
  });
  function g(b) {
    r && qe(u, "_close", {}, { bubbles: !0 }), b.stopPropagation();
  }
  const h = (b) => {
    switch (b.key) {
      case "Escape":
        g(b), b.preventDefault();
        break;
    }
  };
  function m() {
    return a === "bottom" ? d : o.actions ? "calc(100vh - 12.5rem - 1px)" : "calc(100vh - 4rem)";
  }
  function v(b) {
    ue[b ? "unshift" : "push"](() => {
      u = b, i(4, u);
    });
  }
  return t.$$set = (b) => {
    "open" in b && i(1, r = b.open), "position" in b && i(2, a = b.position), "heading" in b && i(3, s = b.heading), "maxsize" in b && i(0, d = b.maxsize), "$$scope" in b && i(9, l = b.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*maxsize, position*/
    5 && i(0, d = d || (a === "bottom" ? "80vh" : "500px"));
  }, [
    d,
    r,
    a,
    s,
    u,
    c,
    g,
    m,
    o,
    l,
    n,
    v
  ];
}
class Zd extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Yd,
      Rd,
      ce,
      {
        open: 1,
        position: 2,
        heading: 3,
        maxsize: 0
      },
      Nd
    );
  }
  get open() {
    return this.$$.ctx[1];
  }
  set open(e) {
    this.$$set({ open: e }), k();
  }
  get position() {
    return this.$$.ctx[2];
  }
  set position(e) {
    this.$$set({ position: e }), k();
  }
  get heading() {
    return this.$$.ctx[3];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get maxsize() {
    return this.$$.ctx[0];
  }
  set maxsize(e) {
    this.$$set({ maxsize: e }), k();
  }
}
customElements.define("goa-drawer", he(Zd, { open: { type: "Boolean" }, position: {}, heading: {}, maxsize: {} }, ["default", "actions"], [], !0));
function Ud(t) {
  let e;
  return {
    c() {
      e = C("span");
    },
    m(i, n) {
      D(i, e, n), t[5](e);
    },
    p: ve,
    i: ve,
    o: ve,
    d(i) {
      i && P(e), t[5](null);
    }
  };
}
const Gr = "dropdown-item:mounted", Kr = "dropdown-item:destroyed";
function Gd(t, e, i) {
  let { filter: n = "" } = e, { label: l = "" } = e, { value: o = "" } = e, { mount: r = "reset" } = e, a, s;
  ke(() => {
    je(
      a,
      Gr,
      {
        el: a,
        filter: n,
        value: o,
        label: l,
        mountType: r
      },
      { bubbles: !0, timeout: 10 }
    ), d();
  });
  function d() {
    Re(a, (c, g) => {
      switch (c) {
        case "dropdown:bind":
          s = g.el;
          break;
      }
    });
  }
  ct(async () => {
    je(s, Kr, { value: o }, { bubbles: !0 });
  });
  function u(c) {
    ue[c ? "unshift" : "push"](() => {
      a = c, i(0, a);
    });
  }
  return t.$$set = (c) => {
    "filter" in c && i(1, n = c.filter), "label" in c && i(2, l = c.label), "value" in c && i(3, o = c.value), "mount" in c && i(4, r = c.mount);
  }, [a, n, l, o, r, u];
}
class Kd extends me {
  constructor(e) {
    super(), ge(this, e, Gd, Ud, ce, { filter: 1, label: 2, value: 3, mount: 4 });
  }
  get filter() {
    return this.$$.ctx[1];
  }
  set filter(e) {
    this.$$set({ filter: e }), k();
  }
  get label() {
    return this.$$.ctx[2];
  }
  set label(e) {
    this.$$set({ label: e }), k();
  }
  get value() {
    return this.$$.ctx[3];
  }
  set value(e) {
    this.$$set({ value: e }), k();
  }
  get mount() {
    return this.$$.ctx[4];
  }
  set mount(e) {
    this.$$set({ mount: e }), k();
  }
}
customElements.define("goa-dropdown-item", he(Kd, { filter: {}, label: {}, value: {}, mount: {} }, [], [], !0));
function Xd(t) {
  _e(t, "svelte-1m2w4vw", `:host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}.dropdown.svelte-1m2w4vw.svelte-1m2w4vw{cursor:pointer;width:var(--width, 100%);max-width:100%}.dropdown-input-group.svelte-1m2w4vw.svelte-1m2w4vw{box-sizing:border-box;outline:none;transition:var(--goa-dropdown-transition);box-shadow:var(--goa-dropdown-border);border-radius:var(--goa-dropdown-border-radius);display:inline-flex;align-items:stretch;vertical-align:middle;background-color:var(--goa-dropdown-color-bg);cursor:pointer;width:100%}.dropdown-input-group.svelte-1m2w4vw.svelte-1m2w4vw:hover{box-shadow:var( --goa-dropdown-border-hover);border:none}.dropdown-input-group.svelte-1m2w4vw.svelte-1m2w4vw:has(input:focus-visible){box-shadow:var(--goa-dropdown-border),
      var(--goa-dropdown-border-focus)}.dropdown-input-group.error.svelte-1m2w4vw.svelte-1m2w4vw,.dropdown-input-group.error.svelte-1m2w4vw.svelte-1m2w4vw:hover{box-shadow:var(--goa-dropdown-border-error)}.dropdown-input-group.error.svelte-1m2w4vw.svelte-1m2w4vw:has(:focus-visible){box-shadow:var(--goa-dropdown-border),
      var(--goa-dropdown-border-focus)}@container not (max-width: 623px){.dropdown-input-group.svelte-1m2w4vw.svelte-1m2w4vw{width:var(--width, 100%)}}.dropdown-icon--arrow.svelte-1m2w4vw.svelte-1m2w4vw,.dropdown-icon--clear.svelte-1m2w4vw.svelte-1m2w4vw{margin-right:var(--goa-dropdown-space-icon-text)}.dropdown-icon--clear.svelte-1m2w4vw.svelte-1m2w4vw:focus:not(.disabled),.dropdown-icon--clear.svelte-1m2w4vw.svelte-1m2w4vw:active:not(.disabled){outline:none}.dropdown-input--leading-icon.svelte-1m2w4vw.svelte-1m2w4vw{margin-left:var(--goa-dropdown-padding-lr)}.dropdown-input--leading-icon.svelte-1m2w4vw+input.svelte-1m2w4vw{padding-left:var(--goa-space-xs)}input.svelte-1m2w4vw.svelte-1m2w4vw{display:inline-block;font:var(--goa-dropdown-typography);color:var(--goa-dropdown-color-text);padding:var(--goa-dropdown-padding);background-color:transparent;width:100%;flex:1 1 auto;z-index:1;text-overflow:ellipsis}input.svelte-1m2w4vw.svelte-1m2w4vw,input.svelte-1m2w4vw.svelte-1m2w4vw:focus,input.svelte-1m2w4vw.svelte-1m2w4vw:hover,input.svelte-1m2w4vw.svelte-1m2w4vw:active{outline:none;border:none}input[aria-disabled="true"].svelte-1m2w4vw.svelte-1m2w4vw{color:var(--goa-dropdown-color-text-disabled)}.dropdown-input-group--disabled.svelte-1m2w4vw.svelte-1m2w4vw,.dropdown-input-group--disabled.svelte-1m2w4vw.svelte-1m2w4vw:hover,.dropdown-input-group--disabled.svelte-1m2w4vw.svelte-1m2w4vw:active,.dropdown-input-group--disabled.svelte-1m2w4vw.svelte-1m2w4vw:focus{background-color:var(--goa-dropdown-color-bg-disabled);box-shadow:var(--goa-dropdown-border-disabled);cursor:default}.dropdown-input-group--disabled.svelte-1m2w4vw goa-icon.svelte-1m2w4vw{outline:none;color:var(--goa-dropdown-color-text-disabled)}ul[role="listbox"].svelte-1m2w4vw.svelte-1m2w4vw{border-radius:var(--goa-dropdown-border-radius);padding:0;margin:0}.dropdown-item.svelte-1m2w4vw.svelte-1m2w4vw{margin:0;padding:var(--goa-dropdown-item-padding);cursor:pointer;color:var(--goa-dropdown-item-color-text);overflow:hidden;white-space:normal;word-break:break-word;overflow-wrap:break-word}.dropdown-item.svelte-1m2w4vw.svelte-1m2w4vw:hover,.dropdown-item--highlighted.svelte-1m2w4vw.svelte-1m2w4vw{background:var(--goa-dropdown-item-color-bg-hover);color:var(--goa-dropdown-item-color-text-hover)}.dropdown-item[aria-selected="true"].svelte-1m2w4vw.svelte-1m2w4vw{background:var(--goa-dropdown-item-color-bg-selected);color:var(--goa-dropdown-item-color-text-selected)}.dropdown-item[aria-selected="true"].svelte-1m2w4vw.svelte-1m2w4vw:hover,.dropdown-item[aria-selected="true"].dropdown-item--highlighted.svelte-1m2w4vw.svelte-1m2w4vw{background:var(--goa-dropdown-item-color-bg-selected-hover);color:var(--goa-dropdown-item-color-text-selected-hover)}.dropdown-native.svelte-1m2w4vw.svelte-1m2w4vw{position:relative;box-shadow:var(--goa-dropdown-border);border-radius:var(--goa-dropdown-border-radius);background-color:var(--goa-dropdown-color-bg);transition:var(--goa-dropdown-transition)}.dropdown-native.svelte-1m2w4vw.svelte-1m2w4vw:has(select:disabled){background-color:var(--goa-dropdown-color-bg-disabled);box-shadow:var(--goa-dropdown-border-disabled);color:var(--goa-color-text-secondary);cursor:default}.dropdown-native.svelte-1m2w4vw.svelte-1m2w4vw:has(select.error){box-shadow:var(--goa-dropdown-border-error)}.dropdown-native.svelte-1m2w4vw.svelte-1m2w4vw:hover{box-shadow:var(--goa-dropdown-border-hover)}select.svelte-1m2w4vw.svelte-1m2w4vw{border:none;font:var(--goa-dropdown-typography);background-color:transparent;color:var(--goa-dropdown-color-text);-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:calc(var(--goa-space-xs) + 1px);padding-left:var(--goa-space-s);padding-right:3rem;outline:none;width:100%}.dropdown-native.svelte-1m2w4vw.svelte-1m2w4vw::after{content:"";position:absolute;right:0.6rem;top:0.6rem;pointer-events:none;width:1.5rem;height:1.5rem;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='none' stroke='%23333333' stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M112 184l144 144 144-144' /%3E%3C/svg%3E");background-repeat:none}.dropdown-native.svelte-1m2w4vw.svelte-1m2w4vw:has(:focus-visible){box-shadow:var(--goa-dropdown-border),
      var(--goa-dropdown-border-focus)}goa-icon.svelte-1m2w4vw.svelte-1m2w4vw:focus-visible{outline:none}.svelte-1m2w4vw.svelte-1m2w4vw::-moz-placeholder{color:var(--goa-dropdown-color-text-placeholder);opacity:1}.svelte-1m2w4vw.svelte-1m2w4vw::placeholder{color:var(--goa-dropdown-color-text-placeholder);opacity:1}`);
}
function $n(t, e, i) {
  const n = t.slice();
  return n[76] = e[i], n[80] = i, n;
}
function el(t, e, i) {
  const n = t.slice();
  return n[76] = e[i], n;
}
function Jd(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v = [], b = /* @__PURE__ */ new Map(), w, y, j, E, M, L, z;
  const V = (
    /*#slots*/
    t[49].default
  ), T = oe(
    V,
    t,
    /*$$scope*/
    t[48],
    null
  );
  let S = (
    /*leadingicon*/
    t[4] && tl(t)
  );
  function A(q, H) {
    var O;
    return (
      /*_inputEl*/
      (O = q[18]) != null && O.value && /*_filterable*/
      q[30] ? ec : $d
    );
  }
  let R = A(t), I = R(t), B = Le(
    /*_filteredOptions*/
    t[19]
  );
  const N = (q) => (
    /*index*/
    q[80]
  );
  for (let q = 0; q < B.length; q += 1) {
    let H = $n(t, B, q), O = N(H);
    b.set(O, v[q] = ll(O, H));
  }
  let F = null;
  return B.length || (F = il(t)), {
    c() {
      var q, H;
      T && T.c(), e = x(), i = C("goa-popover"), n = C("div"), S && S.c(), l = x(), o = C("input"), g = x(), I.c(), h = x(), m = C("ul");
      for (let O = 0; O < v.length; O += 1)
        v[O].c();
      F && F.c(), f(o, "style", r = `
            cursor: ${/*_disabled*/
      t[29] ? "default" : (
        /*_filterable*/
        t[30] ? "auto" : "pointer"
      )};
          `), f(o, "data-testid", "input"), o.value = a = /*_selectedOption*/
      ((q = t[22]) == null ? void 0 : q.label) || /*_selectedOption*/
      ((H = t[22]) == null ? void 0 : H.value) || "", f(o, "type", "text"), f(o, "role", "combobox"), f(o, "autocomplete", "off"), f(o, "aria-autocomplete", "list"), f(o, "aria-controls", s = `menu-${/*name*/
      t[1]}`), f(
        o,
        "aria-expanded",
        /*_isMenuVisible*/
        t[23]
      ), f(o, "aria-label", d = /*arialabel*/
      t[2] || /*name*/
      t[1]), f(
        o,
        "aria-labelledby",
        /*arialabelledby*/
        t[3]
      ), f(
        o,
        "id",
        /*name*/
        t[1]
      ), f(
        o,
        "aria-activedescendant",
        /*_activeDescendantId*/
        t[28]
      ), f(
        o,
        "aria-disabled",
        /*_disabled*/
        t[29]
      ), f(o, "aria-owns", u = /*_isMenuVisible*/
      t[23] ? `menu-${/*name*/
      t[1]}` : void 0), f(o, "aria-haspopup", "listbox"), o.disabled = /*_disabled*/
      t[29], o.readOnly = c = !/*_filterable*/
      t[30], f(
        o,
        "placeholder",
        /*placeholder*/
        t[6]
      ), f(
        o,
        "name",
        /*name*/
        t[1]
      ), f(o, "class", "svelte-1m2w4vw"), f(n, "slot", "target"), f(n, "class", "dropdown-input-group svelte-1m2w4vw"), G(
        n,
        "dropdown-input-group--disabled",
        /*_disabled*/
        t[29]
      ), G(
        n,
        "error",
        /*_error*/
        t[20]
      ), f(m, "id", w = `menu-${/*name*/
      t[1]}`), f(m, "role", "listbox"), f(m, "tabindex", "-1"), f(m, "data-testid", "dropdown-menu"), f(m, "aria-label", y = /*arialabel*/
      t[2] || /*name*/
      t[1]), f(
        m,
        "aria-labelledby",
        /*arialabelledby*/
        t[3]
      ), f(m, "style", j = `
            outline: none;
            overflow-y: auto;
            max-height: ${/*maxheight*/
      t[5]};
          `), f(m, "class", "svelte-1m2w4vw"), p(
        i,
        "disabled",
        /*disabled*/
        t[7]
      ), p(
        i,
        "relative",
        /*relative*/
        t[8]
      ), p(i, "data-testid", "option-list"), p(i, "width", E = `${/*_popoverMaxWidth*/
      t[24] || 0}`), p(
        i,
        "minwidth",
        /*_dropdownWidth*/
        t[27]
      ), p(
        i,
        "maxwidth",
        /*_dropdownWidth*/
        t[27]
      ), p(
        i,
        "open",
        /*_isMenuVisible*/
        t[23]
      ), p(i, "padded", "false"), p(i, "tabindex", "-1"), p(i, "class", "svelte-1m2w4vw");
    },
    m(q, H) {
      T && T.m(q, H), D(q, e, H), D(q, i, H), _(i, n), S && S.m(n, null), _(n, l), _(n, o), t[50](o), _(n, g), I.m(n, null), _(i, h), _(i, m);
      for (let O = 0; O < v.length; O += 1)
        v[O] && v[O].m(m, null);
      F && F.m(m, null), t[52](m), M = !0, L || (z = [
        te(
          o,
          "keydown",
          /*onInputKeyDown*/
          t[36]
        ),
        te(
          o,
          "keyup",
          /*onInputKeyUp*/
          t[35]
        ),
        te(
          o,
          "change",
          /*onChange*/
          t[34]
        ),
        te(
          o,
          "focus",
          /*onFocus*/
          t[41]
        ),
        te(
          m,
          "focus",
          /*onFocus*/
          t[41]
        ),
        te(
          i,
          "_open",
          /*showMenu*/
          t[31]
        ),
        te(
          i,
          "_close",
          /*hideMenu*/
          t[32]
        )
      ], L = !0);
    },
    p(q, H) {
      var O, W;
      T && T.p && (!M || H[1] & /*$$scope*/
      131072) && ae(
        T,
        V,
        q,
        /*$$scope*/
        q[48],
        M ? re(
          V,
          /*$$scope*/
          q[48],
          H,
          null
        ) : se(
          /*$$scope*/
          q[48]
        ),
        null
      ), /*leadingicon*/
      q[4] ? S ? S.p(q, H) : (S = tl(q), S.c(), S.m(n, l)) : S && (S.d(1), S = null), (!M || H[0] & /*_disabled, _filterable*/
      1610612736 && r !== (r = `
            cursor: ${/*_disabled*/
      q[29] ? "default" : (
        /*_filterable*/
        q[30] ? "auto" : "pointer"
      )};
          `)) && f(o, "style", r), (!M || H[0] & /*_selectedOption*/
      4194304 && a !== (a = /*_selectedOption*/
      ((O = q[22]) == null ? void 0 : O.label) || /*_selectedOption*/
      ((W = q[22]) == null ? void 0 : W.value) || "") && o.value !== a) && (o.value = a), (!M || H[0] & /*name*/
      2 && s !== (s = `menu-${/*name*/
      q[1]}`)) && f(o, "aria-controls", s), (!M || H[0] & /*_isMenuVisible*/
      8388608) && f(
        o,
        "aria-expanded",
        /*_isMenuVisible*/
        q[23]
      ), (!M || H[0] & /*arialabel, name*/
      6 && d !== (d = /*arialabel*/
      q[2] || /*name*/
      q[1])) && f(o, "aria-label", d), (!M || H[0] & /*arialabelledby*/
      8) && f(
        o,
        "aria-labelledby",
        /*arialabelledby*/
        q[3]
      ), (!M || H[0] & /*name*/
      2) && f(
        o,
        "id",
        /*name*/
        q[1]
      ), (!M || H[0] & /*_activeDescendantId*/
      268435456) && f(
        o,
        "aria-activedescendant",
        /*_activeDescendantId*/
        q[28]
      ), (!M || H[0] & /*_disabled*/
      536870912) && f(
        o,
        "aria-disabled",
        /*_disabled*/
        q[29]
      ), (!M || H[0] & /*_isMenuVisible, name*/
      8388610 && u !== (u = /*_isMenuVisible*/
      q[23] ? `menu-${/*name*/
      q[1]}` : void 0)) && f(o, "aria-owns", u), (!M || H[0] & /*_disabled*/
      536870912) && (o.disabled = /*_disabled*/
      q[29]), (!M || H[0] & /*_filterable*/
      1073741824 && c !== (c = !/*_filterable*/
      q[30])) && (o.readOnly = c), (!M || H[0] & /*placeholder*/
      64) && f(
        o,
        "placeholder",
        /*placeholder*/
        q[6]
      ), (!M || H[0] & /*name*/
      2) && f(
        o,
        "name",
        /*name*/
        q[1]
      ), R === (R = A(q)) && I ? I.p(q, H) : (I.d(1), I = R(q), I && (I.c(), I.m(n, null))), (!M || H[0] & /*_disabled*/
      536870912) && G(
        n,
        "dropdown-input-group--disabled",
        /*_disabled*/
        q[29]
      ), (!M || H[0] & /*_error*/
      1048576) && G(
        n,
        "error",
        /*_error*/
        q[20]
      ), H[0] & /*_filteredOptions, _selectedOption, _highlightedIndex, _isDirty, _filterable*/
      1145602048 | H[1] & /*onSelect*/
      4 && (B = Le(
        /*_filteredOptions*/
        q[19]
      ), v = Sa(v, H, N, 1, q, B, b, m, qa, ll, null, $n), !B.length && F ? F.p(q, H) : B.length ? F && (F.d(1), F = null) : (F = il(q), F.c(), F.m(m, null))), (!M || H[0] & /*name*/
      2 && w !== (w = `menu-${/*name*/
      q[1]}`)) && f(m, "id", w), (!M || H[0] & /*arialabel, name*/
      6 && y !== (y = /*arialabel*/
      q[2] || /*name*/
      q[1])) && f(m, "aria-label", y), (!M || H[0] & /*arialabelledby*/
      8) && f(
        m,
        "aria-labelledby",
        /*arialabelledby*/
        q[3]
      ), (!M || H[0] & /*maxheight*/
      32 && j !== (j = `
            outline: none;
            overflow-y: auto;
            max-height: ${/*maxheight*/
      q[5]};
          `)) && f(m, "style", j), (!M || H[0] & /*disabled*/
      128) && p(
        i,
        "disabled",
        /*disabled*/
        q[7]
      ), (!M || H[0] & /*relative*/
      256) && p(
        i,
        "relative",
        /*relative*/
        q[8]
      ), (!M || H[0] & /*_popoverMaxWidth*/
      16777216 && E !== (E = `${/*_popoverMaxWidth*/
      q[24] || 0}`)) && p(i, "width", E), (!M || H[0] & /*_dropdownWidth*/
      134217728) && p(
        i,
        "minwidth",
        /*_dropdownWidth*/
        q[27]
      ), (!M || H[0] & /*_dropdownWidth*/
      134217728) && p(
        i,
        "maxwidth",
        /*_dropdownWidth*/
        q[27]
      ), (!M || H[0] & /*_isMenuVisible*/
      8388608) && p(
        i,
        "open",
        /*_isMenuVisible*/
        q[23]
      );
    },
    i(q) {
      M || (Y(T, q), M = !0);
    },
    o(q) {
      U(T, q), M = !1;
    },
    d(q) {
      q && (P(e), P(i)), T && T.d(q), S && S.d(), t[50](null), I.d();
      for (let H = 0; H < v.length; H += 1)
        v[H].d();
      F && F.d(), t[52](null), L = !1, He(z);
    }
  };
}
function Qd(t) {
  let e, i, n, l, o;
  const r = (
    /*#slots*/
    t[49].default
  ), a = oe(
    r,
    t,
    /*$$scope*/
    t[48],
    null
  );
  let s = Le(
    /*_options*/
    t[14]
  ), d = [];
  for (let u = 0; u < s.length; u += 1)
    d[u] = ol(el(t, s, u));
  return {
    c() {
      e = C("select"), a && a.c();
      for (let u = 0; u < d.length; u += 1)
        d[u].c();
      f(
        e,
        "name",
        /*name*/
        t[1]
      ), f(e, "aria-label", i = /*arialabel*/
      t[2] || /*name*/
      t[1]), f(
        e,
        "aria-labelledby",
        /*arialabelledby*/
        t[3]
      ), e.disabled = /*_disabled*/
      t[29], f(
        e,
        "id",
        /*name*/
        t[1]
      ), f(e, "class", "svelte-1m2w4vw"), G(
        e,
        "error",
        /*_error*/
        t[20]
      );
    },
    m(u, c) {
      D(u, e, c), a && a.m(e, null);
      for (let g = 0; g < d.length; g += 1)
        d[g] && d[g].m(e, null);
      n = !0, l || (o = [
        te(
          e,
          "change",
          /*onNativeSelect*/
          t[39]
        ),
        te(
          e,
          "focus",
          /*onFocus*/
          t[41]
        )
      ], l = !0);
    },
    p(u, c) {
      if (a && a.p && (!n || c[1] & /*$$scope*/
      131072) && ae(
        a,
        r,
        u,
        /*$$scope*/
        u[48],
        n ? re(
          r,
          /*$$scope*/
          u[48],
          c,
          null
        ) : se(
          /*$$scope*/
          u[48]
        ),
        null
      ), c[0] & /*value, _options*/
      16385) {
        s = Le(
          /*_options*/
          u[14]
        );
        let g;
        for (g = 0; g < s.length; g += 1) {
          const h = el(u, s, g);
          d[g] ? d[g].p(h, c) : (d[g] = ol(h), d[g].c(), d[g].m(e, null));
        }
        for (; g < d.length; g += 1)
          d[g].d(1);
        d.length = s.length;
      }
      (!n || c[0] & /*name*/
      2) && f(
        e,
        "name",
        /*name*/
        u[1]
      ), (!n || c[0] & /*arialabel, name*/
      6 && i !== (i = /*arialabel*/
      u[2] || /*name*/
      u[1])) && f(e, "aria-label", i), (!n || c[0] & /*arialabelledby*/
      8) && f(
        e,
        "aria-labelledby",
        /*arialabelledby*/
        u[3]
      ), (!n || c[0] & /*_disabled*/
      536870912) && (e.disabled = /*_disabled*/
      u[29]), (!n || c[0] & /*name*/
      2) && f(
        e,
        "id",
        /*name*/
        u[1]
      ), (!n || c[0] & /*_error*/
      1048576) && G(
        e,
        "error",
        /*_error*/
        u[20]
      );
    },
    i(u) {
      n || (Y(a, u), n = !0);
    },
    o(u) {
      U(a, u), n = !1;
    },
    d(u) {
      u && P(e), a && a.d(u), Ye(d, u), l = !1, He(o);
    }
  };
}
function tl(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "class", "dropdown-input--leading-icon svelte-1m2w4vw"), p(e, "data-testid", "leading-icon"), p(
        e,
        "type",
        /*leadingicon*/
        t[4]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n[0] & /*leadingicon*/
      16 && p(
        e,
        "type",
        /*leadingicon*/
        i[4]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function $d(t) {
  let e, i, n, l, o, r, a;
  return {
    c() {
      e = C("goa-icon"), p(e, "role", "button"), p(e, "tabindex", "0"), p(
        e,
        "id",
        /*name*/
        t[1]
      ), p(e, "arialabel", i = /*arialabel*/
      t[2] || /*name*/
      t[1]), p(e, "ariacontrols", n = `menu-${/*name*/
      t[1]}`), p(e, "ariaexpanded", l = vt(
        /*_isMenuVisible*/
        t[23]
      )), p(e, "class", "dropdown-icon--arrow svelte-1m2w4vw"), p(e, "size", "medium"), p(e, "type", o = /*_isMenuVisible*/
      t[23] ? "chevron-up" : "chevron-down");
    },
    m(s, d) {
      D(s, e, d), r || (a = te(
        e,
        "click",
        /*onChevronClick*/
        t[40]
      ), r = !0);
    },
    p(s, d) {
      d[0] & /*name*/
      2 && p(
        e,
        "id",
        /*name*/
        s[1]
      ), d[0] & /*arialabel, name*/
      6 && i !== (i = /*arialabel*/
      s[2] || /*name*/
      s[1]) && p(e, "arialabel", i), d[0] & /*name*/
      2 && n !== (n = `menu-${/*name*/
      s[1]}`) && p(e, "ariacontrols", n), d[0] & /*_isMenuVisible*/
      8388608 && l !== (l = vt(
        /*_isMenuVisible*/
        s[23]
      )) && p(e, "ariaexpanded", l), d[0] & /*_isMenuVisible*/
      8388608 && o !== (o = /*_isMenuVisible*/
      s[23] ? "chevron-up" : "chevron-down") && p(e, "type", o);
    },
    d(s) {
      s && P(e), r = !1, a();
    }
  };
}
function ec(t) {
  let e, i, n, l, o, r, a;
  return {
    c() {
      e = C("goa-icon"), p(
        e,
        "id",
        /*name*/
        t[1]
      ), p(e, "data-testid", "clear-icon"), p(e, "tabindex", i = /*_disabled*/
      t[29] ? -1 : 0), p(e, "role", "button"), p(e, "arialabel", n = `clear ${/*arialabel*/
      t[2] || /*name*/
      t[1]}`), p(e, "ariacontrols", l = `menu-${/*name*/
      t[1]}`), p(e, "ariaexpanded", o = vt(
        /*_isMenuVisible*/
        t[23]
      )), p(e, "class", "dropdown-icon--clear svelte-1m2w4vw"), p(e, "size", "medium"), p(e, "type", "close"), p(e, "theme", "filled"), G(
        e,
        "disabled",
        /*_disabled*/
        t[29]
      );
    },
    m(s, d) {
      D(s, e, d), r || (a = [
        te(
          e,
          "click",
          /*onClearIconClick*/
          t[38]
        ),
        te(
          e,
          "keydown",
          /*onClearIconKeyDown*/
          t[37]
        )
      ], r = !0);
    },
    p(s, d) {
      d[0] & /*name*/
      2 && p(
        e,
        "id",
        /*name*/
        s[1]
      ), d[0] & /*_disabled*/
      536870912 && i !== (i = /*_disabled*/
      s[29] ? -1 : 0) && p(e, "tabindex", i), d[0] & /*arialabel, name*/
      6 && n !== (n = `clear ${/*arialabel*/
      s[2] || /*name*/
      s[1]}`) && p(e, "arialabel", n), d[0] & /*name*/
      2 && l !== (l = `menu-${/*name*/
      s[1]}`) && p(e, "ariacontrols", l), d[0] & /*_isMenuVisible*/
      8388608 && o !== (o = vt(
        /*_isMenuVisible*/
        s[23]
      )) && p(e, "ariaexpanded", o), d[0] & /*_disabled*/
      536870912 && G(
        e,
        "disabled",
        /*_disabled*/
        s[29]
      );
    },
    d(s) {
      s && P(e), r = !1, He(a);
    }
  };
}
function il(t) {
  let e, i = (
    /*_filterable*/
    t[30] && nl()
  );
  return {
    c() {
      i && i.c(), e = Ne();
    },
    m(n, l) {
      i && i.m(n, l), D(n, e, l);
    },
    p(n, l) {
      /*_filterable*/
      n[30] ? i || (i = nl(), i.c(), i.m(e.parentNode, e)) : i && (i.d(1), i = null);
    },
    d(n) {
      n && P(e), i && i.d(n);
    }
  };
}
function nl(t) {
  let e;
  return {
    c() {
      e = C("li"), e.textContent = `No matches found
            `, f(e, "class", "dropdown-item svelte-1m2w4vw"), f(e, "data-testid", "dropdown-item-not-found");
    },
    m(i, n) {
      D(i, e, n);
    },
    d(i) {
      i && P(e);
    }
  };
}
function ll(t, e) {
  let i, n = (
    /*option*/
    (e[76].label || /*option*/
    e[76].value) + ""
  ), l, o, r, a, s, d, u, c, g;
  function h() {
    return (
      /*click_handler*/
      e[51](
        /*option*/
        e[76]
      )
    );
  }
  return {
    key: t,
    first: null,
    c() {
      var m, v;
      i = C("li"), l = le(n), o = x(), f(i, "id", r = /*option*/
      e[76].value), f(i, "aria-selected", a = /*_selectedOption*/
      ((m = e[22]) == null ? void 0 : m.value) === /*option*/
      (e[76].label || /*option*/
      e[76].value)), f(i, "class", "dropdown-item svelte-1m2w4vw"), f(i, "data-index", s = /*index*/
      e[80]), f(i, "data-testid", d = `dropdown-item-${/*option*/
      e[76].value}`), f(i, "data-value", u = /*option*/
      e[76].value), f(i, "role", "option"), Be(i, "display", "block"), G(
        i,
        "selected",
        /*_selectedOption*/
        ((v = e[22]) == null ? void 0 : v.value) === /*option*/
        (e[76].label || /*option*/
        e[76].value)
      ), G(
        i,
        "dropdown-item--highlighted",
        /*index*/
        e[80] === /*_highlightedIndex*/
        e[15]
      ), this.first = i;
    },
    m(m, v) {
      D(m, i, v), _(i, l), _(i, o), c || (g = te(i, "click", h), c = !0);
    },
    p(m, v) {
      var b, w;
      e = m, v[0] & /*_filteredOptions*/
      524288 && n !== (n = /*option*/
      (e[76].label || /*option*/
      e[76].value) + "") && pe(l, n), v[0] & /*_filteredOptions*/
      524288 && r !== (r = /*option*/
      e[76].value) && f(i, "id", r), v[0] & /*_selectedOption, _filteredOptions*/
      4718592 && a !== (a = /*_selectedOption*/
      ((b = e[22]) == null ? void 0 : b.value) === /*option*/
      (e[76].label || /*option*/
      e[76].value)) && f(i, "aria-selected", a), v[0] & /*_filteredOptions*/
      524288 && s !== (s = /*index*/
      e[80]) && f(i, "data-index", s), v[0] & /*_filteredOptions*/
      524288 && d !== (d = `dropdown-item-${/*option*/
      e[76].value}`) && f(i, "data-testid", d), v[0] & /*_filteredOptions*/
      524288 && u !== (u = /*option*/
      e[76].value) && f(i, "data-value", u), v[0] & /*_selectedOption, _filteredOptions*/
      4718592 && G(
        i,
        "selected",
        /*_selectedOption*/
        ((w = e[22]) == null ? void 0 : w.value) === /*option*/
        (e[76].label || /*option*/
        e[76].value)
      ), v[0] & /*_filteredOptions, _highlightedIndex*/
      557056 && G(
        i,
        "dropdown-item--highlighted",
        /*index*/
        e[80] === /*_highlightedIndex*/
        e[15]
      );
    },
    d(m) {
      m && P(i), c = !1, g();
    }
  };
}
function ol(t) {
  let e, i = (
    /*option*/
    t[76].label + ""
  ), n, l, o, r;
  return {
    c() {
      e = C("option"), n = le(i), l = x(), e.selected = o = /*value*/
      t[0] === /*option*/
      t[76].value, e.__value = r = /*option*/
      t[76].value, ri(e, e.__value), f(e, "class", "svelte-1m2w4vw");
    },
    m(a, s) {
      D(a, e, s), _(e, n), _(e, l);
    },
    p(a, s) {
      s[0] & /*_options*/
      16384 && i !== (i = /*option*/
      a[76].label + "") && pe(n, i), s[0] & /*value, _options*/
      16385 && o !== (o = /*value*/
      a[0] === /*option*/
      a[76].value) && (e.selected = o), s[0] & /*_options*/
      16384 && r !== (r = /*option*/
      a[76].value) && (e.__value = r, ri(e, e.__value));
    },
    d(a) {
      a && P(e);
    }
  };
}
function tc(t) {
  let e, i, n, l, o, r, a;
  const s = [Qd, Jd], d = [];
  function u(c, g) {
    return (
      /*_native*/
      c[21] ? 0 : 1
    );
  }
  return i = u(t), n = d[i] = s[i](t), {
    c() {
      e = C("div"), n.c(), f(e, "data-testid", l = /*testid*/
      t[13] || `${/*name*/
      t[1]}-dropdown`), f(e, "class", "dropdown svelte-1m2w4vw"), f(e, "style", o = `
      ${be(
        /*mt*/
        t[9],
        /*mr*/
        t[10],
        /*mb*/
        t[11],
        /*ml*/
        t[12]
      )};
      --width: ${/*_width*/
      t[16]};
    `), We(() => (
        /*div_elementresize_handler*/
        t[54].call(e)
      )), G(
        e,
        "dropdown-native",
        /*_native*/
        t[21]
      );
    },
    m(c, g) {
      D(c, e, g), d[i].m(e, null), t[53](e), r = ki(
        e,
        /*div_elementresize_handler*/
        t[54].bind(e)
      ), a = !0;
    },
    p(c, g) {
      let h = i;
      i = u(c), i === h ? d[i].p(c, g) : (Oe(), U(d[h], 1, 1, () => {
        d[h] = null;
      }), Fe(), n = d[i], n ? n.p(c, g) : (n = d[i] = s[i](c), n.c()), Y(n, 1), n.m(e, null)), (!a || g[0] & /*testid, name*/
      8194 && l !== (l = /*testid*/
      c[13] || `${/*name*/
      c[1]}-dropdown`)) && f(e, "data-testid", l), (!a || g[0] & /*mt, mr, mb, ml, _width*/
      73216 && o !== (o = `
      ${be(
        /*mt*/
        c[9],
        /*mr*/
        c[10],
        /*mb*/
        c[11],
        /*ml*/
        c[12]
      )};
      --width: ${/*_width*/
      c[16]};
    `)) && f(e, "style", o), (!a || g[0] & /*_native*/
      2097152) && G(
        e,
        "dropdown-native",
        /*_native*/
        c[21]
      );
    },
    i(c) {
      a || (Y(n), a = !0);
    },
    o(c) {
      U(n), a = !1;
    },
    d(c) {
      c && P(e), d[i].d(), t[53](null), r();
    }
  };
}
function ic(t) {
  let e;
  try {
    e = JSON.parse(t || '[""]');
  } catch {
    e = [t];
  }
  return (typeof e == "object" ? e : [e]).map((n) => `${n}`);
}
function nc(t, e) {
  if (e.length === 0) return !0;
  let i = t.filter || t.label || t.value;
  return i = i.toLowerCase(), e = e.toLowerCase().trim(), i.startsWith(e) || i.includes(" " + e);
}
function lc(t, e, i) {
  let n, l, o, r, a, { $$slots: s = {}, $$scope: d } = e, { name: u } = e, { arialabel: c = "" } = e, { arialabelledby: g = "" } = e, { value: h = "" } = e, { filterable: m = "false" } = e, { leadingicon: v = null } = e, { maxheight: b = "276px" } = e, { placeholder: w = "" } = e, { width: y = "" } = e, { disabled: j = "false" } = e, { error: E = "false" } = e, { multiselect: M = "false" } = e, { native: L = "false" } = e, { relative: z = "false" } = e, { mt: V = null } = e, { mr: T = null } = e, { mb: S = null } = e, { ml: A = null } = e, { testid: R = "" } = e, I = [], B, N = !1, F = -1, q, H, O, W, K, $, ye = !1, Z = [], Q = [], X, ee = Ce(E), ie = ee, J = "auto";
  ke(() => {
    yi(O), De(), Ct(), $ = r ? new la(K) : new oa(K);
  });
  function De() {
    Re(O, (ne, we, Se) => {
      switch (ne) {
        case bt:
          Ae(we);
          break;
        case dt:
          fe(we);
          break;
        case ut:
          i(42, E = "false");
          break;
        case Gr:
          zt(we);
          break;
        case Kr:
          ji(we);
          break;
      }
    });
  }
  function fe(ne) {
    i(42, E = ne.error ? "true" : "false");
  }
  function Ae(ne) {
    i(0, h = ne.value), qe(O, "_change", { name: u, value: h }, { bubbles: !0 });
  }
  function Ct() {
    je(O, Qe, { name: u, el: O }, { bubbles: !0, timeout: 10 });
  }
  function zt(ne) {
    switch (ne.mountType) {
      case "append":
        i(14, I = [...I, ne]);
        break;
      case "prepend":
        i(14, I = [ne, ...I]);
        break;
      case "reset":
        i(14, I = [...I, ne]);
        break;
    }
    je(ne.el, "dropdown:bind", { el: O }), X && clearTimeout(X), X = setTimeout(
      () => {
        _t(), o || Xt();
      },
      1
    );
  }
  function ji(ne) {
    i(14, I = I.filter((we) => we.value !== ne.value));
  }
  function Xt() {
    i(22, B = I.find((ne) => ne.value == Q[0]));
  }
  function Jt(ne) {
    const we = ne.map((at) => (`${at.label}` || `${at.value}` || "").length).sort((at, Mt) => at > Mt ? 1 : -1).pop();
    let Se = Math.max(we || 0, w.length) + 7;
    return v && (Se += 4), `${Se}ch`;
  }
  function Qt(ne) {
    let we = F + ne, Se = Z != null && Z.length ? Z : I;
    Se.length !== 0 && (we < 0 ? we = r ? Se.length - 1 : 0 : we >= Se.length && (we = r ? 0 : Se.length - 1), i(15, F = we), $t(we));
  }
  function $t(ne) {
    const we = W.querySelector(`li[data-index="${ne}"]`);
    if (!we) return;
    const Se = we.getBoundingClientRect(), at = W.getBoundingClientRect();
    Se.top >= 0 && Se.left >= 0 && Se.bottom <= at.height && Se.right <= at.width || we.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }
  function _t() {
    i(19, Z = r ? I.filter((ne) => nc(ne, (K == null ? void 0 : K.value) || "")) : I);
  }
  function $e() {
    n || setTimeout(
      async () => {
        _t(), i(23, N = !0);
      },
      0
    );
  }
  function rt() {
    i(23, N = !1);
  }
  function jt() {
    i(18, K.value = (B == null ? void 0 : B.label) || (B == null ? void 0 : B.value) || "", K);
  }
  function Et(ne) {
    const we = l ? { name: u, values: [ne, ...Q] } : { name: u, value: ne };
    ye && setTimeout(
      () => {
        O == null || O.dispatchEvent(new CustomEvent("_change", { composed: !0, detail: we, bubbles: !0 })), i(26, ye = !1);
      },
      1
    );
  }
  function ft(ne) {
    n || (i(26, ye = ne.value !== (B == null ? void 0 : B.value)), i(22, B = ne), o || (rt(), _t(), jt()), Et(ne.value));
  }
  async function de(ne) {
    if (r)
      if (await Pe(), _t(), Z.length === 1) {
        const we = Z[0];
        i(22, B = we), Et(we.value), jt(), setTimeout(
          () => {
            rt();
          },
          10
        );
      } else
        i(22, B = void 0), jt(), Et("");
  }
  function Ie(ne) {
    n || (i(26, ye = !0), $.handleKeyUp(ne));
  }
  function Qr(ne) {
    n || (i(26, ye = !0), $.handleKeyDown(ne));
  }
  function $r(ne) {
    (ne.key === "Enter" || ne.key === " ") && (ne.stopPropagation(), Ei(), $e());
  }
  function ea(ne) {
    Ei(), $e(), ne.stopPropagation();
  }
  function ta(ne) {
    const we = ne.currentTarget, Se = I[we.selectedIndex];
    i(26, ye = !0), ft(Se);
  }
  function Ei() {
    n || (i(28, a = void 0), i(15, F = -1), i(22, B = void 0), i(26, ye = !0), _t(), Et(""), jt());
  }
  async function ia(ne) {
    await Pe(), $e(), ne.stopPropagation();
  }
  function na(ne) {
    qe(O, "help-text::announce", void 0, { bubbles: !0 });
  }
  class la {
    constructor(we) {
      this.input = we;
    }
    onEscape(we) {
      Ei();
    }
    onEnter(we) {
      const Se = Z[F];
      Se && (i(26, ye = Se.value !== (B == null ? void 0 : B.value)), ft(Se)), B ? rt() : $e(), we.stopPropagation();
    }
    onArrow(we, Se) {
      N || $e(), Qt(Se === "up" ? -1 : 1), we.stopPropagation();
    }
    onTab(we) {
      const Se = Z.find((at) => {
        var Mt;
        return ((Mt = at.label) == null ? void 0 : Mt.toLowerCase()) === this.input.value.toLowerCase();
      });
      Se && ft(Se), rt();
    }
    onKeyUp(we) {
      $e();
    }
    handleKeyUp(we) {
      switch (we.key) {
        case "Enter":
          this.onEnter(we);
          break;
        case "ArrowUp":
          this.onArrow(we, "up");
          break;
        case "ArrowDown":
          this.onArrow(we, "down");
          break;
        case "Home":
          this.input.setSelectionRange(0, 0);
          break;
        case "End":
          this.input.setSelectionRange(this.input.value.length, this.input.value.length);
          break;
        case "Tab":
          break;
        default:
          this.onKeyUp(we);
          break;
      }
    }
    handleKeyDown(we) {
      switch (we.key) {
        case "Escape":
          this.onEscape(we);
          break;
        case "Tab":
          this.onTab(we);
          break;
      }
    }
  }
  class oa {
    constructor(we) {
    }
    onEnter(we) {
      if (N) {
        const Se = Z[F];
        Se && ft(Se), rt();
      } else
        $e();
      we.preventDefault(), we.stopPropagation();
    }
    onArrow(we, Se) {
      N || $e(), Qt(Se === "up" ? -1 : 1), we.preventDefault(), we.stopPropagation();
    }
    handleKeyDown(we) {
      switch (we.key) {
        case " ":
        case "Enter":
          this.onEnter(we);
          break;
        case "ArrowUp":
          this.onArrow(we, "up");
          break;
        case "ArrowDown":
          this.onArrow(we, "down");
          break;
        case "Tab":
          rt();
          break;
      }
      return !1;
    }
    handleKeyUp(we) {
      switch (we.key) {
        case "ArrowUp":
        case "ArrowDown":
        case " ":
        case "Enter":
          we.preventDefault(), we.stopPropagation();
      }
    }
  }
  function ra(ne) {
    ue[ne ? "unshift" : "push"](() => {
      K = ne, i(18, K);
    });
  }
  const aa = (ne) => {
    i(26, ye = !0), ft(ne);
  };
  function sa(ne) {
    ue[ne ? "unshift" : "push"](() => {
      W = ne, i(25, W);
    });
  }
  function ua(ne) {
    ue[ne ? "unshift" : "push"](() => {
      O = ne, i(17, O);
    });
  }
  function da() {
    H = this.clientWidth, i(24, H), i(44, y), i(14, I), i(16, q);
  }
  return t.$$set = (ne) => {
    "name" in ne && i(1, u = ne.name), "arialabel" in ne && i(2, c = ne.arialabel), "arialabelledby" in ne && i(3, g = ne.arialabelledby), "value" in ne && i(0, h = ne.value), "filterable" in ne && i(43, m = ne.filterable), "leadingicon" in ne && i(4, v = ne.leadingicon), "maxheight" in ne && i(5, b = ne.maxheight), "placeholder" in ne && i(6, w = ne.placeholder), "width" in ne && i(44, y = ne.width), "disabled" in ne && i(7, j = ne.disabled), "error" in ne && i(42, E = ne.error), "multiselect" in ne && i(45, M = ne.multiselect), "native" in ne && i(46, L = ne.native), "relative" in ne && i(8, z = ne.relative), "mt" in ne && i(9, V = ne.mt), "mr" in ne && i(10, T = ne.mr), "mb" in ne && i(11, S = ne.mb), "ml" in ne && i(12, A = ne.ml), "testid" in ne && i(13, R = ne.testid), "$$scope" in ne && i(48, d = ne.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*_inputEl*/
    262144 && K && i(27, J = `${K.offsetWidth}px`), t.$$.dirty[0] & /*disabled*/
    128 && i(29, n = Ce(j)), t.$$.dirty[1] & /*multiselect*/
    16384 && (l = Ce(M)), t.$$.dirty[1] & /*native*/
    32768 && i(21, o = Ce(L)), t.$$.dirty[0] & /*_native*/
    2097152 | t.$$.dirty[1] & /*filterable*/
    4096 && i(30, r = Ce(m) && !o), t.$$.dirty[0] & /*_filteredOptions, _highlightedIndex*/
    557056 && i(28, a = Z[F] ? Z[F].value : void 0), t.$$.dirty[0] & /*value*/
    1 && (Q = ic(h || ""), Xt()), t.$$.dirty[0] & /*_options, _width*/
    81920 | t.$$.dirty[1] & /*width*/
    8192 && (y ? /(px|%|ch)$/.test(y) ? i(16, q = y) : i(16, q = `${y}px`) : i(16, q = Jt(I)), i(24, H = `min(${q}, 100%)`)), t.$$.dirty[0] & /*_error, _rootEl*/
    1179648 | t.$$.dirty[1] & /*error, _prevError*/
    67584 && (i(20, ee = Ce(E)), ee !== ie && (qe(O, "error::change", { isError: ee }, { bubbles: !0 }), i(47, ie = ee)));
  }, [
    h,
    u,
    c,
    g,
    v,
    b,
    w,
    j,
    z,
    V,
    T,
    S,
    A,
    R,
    I,
    F,
    q,
    O,
    K,
    Z,
    ee,
    o,
    B,
    N,
    H,
    W,
    ye,
    J,
    a,
    n,
    r,
    $e,
    rt,
    ft,
    de,
    Ie,
    Qr,
    $r,
    ea,
    ta,
    ia,
    na,
    E,
    m,
    y,
    M,
    L,
    ie,
    d,
    s,
    ra,
    aa,
    sa,
    ua,
    da
  ];
}
class oc extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      lc,
      tc,
      ce,
      {
        name: 1,
        arialabel: 2,
        arialabelledby: 3,
        value: 0,
        filterable: 43,
        leadingicon: 4,
        maxheight: 5,
        placeholder: 6,
        width: 44,
        disabled: 7,
        error: 42,
        multiselect: 45,
        native: 46,
        relative: 8,
        mt: 9,
        mr: 10,
        mb: 11,
        ml: 12,
        testid: 13
      },
      Xd,
      [-1, -1, -1]
    );
  }
  get name() {
    return this.$$.ctx[1];
  }
  set name(e) {
    this.$$set({ name: e }), k();
  }
  get arialabel() {
    return this.$$.ctx[2];
  }
  set arialabel(e) {
    this.$$set({ arialabel: e }), k();
  }
  get arialabelledby() {
    return this.$$.ctx[3];
  }
  set arialabelledby(e) {
    this.$$set({ arialabelledby: e }), k();
  }
  get value() {
    return this.$$.ctx[0];
  }
  set value(e) {
    this.$$set({ value: e }), k();
  }
  get filterable() {
    return this.$$.ctx[43];
  }
  set filterable(e) {
    this.$$set({ filterable: e }), k();
  }
  get leadingicon() {
    return this.$$.ctx[4];
  }
  set leadingicon(e) {
    this.$$set({ leadingicon: e }), k();
  }
  get maxheight() {
    return this.$$.ctx[5];
  }
  set maxheight(e) {
    this.$$set({ maxheight: e }), k();
  }
  get placeholder() {
    return this.$$.ctx[6];
  }
  set placeholder(e) {
    this.$$set({ placeholder: e }), k();
  }
  get width() {
    return this.$$.ctx[44];
  }
  set width(e) {
    this.$$set({ width: e }), k();
  }
  get disabled() {
    return this.$$.ctx[7];
  }
  set disabled(e) {
    this.$$set({ disabled: e }), k();
  }
  get error() {
    return this.$$.ctx[42];
  }
  set error(e) {
    this.$$set({ error: e }), k();
  }
  get multiselect() {
    return this.$$.ctx[45];
  }
  set multiselect(e) {
    this.$$set({ multiselect: e }), k();
  }
  get native() {
    return this.$$.ctx[46];
  }
  set native(e) {
    this.$$set({ native: e }), k();
  }
  get relative() {
    return this.$$.ctx[8];
  }
  set relative(e) {
    this.$$set({ relative: e }), k();
  }
  get mt() {
    return this.$$.ctx[9];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[10];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[11];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[12];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get testid() {
    return this.$$.ctx[13];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-dropdown", he(oc, { name: {}, arialabel: {}, arialabelledby: {}, value: {}, filterable: {}, leadingicon: {}, maxheight: {}, placeholder: {}, width: {}, disabled: {}, error: {}, multiselect: {}, native: {}, relative: {}, mt: {}, mr: {}, mb: {}, ml: {}, testid: {} }, ["default"], [], !0));
function rc(t) {
  _e(t, "svelte-quhy4b", `#container.svelte-quhy4b{container:self / inline-size}.root.svelte-quhy4b{display:grid;padding:var(--goa-space-l);border:var(--goa-border-width-s) solid var(--goa-color-greyscale-200);border-radius:var(--goa-border-radius-m);margin:0.5rem 0;gap:1rem;align-items:center}.details.svelte-quhy4b{grid-area:details;display:flex;flex-direction:column;overflow-x:hidden}.actions.svelte-quhy4b{grid-area:action}@container self (min-width: 624px){.root.svelte-quhy4b{grid-template-columns:38px 1fr auto;grid-template-rows:auto;grid-template-areas:"icon details action"}.details.svelte-quhy4b{margin-left:0.5rem}}@container self (max-width: 623px){.root.svelte-quhy4b{grid-template-columns:38px auto;grid-template-rows:repeat(2, auto);grid-template-areas:"icon details"
        "action action"}.actions.svelte-quhy4b{display:flex;justify-content:center}}.root.error.svelte-quhy4b{border:var(--goa-border-width-m) solid var(--goa-color-interactive-error)}.fileicon.svelte-quhy4b{grid-area:icon;align-self:center}.filename.svelte-quhy4b{grid-area:filename;font-size:var(--goa-font-size-4);overflow-wrap:anywhere}.error-msg.svelte-quhy4b{display:flex;align-items:flex-start;margin-top:0.5rem;gap:var(--goa-space-2xs);color:var(--goa-color-interactive-error);font:var(--goa-typography-body-xs)}.timestamp.svelte-quhy4b,.filesize.svelte-quhy4b{color:var(--goa-color-greyscale-700);font:var(--goa-typography-body-s)}.progress.svelte-quhy4b{display:flex;align-items:center;font:var(--goa-typography-body-xs);gap:0.5rem}progress.svelte-quhy4b{flex:1 1 auto;-webkit-appearance:none;-moz-appearance:none;appearance:none;height:4px;border:none;border-radius:var(--goa-border-radius-m);background:var(--goa-color-greyscale-200);color:var(--goa-color-greyscale-700)}progress.svelte-quhy4b::-webkit-progress-value{background:var(--goa-color-interactive-default)}progress.svelte-quhy4b::-webkit-progress-bar{background:var(--goa-color-greyscale-200)}progress.svelte-quhy4b::-moz-progress-bar{background:var(--goa-color-interactive-default)}`);
}
function ac(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "class", "fileicon svelte-quhy4b"), p(e, "data-testid", "icon"), p(e, "type", "goa-file"), p(e, "fillcolor", "#dcdcdc"), p(e, "size", "xlarge");
    },
    m(i, n) {
      D(i, e, n);
    },
    p: ve,
    d(i) {
      i && P(e);
    }
  };
}
function sc(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "class", "fileicon svelte-quhy4b"), p(e, "data-testid", "icon"), p(
        e,
        "type",
        /*_fileIcon*/
        t[7]
      ), p(e, "fillcolor", "#0070c4"), p(e, "size", "xlarge");
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*_fileIcon*/
      128 && p(
        e,
        "type",
        /*_fileIcon*/
        i[7]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function rl(t) {
  let e, i = al(
    /*size*/
    t[1]
  ) + "", n;
  return {
    c() {
      e = C("div"), n = le(i), f(e, "class", "filesize svelte-quhy4b"), f(e, "data-testid", "filesize");
    },
    m(l, o) {
      D(l, e, o), _(e, n);
    },
    p(l, o) {
      o & /*size*/
      2 && i !== (i = al(
        /*size*/
        l[1]
      ) + "") && pe(n, i);
    },
    d(l) {
      l && P(e);
    }
  };
}
function uc(t) {
  let e, i, n, l;
  return {
    c() {
      e = C("div"), i = C("goa-icon"), n = x(), l = le(
        /*error*/
        t[3]
      ), p(i, "type", "warning"), p(i, "size", "small"), p(i, "theme", "filled"), f(e, "class", "error-msg svelte-quhy4b"), f(e, "data-testid", "error");
    },
    m(o, r) {
      D(o, e, r), _(e, i), _(e, n), _(e, l);
    },
    p(o, r) {
      r & /*error*/
      8 && pe(
        l,
        /*error*/
        o[3]
      );
    },
    d(o) {
      o && P(e);
    }
  };
}
function dc(t) {
  let e;
  return {
    c() {
      e = C("div"), e.textContent = `Uploaded on ${Fa()}`, f(e, "class", "timestamp svelte-quhy4b"), f(e, "data-testid", "timestamp");
    },
    m(i, n) {
      D(i, e, n);
    },
    p: ve,
    d(i) {
      i && P(e);
    }
  };
}
function cc(t) {
  let e, i, n, l = Math.ceil(
    /*progress*/
    t[2]
  ) + "", o, r;
  return {
    c() {
      e = C("div"), i = C("progress"), n = x(), o = le(l), r = le("%"), i.value = /*progress*/
      t[2], f(i, "max", "100"), f(i, "class", "svelte-quhy4b"), f(e, "class", "progress svelte-quhy4b"), f(e, "data-testid", "progress");
    },
    m(a, s) {
      D(a, e, s), _(e, i), _(e, n), _(e, o), _(e, r);
    },
    p(a, s) {
      s & /*progress*/
      4 && (i.value = /*progress*/
      a[2]), s & /*progress*/
      4 && l !== (l = Math.ceil(
        /*progress*/
        a[2]
      ) + "") && pe(o, l);
    },
    d(a) {
      a && P(e);
    }
  };
}
function fc(t) {
  let e, i, n;
  return {
    c() {
      e = C("goa-button"), e.textContent = "Cancel", p(e, "type", "tertiary"), p(e, "size", "compact"), p(e, "variant", "destructive");
    },
    m(l, o) {
      D(l, e, o), i || (n = te(
        e,
        "click",
        /*click_handler_2*/
        t[12]
      ), i = !0);
    },
    p: ve,
    d(l) {
      l && P(e), i = !1, n();
    }
  };
}
function gc(t) {
  let e, i, n;
  return {
    c() {
      e = C("goa-button"), e.textContent = "Remove", p(e, "type", "tertiary"), p(e, "size", "compact"), p(e, "leadingicon", "trash");
    },
    m(l, o) {
      D(l, e, o), i || (n = te(
        e,
        "click",
        /*click_handler_1*/
        t[11]
      ), i = !0);
    },
    p: ve,
    d(l) {
      l && P(e), i = !1, n();
    }
  };
}
function hc(t) {
  let e, i, n;
  return {
    c() {
      e = C("goa-button"), e.textContent = "Cancel", p(e, "type", "tertiary"), p(e, "size", "compact");
    },
    m(l, o) {
      D(l, e, o), i || (n = te(
        e,
        "click",
        /*click_handler*/
        t[10]
      ), i = !0);
    },
    p: ve,
    d(l) {
      l && P(e), i = !1, n();
    }
  };
}
function mc(t) {
  let e, i, n, l, o, r, a, s, d, u, c;
  function g(L, z) {
    return (
      /*_status*/
      L[5] === "uploaded" ? sc : ac
    );
  }
  let h = g(t), m = h(t), v = (
    /*_status*/
    t[5] !== "error" && rl(t)
  );
  function b(L, z) {
    if (
      /*_status*/
      L[5] === "uploading"
    ) return cc;
    if (
      /*_status*/
      L[5] === "uploaded"
    ) return dc;
    if (
      /*_status*/
      L[5] === "error"
    ) return uc;
  }
  let w = b(t), y = w && w(t);
  function j(L, z) {
    if (
      /*_status*/
      L[5] === "uploading"
    ) return hc;
    if (
      /*_status*/
      L[5] === "uploaded"
    ) return gc;
    if (
      /*_status*/
      L[5] === "error"
    ) return fc;
  }
  let E = j(t), M = E && E(t);
  return {
    c() {
      e = C("div"), i = C("div"), m.c(), n = x(), l = C("div"), o = C("div"), r = le(
        /*filename*/
        t[0]
      ), a = x(), v && v.c(), s = x(), y && y.c(), d = x(), u = C("div"), M && M.c(), f(o, "class", "filename svelte-quhy4b"), f(o, "data-testid", "filename"), f(l, "class", "details svelte-quhy4b"), f(u, "class", "actions svelte-quhy4b"), f(u, "data-testid", "actions"), f(i, "data-testid", "root"), f(i, "class", c = Ee(`root ${/*_status*/
      t[5]}`) + " svelte-quhy4b"), G(
        i,
        "error",
        /*error*/
        t[3]
      ), f(e, "id", "container"), f(
        e,
        "data-testid",
        /*testid*/
        t[4]
      ), f(e, "class", "svelte-quhy4b");
    },
    m(L, z) {
      D(L, e, z), _(e, i), m.m(i, null), _(i, n), _(i, l), _(l, o), _(o, r), _(l, a), v && v.m(l, null), _(l, s), y && y.m(l, null), _(i, d), _(i, u), M && M.m(u, null), t[13](i);
    },
    p(L, [z]) {
      h === (h = g(L)) && m ? m.p(L, z) : (m.d(1), m = h(L), m && (m.c(), m.m(i, n))), z & /*filename*/
      1 && pe(
        r,
        /*filename*/
        L[0]
      ), /*_status*/
      L[5] !== "error" ? v ? v.p(L, z) : (v = rl(L), v.c(), v.m(l, s)) : v && (v.d(1), v = null), w === (w = b(L)) && y ? y.p(L, z) : (y && y.d(1), y = w && w(L), y && (y.c(), y.m(l, null))), E === (E = j(L)) && M ? M.p(L, z) : (M && M.d(1), M = E && E(L), M && (M.c(), M.m(u, null))), z & /*_status*/
      32 && c !== (c = Ee(`root ${/*_status*/
      L[5]}`) + " svelte-quhy4b") && f(i, "class", c), z & /*_status, error*/
      40 && G(
        i,
        "error",
        /*error*/
        L[3]
      ), z & /*testid*/
      16 && f(
        e,
        "data-testid",
        /*testid*/
        L[4]
      );
    },
    i: ve,
    o: ve,
    d(L) {
      L && P(e), m.d(), v && v.d(), y && y.d(), M && M.d(), t[13](null);
    }
  };
}
function vc(t, e) {
  const i = t.split("."), n = i[i.length - 1], l = n === "xlxs" && "goa-xls" || n === "xls" && "goa-xls" || n === "zip" && "goa-zip" || n === "docx" && "goa-doc" || n === "doc" && "goa-doc" || n === "pptx" && "goa-ppt" || n === "ppt" && "goa-ppt" || n === "pdf" && "goa-pdf" || n === "html" && "goa-html";
  return l || e === "application/vnd.ms-powerpoint" && "goa-ppt" || e.includes("presentationml") && "goa-ppt" || e.includes("wordprocessingml") && "goa-doc" || e.includes("spreadsheet") && "goa-xls" || e.startsWith("video") && "goa-video" || e.startsWith("audio") && "goa-audio" || e.startsWith("image") && "goa-image" || e === "application/msword" && "goa-doc" || "goa-file";
}
function al(t) {
  switch (!0) {
    case t < 1024:
      return t + "B";
    case t < 1024 * 1024:
      return Math.round(t / 1024) + "KB";
    case t < Math.pow(1024, 3):
      return Math.round(t / Math.pow(1024, 2)) + "MB";
    default:
      return "n/a";
  }
}
function bc(t, e, i) {
  let { filename: n } = e, { size: l } = e, { type: o = "" } = e, { progress: r = -1 } = e, { error: a = "" } = e, { testid: s = "" } = e, d = "uploading", u, c = "goa-file";
  function g(w) {
    u.dispatchEvent(new CustomEvent(w, { composed: !0 }));
  }
  const h = () => g("_cancel"), m = () => g("_delete"), v = () => g("_delete");
  function b(w) {
    ue[w ? "unshift" : "push"](() => {
      u = w, i(6, u);
    });
  }
  return t.$$set = (w) => {
    "filename" in w && i(0, n = w.filename), "size" in w && i(1, l = w.size), "type" in w && i(9, o = w.type), "progress" in w && i(2, r = w.progress), "error" in w && i(3, a = w.error), "testid" in w && i(4, s = w.testid);
  }, t.$$.update = () => {
    t.$$.dirty & /*error, progress*/
    12 && i(5, d = a && "error" || r >= 0 && r < 100 && "uploading" || "uploaded"), t.$$.dirty & /*filename, type*/
    513 && i(7, c = n && o && vc(n, o));
  }, [
    n,
    l,
    r,
    a,
    s,
    d,
    u,
    c,
    g,
    o,
    h,
    m,
    v,
    b
  ];
}
class pc extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      bc,
      mc,
      ce,
      {
        filename: 0,
        size: 1,
        type: 9,
        progress: 2,
        error: 3,
        testid: 4
      },
      rc
    );
  }
  get filename() {
    return this.$$.ctx[0];
  }
  set filename(e) {
    this.$$set({ filename: e }), k();
  }
  get size() {
    return this.$$.ctx[1];
  }
  set size(e) {
    this.$$set({ size: e }), k();
  }
  get type() {
    return this.$$.ctx[9];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get progress() {
    return this.$$.ctx[2];
  }
  set progress(e) {
    this.$$set({ progress: e }), k();
  }
  get error() {
    return this.$$.ctx[3];
  }
  set error(e) {
    this.$$set({ error: e }), k();
  }
  get testid() {
    return this.$$.ctx[4];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-file-upload-card", he(pc, { filename: {}, size: {}, type: {}, progress: {}, error: {}, testid: {} }, [], [], !0));
function _c(t) {
  _e(t, "svelte-1mfs51e", '.dragdrop.svelte-1mfs51e.svelte-1mfs51e{border-radius:var(--goa-file-upload-border-radius);border:var(--goa-file-upload-border);display:flex;font:var(--goa-file-upload-instruction-text);flex-direction:column;align-items:center;justify-content:center;gap:var(--goa-file-upload-text-gap);padding:var(--goa-file-upload-padding);color:var(--goa-file-upload-instruction-color);text-align:center;cursor:pointer;background:var(--goa-file-upload-color-bg);container:self / inline-size}.dragdrop.svelte-1mfs51e.svelte-1mfs51e:active{border:var(--goa-file-upload-border-active);outline:none}.dragdrop.svelte-1mfs51e.svelte-1mfs51e:focus-within{border:var(--goa-file-upload-border-hover);box-shadow:var(--goa-file-upload-border-focus);background-color:var(--goa-file-upload-color-bg-focus);color:var(--goa-file-upload-instruction-color-focus)}.state-hover.svelte-1mfs51e.svelte-1mfs51e{background:var(--goa-file-upload-color-bg-hover);border:var(--goa-file-upload-border-hover);color:var(--goa-file-upload-instruction-color-hover)}.state-dragenter.svelte-1mfs51e.svelte-1mfs51e{background:var(--goa-file-upload-color-bg-drag);border:var(--goa-file-upload-border-drag);color:var(--goa-file-upload-instruction-color-drag)}.instructions.svelte-1mfs51e.svelte-1mfs51e{display:flex;align-items:center}goa-icon.svelte-1mfs51e.svelte-1mfs51e{margin:0 var(--goa-space-s)}.browse-files.svelte-1mfs51e.svelte-1mfs51e{text-decoration:underline}em.svelte-1mfs51e.svelte-1mfs51e{font-style:normal;font:var(--goa-file-upload-help-text);color:var(--goa-file-upload-help-text-color)}.or-text.svelte-1mfs51e.svelte-1mfs51e{margin:var(--goa-space-3xs) var(--goa-space-xs) 0 var(--goa-space-xs)}.max-file-size.svelte-1mfs51e.svelte-1mfs51e{display:block}.button.svelte-1mfs51e .max-file-size.svelte-1mfs51e{margin-top:var(--goa-space-xs)}input[type="file"].svelte-1mfs51e.svelte-1mfs51e{position:absolute;left:-9999px}.issues.svelte-1mfs51e.svelte-1mfs51e{border-bottom:1px solid var(--goa-color-greyscale-200);margin:1rem 0}.issue.svelte-1mfs51e.svelte-1mfs51e{margin-bottom:1rem}.error.svelte-1mfs51e.svelte-1mfs51e{color:var(--goa-color-interactive-error);font-size:0.9em;display:flex;align-items:center;gap:0.5rem}@container self (max-width: 623px){.dragdrop.svelte-1mfs51e.svelte-1mfs51e{padding-top:1.75rem}.instructions.svelte-1mfs51e.svelte-1mfs51e{flex-direction:column}}');
}
function sl(t, e, i) {
  const n = t.slice();
  return n[22] = e[i], n;
}
function ul(t) {
  let e, i, n, l, o, r, a, s, d, u = (
    /*maxfilesize*/
    t[2] && dl(t)
  );
  return {
    c() {
      e = C("div"), i = C("div"), i.innerHTML = '<goa-icon type="cloud-upload" size="large" class="svelte-1mfs51e"></goa-icon> <div>Drag and drop files here</div> <em class="or-text svelte-1mfs51e">or</em> <div class="browse-files svelte-1mfs51e">Browse files</div>', n = x(), u && u.c(), l = x(), o = C("input"), f(i, "class", "instructions svelte-1mfs51e"), f(o, "data-testid", "input"), f(o, "tabindex", "0"), f(o, "type", "file"), f(
        o,
        "accept",
        /*accept*/
        t[1]
      ), o.multiple = !0, f(o, "class", "svelte-1mfs51e"), f(e, "data-testid", r = /*testid*/
      t[3] || "dragdrop"), f(e, "class", a = Ee(`dragdrop state-${/*_state*/
      t[6]}`) + " svelte-1mfs51e");
    },
    m(c, g) {
      D(c, e, g), _(e, i), _(e, n), u && u.m(e, null), _(e, l), _(e, o), t[14](o), t[15](e), s || (d = [
        te(
          e,
          "click",
          /*openFilePicker*/
          t[8]
        ),
        te(
          e,
          "drop",
          /*onDrop*/
          t[9]
        ),
        te(
          e,
          "mouseover",
          /*onMouseOver*/
          t[12]
        ),
        te(
          e,
          "mouseout",
          /*onMouseOut*/
          t[13]
        ),
        te(
          e,
          "dragenter",
          /*onDragEnter*/
          t[10]
        ),
        te(
          e,
          "dragleave",
          /*onDragLeave*/
          t[11]
        ),
        te(e, "dragover", kc)
      ], s = !0);
    },
    p(c, g) {
      /*maxfilesize*/
      c[2] ? u ? u.p(c, g) : (u = dl(c), u.c(), u.m(e, l)) : u && (u.d(1), u = null), g & /*accept*/
      2 && f(
        o,
        "accept",
        /*accept*/
        c[1]
      ), g & /*testid*/
      8 && r !== (r = /*testid*/
      c[3] || "dragdrop") && f(e, "data-testid", r), g & /*_state*/
      64 && a !== (a = Ee(`dragdrop state-${/*_state*/
      c[6]}`) + " svelte-1mfs51e") && f(e, "class", a);
    },
    d(c) {
      c && P(e), u && u.d(), t[14](null), t[15](null), s = !1, He(d);
    }
  };
}
function dl(t) {
  let e, i, n;
  return {
    c() {
      e = C("em"), i = le("Maximum file size is "), n = le(
        /*maxfilesize*/
        t[2]
      ), f(e, "class", "max-file-size svelte-1mfs51e"), f(e, "data-testid", "max-file-size");
    },
    m(l, o) {
      D(l, e, o), _(e, i), _(e, n);
    },
    p(l, o) {
      o & /*maxfilesize*/
      4 && pe(
        n,
        /*maxfilesize*/
        l[2]
      );
    },
    d(l) {
      l && P(e);
    }
  };
}
function cl(t) {
  let e, i, n, l, o, r, a, s, d = (
    /*maxfilesize*/
    t[2] && fl(t)
  );
  return {
    c() {
      e = C("div"), i = C("goa-button"), i.textContent = "Choose file", n = x(), d && d.c(), l = x(), o = C("input"), p(i, "type", "secondary"), f(e, "class", "button svelte-1mfs51e"), f(o, "data-testid", r = /*testid*/
      t[3] || "input"), f(o, "tabindex", "-1"), f(o, "type", "file"), f(
        o,
        "accept",
        /*accept*/
        t[1]
      ), o.multiple = !0, f(o, "class", "svelte-1mfs51e");
    },
    m(u, c) {
      D(u, e, c), _(e, i), _(e, n), d && d.m(e, null), t[16](e), D(u, l, c), D(u, o, c), t[17](o), a || (s = te(
        i,
        "click",
        /*openFilePicker*/
        t[8]
      ), a = !0);
    },
    p(u, c) {
      /*maxfilesize*/
      u[2] ? d ? d.p(u, c) : (d = fl(u), d.c(), d.m(e, null)) : d && (d.d(1), d = null), c & /*testid*/
      8 && r !== (r = /*testid*/
      u[3] || "input") && f(o, "data-testid", r), c & /*accept*/
      2 && f(
        o,
        "accept",
        /*accept*/
        u[1]
      );
    },
    d(u) {
      u && (P(e), P(l), P(o)), d && d.d(), t[16](null), t[17](null), a = !1, s();
    }
  };
}
function fl(t) {
  let e, i, n;
  return {
    c() {
      e = C("em"), i = le("Maximum file size is "), n = le(
        /*maxfilesize*/
        t[2]
      ), f(e, "class", "max-file-size svelte-1mfs51e"), f(e, "data-testid", "max-file-size");
    },
    m(l, o) {
      D(l, e, o), _(e, i), _(e, n);
    },
    p(l, o) {
      o & /*maxfilesize*/
      4 && pe(
        n,
        /*maxfilesize*/
        l[2]
      );
    },
    d(l) {
      l && P(e);
    }
  };
}
function gl(t) {
  let e, i = Le(
    /*issues*/
    t[7]
  ), n = [];
  for (let l = 0; l < i.length; l += 1)
    n[l] = hl(sl(t, i, l));
  return {
    c() {
      e = C("div");
      for (let l = 0; l < n.length; l += 1)
        n[l].c();
      f(e, "class", "issues svelte-1mfs51e");
    },
    m(l, o) {
      D(l, e, o);
      for (let r = 0; r < n.length; r += 1)
        n[r] && n[r].m(e, null);
    },
    p(l, o) {
      if (o & /*issues*/
      128) {
        i = Le(
          /*issues*/
          l[7]
        );
        let r;
        for (r = 0; r < i.length; r += 1) {
          const a = sl(l, i, r);
          n[r] ? n[r].p(a, o) : (n[r] = hl(a), n[r].c(), n[r].m(e, null));
        }
        for (; r < n.length; r += 1)
          n[r].d(1);
        n.length = i.length;
      }
    },
    d(l) {
      l && P(e), Ye(n, l);
    }
  };
}
function hl(t) {
  let e, i = (
    /*issue*/
    t[22].filename + ""
  ), n, l, o, r, a, s = (
    /*issue*/
    t[22].error + ""
  ), d, u;
  return {
    c() {
      e = C("div"), n = le(i), l = x(), o = C("div"), r = C("goa-icon"), a = x(), d = le(s), u = x(), p(r, "type", "warning"), p(r, "size", "small"), p(r, "theme", "filled"), p(r, "class", "svelte-1mfs51e"), f(o, "class", "error svelte-1mfs51e"), f(o, "data-testid", "error"), f(e, "class", "issue svelte-1mfs51e");
    },
    m(c, g) {
      D(c, e, g), _(e, n), _(e, l), _(e, o), _(o, r), _(o, a), _(o, d), _(e, u);
    },
    p(c, g) {
      g & /*issues*/
      128 && i !== (i = /*issue*/
      c[22].filename + "") && pe(n, i), g & /*issues*/
      128 && s !== (s = /*issue*/
      c[22].error + "") && pe(d, s);
    },
    d(c) {
      c && P(e);
    }
  };
}
function wc(t) {
  let e, i, n, l = (
    /*variant*/
    t[0] === "dragdrop" && ul(t)
  ), o = (
    /*variant*/
    t[0] === "button" && cl(t)
  ), r = (
    /*issues*/
    t[7].length && gl(t)
  );
  return {
    c() {
      l && l.c(), e = x(), o && o.c(), i = x(), r && r.c(), n = Ne();
    },
    m(a, s) {
      l && l.m(a, s), D(a, e, s), o && o.m(a, s), D(a, i, s), r && r.m(a, s), D(a, n, s);
    },
    p(a, [s]) {
      /*variant*/
      a[0] === "dragdrop" ? l ? l.p(a, s) : (l = ul(a), l.c(), l.m(e.parentNode, e)) : l && (l.d(1), l = null), /*variant*/
      a[0] === "button" ? o ? o.p(a, s) : (o = cl(a), o.c(), o.m(i.parentNode, i)) : o && (o.d(1), o = null), /*issues*/
      a[7].length ? r ? r.p(a, s) : (r = gl(a), r.c(), r.m(n.parentNode, n)) : r && (r.d(1), r = null);
    },
    i: ve,
    o: ve,
    d(a) {
      a && (P(e), P(i), P(n)), l && l.d(a), o && o.d(a), r && r.d(a);
    }
  };
}
function kc(t) {
  return t.preventDefault(), !1;
}
function yc(t, e, i) {
  let { variant: n = "dragdrop" } = e, { accept: l = "*" } = e, { maxfilesize: o = "5MB" } = e, { testid: r = "" } = e, a, s, d = "default", u = [];
  ke(() => {
    s.addEventListener(
      "change",
      () => {
        i(7, u = []), [...s.files].forEach((T) => {
          const S = c(T);
          if (S) {
            i(7, u = [{ filename: T.name, error: S }, ...u]);
            return;
          }
          m(T);
        }), i(5, s.value = "", s);
      },
      !0
    );
  });
  function c(T) {
    return g(T) ? h(T) ? null : `The file must be less than ${o}` : "Invalid file type";
  }
  function g(T) {
    const S = l.split(",");
    for (const A of S)
      if (T.type.match(A.replace("*", ".*")) || T.name.endsWith(A.trim()))
        return !0;
    return !1;
  }
  function h(T) {
    const S = o.match(/(\d*)(\w*$)/);
    if (!S)
      return !1;
    const A = S[1], R = S[2], I = {
      B: 1,
      KB: 1024,
      MB: Math.pow(1024, 2),
      GB: Math.pow(1024, 3)
    };
    return !(T.size / I[R] > parseInt(A));
  }
  function m(T) {
    a.dispatchEvent(new CustomEvent("_selectFile", { composed: !0, detail: { file: T } }));
  }
  function v() {
    s.click();
  }
  function b(T) {
    var S, A;
    T.preventDefault(), i(7, u = []), (S = T.dataTransfer) != null && S.items ? [...T.dataTransfer.items].forEach((R) => {
      if (R.kind === "file") {
        const I = R.getAsFile();
        if (I) {
          const B = c(I);
          if (B) {
            i(7, u = [{ filename: I.name, error: B }, ...u]);
            return;
          }
          m(I);
        }
      }
    }) : [...(A = T.dataTransfer) == null ? void 0 : A.files].forEach((R) => {
      const I = c(R);
      if (I) {
        i(7, u = [{ filename: R.name, error: I }, ...u]);
        return;
      }
      m(R);
    }), i(5, s.value = "", s);
  }
  function w() {
    i(6, d = "dragenter");
  }
  function y(T) {
    const S = a.getBoundingClientRect();
    T.clientX > S.x && T.clientX <= S.x + S.width && T.clientY > S.y && T.clientY <= S.y + S.height || i(6, d = "default");
  }
  function j() {
    i(6, d = "hover");
  }
  function E() {
    i(6, d = "default");
  }
  function M(T) {
    ue[T ? "unshift" : "push"](() => {
      s = T, i(5, s);
    });
  }
  function L(T) {
    ue[T ? "unshift" : "push"](() => {
      a = T, i(4, a);
    });
  }
  function z(T) {
    ue[T ? "unshift" : "push"](() => {
      a = T, i(4, a);
    });
  }
  function V(T) {
    ue[T ? "unshift" : "push"](() => {
      s = T, i(5, s);
    });
  }
  return t.$$set = (T) => {
    "variant" in T && i(0, n = T.variant), "accept" in T && i(1, l = T.accept), "maxfilesize" in T && i(2, o = T.maxfilesize), "testid" in T && i(3, r = T.testid);
  }, [
    n,
    l,
    o,
    r,
    a,
    s,
    d,
    u,
    v,
    b,
    w,
    y,
    j,
    E,
    M,
    L,
    z,
    V
  ];
}
class Cc extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      yc,
      wc,
      ce,
      {
        variant: 0,
        accept: 1,
        maxfilesize: 2,
        testid: 3
      },
      _c
    );
  }
  get variant() {
    return this.$$.ctx[0];
  }
  set variant(e) {
    this.$$set({ variant: e }), k();
  }
  get accept() {
    return this.$$.ctx[1];
  }
  set accept(e) {
    this.$$set({ accept: e }), k();
  }
  get maxfilesize() {
    return this.$$.ctx[2];
  }
  set maxfilesize(e) {
    this.$$set({ maxfilesize: e }), k();
  }
  get testid() {
    return this.$$.ctx[3];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-file-upload-input", he(Cc, { variant: {}, accept: {}, maxfilesize: {}, testid: {} }, [], [], !0));
function zc(t) {
  _e(t, "svelte-jswabp", `.chip.svelte-jswabp{display:inline-flex;align-items:center;background-color:var(--goa-color-greyscale-white);border-radius:1rem;border:var(--goa-border-width-s) solid var(--goa-color-greyscale-700);box-sizing:border-box;color:var(--goa-color-text-default);font:var(--goa-typography-body-s);gap:0.5rem;min-height:2rem;padding:3px 8px 3px 12px;min-width:56px;cursor:pointer;touch-action:manipulation}.chip.focused.svelte-jswabp{outline:var(--goa-border-width-l) solid var(--goa-color-interactive-focus)}.chip.error.svelte-jswabp{background-color:var(--goa-color-emergency-light);border-color:var(--goa-color-emergency-default);color:var(--goa-color-emergency-default)}.delete-icon.svelte-jswabp{flex-shrink:0}.text.svelte-jswabp{line-height:var(--goa-line-height-2);padding-top:2px;padding-bottom:var(
      --font-valign-fix,
      0
    );overflow-wrap:break-word;word-wrap:break-word}.error.svelte-jswabp:hover{background-color:var(--goa-color-emergency-light)}`);
}
function jc(t) {
  let e, i, n, l, o, r, a, s, d, u, c;
  return {
    c() {
      e = C("div"), i = C("div"), n = le(
        /*content*/
        t[4]
      ), l = x(), o = C("goa-icon"), f(i, "class", "text svelte-jswabp"), p(o, "class", "delete-icon svelte-jswabp"), p(o, "size", "small"), p(o, "theme", r = /*_error*/
      t[9] || /*_hovering*/
      t[7] || /*_focused*/
      t[8] ? "filled" : "outline"), p(o, "type", "close-circle"), p(o, "fillcolor", a = /*_error*/
      t[9] ? "var(--goa-color-emergency-default)" : "var(--goa-color-greyscale-700)"), p(o, "opacity", s = /*_error*/
      t[9] ? (
        /*_hovering*/
        t[7] || /*_focused*/
        t[8] ? 1 : 0.5
      ) : 1), f(
        e,
        "data-testid",
        /*testid*/
        t[5]
      ), f(e, "class", "chip svelte-jswabp"), f(e, "style", d = be(
        /*mt*/
        t[0],
        /*mr*/
        t[1],
        /*mb*/
        t[2],
        /*ml*/
        t[3]
      )), f(e, "tabindex", "0"), f(e, "role", "button"), f(
        e,
        "aria-label",
        /*chipAriaLabel*/
        t[10]
      ), G(
        e,
        "error",
        /*_error*/
        t[9]
      ), G(
        e,
        "focused",
        /*_focused*/
        t[8]
      );
    },
    m(g, h) {
      D(g, e, h), _(e, i), _(i, n), _(e, l), _(e, o), t[15](e), u || (c = [
        te(
          e,
          "click",
          /*onDelete*/
          t[11]
        ),
        te(
          e,
          "keydown",
          /*handleKeyDown*/
          t[12]
        ),
        te(
          e,
          "mouseover",
          /*mouseover_handler*/
          t[16]
        ),
        te(
          e,
          "mouseout",
          /*mouseout_handler*/
          t[17]
        ),
        te(
          e,
          "focus",
          /*focus_handler*/
          t[18]
        ),
        te(
          e,
          "blur",
          /*blur_handler*/
          t[19]
        )
      ], u = !0);
    },
    p(g, [h]) {
      h & /*content*/
      16 && pe(
        n,
        /*content*/
        g[4]
      ), h & /*_error, _hovering, _focused*/
      896 && r !== (r = /*_error*/
      g[9] || /*_hovering*/
      g[7] || /*_focused*/
      g[8] ? "filled" : "outline") && p(o, "theme", r), h & /*_error*/
      512 && a !== (a = /*_error*/
      g[9] ? "var(--goa-color-emergency-default)" : "var(--goa-color-greyscale-700)") && p(o, "fillcolor", a), h & /*_error, _hovering, _focused*/
      896 && s !== (s = /*_error*/
      g[9] ? (
        /*_hovering*/
        g[7] || /*_focused*/
        g[8] ? 1 : 0.5
      ) : 1) && p(o, "opacity", s), h & /*testid*/
      32 && f(
        e,
        "data-testid",
        /*testid*/
        g[5]
      ), h & /*mt, mr, mb, ml*/
      15 && d !== (d = be(
        /*mt*/
        g[0],
        /*mr*/
        g[1],
        /*mb*/
        g[2],
        /*ml*/
        g[3]
      )) && f(e, "style", d), h & /*chipAriaLabel*/
      1024 && f(
        e,
        "aria-label",
        /*chipAriaLabel*/
        g[10]
      ), h & /*_error*/
      512 && G(
        e,
        "error",
        /*_error*/
        g[9]
      ), h & /*_focused*/
      256 && G(
        e,
        "focused",
        /*_focused*/
        g[8]
      );
    },
    i: ve,
    o: ve,
    d(g) {
      g && P(e), t[15](null), u = !1, He(c);
    }
  };
}
function Ec(t, e, i) {
  let n, { mt: l = null } = e, { mr: o = null } = e, { mb: r = null } = e, { ml: a = null } = e, { error: s = "false" } = e, { content: d } = e, { testid: u = "" } = e, { ariaLabel: c = "" } = e, g, h = !1, m = !1, v;
  function b(z) {
    g.dispatchEvent(new CustomEvent("_click", { composed: !0, bubbles: !0 })), z.stopPropagation();
  }
  function w(z) {
    (z.key === "Enter" || z.key === " ") && (b(z), z.preventDefault());
  }
  function y(z) {
    ue[z ? "unshift" : "push"](() => {
      g = z, i(6, g);
    });
  }
  const j = () => i(7, h = !0), E = () => i(7, h = !1), M = () => i(8, m = !0), L = () => i(8, m = !1);
  return t.$$set = (z) => {
    "mt" in z && i(0, l = z.mt), "mr" in z && i(1, o = z.mr), "mb" in z && i(2, r = z.mb), "ml" in z && i(3, a = z.ml), "error" in z && i(13, s = z.error), "content" in z && i(4, d = z.content), "testid" in z && i(5, u = z.testid), "ariaLabel" in z && i(14, c = z.ariaLabel);
  }, t.$$.update = () => {
    t.$$.dirty & /*error*/
    8192 && i(9, v = Ce(s)), t.$$.dirty & /*ariaLabel, content*/
    16400 && i(10, n = c || `${d}, removable`);
  }, [
    l,
    o,
    r,
    a,
    d,
    u,
    g,
    h,
    m,
    v,
    n,
    b,
    w,
    s,
    c,
    y,
    j,
    E,
    M,
    L
  ];
}
class Mc extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Ec,
      jc,
      ce,
      {
        mt: 0,
        mr: 1,
        mb: 2,
        ml: 3,
        error: 13,
        content: 4,
        testid: 5,
        ariaLabel: 14
      },
      zc
    );
  }
  get mt() {
    return this.$$.ctx[0];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[1];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[2];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[3];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get error() {
    return this.$$.ctx[13];
  }
  set error(e) {
    this.$$set({ error: e }), k();
  }
  get content() {
    return this.$$.ctx[4];
  }
  set content(e) {
    this.$$set({ content: e }), k();
  }
  get testid() {
    return this.$$.ctx[5];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get ariaLabel() {
    return this.$$.ctx[14];
  }
  set ariaLabel(e) {
    this.$$set({ ariaLabel: e }), k();
  }
}
customElements.define("goa-filter-chip", he(Mc, { mt: {}, mr: {}, mb: {}, ml: {}, error: {}, content: {}, testid: {}, ariaLabel: {} }, [], [], !0));
function Lc(t) {
  _e(t, "svelte-w8bdbk", "div.svelte-w8bdbk{display:inline}");
}
function qc(t) {
  let e, i, n, l, o, r;
  const a = (
    /*#slots*/
    t[2].default
  ), s = oe(
    a,
    t,
    /*$$scope*/
    t[1],
    null
  );
  return {
    c() {
      e = C("div"), i = C("span"), n = x(), s && s.c(), l = x(), o = C("span"), f(i, "data-tab-boundry", "start"), f(i, "tabindex", "0"), f(o, "data-tab-boundry", "end"), f(o, "tabindex", "0"), f(e, "class", "svelte-w8bdbk");
    },
    m(d, u) {
      D(d, e, u), _(e, i), _(e, n), s && s.m(e, null), _(e, l), _(e, o), t[3](e), r = !0;
    },
    p(d, [u]) {
      s && s.p && (!r || u & /*$$scope*/
      2) && ae(
        s,
        a,
        d,
        /*$$scope*/
        d[1],
        r ? re(
          a,
          /*$$scope*/
          d[1],
          u,
          null
        ) : se(
          /*$$scope*/
          d[1]
        ),
        null
      );
    },
    i(d) {
      r || (Y(s, d), r = !0);
    },
    o(d) {
      U(s, d), r = !1;
    },
    d(d) {
      d && P(e), s && s.d(d), t[3](null);
    }
  };
}
function Sc(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, o, r, a, s, d = !0;
  ke(async () => {
    await Pe(), o.addEventListener("focus", m, !0), o.addEventListener("keydown", u, !0), o.addEventListener("keyup", c, !0), r = o.querySelector("[data-tab-boundry=start]"), a = o.querySelector("[data-tab-boundry=end]"), h();
  });
  function u(j) {
    j.shiftKey && (s = !0);
  }
  function c(j) {
    j.shiftKey && (s = !1);
  }
  function g(j) {
    var z, V;
    const E = j, M = E.tabIndex > 0 || E.tabIndex === 0 && E.getAttribute("tabIndex") !== null;
    if (d && ((z = E.getAttribute) != null && z.call(E, "data-ignore-focus"))) return "ignore-focus";
    if (E.nodeType !== 1) return null;
    if (M) return j;
    if (E != null && E.getAttribute("disabled") || E.tabIndex < 0 || ((V = E.getAttribute) == null ? void 0 : V.call(E, "tabindex")) === "-1") return null;
    let L = null;
    switch (E.nodeName) {
      case "A": {
        const T = E;
        T.href && T.rel !== "ignore" && (L = j);
        break;
      }
      case "INPUT": {
        const T = E;
        T.type !== "hidden" && T.type !== "file" && (L = j);
        break;
      }
      case "BUTTON":
      case "SELECT":
      case "TEXTAREA":
        L = j;
        break;
    }
    return L;
  }
  function h() {
    const j = o == null ? void 0 : o.querySelector("slot");
    if (!j) return;
    const E = v([j], !1);
    E == null || E.focus();
  }
  function m(j) {
    const E = (j == null ? void 0 : j.target) ?? o;
    if (d = !1, E.dataset.tabBoundry === "start") {
      if (s) {
        a == null || a.focus();
        return;
      }
      const M = E.nextElementSibling;
      if (!M) return;
      const L = v([M], !1);
      L == null || L.focus();
      return;
    }
    if (E.dataset.tabBoundry === "end") {
      if (!s) {
        r == null || r.focus();
        return;
      }
      const M = E.previousElementSibling;
      if (!M) return;
      const L = v([M], !0);
      L == null || L.focus();
      return;
    }
  }
  function v(j, E = !1) {
    const M = E ? [...j].reverse() : j;
    for (const L of M)
      if (g(L) !== "ignore-focus") {
        const z = g(L) || v(L.childNodes, E) || b(L, E) || w(L, E);
        if (z)
          return z;
      }
    return null;
  }
  function b(j, E) {
    return j instanceof HTMLSlotElement ? v([...j.assignedNodes()], E) : null;
  }
  function w(j, E) {
    var M;
    return j instanceof HTMLElement ? v([...((M = j.shadowRoot) == null ? void 0 : M.childNodes) || []], E) : null;
  }
  function y(j) {
    ue[j ? "unshift" : "push"](() => {
      o = j, i(0, o);
    });
  }
  return t.$$set = (j) => {
    "$$scope" in j && i(1, l = j.$$scope);
  }, [o, l, n, y];
}
class Tc extends me {
  constructor(e) {
    super(), ge(this, e, Sc, qc, ce, {}, Lc);
  }
}
customElements.define("goa-focus-trap", he(Tc, {}, ["default"], [], !0));
function Pc(t) {
  _e(t, "svelte-gzux3e", ".svelte-gzux3e.svelte-gzux3e{box-sizing:border-box}.app-footer.svelte-gzux3e.svelte-gzux3e{background-color:var(--goa-footer-color-bg);border-top:var(--goa-footer-border-top);border-bottom:var(--goa-footer-border-bottom);container:self / inline-size}.content.svelte-gzux3e.svelte-gzux3e{margin:0 auto;width:min(var(--max-content-width), 100%)}@container self (max-width: 623px){.content.svelte-gzux3e.svelte-gzux3e{padding:var(--goa-footer-padding-small-screen);font-size:var(--goa-footer-typography-small-screen)}.logo.svelte-gzux3e.svelte-gzux3e{width:var(--goa-footer-size-logo-mobile)}}@container self (min-width: 624px) and (max-width: 1023px){.content.svelte-gzux3e.svelte-gzux3e{padding:var(--goa-footer-padding-medium-screen)}.logo.svelte-gzux3e.svelte-gzux3e{width:var(--goa-footer-size-logo-tablet)}}@container self (min-width: 1024px){.content.svelte-gzux3e.svelte-gzux3e{padding:var(--goa-footer-padding-large-screen)}.logo.svelte-gzux3e.svelte-gzux3e{width:var(--goa-footer-size-logo-desktop)}}.meta-section.svelte-gzux3e.svelte-gzux3e{display:flex;flex-direction:column;gap:var(--goa-space-l)}.meta-section.with-meta-links.svelte-gzux3e.svelte-gzux3e{justify-content:space-between}.meta-links.svelte-gzux3e.svelte-gzux3e{display:none}.with-meta-links.svelte-gzux3e .meta-links.svelte-gzux3e{display:block}.nav-links.svelte-gzux3e.svelte-gzux3e{display:flex;flex-direction:column;gap:var(--goa-space-xl)}.abgov.svelte-gzux3e.svelte-gzux3e{display:flex;flex-direction:column;justify-content:space-between;width:100%;gap:var(--goa-space-m)}@container self (min-width: 624px){.meta-section.svelte-gzux3e.svelte-gzux3e{flex-direction:row;gap:var(--goa-space-xl)}.nav-links.svelte-gzux3e.svelte-gzux3e{flex-direction:row;gap:var(--goa-space-2xl)}.abgov.svelte-gzux3e.svelte-gzux3e{align-items:center;flex-direction:row-reverse;gap:var(--goa-space-m)}.abgov.with-meta-links.svelte-gzux3e.svelte-gzux3e{align-items:flex-end}}.abgov.with-meta-links.svelte-gzux3e.svelte-gzux3e{gap:var(--goa-space-m);flex-direction:column;width:unset}.goa-copyright.svelte-gzux3e.svelte-gzux3e{white-space:nowrap}a.svelte-gzux3e.svelte-gzux3e{color:var(--goa-footer-color-links-secondary);cursor:pointer;display:flex}a.svelte-gzux3e.svelte-gzux3e:hover{color:var(--goa-footer-color-links-secondary-hover)}a.svelte-gzux3e.svelte-gzux3e:focus-visible{outline:var(--goa-footer-link-focus);border-radius:2px}");
}
const Dc = (t) => ({}), ml = (t) => ({}), Hc = (t) => ({}), vl = (t) => ({});
function bl(t) {
  let e;
  return {
    c() {
      e = C("goa-divider"), p(e, "mt", "l"), p(e, "mb", "l"), p(e, "class", "svelte-gzux3e");
    },
    m(i, n) {
      D(i, e, n);
    },
    d(i) {
      i && P(e);
    }
  };
}
function Oc(t) {
  let e, i;
  return {
    c() {
      e = C("img"), Ot(e.src, i = Xr) || f(e, "src", i), f(e, "alt", "Government of Alberta Logo"), f(e, "class", "logo svelte-gzux3e");
    },
    m(n, l) {
      D(n, e, l);
    },
    p: ve,
    d(n) {
      n && P(e);
    }
  };
}
function Fc(t) {
  let e, i, n;
  return {
    c() {
      e = C("a"), i = C("img"), Ot(i.src, n = Xr) || f(i, "src", n), f(i, "alt", "Government of Alberta Logo"), f(i, "class", "logo svelte-gzux3e"), f(
        e,
        "href",
        /*url*/
        t[2]
      ), f(e, "class", "svelte-gzux3e");
    },
    m(l, o) {
      D(l, e, o), _(e, i);
    },
    p(l, o) {
      o & /*url*/
      4 && f(
        e,
        "href",
        /*url*/
        l[2]
      );
    },
    d(l) {
      l && P(e);
    }
  };
}
function Ac(t) {
  var L;
  let e, i, n, l, o, r, a, s, d, u, c, g, h;
  const m = (
    /*#slots*/
    t[8].nav
  ), v = oe(
    m,
    t,
    /*$$scope*/
    t[7],
    vl
  );
  let b = (
    /*navLinks*/
    ((L = t[4]) == null ? void 0 : L.length) > 0 && bl()
  );
  const w = (
    /*#slots*/
    t[8].meta
  ), y = oe(
    w,
    t,
    /*$$scope*/
    t[7],
    ml
  );
  function j(z, V) {
    return (
      /*url*/
      z[2] && /*url*/
      z[2] !== "" ? Fc : Oc
    );
  }
  let E = j(t), M = E(t);
  return {
    c() {
      e = C("div"), i = C("div"), n = C("div"), v && v.c(), l = x(), b && b.c(), o = x(), r = C("div"), a = C("div"), y && y.c(), s = x(), d = C("div"), M.c(), u = x(), c = C("a"), c.textContent = `© ${/*year*/
      t[6]} Government of Alberta`, f(n, "class", "nav-links svelte-gzux3e"), f(a, "class", "meta-links svelte-gzux3e"), f(c, "href", "https://alberta.ca"), f(c, "class", "goa-copyright svelte-gzux3e"), f(d, "class", "abgov svelte-gzux3e"), G(
        d,
        "with-meta-links",
        /*metaLinks*/
        t[5] && /*metaLinks*/
        t[5].length > 0
      ), f(r, "class", "meta-section svelte-gzux3e"), G(
        r,
        "with-meta-links",
        /*metaLinks*/
        t[5] && /*metaLinks*/
        t[5].length > 0
      ), f(i, "class", "content svelte-gzux3e"), f(e, "class", "app-footer svelte-gzux3e"), f(e, "style", g = `--max-content-width: ${/*maxcontentwidth*/
      t[0] || "100%"}`), f(
        e,
        "data-testid",
        /*testid*/
        t[1]
      );
    },
    m(z, V) {
      D(z, e, V), _(e, i), _(i, n), v && v.m(n, null), _(i, l), b && b.m(i, null), _(i, o), _(i, r), _(r, a), y && y.m(a, null), _(r, s), _(r, d), M.m(d, null), _(d, u), _(d, c), t[9](e), h = !0;
    },
    p(z, [V]) {
      var T;
      v && v.p && (!h || V & /*$$scope*/
      128) && ae(
        v,
        m,
        z,
        /*$$scope*/
        z[7],
        h ? re(
          m,
          /*$$scope*/
          z[7],
          V,
          Hc
        ) : se(
          /*$$scope*/
          z[7]
        ),
        vl
      ), /*navLinks*/
      ((T = z[4]) == null ? void 0 : T.length) > 0 ? b || (b = bl(), b.c(), b.m(i, o)) : b && (b.d(1), b = null), y && y.p && (!h || V & /*$$scope*/
      128) && ae(
        y,
        w,
        z,
        /*$$scope*/
        z[7],
        h ? re(
          w,
          /*$$scope*/
          z[7],
          V,
          Dc
        ) : se(
          /*$$scope*/
          z[7]
        ),
        ml
      ), E === (E = j(z)) && M ? M.p(z, V) : (M.d(1), M = E(z), M && (M.c(), M.m(d, u))), (!h || V & /*metaLinks*/
      32) && G(
        d,
        "with-meta-links",
        /*metaLinks*/
        z[5] && /*metaLinks*/
        z[5].length > 0
      ), (!h || V & /*metaLinks*/
      32) && G(
        r,
        "with-meta-links",
        /*metaLinks*/
        z[5] && /*metaLinks*/
        z[5].length > 0
      ), (!h || V & /*maxcontentwidth*/
      1 && g !== (g = `--max-content-width: ${/*maxcontentwidth*/
      z[0] || "100%"}`)) && f(e, "style", g), (!h || V & /*testid*/
      2) && f(
        e,
        "data-testid",
        /*testid*/
        z[1]
      );
    },
    i(z) {
      h || (Y(v, z), Y(y, z), h = !0);
    },
    o(z) {
      U(v, z), U(y, z), h = !1;
    },
    d(z) {
      z && P(e), v && v.d(z), b && b.d(), y && y.d(z), M.d(), t[9](null);
    }
  };
}
const Xr = "data:image/svg+xml,%3Csvg width='155' height='42' viewBox='0 0 155 42' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_74_4890)'%3E%3Cpath d='M155 21H140.6V35.4004H155V21Z' fill='%2300B6ED'/%3E%3Cpath d='M65.5539 33.211C64.116 33.349 62.6147 33.4882 61.0366 33.5566C61.6106 29.2005 63.9758 23.1883 66.915 24.1484C68.6357 24.7016 67.7035 29.8197 65.5527 33.2086L65.5539 33.211ZM61.8957 36.1823C61.4683 36.2514 61.0326 36.2514 60.6053 36.1823C60.7165 36.1047 60.8073 36.0013 60.8699 35.881C60.9325 35.7606 60.965 35.6268 60.9647 35.4911V34.9378C61.7531 34.9378 62.9717 34.7998 64.4779 34.6606C63.8154 35.4471 62.9038 35.9839 61.8957 36.1823ZM79.8198 25.8116C81.6842 24.1484 82.6164 24.29 82.8273 24.7052C83.3294 25.6736 81.1786 29.0625 76.9489 30.9297C77.3845 28.9796 78.3814 27.2002 79.8162 25.8116H79.8198ZM149 27.4712C148.784 24.0824 145.702 23.5291 145.272 24.4976C145.128 24.8432 146.419 24.7052 146.419 27.1256C146.419 31.0677 142.261 36.2543 136.953 36.2543C135.111 36.3656 133.298 35.7577 131.894 34.5583C130.49 33.3589 129.605 31.6613 129.425 29.8221C129.209 28.3701 129.568 26.3636 126.988 26.6408C125.19 26.8484 123.618 30.1677 121.324 33.001C119.387 35.4215 118.527 35.2139 118.957 33.139C119.531 30.5109 121.754 24.4256 124.335 24.0104C125.553 23.8027 125.983 25.8104 126.491 24.5636C126.674 24.1246 126.746 23.6475 126.701 23.1742C126.655 22.7009 126.495 22.246 126.233 21.8497C125.97 21.4533 125.615 21.1276 125.197 20.9012C124.78 20.6749 124.313 20.5549 123.839 20.5519C121.974 20.5519 119.751 22.4887 117.888 24.632C116.311 26.5688 108.209 38.0483 104.768 35.5595C103.191 34.3834 103.33 29.6793 104.338 24.1484C105.794 23.5168 107.361 23.1795 108.948 23.1559C110.536 23.1322 112.112 23.4226 113.587 24.0104C114.519 24.4256 114.665 24.356 114.233 23.3875C113.659 21.9355 110.433 19.653 105.343 20.6899C105.199 20.6899 105.127 20.7595 104.984 20.7595C105.414 18.9594 105.844 17.0946 106.421 15.2957C106.923 13.6361 108.286 10.8004 104.624 10.3168C103.477 10.1092 103.979 10.6624 103.546 12.184C102.827 14.9501 101.969 18.5442 101.323 22.2115C98.0002 24.1064 95.2885 26.9143 93.5082 30.3033C93.9222 28.7349 94.2336 27.141 94.4404 25.532C94.4806 25.1343 94.3704 24.7359 94.1314 24.4157C93.8924 24.0955 93.5422 23.8768 93.1499 23.8027C92.3615 23.5951 91.3526 23.9408 90.4252 25.2548C88.2025 28.2981 85.4071 33.0694 81.1055 35.0747C78.0225 36.5267 76.6601 35.0747 76.5894 32.7946C77.1289 32.6525 77.6562 32.4675 78.1663 32.2414C83.7583 29.8905 85.6228 26.294 84.2604 24.0812C82.898 22.0063 79.0985 22.6291 76.0155 25.7408C74.3913 27.5384 73.4079 29.8245 73.2188 32.2414C71.9284 32.5186 70.4941 32.7214 68.8454 32.9326C71.4263 28.8525 71.2118 23.3191 67.4075 22.3519C62.9621 21.2455 60.7395 25.3952 59.8084 28.8525C60.1679 24.98 60.7407 21.1063 61.4572 17.3034C61.8167 15.6437 62.9621 12.808 59.3004 12.3244C58.1537 12.1168 58.2963 12.67 58.3682 14.1917C58.512 16.2665 56.1455 28.6461 57.3641 34.0402C55.7872 34.5202 55.1414 35.6999 57.1484 36.8759C58.3625 37.3816 59.673 37.6128 60.9865 37.5531C62.3 37.4933 63.5842 37.1441 64.7475 36.5303C65.8289 36.0016 66.8016 35.2742 67.6148 34.3858C69.4792 34.1782 71.4143 33.8326 73.2069 33.5554C73.4932 35.9759 75.1432 37.7735 78.8708 37.4279C84.1765 36.9479 88.9083 30.6501 90.7008 27.608C90.3413 30.8589 88.1917 37.9811 91.9194 37.6355C93.3572 37.4975 92.7797 37.2899 92.8516 36.0455C93.211 31.7578 96.8668 28.0929 100.52 25.8788C99.8743 31.1349 100.09 35.8391 102.599 37.2899C107.187 40.056 113.569 32.7946 117.153 28.3689C115.355 32.311 114.356 37.2899 117.009 38.0507C120.164 38.9496 122.673 33.8326 125.612 29.9589C125.971 32.725 127.907 37.5659 135.649 37.5659C143.966 37.4963 149.2 32.6554 148.984 27.4688L149 27.4712ZM36.7117 36.1091C33.9173 35.1299 31.1875 33.9747 28.5387 32.6506C30.939 31.8034 33.2854 30.8103 35.565 29.6769C35.8138 31.8427 36.1968 33.9909 36.7117 36.1091ZM57.8817 39.9888C57.8098 39.7812 57.2359 40.0584 56.735 39.9888C55.2289 39.7812 53.2219 37.7759 52.6479 34.525C51.5695 28.6449 52.2178 22.8379 54.0103 14.1929C54.3698 12.5332 55.5164 9.69756 51.8535 9.14435C50.7068 9.00634 51.2796 9.55956 50.9932 11.0116C49.5553 17.4438 44.1106 22.0771 38.6624 25.1888C38.0884 17.8578 38.3029 9.62796 39.7408 4.64903C40.9629 0.430912 42.396 1.19173 40.6035 0.292908C38.8109 -0.605916 36.732 0.568916 35.0833 3.7478C33.4346 6.92669 25.9122 24.014 13.8629 35.5631C7.69931 41.4408 2.10485 38.3987 1.02886 37.4999C0.0966476 36.7391 -0.189725 37.9151 0.885072 39.09C5.8325 44.3461 13.1452 41.37 15.7968 38.8128C23.1059 31.759 31.6408 16.5438 35.0881 10.1128C34.6816 15.735 34.7775 21.3824 35.3745 26.9876C32.6035 28.2941 29.7251 29.3585 26.7713 30.1689C25.0507 30.5841 23.9747 31.2753 23.9747 32.0362C23.9747 32.797 25.1213 33.5578 26.7713 34.3162C29.7105 35.6999 38.3856 39.5724 40.4645 40.8168C42.2618 41.8536 43.1892 41.0244 43.6913 39.918C44.4102 38.4659 42.4727 37.6379 40.6083 37.1519C39.7869 34.1144 39.2115 31.0154 38.8876 27.8853C43.2611 25.2572 47.6346 21.7999 50.0718 17.445C49.4271 21.0451 47.8491 33.421 51.8691 38.6076C52.4249 39.3234 53.1422 39.8971 53.9622 40.2815C54.7822 40.666 55.6816 40.8502 56.5864 40.8192C57.5905 40.7496 58.0243 40.128 57.8769 39.9888' fill='%23545860'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_74_4890'%3E%3Crect width='154.804' height='42' fill='white' transform='translate(0.195801)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A";
function Vc(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { maxcontentwidth: o = "" } = e, { testid: r = "" } = e, { url: a = "https://alberta.ca" } = e, s, d, u;
  const c = /* @__PURE__ */ (/* @__PURE__ */ new Date()).getFullYear();
  ke(async () => {
    await Pe();
    const h = s.querySelector("slot[name=nav]"), m = s.querySelector("slot[name=meta]");
    i(5, u = m == null ? void 0 : m.assignedElements()), i(4, d = h == null ? void 0 : h.assignedElements());
  });
  function g(h) {
    ue[h ? "unshift" : "push"](() => {
      s = h, i(3, s);
    });
  }
  return t.$$set = (h) => {
    "maxcontentwidth" in h && i(0, o = h.maxcontentwidth), "testid" in h && i(1, r = h.testid), "url" in h && i(2, a = h.url), "$$scope" in h && i(7, l = h.$$scope);
  }, [
    o,
    r,
    a,
    s,
    d,
    u,
    c,
    l,
    n,
    g
  ];
}
class Ic extends me {
  constructor(e) {
    super(), ge(this, e, Vc, Ac, ce, { maxcontentwidth: 0, testid: 1, url: 2 }, Pc);
  }
  get maxcontentwidth() {
    return this.$$.ctx[0];
  }
  set maxcontentwidth(e) {
    this.$$set({ maxcontentwidth: e }), k();
  }
  get testid() {
    return this.$$.ctx[1];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get url() {
    return this.$$.ctx[2];
  }
  set url(e) {
    this.$$set({ url: e }), k();
  }
}
customElements.define("goa-app-footer", he(Ic, { maxcontentwidth: {}, testid: {}, url: {} }, ["nav", "meta"], [], !0));
function xc(t) {
  _e(t, "svelte-n2dbl6", ".hidden.svelte-n2dbl6{display:none}ul.svelte-n2dbl6{display:flex;flex-wrap:wrap;gap:var(--goa-footer-meta-links-gap);padding:0;margin:8px 0px 0px 0px}li.svelte-n2dbl6{list-style-type:none}@media(max-width: 623px){ul.svelte-n2dbl6{display:flex;flex-wrap:wrap;gap:var(--goa-footer-meta-links-gap-small-screen);padding:0;margin:0px 0px 0px 0px}}a.svelte-n2dbl6{color:var(--goa-footer-color-links);cursor:pointer;white-space:nowrap}a.svelte-n2dbl6:hover{color:var(--goa-footer-color-links-hover)}a.svelte-n2dbl6:focus-visible{outline:var(--goa-footer-link-focus);border-radius:2px}");
}
function pl(t, e, i) {
  const n = t.slice();
  return n[6] = e[i], n;
}
function _l(t) {
  let e, i, n = (
    /*child*/
    t[6].innerHTML + ""
  ), l, o;
  return {
    c() {
      e = C("li"), i = C("a"), l = le(n), f(i, "href", o = /*child*/
      t[6].href), f(i, "class", "svelte-n2dbl6"), f(e, "class", "svelte-n2dbl6");
    },
    m(r, a) {
      D(r, e, a), _(e, i), _(i, l);
    },
    p(r, a) {
      a & /*children*/
      4 && n !== (n = /*child*/
      r[6].innerHTML + "") && pe(l, n), a & /*children*/
      4 && o !== (o = /*child*/
      r[6].href) && f(i, "href", o);
    },
    d(r) {
      r && P(e);
    }
  };
}
function Bc(t) {
  let e, i, n, l, o;
  const r = (
    /*#slots*/
    t[4].default
  ), a = oe(
    r,
    t,
    /*$$scope*/
    t[3],
    null
  );
  let s = Le(
    /*children*/
    t[2]
  ), d = [];
  for (let u = 0; u < s.length; u += 1)
    d[u] = _l(pl(t, s, u));
  return {
    c() {
      e = C("section"), i = C("div"), a && a.c(), n = x(), l = C("ul");
      for (let u = 0; u < d.length; u += 1)
        d[u].c();
      f(i, "class", "hidden svelte-n2dbl6"), f(l, "class", "svelte-n2dbl6"), f(
        e,
        "data-testid",
        /*testid*/
        t[0]
      );
    },
    m(u, c) {
      D(u, e, c), _(e, i), a && a.m(i, null), _(e, n), _(e, l);
      for (let g = 0; g < d.length; g += 1)
        d[g] && d[g].m(l, null);
      t[5](e), o = !0;
    },
    p(u, [c]) {
      if (a && a.p && (!o || c & /*$$scope*/
      8) && ae(
        a,
        r,
        u,
        /*$$scope*/
        u[3],
        o ? re(
          r,
          /*$$scope*/
          u[3],
          c,
          null
        ) : se(
          /*$$scope*/
          u[3]
        ),
        null
      ), c & /*children*/
      4) {
        s = Le(
          /*children*/
          u[2]
        );
        let g;
        for (g = 0; g < s.length; g += 1) {
          const h = pl(u, s, g);
          d[g] ? d[g].p(h, c) : (d[g] = _l(h), d[g].c(), d[g].m(l, null));
        }
        for (; g < d.length; g += 1)
          d[g].d(1);
        d.length = s.length;
      }
      (!o || c & /*testid*/
      1) && f(
        e,
        "data-testid",
        /*testid*/
        u[0]
      );
    },
    i(u) {
      o || (Y(a, u), o = !0);
    },
    o(u) {
      U(a, u), o = !1;
    },
    d(u) {
      u && P(e), a && a.d(u), Ye(d, u), t[5](null);
    }
  };
}
function Nc(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { testid: o = "" } = e, r, a = [];
  ke(async () => {
    if (await Pe(), i(2, a = r.querySelector("slot").assignedElements()), !a.map((u) => u.hasAttribute("href")).reduce(
      (u, c) => u && c,
      !0
    )) {
      i(2, a = []), console.warn("GoAFooterMetaSection children must be anchor elements.");
      return;
    }
  });
  function s(d) {
    ue[d ? "unshift" : "push"](() => {
      r = d, i(1, r);
    });
  }
  return t.$$set = (d) => {
    "testid" in d && i(0, o = d.testid), "$$scope" in d && i(3, l = d.$$scope);
  }, [o, r, a, l, n, s];
}
class Wc extends me {
  constructor(e) {
    super(), ge(this, e, Nc, Bc, ce, { testid: 0 }, xc);
  }
  get testid() {
    return this.$$.ctx[0];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-app-footer-meta-section", he(Wc, { testid: {} }, ["default"], [], !0));
function Rc(t) {
  _e(t, "svelte-19vpbbx", ":host{flex:auto}.title.svelte-19vpbbx{font:var(--goa-typography-heading-s);padding-bottom:var(--goa-space-m);color:var(--goa-color-greyscale-800)}.hidden.svelte-19vpbbx{display:none}.links.svelte-19vpbbx{display:flex;flex-direction:column;list-style-type:none;padding-left:0;margin:0;gap:12px}@media not (max-width: 623px){.links.svelte-19vpbbx{list-style-type:none;padding-left:0;flex-direction:column}.title.svelte-19vpbbx{font:var(--goa-typography-heading-m);padding-bottom:var(--goa-space-l)}}@media(min-width: 624px) and (max-width: 1023px){.links.svelte-19vpbbx{display:var(--narrow-display-type);-moz-column-count:var(--narrow-column-count);column-count:var(--narrow-column-count)}}@media(min-width: 1024px){.links.svelte-19vpbbx{display:var(--wide-display-type);-moz-column-count:var(--wide-column-count);column-count:var(--wide-column-count)}}a.svelte-19vpbbx{color:var(--goa-footer-color-links);cursor:pointer}a.svelte-19vpbbx:hover{color:var(--goa-footer-color-links-hover)}a.svelte-19vpbbx:focus-visible{outline:var(--goa-footer-link-focus);border-radius:2px}");
}
function wl(t, e, i) {
  const n = t.slice();
  return n[8] = e[i], n;
}
function kl(t) {
  let e, i, n, l;
  return {
    c() {
      e = C("div"), i = le(
        /*heading*/
        t[0]
      ), n = x(), l = C("goa-divider"), f(e, "class", "title svelte-19vpbbx"), p(l, "mb", "l");
    },
    m(o, r) {
      D(o, e, r), _(e, i), D(o, n, r), D(o, l, r);
    },
    p(o, r) {
      r & /*heading*/
      1 && pe(
        i,
        /*heading*/
        o[0]
      );
    },
    d(o) {
      o && (P(e), P(n), P(l));
    }
  };
}
function yl(t) {
  let e, i, n = (
    /*child*/
    t[8].innerHTML + ""
  ), l, o;
  return {
    c() {
      e = C("li"), i = C("a"), l = le(n), f(i, "href", o = /*child*/
      t[8].href), f(i, "class", "svelte-19vpbbx");
    },
    m(r, a) {
      D(r, e, a), _(e, i), _(i, l);
    },
    p(r, a) {
      a & /*children*/
      16 && n !== (n = /*child*/
      r[8].innerHTML + "") && pe(l, n), a & /*children*/
      16 && o !== (o = /*child*/
      r[8].href) && f(i, "href", o);
    },
    d(r) {
      r && P(e);
    }
  };
}
function Yc(t) {
  let e, i, n, l, o, r, a, s = (
    /*heading*/
    t[0] && kl(t)
  );
  const d = (
    /*#slots*/
    t[6].default
  ), u = oe(
    d,
    t,
    /*$$scope*/
    t[5],
    null
  );
  let c = Le(
    /*children*/
    t[4]
  ), g = [];
  for (let h = 0; h < c.length; h += 1)
    g[h] = yl(wl(t, c, h));
  return {
    c() {
      e = C("section"), s && s.c(), i = x(), n = C("div"), u && u.c(), l = x(), o = C("ul");
      for (let h = 0; h < g.length; h += 1)
        g[h].c();
      f(n, "class", "hidden svelte-19vpbbx"), f(o, "class", "links svelte-19vpbbx"), f(o, "style", r = `
      --narrow-display-type: ${Math.ceil(
        /*maxcolumncount*/
        t[1] / 2
      ) > 1 ? "block" : "flex"};
      --narrow-column-count: ${Math.ceil(
        /*maxcolumncount*/
        t[1] / 2
      )};
      --wide-display-type: ${/*maxcolumncount*/
      t[1] > 1 ? "block" : "flex"};
      --wide-column-count: ${/*maxcolumncount*/
      t[1]};
    `), f(
        e,
        "data-testid",
        /*testid*/
        t[2]
      );
    },
    m(h, m) {
      D(h, e, m), s && s.m(e, null), _(e, i), _(e, n), u && u.m(n, null), _(e, l), _(e, o);
      for (let v = 0; v < g.length; v += 1)
        g[v] && g[v].m(o, null);
      t[7](e), a = !0;
    },
    p(h, [m]) {
      if (/*heading*/
      h[0] ? s ? s.p(h, m) : (s = kl(h), s.c(), s.m(e, i)) : s && (s.d(1), s = null), u && u.p && (!a || m & /*$$scope*/
      32) && ae(
        u,
        d,
        h,
        /*$$scope*/
        h[5],
        a ? re(
          d,
          /*$$scope*/
          h[5],
          m,
          null
        ) : se(
          /*$$scope*/
          h[5]
        ),
        null
      ), m & /*children*/
      16) {
        c = Le(
          /*children*/
          h[4]
        );
        let v;
        for (v = 0; v < c.length; v += 1) {
          const b = wl(h, c, v);
          g[v] ? g[v].p(b, m) : (g[v] = yl(b), g[v].c(), g[v].m(o, null));
        }
        for (; v < g.length; v += 1)
          g[v].d(1);
        g.length = c.length;
      }
      (!a || m & /*maxcolumncount*/
      2 && r !== (r = `
      --narrow-display-type: ${Math.ceil(
        /*maxcolumncount*/
        h[1] / 2
      ) > 1 ? "block" : "flex"};
      --narrow-column-count: ${Math.ceil(
        /*maxcolumncount*/
        h[1] / 2
      )};
      --wide-display-type: ${/*maxcolumncount*/
      h[1] > 1 ? "block" : "flex"};
      --wide-column-count: ${/*maxcolumncount*/
      h[1]};
    `)) && f(o, "style", r), (!a || m & /*testid*/
      4) && f(
        e,
        "data-testid",
        /*testid*/
        h[2]
      );
    },
    i(h) {
      a || (Y(u, h), a = !0);
    },
    o(h) {
      U(u, h), a = !1;
    },
    d(h) {
      h && P(e), s && s.d(), u && u.d(h), Ye(g, h), t[7](null);
    }
  };
}
function Zc(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { heading: o = "" } = e, { maxcolumncount: r = 1 } = e, { testid: a = "" } = e, s, d = [];
  ke(async () => {
    var g;
    if (await Pe(), i(4, d = (g = s.querySelector("slot")) == null ? void 0 : g.assignedElements()), !d.map((h) => h.hasAttribute("href")).reduce(
      (h, m) => h && m,
      !0
    )) {
      i(4, d = []), console.warn("GoAFooterNavSection children must be anchor elements.");
      return;
    }
  });
  function u(c) {
    ue[c ? "unshift" : "push"](() => {
      s = c, i(3, s);
    });
  }
  return t.$$set = (c) => {
    "heading" in c && i(0, o = c.heading), "maxcolumncount" in c && i(1, r = c.maxcolumncount), "testid" in c && i(2, a = c.testid), "$$scope" in c && i(5, l = c.$$scope);
  }, [
    o,
    r,
    a,
    s,
    d,
    l,
    n,
    u
  ];
}
class Uc extends me {
  constructor(e) {
    super(), ge(this, e, Zc, Yc, ce, { heading: 0, maxcolumncount: 1, testid: 2 }, Rc);
  }
  get heading() {
    return this.$$.ctx[0];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get maxcolumncount() {
    return this.$$.ctx[1];
  }
  set maxcolumncount(e) {
    this.$$set({ maxcolumncount: e }), k();
  }
  get testid() {
    return this.$$.ctx[2];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-app-footer-nav-section", he(Uc, { heading: {}, maxcolumncount: {}, testid: {} }, ["default"], [], !0));
function Gc(t) {
  _e(t, "svelte-1js6q8l", "fieldset.svelte-1js6q8l.svelte-1js6q8l{border:none;padding:0}ul.svelte-1js6q8l.svelte-1js6q8l{padding:0}ul.svelte-1js6q8l li.svelte-1js6q8l{list-style-type:none}a.error.svelte-1js6q8l.svelte-1js6q8l,a.error.svelte-1js6q8l.svelte-1js6q8l:visited{color:var(--goa-color-emergency-dark)}");
}
function Cl(t, e, i) {
  const n = t.slice();
  return n[27] = e[i], n;
}
function zl(t) {
  let e, i, n = Le(Object.keys(
    /*_errors*/
    t[1]
  )), l = [];
  for (let o = 0; o < n.length; o += 1)
    l[o] = jl(Cl(t, n, o));
  return {
    c() {
      e = C("goa-callout"), i = C("ul");
      for (let o = 0; o < l.length; o += 1)
        l[o].c();
      f(i, "class", "errors svelte-1js6q8l"), p(e, "type", "emergency"), p(e, "heading", "There is a problem");
    },
    m(o, r) {
      D(o, e, r), _(e, i);
      for (let a = 0; a < l.length; a += 1)
        l[a] && l[a].m(i, null);
    },
    p(o, r) {
      if (r & /*Object, _errors, jumpToError*/
      6) {
        n = Le(Object.keys(
          /*_errors*/
          o[1]
        ));
        let a;
        for (a = 0; a < n.length; a += 1) {
          const s = Cl(o, n, a);
          l[a] ? l[a].p(s, r) : (l[a] = jl(s), l[a].c(), l[a].m(i, null));
        }
        for (; a < l.length; a += 1)
          l[a].d(1);
        l.length = n.length;
      }
    },
    d(o) {
      o && P(e), Ye(l, o);
    }
  };
}
function jl(t) {
  let e, i, n = (
    /*_errors*/
    t[1][
      /*key*/
      t[27]
    ] + ""
  ), l, o, r, a, s;
  function d(...u) {
    return (
      /*click_handler*/
      t[7](
        /*key*/
        t[27],
        ...u
      )
    );
  }
  return {
    c() {
      e = C("li"), i = C("a"), l = le(n), r = x(), f(i, "class", "error svelte-1js6q8l"), f(i, "href", o = `#${/*key*/
      t[27]}`), f(e, "class", "svelte-1js6q8l");
    },
    m(u, c) {
      D(u, e, c), _(e, i), _(i, l), _(e, r), a || (s = te(i, "click", d), a = !0);
    },
    p(u, c) {
      t = u, c & /*_errors*/
      2 && n !== (n = /*_errors*/
      t[1][
        /*key*/
        t[27]
      ] + "") && pe(l, n), c & /*_errors*/
      2 && o !== (o = `#${/*key*/
      t[27]}`) && f(i, "href", o);
    },
    d(u) {
      u && P(e), a = !1, s();
    }
  };
}
function Kc(t) {
  let e, i = Object.values(
    /*_errors*/
    t[1]
  ).filter(El).length, n, l, o, r = i && zl(t);
  const a = (
    /*#slots*/
    t[6].default
  ), s = oe(
    a,
    t,
    /*$$scope*/
    t[5],
    null
  );
  return {
    c() {
      e = C("fieldset"), r && r.c(), n = x(), l = C("goa-block"), s && s.c(), p(l, "gap", "m"), p(l, "direction", "column"), f(e, "class", "svelte-1js6q8l");
    },
    m(d, u) {
      D(d, e, u), r && r.m(e, null), _(e, n), _(e, l), s && s.m(l, null), t[8](e), o = !0;
    },
    p(d, [u]) {
      u & /*_errors*/
      2 && (i = Object.values(
        /*_errors*/
        d[1]
      ).filter(El).length), i ? r ? r.p(d, u) : (r = zl(d), r.c(), r.m(e, n)) : r && (r.d(1), r = null), s && s.p && (!o || u & /*$$scope*/
      32) && ae(
        s,
        a,
        d,
        /*$$scope*/
        d[5],
        o ? re(
          a,
          /*$$scope*/
          d[5],
          u,
          null
        ) : se(
          /*$$scope*/
          d[5]
        ),
        null
      );
    },
    i(d) {
      o || (Y(s, d), o = !0);
    },
    o(d) {
      U(s, d), o = !1;
    },
    d(d) {
      d && P(e), r && r.d(), s && s.d(d), t[8](null);
    }
  };
}
const El = (t) => !!t;
function Xc(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { id: o = "" } = e, { dispatchOn: r = "continue" } = e, a, s = {}, d = {}, u = {}, c = {}, g = {};
  ke(() => {
    L(), z(), h();
  });
  function h() {
    Re(a, (B, N, F) => {
      switch (B) {
        case Ri:
          b(N), F.stopPropagation();
          break;
        case Fr:
          w(), F.stopPropagation();
          break;
        case Rr:
          y(N), F.stopPropagation();
          break;
        case Qe:
          j(N), F.stopPropagation();
          break;
        case Wi:
          m(N), F.stopPropagation();
          break;
        case id:
          E(N), F.stopPropagation();
          break;
        case Nr:
          S(N), F.stopPropagation();
          break;
        case mi:
          v(F), F.stopPropagation();
          break;
      }
    });
  }
  function m(B) {
    B.active && (u = { ...d });
  }
  function v(B) {
    d = {}, B.stopPropagation();
    for (const { el: N } of Object.values(g))
      je(N, zi);
  }
  function b(B) {
    if (B.value.type === "details") {
      for (const [N, F] of Object.entries(B.value.fieldsets))
        d[N] = { ...F };
      for (const [N, F] of Object.entries(d))
        F.value && je(g[N].el, bt, { name: N, value: F.value });
    }
  }
  function w() {
    i(1, s = {});
    for (const [B, N] of Object.entries(g))
      je(N.el, ut, null);
    for (const [B, { el: N }] of Object.entries(c))
      je(N, ut, null);
  }
  function y(B) {
    const { id: N, label: F, el: q } = B;
    c[N] = { label: F, el: q };
  }
  function j(B) {
    const { name: N, el: F } = B;
    if (!N) return;
    const q = Object.keys(g).length;
    g[N] = { order: q + 1, el: F };
  }
  function E(B) {
    i(1, s[B.name] = B.msg, s), je(g[B.name].el, dt, { error: B.msg }), je(c[B.name].el, dt, { error: B.msg });
  }
  function M() {
    for (const [B, N] of Object.entries(g))
      u[B] && je(N.el, bt, { name: B, value: u[B].value });
  }
  function L() {
    setTimeout(
      () => {
        je(
          a,
          It,
          {
            id: o,
            el: a,
            cb: (B) => i(3, o = B)
          },
          { bubbles: !0, timeout: 10 }
        );
      },
      10
    );
  }
  function z() {
    a.addEventListener("_change", (B) => {
      const { name: N, value: F } = B.detail;
      c[N] && g[N] && (d[N] = {
        name: N,
        value: F,
        label: c[N].label,
        order: g[N].order
      }, r === "change" && Object.keys(d).length > 0 && V(), B.stopPropagation());
    });
  }
  function V() {
    je(a, bi, { id: o, state: { data: d }, dispatchOn: r }, { bubbles: !0 });
  }
  function T(B, N) {
    g[N].el.focus(), B.preventDefault();
  }
  function S(B) {
    Object.keys(d).length > 0 && V(), A(B), B.cancelled && (M(), d = u);
  }
  function A(B) {
    qe(
      a,
      "_continue",
      {
        el: a,
        state: B.cancelled ? u : d
      },
      { bubbles: !0 }
    );
  }
  const R = (B, N) => T(N, B);
  function I(B) {
    ue[B ? "unshift" : "push"](() => {
      a = B, i(0, a);
    });
  }
  return t.$$set = (B) => {
    "id" in B && i(3, o = B.id), "dispatchOn" in B && i(4, r = B.dispatchOn), "$$scope" in B && i(5, l = B.$$scope);
  }, [
    a,
    s,
    T,
    o,
    r,
    l,
    n,
    R,
    I
  ];
}
class Jc extends me {
  constructor(e) {
    super(), ge(this, e, Xc, Kc, ce, { id: 3, dispatchOn: 4 }, Gc);
  }
  get id() {
    return this.$$.ctx[3];
  }
  set id(e) {
    this.$$set({ id: e }), k();
  }
  get dispatchOn() {
    return this.$$.ctx[4];
  }
  set dispatchOn(e) {
    this.$$set({ dispatchOn: e }), k();
  }
}
customElements.define("goa-fieldset", he(Jc, { id: {}, dispatchOn: { attribute: "dispatch-on" } }, ["default"], [], !0));
function Qc(t) {
  let e, i, n, l, o, r, a;
  const s = (
    /*#slots*/
    t[6].default
  ), d = oe(
    s,
    t,
    /*$$scope*/
    t[5],
    null
  );
  return {
    c() {
      e = C("div"), i = x(), n = C("form"), l = C("div"), d && d.c(), f(n, "data-id", o = `form: ${/*name*/
      t[1]}`), f(n, "style", r = ze(
        "visibility",
        /*status*/
        t[0] === "complete" ? "visible" : "hidden"
      ));
    },
    m(u, c) {
      D(u, e, c), t[7](e), D(u, i, c), D(u, n, c), _(n, l), d && d.m(l, null), t[8](l), t[9](n), a = !0;
    },
    p(u, c) {
      d && d.p && (!a || c[0] & /*$$scope*/
      32) && ae(
        d,
        s,
        u,
        /*$$scope*/
        u[5],
        a ? re(
          s,
          /*$$scope*/
          u[5],
          c,
          null
        ) : se(
          /*$$scope*/
          u[5]
        ),
        null
      ), (!a || c[0] & /*name*/
      2 && o !== (o = `form: ${/*name*/
      u[1]}`)) && f(n, "data-id", o), (!a || c[0] & /*status*/
      1 && r !== (r = ze(
        "visibility",
        /*status*/
        u[0] === "complete" ? "visible" : "hidden"
      ))) && f(n, "style", r);
    },
    i(u) {
      a || (Y(d, u), a = !0);
    },
    o(u) {
      U(d, u), a = !1;
    },
    d(u) {
      u && (P(e), P(i), P(n)), t[7](null), d && d.d(u), t[8](null), t[9](null);
    }
  };
}
function Ml() {
  return {
    uuid: crypto.randomUUID(),
    form: {},
    history: [],
    editting: "",
    lastModified: void 0,
    status: "not-started"
  };
}
function $c(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { status: o = "complete" } = e, { name: r = "[name] not set" } = e, a, s, d, u = {}, c = {}, g = {}, h, m, v, b;
  ke(() => {
    qe(a, "_init", { el: a }, { bubbles: !0 }), y(), w(), b = Ml();
  });
  function w() {
    d.addEventListener(Yt, (Q) => {
      const X = Q.detail;
      if (X.type === "details") {
        console.warn("Form:addSubformRelayListener", r, "received details type, ignoring");
        return;
      }
      b.form[X.id] = {
        data: { type: "list", items: X.data }
      }, qe(a, Yt, { type: "details", data: b }, { bubbles: !0 }), A();
    });
  }
  function y() {
    Re(a, (Q, X, ee) => {
      switch (ee.stopPropagation(), Q) {
        case Ht:
          j(X);
          break;
        case Ar:
          E(X);
          break;
        case It:
          L(X);
          break;
        case Wr:
          z(X);
          break;
        case vi:
          H();
          break;
        case bi:
          V(X);
          break;
        case Zr:
          M(X);
          break;
        case Di:
          T(X);
          break;
        case Ur:
          R(X);
          break;
        case Br:
          B();
          break;
        case Yr:
          O(X);
          break;
        case mi:
          N();
          break;
      }
    });
  }
  function j(Q) {
    b = { ...b, ...Q || {} }, K(), q(b.history[b.history.length - 1]), A();
  }
  function E(Q) {
    u[Q.id] = Q.el, m = Qi(m, W, 100);
  }
  function M(Q) {
    h = Q.el, A();
  }
  function L(Q) {
    const { id: X } = Q;
    c[X] = Q;
  }
  function z(Q) {
    g[Q.id] = Q, b.form[Q.id] = {
      ...b.form[Q.id],
      heading: Q.heading
    }, v = Qi(v, () => {
      const [X] = Object.entries(g)[0];
      b.history.push(X), q(X);
    });
  }
  function V(Q) {
    const { id: X, state: ee } = Q;
    for (const [ie, J] of Object.entries(ee.data))
      J.value === "" && delete ee.data[ie];
    b.form[X] = {
      heading: ee.heading,
      data: { type: "details", fieldsets: ee.data }
    }, b.lastModified = /* @__PURE__ */ new Date(), S();
  }
  function T(Q) {
    const { next: X } = Q, ee = b.history[b.history.length - 1];
    if (!ee) {
      console.warn("Form:onContinue", r, "no last page");
      return;
    }
    if (S(), b.editting) {
      F(b.editting);
      const ie = b.history.indexOf(b.editting) + 1;
      b.history[ie] === X ? q(ee) : (b.history = [...b.history.slice(0, ie), X], q(X), I(), b.editting = "");
    } else
      F(ee), ee !== X && b.history.push(X), q(X);
    A();
  }
  function S() {
    qe(a, Yt, { type: "details", data: b }, { bubbles: !0, timeout: 100 });
  }
  function A() {
    const Q = { ...b }, X = Object.keys(c);
    Q.form = Object.entries(Q.form).filter(([ee, ie]) => X.includes(ee)).reduce(
      (ee, [ie, J]) => (ee[ie] = J, ee),
      {}
    ), je(h, Ht, Q);
  }
  function R(Q) {
    b.editting = Q.id, q(Q.id), I();
  }
  function I() {
    for (const Q of Object.values(g))
      je(Q.el, Vr, { id: b.editting });
  }
  function B() {
    b.status = "complete", qe(a, "_complete", b, { bubbles: !0 });
  }
  function N() {
    const Q = b.history[0];
    b = Ml(), b.history.push(Q);
    for (const { el: ee } of Object.values(c))
      je(ee, mi);
    A();
    const [X] = Object.entries(g)[0];
    q(X);
  }
  function F(Q) {
    if (!c[Q]) {
      console.warn("Form:resetFieldsetErrors", r, "fieldset does not exist", Q);
      return;
    }
    je(c[Q].el, Fr, null);
  }
  function q(Q) {
    Object.keys(g).forEach((ee) => {
      je(g[ee].el, Wi, { active: ee === Q });
    });
  }
  function H(Q) {
    const X = b.history;
    if (X.length === 1) {
      je(s, vi, null, { bubbles: !0 });
      return;
    }
    X.pop(), b.history = X, q(b.history[b.history.length - 1]), history.back();
  }
  function O(Q) {
    var ie;
    typeof Q == "string" ? b = { ...b, ...JSON.parse(Q) } : b = { ...b, ...Q || {} };
    let X, ee = ((ie = b.history) == null ? void 0 : ie.length) ?? 0;
    ee > 0 && (X = b.history[ee - 1]), setTimeout(
      () => {
        if (X) {
          const J = g[X];
          q(J.id);
        } else {
          const [J] = Object.entries(g)[0];
          b.history.push(J), q(J);
        }
        A(), S(), W();
      },
      200
    );
  }
  function W() {
    var Q;
    for (const [X, ee] of Object.entries(u)) {
      const ie = (Q = b.form[X]) == null ? void 0 : Q.data;
      (ie == null ? void 0 : ie.type) === "list" && je(ee, Ht, ie.items);
    }
  }
  function K() {
    var Q;
    for (const [X, ee] of Object.entries(c)) {
      const ie = (Q = b.form[X]) == null ? void 0 : Q.data;
      ie && je(ee.el, Ri, { name: X, value: ie });
    }
  }
  function $(Q) {
    ue[Q ? "unshift" : "push"](() => {
      s = Q, i(3, s);
    });
  }
  function ye(Q) {
    ue[Q ? "unshift" : "push"](() => {
      d = Q, i(4, d);
    });
  }
  function Z(Q) {
    ue[Q ? "unshift" : "push"](() => {
      a = Q, i(2, a);
    });
  }
  return t.$$set = (Q) => {
    "status" in Q && i(0, o = Q.status), "name" in Q && i(1, r = Q.name), "$$scope" in Q && i(5, l = Q.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*status*/
    1 && o === "complete" && K();
  }, [
    o,
    r,
    a,
    s,
    d,
    l,
    n,
    $,
    ye,
    Z
  ];
}
class ef extends me {
  constructor(e) {
    super(), ge(this, e, $c, Qc, ce, { status: 0, name: 1 }, null, [-1, -1]);
  }
  get status() {
    return this.$$.ctx[0];
  }
  set status(e) {
    this.$$set({ status: e }), k();
  }
  get name() {
    return this.$$.ctx[1];
  }
  set name(e) {
    this.$$set({ name: e }), k();
  }
}
customElements.define("goa-public-form", he(ef, { status: {}, name: {} }, ["default"], [], !0));
function Ll(t) {
  let e, i, n = (
    /*backUrl*/
    t[3] && ql(t)
  ), l = !/*backUrl*/
  t[3] && /*type*/
  t[4] === "step" && Sl(t);
  return {
    c() {
      n && n.c(), e = x(), l && l.c(), i = Ne();
    },
    m(o, r) {
      n && n.m(o, r), D(o, e, r), l && l.m(o, r), D(o, i, r);
    },
    p(o, r) {
      /*backUrl*/
      o[3] ? n ? n.p(o, r) : (n = ql(o), n.c(), n.m(e.parentNode, e)) : n && (n.d(1), n = null), !/*backUrl*/
      o[3] && /*type*/
      o[4] === "step" ? l ? l.p(o, r) : (l = Sl(o), l.c(), l.m(i.parentNode, i)) : l && (l.d(1), l = null);
    },
    d(o) {
      o && (P(e), P(i)), n && n.d(o), l && l.d(o);
    }
  };
}
function ql(t) {
  let e, i, n;
  return {
    c() {
      e = C("goa-link"), i = C("a"), n = le("Back"), f(
        i,
        "href",
        /*backUrl*/
        t[3]
      ), p(e, "leadingicon", "chevron-back"), p(e, "mb", "2xl");
    },
    m(l, o) {
      D(l, e, o), _(e, i), _(i, n);
    },
    p(l, o) {
      o[0] & /*backUrl*/
      8 && f(
        i,
        "href",
        /*backUrl*/
        l[3]
      );
    },
    d(l) {
      l && P(e);
    }
  };
}
function Sl(t) {
  let e, i, n;
  return {
    c() {
      e = C("goa-link-button"), e.textContent = "Back", p(e, "leadingicon", "chevron-back"), p(e, "mb", "2xl");
    },
    m(l, o) {
      D(l, e, o), i || (n = te(
        e,
        "_click",
        /*handleBack*/
        t[17]
      ), i = !0);
    },
    p: ve,
    d(l) {
      l && P(e), i = !1, n();
    }
  };
}
function Tl(t) {
  let e, i;
  return {
    c() {
      e = C("goa-text"), i = le(
        /*sectionTitle*/
        t[2]
      ), p(e, "size", "body-l"), p(e, "mb", "s"), p(e, "color", "secondary");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l[0] & /*sectionTitle*/
      4 && pe(
        i,
        /*sectionTitle*/
        n[2]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function Pl(t) {
  let e, i;
  return {
    c() {
      e = C("goa-text"), i = le(
        /*heading*/
        t[1]
      ), p(e, "as", "h2"), p(e, "size", "heading-l");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l[0] & /*heading*/
      2 && pe(
        i,
        /*heading*/
        n[1]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function Dl(t) {
  let e, i, n = (
    /*_editting*/
    t[14] && Hl(t)
  );
  function l(a, s) {
    if (
      /*type*/
      a[4] === "summary"
    ) return nf;
    if (
      /*buttonVisibility*/
      a[5] === "visible"
    ) return tf;
  }
  let o = l(t), r = o && o(t);
  return {
    c() {
      e = C("goa-block"), n && n.c(), i = x(), r && r.c(), p(e, "mt", "xl");
    },
    m(a, s) {
      D(a, e, s), n && n.m(e, null), _(e, i), r && r.m(e, null);
    },
    p(a, s) {
      /*_editting*/
      a[14] ? n ? n.p(a, s) : (n = Hl(a), n.c(), n.m(e, i)) : n && (n.d(1), n = null), o === (o = l(a)) && r ? r.p(a, s) : (r && r.d(1), r = o && o(a), r && (r.c(), r.m(e, null)));
    },
    d(a) {
      a && P(e), n && n.d(), r && r.d();
    }
  };
}
function Hl(t) {
  let e, i, n;
  return {
    c() {
      e = C("goa-button"), e.textContent = "Cancel", p(e, "type", "secondary");
    },
    m(l, o) {
      D(l, e, o), i || (n = te(
        e,
        "_click",
        /*click_handler*/
        t[21]
      ), i = !0);
    },
    p: ve,
    d(l) {
      l && P(e), i = !1, n();
    }
  };
}
function tf(t) {
  let e, i = (
    /*buttonText*/
    (t[0] || "Continue") + ""
  ), n, l, o;
  return {
    c() {
      e = C("goa-button"), n = le(i), p(e, "type", "primary");
    },
    m(r, a) {
      D(r, e, a), _(e, n), l || (o = te(
        e,
        "_click",
        /*click_handler_2*/
        t[23]
      ), l = !0);
    },
    p(r, a) {
      a[0] & /*buttonText*/
      1 && i !== (i = /*buttonText*/
      (r[0] || "Continue") + "") && pe(n, i);
    },
    d(r) {
      r && P(e), l = !1, o();
    }
  };
}
function nf(t) {
  let e, i = (
    /*buttonText*/
    (t[0] || "Confirm") + ""
  ), n, l, o;
  return {
    c() {
      e = C("goa-button"), n = le(i), p(e, "type", "primary");
    },
    m(r, a) {
      D(r, e, a), _(e, n), l || (o = te(
        e,
        "_click",
        /*click_handler_1*/
        t[22]
      ), l = !0);
    },
    p(r, a) {
      a[0] & /*buttonText*/
      1 && i !== (i = /*buttonText*/
      (r[0] || "Confirm") + "") && pe(n, i);
    },
    d(r) {
      r && P(e), l = !1, o();
    }
  };
}
function lf(t) {
  let e, i, n, l, o, r, a, s, d = !/*_editting*/
  t[14] && Ll(t), u = (
    /*sectionTitle*/
    t[2] && Tl(t)
  ), c = (
    /*heading*/
    t[1] && Pl(t)
  );
  const g = (
    /*#slots*/
    t[20].default
  ), h = oe(
    g,
    t,
    /*$$scope*/
    t[19],
    null
  );
  let m = (
    /*type*/
    t[4] !== "multistep" && Dl(t)
  );
  return {
    c() {
      e = C("section"), i = C("div"), d && d.c(), n = x(), u && u.c(), l = x(), c && c.c(), o = x(), h && h.c(), r = x(), m && m.c(), f(e, "style", a = Ue(be(
        /*mt*/
        t[6],
        /*mr*/
        t[7],
        /*mb*/
        t[8],
        /*ml*/
        t[9]
      ), `display: ${/*_active*/
      t[11] || /*active*/
      t[10] ? "block" : "none"}`));
    },
    m(v, b) {
      D(v, e, b), _(e, i), d && d.m(i, null), _(i, n), u && u.m(i, null), _(i, l), c && c.m(i, null), _(i, o), h && h.m(i, null), _(i, r), m && m.m(i, null), t[24](i), t[25](e), s = !0;
    },
    p(v, b) {
      /*_editting*/
      v[14] ? d && (d.d(1), d = null) : d ? d.p(v, b) : (d = Ll(v), d.c(), d.m(i, n)), /*sectionTitle*/
      v[2] ? u ? u.p(v, b) : (u = Tl(v), u.c(), u.m(i, l)) : u && (u.d(1), u = null), /*heading*/
      v[1] ? c ? c.p(v, b) : (c = Pl(v), c.c(), c.m(i, o)) : c && (c.d(1), c = null), h && h.p && (!s || b[0] & /*$$scope*/
      524288) && ae(
        h,
        g,
        v,
        /*$$scope*/
        v[19],
        s ? re(
          g,
          /*$$scope*/
          v[19],
          b,
          null
        ) : se(
          /*$$scope*/
          v[19]
        ),
        null
      ), /*type*/
      v[4] !== "multistep" ? m ? m.p(v, b) : (m = Dl(v), m.c(), m.m(i, null)) : m && (m.d(1), m = null), (!s || b[0] & /*mt, mr, mb, ml, _active, active*/
      4032 && a !== (a = Ue(be(
        /*mt*/
        v[6],
        /*mr*/
        v[7],
        /*mb*/
        v[8],
        /*ml*/
        v[9]
      ), `display: ${/*_active*/
      v[11] || /*active*/
      v[10] ? "block" : "none"}`))) && f(e, "style", a);
    },
    i(v) {
      s || (Y(h, v), s = !0);
    },
    o(v) {
      U(h, v), s = !1;
    },
    d(v) {
      v && P(e), d && d.d(), u && u.d(), c && c.d(), h && h.d(v), m && m.d(), t[24](null), t[25](null);
    }
  };
}
function of(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { buttonText: o = "" } = e, { id: r = "" } = e, { heading: a = "" } = e, { sectionTitle: s = "" } = e, { backUrl: d = "" } = e, { type: u = "step" } = e, { buttonVisibility: c = "visible" } = e, { mt: g = null } = e, { mr: h = null } = e, { mb: m = null } = e, { ml: v = null } = e, { active: b = !1 } = e, w, y, j, E = !1, M = !1;
  ke(() => {
    L(), V();
  });
  function L() {
    Re(y, (W, K, $) => {
      switch (W) {
        case Wi:
          S(K), $.stopPropagation();
          break;
        case Vr:
          A(K), $.stopPropagation();
          break;
        case bi:
          T(K), $.stopPropagation();
          break;
        case It:
          z($, K), $.stopPropagation();
          break;
      }
    });
  }
  function z(W, K) {
    var $;
    W.stopPropagation(), j = K.el, ($ = K.cb) == null || $.call(K, r), je(w, It, { ...K, id: r }, { bubbles: !0 });
  }
  function V() {
    setTimeout(
      () => {
        je(w, Wr, { id: r, el: y, heading: a }, { bubbles: !0 });
      },
      10
    );
  }
  function T(W) {
    je(
      w,
      bi,
      {
        ...W,
        state: { ...W.state, heading: a }
      },
      { bubbles: !0 }
    );
  }
  function S(W) {
    i(11, E = W.active);
  }
  function A(W) {
    i(14, M = W.id === r);
  }
  function R(W = !1) {
    j ? je(j, Nr, { cancelled: W }) : qe(w, "_continue", null, { bubbles: !0 });
  }
  function I() {
    R(), je(w, Br, null, { bubbles: !0 });
  }
  function B(W) {
    je(w, vi, null, { bubbles: !0 }), W.stopPropagation();
  }
  const N = () => R(!1), F = () => I(), q = () => R();
  function H(W) {
    ue[W ? "unshift" : "push"](() => {
      y = W, i(13, y);
    });
  }
  function O(W) {
    ue[W ? "unshift" : "push"](() => {
      w = W, i(12, w);
    });
  }
  return t.$$set = (W) => {
    "buttonText" in W && i(0, o = W.buttonText), "id" in W && i(18, r = W.id), "heading" in W && i(1, a = W.heading), "sectionTitle" in W && i(2, s = W.sectionTitle), "backUrl" in W && i(3, d = W.backUrl), "type" in W && i(4, u = W.type), "buttonVisibility" in W && i(5, c = W.buttonVisibility), "mt" in W && i(6, g = W.mt), "mr" in W && i(7, h = W.mr), "mb" in W && i(8, m = W.mb), "ml" in W && i(9, v = W.ml), "active" in W && i(10, b = W.active), "$$scope" in W && i(19, l = W.$$scope);
  }, t.$$.update = () => {
    if (t.$$.dirty[0] & /*_active, id*/
    264192 && E) {
      const W = new URL(location.href);
      W.searchParams.set("page", r), history.pushState({ page: r }, "", W);
    }
  }, [
    o,
    a,
    s,
    d,
    u,
    c,
    g,
    h,
    m,
    v,
    b,
    E,
    w,
    y,
    M,
    R,
    I,
    B,
    r,
    l,
    n,
    N,
    F,
    q,
    H,
    O
  ];
}
class rf extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      of,
      lf,
      ce,
      {
        buttonText: 0,
        id: 18,
        heading: 1,
        sectionTitle: 2,
        backUrl: 3,
        type: 4,
        buttonVisibility: 5,
        mt: 6,
        mr: 7,
        mb: 8,
        ml: 9,
        active: 10
      },
      null,
      [-1, -1]
    );
  }
  get buttonText() {
    return this.$$.ctx[0];
  }
  set buttonText(e) {
    this.$$set({ buttonText: e }), k();
  }
  get id() {
    return this.$$.ctx[18];
  }
  set id(e) {
    this.$$set({ id: e }), k();
  }
  get heading() {
    return this.$$.ctx[1];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get sectionTitle() {
    return this.$$.ctx[2];
  }
  set sectionTitle(e) {
    this.$$set({ sectionTitle: e }), k();
  }
  get backUrl() {
    return this.$$.ctx[3];
  }
  set backUrl(e) {
    this.$$set({ backUrl: e }), k();
  }
  get type() {
    return this.$$.ctx[4];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get buttonVisibility() {
    return this.$$.ctx[5];
  }
  set buttonVisibility(e) {
    this.$$set({ buttonVisibility: e }), k();
  }
  get mt() {
    return this.$$.ctx[6];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[7];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[8];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[9];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get active() {
    return this.$$.ctx[10];
  }
  set active(e) {
    this.$$set({ active: e }), k();
  }
}
customElements.define("goa-public-form-page", he(rf, { buttonText: { type: "String", attribute: "button-text" }, id: {}, heading: {}, sectionTitle: { type: "String", attribute: "section-title" }, backUrl: { attribute: "back-url", type: "String" }, type: {}, buttonVisibility: { type: "String", attribute: "button-visibility" }, mt: {}, mr: {}, mb: {}, ml: {}, active: { type: "Boolean" } }, ["default"], [], !0));
function af(t) {
  _e(t, "svelte-tgbrls", `@media(max-width: 1023px){.summary.svelte-tgbrls.svelte-tgbrls{display:block;grid-template-rows:min-content auto;grid-template-columns:auto;grid-template-areas:"top top top"
    }.data.svelte-tgbrls tr.svelte-tgbrls:last-of-type{padding-bottom:var(--goa-space-m)}.data.svelte-tgbrls td.svelte-tgbrls:first-of-type{font-weight:bold}.data.svelte-tgbrls td.svelte-tgbrls{display:block}.action.svelte-tgbrls.svelte-tgbrls{margin-top:var(--goa-space-m)}}@media(min-width: 1024px){.summary.svelte-tgbrls.svelte-tgbrls{display:grid;grid-auto-rows:1fr;grid-template-columns:1fr min-content;grid-template-areas:"data action"
    }.summary-with-header.svelte-tgbrls.svelte-tgbrls{display:grid;grid-auto-rows:auto;grid-template-columns:1fr min-content;grid-template-areas:"heading action"
        "data ."
    }.heading.svelte-tgbrls.svelte-tgbrls{grid-area:heading;grid-template-columns:1fr 1fr}.action.svelte-tgbrls.svelte-tgbrls{grid-area:action;text-align:right}.data.svelte-tgbrls.svelte-tgbrls{grid-area:data}table.svelte-tgbrls.svelte-tgbrls{width:100%}.label.svelte-tgbrls.svelte-tgbrls{width:50%;font:var(--goa-typography-heading-s)}.value.svelte-tgbrls.svelte-tgbrls{width:50%;padding-left:1rem}}`);
}
function Ol(t, e, i) {
  const n = t.slice();
  return n[9] = e[i], n;
}
function Fl(t, e, i) {
  const n = t.slice();
  return n[16] = e[i], n[18] = i, n;
}
function Al(t, e, i) {
  const n = t.slice();
  return n[12] = e[i][0], n[13] = e[i][1], n;
}
function Vl(t, e, i) {
  const n = t.slice();
  return n[12] = e[i][0], n[13] = e[i][1], n;
}
function Il(t) {
  let e, i;
  return {
    c() {
      e = C("goa-text"), i = le(
        /*heading*/
        t[0]
      ), p(e, "as", "h3"), p(e, "size", "heading-m"), p(e, "color", "secondary"), p(e, "mb", "l");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l & /*heading*/
      1 && pe(
        i,
        /*heading*/
        n[0]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function xl(t) {
  let e, i = Le(
    /*_state*/
    t[2].history
  ), n = [];
  for (let l = 0; l < i.length; l += 1)
    n[l] = Gl(Ol(t, i, l));
  return {
    c() {
      for (let l = 0; l < n.length; l += 1)
        n[l].c();
      e = Ne();
    },
    m(l, o) {
      for (let r = 0; r < n.length; r += 1)
        n[r] && n[r].m(l, o);
      D(l, e, o);
    },
    p(l, o) {
      if (o & /*getHeading, _state, changePage, Object, getData, getDataList*/
      28) {
        i = Le(
          /*_state*/
          l[2].history
        );
        let r;
        for (r = 0; r < i.length; r += 1) {
          const a = Ol(l, i, r);
          n[r] ? n[r].p(a, o) : (n[r] = Gl(a), n[r].c(), n[r].m(e.parentNode, e));
        }
        for (; r < n.length; r += 1)
          n[r].d(1);
        n.length = i.length;
      }
    },
    d(l) {
      l && P(e), Ye(n, l);
    }
  };
}
function Bl(t) {
  var v, b;
  let e, i, n = (
    /*getHeading*/
    t[4](
      /*page*/
      t[9]
    )
  ), l, o, r, a, s, d, u, c, g = n && Nl(t), h = (
    /*_state*/
    ((b = (v = t[2].form[
      /*page*/
      t[9]
    ]) == null ? void 0 : v.data) == null ? void 0 : b.type) && Wl(t)
  );
  function m(...w) {
    return (
      /*click_handler*/
      t[5](
        /*page*/
        t[9],
        ...w
      )
    );
  }
  return {
    c() {
      e = C("goa-container"), i = C("div"), g && g.c(), l = x(), o = C("div"), h && h.c(), r = x(), a = C("div"), s = C("goa-link"), s.textContent = "Change", d = x(), f(o, "class", "data svelte-tgbrls"), p(s, "leadingicon", "pencil"), f(a, "class", "action svelte-tgbrls"), f(i, "class", "summary svelte-tgbrls"), G(i, "summary-with-header", !!/*getHeading*/
      t[4](
        /*page*/
        t[9]
      ));
    },
    m(w, y) {
      D(w, e, y), _(e, i), g && g.m(i, null), _(i, l), _(i, o), h && h.m(o, null), _(i, r), _(i, a), _(a, s), _(e, d), u || (c = te(s, "click", m), u = !0);
    },
    p(w, y) {
      var j, E;
      t = w, y & /*_state*/
      4 && (n = /*getHeading*/
      t[4](
        /*page*/
        t[9]
      )), n ? g ? g.p(t, y) : (g = Nl(t), g.c(), g.m(i, l)) : g && (g.d(1), g = null), /*_state*/
      (E = (j = t[2].form[
        /*page*/
        t[9]
      ]) == null ? void 0 : j.data) != null && E.type ? h ? h.p(t, y) : (h = Wl(t), h.c(), h.m(o, null)) : h && (h.d(1), h = null), y & /*getHeading, _state*/
      20 && G(i, "summary-with-header", !!/*getHeading*/
      t[4](
        /*page*/
        t[9]
      ));
    },
    d(w) {
      w && P(e), g && g.d(), h && h.d(), u = !1, c();
    }
  };
}
function Nl(t) {
  let e, i = (
    /*getHeading*/
    t[4](
      /*page*/
      t[9]
    ) + ""
  ), n;
  return {
    c() {
      e = C("goa-text"), n = le(i), p(e, "class", "heading svelte-tgbrls"), p(e, "color", "secondary");
    },
    m(l, o) {
      D(l, e, o), _(e, n);
    },
    p(l, o) {
      o & /*_state*/
      4 && i !== (i = /*getHeading*/
      l[4](
        /*page*/
        l[9]
      ) + "") && pe(n, i);
    },
    d(l) {
      l && P(e);
    }
  };
}
function Wl(t) {
  let e;
  function i(o, r) {
    var a, s;
    return (
      /*_state*/
      ((s = (a = o[2].form[
        /*page*/
        o[9]
      ]) == null ? void 0 : a.data) == null ? void 0 : s.type) === "details" ? uf : sf
    );
  }
  let n = i(t), l = n(t);
  return {
    c() {
      l.c(), e = Ne();
    },
    m(o, r) {
      l.m(o, r), D(o, e, r);
    },
    p(o, r) {
      n === (n = i(o)) && l ? l.p(o, r) : (l.d(1), l = n(o), l && (l.c(), l.m(e.parentNode, e)));
    },
    d(o) {
      o && P(e), l.d(o);
    }
  };
}
function sf(t) {
  let e, i = Le(pi(
    /*_state*/
    t[2],
    /*page*/
    t[9]
  )), n = [];
  for (let l = 0; l < i.length; l += 1)
    n[l] = Zl(Fl(t, i, l));
  return {
    c() {
      for (let l = 0; l < n.length; l += 1)
        n[l].c();
      e = Ne();
    },
    m(l, o) {
      for (let r = 0; r < n.length; r += 1)
        n[r] && n[r].m(l, o);
      D(l, e, o);
    },
    p(l, o) {
      if (o & /*getDataList, _state, Object*/
      4) {
        i = Le(pi(
          /*_state*/
          l[2],
          /*page*/
          l[9]
        ));
        let r;
        for (r = 0; r < i.length; r += 1) {
          const a = Fl(l, i, r);
          n[r] ? n[r].p(a, o) : (n[r] = Zl(a), n[r].c(), n[r].m(e.parentNode, e));
        }
        for (; r < n.length; r += 1)
          n[r].d(1);
        n.length = i.length;
      }
    },
    d(l) {
      l && P(e), Ye(n, l);
    }
  };
}
function uf(t) {
  let e, i = Le(Object.entries(Hi(
    /*_state*/
    t[2],
    /*page*/
    t[9]
  ))), n = [];
  for (let l = 0; l < i.length; l += 1)
    n[l] = Ul(Vl(t, i, l));
  return {
    c() {
      e = C("table");
      for (let l = 0; l < n.length; l += 1)
        n[l].c();
      f(e, "class", "svelte-tgbrls");
    },
    m(l, o) {
      D(l, e, o);
      for (let r = 0; r < n.length; r += 1)
        n[r] && n[r].m(e, null);
    },
    p(l, o) {
      if (o & /*Object, getData, _state*/
      4) {
        i = Le(Object.entries(Hi(
          /*_state*/
          l[2],
          /*page*/
          l[9]
        )));
        let r;
        for (r = 0; r < i.length; r += 1) {
          const a = Vl(l, i, r);
          n[r] ? n[r].p(a, o) : (n[r] = Ul(a), n[r].c(), n[r].m(e, null));
        }
        for (; r < n.length; r += 1)
          n[r].d(1);
        n.length = i.length;
      }
    },
    d(l) {
      l && P(e), Ye(n, l);
    }
  };
}
function Rl(t) {
  let e, i, n = (
    /*data*/
    t[13].label + ""
  ), l, o, r, a = (
    /*data*/
    t[13].value + ""
  ), s, d;
  return {
    c() {
      e = C("tr"), i = C("td"), l = le(n), o = x(), r = C("td"), s = le(a), d = x(), f(i, "class", "label svelte-tgbrls"), f(r, "class", "value svelte-tgbrls"), f(e, "class", "svelte-tgbrls");
    },
    m(u, c) {
      D(u, e, c), _(e, i), _(i, l), _(e, o), _(e, r), _(r, s), _(e, d);
    },
    p(u, c) {
      c & /*_state*/
      4 && n !== (n = /*data*/
      u[13].label + "") && pe(l, n), c & /*_state*/
      4 && a !== (a = /*data*/
      u[13].value + "") && pe(s, a);
    },
    d(u) {
      u && P(e);
    }
  };
}
function Yl(t) {
  let e;
  return {
    c() {
      e = C("goa-divider"), p(e, "mt", "m"), p(e, "mb", "m");
    },
    m(i, n) {
      D(i, e, n);
    },
    d(i) {
      i && P(e);
    }
  };
}
function Zl(t) {
  let e, i, n = (
    /*index*/
    t[18] < pi(
      /*_state*/
      t[2],
      /*page*/
      t[9]
    ).length - 1
  ), l, o = Le(Object.entries(
    /*item*/
    t[16]
  )), r = [];
  for (let s = 0; s < o.length; s += 1)
    r[s] = Rl(Al(t, o, s));
  let a = n && Yl();
  return {
    c() {
      e = C("table");
      for (let s = 0; s < r.length; s += 1)
        r[s].c();
      i = x(), a && a.c(), l = Ne(), f(e, "class", "svelte-tgbrls");
    },
    m(s, d) {
      D(s, e, d);
      for (let u = 0; u < r.length; u += 1)
        r[u] && r[u].m(e, null);
      D(s, i, d), a && a.m(s, d), D(s, l, d);
    },
    p(s, d) {
      if (d & /*Object, getDataList, _state*/
      4) {
        o = Le(Object.entries(
          /*item*/
          s[16]
        ));
        let u;
        for (u = 0; u < o.length; u += 1) {
          const c = Al(s, o, u);
          r[u] ? r[u].p(c, d) : (r[u] = Rl(c), r[u].c(), r[u].m(e, null));
        }
        for (; u < r.length; u += 1)
          r[u].d(1);
        r.length = o.length;
      }
      d & /*_state*/
      4 && (n = /*index*/
      s[18] < pi(
        /*_state*/
        s[2],
        /*page*/
        s[9]
      ).length - 1), n ? a || (a = Yl(), a.c(), a.m(l.parentNode, l)) : a && (a.d(1), a = null);
    },
    d(s) {
      s && (P(e), P(i), P(l)), Ye(r, s), a && a.d(s);
    }
  };
}
function Ul(t) {
  let e, i, n = (
    /*data*/
    t[13].label + ""
  ), l, o, r, a = (
    /*data*/
    t[13].value + ""
  ), s, d;
  return {
    c() {
      e = C("tr"), i = C("td"), l = le(n), o = x(), r = C("td"), s = le(a), d = x(), f(i, "class", "label svelte-tgbrls"), f(r, "class", "value svelte-tgbrls"), f(e, "class", "svelte-tgbrls");
    },
    m(u, c) {
      D(u, e, c), _(e, i), _(i, l), _(e, o), _(e, r), _(r, s), _(e, d);
    },
    p(u, c) {
      c & /*_state*/
      4 && n !== (n = /*data*/
      u[13].label + "") && pe(l, n), c & /*_state*/
      4 && a !== (a = /*data*/
      u[13].value + "") && pe(s, a);
    },
    d(u) {
      u && P(e);
    }
  };
}
function Gl(t) {
  let e, i = (
    /*_state*/
    t[2].form[
      /*page*/
      t[9]
    ] && Bl(t)
  );
  return {
    c() {
      i && i.c(), e = Ne();
    },
    m(n, l) {
      i && i.m(n, l), D(n, e, l);
    },
    p(n, l) {
      /*_state*/
      n[2].form[
        /*page*/
        n[9]
      ] ? i ? i.p(n, l) : (i = Bl(n), i.c(), i.m(e.parentNode, e)) : i && (i.d(1), i = null);
    },
    d(n) {
      n && P(e), i && i.d(n);
    }
  };
}
function df(t) {
  let e, i, n = (
    /*heading*/
    t[0] && Il(t)
  ), l = (
    /*_state*/
    t[2] && xl(t)
  );
  return {
    c() {
      e = C("div"), n && n.c(), i = x(), l && l.c();
    },
    m(o, r) {
      D(o, e, r), n && n.m(e, null), _(e, i), l && l.m(e, null), t[6](e);
    },
    p(o, [r]) {
      /*heading*/
      o[0] ? n ? n.p(o, r) : (n = Il(o), n.c(), n.m(e, i)) : n && (n.d(1), n = null), /*_state*/
      o[2] ? l ? l.p(o, r) : (l = xl(o), l.c(), l.m(e, null)) : l && (l.d(1), l = null);
    },
    i: ve,
    o: ve,
    d(o) {
      o && P(e), n && n.d(), l && l.d(), t[6](null);
    }
  };
}
function Hi(t, e) {
  var i, n;
  if (((n = (i = t.form[e]) == null ? void 0 : i.data) == null ? void 0 : n.type) === "details")
    return Object.entries(t.form[e].data.fieldsets || {}).sort((l, o) => l[1].order > o[1].order ? 1 : -1).reduce(
      (l, [o, r]) => (l[o] = r, l),
      {}
    );
}
function pi(t, e) {
  var n;
  const i = (n = t.form[e]) == null ? void 0 : n.data;
  if ((i == null ? void 0 : i.type) === "list")
    return i.items.reduce(
      (l, o) => {
        const r = o.history.reduce(
          (a, s) => (a = {
            ...a,
            ...Hi(o, s)
          }, a),
          {}
        );
        return l.push(r), l;
      },
      []
    );
}
function cf(t, e, i) {
  let { heading: n = "" } = e, l, o;
  ke(() => {
    r(), je(l, Zr, { el: l }, { bubbles: !0, timeout: 100 });
  });
  function r() {
    Re(l, (g, h) => {
      switch (g) {
        case Ht:
          a(h);
          break;
      }
    });
  }
  function a(g) {
    i(2, o = g);
  }
  function s(g, h) {
    je(l, Ur, { id: h }, { bubbles: !0 }), g.preventDefault();
  }
  function d(g) {
    var h, m;
    return ((m = (h = o.form) == null ? void 0 : h[g]) == null ? void 0 : m.heading) || "";
  }
  const u = (g, h) => s(h, g);
  function c(g) {
    ue[g ? "unshift" : "push"](() => {
      l = g, i(1, l);
    });
  }
  return t.$$set = (g) => {
    "heading" in g && i(0, n = g.heading);
  }, [n, l, o, s, d, u, c];
}
class ff extends me {
  constructor(e) {
    super(), ge(this, e, cf, df, ce, { heading: 0 }, af);
  }
  get heading() {
    return this.$$.ctx[0];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
}
customElements.define("goa-public-form-summary", he(ff, { heading: {} }, [], [], !0));
const gf = (t) => ({}), Kl = (t) => ({});
function hf(t) {
  let e, i, n, l, o, r, a, s, d;
  const u = (
    /*#slots*/
    t[11]["subform-index"]
  ), c = oe(
    u,
    t,
    /*$$scope*/
    t[10],
    Kl
  ), g = (
    /*#slots*/
    t[11].default
  ), h = oe(
    g,
    t,
    /*$$scope*/
    t[10],
    null
  );
  return {
    c() {
      e = C("div"), i = C("section"), c && c.c(), l = x(), o = C("goa-public-form"), h && h.c(), f(i, "style", n = ze("display", `${/*_mode*/
      t[5] === "index" ? "block" : "none"}`)), p(
        o,
        "name",
        /*name*/
        t[0]
      ), p(
        o,
        "dispatchOn",
        /*dispatchOn*/
        t[2]
      ), p(
        o,
        "backUrl",
        /*backUrl*/
        t[1]
      ), p(o, "data-id", "subform-form"), p(o, "style", r = Ue(`display: ${/*_mode*/
      t[5] === "form" ? "block" : "none"}`)), f(e, "data-id", "subform");
    },
    m(m, v) {
      D(m, e, v), _(e, i), c && c.m(i, null), _(e, l), _(e, o), h && h.m(o, null), t[12](o), t[13](e), a = !0, s || (d = [
        te(
          o,
          "_stateChange",
          /*onChildFormStateChange*/
          t[7]
        ),
        te(o, "_continue", mf),
        te(
          o,
          "_complete",
          /*onChildFormComplete*/
          t[8]
        ),
        te(
          o,
          "_init",
          /*onInit*/
          t[6]
        )
      ], s = !0);
    },
    p(m, v) {
      c && c.p && (!a || v[0] & /*$$scope*/
      1024) && ae(
        c,
        u,
        m,
        /*$$scope*/
        m[10],
        a ? re(
          u,
          /*$$scope*/
          m[10],
          v,
          gf
        ) : se(
          /*$$scope*/
          m[10]
        ),
        Kl
      ), (!a || v[0] & /*_mode*/
      32 && n !== (n = ze("display", `${/*_mode*/
      m[5] === "index" ? "block" : "none"}`))) && f(i, "style", n), h && h.p && (!a || v[0] & /*$$scope*/
      1024) && ae(
        h,
        g,
        m,
        /*$$scope*/
        m[10],
        a ? re(
          g,
          /*$$scope*/
          m[10],
          v,
          null
        ) : se(
          /*$$scope*/
          m[10]
        ),
        null
      ), (!a || v[0] & /*name*/
      1) && p(
        o,
        "name",
        /*name*/
        m[0]
      ), (!a || v[0] & /*dispatchOn*/
      4) && p(
        o,
        "dispatchOn",
        /*dispatchOn*/
        m[2]
      ), (!a || v[0] & /*backUrl*/
      2) && p(
        o,
        "backUrl",
        /*backUrl*/
        m[1]
      ), (!a || v[0] & /*_mode*/
      32 && r !== (r = Ue(`display: ${/*_mode*/
      m[5] === "form" ? "block" : "none"}`))) && p(o, "style", r);
    },
    i(m) {
      a || (Y(c, m), Y(h, m), a = !0);
    },
    o(m) {
      U(c, m), U(h, m), a = !1;
    },
    d(m) {
      m && P(e), c && c.d(m), h && h.d(m), t[12](null), t[13](null), s = !1, He(d);
    }
  };
}
function mf(t) {
  t.stopPropagation();
}
function vf(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { id: o = "" } = e, { name: r } = e, { backUrl: a = "" } = e, { dispatchOn: s = "continue" } = e, d, u, c, g = [], h = "index";
  ke(() => {
    b(), R(), A(), v();
  });
  function m(q) {
    q.stopPropagation(), d = q.detail.el, qe(c, "_init", { el: u }, { bubbles: !0 });
  }
  function v() {
    setTimeout(
      () => {
        const q = document.querySelector("goa-public-subform-index").shadowRoot.querySelector("[data-bind]");
        je(q, Ir, { el: u });
      },
      10
    );
  }
  function b() {
    Re(u, (q, H, O) => {
      switch (O.stopPropagation(), q) {
        case Ht:
          T(H);
          break;
        case Ri:
          S(H);
          break;
        case vi:
          w();
          break;
        case It:
          break;
        case xr:
          L();
          break;
        case ed:
          z();
          break;
        case Yr:
          M(H);
          break;
        case Di:
          je(d, Di, H);
          break;
        case td:
          y(H);
          break;
      }
    });
  }
  function w() {
    i(5, h = "index"), g.pop();
  }
  function y(q) {
    switch (q.operation) {
      case "remove":
        E(q.index);
        break;
      case "edit":
        j(q.index);
        break;
    }
  }
  function j(q) {
    i(5, h = "form"), je(d, Ht, g[q]);
  }
  function E(q) {
    g = [...g.slice(0, q), ...g.slice(q + 1)], qe(c, Yt, { type: "list", data: g, id: o }, { bubbles: !0 });
  }
  function M(q) {
    g = q, V();
  }
  function L() {
    i(5, h = "form");
  }
  function z() {
    i(5, h = "index"), V(), qe(c, "_continue", { el: u }, { bubbles: !0 });
  }
  function V() {
    g.length;
  }
  function T(q) {
    Array.isArray(q) && (g = q, qe(c, "_stateChange", { data: g, id: o }, { bubbles: !0 }));
  }
  function S(q) {
    for (const [H, O] of Object.entries(q))
      g[H] = { ...O };
  }
  function A() {
    je(c, Ar, { id: o, el: u }, { bubbles: !0, timeout: 10 });
  }
  function R() {
    je(c, It, { id: o, el: u }, { bubbles: !0, timeout: 10 });
  }
  function I(q) {
    const H = q.detail;
    if (H.type === "list") {
      console.warn("SubForm: onChildFormStateChange: list not supported");
      return;
    }
    const O = g.findIndex((K) => K.uuid === H.data.uuid), W = JSON.parse(JSON.stringify(H.data));
    O >= 0 ? g[O] = W : g.push(W), qe(c, Yt, { type: "list", data: g, id: o }, { bubbles: !0 }), q.stopPropagation();
  }
  function B(q) {
    i(5, h = "index"), V(), je(d, mi), q.stopPropagation();
  }
  function N(q) {
    ue[q ? "unshift" : "push"](() => {
      u = q, i(3, u);
    });
  }
  function F(q) {
    ue[q ? "unshift" : "push"](() => {
      c = q, i(4, c);
    });
  }
  return t.$$set = (q) => {
    "id" in q && i(9, o = q.id), "name" in q && i(0, r = q.name), "backUrl" in q && i(1, a = q.backUrl), "dispatchOn" in q && i(2, s = q.dispatchOn), "$$scope" in q && i(10, l = q.$$scope);
  }, [
    r,
    a,
    s,
    u,
    c,
    h,
    m,
    I,
    B,
    o,
    l,
    n,
    N,
    F
  ];
}
class bf extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      vf,
      hf,
      ce,
      {
        id: 9,
        name: 0,
        backUrl: 1,
        dispatchOn: 2
      },
      null,
      [-1, -1]
    );
  }
  get id() {
    return this.$$.ctx[9];
  }
  set id(e) {
    this.$$set({ id: e }), k();
  }
  get name() {
    return this.$$.ctx[0];
  }
  set name(e) {
    this.$$set({ name: e }), k();
  }
  get backUrl() {
    return this.$$.ctx[1];
  }
  set backUrl(e) {
    this.$$set({ backUrl: e }), k();
  }
  get dispatchOn() {
    return this.$$.ctx[2];
  }
  set dispatchOn(e) {
    this.$$set({ dispatchOn: e }), k();
  }
}
customElements.define("goa-public-subform", he(bf, { id: {}, name: {}, backUrl: {}, dispatchOn: {} }, ["subform-index", "default"], [], !0));
function pf(t) {
  let e, i, n, l, o, r, a, s, d;
  const u = (
    /*#slots*/
    t[7].default
  ), c = oe(
    u,
    t,
    /*$$scope*/
    t[6],
    null
  );
  return {
    c() {
      e = C("goa-public-form-page"), i = C("div"), c && c.c(), n = x(), l = C("goa-block"), o = C("goa-button"), r = le(
        /*actionButtonText*/
        t[2]
      ), p(o, "type", "secondary"), p(l, "direction", "column"), p(l, "gap", "3xl"), f(i, "data-bind", ""), p(e, "id", "index"), p(e, "type", "step"), p(
        e,
        "heading",
        /*heading*/
        t[0]
      ), p(
        e,
        "section-title",
        /*sectionTitle*/
        t[1]
      ), p(
        e,
        "button-visibility",
        /*buttonVisibility*/
        t[3]
      ), p(e, "active", "");
    },
    m(g, h) {
      D(g, e, h), _(e, i), c && c.m(i, null), _(i, n), _(i, l), _(l, o), _(o, r), t[8](i), a = !0, s || (d = te(
        o,
        "_click",
        /*continueToSubform*/
        t[5]
      ), s = !0);
    },
    p(g, [h]) {
      c && c.p && (!a || h & /*$$scope*/
      64) && ae(
        c,
        u,
        g,
        /*$$scope*/
        g[6],
        a ? re(
          u,
          /*$$scope*/
          g[6],
          h,
          null
        ) : se(
          /*$$scope*/
          g[6]
        ),
        null
      ), (!a || h & /*actionButtonText*/
      4) && pe(
        r,
        /*actionButtonText*/
        g[2]
      ), (!a || h & /*heading*/
      1) && p(
        e,
        "heading",
        /*heading*/
        g[0]
      ), (!a || h & /*sectionTitle*/
      2) && p(
        e,
        "section-title",
        /*sectionTitle*/
        g[1]
      ), (!a || h & /*buttonVisibility*/
      8) && p(
        e,
        "button-visibility",
        /*buttonVisibility*/
        g[3]
      );
    },
    i(g) {
      a || (Y(c, g), a = !0);
    },
    o(g) {
      U(c, g), a = !1;
    },
    d(g) {
      g && P(e), c && c.d(g), t[8](null), s = !1, d();
    }
  };
}
function _f(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { heading: o = "" } = e, { sectionTitle: r = "" } = e, { actionButtonText: a } = e, { buttonVisibility: s = "hidden" } = e, d, u;
  ke(() => {
    c();
  });
  function c() {
    Re(d, (m, v, b) => {
      switch (m) {
        case Ir:
          u = v.el, b.stopPropagation();
          break;
      }
    });
  }
  function g(m) {
    m.stopPropagation(), je(u, xr, null, { bubbles: !0 });
  }
  function h(m) {
    ue[m ? "unshift" : "push"](() => {
      d = m, i(4, d);
    });
  }
  return t.$$set = (m) => {
    "heading" in m && i(0, o = m.heading), "sectionTitle" in m && i(1, r = m.sectionTitle), "actionButtonText" in m && i(2, a = m.actionButtonText), "buttonVisibility" in m && i(3, s = m.buttonVisibility), "$$scope" in m && i(6, l = m.$$scope);
  }, [
    o,
    r,
    a,
    s,
    d,
    g,
    l,
    n,
    h
  ];
}
class wf extends me {
  constructor(e) {
    super(), ge(this, e, _f, pf, ce, {
      heading: 0,
      sectionTitle: 1,
      actionButtonText: 2,
      buttonVisibility: 3
    });
  }
  get heading() {
    return this.$$.ctx[0];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get sectionTitle() {
    return this.$$.ctx[1];
  }
  set sectionTitle(e) {
    this.$$set({ sectionTitle: e }), k();
  }
  get actionButtonText() {
    return this.$$.ctx[2];
  }
  set actionButtonText(e) {
    this.$$set({ actionButtonText: e }), k();
  }
  get buttonVisibility() {
    return this.$$.ctx[3];
  }
  set buttonVisibility(e) {
    this.$$set({ buttonVisibility: e }), k();
  }
}
customElements.define("goa-public-subform-index", he(wf, { heading: {}, sectionTitle: { type: "String", attribute: "section-title" }, actionButtonText: { type: "String", attribute: "action-button-text" }, buttonVisibility: { type: "String", attribute: "button-visibility" } }, ["default"], [], !0));
function kf(t) {
  _e(t, "svelte-1rjq4hq", ".description.svelte-1rjq4hq{min-width:40ch}");
}
function yf(t) {
  let e, i, n, l, o, r, a;
  const s = (
    /*#slots*/
    t[4].default
  ), d = oe(
    s,
    t,
    /*$$scope*/
    t[3],
    null
  );
  return {
    c() {
      e = C("goa-block"), i = C("div"), d && d.c(), n = x(), l = C("goa-spacer"), o = x(), r = C("goa-badge"), f(i, "class", "description svelte-1rjq4hq"), p(l, "hspacing", "fill"), p(
        l,
        "type",
        /*status*/
        t[0]
      ), p(
        r,
        "type",
        /*_badgeType*/
        t[2]
      ), p(
        r,
        "content",
        /*_badgeContent*/
        t[1]
      );
    },
    m(u, c) {
      D(u, e, c), _(e, i), d && d.m(i, null), _(e, n), _(e, l), _(e, o), _(e, r), a = !0;
    },
    p(u, [c]) {
      d && d.p && (!a || c & /*$$scope*/
      8) && ae(
        d,
        s,
        u,
        /*$$scope*/
        u[3],
        a ? re(
          s,
          /*$$scope*/
          u[3],
          c,
          null
        ) : se(
          /*$$scope*/
          u[3]
        ),
        null
      ), (!a || c & /*status*/
      1) && p(
        l,
        "type",
        /*status*/
        u[0]
      ), (!a || c & /*_badgeType*/
      4) && p(
        r,
        "type",
        /*_badgeType*/
        u[2]
      ), (!a || c & /*_badgeContent*/
      2) && p(
        r,
        "content",
        /*_badgeContent*/
        u[1]
      );
    },
    i(u) {
      a || (Y(d, u), a = !0);
    },
    o(u) {
      U(d, u), a = !1;
    },
    d(u) {
      u && P(e), d && d.d(u);
    }
  };
}
function Cf(t, e, i) {
  let n, l, { $$slots: o = {}, $$scope: r } = e, { status: a = "cannot-start" } = e;
  return t.$$set = (s) => {
    "status" in s && i(0, a = s.status), "$$scope" in s && i(3, r = s.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*status*/
    1 && i(2, n = a === "completed" ? "success" : a === "not-started" ? "information" : "light"), t.$$.dirty & /*status*/
    1 && i(1, l = a === "completed" ? "Completed" : a === "not-started" ? "Not started" : "Cannot start yet");
  }, [a, l, n, r, o];
}
class zf extends me {
  constructor(e) {
    super(), ge(this, e, Cf, yf, ce, { status: 0 }, kf);
  }
  get status() {
    return this.$$.ctx[0];
  }
  set status(e) {
    this.$$set({ status: e }), k();
  }
}
customElements.define("goa-public-form-task", he(zf, { status: {} }, ["default"], [], !0));
function jf(t) {
  _e(t, "svelte-1ym28a", "fieldset.svelte-1ym28a{border:none;padding:0}");
}
function Xl(t) {
  let e, i;
  return {
    c() {
      e = C("goa-text"), i = le(
        /*heading*/
        t[0]
      ), p(e, "as", "h2"), p(e, "size", "heading-l");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l & /*heading*/
      1 && pe(
        i,
        /*heading*/
        n[0]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function Ef(t) {
  let e, i, n, l, o, r = (
    /*heading*/
    t[0] && Xl(t)
  );
  const a = (
    /*#slots*/
    t[6].default
  ), s = oe(
    a,
    t,
    /*$$scope*/
    t[5],
    null
  );
  return {
    c() {
      e = C("section"), i = C("fieldset"), r && r.c(), n = x(), s && s.c(), f(i, "style", l = be(
        /*mt*/
        t[1],
        /*mr*/
        t[2],
        /*mb*/
        t[3],
        /*ml*/
        t[4]
      )), f(i, "class", "svelte-1ym28a");
    },
    m(d, u) {
      D(d, e, u), _(e, i), r && r.m(i, null), _(i, n), s && s.m(i, null), o = !0;
    },
    p(d, [u]) {
      /*heading*/
      d[0] ? r ? r.p(d, u) : (r = Xl(d), r.c(), r.m(i, n)) : r && (r.d(1), r = null), s && s.p && (!o || u & /*$$scope*/
      32) && ae(
        s,
        a,
        d,
        /*$$scope*/
        d[5],
        o ? re(
          a,
          /*$$scope*/
          d[5],
          u,
          null
        ) : se(
          /*$$scope*/
          d[5]
        ),
        null
      ), (!o || u & /*mt, mr, mb, ml*/
      30 && l !== (l = be(
        /*mt*/
        d[1],
        /*mr*/
        d[2],
        /*mb*/
        d[3],
        /*ml*/
        d[4]
      ))) && f(i, "style", l);
    },
    i(d) {
      o || (Y(s, d), o = !0);
    },
    o(d) {
      U(s, d), o = !1;
    },
    d(d) {
      d && P(e), r && r.d(), s && s.d(d);
    }
  };
}
function Mf(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { heading: o = "" } = e, { mt: r = null } = e, { mr: a = null } = e, { mb: s = null } = e, { ml: d = null } = e;
  return t.$$set = (u) => {
    "heading" in u && i(0, o = u.heading), "mt" in u && i(1, r = u.mt), "mr" in u && i(2, a = u.mr), "mb" in u && i(3, s = u.mb), "ml" in u && i(4, d = u.ml), "$$scope" in u && i(5, l = u.$$scope);
  }, [o, r, a, s, d, l, n];
}
class Lf extends me {
  constructor(e) {
    super(), ge(this, e, Mf, Ef, ce, { heading: 0, mt: 1, mr: 2, mb: 3, ml: 4 }, jf);
  }
  get heading() {
    return this.$$.ctx[0];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get mt() {
    return this.$$.ctx[1];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[2];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[3];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[4];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-public-form-task-list", he(Lf, { heading: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function qf(t) {
  _e(t, "svelte-1pbqooa", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}.svelte-1pbqooa.svelte-1pbqooa{box-sizing:border-box}.label.svelte-1pbqooa.svelte-1pbqooa{display:block;font:var(--goa-form-item-label-typography);padding-bottom:var(--goa-form-item-label-padding-bottom)}.label.large.svelte-1pbqooa.svelte-1pbqooa{font:var(--goa-form-item-label-large-typography);padding-bottom:var(--goa-form-item-label-large-padding-bottom)}.label.svelte-1pbqooa em.svelte-1pbqooa{font:var(--goa-form-item-optional-label-typography);color:var(--goa-form-item-optional-label-color);margin-left:var(--goa-space-2xs)}.error-msg.svelte-1pbqooa.svelte-1pbqooa{display:flex;align-items:flex-start;gap:var(--goa-space-2xs);font:var(--goa-form-item-message-typography);color:var(--goa-form-item-error-message-color);margin-top:var(--goa-form-item-message-margin-top)}.error-msg.svelte-1pbqooa goa-icon.svelte-1pbqooa{transform:translateY(calc(var(--goa-space-2xs) * -1))}.help-msg.svelte-1pbqooa.svelte-1pbqooa{font:var(--goa-form-item-message-typography);color:var(--goa-form-item-help-message-color);margin-top:var(--goa-form-item-message-margin-top)}.error-msg.svelte-1pbqooa+.help-msg.svelte-1pbqooa{margin-top:var(--goa-form-item-message-gap)}.sr-only.svelte-1pbqooa.svelte-1pbqooa{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0}");
}
const Sf = (t) => ({}), Jl = (t) => ({}), Tf = (t) => ({}), Ql = (t) => ({});
function $l(t) {
  let e, i, n, l = (
    /*requirement*/
    t[9] && /*REQUIREMENT_TYPES*/
    t[12].includes(
      /*requirement*/
      t[9]
    )
  ), o, r = l && eo(t);
  return {
    c() {
      e = C("label"), i = le(
        /*label*/
        t[6]
      ), n = x(), r && r.c(), f(e, "class", o = Ee(`label ${/*labelsize*/
      t[7]}`) + " svelte-1pbqooa");
    },
    m(a, s) {
      D(a, e, s), _(e, i), _(e, n), r && r.m(e, null);
    },
    p(a, s) {
      s[0] & /*label*/
      64 && pe(
        i,
        /*label*/
        a[6]
      ), s[0] & /*requirement*/
      512 && (l = /*requirement*/
      a[9] && /*REQUIREMENT_TYPES*/
      a[12].includes(
        /*requirement*/
        a[9]
      )), l ? r ? r.p(a, s) : (r = eo(a), r.c(), r.m(e, null)) : r && (r.d(1), r = null), s[0] & /*labelsize*/
      128 && o !== (o = Ee(`label ${/*labelsize*/
      a[7]}`) + " svelte-1pbqooa") && f(e, "class", o);
    },
    d(a) {
      a && P(e), r && r.d();
    }
  };
}
function eo(t) {
  let e, i, n, l;
  return {
    c() {
      e = C("em"), i = le("("), n = le(
        /*requirement*/
        t[9]
      ), l = le(")"), f(e, "class", "svelte-1pbqooa");
    },
    m(o, r) {
      D(o, e, r), _(e, i), _(e, n), _(e, l);
    },
    p(o, r) {
      r[0] & /*requirement*/
      512 && pe(
        n,
        /*requirement*/
        o[9]
      );
    },
    d(o) {
      o && P(e);
    }
  };
}
function to(t) {
  let e, i, n, l;
  const o = (
    /*#slots*/
    t[18].error
  ), r = oe(
    o,
    t,
    /*$$scope*/
    t[17],
    Ql
  ), a = r || Pf(t);
  return {
    c() {
      e = C("div"), i = C("goa-icon"), n = x(), a && a.c(), p(i, "type", "warning"), p(i, "size", "small"), p(i, "theme", "filled"), p(i, "mt", "2xs"), p(i, "class", "svelte-1pbqooa"), f(e, "class", "error-msg svelte-1pbqooa"), f(
        e,
        "id",
        /*_errorId*/
        t[13]
      ), f(e, "role", "alert");
    },
    m(s, d) {
      D(s, e, d), _(e, i), _(e, n), a && a.m(e, null), l = !0;
    },
    p(s, d) {
      r ? r.p && (!l || d[0] & /*$$scope*/
      131072) && ae(
        r,
        o,
        s,
        /*$$scope*/
        s[17],
        l ? re(
          o,
          /*$$scope*/
          s[17],
          d,
          Tf
        ) : se(
          /*$$scope*/
          s[17]
        ),
        Ql
      ) : a && a.p && (!l || d[0] & /*error*/
      1) && a.p(s, l ? d : [-1, -1]);
    },
    i(s) {
      l || (Y(a, s), l = !0);
    },
    o(s) {
      U(a, s), l = !1;
    },
    d(s) {
      s && P(e), a && a.d(s);
    }
  };
}
function Pf(t) {
  let e;
  return {
    c() {
      e = le(
        /*error*/
        t[0]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n[0] & /*error*/
      1 && pe(
        e,
        /*error*/
        i[0]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function io(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[18].helptext
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[17],
    Jl
  ), o = l || Df(t);
  return {
    c() {
      e = C("div"), o && o.c(), f(e, "class", "help-msg svelte-1pbqooa"), f(
        e,
        "id",
        /*_helpTextId*/
        t[14]
      );
    },
    m(r, a) {
      D(r, e, a), o && o.m(e, null), i = !0;
    },
    p(r, a) {
      l ? l.p && (!i || a[0] & /*$$scope*/
      131072) && ae(
        l,
        n,
        r,
        /*$$scope*/
        r[17],
        i ? re(
          n,
          /*$$scope*/
          r[17],
          a,
          Sf
        ) : se(
          /*$$scope*/
          r[17]
        ),
        Jl
      ) : o && o.p && (!i || a[0] & /*helptext*/
      256) && o.p(r, i ? a : [-1, -1]);
    },
    i(r) {
      i || (Y(o, r), i = !0);
    },
    o(r) {
      U(o, r), i = !1;
    },
    d(r) {
      r && P(e), o && o.d(r);
    }
  };
}
function Df(t) {
  let e;
  return {
    c() {
      e = le(
        /*helptext*/
        t[8]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n[0] & /*helptext*/
      256 && pe(
        e,
        /*helptext*/
        i[8]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function Hf(t) {
  let e, i, n, l, o, r, a, s = (
    /*label*/
    t[6] && $l(t)
  );
  const d = (
    /*#slots*/
    t[18].default
  ), u = oe(
    d,
    t,
    /*$$scope*/
    t[17],
    null
  );
  let c = (
    /*$$slots*/
    (t[15].error || /*error*/
    t[0]) && to(t)
  ), g = (
    /*$$slots*/
    (t[15].helptext || /*helptext*/
    t[8]) && io(t)
  );
  return {
    c() {
      e = C("div"), s && s.c(), i = x(), n = C("div"), u && u.c(), l = x(), c && c.c(), o = x(), g && g.c(), f(n, "class", "form-item-input svelte-1pbqooa"), f(
        e,
        "data-testid",
        /*testid*/
        t[5]
      ), f(e, "style", r = `
    ${be(
        /*mt*/
        t[1],
        /*mr*/
        t[2],
        /*mb*/
        t[3],
        /*ml*/
        t[4]
      )}
    max-width: ${/*maxwidth*/
      t[10]};
  `), f(e, "class", "svelte-1pbqooa");
    },
    m(h, m) {
      D(h, e, m), s && s.m(e, null), _(e, i), _(e, n), u && u.m(n, null), _(e, l), c && c.m(e, null), _(e, o), g && g.m(e, null), t[19](e), a = !0;
    },
    p(h, m) {
      /*label*/
      h[6] ? s ? s.p(h, m) : (s = $l(h), s.c(), s.m(e, i)) : s && (s.d(1), s = null), u && u.p && (!a || m[0] & /*$$scope*/
      131072) && ae(
        u,
        d,
        h,
        /*$$scope*/
        h[17],
        a ? re(
          d,
          /*$$scope*/
          h[17],
          m,
          null
        ) : se(
          /*$$scope*/
          h[17]
        ),
        null
      ), /*$$slots*/
      h[15].error || /*error*/
      h[0] ? c ? (c.p(h, m), m[0] & /*$$slots, error*/
      32769 && Y(c, 1)) : (c = to(h), c.c(), Y(c, 1), c.m(e, o)) : c && (Oe(), U(c, 1, 1, () => {
        c = null;
      }), Fe()), /*$$slots*/
      h[15].helptext || /*helptext*/
      h[8] ? g ? (g.p(h, m), m[0] & /*$$slots, helptext*/
      33024 && Y(g, 1)) : (g = io(h), g.c(), Y(g, 1), g.m(e, null)) : g && (Oe(), U(g, 1, 1, () => {
        g = null;
      }), Fe()), (!a || m[0] & /*testid*/
      32) && f(
        e,
        "data-testid",
        /*testid*/
        h[5]
      ), (!a || m[0] & /*mt, mr, mb, ml, maxwidth*/
      1054 && r !== (r = `
    ${be(
        /*mt*/
        h[1],
        /*mr*/
        h[2],
        /*mb*/
        h[3],
        /*ml*/
        h[4]
      )}
    max-width: ${/*maxwidth*/
      h[10]};
  `)) && f(e, "style", r);
    },
    i(h) {
      a || (Y(u, h), Y(c), Y(g), a = !0);
    },
    o(h) {
      U(u, h), U(c), U(g), a = !1;
    },
    d(h) {
      h && P(e), s && s.d(), u && u.d(h), c && c.d(), g && g.d(), t[19](null);
    }
  };
}
function Of(t) {
  const e = document.createElement("div");
  e.className = "sr-only", e.setAttribute("aria-live", "polite"), e.setAttribute("aria-atomic", "true"), document.body.appendChild(e), setTimeout(
    () => {
      e.textContent = t;
    },
    100
  ), setTimeout(
    () => {
      document.body.removeChild(e);
    },
    3e3
  );
}
function Ff(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e;
  const o = pt(n), [r, a] = Me("Requirement type", ["optional", "required"], !1), [s, d] = Me("Label size type", ["regular", "large"], !1);
  let { mt: u = null } = e, { mr: c = null } = e, { mb: g = null } = e, { ml: h = null } = e, { testid: m = "" } = e, { label: v = "" } = e, { labelsize: b = "regular" } = e, { helptext: w = "" } = e, { error: y = "" } = e, { requirement: j = "" } = e, { maxwidth: E = "none" } = e, { name: M = "blank" } = e, L, z, V = `error-${fi()}`, T = `helptext-${fi()}`, S = !1;
  ke(() => {
    a(j), d(b), Re(L, (O, W) => {
      switch (O) {
        case Qe:
          F(W);
          break;
        case dt:
          N(W);
          break;
        case ut:
          i(0, y = "");
          break;
      }
    }), L == null || L.addEventListener("form-field::bind", A), L == null || L.addEventListener("error::change", R), L == null || L.addEventListener("help-text::announce", I);
  });
  function A(O) {
    z = O.detail.el;
    const K = z.getAttribute("aria-label");
    (!K || K.trim() === "") && z.setAttribute("aria-label", v), z.setAttribute("aria-required", j === "required" ? "true" : "false"), B();
  }
  function R(O) {
    const W = O;
    S !== W.detail.isError && (S = W.detail.isError, B());
  }
  function I() {
    const O = S && y || w;
    O && Of(O);
  }
  function B() {
    if (!z) return;
    let O = [];
    (S || o.error) && O.push(V), (w || o.helptext) && O.push(T), O.length > 0 ? z.setAttribute("aria-describedby", O.join(" ")) : z.setAttribute("aria-describedby", "");
  }
  function N(O) {
    i(0, y = O.error);
  }
  function F(O) {
    const { el: W, name: K } = O, $ = W.getAttribute("aria-label");
    (!$ || $.trim() === "") && W.setAttribute("aria-label", v), q(K);
  }
  function q(O) {
    je(
      L,
      Rr,
      {
        id: O,
        label: M !== "blank" ? M : v,
        el: L
      },
      { bubbles: !0, timeout: 10 }
    );
  }
  function H(O) {
    ue[O ? "unshift" : "push"](() => {
      L = O, i(11, L);
    });
  }
  return t.$$set = (O) => {
    "mt" in O && i(1, u = O.mt), "mr" in O && i(2, c = O.mr), "mb" in O && i(3, g = O.mb), "ml" in O && i(4, h = O.ml), "testid" in O && i(5, m = O.testid), "label" in O && i(6, v = O.label), "labelsize" in O && i(7, b = O.labelsize), "helptext" in O && i(8, w = O.helptext), "error" in O && i(0, y = O.error), "requirement" in O && i(9, j = O.requirement), "maxwidth" in O && i(10, E = O.maxwidth), "name" in O && i(16, M = O.name), "$$scope" in O && i(17, l = O.$$scope);
  }, [
    y,
    u,
    c,
    g,
    h,
    m,
    v,
    b,
    w,
    j,
    E,
    L,
    r,
    V,
    T,
    o,
    M,
    l,
    n,
    H
  ];
}
class Af extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Ff,
      Hf,
      ce,
      {
        mt: 1,
        mr: 2,
        mb: 3,
        ml: 4,
        testid: 5,
        label: 6,
        labelsize: 7,
        helptext: 8,
        error: 0,
        requirement: 9,
        maxwidth: 10,
        name: 16
      },
      qf,
      [-1, -1]
    );
  }
  get mt() {
    return this.$$.ctx[1];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[2];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[3];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[4];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get testid() {
    return this.$$.ctx[5];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get label() {
    return this.$$.ctx[6];
  }
  set label(e) {
    this.$$set({ label: e }), k();
  }
  get labelsize() {
    return this.$$.ctx[7];
  }
  set labelsize(e) {
    this.$$set({ labelsize: e }), k();
  }
  get helptext() {
    return this.$$.ctx[8];
  }
  set helptext(e) {
    this.$$set({ helptext: e }), k();
  }
  get error() {
    return this.$$.ctx[0];
  }
  set error(e) {
    this.$$set({ error: e }), k();
  }
  get requirement() {
    return this.$$.ctx[9];
  }
  set requirement(e) {
    this.$$set({ requirement: e }), k();
  }
  get maxwidth() {
    return this.$$.ctx[10];
  }
  set maxwidth(e) {
    this.$$set({ maxwidth: e }), k();
  }
  get name() {
    return this.$$.ctx[16];
  }
  set name(e) {
    this.$$set({ name: e }), k();
  }
}
customElements.define("goa-form-item", he(Af, { mt: {}, mr: {}, mb: {}, ml: {}, testid: {}, label: {}, labelsize: {}, helptext: {}, error: {}, requirement: {}, maxwidth: {}, name: {} }, ["default", "error", "helptext"], [], !0));
function Vf(t) {
  _e(t, "svelte-4swyjk", `input[type="checkbox"].svelte-4swyjk.svelte-4swyjk{position:absolute;left:-9999px}label.svelte-4swyjk.svelte-4swyjk{display:flex;box-sizing:border-box;height:100%;width:100%;padding:var(--goa-step-padding)}label.svelte-4swyjk.svelte-4swyjk:not([aria-disabled="true"]):not([aria-current="step"]):has(input:focus-visible){outline:var(--goa-color-interactive-focus) solid var(--goa-border-width-l)}label.svelte-4swyjk.svelte-4swyjk:not([aria-disabled="true"]):not([aria-current="step"]):hover{background-color:rgba(0, 0, 0, 0.05);cursor:pointer}label.desktop.svelte-4swyjk.svelte-4swyjk{text-align:center;flex-direction:column;align-items:center}label.desktop.svelte-4swyjk .details.svelte-4swyjk{margin-top:0.75rem}label.mobile.svelte-4swyjk.svelte-4swyjk{flex-direction:row;align-items:center;text-align:start;padding:var(--goa-step-padding-vertical)}label.mobile.svelte-4swyjk .details.svelte-4swyjk{margin-left:var(--goa-space-xs)}.status.svelte-4swyjk.svelte-4swyjk{flex:0 0 auto;display:flex;align-items:center;justify-content:center;box-sizing:border-box;border-radius:999px;border:var(--goa-step-border);background:var(--goa-step-color-bg);height:var(--goa-step-size);width:var(--goa-step-size)}.status.svelte-4swyjk>.svelte-4swyjk{fill:var(--fill-color, var(--goa-step-color-bg-complete));color:var(--fill-color, var(--goa-step-color-bg-complete))}[aria-current="step"].svelte-4swyjk .text.svelte-4swyjk{font:var(--goa-step-typography-label-active)}[data-status="complete"].svelte-4swyjk .status.svelte-4swyjk{background:var(--goa-step-color-bg-complete)}[aria-current="step"][data-status="complete"].svelte-4swyjk .status.svelte-4swyjk{background:var(--goa-step-color-bg-active)}.step-number.svelte-4swyjk.svelte-4swyjk{margin-bottom:var(--font-valign-fix);font:var(--goa-step-typography-step-number);color:var(--goa-step-color-step-number)}label.svelte-4swyjk:not(
      [data-status="complete"],
      [data-status="incomplete"],
      [aria-current="step"]
    ) .status.svelte-4swyjk{border-color:var(--goa-step-color-border)}.text.svelte-4swyjk.svelte-4swyjk{font:var(--goa-step-typography-label);color:var(--goa-step-color-label)}.subtext.svelte-4swyjk.svelte-4swyjk{margin-top:0.25rem;font:var(--goa-step-typography-sublabel);color:var(--goa-step-color-sublabel)}`);
}
function If(t) {
  let e, i = (
    /*childindex*/
    (t[3] || "") + ""
  ), n;
  return {
    c() {
      e = C("div"), n = le(i), f(e, "data-testid", "step-number"), f(e, "class", "step-number svelte-4swyjk");
    },
    m(l, o) {
      D(l, e, o), _(e, n);
    },
    p(l, o) {
      o & /*childindex*/
      8 && i !== (i = /*childindex*/
      (l[3] || "") + "") && pe(n, i);
    },
    d(l) {
      l && P(e);
    }
  };
}
function xf(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", "remove"), p(e, "theme", "filled"), p(e, "class", "svelte-4swyjk");
    },
    m(i, n) {
      D(i, e, n);
    },
    p: ve,
    d(i) {
      i && P(e);
    }
  };
}
function Bf(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", "checkmark"), p(e, "inverted", ""), p(e, "class", "svelte-4swyjk");
    },
    m(i, n) {
      D(i, e, n);
    },
    p: ve,
    d(i) {
      i && P(e);
    }
  };
}
function Nf(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", "pencil"), p(e, "theme", "filled"), p(e, "class", "svelte-4swyjk");
    },
    m(i, n) {
      D(i, e, n);
    },
    p: ve,
    d(i) {
      i && P(e);
    }
  };
}
function no(t) {
  let e;
  return {
    c() {
      e = C("div"), e.textContent = "Partially complete", f(e, "class", "subtext svelte-4swyjk"), f(e, "data-testid", "subtext");
    },
    m(i, n) {
      D(i, e, n);
    },
    d(i) {
      i && P(e);
    }
  };
}
function Wf(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v;
  function b(E, M) {
    return (
      /*current*/
      E[2] ? Nf : (
        /*status*/
        E[0] === "complete" ? Bf : (
          /*status*/
          E[0] === "incomplete" ? xf : If
        )
      )
    );
  }
  let w = b(t), y = w(t), j = (
    /*status*/
    t[0] === "incomplete" && no()
  );
  return {
    c() {
      e = C("label"), i = C("input"), o = x(), r = C("div"), y.c(), a = x(), s = C("div"), d = C("div"), u = le(
        /*text*/
        t[1]
      ), c = x(), j && j.c(), f(
        i,
        "id",
        /*text*/
        t[1]
      ), f(i, "type", "checkbox"), i.checked = /*current*/
      t[2], f(i, "aria-disabled", n = !/*_isEnabled*/
      t[8]), i.disabled = l = !/*_isEnabled*/
      t[8], f(i, "data-testid", "checkbox"), f(i, "class", "svelte-4swyjk"), f(r, "data-testid", "status"), f(r, "class", "status svelte-4swyjk"), f(d, "class", "text svelte-4swyjk"), f(d, "data-testid", "text"), f(s, "class", "details svelte-4swyjk"), f(
        e,
        "id",
        /*arialabel*/
        t[4]
      ), f(e, "role", "listitem"), f(e, "tabindex", "-1"), f(
        e,
        "for",
        /*text*/
        t[1]
      ), f(
        e,
        "data-status",
        /*status*/
        t[0]
      ), f(e, "aria-current", g = /*current*/
      t[2] ? "step" : "false"), f(e, "aria-label", h = /*arialabel*/
      t[4] || `${/*text*/
      t[1]} ${/*status*/
      t[0] || ""}`), f(e, "data-testid", "label"), f(e, "class", "svelte-4swyjk"), G(
        e,
        "mobile",
        /*_isMobile*/
        t[7]
      ), G(e, "desktop", !/*_isMobile*/
      t[7]);
    },
    m(E, M) {
      D(E, e, M), _(e, i), t[11](i), _(e, o), _(e, r), y.m(r, null), _(e, a), _(e, s), _(s, d), _(d, u), _(s, c), j && j.m(s, null), t[12](e), m || (v = te(
        i,
        "click",
        /*onClick*/
        t[9]
      ), m = !0);
    },
    p(E, [M]) {
      M & /*text*/
      2 && f(
        i,
        "id",
        /*text*/
        E[1]
      ), M & /*current*/
      4 && (i.checked = /*current*/
      E[2]), M & /*_isEnabled*/
      256 && n !== (n = !/*_isEnabled*/
      E[8]) && f(i, "aria-disabled", n), M & /*_isEnabled*/
      256 && l !== (l = !/*_isEnabled*/
      E[8]) && (i.disabled = l), w === (w = b(E)) && y ? y.p(E, M) : (y.d(1), y = w(E), y && (y.c(), y.m(r, null))), M & /*text*/
      2 && pe(
        u,
        /*text*/
        E[1]
      ), /*status*/
      E[0] === "incomplete" ? j || (j = no(), j.c(), j.m(s, null)) : j && (j.d(1), j = null), M & /*arialabel*/
      16 && f(
        e,
        "id",
        /*arialabel*/
        E[4]
      ), M & /*text*/
      2 && f(
        e,
        "for",
        /*text*/
        E[1]
      ), M & /*status*/
      1 && f(
        e,
        "data-status",
        /*status*/
        E[0]
      ), M & /*current*/
      4 && g !== (g = /*current*/
      E[2] ? "step" : "false") && f(e, "aria-current", g), M & /*arialabel, text, status*/
      19 && h !== (h = /*arialabel*/
      E[4] || `${/*text*/
      E[1]} ${/*status*/
      E[0] || ""}`) && f(e, "aria-label", h), M & /*_isMobile*/
      128 && G(
        e,
        "mobile",
        /*_isMobile*/
        E[7]
      ), M & /*_isMobile*/
      128 && G(e, "desktop", !/*_isMobile*/
      E[7]);
    },
    i: ve,
    o: ve,
    d(E) {
      E && P(e), t[11](null), y.d(), j && j.d(), t[12](null), m = !1, v();
    }
  };
}
function Rf(t, e, i) {
  let n, { text: l } = e, { status: o = void 0 } = e, r = !1, a = !1, s, d = "", u, c, g;
  ke(() => {
    u.addEventListener("form-stepper:resized", (w) => {
      const { mobile: y } = w.detail;
      i(7, g = y);
    }), u.addEventListener("formstepper:init", (w) => {
      const y = w;
      i(4, d = y.detail.ariaLabel), i(10, a = y.detail.enabled), i(3, s = y.detail.childIndex), i(2, r = y.detail.current), i(0, o = y.detail.status);
    }), u.addEventListener("formstepper:enabled:changed", (w) => {
      i(10, a = w.detail.enabled);
    }), u.addEventListener("formstepper:current:changed", (w) => {
      const y = w;
      i(10, a = !0), i(2, r = y.detail.current);
    }), h(u);
  });
  function h(w) {
    setTimeout(
      () => {
        w.dispatchEvent(new CustomEvent(
          "formstep:mounted",
          {
            detail: { el: u, status: o },
            composed: !0,
            bubbles: !0
          }
        ));
      },
      10
    );
  }
  function m(w) {
    n && (i(6, c.checked = !c.checked, c), u.dispatchEvent(new CustomEvent(
      "_click",
      {
        composed: !0,
        bubbles: !0,
        detail: { step: +s }
      }
    )), w.stopPropagation());
  }
  function v(w) {
    ue[w ? "unshift" : "push"](() => {
      c = w, i(6, c);
    });
  }
  function b(w) {
    ue[w ? "unshift" : "push"](() => {
      u = w, i(5, u);
    });
  }
  return t.$$set = (w) => {
    "text" in w && i(1, l = w.text), "status" in w && i(0, o = w.status);
  }, t.$$.update = () => {
    t.$$.dirty & /*enabled, status*/
    1025 && i(8, n = a || o === "complete");
  }, [
    o,
    l,
    r,
    s,
    d,
    u,
    c,
    g,
    n,
    m,
    a,
    v,
    b
  ];
}
class Yf extends me {
  constructor(e) {
    super(), ge(this, e, Rf, Wf, ce, { text: 1, status: 0 }, Vf);
  }
  get text() {
    return this.$$.ctx[1];
  }
  set text(e) {
    this.$$set({ text: e }), k();
  }
  get status() {
    return this.$$.ctx[0];
  }
  set status(e) {
    this.$$set({ status: e }), k();
  }
}
customElements.define("goa-form-step", he(Yf, { text: {}, status: {} }, [], [], !0));
function Zf(t) {
  _e(t, "svelte-cdwii4", `.slots.svelte-cdwii4{position:relative;inset:0;z-index:2}#container.svelte-cdwii4{container:self / inline-size}progress.svelte-cdwii4{position:absolute;z-index:1;-webkit-appearance:none;-moz-appearance:none;appearance:none;height:var(--goa-stepper-line-thickness);border:none;background:var(--goa-stepper-color-line);pointer-events:none}progress.horizontal.svelte-cdwii4{top:calc(1.5rem + (2.5rem / 2) - 2px);left:calc(var(--step-width) / 2);width:calc(100% - var(--step-width))}@container self (min-width: 624px){progress.horizontal.svelte-cdwii4{display:block}progress.vertical.svelte-cdwii4{display:none}.form-stepper.svelte-cdwii4{position:relative}}progress.vertical.svelte-cdwii4{width:calc(var(--height) - var(--step-height));transform:rotate(90deg)
      translate(
        calc(50% + 1.25rem + 1rem),
        calc((var(--height) - var(--step-height)) / 2 - 1.25rem - 1.5rem)
      )}@container self (max-width: 623px){progress.horizontal.svelte-cdwii4{display:none}progress.vertical.svelte-cdwii4{display:inline-block}.form-stepper.svelte-cdwii4{display:block}}progress.svelte-cdwii4::-webkit-progress-value{background:var(--goa-color-interactive-default)}progress.svelte-cdwii4::-webkit-progress-bar{background:var(--goa-stepper-color-line)}progress.svelte-cdwii4::-moz-progress-bar{background:var(--goa-color-interactive-default)}`);
}
function lo(t) {
  let e, i, n;
  return {
    c() {
      e = C("progress"), i = x(), n = C("progress"), f(e, "class", "horizontal svelte-cdwii4"), e.value = /*_progress*/
      t[11], f(e, "max", "100"), f(n, "class", "vertical svelte-cdwii4"), n.value = /*_progress*/
      t[11], f(n, "max", "100");
    },
    m(l, o) {
      D(l, e, o), D(l, i, o), D(l, n, o);
    },
    p(l, o) {
      o[0] & /*_progress*/
      2048 && (e.value = /*_progress*/
      l[11]), o[0] & /*_progress*/
      2048 && (n.value = /*_progress*/
      l[11]);
    },
    d(l) {
      l && (P(e), P(i), P(n));
    }
  };
}
function Uf(t) {
  let e, i, n, l, o, r, a, s = (
    /*_steps*/
    t[7].length > 0 && /*_showProgressBars*/
    t[12] && lo(t)
  );
  const d = (
    /*#slots*/
    t[17].default
  ), u = oe(
    d,
    t,
    /*$$scope*/
    t[16],
    null
  );
  return {
    c() {
      e = C("div"), i = C("div"), s && s.c(), n = x(), l = C("div"), o = C("goa-grid"), u && u.c(), p(o, "minchildwidth", "10ch"), f(l, "class", "slots svelte-cdwii4"), f(i, "class", "form-stepper svelte-cdwii4"), f(i, "style", r = `
      ${be(
        /*mt*/
        t[1],
        /*mr*/
        t[2],
        /*mb*/
        t[3],
        /*ml*/
        t[4]
      )};
      --progress: ${/*_progress*/
      t[11]}%;
      --step-width: ${/*_stepWidth*/
      t[8]}px;
      --step-height: ${/*_stepHeight*/
      t[9]}px;
      --height: ${/*_progressHeight*/
      t[10]}px;
    `), f(i, "role", "list"), f(
        i,
        "data-testid",
        /*testid*/
        t[0]
      ), f(e, "id", "container"), f(e, "class", "svelte-cdwii4");
    },
    m(c, g) {
      D(c, e, g), _(e, i), s && s.m(i, null), _(i, n), _(i, l), _(l, o), u && u.m(o, null), t[18](l), t[19](i), a = !0;
    },
    p(c, g) {
      /*_steps*/
      c[7].length > 0 && /*_showProgressBars*/
      c[12] ? s ? s.p(c, g) : (s = lo(c), s.c(), s.m(i, n)) : s && (s.d(1), s = null), u && u.p && (!a || g[0] & /*$$scope*/
      65536) && ae(
        u,
        d,
        c,
        /*$$scope*/
        c[16],
        a ? re(
          d,
          /*$$scope*/
          c[16],
          g,
          null
        ) : se(
          /*$$scope*/
          c[16]
        ),
        null
      ), (!a || g[0] & /*mt, mr, mb, ml, _progress, _stepWidth, _stepHeight, _progressHeight*/
      3870 && r !== (r = `
      ${be(
        /*mt*/
        c[1],
        /*mr*/
        c[2],
        /*mb*/
        c[3],
        /*ml*/
        c[4]
      )};
      --progress: ${/*_progress*/
      c[11]}%;
      --step-width: ${/*_stepWidth*/
      c[8]}px;
      --step-height: ${/*_stepHeight*/
      c[9]}px;
      --height: ${/*_progressHeight*/
      c[10]}px;
    `)) && f(i, "style", r), (!a || g[0] & /*testid*/
      1) && f(
        i,
        "data-testid",
        /*testid*/
        c[0]
      );
    },
    i(c) {
      a || (Y(u, c), a = !0);
    },
    o(c) {
      U(u, c), a = !1;
    },
    d(c) {
      c && P(e), s && s.d(), u && u.d(c), t[18](null), t[19](null);
    }
  };
}
function Gf(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { step: o = -1 } = e, { testid: r = "" } = e, { mt: a = null } = e, { mr: s = null } = e, { mb: d = null } = e, { ml: u = null } = e, c, g, h = [], m, v, b, w, y = 0, j, E = 1, M = !1, L, z;
  ke(async () => {
    await Pe(), b = +o == -1 ? "free" : "constrained", V(), z = R(), z.observe(c);
  }), ct(() => {
    window.removeEventListener("orientationchange", N), z.unobserve(c);
  });
  function V() {
    c.addEventListener("formstep:mounted", (O) => {
      const W = O, { el: K, status: $ } = W.detail;
      i(7, h = [...h, { el: K, status: $ }]), L && clearTimeout(L), L = setTimeout(() => {
        T(), N(), A(), S(), i(14, j = o < 1 ? 1 : o), F();
      });
    });
  }
  function T() {
    for (const [O, W] of h.entries()) {
      const K = O + 1, $ = {
        ariaLabel: `Step ${K} of ${h.length}`,
        childIndex: K,
        current: o === -1 ? K === 1 : K === o,
        enabled: K <= o || b === "free",
        status: W.status
      };
      W.el.dispatchEvent(new CustomEvent("formstepper:init", { composed: !0, detail: $ }));
    }
  }
  function S() {
    window.addEventListener("orientationchange", N);
  }
  function A() {
    c == null || c.addEventListener("_click", (O) => {
      const W = O.detail.step;
      I(W);
    });
  }
  function R() {
    return new ResizeObserver((O) => {
      if (O.length !== 1) return;
      N();
      const W = O[0].contentRect.width;
      for (const K of h)
        K.el.dispatchEvent(new CustomEvent(
          "form-stepper:resized",
          {
            bubbles: !0,
            composed: !0,
            detail: { testid: r, mobile: W < gi }
          }
        ));
    });
  }
  function I(O) {
    h.length !== 0 && (j > 0 && h[j - 1].el.dispatchEvent(new CustomEvent(
      "formstepper:current:changed",
      {
        detail: { current: !1 },
        composed: !0
      }
    )), h[O - 1].el.dispatchEvent(new CustomEvent(
      "formstepper:current:changed",
      {
        detail: { current: !0 },
        composed: !0
      }
    )), i(14, j = O), B(), F());
  }
  function B() {
    i(11, y = (j - 1) / (h.length - 1) * 100);
  }
  function N() {
    var W;
    const O = (W = h == null ? void 0 : h[0]) == null ? void 0 : W.el;
    i(8, m = (O == null ? void 0 : O.offsetWidth) ?? 0), i(9, v = (O == null ? void 0 : O.offsetHeight) ?? 0), i(10, w = g == null ? void 0 : g.offsetHeight), setTimeout(() => i(12, M = !0), 100);
  }
  function F() {
    c == null || c.dispatchEvent(new CustomEvent(
      "_change",
      {
        composed: !0,
        bubbles: !0,
        detail: {
          step: +j,
          stepIndex: +j - 1
        }
      }
    ));
  }
  function q(O) {
    ue[O ? "unshift" : "push"](() => {
      g = O, i(6, g);
    });
  }
  function H(O) {
    ue[O ? "unshift" : "push"](() => {
      c = O, i(5, c);
    });
  }
  return t.$$set = (O) => {
    "step" in O && i(13, o = O.step), "testid" in O && i(0, r = O.testid), "mt" in O && i(1, a = O.mt), "mr" in O && i(2, s = O.mr), "mb" in O && i(3, d = O.mb), "ml" in O && i(4, u = O.ml), "$$scope" in O && i(16, l = O.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*_currentStep, _maxAllowedStep*/
    49152 && i(15, E = Math.max(j || 1, E || 1)), t.$$.dirty[0] & /*step*/
    8192 && i(13, o = +o), t.$$.dirty[0] & /*step, _currentStep*/
    24576 && o > 0 && j !== o && I(o), t.$$.dirty[0] & /*_currentStep*/
    16384 && j && B();
  }, [
    r,
    a,
    s,
    d,
    u,
    c,
    g,
    h,
    m,
    v,
    w,
    y,
    M,
    o,
    j,
    E,
    l,
    n,
    q,
    H
  ];
}
class Kf extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Gf,
      Uf,
      ce,
      {
        step: 13,
        testid: 0,
        mt: 1,
        mr: 2,
        mb: 3,
        ml: 4
      },
      Zf,
      [-1, -1]
    );
  }
  get step() {
    return this.$$.ctx[13];
  }
  set step(e) {
    this.$$set({ step: e }), k();
  }
  get testid() {
    return this.$$.ctx[0];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[1];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[2];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[3];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[4];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-form-stepper", he(Kf, { step: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function Xf(t) {
  _e(t, "svelte-1f1uff1", `.page.svelte-1f1uff1{height:100vh;grid-template-columns:auto;grid-template-rows:min-content auto min-content;grid-template-areas:"header"
      "content"
      "nav"
      "footer";display:grid;place-content:stretch stretch;gap:0 0}@media(max-width: 623px){.page.svelte-1f1uff1{grid-template-columns:300px auto;grid-template-rows:min-content auto min-content;grid-template-areas:"header header"
        "nav content"
        "footer footer"}}.header.svelte-1f1uff1{grid-area:header}.footer.svelte-1f1uff1{grid-area:footer}main.svelte-1f1uff1{grid-area:content;justify-self:stretch;padding:1rem}.nav.svelte-1f1uff1{grid-area:nav;padding:1rem;background-color:var(--goa-color-greyscale-100)}`);
}
const Jf = (t) => ({}), oo = (t) => ({}), Qf = (t) => ({}), ro = (t) => ({}), $f = (t) => ({}), ao = (t) => ({});
function e1(t) {
  let e, i, n, l, o, r, a, s, d;
  const u = (
    /*#slots*/
    t[1].header
  ), c = oe(
    u,
    t,
    /*$$scope*/
    t[0],
    ao
  ), g = (
    /*#slots*/
    t[1].nav
  ), h = oe(
    g,
    t,
    /*$$scope*/
    t[0],
    ro
  ), m = (
    /*#slots*/
    t[1].default
  ), v = oe(
    m,
    t,
    /*$$scope*/
    t[0],
    null
  ), b = (
    /*#slots*/
    t[1].footer
  ), w = oe(
    b,
    t,
    /*$$scope*/
    t[0],
    oo
  );
  return {
    c() {
      e = C("div"), i = C("header"), c && c.c(), n = x(), l = C("nav"), h && h.c(), o = x(), r = C("main"), v && v.c(), a = x(), s = C("footer"), w && w.c(), f(i, "class", "header svelte-1f1uff1"), f(l, "class", "nav svelte-1f1uff1"), f(r, "class", "svelte-1f1uff1"), f(s, "class", "footer svelte-1f1uff1"), f(e, "class", "page svelte-1f1uff1");
    },
    m(y, j) {
      D(y, e, j), _(e, i), c && c.m(i, null), _(e, n), _(e, l), h && h.m(l, null), _(e, o), _(e, r), v && v.m(r, null), _(e, a), _(e, s), w && w.m(s, null), d = !0;
    },
    p(y, [j]) {
      c && c.p && (!d || j & /*$$scope*/
      1) && ae(
        c,
        u,
        y,
        /*$$scope*/
        y[0],
        d ? re(
          u,
          /*$$scope*/
          y[0],
          j,
          $f
        ) : se(
          /*$$scope*/
          y[0]
        ),
        ao
      ), h && h.p && (!d || j & /*$$scope*/
      1) && ae(
        h,
        g,
        y,
        /*$$scope*/
        y[0],
        d ? re(
          g,
          /*$$scope*/
          y[0],
          j,
          Qf
        ) : se(
          /*$$scope*/
          y[0]
        ),
        ro
      ), v && v.p && (!d || j & /*$$scope*/
      1) && ae(
        v,
        m,
        y,
        /*$$scope*/
        y[0],
        d ? re(
          m,
          /*$$scope*/
          y[0],
          j,
          null
        ) : se(
          /*$$scope*/
          y[0]
        ),
        null
      ), w && w.p && (!d || j & /*$$scope*/
      1) && ae(
        w,
        b,
        y,
        /*$$scope*/
        y[0],
        d ? re(
          b,
          /*$$scope*/
          y[0],
          j,
          Jf
        ) : se(
          /*$$scope*/
          y[0]
        ),
        oo
      );
    },
    i(y) {
      d || (Y(c, y), Y(h, y), Y(v, y), Y(w, y), d = !0);
    },
    o(y) {
      U(c, y), U(h, y), U(v, y), U(w, y), d = !1;
    },
    d(y) {
      y && P(e), c && c.d(y), h && h.d(y), v && v.d(y), w && w.d(y);
    }
  };
}
function t1(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e;
  return t.$$set = (o) => {
    "$$scope" in o && i(0, l = o.$$scope);
  }, [l, n];
}
class i1 extends me {
  constructor(e) {
    super(), ge(this, e, t1, e1, ce, {}, Xf);
  }
}
customElements.define("goa-layout-full-nav", he(i1, {}, ["header", "nav", "default", "footer"], [], !0));
function n1(t) {
  _e(t, "svelte-esicfq", `:host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}.goa-grid.svelte-esicfq{display:flex;flex-direction:column;gap:var(--gap)}@media(min-width: 624px){.goa-grid.svelte-esicfq{display:grid;grid-template-columns:repeat(
        auto-fit,
        minmax(var(--min-child-width), 1fr)
      )}}`);
}
function l1(t) {
  let e, i, n;
  const l = (
    /*#slots*/
    t[8].default
  ), o = oe(
    l,
    t,
    /*$$scope*/
    t[7],
    null
  );
  return {
    c() {
      e = C("div"), o && o.c(), f(e, "class", "goa-grid svelte-esicfq"), f(e, "style", i = `
    ${be(
        /*mt*/
        t[3],
        /*mr*/
        t[4],
        /*mb*/
        t[5],
        /*ml*/
        t[6]
      )}
    --min-child-width: ${/*minchildwidth*/
      t[1] || 0};
    gap: var(--goa-space-${/*gap*/
      t[0]})
  `), f(
        e,
        "data-testid",
        /*testid*/
        t[2]
      );
    },
    m(r, a) {
      D(r, e, a), o && o.m(e, null), n = !0;
    },
    p(r, [a]) {
      o && o.p && (!n || a & /*$$scope*/
      128) && ae(
        o,
        l,
        r,
        /*$$scope*/
        r[7],
        n ? re(
          l,
          /*$$scope*/
          r[7],
          a,
          null
        ) : se(
          /*$$scope*/
          r[7]
        ),
        null
      ), (!n || a & /*mt, mr, mb, ml, minchildwidth, gap*/
      123 && i !== (i = `
    ${be(
        /*mt*/
        r[3],
        /*mr*/
        r[4],
        /*mb*/
        r[5],
        /*ml*/
        r[6]
      )}
    --min-child-width: ${/*minchildwidth*/
      r[1] || 0};
    gap: var(--goa-space-${/*gap*/
      r[0]})
  `)) && f(e, "style", i), (!n || a & /*testid*/
      4) && f(
        e,
        "data-testid",
        /*testid*/
        r[2]
      );
    },
    i(r) {
      n || (Y(o, r), n = !0);
    },
    o(r) {
      U(o, r), n = !1;
    },
    d(r) {
      r && P(e), o && o.d(r);
    }
  };
}
function o1(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { gap: o = "m" } = e, { minchildwidth: r = "" } = e, { testid: a = "" } = e, { mt: s = null } = e, { mr: d = null } = e, { mb: u = null } = e, { ml: c = null } = e;
  return ke(() => {
    Kt("Grid", { minchildwidth: r });
  }), t.$$set = (g) => {
    "gap" in g && i(0, o = g.gap), "minchildwidth" in g && i(1, r = g.minchildwidth), "testid" in g && i(2, a = g.testid), "mt" in g && i(3, s = g.mt), "mr" in g && i(4, d = g.mr), "mb" in g && i(5, u = g.mb), "ml" in g && i(6, c = g.ml), "$$scope" in g && i(7, l = g.$$scope);
  }, [o, r, a, s, d, u, c, l, n];
}
class r1 extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      o1,
      l1,
      ce,
      {
        gap: 0,
        minchildwidth: 1,
        testid: 2,
        mt: 3,
        mr: 4,
        mb: 5,
        ml: 6
      },
      n1
    );
  }
  get gap() {
    return this.$$.ctx[0];
  }
  set gap(e) {
    this.$$set({ gap: e }), k();
  }
  get minchildwidth() {
    return this.$$.ctx[1];
  }
  set minchildwidth(e) {
    this.$$set({ minchildwidth: e }), k();
  }
  get testid() {
    return this.$$.ctx[2];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[3];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[4];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[5];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[6];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-grid", he(r1, { gap: {}, minchildwidth: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function a1(t) {
  _e(t, "svelte-1an6u34", `:host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}.goa-hero.svelte-1an6u34{background:var(--hero-banner-background-color);box-sizing:border-box;display:flex;justify-content:center;flex-direction:column;color:var(--hero-banner-text-color, var(--goa-color-text-default));background-position:center center;width:100%;padding:var(--goa-hero-banner-padding)}@media(max-width: 623px){.goa-hero.svelte-1an6u34{padding:var(--goa-hero-banner-mobile-padding)}}.goa-hero.with-image.svelte-1an6u34{border-bottom:8px solid var(--goa-color-brand-default);justify-content:flex-end;background:unset;background-image:linear-gradient(
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.42) 42%,
        rgba(0, 0, 0, 0.6) 100%
      ),
      var(--hero-background-url);background-size:cover;background-position:center;background-repeat:no-repeat;color:var(--hero-banner-text-color, var(--goa-color-text-light))}h1.svelte-1an6u34{font:var(--goa-hero-banner-heading);margin:0}.goa-hero-banner-content.svelte-1an6u34{font:var(--goa-hero-banner-content);margin:var(--goa-hero-banner-content-gap)}.goa-hero-banner-actions.svelte-1an6u34{margin:var(--goa-hero-banner-content-gap)}`);
}
const s1 = (t) => ({}), so = (t) => ({});
function u1(t) {
  let e, i, n, l, o, r, a, s, d, u;
  const c = (
    /*#slots*/
    t[8].default
  ), g = oe(
    c,
    t,
    /*$$scope*/
    t[7],
    null
  ), h = (
    /*#slots*/
    t[8].actions
  ), m = oe(
    h,
    t,
    /*$$scope*/
    t[7],
    so
  );
  return {
    c() {
      e = C("div"), i = C("goa-page-block"), n = C("h1"), l = le(
        /*heading*/
        t[1]
      ), o = x(), r = C("div"), g && g.c(), a = x(), s = C("div"), m && m.c(), f(n, "class", "svelte-1an6u34"), f(r, "class", "goa-hero-banner-content svelte-1an6u34"), f(r, "role", "note"), f(s, "class", "goa-hero-banner-actions svelte-1an6u34"), p(i, "width", d = /*maxcontentwidth*/
      t[3] || "full"), f(e, "class", "goa-hero svelte-1an6u34"), f(
        e,
        "data-testid",
        /*testid*/
        t[6]
      ), Be(
        e,
        "min-height",
        /*minheight*/
        t[0]
      ), Be(
        e,
        "--hero-banner-background-color",
        /*backgroundcolor*/
        t[4]
      ), Be(
        e,
        "--hero-banner-text-color",
        /*textcolor*/
        t[5]
      ), Be(e, "--hero-background-url", "url(" + /*backgroundurl*/
      t[2] + ")"), G(
        e,
        "with-image",
        /*backgroundurl*/
        t[2]
      );
    },
    m(v, b) {
      D(v, e, b), _(e, i), _(i, n), _(n, l), _(i, o), _(i, r), g && g.m(r, null), _(i, a), _(i, s), m && m.m(s, null), u = !0;
    },
    p(v, [b]) {
      (!u || b & /*heading*/
      2) && pe(
        l,
        /*heading*/
        v[1]
      ), g && g.p && (!u || b & /*$$scope*/
      128) && ae(
        g,
        c,
        v,
        /*$$scope*/
        v[7],
        u ? re(
          c,
          /*$$scope*/
          v[7],
          b,
          null
        ) : se(
          /*$$scope*/
          v[7]
        ),
        null
      ), m && m.p && (!u || b & /*$$scope*/
      128) && ae(
        m,
        h,
        v,
        /*$$scope*/
        v[7],
        u ? re(
          h,
          /*$$scope*/
          v[7],
          b,
          s1
        ) : se(
          /*$$scope*/
          v[7]
        ),
        so
      ), (!u || b & /*maxcontentwidth*/
      8 && d !== (d = /*maxcontentwidth*/
      v[3] || "full")) && p(i, "width", d), (!u || b & /*testid*/
      64) && f(
        e,
        "data-testid",
        /*testid*/
        v[6]
      ), (!u || b & /*minheight*/
      1) && Be(
        e,
        "min-height",
        /*minheight*/
        v[0]
      ), (!u || b & /*backgroundcolor*/
      16) && Be(
        e,
        "--hero-banner-background-color",
        /*backgroundcolor*/
        v[4]
      ), (!u || b & /*textcolor*/
      32) && Be(
        e,
        "--hero-banner-text-color",
        /*textcolor*/
        v[5]
      ), (!u || b & /*backgroundurl*/
      4) && Be(e, "--hero-background-url", "url(" + /*backgroundurl*/
      v[2] + ")"), (!u || b & /*backgroundurl*/
      4) && G(
        e,
        "with-image",
        /*backgroundurl*/
        v[2]
      );
    },
    i(v) {
      u || (Y(g, v), Y(m, v), u = !0);
    },
    o(v) {
      U(g, v), U(m, v), u = !1;
    },
    d(v) {
      v && P(e), g && g.d(v), m && m.d(v);
    }
  };
}
function d1(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { heading: o } = e, { backgroundurl: r } = e, { minheight: a } = e, { maxcontentwidth: s = "100%" } = e, { backgroundcolor: d = "#f8f8f8" } = e, { textcolor: u = "" } = e, { testid: c = "background" } = e;
  return t.$$set = (g) => {
    "heading" in g && i(1, o = g.heading), "backgroundurl" in g && i(2, r = g.backgroundurl), "minheight" in g && i(0, a = g.minheight), "maxcontentwidth" in g && i(3, s = g.maxcontentwidth), "backgroundcolor" in g && i(4, d = g.backgroundcolor), "textcolor" in g && i(5, u = g.textcolor), "testid" in g && i(6, c = g.testid), "$$scope" in g && i(7, l = g.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*minheight, backgroundurl*/
    5 && !a && r && i(0, a = "600px");
  }, [
    a,
    o,
    r,
    s,
    d,
    u,
    c,
    l,
    n
  ];
}
class c1 extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      d1,
      u1,
      ce,
      {
        heading: 1,
        backgroundurl: 2,
        minheight: 0,
        maxcontentwidth: 3,
        backgroundcolor: 4,
        textcolor: 5,
        testid: 6
      },
      a1
    );
  }
  get heading() {
    return this.$$.ctx[1];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get backgroundurl() {
    return this.$$.ctx[2];
  }
  set backgroundurl(e) {
    this.$$set({ backgroundurl: e }), k();
  }
  get minheight() {
    return this.$$.ctx[0];
  }
  set minheight(e) {
    this.$$set({ minheight: e }), k();
  }
  get maxcontentwidth() {
    return this.$$.ctx[3];
  }
  set maxcontentwidth(e) {
    this.$$set({ maxcontentwidth: e }), k();
  }
  get backgroundcolor() {
    return this.$$.ctx[4];
  }
  set backgroundcolor(e) {
    this.$$set({ backgroundcolor: e }), k();
  }
  get textcolor() {
    return this.$$.ctx[5];
  }
  set textcolor(e) {
    this.$$set({ textcolor: e }), k();
  }
  get testid() {
    return this.$$.ctx[6];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-hero-banner", he(c1, { heading: {}, backgroundurl: {}, minheight: {}, maxcontentwidth: {}, backgroundcolor: {}, textcolor: {}, testid: {} }, ["default", "actions"], [], !0));
function f1(t) {
  _e(t, "svelte-1tqx19v", `:host{display:inline-flex;align-items:center;box-sizing:border-box;font-family:var(--goa-font-family-sans)}:host:focus,:host:focus-within,:host:focus-visible{outline:none !important}.goa-icon-button--small.svelte-1tqx19v{padding:var(--goa-icon-button-medium-padding)}.goa-icon-button--medium.svelte-1tqx19v{padding:var(--goa-icon-button-medium-padding)}.goa-icon-button--large.svelte-1tqx19v{padding:var(--goa-icon-button-large-padding)}.goa-icon-button--xlarge.svelte-1tqx19v{padding:var(--goa-icon-button-large-padding)}button.svelte-1tqx19v{display:inline-flex;align-items:center;box-sizing:border-box;justify-content:center;background:transparent;cursor:pointer;border:none;border-radius:var(--goa-icon-button-medium-border-radius);padding:var(--padding);cursor:pointer;transition:background-color 0.2s ease-in-out,
      color 0.2s ease-in-out,
      transform 0.1s ease-in-out}button.svelte-1tqx19v:active{transform:translateY(2px)}button.svelte-1tqx19v:hover{outline:none}button.svelte-1tqx19v:focus-visible{box-shadow:0 0 0 3px var(--goa-color-interactive-focus);outline:none}button.svelte-1tqx19v:disabled{pointer-events:none;transform:none;cursor:default;opacity:1}button.svelte-1tqx19v:disabled:hover{background-color:transparent}.color.svelte-1tqx19v{color:var(--goa-icon-button-default-color);fill:var(--goa-icon-button-default-color)}.color.svelte-1tqx19v:hover,.color.svelte-1tqx19v:focus{color:var(--goa-icon-button-default-hover-color);fill:var(--goa-icon-button-default-hover-color);background-color:var(--goa-icon-button-default-hover-color-bg)}.color.svelte-1tqx19v:disabled{color:var(--goa-icon-button-default-disabled-color);fill:var(--goa-icon-button-default-disabled-color)}.dark.svelte-1tqx19v{color:var(--goa-icon-button-dark-color);fill:var(--goa-icon-button-dark-color)}.dark.svelte-1tqx19v:hover,.dark.svelte-1tqx19v:focus,.dark.svelte-1tqx19v:active{background-color:var(--goa-icon-button-dark-hover-color-bg)}.dark.svelte-1tqx19v:disabled{color:var(--goa-icon-button-dark-disabled-color-bg);fill:var(--goa-icon-button-dark-disabled-color-bg)}.nocolor.svelte-1tqx19v{color:var(--goa-icon-button-dark-color);fill:var(--goa-icon-button-dark-color)}.nocolor.svelte-1tqx19v:hover,.nocolor.svelte-1tqx19v:focus,.nocolor.svelte-1tqx19v:active{background-color:var(--goa-icon-button-dark-hover-color-bg)}.destructive.svelte-1tqx19v{color:var(--goa-icon-button-destructive-color);fill:var(--goa-icon-button-destructive-color)}.destructive.svelte-1tqx19v:hover,.destructive.svelte-1tqx19v:focus,.destructive.svelte-1tqx19v:active{background-color:var(--goa-icon-button-destructive-hover-color-bg)}.destructive.svelte-1tqx19v:disabled{color:var(--goa-icon-button-destructive-disabled-color);fill:var(--goa-icon-button-destructive-disabled-color)}.light.svelte-1tqx19v{color:var(--goa-icon-button-light-color);fill:var(--goa-icon-button-light-color)}.light.svelte-1tqx19v:hover,.light.svelte-1tqx19v:focus,.light.svelte-1tqx19v:active{background-color:var(--goa-icon-button-light-hover-color-bg)}.light.svelte-1tqx19v:disabled{color:var(--goa-icon-button-light-disabled-color);fill:var(--goa-icon-button-light-disabled-color)}.inverted.svelte-1tqx19v{color:var(--goa-icon-button-light-color);fill:var(--goa-icon-button-light-color)}.inverted.svelte-1tqx19v:hover,.inverted.svelte-1tqx19v:focus,.inverted.svelte-1tqx19v:active{background-color:var(--goa-icon-button-light-hover-color-bg)}`);
}
function g1(t) {
  let e, i, n, l, o, r;
  return {
    c() {
      e = C("button"), i = C("goa-icon"), p(
        i,
        "title",
        /*title*/
        t[3]
      ), p(
        i,
        "type",
        /*icon*/
        t[0]
      ), p(
        i,
        "size",
        /*size*/
        t[1]
      ), p(
        i,
        "theme",
        /*theme*/
        t[2]
      ), f(e, "class", n = Ee(`goa-icon-button goa-icon-button--${/*size*/
      t[1]} ${/*css*/
      t[11]}`) + " svelte-1tqx19v"), f(e, "style", l = be(
        /*mt*/
        t[6],
        /*mr*/
        t[7],
        /*mb*/
        t[8],
        /*ml*/
        t[9]
      )), f(
        e,
        "title",
        /*title*/
        t[3]
      ), e.disabled = /*isDisabled*/
      t[10], f(
        e,
        "data-testid",
        /*testid*/
        t[4]
      ), f(
        e,
        "aria-label",
        /*arialabel*/
        t[5]
      );
    },
    m(a, s) {
      D(a, e, s), _(e, i), o || (r = te(e, "click", h1), o = !0);
    },
    p(a, [s]) {
      s & /*title*/
      8 && p(
        i,
        "title",
        /*title*/
        a[3]
      ), s & /*icon*/
      1 && p(
        i,
        "type",
        /*icon*/
        a[0]
      ), s & /*size*/
      2 && p(
        i,
        "size",
        /*size*/
        a[1]
      ), s & /*theme*/
      4 && p(
        i,
        "theme",
        /*theme*/
        a[2]
      ), s & /*size, css*/
      2050 && n !== (n = Ee(`goa-icon-button goa-icon-button--${/*size*/
      a[1]} ${/*css*/
      a[11]}`) + " svelte-1tqx19v") && f(e, "class", n), s & /*mt, mr, mb, ml*/
      960 && l !== (l = be(
        /*mt*/
        a[6],
        /*mr*/
        a[7],
        /*mb*/
        a[8],
        /*ml*/
        a[9]
      )) && f(e, "style", l), s & /*title*/
      8 && f(
        e,
        "title",
        /*title*/
        a[3]
      ), s & /*isDisabled*/
      1024 && (e.disabled = /*isDisabled*/
      a[10]), s & /*testid*/
      16 && f(
        e,
        "data-testid",
        /*testid*/
        a[4]
      ), s & /*arialabel*/
      32 && f(
        e,
        "aria-label",
        /*arialabel*/
        a[5]
      );
    },
    i: ve,
    o: ve,
    d(a) {
      a && P(e), o = !1, r();
    }
  };
}
function h1(t) {
  var e;
  (e = t.target) == null || e.dispatchEvent(new CustomEvent("_click", { composed: !0, detail: { event: t } }));
}
function m1(t, e, i) {
  let n, l, o;
  const [r, a] = Me("Icon Button Variant", ["color", "nocolor", "light", "dark", "destructive"], !0);
  let { icon: s } = e, { size: d = "medium" } = e, { theme: u = "outline" } = e, { variant: c = "color" } = e, { title: g = "" } = e, { testid: h = "" } = e, { disabled: m = "false" } = e, { inverted: v = "false" } = e, { arialabel: b = "" } = e, { mt: w = null } = e, { mr: y = null } = e, { mb: j = null } = e, { ml: E = null } = e;
  return ke(() => {
    a(c), c == "nocolor" && console.warn("goa-icon-button nocolor variant is deprecated. Instead use dark."), o && console.warn("goa-icon-button inverted is deprecated. Instead use light variant.");
  }), t.$$set = (M) => {
    "icon" in M && i(0, s = M.icon), "size" in M && i(1, d = M.size), "theme" in M && i(2, u = M.theme), "variant" in M && i(12, c = M.variant), "title" in M && i(3, g = M.title), "testid" in M && i(4, h = M.testid), "disabled" in M && i(13, m = M.disabled), "inverted" in M && i(14, v = M.inverted), "arialabel" in M && i(5, b = M.arialabel), "mt" in M && i(6, w = M.mt), "mr" in M && i(7, y = M.mr), "mb" in M && i(8, j = M.mb), "ml" in M && i(9, E = M.ml);
  }, t.$$.update = () => {
    t.$$.dirty & /*inverted*/
    16384 && i(15, o = Ce(v)), t.$$.dirty & /*variant, isInverted*/
    36864 && i(11, n = `${c} ${o ? "inverted" : ""}`), t.$$.dirty & /*disabled*/
    8192 && i(10, l = Ce(m));
  }, [
    s,
    d,
    u,
    g,
    h,
    b,
    w,
    y,
    j,
    E,
    l,
    n,
    c,
    m,
    v,
    o
  ];
}
class v1 extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      m1,
      g1,
      ce,
      {
        icon: 0,
        size: 1,
        theme: 2,
        variant: 12,
        title: 3,
        testid: 4,
        disabled: 13,
        inverted: 14,
        arialabel: 5,
        mt: 6,
        mr: 7,
        mb: 8,
        ml: 9
      },
      f1
    );
  }
  get icon() {
    return this.$$.ctx[0];
  }
  set icon(e) {
    this.$$set({ icon: e }), k();
  }
  get size() {
    return this.$$.ctx[1];
  }
  set size(e) {
    this.$$set({ size: e }), k();
  }
  get theme() {
    return this.$$.ctx[2];
  }
  set theme(e) {
    this.$$set({ theme: e }), k();
  }
  get variant() {
    return this.$$.ctx[12];
  }
  set variant(e) {
    this.$$set({ variant: e }), k();
  }
  get title() {
    return this.$$.ctx[3];
  }
  set title(e) {
    this.$$set({ title: e }), k();
  }
  get testid() {
    return this.$$.ctx[4];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get disabled() {
    return this.$$.ctx[13];
  }
  set disabled(e) {
    this.$$set({ disabled: e }), k();
  }
  get inverted() {
    return this.$$.ctx[14];
  }
  set inverted(e) {
    this.$$set({ inverted: e }), k();
  }
  get arialabel() {
    return this.$$.ctx[5];
  }
  set arialabel(e) {
    this.$$set({ arialabel: e }), k();
  }
  get mt() {
    return this.$$.ctx[6];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[7];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[8];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[9];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-icon-button", he(v1, { icon: {}, size: {}, theme: {}, variant: {}, title: {}, testid: {}, disabled: {}, inverted: {}, arialabel: {}, mt: {}, mr: {}, mb: {}, ml: {} }, [], [], !0));
function b1(t) {
  _e(t, "svelte-i0ynra", ":host{display:inline-flex;align-items:center}ion-icon.svelte-i0ynra.svelte-i0ynra{pointer-events:none;width:100%;height:100%}.goa-icon.svelte-i0ynra.svelte-i0ynra{fill:var(--fill-color);color:var(--fill-color);opacity:var(--opacity);display:inline-flex;align-items:center;justify-content:center}.goa-icon--1.svelte-i0ynra.svelte-i0ynra{width:var(--goa-icon-size-1);height:var(--goa-icon-size-1)}.goa-icon--2.svelte-i0ynra.svelte-i0ynra{width:var(--goa-icon-size-2);height:var(--goa-icon-size-2)}.goa-icon--3.svelte-i0ynra.svelte-i0ynra{width:var(--goa-icon-size-3);height:var(--goa-icon-size-3)}.goa-icon--4.svelte-i0ynra.svelte-i0ynra{width:var(--goa-icon-size-4);height:var(--goa-icon-size-4)}.goa-icon--5.svelte-i0ynra.svelte-i0ynra{width:var(--goa-icon-size-5);height:var(--goa-icon-size-5)}.goa-icon--6.svelte-i0ynra.svelte-i0ynra{width:var(--goa-icon-size-6);height:var(--goa-icon-size-6)}.goa-icon--2xsmall.svelte-i0ynra.svelte-i0ynra{width:var(--goa-icon-size-s);height:var(--goa-icon-size-s)}.goa-icon--xsmall.svelte-i0ynra.svelte-i0ynra{width:18px;height:18px}.goa-icon--small.svelte-i0ynra.svelte-i0ynra{width:var(--goa-icon-size-m);height:var(--goa-icon-size-m)}.goa-icon--medium.svelte-i0ynra.svelte-i0ynra{width:var(--goa-icon-size-l);height:var(--goa-icon-size-l)}.goa-icon--large.svelte-i0ynra.svelte-i0ynra{width:2rem;height:2rem}.goa-icon--xlarge.svelte-i0ynra.svelte-i0ynra{width:2.5rem;height:2.5rem}.goa-icon.svelte-i0ynra.svelte-i0ynra:has(.icon-override){height:-moz-fit-content;height:fit-content}.icon-override.svelte-i0ynra.svelte-i0ynra{display:flex;flex-direction:column;align-items:center}.inverted.svelte-i0ynra .svelte-i0ynra{color:var(--goa-color-greyscale-white);fill:var(--goa-color-greyscale-white)}");
}
function uo(t) {
  let e;
  function i(o, r) {
    return (
      /*type*/
      o[4] in /*_iconOverrides*/
      o[17] ? _1 : p1
    );
  }
  let n = i(t), l = n(t);
  return {
    c() {
      l.c(), e = Ne();
    },
    m(o, r) {
      l.m(o, r), D(o, e, r);
    },
    p(o, r) {
      n === (n = i(o)) && l ? l.p(o, r) : (l.d(1), l = n(o), l && (l.c(), l.m(e.parentNode, e)));
    },
    d(o) {
      o && P(e), l.d(o);
    }
  };
}
function p1(t) {
  let e;
  return {
    c() {
      e = C("ion-icon"), p(
        e,
        "name",
        /*_iconName*/
        t[14]
      ), p(e, "class", "svelte-i0ynra");
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*_iconName*/
      16384 && p(
        e,
        "name",
        /*_iconName*/
        i[14]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function _1(t) {
  let e, i = (
    /*_iconOverrides*/
    (t[17][`${/*type*/
    t[4]}-${/*theme*/
    t[6]}`] || /*_iconOverrides*/
    t[17][
      /*type*/
      t[4]
    ]) + ""
  );
  return {
    c() {
      e = C("div"), f(e, "class", "icon-override svelte-i0ynra");
    },
    m(n, l) {
      D(n, e, l), e.innerHTML = i;
    },
    p(n, l) {
      l & /*type, theme*/
      80 && i !== (i = /*_iconOverrides*/
      (n[17][`${/*type*/
      n[4]}-${/*theme*/
      n[6]}`] || /*_iconOverrides*/
      n[17][
        /*type*/
        n[4]
      ]) + "") && (e.innerHTML = i);
    },
    d(n) {
      n && P(e);
    }
  };
}
function w1(t) {
  let e, i, n, l = (
    /*type*/
    t[4] && uo(t)
  );
  return {
    c() {
      e = C("div"), l && l.c(), f(
        e,
        "role",
        /*role*/
        t[13]
      ), f(
        e,
        "aria-label",
        /*arialabel*/
        t[11]
      ), f(
        e,
        "aria-controls",
        /*ariacontrols*/
        t[12]
      ), f(
        e,
        "aria-expanded",
        /*_ariaExpanded*/
        t[15]
      ), f(e, "class", i = Ee(`goa-icon goa-icon--${/*size*/
      t[5]}`) + " svelte-i0ynra"), f(
        e,
        "data-testid",
        /*testid*/
        t[10]
      ), f(
        e,
        "title",
        /*title*/
        t[9]
      ), f(e, "style", n = `
    ${be(
        /*mt*/
        t[0],
        /*mr*/
        t[1],
        /*mb*/
        t[2],
        /*ml*/
        t[3]
      )}
    ${ze(
        "--fill-color",
        /*fillcolor*/
        t[7]
      )};
    ${ze(
        "--opacity",
        /*opacity*/
        t[8]
      )};
  `), G(
        e,
        "inverted",
        /*_isInverted*/
        t[16]
      );
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null);
    },
    p(o, [r]) {
      /*type*/
      o[4] ? l ? l.p(o, r) : (l = uo(o), l.c(), l.m(e, null)) : l && (l.d(1), l = null), r & /*role*/
      8192 && f(
        e,
        "role",
        /*role*/
        o[13]
      ), r & /*arialabel*/
      2048 && f(
        e,
        "aria-label",
        /*arialabel*/
        o[11]
      ), r & /*ariacontrols*/
      4096 && f(
        e,
        "aria-controls",
        /*ariacontrols*/
        o[12]
      ), r & /*_ariaExpanded*/
      32768 && f(
        e,
        "aria-expanded",
        /*_ariaExpanded*/
        o[15]
      ), r & /*size*/
      32 && i !== (i = Ee(`goa-icon goa-icon--${/*size*/
      o[5]}`) + " svelte-i0ynra") && f(e, "class", i), r & /*testid*/
      1024 && f(
        e,
        "data-testid",
        /*testid*/
        o[10]
      ), r & /*title*/
      512 && f(
        e,
        "title",
        /*title*/
        o[9]
      ), r & /*mt, mr, mb, ml, fillcolor, opacity*/
      399 && n !== (n = `
    ${be(
        /*mt*/
        o[0],
        /*mr*/
        o[1],
        /*mb*/
        o[2],
        /*ml*/
        o[3]
      )}
    ${ze(
        "--fill-color",
        /*fillcolor*/
        o[7]
      )};
    ${ze(
        "--opacity",
        /*opacity*/
        o[8]
      )};
  `) && f(e, "style", n), r & /*size, _isInverted*/
      65568 && G(
        e,
        "inverted",
        /*_isInverted*/
        o[16]
      );
    },
    i: ve,
    o: ve,
    d(o) {
      o && P(e), l && l.d();
    }
  };
}
function k1(t, e) {
  return t ? e === "filled" || t.indexOf("logo") === 0 ? t : `${t}-${e}` : "";
}
function y1(t, e, i) {
  let n, l, o, { mt: r = null } = e, { mr: a = null } = e, { mb: s = null } = e, { ml: d = null } = e, { type: u } = e, { size: c = "medium" } = e, { theme: g = "outline" } = e, { inverted: h = "false" } = e, { fillcolor: m = "" } = e, { opacity: v = 1 } = e, { title: b = "" } = e, { testid: w = "" } = e, { arialabel: y = "" } = e, { ariacontrols: j = "" } = e, { ariaexpanded: E = "" } = e, { role: M = "img" } = e;
  const L = {
    pencil: '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4.86885 18.6573C4.86885 18.9334 5.0927 19.1573 5.36885 19.1573H5.90136C6.03391 19.1573 6.16103 19.1046 6.25479 19.0109L15.6988 9.57357L14.4593 8.33405L5.01542 17.7713C4.92157 17.865 4.86885 17.9923 4.86885 18.1249V18.6573ZM19.1614 8.47035L15.5555 4.86447L16.7387 3.68129C17.058 3.36202 17.4571 3.20708 17.936 3.21647C18.4149 3.22586 18.814 3.39019 19.1333 3.70946L20.3446 4.92081C20.6639 5.24008 20.8235 5.63447 20.8235 6.10399C20.8235 6.5735 20.6639 6.9679 20.3446 7.28717L19.1614 8.47035ZM4.02372 20.8475C3.77957 20.8475 3.57768 20.7677 3.41804 20.608C3.25841 20.4484 3.17859 20.2465 3.17859 20.0024V17.5797C3.17859 17.467 3.19737 17.3637 3.23493 17.2698C3.27249 17.1759 3.33822 17.082 3.43213 16.9881L14.4874 5.93952L18.0933 9.5454L7.03801 20.594C6.9441 20.6879 6.8502 20.7536 6.7563 20.7912C6.6624 20.8287 6.5591 20.8475 6.44642 20.8475H4.02372Z" fill="currentcolor"/> </svg>',
    "pencil-filled": '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M19.1442 8.47956L15.5355 4.87088L16.7196 3.68678C17.0391 3.36726 17.4385 3.2122 17.9178 3.22159C18.3971 3.23099 18.7965 3.39545 19.116 3.71497L20.3283 4.92726C20.6478 5.24678 20.8076 5.64148 20.8076 6.11136C20.8076 6.58124 20.6478 6.97594 20.3283 7.29546L19.1442 8.47956ZM4.03951 20.8424C3.79517 20.8424 3.59312 20.7626 3.43337 20.6028C3.27361 20.443 3.19373 20.241 3.19373 19.9966V17.5721C3.19373 17.4593 3.21252 17.356 3.25011 17.262C3.2877 17.168 3.35349 17.074 3.44746 16.9801L14.4689 5.93435L18.0776 9.54303L7.05615 20.5887C6.96217 20.6827 6.8682 20.7485 6.77422 20.7861C6.68024 20.8236 6.57687 20.8424 6.4641 20.8424H4.03951Z" fill="currentcolor" /> </svg>',
    checkmark: '<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.20129 11.5368L15.9974 0.341265C16.3611 -0.0743717 16.9929 -0.116489 17.4085 0.247193C17.8241 0.610875 17.8663 1.24264 17.5026 1.65827L7.00258 13.6583C6.82032 13.8666 6.5599 13.99 6.28328 13.9992C6.00666 14.0084 5.7386 13.9026 5.54289 13.7069L1.04289 9.20688C0.652369 8.81635 0.652369 8.18319 1.04289 7.79266C1.43342 7.40214 2.06658 7.40214 2.45711 7.79266L6.20129 11.5368Z" fill="currentcolor"/> </svg>',
    remove: '<svg width="16" height="20" viewBox="0 0 16 1" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.5 -0.000244141C0.947715 -0.000244141 0.5 0.447471 0.5 0.999756C0.5 1.55204 0.947715 1.99976 1.5 1.99976H15C15.5523 1.99976 16 1.55204 16 0.999756C16 0.447471 15.5523 -0.000244141 15 -0.000244141H1.5Z" fill="currentcolor"/> </svg>',
    "goa-file": '<svg width="39" height="48" viewBox="0 0 39 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_1357_108691)"> <path d="M38.741 14C38.541 13.07 38.081 12.22 37.401 11.54L36.861 11L27.861 2L27.321 1.46C26.641 0.78 25.781 0.32 24.861 0.12C24.511 0.04 24.151 0 23.791 0H5.86096C3.10096 0 0.860962 2.24 0.860962 5V43C0.860962 45.76 3.10096 48 5.86096 48H33.861C36.621 48 38.861 45.76 38.861 43V15.07C38.861 14.71 38.811 14.35 38.741 14ZM35.041 12H29.871C28.221 12 26.871 10.65 26.871 9V3.83L35.041 12ZM36.871 43C36.871 44.65 35.521 46 33.871 46H5.87097C4.22097 46 2.87097 44.65 2.87097 43V5C2.87097 3.35 4.22097 2 5.87097 2H23.801C24.171 2 24.531 2.07 24.871 2.2V9C24.871 11.76 27.111 14 29.871 14H36.671C36.801 14.34 36.871 14.7 36.871 15.07V43Z" fill="currentcolor"/> </g> <defs> <clipPath id="clip0_1357_108691"><rect width="38" height="48" fill="white" transform="translate(0.861328)"/></clipPath></defs></svg>',
    "goa-text": '<svg width="39" height="48" viewBox="0 0 39 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M38.7953 14C38.5953 13.07 38.1353 12.22 37.4553 11.54L36.9153 11L27.9153 2L27.3753 1.46C26.6953 0.78 25.8353 0.32 24.9153 0.12C24.5653 0.04 24.2053 0 23.8453 0H5.91528C3.15528 0 0.915283 2.24 0.915283 5V43C0.915283 45.76 3.15528 48 5.91528 48H33.9153C36.6753 48 38.9153 45.76 38.9153 43V15.07C38.9153 14.71 38.8653 14.35 38.7953 14ZM35.0953 12H29.9253C28.2753 12 26.9253 10.65 26.9253 9V3.83L35.0953 12ZM36.9253 43C36.9253 44.65 35.5753 46 33.9253 46H5.91528C4.26528 46 2.91528 44.65 2.91528 43V5C2.91528 3.35 4.26528 2 5.91528 2H23.8453C24.2153 2 24.5753 2.07 24.9153 2.2V9C24.9153 11.76 27.1553 14 29.9153 14H36.7153C36.8453 14.34 36.9153 14.7 36.9153 15.07V43H36.9253Z" fill="currentcolor"/> <path d="M27.9153 34H11.9153C11.363 34 10.9153 34.4477 10.9153 35C10.9153 35.5523 11.363 36 11.9153 36H27.9153C28.4676 36 28.9153 35.5523 28.9153 35C28.9153 34.4477 28.4676 34 27.9153 34Z" fill="currentcolor"/> <path d="M27.9153 26H11.9153C11.363 26 10.9153 26.4477 10.9153 27C10.9153 27.5523 11.363 28 11.9153 28H27.9153C28.4676 28 28.9153 27.5523 28.9153 27C28.9153 26.4477 28.4676 26 27.9153 26Z" fill="currentcolor"/> </svg>',
    "goa-pdf": '<svg width="39" height="48" viewBox="0 0 39 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M37.8861 14C37.6861 13.07 37.2261 12.22 36.5461 11.54L36.0061 11L27.0061 2L26.4661 1.46C25.7861 0.78 24.9261 0.32 24.0061 0.12C23.6561 0.04 23.2961 0 22.9361 0H5.0061C2.2461 0 0.00610352 2.24 0.00610352 5V43C0.00610352 45.76 2.2461 48 5.0061 48H33.0061C35.7661 48 38.0061 45.76 38.0061 43V15.07C38.0061 14.71 37.9561 14.35 37.8861 14ZM34.1861 12H29.0161C27.3661 12 26.0161 10.65 26.0161 9V3.83L34.1861 12ZM36.0161 43C36.0161 44.65 34.6661 46 33.0161 46H5.0061C3.3561 46 2.0061 44.65 2.0061 43V5C2.0061 3.35 3.3561 2 5.0061 2H22.9361C23.3061 2 23.6661 2.07 24.0061 2.2V9C24.0061 11.76 26.2461 14 29.0061 14H35.8061C35.9361 14.34 36.0061 14.7 36.0061 15.07V43H36.0161Z" fill="currentcolor"/> <path d="M5.02611 27C5.02611 26.45 5.47611 26 6.02611 26H9.05611C11.1161 26 12.9261 27.06 12.9261 29.28C12.9261 31.5 11.2461 32.74 8.85611 32.74H7.25611V35.85C7.25611 36.47 6.75611 36.97 6.13611 36.97C5.51611 36.97 5.01611 36.47 5.01611 35.85V27.01L5.02611 27ZM7.26611 30.96H8.73611C9.91611 30.96 10.6561 30.53 10.6561 29.31C10.6561 28.22 9.90611 27.77 8.79611 27.77H7.25611V30.96H7.26611Z" fill="currentcolor"/> <path d="M15.0361 27C15.0361 26.45 15.4861 26 16.0361 26H18.8461C22.1761 26 24.0161 28.03 24.0161 31.25C24.0161 34.82 22.0961 36.96 18.7661 36.96H16.0361C15.4861 36.96 15.0361 36.51 15.0361 35.96V27ZM17.2961 35.2H18.7361C20.6861 35.2 21.6961 33.74 21.6961 31.28C21.6961 29.25 20.7861 27.79 18.7461 27.79H17.2861V35.2H17.2961Z" fill="currentcolor"/> <path d="M25.9761 27C25.9761 26.45 26.4261 26 26.9761 26H32.0861C32.5961 26 33.0061 26.41 33.0061 26.92C33.0061 27.43 32.5961 27.84 32.0861 27.84H28.1761V30.63H31.8161C32.3161 30.63 32.7161 31.03 32.7161 31.53C32.7161 32.03 32.3161 32.43 31.8161 32.43H28.1761V35.86C28.1761 36.47 27.6861 36.96 27.0761 36.96C26.4661 36.96 25.9761 36.47 25.9761 35.86V26.99V27Z" fill="currentcolor"/> </svg> ',
    "goa-doc": '<svg width="39" height="48" viewBox="0 0 39 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M38.6134 14C38.4134 13.07 37.9534 12.22 37.2734 11.54L36.7334 11L27.7334 2L27.1934 1.46C26.5134 0.78 25.6534 0.32 24.7334 0.12C24.3834 0.04 24.0234 0 23.6634 0H5.7334C2.9734 0 0.733398 2.24 0.733398 5V43C0.733398 45.76 2.9734 48 5.7334 48H33.7334C36.4934 48 38.7334 45.76 38.7334 43V15.07C38.7334 14.71 38.6834 14.35 38.6134 14ZM34.9134 12H29.7434C28.0934 12 26.7434 10.65 26.7434 9V3.83L34.9134 12ZM36.7434 43C36.7434 44.65 35.3934 46 33.7434 46H5.7334C4.0834 46 2.7334 44.65 2.7334 43V5C2.7334 3.35 4.0834 2 5.7334 2H23.6634C24.0334 2 24.3934 2.07 24.7334 2.2V9C24.7334 11.76 26.9734 14 29.7334 14H36.5334C36.6634 14.34 36.7334 14.7 36.7334 15.07V43H36.7434Z" fill="currentcolor"/> <path d="M13.7834 36.6406L10.9034 24.5806C10.6934 23.7206 11.3534 22.8906 12.2334 22.8906C12.8734 22.8906 13.4334 23.3406 13.5734 23.9706C14.4934 28.2306 15.3434 32.5006 15.6434 34.9706H15.6634C16.0934 32.6806 17.3834 27.7106 18.2434 24.0806C18.4134 23.3806 19.0334 22.8906 19.7534 22.8906C20.4634 22.8906 21.0834 23.3706 21.2534 24.0606C22.0734 27.3606 23.3634 32.5806 23.7534 34.8406H23.7734C24.1834 32.0406 25.4534 26.8306 26.1134 23.8706C26.2434 23.3006 26.7434 22.8906 27.3334 22.8906C28.1534 22.8906 28.7434 23.6606 28.5434 24.4506L25.4134 36.6706C25.2134 37.4606 24.5034 38.0106 23.6934 38.0106C22.8634 38.0106 22.1534 37.4506 21.9634 36.6406C21.1734 33.2806 20.0434 28.8506 19.6434 26.6306H19.6234C19.1834 28.9106 18.0234 33.4506 17.2234 36.6606C17.0234 37.4506 16.3134 38.0006 15.5034 38.0006C14.6834 38.0006 13.9634 37.4406 13.7734 36.6406H13.7834Z" fill="currentcolor"/> </svg> ',
    "goa-ppt": '<svg width="39" height="48" viewBox="0 0 39 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M38.2498 14C38.0498 13.07 37.5898 12.22 36.9098 11.54L36.3698 11L27.3698 2L26.8298 1.46C26.1497 0.78 25.2898 0.32 24.3698 0.12C24.0198 0.04 23.6598 0 23.2998 0H5.36975C2.60975 0 0.369751 2.24 0.369751 5V43C0.369751 45.76 2.60975 48 5.36975 48H33.3698C36.1297 48 38.3698 45.76 38.3698 43V15.07C38.3698 14.71 38.3198 14.35 38.2498 14ZM34.5498 12H29.3798C27.7298 12 26.3798 10.65 26.3798 9V3.83L34.5498 12ZM36.3797 43C36.3797 44.65 35.0298 46 33.3797 46H5.36975C3.71975 46 2.36975 44.65 2.36975 43V5C2.36975 3.35 3.71975 2 5.36975 2H23.2998C23.6698 2 24.0298 2.07 24.3698 2.2V9C24.3698 11.76 26.6098 14 29.3698 14H36.1698C36.2998 14.34 36.3698 14.7 36.3698 15.07V43H36.3797Z" fill="currentcolor"/> <path d="M14.0798 24.8906C14.0798 23.7906 14.9798 22.8906 16.0798 22.8906H19.4698C22.3098 22.8906 24.6598 24.3406 24.6598 27.2906C24.6598 30.2406 22.4198 31.9306 19.2298 31.9306H16.7698V36.6606C16.7698 37.4006 16.1698 38.0006 15.4298 38.0006C14.6898 38.0006 14.0898 37.4006 14.0898 36.6606V24.8906H14.0798ZM16.7598 29.8206H19.0698C20.8098 29.8206 21.9498 29.1806 21.9498 27.3606C21.9498 25.7306 20.7798 25.0306 19.1298 25.0306H16.7498V29.8306L16.7598 29.8206Z" fill="currentcolor"/> </svg> ',
    "goa-xls": '<svg width="39" height="48" viewBox="0 0 39 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M38.3407 14C38.1407 13.07 37.6807 12.22 37.0007 11.54L36.4607 11L27.4607 2L26.9207 1.46C26.2407 0.78 25.3807 0.32 24.4607 0.12C24.1107 0.04 23.7507 0 23.3907 0H5.46069C2.70069 0 0.460693 2.24 0.460693 5V43C0.460693 45.76 2.70069 48 5.46069 48H33.4607C36.2207 48 38.4607 45.76 38.4607 43V15.07C38.4607 14.71 38.4107 14.35 38.3407 14ZM34.6407 12H29.4707C27.8207 12 26.4707 10.65 26.4707 9V3.83L34.6407 12ZM36.4707 43C36.4707 44.65 35.1207 46 33.4707 46H5.46069C3.81069 46 2.46069 44.65 2.46069 43V5C2.46069 3.35 3.81069 2 5.46069 2H23.3907C23.7607 2 24.1207 2.07 24.4607 2.2V9C24.4607 11.76 26.7007 14 29.4607 14H36.2607C36.3907 14.34 36.4607 14.7 36.4607 15.07V43H36.4707Z" fill="currentcolor"/> <path d="M23.4107 38.0006C22.9407 38.0006 22.5107 37.7506 22.2707 37.3406L19.3907 32.2806H19.3707L16.4607 37.3906C16.2507 37.7706 15.8407 38.0006 15.4107 38.0006C14.4707 38.0006 13.8907 36.9706 14.3807 36.1606L17.9207 30.3906L14.5807 24.8606C14.0607 23.9906 14.6807 22.8906 15.6907 22.8906C16.1607 22.8906 16.5907 23.1406 16.8207 23.5406L19.5307 28.2806L19.5507 28.2606L22.3507 23.4806C22.5607 23.1206 22.9507 22.8906 23.3807 22.8906C24.3107 22.8906 24.8807 23.9106 24.3907 24.7006L21.0307 30.1206L24.5407 36.0206C25.0607 36.8906 24.4307 38.0006 23.4207 38.0006H23.4107Z" fill="currentcolor"/> </svg> ',
    "goa-zip": '<svg width="39" height="48" viewBox="0 0 39 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M38.7043 14C38.5043 13.07 38.0443 12.22 37.3643 11.54L36.8243 11L27.8243 2L27.2843 1.46C26.6043 0.78 25.7443 0.32 24.8243 0.12C24.4743 0.04 24.1143 0 23.7543 0H5.82434C3.06434 0 0.824341 2.24 0.824341 5V43C0.824341 45.76 3.06434 48 5.82434 48H33.8243C36.5843 48 38.8243 45.76 38.8243 43V15.07C38.8243 14.71 38.7743 14.35 38.7043 14ZM35.0043 12H29.8343C28.1843 12 26.8343 10.65 26.8343 9V3.83L35.0043 12ZM36.8343 43C36.8343 44.65 35.4843 46 33.8343 46H5.82434C4.17434 46 2.82434 44.65 2.82434 43V5C2.82434 3.35 4.17434 2 5.82434 2H23.7543C24.1243 2 24.4843 2.07 24.8243 2.2V9C24.8243 11.76 27.0643 14 29.8243 14H36.6243C36.7543 14.34 36.8243 14.7 36.8243 15.07V43H36.8343Z" fill="currentcolor"/> <path d="M14.8243 20H12.8243V22H14.8243V20Z" fill="currentcolor"/> <path d="M12.8243 18H10.8243V20H12.8243V18Z" fill="currentcolor"/> <path d="M14.8243 16H12.8243V18H14.8243V16Z" fill="currentcolor"/> <path d="M12.8243 14H10.8243V16H12.8243V14Z" fill="currentcolor"/> <path d="M14.8243 12H12.8243V14H14.8243V12Z" fill="currentcolor"/> <path d="M12.8243 10H10.8243V12H12.8243V10Z" fill="currentcolor"/> <path d="M14.8243 8H12.8243V10H14.8243V8Z" fill="currentcolor"/> <path d="M12.8243 6H10.8243V8H12.8243V6Z" fill="currentcolor"/> <path d="M14.8243 4H12.8243V6H14.8243V4Z" fill="currentcolor"/> <path d="M12.8243 2H10.8243V4H12.8243V2Z" fill="currentcolor"/> <path d="M17.7244 32.14L15.4744 23.69C15.3644 23.29 15.0044 23 14.5844 23H11.0644C10.6444 23 10.2744 23.28 10.1744 23.69L7.92435 32.14C7.30435 35.17 9.62435 37.97 12.8244 38C16.0144 37.98 18.3444 35.18 17.7244 32.14ZM15.1944 34.89C14.6244 35.58 13.7644 35.98 12.8244 35.99C11.8844 35.98 11.0244 35.58 10.4544 34.89C9.92435 34.24 9.71435 33.42 9.87435 32.59L11.8944 25H13.7544L15.7744 32.59C15.9344 33.42 15.7244 34.24 15.1944 34.89Z" fill="currentcolor"/> <path d="M13.8243 32H11.8243C11.2721 32 10.8243 32.4477 10.8243 33C10.8243 33.5523 11.2721 34 11.8243 34H13.8243C14.3766 34 14.8243 33.5523 14.8243 33C14.8243 32.4477 14.3766 32 13.8243 32Z" fill="currentcolor"/> </svg> ',
    "goa-video": '<svg width="39" height="48" viewBox="0 0 39 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M37.977 14C37.777 13.07 37.317 12.22 36.637 11.54L36.097 11L27.097 2L26.557 1.46C25.877 0.78 25.017 0.32 24.097 0.12C23.747 0.04 23.387 0 23.027 0H5.09705C2.33705 0 0.0970459 2.24 0.0970459 5V43C0.0970459 45.76 2.33705 48 5.09705 48H33.097C35.857 48 38.097 45.76 38.097 43V15.07C38.097 14.71 38.047 14.35 37.977 14ZM34.277 12H29.107C27.457 12 26.107 10.65 26.107 9V3.83L34.277 12ZM36.107 43C36.107 44.65 34.757 46 33.107 46H5.09705C3.44705 46 2.09705 44.65 2.09705 43V5C2.09705 3.35 3.44705 2 5.09705 2H23.027C23.397 2 23.757 2.07 24.097 2.2V9C24.097 11.76 26.337 14 29.097 14H35.897C36.027 14.34 36.097 14.7 36.097 15.07V43H36.107Z" fill="currentcolor"/> <path d="M22.097 26.0002V29.0102C22.097 29.7802 22.927 30.2602 23.587 29.8802L25.077 29.0302L28.087 27.3202V34.6902L25.077 32.9802L23.587 32.1302C22.917 31.7502 22.097 32.2302 22.097 33.0002V35.9902H10.097V25.9902H22.097M22.097 23.9902H10.097C8.99705 23.9902 8.09705 24.8902 8.09705 25.9902V35.9902C8.09705 37.0902 8.99705 37.9902 10.097 37.9902H22.097C23.197 37.9902 24.097 37.0902 24.097 35.9902V34.7202L27.107 36.4302C27.427 36.6102 27.767 36.6902 28.087 36.6902C29.137 36.6902 30.087 35.8502 30.087 34.6902V27.3202C30.087 26.1502 29.127 25.3202 28.087 25.3202C27.757 25.3202 27.417 25.4002 27.107 25.5802L24.097 27.2902V25.9902C24.097 24.8902 23.197 23.9902 22.097 23.9902Z" fill="currentcolor"/> </svg> ',
    "goa-audio": '<svg width="39" height="49" viewBox="0 0 39 49" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M38.0679 14.2305C37.8679 13.3005 37.4079 12.4505 36.7279 11.7705L36.1879 11.2305L27.1879 2.23047L26.6479 1.69047C25.9679 1.01047 25.1079 0.550469 24.1879 0.350469C23.8379 0.270469 23.4779 0.230469 23.1179 0.230469H5.18793C2.42793 0.230469 0.187927 2.47047 0.187927 5.23047V43.2305C0.187927 45.9905 2.42793 48.2305 5.18793 48.2305H33.1879C35.9479 48.2305 38.1879 45.9905 38.1879 43.2305V15.3005C38.1879 14.9405 38.1379 14.5805 38.0679 14.2305ZM34.3679 12.2305H29.1979C27.5479 12.2305 26.1979 10.8805 26.1979 9.23047V4.06047L34.3679 12.2305ZM36.1979 43.2305C36.1979 44.8805 34.8479 46.2305 33.1979 46.2305H5.19792C3.54792 46.2305 2.19792 44.8805 2.19792 43.2305V5.23047C2.19792 3.58047 3.54792 2.23047 5.19792 2.23047H23.1279C23.4979 2.23047 23.8579 2.30047 24.1979 2.43047V9.23047C24.1979 11.9905 26.4379 14.2305 29.1979 14.2305H35.9979C36.1279 14.5705 36.1979 14.9305 36.1979 15.3005V43.2305Z" fill="currentcolor"/> <path d="M20.1879 25.1189V37.3489L16.3479 34.6089L15.8279 34.2389H10.1879V28.2389H15.8279L16.3479 27.8689L20.1879 25.1289M20.1879 23.1289C19.7979 23.1289 19.3979 23.2489 19.0279 23.5089L15.1879 26.2489H10.1879C9.08793 26.2489 8.18793 27.1489 8.18793 28.2489V34.2489C8.18793 35.3489 9.08793 36.2489 10.1879 36.2489H15.1879L19.0279 38.9889C19.3879 39.2489 19.7879 39.3689 20.1879 39.3689C21.2279 39.3689 22.1979 38.5489 22.1979 37.3689V25.1389C22.1979 23.9589 21.2279 23.1389 20.1879 23.1389V23.1289Z" fill="currentcolor"/> <path d="M26.1381 23.707C26.6381 24.037 27.1081 24.417 27.5481 24.857C27.9881 25.297 28.3681 25.767 28.6981 26.267C29.0281 26.767 29.2981 27.287 29.5181 27.837C29.7381 28.387 29.8981 28.937 30.0081 29.507C30.1181 30.077 30.1681 30.647 30.1681 31.227C30.1681 31.807 30.1181 32.377 30.0081 32.947C29.8981 33.517 29.7381 34.077 29.5181 34.617C29.2981 35.157 29.0281 35.687 28.6981 36.187C28.3681 36.687 27.9881 37.157 27.5481 37.597C27.1081 38.037 26.6381 38.417 26.1381 38.747" stroke="currentcolor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/> </svg> ',
    "goa-image": '<svg width="39" height="49" viewBox="0 0 39 49" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M38.1588 14.2305C37.9588 13.3005 37.4988 12.4505 36.8188 11.7705L36.2788 11.2305L27.2788 2.23047L26.7388 1.69047C26.0588 1.01047 25.1988 0.550469 24.2788 0.350469C23.9288 0.270469 23.5688 0.230469 23.2088 0.230469H5.27881C2.51881 0.230469 0.278809 2.47047 0.278809 5.23047V43.2305C0.278809 45.9905 2.51881 48.2305 5.27881 48.2305H33.2788C36.0388 48.2305 38.2788 45.9905 38.2788 43.2305V15.3005C38.2788 14.9405 38.2288 14.5805 38.1588 14.2305ZM34.4588 12.2305H29.2888C27.6388 12.2305 26.2888 10.8805 26.2888 9.23047V4.06047L34.4588 12.2305ZM36.2888 43.2305C36.2888 44.8805 34.9388 46.2305 33.2888 46.2305H5.2888C3.6388 46.2305 2.2888 44.8805 2.2888 43.2305V5.23047C2.2888 3.58047 3.6388 2.23047 5.2888 2.23047H23.2188C23.5888 2.23047 23.9488 2.30047 24.2888 2.43047V9.23047C24.2888 11.9905 26.5288 14.2305 29.2888 14.2305H36.0888C36.2188 14.5705 36.2888 14.9305 36.2888 15.3005V43.2305Z" fill="currentcolor"/> <path d="M20.9985 28.2305C21.3585 28.2305 21.6485 28.4405 21.7885 28.7305L27.1085 36.7305C27.3185 37.0205 27.3185 37.4405 27.1785 37.7305C27.0385 38.0905 26.6785 38.2305 26.3185 38.2305H12.2385C11.8785 38.2305 11.5885 38.0905 11.3785 37.7305C11.2385 37.4405 11.2385 37.0205 11.4485 36.7305L14.8285 31.7305C14.9685 31.4405 15.3285 31.2305 15.6185 31.2305C15.9785 31.2305 16.2685 31.4405 16.4785 31.7305L17.3385 32.9405L20.1385 28.7305C20.3585 28.4405 20.6385 28.2305 20.9985 28.2305ZM20.9985 26.2305C20.0485 26.2305 19.1685 26.6905 18.5385 27.5305L18.4985 27.5805L18.4685 27.6305L17.1185 29.6605C16.6585 29.3805 16.1485 29.2405 15.6085 29.2405C14.6085 29.2405 13.6185 29.8205 13.1085 30.6905L9.79851 35.5905C9.17851 36.4505 9.08851 37.6705 9.57851 38.6305L9.60851 38.7005L9.6485 38.7705C10.2085 39.7005 11.1485 40.2405 12.2285 40.2405H26.3085C27.5185 40.2405 28.5385 39.6005 28.9985 38.5605C29.4385 37.6105 29.3385 36.4405 28.7485 35.6005L23.5085 27.7105C22.9885 26.8005 22.0485 26.2405 21.0085 26.2405L20.9985 26.2305Z" fill="currentcolor"/> <path d="M12.7788 23.2305C13.6088 23.2305 14.2788 23.9005 14.2788 24.7305C14.2788 25.5605 13.6088 26.2305 12.7788 26.2305C11.9488 26.2305 11.2788 25.5605 11.2788 24.7305C11.2788 23.9005 11.9488 23.2305 12.7788 23.2305ZM12.7788 21.2305C10.8488 21.2305 9.27881 22.8005 9.27881 24.7305C9.27881 26.6605 10.8488 28.2305 12.7788 28.2305C14.7088 28.2305 16.2788 26.6605 16.2788 24.7305C16.2788 22.8005 14.7088 21.2305 12.7788 21.2305Z" fill="currentcolor"/> </svg> '
  };
  return t.$$set = (z) => {
    "mt" in z && i(0, r = z.mt), "mr" in z && i(1, a = z.mr), "mb" in z && i(2, s = z.mb), "ml" in z && i(3, d = z.ml), "type" in z && i(4, u = z.type), "size" in z && i(5, c = z.size), "theme" in z && i(6, g = z.theme), "inverted" in z && i(18, h = z.inverted), "fillcolor" in z && i(7, m = z.fillcolor), "opacity" in z && i(8, v = z.opacity), "title" in z && i(9, b = z.title), "testid" in z && i(10, w = z.testid), "arialabel" in z && i(11, y = z.arialabel), "ariacontrols" in z && i(12, j = z.ariacontrols), "ariaexpanded" in z && i(19, E = z.ariaexpanded), "role" in z && i(13, M = z.role);
  }, t.$$.update = () => {
    t.$$.dirty & /*inverted*/
    262144 && i(16, n = Ce(h)), t.$$.dirty & /*ariaexpanded*/
    524288 && i(15, l = Ce(E)), t.$$.dirty & /*type, theme*/
    80 && i(14, o = k1(u, g));
  }, [
    r,
    a,
    s,
    d,
    u,
    c,
    g,
    m,
    v,
    b,
    w,
    y,
    j,
    M,
    o,
    l,
    n,
    L,
    h,
    E
  ];
}
class C1 extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      y1,
      w1,
      ce,
      {
        mt: 0,
        mr: 1,
        mb: 2,
        ml: 3,
        type: 4,
        size: 5,
        theme: 6,
        inverted: 18,
        fillcolor: 7,
        opacity: 8,
        title: 9,
        testid: 10,
        arialabel: 11,
        ariacontrols: 12,
        ariaexpanded: 19,
        role: 13
      },
      b1
    );
  }
  get mt() {
    return this.$$.ctx[0];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[1];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[2];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[3];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get type() {
    return this.$$.ctx[4];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get size() {
    return this.$$.ctx[5];
  }
  set size(e) {
    this.$$set({ size: e }), k();
  }
  get theme() {
    return this.$$.ctx[6];
  }
  set theme(e) {
    this.$$set({ theme: e }), k();
  }
  get inverted() {
    return this.$$.ctx[18];
  }
  set inverted(e) {
    this.$$set({ inverted: e }), k();
  }
  get fillcolor() {
    return this.$$.ctx[7];
  }
  set fillcolor(e) {
    this.$$set({ fillcolor: e }), k();
  }
  get opacity() {
    return this.$$.ctx[8];
  }
  set opacity(e) {
    this.$$set({ opacity: e }), k();
  }
  get title() {
    return this.$$.ctx[9];
  }
  set title(e) {
    this.$$set({ title: e }), k();
  }
  get testid() {
    return this.$$.ctx[10];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get arialabel() {
    return this.$$.ctx[11];
  }
  set arialabel(e) {
    this.$$set({ arialabel: e }), k();
  }
  get ariacontrols() {
    return this.$$.ctx[12];
  }
  set ariacontrols(e) {
    this.$$set({ ariacontrols: e }), k();
  }
  get ariaexpanded() {
    return this.$$.ctx[19];
  }
  set ariaexpanded(e) {
    this.$$set({ ariaexpanded: e }), k();
  }
  get role() {
    return this.$$.ctx[13];
  }
  set role(e) {
    this.$$set({ role: e }), k();
  }
}
customElements.define("goa-icon", he(C1, { mt: {}, mr: {}, mb: {}, ml: {}, type: {}, size: {}, theme: {}, inverted: {}, fillcolor: {}, opacity: {}, title: {}, testid: {}, arialabel: {}, ariacontrols: {}, ariaexpanded: {}, role: {} }, [], [], !0));
function z1(t) {
  _e(t, "svelte-4gkin5", `:host{box-sizing:border-box}.container.svelte-4gkin5.svelte-4gkin5{position:relative;width:auto;display:inline-block;max-width:100%}@media not (max-width: 623px){.container.svelte-4gkin5.svelte-4gkin5{width:auto}}.goa-input.svelte-4gkin5.svelte-4gkin5,.goa-input.svelte-4gkin5 .svelte-4gkin5{line-height:normal}.goa-input.svelte-4gkin5.svelte-4gkin5{outline:none;transition:var(--goa-text-input-transition);background-clip:padding-box;display:inline-flex;align-items:stretch;min-width:100%;background-color:var(--goa-text-input-color-bg);box-shadow:var(--goa-text-input-border);border-radius:var(--goa-text-input-border-radius);vertical-align:middle;max-width:100%}.goa-input.svelte-4gkin5.svelte-4gkin5:not(.error):not(.leading-content):not(.trailing-content):hover:not(
      :has(input:focus-visible)
    ){box-shadow:var(--goa-text-input-border-hover)}.goa-input.svelte-4gkin5.svelte-4gkin5:not(.error):has(input:focus-visible){box-shadow:var(--goa-text-input-border),
      var(--goa-text-input-border-focus)}.goa-input.error.svelte-4gkin5 input.input--goa.svelte-4gkin5:not(input:focus-visible){box-shadow:var(--goa-text-input-border-error)}.goa-input.leading-content.error.svelte-4gkin5 input.input--goa.svelte-4gkin5:not(input:focus-visible){border-top-left-radius:0;border-bottom-left-radius:0}.goa-input.trailing-content.error.svelte-4gkin5 input.input--goa.svelte-4gkin5:not(input:focus-visible){border-top-right-radius:0;border-bottom-right-radius:0}.goa-input.svelte-4gkin5.svelte-4gkin5:has(input:focus-visible){box-shadow:var(--goa-text-input-border),
      var(--goa-text-input-border-focus)}.goa-input.type--range.svelte-4gkin5.svelte-4gkin5{border:none;&.type--range:active,
    &.type--range:focus-visible,
    &.type--range:focus-within {
      box-shadow: none;
    }}.leading-icon.svelte-4gkin5.svelte-4gkin5{margin-left:var(--goa-text-input-padding-lr)}.trailing-icon.svelte-4gkin5.svelte-4gkin5{margin-right:var(--goa-text-input-padding-lr)}.trailing-icon-button.svelte-4gkin5.svelte-4gkin5{margin-right:var(--goa-text-input-padding-lr)}input.svelte-4gkin5.svelte-4gkin5{display:inline-block;color:var(--goa-text-input-color-text);font:var(--goa-text-input-typography);padding:var(--goa-text-input-padding);background-color:transparent;width:calc(var(--width) + 1ch);max-width:100%;flex:1 1 auto;z-index:1;border-radius:var(--goa-text-input-border-radius)}input.svelte-4gkin5.svelte-4gkin5,input.svelte-4gkin5.svelte-4gkin5:focus-visible,input.svelte-4gkin5.svelte-4gkin5:hover,input.svelte-4gkin5.svelte-4gkin5:active{outline:none;border:none}input[readonly].svelte-4gkin5.svelte-4gkin5{cursor:pointer}.leading-icon.svelte-4gkin5+input.svelte-4gkin5{padding-left:var(--goa-text-input-space-btw-icon-text)}.input--disabled.svelte-4gkin5.svelte-4gkin5,.input--disabled.svelte-4gkin5.svelte-4gkin5:hover,.input--disabled.svelte-4gkin5.svelte-4gkin5:active,.input--disabled.svelte-4gkin5.svelte-4gkin5:focus-visible{background-color:var(--goa-text-input-color-bg-disabled);border:var(--goa-text-input-border-disabled);cursor:default;box-shadow:none !important}.input--disabled.svelte-4gkin5 input.svelte-4gkin5,.input--disabled.svelte-4gkin5 input.svelte-4gkin5:hover,.input--disabled.svelte-4gkin5 input.svelte-4gkin5:active,.input--disabled.svelte-4gkin5 input.svelte-4gkin5:focus-visible{color:var(--goa-text-input-color-text-disabled)}.input--disabled.svelte-4gkin5 input.svelte-4gkin5:hover{cursor:default !important}.input--disabled.svelte-4gkin5 .leading-icon.svelte-4gkin5,.input--disabled.svelte-4gkin5 .trailing-icon.svelte-4gkin5{color:var(--goa-text-input-color-icon-disabled);cursor:default}.prefix.svelte-4gkin5.svelte-4gkin5,.suffix.svelte-4gkin5.svelte-4gkin5,.leading-content-slot.svelte-4gkin5 ::slotted(div),.trailing-content-slot.svelte-4gkin5 ::slotted(div){background-color:var(--goa-text-input-lt-content-color-bg);box-shadow:var(--goa-text-input-border);display:flex;align-items:center;white-space:normal}.leading-content-slot.svelte-4gkin5 ::slotted(div),.trailing-content-slot.svelte-4gkin5 ::slotted(div){padding:var(--goa-text-input-padding)}.prefix.svelte-4gkin5.svelte-4gkin5,.leading-content-slot.svelte-4gkin5 ::slotted(div){border-top-left-radius:var(--goa-text-input-border-radius);border-bottom-left-radius:var(--goa-text-input-border-radius)}.suffix.svelte-4gkin5.svelte-4gkin5,.trailing-content-slot.svelte-4gkin5 ::slotted(div){border-top-right-radius:var(--goa-text-input-border-radius);border-bottom-right-radius:var(--goa-text-input-border-radius)}.input-leading-content.svelte-4gkin5.svelte-4gkin5{border-top-left-radius:var(--goa-border-radius-none);border-bottom-left-radius:var(--goa-border-radius-none)}.input-trailing-content.svelte-4gkin5.svelte-4gkin5{border-top-right-radius:var(--goa-border-radius-none);border-bottom-right-radius:var(--goa-border-radius-none)}.input-leading-content.svelte-4gkin5.svelte-4gkin5:not(.error):not(input:focus-visible):hover{box-shadow:var(--goa-text-input-border-hover)}.input-trailing-content.svelte-4gkin5.svelte-4gkin5:not(.error):not(input:focus-visible):hover{box-shadow:var(--goa-text-input-border-hover)}.input-leading-content.svelte-4gkin5.svelte-4gkin5:active,.input-leading-content.svelte-4gkin5.svelte-4gkin5:focus-visible,.input-leading-content.svelte-4gkin5.svelte-4gkin5:focus-within{box-shadow:var(--goa-text-input-border),
      var(--goa-text-input-border-focus)}.input-trailing-content.svelte-4gkin5.svelte-4gkin5:active,.input-trailing-content.svelte-4gkin5.svelte-4gkin5:focus-visible,.input-trailing-content.svelte-4gkin5.svelte-4gkin5:focus-within{box-shadow:var(--goa-text-input-border),
      var(--goa-text-input-border-focus)}.goa-input.leading-content.svelte-4gkin5.svelte-4gkin5:has(input:focus-visible){box-shadow:var(--goa-text-input-border)}.goa-input.trailing-content.svelte-4gkin5.svelte-4gkin5:has(input:focus-visible){box-shadow:var(--goa-text-input-border)}input.input--goa.svelte-4gkin5.svelte-4gkin5{display:block;border:none;flex:1 1 auto}.variant--bare.svelte-4gkin5.svelte-4gkin5{border:none}.variant--bare.svelte-4gkin5.svelte-4gkin5:focus-visible,.variant--bare.svelte-4gkin5.svelte-4gkin5:active,.variant--bare.svelte-4gkin5.svelte-4gkin5:focus-within{box-shadow:none}input[type="search"].svelte-4gkin5.svelte-4gkin5:enabled:read-write:-webkit-any(
      :focus-visible,
      :hover
    )::-webkit-search-cancel-button{position:relative;right:var(--search-icon-offset);cursor:pointer;-webkit-appearance:none;height:1.2rem;width:1.2rem;background:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="%23333" d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"/></svg>')
      center center no-repeat}.svelte-4gkin5.svelte-4gkin5::-ms-reveal{display:none}.svelte-4gkin5.svelte-4gkin5::-moz-placeholder{color:var(--goa-text-input-color-text-placeholder);opacity:1}.svelte-4gkin5.svelte-4gkin5::placeholder{color:var(--goa-text-input-color-text-placeholder);opacity:1}`);
}
const j1 = (t) => ({}), co = (t) => ({}), E1 = (t) => ({}), fo = (t) => ({});
function go(t) {
  let e, i;
  return {
    c() {
      e = C("div"), i = le(
        /*prefix*/
        t[14]
      ), f(e, "class", "prefix svelte-4gkin5");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l[0] & /*prefix*/
      16384 && pe(
        i,
        /*prefix*/
        n[14]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function ho(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "class", "leading-icon svelte-4gkin5"), p(e, "data-testid", "leading-icon"), p(
        e,
        "type",
        /*leadingicon*/
        t[5]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n[0] & /*leadingicon*/
      32 && p(
        e,
        "type",
        /*leadingicon*/
        i[5]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function mo(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "class", "trailing-icon svelte-4gkin5"), p(e, "data-testid", "trailing-icon"), p(e, "size", "medium"), p(
        e,
        "type",
        /*trailingicon*/
        t[6]
      ), p(
        e,
        "arialabel",
        /*trailingiconarialabel*/
        t[22]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n[0] & /*trailingicon*/
      64 && p(
        e,
        "type",
        /*trailingicon*/
        i[6]
      ), n[0] & /*trailingiconarialabel*/
      4194304 && p(
        e,
        "arialabel",
        /*trailingiconarialabel*/
        i[22]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function vo(t) {
  let e, i, n;
  return {
    c() {
      e = C("goa-icon-button"), p(
        e,
        "disabled",
        /*isDisabled*/
        t[30]
      ), p(e, "variant", "dark"), p(e, "size", "medium"), p(
        e,
        "icon",
        /*trailingicon*/
        t[6]
      ), p(e, "data-testid", "trailing-icon-button"), p(e, "class", "trailing-icon-button svelte-4gkin5"), p(
        e,
        "arialabel",
        /*trailingiconarialabel*/
        t[22]
      );
    },
    m(l, o) {
      D(l, e, o), i || (n = te(e, "click", L1), i = !0);
    },
    p(l, o) {
      o[0] & /*isDisabled*/
      1073741824 && p(
        e,
        "disabled",
        /*isDisabled*/
        l[30]
      ), o[0] & /*trailingicon*/
      64 && p(
        e,
        "icon",
        /*trailingicon*/
        l[6]
      ), o[0] & /*trailingiconarialabel*/
      4194304 && p(
        e,
        "arialabel",
        /*trailingiconarialabel*/
        l[22]
      );
    },
    d(l) {
      l && P(e), i = !1, n();
    }
  };
}
function bo(t) {
  let e, i;
  return {
    c() {
      e = C("span"), i = le(
        /*suffix*/
        t[15]
      ), f(e, "class", "suffix svelte-4gkin5");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l[0] & /*suffix*/
      32768 && pe(
        i,
        /*suffix*/
        n[15]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function M1(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v, b, w, y, j, E, M, L, z = (
    /*prefix*/
    t[14] && go(t)
  );
  const V = (
    /*#slots*/
    t[45].leadingContent
  ), T = oe(
    V,
    t,
    /*$$scope*/
    t[44],
    fo
  );
  let S = (
    /*leadingicon*/
    t[5] && ho(t)
  ), A = (
    /*trailingicon*/
    t[6] && !/*handlesTrailingIconClick*/
    t[31] && mo(t)
  ), R = (
    /*trailingicon*/
    t[6] && /*handlesTrailingIconClick*/
    t[31] && vo(t)
  ), I = (
    /*suffix*/
    t[15] && bo(t)
  );
  const B = (
    /*#slots*/
    t[45].trailingContent
  ), N = oe(
    B,
    t,
    /*$$scope*/
    t[44],
    co
  );
  return {
    c() {
      e = C("div"), i = C("div"), z && z.c(), n = x(), l = C("div"), T && T.c(), o = x(), S && S.c(), r = x(), a = C("input"), h = x(), A && A.c(), m = x(), R && R.c(), v = x(), I && I.c(), b = x(), w = C("div"), N && N.c(), f(l, "class", "leading-content-slot svelte-4gkin5"), f(a, "class", s = "input--" + /*variant*/
      t[7] + " svelte-4gkin5"), f(a, "style", d = `--search-icon-offset: ${/*trailingicon*/
      t[6] ? "-0.5rem" : "0"}`), a.readOnly = /*isReadonly*/
      t[29], a.disabled = /*isDisabled*/
      t[30], f(
        a,
        "data-testid",
        /*testid*/
        t[8]
      ), f(
        a,
        "autocapitalize",
        /*autocapitalize*/
        t[3]
      ), f(
        a,
        "name",
        /*name*/
        t[2]
      ), f(
        a,
        "type",
        /*type*/
        t[1]
      ), a.value = u = /*value*/
      t[0] || "", f(
        a,
        "placeholder",
        /*placeholder*/
        t[4]
      ), f(
        a,
        "min",
        /*min*/
        t[11]
      ), f(
        a,
        "max",
        /*max*/
        t[12]
      ), f(
        a,
        "step",
        /*step*/
        t[13]
      ), f(
        a,
        "maxlength",
        /*maxlength*/
        t[16]
      ), f(a, "id", c = /*id*/
      t[17] || /*name*/
      t[2]), f(a, "role", "textbox"), f(
        a,
        "aria-label",
        /*arialabel*/
        t[9]
      ), f(
        a,
        "aria-labelledby",
        /*arialabelledby*/
        t[10]
      ), f(a, "aria-invalid", g = /*_error*/
      t[25] ? "true" : "false"), G(
        a,
        "input-leading-content",
        /*_leadingContentSlot*/
        t[26] && !/*isDisabled*/
        t[30]
      ), G(
        a,
        "input-trailing-content",
        /*_trailingContentSlot*/
        t[27] && !/*isDisabled*/
        t[30]
      ), f(w, "class", "trailing-content-slot svelte-4gkin5"), f(i, "class", y = "goa-input variant--" + /*variant*/
      t[7] + " type--" + /*type*/
      t[1] + " svelte-4gkin5"), G(
        i,
        "input--disabled",
        /*isDisabled*/
        t[30]
      ), G(
        i,
        "leading-content",
        /*_leadingContentSlot*/
        t[26]
      ), G(
        i,
        "trailing-content",
        /*_trailingContentSlot*/
        t[27]
      ), G(
        i,
        "error",
        /*_error*/
        t[25]
      ), G(
        i,
        "has-icon",
        /*leadingicon*/
        t[5] || /*trailingicon*/
        t[6]
      ), f(e, "class", "container svelte-4gkin5"), f(e, "style", j = `${/*_containerWidth*/
      t[28]}${be(
        /*mt*/
        t[18],
        /*mr*/
        t[19],
        /*mb*/
        t[20],
        /*ml*/
        t[21]
      )}`);
    },
    m(F, q) {
      D(F, e, q), _(e, i), z && z.m(i, null), _(i, n), _(i, l), T && T.m(l, null), _(i, o), S && S.m(i, null), _(i, r), _(i, a), t[46](a), _(i, h), A && A.m(i, null), _(i, m), R && R.m(i, null), _(i, v), I && I.m(i, null), _(i, b), _(i, w), N && N.m(w, null), t[47](e), E = !0, M || (L = [
        te(
          a,
          "keyup",
          /*onKeyUp*/
          t[32]
        ),
        te(
          a,
          "change",
          /*onKeyUp*/
          t[32]
        ),
        te(
          a,
          "focus",
          /*onFocus*/
          t[33]
        ),
        te(
          a,
          "blur",
          /*onBlur*/
          t[34]
        )
      ], M = !0);
    },
    p(F, q) {
      /*prefix*/
      F[14] ? z ? z.p(F, q) : (z = go(F), z.c(), z.m(i, n)) : z && (z.d(1), z = null), T && T.p && (!E || q[1] & /*$$scope*/
      8192) && ae(
        T,
        V,
        F,
        /*$$scope*/
        F[44],
        E ? re(
          V,
          /*$$scope*/
          F[44],
          q,
          E1
        ) : se(
          /*$$scope*/
          F[44]
        ),
        fo
      ), /*leadingicon*/
      F[5] ? S ? S.p(F, q) : (S = ho(F), S.c(), S.m(i, r)) : S && (S.d(1), S = null), (!E || q[0] & /*variant*/
      128 && s !== (s = "input--" + /*variant*/
      F[7] + " svelte-4gkin5")) && f(a, "class", s), (!E || q[0] & /*trailingicon*/
      64 && d !== (d = `--search-icon-offset: ${/*trailingicon*/
      F[6] ? "-0.5rem" : "0"}`)) && f(a, "style", d), (!E || q[0] & /*isReadonly*/
      536870912) && (a.readOnly = /*isReadonly*/
      F[29]), (!E || q[0] & /*isDisabled*/
      1073741824) && (a.disabled = /*isDisabled*/
      F[30]), (!E || q[0] & /*testid*/
      256) && f(
        a,
        "data-testid",
        /*testid*/
        F[8]
      ), (!E || q[0] & /*autocapitalize*/
      8) && f(
        a,
        "autocapitalize",
        /*autocapitalize*/
        F[3]
      ), (!E || q[0] & /*name*/
      4) && f(
        a,
        "name",
        /*name*/
        F[2]
      ), (!E || q[0] & /*type*/
      2) && f(
        a,
        "type",
        /*type*/
        F[1]
      ), (!E || q[0] & /*value*/
      1 && u !== (u = /*value*/
      F[0] || "") && a.value !== u) && (a.value = u), (!E || q[0] & /*placeholder*/
      16) && f(
        a,
        "placeholder",
        /*placeholder*/
        F[4]
      ), (!E || q[0] & /*min*/
      2048) && f(
        a,
        "min",
        /*min*/
        F[11]
      ), (!E || q[0] & /*max*/
      4096) && f(
        a,
        "max",
        /*max*/
        F[12]
      ), (!E || q[0] & /*step*/
      8192) && f(
        a,
        "step",
        /*step*/
        F[13]
      ), (!E || q[0] & /*maxlength*/
      65536) && f(
        a,
        "maxlength",
        /*maxlength*/
        F[16]
      ), (!E || q[0] & /*id, name*/
      131076 && c !== (c = /*id*/
      F[17] || /*name*/
      F[2])) && f(a, "id", c), (!E || q[0] & /*arialabel*/
      512) && f(
        a,
        "aria-label",
        /*arialabel*/
        F[9]
      ), (!E || q[0] & /*arialabelledby*/
      1024) && f(
        a,
        "aria-labelledby",
        /*arialabelledby*/
        F[10]
      ), (!E || q[0] & /*_error*/
      33554432 && g !== (g = /*_error*/
      F[25] ? "true" : "false")) && f(a, "aria-invalid", g), (!E || q[0] & /*variant, _leadingContentSlot, isDisabled*/
      1140850816) && G(
        a,
        "input-leading-content",
        /*_leadingContentSlot*/
        F[26] && !/*isDisabled*/
        F[30]
      ), (!E || q[0] & /*variant, _trailingContentSlot, isDisabled*/
      1207959680) && G(
        a,
        "input-trailing-content",
        /*_trailingContentSlot*/
        F[27] && !/*isDisabled*/
        F[30]
      ), /*trailingicon*/
      F[6] && !/*handlesTrailingIconClick*/
      F[31] ? A ? A.p(F, q) : (A = mo(F), A.c(), A.m(i, m)) : A && (A.d(1), A = null), /*trailingicon*/
      F[6] && /*handlesTrailingIconClick*/
      F[31] ? R ? R.p(F, q) : (R = vo(F), R.c(), R.m(i, v)) : R && (R.d(1), R = null), /*suffix*/
      F[15] ? I ? I.p(F, q) : (I = bo(F), I.c(), I.m(i, b)) : I && (I.d(1), I = null), N && N.p && (!E || q[1] & /*$$scope*/
      8192) && ae(
        N,
        B,
        F,
        /*$$scope*/
        F[44],
        E ? re(
          B,
          /*$$scope*/
          F[44],
          q,
          j1
        ) : se(
          /*$$scope*/
          F[44]
        ),
        co
      ), (!E || q[0] & /*variant, type*/
      130 && y !== (y = "goa-input variant--" + /*variant*/
      F[7] + " type--" + /*type*/
      F[1] + " svelte-4gkin5")) && f(i, "class", y), (!E || q[0] & /*variant, type, isDisabled*/
      1073741954) && G(
        i,
        "input--disabled",
        /*isDisabled*/
        F[30]
      ), (!E || q[0] & /*variant, type, _leadingContentSlot*/
      67108994) && G(
        i,
        "leading-content",
        /*_leadingContentSlot*/
        F[26]
      ), (!E || q[0] & /*variant, type, _trailingContentSlot*/
      134217858) && G(
        i,
        "trailing-content",
        /*_trailingContentSlot*/
        F[27]
      ), (!E || q[0] & /*variant, type, _error*/
      33554562) && G(
        i,
        "error",
        /*_error*/
        F[25]
      ), (!E || q[0] & /*variant, type, leadingicon, trailingicon*/
      226) && G(
        i,
        "has-icon",
        /*leadingicon*/
        F[5] || /*trailingicon*/
        F[6]
      ), (!E || q[0] & /*_containerWidth, mt, mr, mb, ml*/
      272367616 && j !== (j = `${/*_containerWidth*/
      F[28]}${be(
        /*mt*/
        F[18],
        /*mr*/
        F[19],
        /*mb*/
        F[20],
        /*ml*/
        F[21]
      )}`)) && f(e, "style", j);
    },
    i(F) {
      E || (Y(T, F), Y(N, F), E = !0);
    },
    o(F) {
      U(T, F), U(N, F), E = !1;
    },
    d(F) {
      F && P(e), z && z.d(), T && T.d(F), S && S.d(), t[46](null), A && A.d(), R && R.d(), I && I.d(), N && N.d(F), t[47](null), M = !1, He(L);
    }
  };
}
function L1() {
  this.dispatchEvent(new CustomEvent("_trailingIconClick", { composed: !0 }));
}
function q1(t, e, i) {
  let n, l, o, r, { $$slots: a = {}, $$scope: s } = e;
  const [d, u] = Me("Input type", [
    "text",
    "number",
    "password",
    "email",
    "date",
    "datetime-local",
    "month",
    "range",
    "search",
    "tel",
    "time",
    "url",
    "week"
  ]), [c, g] = Me("Input auto capitalize", ["on", "off", "none", "sentences", "words", "characters"]);
  let { type: h = "text" } = e, { name: m = "" } = e, { value: v = "" } = e, { autocapitalize: b = "off" } = e, { placeholder: w = "" } = e, { leadingicon: y = null } = e, { trailingicon: j = null } = e, { variant: E = "goa" } = e, { disabled: M = "false" } = e, { handletrailingiconclick: L = "false" } = e, { focused: z = "false" } = e, { readonly: V = "false" } = e, { error: T = "false" } = e, { testid: S = "" } = e, { width: A = "30ch" } = e, { arialabel: R = "" } = e, { arialabelledby: I = "" } = e, { min: B = "" } = e, { max: N = "" } = e, { step: F = 1 } = e, { prefix: q = "" } = e, { suffix: H = "" } = e, { debounce: O = 0 } = e, { maxlength: W = null } = e, { id: K = "" } = e, { mt: $ = null } = e, { mr: ye = null } = e, { mb: Z = null } = e, { ml: Q = null } = e, { trailingiconarialabel: X = "" } = e, ee = !1, ie = !1, J, De, fe, Ae = !1, Ct = !1, zt = "";
  ke(async () => {
    await Pe(), u(h), g(b), ji(), jt(), rt(), Qt(), A.includes("%") ? i(28, zt = `width: ${A};`) : i(28, zt = `--width: ${A};`);
  });
  function ji() {
    Re(De, (de, Ie) => {
      switch (de) {
        case bt:
          Jt(Ie);
          break;
        case dt:
          Xt(Ie);
          break;
        case ut:
          i(36, T = "false");
          break;
        case zi:
          Jt({ name: m, value: "" });
          break;
      }
    });
  }
  function Xt(de) {
    i(36, T = de.error ? "true" : "false");
  }
  function Jt(de) {
    i(0, v = de.value);
  }
  function Qt() {
    je(fe, Qe, { name: m, el: De }, { bubbles: !0, timeout: 10 });
  }
  function $t(de) {
    const Ie = de.target;
    Ie && (o || (J != null && clearTimeout(J), J = setTimeout(
      () => {
        Ie.dispatchEvent(new CustomEvent(
          "_change",
          {
            composed: !0,
            bubbles: !0,
            cancelable: !0,
            detail: { name: m, value: Ie.value }
          }
        ));
      },
      O
    ), Ie.dispatchEvent(new CustomEvent(
      "_keyPress",
      {
        composed: !0,
        detail: { name: m, value: Ie.value, key: de.key }
      }
    )), i(0, v = Ie.value)));
  }
  function _t(de) {
    const Ie = de.target;
    Ie.dispatchEvent(new CustomEvent(
      "_focus",
      {
        composed: !0,
        detail: { name: m, value: Ie.value }
      }
    )), qe(fe, "help-text::announce", void 0, { bubbles: !0 });
  }
  function $e(de) {
    i(35, z = "false");
    const Ie = de.target;
    Ie.dispatchEvent(new CustomEvent(
      "_blur",
      {
        composed: !0,
        detail: { name: m, value: Ie.value }
      }
    ));
  }
  function rt() {
    const de = fe.querySelector("slot[name=leadingContent]");
    de && de.assignedNodes().length > 0 && i(26, ee = !0);
    const Ie = fe.querySelector("slot[name=trailingContent]");
    Ie && Ie.assignedNodes().length > 0 && i(27, ie = !0);
  }
  function jt() {
    (q != "" || H != "") && console.warn("GoAInput [prefix] and [suffix] properties are deprecated. Instead use leadingContent and trailingContent.");
  }
  function Et(de) {
    ue[de ? "unshift" : "push"](() => {
      De = de, i(23, De);
    });
  }
  function ft(de) {
    ue[de ? "unshift" : "push"](() => {
      fe = de, i(24, fe);
    });
  }
  return t.$$set = (de) => {
    "type" in de && i(1, h = de.type), "name" in de && i(2, m = de.name), "value" in de && i(0, v = de.value), "autocapitalize" in de && i(3, b = de.autocapitalize), "placeholder" in de && i(4, w = de.placeholder), "leadingicon" in de && i(5, y = de.leadingicon), "trailingicon" in de && i(6, j = de.trailingicon), "variant" in de && i(7, E = de.variant), "disabled" in de && i(37, M = de.disabled), "handletrailingiconclick" in de && i(38, L = de.handletrailingiconclick), "focused" in de && i(35, z = de.focused), "readonly" in de && i(39, V = de.readonly), "error" in de && i(36, T = de.error), "testid" in de && i(8, S = de.testid), "width" in de && i(40, A = de.width), "arialabel" in de && i(9, R = de.arialabel), "arialabelledby" in de && i(10, I = de.arialabelledby), "min" in de && i(11, B = de.min), "max" in de && i(12, N = de.max), "step" in de && i(13, F = de.step), "prefix" in de && i(14, q = de.prefix), "suffix" in de && i(15, H = de.suffix), "debounce" in de && i(41, O = de.debounce), "maxlength" in de && i(16, W = de.maxlength), "id" in de && i(17, K = de.id), "mt" in de && i(18, $ = de.mt), "mr" in de && i(19, ye = de.mr), "mb" in de && i(20, Z = de.mb), "ml" in de && i(21, Q = de.ml), "trailingiconarialabel" in de && i(22, X = de.trailingiconarialabel), "$$scope" in de && i(44, s = de.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty[1] & /*handletrailingiconclick*/
    128 && i(31, n = Ce(L)), t.$$.dirty[1] & /*focused*/
    16 && i(43, l = Ce(z)), t.$$.dirty[1] & /*readonly*/
    256 && i(29, o = Ce(V)), t.$$.dirty[1] & /*disabled*/
    64 && i(30, r = Ce(M)), t.$$.dirty[0] & /*_error, _rootEl*/
    50331648 | t.$$.dirty[1] & /*error, _prevError*/
    2080 && (i(25, Ae = Ce(T)), Ae !== Ct && (qe(fe, "error::change", { isError: Ae }, { bubbles: !0 }), i(42, Ct = Ae))), t.$$.dirty[0] & /*_inputEl*/
    8388608 | t.$$.dirty[1] & /*isFocused*/
    4096 && l && De && setTimeout(() => De.focus(), 2), t.$$.dirty[0] & /*_inputEl, type*/
    8388610 && De && h === "search" && De.addEventListener("search", (de) => {
      $t(de);
    });
  }, [
    v,
    h,
    m,
    b,
    w,
    y,
    j,
    E,
    S,
    R,
    I,
    B,
    N,
    F,
    q,
    H,
    W,
    K,
    $,
    ye,
    Z,
    Q,
    X,
    De,
    fe,
    Ae,
    ee,
    ie,
    zt,
    o,
    r,
    n,
    $t,
    _t,
    $e,
    z,
    T,
    M,
    L,
    V,
    A,
    O,
    Ct,
    l,
    s,
    a,
    Et,
    ft
  ];
}
class S1 extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      q1,
      M1,
      ce,
      {
        type: 1,
        name: 2,
        value: 0,
        autocapitalize: 3,
        placeholder: 4,
        leadingicon: 5,
        trailingicon: 6,
        variant: 7,
        disabled: 37,
        handletrailingiconclick: 38,
        focused: 35,
        readonly: 39,
        error: 36,
        testid: 8,
        width: 40,
        arialabel: 9,
        arialabelledby: 10,
        min: 11,
        max: 12,
        step: 13,
        prefix: 14,
        suffix: 15,
        debounce: 41,
        maxlength: 16,
        id: 17,
        mt: 18,
        mr: 19,
        mb: 20,
        ml: 21,
        trailingiconarialabel: 22
      },
      z1,
      [-1, -1]
    );
  }
  get type() {
    return this.$$.ctx[1];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get name() {
    return this.$$.ctx[2];
  }
  set name(e) {
    this.$$set({ name: e }), k();
  }
  get value() {
    return this.$$.ctx[0];
  }
  set value(e) {
    this.$$set({ value: e }), k();
  }
  get autocapitalize() {
    return this.$$.ctx[3];
  }
  set autocapitalize(e) {
    this.$$set({ autocapitalize: e }), k();
  }
  get placeholder() {
    return this.$$.ctx[4];
  }
  set placeholder(e) {
    this.$$set({ placeholder: e }), k();
  }
  get leadingicon() {
    return this.$$.ctx[5];
  }
  set leadingicon(e) {
    this.$$set({ leadingicon: e }), k();
  }
  get trailingicon() {
    return this.$$.ctx[6];
  }
  set trailingicon(e) {
    this.$$set({ trailingicon: e }), k();
  }
  get variant() {
    return this.$$.ctx[7];
  }
  set variant(e) {
    this.$$set({ variant: e }), k();
  }
  get disabled() {
    return this.$$.ctx[37];
  }
  set disabled(e) {
    this.$$set({ disabled: e }), k();
  }
  get handletrailingiconclick() {
    return this.$$.ctx[38];
  }
  set handletrailingiconclick(e) {
    this.$$set({ handletrailingiconclick: e }), k();
  }
  get focused() {
    return this.$$.ctx[35];
  }
  set focused(e) {
    this.$$set({ focused: e }), k();
  }
  get readonly() {
    return this.$$.ctx[39];
  }
  set readonly(e) {
    this.$$set({ readonly: e }), k();
  }
  get error() {
    return this.$$.ctx[36];
  }
  set error(e) {
    this.$$set({ error: e }), k();
  }
  get testid() {
    return this.$$.ctx[8];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get width() {
    return this.$$.ctx[40];
  }
  set width(e) {
    this.$$set({ width: e }), k();
  }
  get arialabel() {
    return this.$$.ctx[9];
  }
  set arialabel(e) {
    this.$$set({ arialabel: e }), k();
  }
  get arialabelledby() {
    return this.$$.ctx[10];
  }
  set arialabelledby(e) {
    this.$$set({ arialabelledby: e }), k();
  }
  get min() {
    return this.$$.ctx[11];
  }
  set min(e) {
    this.$$set({ min: e }), k();
  }
  get max() {
    return this.$$.ctx[12];
  }
  set max(e) {
    this.$$set({ max: e }), k();
  }
  get step() {
    return this.$$.ctx[13];
  }
  set step(e) {
    this.$$set({ step: e }), k();
  }
  get prefix() {
    return this.$$.ctx[14];
  }
  set prefix(e) {
    this.$$set({ prefix: e }), k();
  }
  get suffix() {
    return this.$$.ctx[15];
  }
  set suffix(e) {
    this.$$set({ suffix: e }), k();
  }
  get debounce() {
    return this.$$.ctx[41];
  }
  set debounce(e) {
    this.$$set({ debounce: e }), k();
  }
  get maxlength() {
    return this.$$.ctx[16];
  }
  set maxlength(e) {
    this.$$set({ maxlength: e }), k();
  }
  get id() {
    return this.$$.ctx[17];
  }
  set id(e) {
    this.$$set({ id: e }), k();
  }
  get mt() {
    return this.$$.ctx[18];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[19];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[20];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[21];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get trailingiconarialabel() {
    return this.$$.ctx[22];
  }
  set trailingiconarialabel(e) {
    this.$$set({ trailingiconarialabel: e }), k();
  }
}
customElements.define("goa-input", he(S1, { type: {}, name: {}, value: {}, autocapitalize: {}, placeholder: {}, leadingicon: {}, trailingicon: {}, variant: {}, disabled: {}, handletrailingiconclick: {}, focused: {}, readonly: {}, error: {}, testid: {}, width: {}, arialabel: {}, arialabelledby: {}, min: {}, max: {}, step: {}, prefix: {}, suffix: {}, debounce: {}, maxlength: {}, id: {}, mt: {}, mr: {}, mb: {}, ml: {}, trailingiconarialabel: {} }, ["leadingContent", "trailingContent"], [], !0));
function T1(t) {
  _e(t, "svelte-1x4o8zb", "::slotted(a){color:var(--goa-color-interactive-default)}.link.svelte-1x4o8zb{display:inline-flex;align-items:center;color:var(--goa-color-interactive-default);padding:0;border:none;background:none;cursor:pointer;font:var(--goa-typography-body-m);text-decoration:underline;gap:8px}.link.svelte-1x4o8zb:hover{color:var(--goa-color-interactive-hover)}");
}
function po(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "class", "leading-icon"), p(
        e,
        "type",
        /*leadingicon*/
        t[0]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*leadingicon*/
      1 && p(
        e,
        "type",
        /*leadingicon*/
        i[0]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function _o(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(
        e,
        "type",
        /*trailingicon*/
        t[1]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*trailingicon*/
      2 && p(
        e,
        "type",
        /*trailingicon*/
        i[1]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function P1(t) {
  let e, i, n, l, o, r = (
    /*leadingicon*/
    t[0] && po(t)
  );
  const a = (
    /*#slots*/
    t[7].default
  ), s = oe(
    a,
    t,
    /*$$scope*/
    t[6],
    null
  );
  let d = (
    /*trailingicon*/
    t[1] && _o(t)
  );
  return {
    c() {
      e = C("div"), r && r.c(), i = x(), s && s.c(), n = x(), d && d.c(), f(e, "class", Ee("link") + " svelte-1x4o8zb"), f(e, "style", l = Ue(be(
        /*mt*/
        t[2],
        /*mr*/
        t[3],
        /*mb*/
        t[4],
        /*ml*/
        t[5]
      )));
    },
    m(u, c) {
      D(u, e, c), r && r.m(e, null), _(e, i), s && s.m(e, null), _(e, n), d && d.m(e, null), o = !0;
    },
    p(u, [c]) {
      /*leadingicon*/
      u[0] ? r ? r.p(u, c) : (r = po(u), r.c(), r.m(e, i)) : r && (r.d(1), r = null), s && s.p && (!o || c & /*$$scope*/
      64) && ae(
        s,
        a,
        u,
        /*$$scope*/
        u[6],
        o ? re(
          a,
          /*$$scope*/
          u[6],
          c,
          null
        ) : se(
          /*$$scope*/
          u[6]
        ),
        null
      ), /*trailingicon*/
      u[1] ? d ? d.p(u, c) : (d = _o(u), d.c(), d.m(e, null)) : d && (d.d(1), d = null), (!o || c & /*mt, mr, mb, ml*/
      60 && l !== (l = Ue(be(
        /*mt*/
        u[2],
        /*mr*/
        u[3],
        /*mb*/
        u[4],
        /*ml*/
        u[5]
      )))) && f(e, "style", l);
    },
    i(u) {
      o || (Y(s, u), o = !0);
    },
    o(u) {
      U(s, u), o = !1;
    },
    d(u) {
      u && P(e), r && r.d(), s && s.d(u), d && d.d();
    }
  };
}
function D1(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { leadingicon: o } = e, { trailingicon: r } = e, { mt: a = null } = e, { mr: s = null } = e, { mb: d = null } = e, { ml: u = null } = e;
  return t.$$set = (c) => {
    "leadingicon" in c && i(0, o = c.leadingicon), "trailingicon" in c && i(1, r = c.trailingicon), "mt" in c && i(2, a = c.mt), "mr" in c && i(3, s = c.mr), "mb" in c && i(4, d = c.mb), "ml" in c && i(5, u = c.ml), "$$scope" in c && i(6, l = c.$$scope);
  }, [o, r, a, s, d, u, l, n];
}
class H1 extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      D1,
      P1,
      ce,
      {
        leadingicon: 0,
        trailingicon: 1,
        mt: 2,
        mr: 3,
        mb: 4,
        ml: 5
      },
      T1
    );
  }
  get leadingicon() {
    return this.$$.ctx[0];
  }
  set leadingicon(e) {
    this.$$set({ leadingicon: e }), k();
  }
  get trailingicon() {
    return this.$$.ctx[1];
  }
  set trailingicon(e) {
    this.$$set({ trailingicon: e }), k();
  }
  get mt() {
    return this.$$.ctx[2];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[3];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[4];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[5];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-link", he(H1, { leadingicon: {}, trailingicon: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function O1(t) {
  _e(t, "svelte-p8neaq", ".link-button.svelte-p8neaq{display:inline-flex;align-items:center;color:var(--goa-color-interactive-default);padding:0;border:none;background:none;cursor:pointer;font:var(--goa-typography-body-m);text-decoration:underline}::slotted(a){color:var(--goa-color-interactive-default)}");
}
function wo(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(
        e,
        "type",
        /*leadingicon*/
        t[1]
      ), p(e, "fillcolor", "#0070C4");
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*leadingicon*/
      2 && p(
        e,
        "type",
        /*leadingicon*/
        i[1]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function ko(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(
        e,
        "type",
        /*trailingicon*/
        t[2]
      ), p(e, "fillcolor", "#0070C4");
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*trailingicon*/
      4 && p(
        e,
        "type",
        /*trailingicon*/
        i[2]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function F1(t) {
  let e, i, n, l, o, r, a, s, d = (
    /*leadingicon*/
    t[1] && wo(t)
  );
  const u = (
    /*#slots*/
    t[10].default
  ), c = oe(
    u,
    t,
    /*$$scope*/
    t[9],
    null
  );
  let g = (
    /*trailingicon*/
    t[2] && ko(t)
  );
  return {
    c() {
      e = C("button"), d && d.c(), i = x(), c && c.c(), n = x(), g && g.c(), f(e, "class", l = Ee(`link-button ${/*type*/
      t[0]}`) + " svelte-p8neaq"), f(e, "style", o = be(
        /*mt*/
        t[3],
        /*mr*/
        t[4],
        /*mb*/
        t[5],
        /*ml*/
        t[6]
      ));
    },
    m(h, m) {
      D(h, e, m), d && d.m(e, null), _(e, i), c && c.m(e, null), _(e, n), g && g.m(e, null), t[11](e), r = !0, a || (s = te(
        e,
        "click",
        /*onClick*/
        t[8]
      ), a = !0);
    },
    p(h, [m]) {
      /*leadingicon*/
      h[1] ? d ? d.p(h, m) : (d = wo(h), d.c(), d.m(e, i)) : d && (d.d(1), d = null), c && c.p && (!r || m & /*$$scope*/
      512) && ae(
        c,
        u,
        h,
        /*$$scope*/
        h[9],
        r ? re(
          u,
          /*$$scope*/
          h[9],
          m,
          null
        ) : se(
          /*$$scope*/
          h[9]
        ),
        null
      ), /*trailingicon*/
      h[2] ? g ? g.p(h, m) : (g = ko(h), g.c(), g.m(e, null)) : g && (g.d(1), g = null), (!r || m & /*type*/
      1 && l !== (l = Ee(`link-button ${/*type*/
      h[0]}`) + " svelte-p8neaq")) && f(e, "class", l), (!r || m & /*mt, mr, mb, ml*/
      120 && o !== (o = be(
        /*mt*/
        h[3],
        /*mr*/
        h[4],
        /*mb*/
        h[5],
        /*ml*/
        h[6]
      ))) && f(e, "style", o);
    },
    i(h) {
      r || (Y(c, h), r = !0);
    },
    o(h) {
      U(c, h), r = !1;
    },
    d(h) {
      h && P(e), d && d.d(), c && c.d(h), g && g.d(), t[11](null), a = !1, s();
    }
  };
}
function A1(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { type: o = "tertiary" } = e, { leadingicon: r } = e, { trailingicon: a } = e, { mt: s = null } = e, { mr: d = null } = e, { mb: u = null } = e, { ml: c = null } = e, g;
  function h(v) {
    qe(g, "_click", null, { bubbles: !0 }), v.stopPropagation();
  }
  function m(v) {
    ue[v ? "unshift" : "push"](() => {
      g = v, i(7, g);
    });
  }
  return t.$$set = (v) => {
    "type" in v && i(0, o = v.type), "leadingicon" in v && i(1, r = v.leadingicon), "trailingicon" in v && i(2, a = v.trailingicon), "mt" in v && i(3, s = v.mt), "mr" in v && i(4, d = v.mr), "mb" in v && i(5, u = v.mb), "ml" in v && i(6, c = v.ml), "$$scope" in v && i(9, l = v.$$scope);
  }, [
    o,
    r,
    a,
    s,
    d,
    u,
    c,
    g,
    h,
    l,
    n,
    m
  ];
}
class V1 extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      A1,
      F1,
      ce,
      {
        type: 0,
        leadingicon: 1,
        trailingicon: 2,
        mt: 3,
        mr: 4,
        mb: 5,
        ml: 6
      },
      O1
    );
  }
  get type() {
    return this.$$.ctx[0];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get leadingicon() {
    return this.$$.ctx[1];
  }
  set leadingicon(e) {
    this.$$set({ leadingicon: e }), k();
  }
  get trailingicon() {
    return this.$$.ctx[2];
  }
  set trailingicon(e) {
    this.$$set({ trailingicon: e }), k();
  }
  get mt() {
    return this.$$.ctx[3];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[4];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[5];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[6];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-link-button", he(V1, { type: {}, leadingicon: {}, trailingicon: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function I1(t) {
  _e(t, "svelte-g86co", `:host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}.feedback-link.svelte-g86co{display:inline-flex}#container.svelte-g86co{container:self / inline-size;background-color:var(--goa-microsite-header-color-bg)}a.svelte-g86co{color:var(--goa-microsite-header-color-links);cursor:pointer}a.svelte-g86co:hover{color:var(--goa-microsite-header-color-links-hover)}a.svelte-g86co:focus{outline:var(--goa-microsite-header-link-focus-border)}a[target="_blank"].svelte-g86co::after{content:"";width:var(--goa-icon-size-s);height:var(--goa-icon-size-s);background-color:var(--goa-color-interactive-default);display:inline-block;margin-left:var(--goa-space-2xs);vertical-align:sub;mask:url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22ionicon%22%20viewBox%3D%220%200%20512%20512%22%3E%3Cpath%20d%3D%22M384%20224v184a40%2040%200%200%201-40%2040H104a40%2040%200%200%201-40-40V168a40%2040%200%200%201%2040-40h167.48M336%2064h112v112M224%20288%20440%2072%22%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%2232%22%2F%3E%3C%2Fsvg%3E")
      center bottom no-repeat;-webkit-mask:url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22ionicon%22%20viewBox%3D%220%200%20512%20512%22%3E%3Cpath%20d%3D%22M384%20224v184a40%2040%200%200%201-40%2040H104a40%2040%200%200%201-40-40V168a40%2040%200%200%201%2040-40h167.48M336%2064h112v112M224%20288%20440%2072%22%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%2232%22%2F%3E%3C%2Fsvg%3E")
      center bottom no-repeat}a[target="_blank"].svelte-g86co:hover:after{background-color:var(--goa-color-interactive-hover)}.content-container.svelte-g86co{font:var(--goa-microsite-header-typography);padding:var(--goa-microsite-header-padding-small-screen);display:flex;align-items:flex-start;justify-content:space-between;max-width:min(var(--max-content-width), 100%);margin:0 auto}@container self (min-width: 624px){.content-container.svelte-g86co{padding:var(--goa-microsite-header-padding-medium-screen)}}@container self (min-width: 1024px){.content-container.svelte-g86co{padding:var(--goa-microsite-header-padding-large-screen)}}.spacer.svelte-g86co{flex:1 1 auto}.version.svelte-g86co{color:var(--goa-microsite-header-color-version-number);margin-left:var(--goa-microsite-header-gap);font-size:var(--goa-microsite-header-typography-version-number)}::slotted([slot="version"]){display:flex;align-items:center}.service-type.svelte-g86co{font-weight:bold;padding:0px 3px 3px 3px;display:flex;line-height:initial;margin-right:var(--goa-microsite-header-gap)}.service-type--alpha.svelte-g86co{background-color:var(--goa-microsite-header-alpha-badge-color);color:var(--goa-microsite-header-alpha-badge-color-text)}.service-type--beta.svelte-g86co{background-color:var(--goa-microsite-header-beta-badge-color);color:var(--goa-microsite-header-beta-badge-color-text)}.site-text.svelte-g86co{font:var(--goa-microsite-header-typography);margin-bottom:4px}`);
}
const x1 = (t) => ({}), yo = (t) => ({});
function Co(t) {
  let e, i, n, l, o, r;
  function a(u, c) {
    if (
      /*feedbackurl*/
      u[2]
    ) return N1;
    if (
      /*_hasfeedbackhandler*/
      u[8]
    ) return B1;
  }
  let s = a(t), d = s && s(t);
  return {
    c() {
      e = C("div"), i = le("An official site of the "), n = C("a"), l = le("Alberta Government"), r = x(), d && d.c(), f(n, "href", "https://www.alberta.ca/index.aspx"), f(n, "target", o = `_${/*headerurltarget*/
      t[4]}`), f(n, "class", "svelte-g86co"), f(e, "data-testid", "type"), f(e, "class", "site-text svelte-g86co");
    },
    m(u, c) {
      D(u, e, c), _(e, i), _(e, n), _(n, l), _(e, r), d && d.m(e, null);
    },
    p(u, c) {
      c & /*headerurltarget*/
      16 && o !== (o = `_${/*headerurltarget*/
      u[4]}`) && f(n, "target", o), s === (s = a(u)) && d ? d.p(u, c) : (d && d.d(1), d = s && s(u), d && (d.c(), d.m(e, null)));
    },
    d(u) {
      u && P(e), d && d.d();
    }
  };
}
function B1(t) {
  let e, i, n, l, o;
  return {
    c() {
      e = C("span"), i = le(`— help us improve it by giving
            
            `), n = C("a"), n.textContent = "feedback", f(n, "href", "#"), f(n, "class", "svelte-g86co"), f(e, "data-testid", "feedback-click");
    },
    m(r, a) {
      D(r, e, a), _(e, i), _(e, n), t[14](e), l || (o = te(
        n,
        "click",
        /*handleFeedbackClick*/
        t[9]
      ), l = !0);
    },
    p: ve,
    d(r) {
      r && P(e), t[14](null), l = !1, o();
    }
  };
}
function N1(t) {
  let e, i, n, l, o, r;
  return {
    c() {
      e = C("span"), i = le(`— help us improve it by giving
            `), n = C("span"), l = C("a"), o = le("feedback"), f(
        l,
        "href",
        /*feedbackurl*/
        t[2]
      ), f(l, "target", r = `_${/*feedbackurltarget*/
      t[5]}`), f(l, "class", "svelte-g86co"), f(n, "class", "feedback-link svelte-g86co"), f(e, "data-testid", "feedback");
    },
    m(a, s) {
      D(a, e, s), _(e, i), _(e, n), _(n, l), _(l, o);
    },
    p(a, s) {
      s & /*feedbackurl*/
      4 && f(
        l,
        "href",
        /*feedbackurl*/
        a[2]
      ), s & /*feedbackurltarget*/
      32 && r !== (r = `_${/*feedbackurltarget*/
      a[5]}`) && f(l, "target", r);
    },
    d(a) {
      a && P(e);
    }
  };
}
function zo(t) {
  let e, i = Eo(
    /*type*/
    t[0]
  ) + "", n, l, o, r, a, s, d, u, c;
  function g(v, b) {
    if (
      /*feedbackurl*/
      v[2]
    ) return R1;
    if (
      /*_hasfeedbackhandler*/
      v[8]
    ) return W1;
  }
  let h = g(t), m = h && h(t);
  return {
    c() {
      e = C("div"), n = le(i), o = x(), r = C("div"), a = le("This is a new "), s = C("a"), d = le("Alberta Government"), c = le(`
        service

        `), m && m.c(), f(e, "data-testid", "type"), f(e, "class", l = "service-type service-type--" + /*type*/
      t[0].toLowerCase() + " svelte-g86co"), f(s, "href", "https://www.alberta.ca/index.aspx"), f(s, "target", u = `_${/*headerurltarget*/
      t[4]}`), f(s, "class", "svelte-g86co"), f(r, "data-testid", "site-text"), f(r, "class", "site-text svelte-g86co");
    },
    m(v, b) {
      D(v, e, b), _(e, n), D(v, o, b), D(v, r, b), _(r, a), _(r, s), _(s, d), _(r, c), m && m.m(r, null);
    },
    p(v, b) {
      b & /*type*/
      1 && i !== (i = Eo(
        /*type*/
        v[0]
      ) + "") && pe(n, i), b & /*type*/
      1 && l !== (l = "service-type service-type--" + /*type*/
      v[0].toLowerCase() + " svelte-g86co") && f(e, "class", l), b & /*headerurltarget*/
      16 && u !== (u = `_${/*headerurltarget*/
      v[4]}`) && f(s, "target", u), h === (h = g(v)) && m ? m.p(v, b) : (m && m.d(1), m = h && h(v), m && (m.c(), m.m(r, null)));
    },
    d(v) {
      v && (P(e), P(o), P(r)), m && m.d();
    }
  };
}
function W1(t) {
  let e, i, n, l, o;
  return {
    c() {
      e = C("span"), i = le(`— help us improve it by giving
            
            `), n = C("a"), n.textContent = "feedback", f(n, "href", "#"), f(n, "class", "svelte-g86co"), f(e, "data-testid", "feedback-click");
    },
    m(r, a) {
      D(r, e, a), _(e, i), _(e, n), t[15](e), l || (o = te(
        n,
        "click",
        /*handleFeedbackClick*/
        t[9]
      ), l = !0);
    },
    p: ve,
    d(r) {
      r && P(e), t[15](null), l = !1, o();
    }
  };
}
function R1(t) {
  let e, i, n, l, o, r;
  return {
    c() {
      e = C("span"), i = le(`— help us improve it by giving
            `), n = C("span"), l = C("a"), o = le("feedback"), f(
        l,
        "href",
        /*feedbackurl*/
        t[2]
      ), f(l, "target", r = `_${/*feedbackurltarget*/
      t[5]}`), f(l, "class", "svelte-g86co"), f(n, "class", "feedback-link svelte-g86co"), f(e, "data-testid", "feedback");
    },
    m(a, s) {
      D(a, e, s), _(e, i), _(e, n), _(n, l), _(l, o);
    },
    p(a, s) {
      s & /*feedbackurl*/
      4 && f(
        l,
        "href",
        /*feedbackurl*/
        a[2]
      ), s & /*feedbackurltarget*/
      32 && r !== (r = `_${/*feedbackurltarget*/
      a[5]}`) && f(l, "target", r);
    },
    d(a) {
      a && P(e);
    }
  };
}
function jo(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[13].version
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[12],
    yo
  ), o = l || Y1(t);
  return {
    c() {
      e = C("div"), o && o.c(), f(e, "data-testid", "version"), f(e, "class", "version svelte-g86co");
    },
    m(r, a) {
      D(r, e, a), o && o.m(e, null), i = !0;
    },
    p(r, a) {
      l ? l.p && (!i || a & /*$$scope*/
      4096) && ae(
        l,
        n,
        r,
        /*$$scope*/
        r[12],
        i ? re(
          n,
          /*$$scope*/
          r[12],
          a,
          x1
        ) : se(
          /*$$scope*/
          r[12]
        ),
        yo
      ) : o && o.p && (!i || a & /*version*/
      2) && o.p(r, i ? a : -1);
    },
    i(r) {
      i || (Y(o, r), i = !0);
    },
    o(r) {
      U(o, r), i = !1;
    },
    d(r) {
      r && P(e), o && o.d(r);
    }
  };
}
function Y1(t) {
  let e;
  return {
    c() {
      e = le(
        /*version*/
        t[1]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*version*/
      2 && pe(
        e,
        /*version*/
        i[1]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function Z1(t) {
  let e, i, n, l = ["alpha", "beta"].includes(
    /*type*/
    t[0]
  ), o, r, a, s, d, u = (
    /*type*/
    t[0] === "live" && Co(t)
  ), c = l && zo(t), g = (
    /*$$slots*/
    (t[10].version || /*version*/
    t[1]) && jo(t)
  );
  return {
    c() {
      e = C("div"), i = C("div"), u && u.c(), n = x(), c && c.c(), o = x(), r = C("div"), a = x(), g && g.c(), f(r, "class", "spacer svelte-g86co"), f(i, "class", "content-container svelte-g86co"), f(i, "style", s = `--max-content-width: ${/*maxcontentwidth*/
      t[3]}`), f(e, "id", "container"), f(
        e,
        "data-testid",
        /*testid*/
        t[6]
      ), f(e, "class", "svelte-g86co");
    },
    m(h, m) {
      D(h, e, m), _(e, i), u && u.m(i, null), _(i, n), c && c.m(i, null), _(i, o), _(i, r), _(i, a), g && g.m(i, null), d = !0;
    },
    p(h, [m]) {
      /*type*/
      h[0] === "live" ? u ? u.p(h, m) : (u = Co(h), u.c(), u.m(i, n)) : u && (u.d(1), u = null), m & /*type*/
      1 && (l = ["alpha", "beta"].includes(
        /*type*/
        h[0]
      )), l ? c ? c.p(h, m) : (c = zo(h), c.c(), c.m(i, o)) : c && (c.d(1), c = null), /*$$slots*/
      h[10].version || /*version*/
      h[1] ? g ? (g.p(h, m), m & /*$$slots, version*/
      1026 && Y(g, 1)) : (g = jo(h), g.c(), Y(g, 1), g.m(i, null)) : g && (Oe(), U(g, 1, 1, () => {
        g = null;
      }), Fe()), (!d || m & /*maxcontentwidth*/
      8 && s !== (s = `--max-content-width: ${/*maxcontentwidth*/
      h[3]}`)) && f(i, "style", s), (!d || m & /*testid*/
      64) && f(
        e,
        "data-testid",
        /*testid*/
        h[6]
      );
    },
    i(h) {
      d || (Y(g), d = !0);
    },
    o(h) {
      U(g), d = !1;
    },
    d(h) {
      h && P(e), u && u.d(), c && c.d(), g && g.d();
    }
  };
}
function Eo(t) {
  return !t || t && t.length === 0 ? "" : t[0].toUpperCase() + t.slice(1);
}
function U1(t, e, i) {
  let n, { $$slots: l = {}, $$scope: o } = e;
  const r = pt(l), [a, s] = Me("Microsite header type", ["live", "alpha", "beta"], !0);
  let { type: d } = e, { version: u = "" } = e, { feedbackurl: c = "" } = e, { maxcontentwidth: g = "100%" } = e, { headerurltarget: h = "blank" } = e, { feedbackurltarget: m = "blank" } = e, { hasfeedbackhandler: v = "false" } = e, { testid: b = "" } = e;
  const [w, y] = Me("URL target values", ["self", "blank"]);
  let j;
  function E(z) {
    n == !0 && (z.preventDefault(), j.dispatchEvent(new CustomEvent("_feedbackClick", { composed: !0, bubbles: !0 })));
  }
  ke(async () => {
    setTimeout(() => s(d), 1), y(h), y(m);
  });
  function M(z) {
    ue[z ? "unshift" : "push"](() => {
      j = z, i(7, j);
    });
  }
  function L(z) {
    ue[z ? "unshift" : "push"](() => {
      j = z, i(7, j);
    });
  }
  return t.$$set = (z) => {
    "type" in z && i(0, d = z.type), "version" in z && i(1, u = z.version), "feedbackurl" in z && i(2, c = z.feedbackurl), "maxcontentwidth" in z && i(3, g = z.maxcontentwidth), "headerurltarget" in z && i(4, h = z.headerurltarget), "feedbackurltarget" in z && i(5, m = z.feedbackurltarget), "hasfeedbackhandler" in z && i(11, v = z.hasfeedbackhandler), "testid" in z && i(6, b = z.testid), "$$scope" in z && i(12, o = z.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*hasfeedbackhandler*/
    2048 && i(8, n = Ce(v));
  }, [
    d,
    u,
    c,
    g,
    h,
    m,
    b,
    j,
    n,
    E,
    r,
    v,
    o,
    l,
    M,
    L
  ];
}
class G1 extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      U1,
      Z1,
      ce,
      {
        type: 0,
        version: 1,
        feedbackurl: 2,
        maxcontentwidth: 3,
        headerurltarget: 4,
        feedbackurltarget: 5,
        hasfeedbackhandler: 11,
        testid: 6
      },
      I1
    );
  }
  get type() {
    return this.$$.ctx[0];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get version() {
    return this.$$.ctx[1];
  }
  set version(e) {
    this.$$set({ version: e }), k();
  }
  get feedbackurl() {
    return this.$$.ctx[2];
  }
  set feedbackurl(e) {
    this.$$set({ feedbackurl: e }), k();
  }
  get maxcontentwidth() {
    return this.$$.ctx[3];
  }
  set maxcontentwidth(e) {
    this.$$set({ maxcontentwidth: e }), k();
  }
  get headerurltarget() {
    return this.$$.ctx[4];
  }
  set headerurltarget(e) {
    this.$$set({ headerurltarget: e }), k();
  }
  get feedbackurltarget() {
    return this.$$.ctx[5];
  }
  set feedbackurltarget(e) {
    this.$$set({ feedbackurltarget: e }), k();
  }
  get hasfeedbackhandler() {
    return this.$$.ctx[11];
  }
  set hasfeedbackhandler(e) {
    this.$$set({ hasfeedbackhandler: e }), k();
  }
  get testid() {
    return this.$$.ctx[6];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-microsite-header", he(G1, { type: {}, version: {}, feedbackurl: {}, maxcontentwidth: {}, headerurltarget: {}, feedbackurltarget: {}, hasfeedbackhandler: {}, testid: {} }, ["version"], [], !0));
function K1(t) {
  _e(t, "svelte-1phvpc7", `:host{box-sizing:border-box;font-family:var(--goa-font-family-sans);position:relative;z-index:99999}:host .svelte-1phvpc7.svelte-1phvpc7{box-sizing:border-box}.modal.svelte-1phvpc7.svelte-1phvpc7{font-family:var(--goa-font-family-sans);position:fixed;inset:0;display:flex;align-items:center;justify-content:center;height:100vh;width:100%;z-index:3}.modal-overlay.svelte-1phvpc7.svelte-1phvpc7{position:absolute;top:0;left:0;width:100%;height:100%;background-color:var(--goa-modal-overlay-color);z-index:1;opacity:var(--goa-modal-overlay-opacity)}.emergency.svelte-1phvpc7.svelte-1phvpc7{background-color:var(--goa-color-emergency-default)}.important.svelte-1phvpc7.svelte-1phvpc7{background-color:var(--goa-color-warning-default)}.information.svelte-1phvpc7.svelte-1phvpc7{background-color:var(--goa-color-info-default)}.event.svelte-1phvpc7.svelte-1phvpc7{background-color:var(--goa-color-info-default)}.success.svelte-1phvpc7.svelte-1phvpc7{background-color:var(--goa-color-success-default)}.callout-bar.svelte-1phvpc7.svelte-1phvpc7{flex:0 0 3rem;text-align:center;padding:var(--goa-modal-callout-bar-padding) 0 0 0;border-radius:var(--goa-modal-border-radius) 0px 0px var(--goa-modal-border-radius)}.content.svelte-1phvpc7.svelte-1phvpc7{flex:1 1 auto;width:100%;padding:var(--goa-modal-padding) var(--goa-modal-padding) 0 var(--goa-modal-padding)}.content.svelte-1phvpc7 header.svelte-1phvpc7{display:flex;justify-content:space-between;margin-bottom:var(--goa-modal-padding)}header.has-content.svelte-1phvpc7.svelte-1phvpc7{margin-bottom:var(--goa-modal-content-gap)}@media(max-width: 623px){.content.svelte-1phvpc7.svelte-1phvpc7{padding:var(--goa-modal-padding-small-screen) var(--goa-modal-padding-small-screen) 0 var(--goa-modal-padding-small-screen)}header.has-content.svelte-1phvpc7.svelte-1phvpc7{margin-bottom:var(--goa-modal-content-gap-small-screen)}.modal-actions.svelte-1phvpc7 ::slotted(*){padding:0}.modal-content.svelte-1phvpc7 ::slotted(:last-child){margin-bottom:var(--goa-space-xs) !important}.modal-pane.svelte-1phvpc7.svelte-1phvpc7{flex-direction:column}.callout-bar.svelte-1phvpc7.svelte-1phvpc7{text-align:left;padding:var(--goa-modal-callout-bar-padding-small-screen);border-radius:var(--goa-modal-border-radius) var(--goa-modal-border-radius) 0px 0px;height:var(--goa-space-2xl)}.modal-content.svelte-1phvpc7.svelte-1phvpc7{margin:0 -1.5rem;box-shadow:none}:host{--scrollable-padding:var(--goa-scrollable-padding-mobile)}}@media(min-width: 624px){.modal-pane.svelte-1phvpc7.svelte-1phvpc7{max-width:var(--maxwidth)}.modal-content.svelte-1phvpc7.svelte-1phvpc7{margin:0 -2rem;box-shadow:none}:host{--scrollable-padding:var(--goa-scrollable-padding-desktop)}}.modal-pane.svelte-1phvpc7.svelte-1phvpc7{background-color:#fff;z-index:2;width:90%;display:flex;box-shadow:var(--goa-shadow-modal);border-radius:var(--goa-modal-border-radius)}.modal-content.svelte-1phvpc7 ::slotted(:last-child){margin-bottom:var(--goa-space-m) !important}.modal-title.svelte-1phvpc7.svelte-1phvpc7{font:var(--goa-modal-header-typography)}.modal-close.svelte-1phvpc7.svelte-1phvpc7{padding-left:var(--goa-space-m)}.modal-actions.svelte-1phvpc7.svelte-1phvpc7{width:100%;padding:var(--goa-space-m) 0 var(--goa-modal-padding) 0;margin:auto 0 0 0;text-align:right}.modal-actions.empty-actions.svelte-1phvpc7.svelte-1phvpc7{padding:0 0 var(--goa-modal-padding) 0}.modal.top.svelte-1phvpc7 .modal-content.svelte-1phvpc7{box-shadow:inset 0 -8px 8px -8px rgba(0, 0, 0, 0.3)}.modal.bottom.svelte-1phvpc7 .modal-content.svelte-1phvpc7{box-shadow:inset 0 8px 8px -8px rgba(0, 0, 0, 0.3)}.modal.middle.svelte-1phvpc7 .modal-content.svelte-1phvpc7{box-shadow:inset 0 8px 8px -8px rgba(0, 0, 0, 0.2),
      inset 0 -8px 8px -8px rgba(0, 0, 0, 0.2)}`);
}
const X1 = (t) => ({}), Mo = (t) => ({}), J1 = (t) => ({}), Lo = (t) => ({}), Q1 = (t) => ({}), qo = (t) => ({});
function So(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v, b, w, y, j, E, M, L, z, V, T = (
    /*calloutvariant*/
    t[3] !== null && To(t)
  ), S = (
    /*heading*/
    (t[1] || /*_isClosable*/
    t[15] || /*$$slots*/
    t[20].heading) && Po(t)
  );
  const A = (
    /*#slots*/
    t[25].content
  ), R = oe(
    A,
    t,
    /*$$scope*/
    t[24],
    Lo
  ), I = R || tg(t), B = (
    /*#slots*/
    t[25].actions
  ), N = oe(
    B,
    t,
    /*$$scope*/
    t[24],
    Mo
  );
  return {
    c() {
      e = C("goa-focus-trap"), i = C("div"), n = C("div"), l = x(), o = C("div"), T && T.c(), r = x(), a = C("div"), S && S.c(), s = x(), d = C("div"), u = C("goa-scrollable"), I && I.c(), g = x(), h = C("div"), N && N.c(), f(n, "data-testid", "modal-overlay"), f(n, "class", "modal-overlay svelte-1phvpc7"), p(u, "direction", "vertical"), p(u, "hpadding", "var(--scrollable-padding)"), p(u, "maxheight", c = "calc(100vh - " + /*_headerHeight*/
      t[14] + "px - var(--goa-space-xl) - " + /*_actionsHeight*/
      t[12] + "px - " + Ho + "px)"), p(u, "class", "svelte-1phvpc7"), f(d, "data-testid", "modal-content"), f(d, "class", "modal-content svelte-1phvpc7"), f(h, "class", "modal-actions svelte-1phvpc7"), f(h, "data-testid", "modal-actions"), We(() => (
        /*div2_elementresize_handler*/
        t[29].call(h)
      )), G(h, "empty-actions", !/*_actionsSlotHasContent*/
      t[13]), f(a, "class", "content svelte-1phvpc7"), f(o, "class", "modal-pane svelte-1phvpc7"), f(o, "tabindex", "-1"), f(
        o,
        "role",
        /*role*/
        t[5]
      ), f(o, "aria-modal", "true"), f(o, "aria-labelledby", "goa-modal-heading"), f(
        i,
        "data-testid",
        /*testid*/
        t[4]
      ), f(i, "class", w = Ee(`modal ${/*_scrollPos*/
      t[10] ?? ""}`) + " svelte-1phvpc7"), f(i, "style", y = `--maxwidth: ${/*maxwidth*/
      t[0]}; --actions-height: ${/*_actionsHeight*/
      t[12]}px; --header-height: ${/*_headerHeight*/
      t[14]}`), f(i, "role", "presentation"), p(
        e,
        "open",
        /*open*/
        t[2]
      ), p(e, "class", "svelte-1phvpc7");
    },
    m(F, q) {
      D(F, e, q), _(e, i), _(i, n), _(i, l), _(i, o), T && T.m(o, null), _(o, r), _(o, a), S && S.m(a, null), _(a, s), _(a, d), _(d, u), I && I.m(u, null), t[28](u), _(a, g), _(a, h), N && N.m(h, null), m = ki(
        h,
        /*div2_elementresize_handler*/
        t[29].bind(h)
      ), t[30](i), L = !0, z || (V = [
        te(
          n,
          "click",
          /*close*/
          t[18]
        ),
        te(
          u,
          "_scroll",
          /*handleScroll*/
          t[19]
        ),
        Fi(j = Yi.call(null, i, { enable: (
          /*_isOpen*/
          t[9]
        ) }))
      ], z = !0);
    },
    p(F, q) {
      t = F, /*calloutvariant*/
      t[3] !== null ? T ? T.p(t, q) : (T = To(t), T.c(), T.m(o, r)) : T && (T.d(1), T = null), /*heading*/
      t[1] || /*_isClosable*/
      t[15] || /*$$slots*/
      t[20].heading ? S ? (S.p(t, q), q[0] & /*heading, _isClosable, $$slots*/
      1081346 && Y(S, 1)) : (S = Po(t), S.c(), Y(S, 1), S.m(a, s)) : S && (Oe(), U(S, 1, 1, () => {
        S = null;
      }), Fe()), R ? R.p && (!L || q[0] & /*$$scope*/
      16777216) && ae(
        R,
        A,
        t,
        /*$$scope*/
        t[24],
        L ? re(
          A,
          /*$$scope*/
          t[24],
          q,
          J1
        ) : se(
          /*$$scope*/
          t[24]
        ),
        Lo
      ) : I && I.p && (!L || q[0] & /*$$scope*/
      16777216) && I.p(t, L ? q : [-1, -1]), (!L || q[0] & /*_headerHeight, _actionsHeight*/
      20480 && c !== (c = "calc(100vh - " + /*_headerHeight*/
      t[14] + "px - var(--goa-space-xl) - " + /*_actionsHeight*/
      t[12] + "px - " + Ho + "px)")) && p(u, "maxheight", c), N && N.p && (!L || q[0] & /*$$scope*/
      16777216) && ae(
        N,
        B,
        t,
        /*$$scope*/
        t[24],
        L ? re(
          B,
          /*$$scope*/
          t[24],
          q,
          X1
        ) : se(
          /*$$scope*/
          t[24]
        ),
        Mo
      ), (!L || q[0] & /*_actionsSlotHasContent*/
      8192) && G(h, "empty-actions", !/*_actionsSlotHasContent*/
      t[13]), (!L || q[0] & /*role*/
      32) && f(
        o,
        "role",
        /*role*/
        t[5]
      ), (!L || q[0] & /*testid*/
      16) && f(
        i,
        "data-testid",
        /*testid*/
        t[4]
      ), (!L || q[0] & /*_scrollPos*/
      1024 && w !== (w = Ee(`modal ${/*_scrollPos*/
      t[10] ?? ""}`) + " svelte-1phvpc7")) && f(i, "class", w), (!L || q[0] & /*maxwidth, _actionsHeight, _headerHeight*/
      20481 && y !== (y = `--maxwidth: ${/*maxwidth*/
      t[0]}; --actions-height: ${/*_actionsHeight*/
      t[12]}px; --header-height: ${/*_headerHeight*/
      t[14]}`)) && f(i, "style", y), j && ot(j.update) && q[0] & /*_isOpen*/
      512 && j.update.call(null, { enable: (
        /*_isOpen*/
        t[9]
      ) }), (!L || q[0] & /*open*/
      4) && p(
        e,
        "open",
        /*open*/
        t[2]
      );
    },
    i(F) {
      L || (Y(S), Y(I, F), Y(N, F), F && We(() => {
        L && (b && b.end(1), v = Xi(o, Wn, {
          duration: (
            /*_transitionTime*/
            t[17]
          ),
          y: 200
        }), v.start());
      }), F && We(() => {
        L && (M && M.end(1), E = Xi(i, xt, { duration: (
          /*_transitionTime*/
          t[17]
        ) }), E.start());
      }), L = !0);
    },
    o(F) {
      U(S), U(I, F), U(N, F), v && v.invalidate(), F && (b = Ji(o, Wn, {
        delay: (
          /*_transitionTime*/
          t[17]
        ),
        duration: (
          /*_transitionTime*/
          t[17]
        ),
        y: -100
      })), E && E.invalidate(), F && (M = Ji(i, xt, {
        delay: (
          /*_transitionTime*/
          t[17]
        ),
        duration: (
          /*_transitionTime*/
          t[17]
        )
      })), L = !1;
    },
    d(F) {
      F && P(e), T && T.d(), S && S.d(), I && I.d(F), t[28](null), N && N.d(F), m(), F && b && b.end(), t[30](null), F && M && M.end(), z = !1, He(V);
    }
  };
}
function To(t) {
  let e, i, n, l;
  return {
    c() {
      e = C("div"), i = C("goa-icon"), p(
        i,
        "type",
        /*_iconType*/
        t[16]
      ), p(i, "inverted", n = /*calloutvariant*/
      t[3] === "important" ? "false" : "true"), p(i, "class", "svelte-1phvpc7"), f(e, "class", l = "callout-bar " + /*calloutvariant*/
      t[3] + " svelte-1phvpc7");
    },
    m(o, r) {
      D(o, e, r), _(e, i);
    },
    p(o, r) {
      r[0] & /*_iconType*/
      65536 && p(
        i,
        "type",
        /*_iconType*/
        o[16]
      ), r[0] & /*calloutvariant*/
      8 && n !== (n = /*calloutvariant*/
      o[3] === "important" ? "false" : "true") && p(i, "inverted", n), r[0] & /*calloutvariant*/
      8 && l !== (l = "callout-bar " + /*calloutvariant*/
      o[3] + " svelte-1phvpc7") && f(e, "class", l);
    },
    d(o) {
      o && P(e);
    }
  };
}
function Po(t) {
  let e, i, n, l, o, r, a;
  const s = [eg, $1], d = [];
  function u(g, h) {
    return (
      /*heading*/
      g[1] ? 0 : 1
    );
  }
  n = u(t), l = d[n] = s[n](t);
  let c = (
    /*_isClosable*/
    t[15] && Do(t)
  );
  return {
    c() {
      e = C("header"), i = C("div"), l.c(), o = x(), c && c.c(), f(i, "data-testid", "modal-title"), f(i, "class", "modal-title svelte-1phvpc7"), f(i, "id", "goa-modal-heading"), f(e, "class", "svelte-1phvpc7"), We(() => (
        /*header_elementresize_handler*/
        t[27].call(e)
      )), G(
        e,
        "has-content",
        /*_requiresTopPadding*/
        t[11]
      );
    },
    m(g, h) {
      D(g, e, h), _(e, i), d[n].m(i, null), _(e, o), c && c.m(e, null), t[26](e), r = ki(
        e,
        /*header_elementresize_handler*/
        t[27].bind(e)
      ), a = !0;
    },
    p(g, h) {
      let m = n;
      n = u(g), n === m ? d[n].p(g, h) : (Oe(), U(d[m], 1, 1, () => {
        d[m] = null;
      }), Fe(), l = d[n], l ? l.p(g, h) : (l = d[n] = s[n](g), l.c()), Y(l, 1), l.m(i, null)), /*_isClosable*/
      g[15] ? c ? c.p(g, h) : (c = Do(g), c.c(), c.m(e, null)) : c && (c.d(1), c = null), (!a || h[0] & /*_requiresTopPadding*/
      2048) && G(
        e,
        "has-content",
        /*_requiresTopPadding*/
        g[11]
      );
    },
    i(g) {
      a || (Y(l), a = !0);
    },
    o(g) {
      U(l), a = !1;
    },
    d(g) {
      g && P(e), d[n].d(), c && c.d(), t[26](null), r();
    }
  };
}
function $1(t) {
  let e;
  const i = (
    /*#slots*/
    t[25].heading
  ), n = oe(
    i,
    t,
    /*$$scope*/
    t[24],
    qo
  );
  return {
    c() {
      n && n.c();
    },
    m(l, o) {
      n && n.m(l, o), e = !0;
    },
    p(l, o) {
      n && n.p && (!e || o[0] & /*$$scope*/
      16777216) && ae(
        n,
        i,
        l,
        /*$$scope*/
        l[24],
        e ? re(
          i,
          /*$$scope*/
          l[24],
          o,
          Q1
        ) : se(
          /*$$scope*/
          l[24]
        ),
        qo
      );
    },
    i(l) {
      e || (Y(n, l), e = !0);
    },
    o(l) {
      U(n, l), e = !1;
    },
    d(l) {
      n && n.d(l);
    }
  };
}
function eg(t) {
  let e;
  return {
    c() {
      e = le(
        /*heading*/
        t[1]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n[0] & /*heading*/
      2 && pe(
        e,
        /*heading*/
        i[1]
      );
    },
    i: ve,
    o: ve,
    d(i) {
      i && P(e);
    }
  };
}
function Do(t) {
  let e, i, n, l;
  return {
    c() {
      e = C("div"), i = C("goa-icon-button"), p(i, "size", "medium"), p(i, "data-ignore-focus", "true"), p(i, "data-testid", "modal-close-button"), p(i, "arialabel", "Close the modal"), p(i, "icon", "close"), p(i, "theme", "filled"), p(i, "variant", "dark"), p(i, "class", "svelte-1phvpc7"), f(e, "class", "modal-close svelte-1phvpc7");
    },
    m(o, r) {
      D(o, e, r), _(e, i), n || (l = te(
        i,
        "click",
        /*close*/
        t[18]
      ), n = !0);
    },
    p: ve,
    d(o) {
      o && P(e), n = !1, l();
    }
  };
}
function tg(t) {
  let e;
  const i = (
    /*#slots*/
    t[25].default
  ), n = oe(
    i,
    t,
    /*$$scope*/
    t[24],
    null
  );
  return {
    c() {
      n && n.c();
    },
    m(l, o) {
      n && n.m(l, o), e = !0;
    },
    p(l, o) {
      n && n.p && (!e || o[0] & /*$$scope*/
      16777216) && ae(
        n,
        i,
        l,
        /*$$scope*/
        l[24],
        e ? re(
          i,
          /*$$scope*/
          l[24],
          o,
          null
        ) : se(
          /*$$scope*/
          l[24]
        ),
        null
      );
    },
    i(l) {
      e || (Y(n, l), e = !0);
    },
    o(l) {
      U(n, l), e = !1;
    },
    d(l) {
      n && n.d(l);
    }
  };
}
function ig(t) {
  let e, i, n = (
    /*_isOpen*/
    t[9] && So(t)
  );
  return {
    c() {
      n && n.c(), e = Ne();
    },
    m(l, o) {
      n && n.m(l, o), D(l, e, o), i = !0;
    },
    p(l, o) {
      /*_isOpen*/
      l[9] ? n ? (n.p(l, o), o[0] & /*_isOpen*/
      512 && Y(n, 1)) : (n = So(l), n.c(), Y(n, 1), n.m(e.parentNode, e)) : n && (Oe(), U(n, 1, 1, () => {
        n = null;
      }), Fe());
    },
    i(l) {
      i || (Y(n), i = !0);
    },
    o(l) {
      U(n), i = !1;
    },
    d(l) {
      l && P(e), n && n.d(l);
    }
  };
}
let Ho = 128;
function ng(t, e, i) {
  let n, l, o, { $$slots: r = {}, $$scope: a } = e;
  const s = pt(r);
  let { heading: d = "" } = e, { closable: u = "false" } = e, { open: c = "false" } = e, { transition: g = "none" } = e, { calloutvariant: h = null } = e, { maxwidth: m = "60ch" } = e, { testid: v = "modal" } = e, { width: b = "" } = e, { role: w = "dialog" } = e, y = null, j = "top", E, M, L = !1, z, V, T = !1, S;
  const [A, R] = Me("Callout variant", ["emergency", "important", "information", "success", "event"]), [I, B] = Me("Modal transition", ["fast", "slow", "none"]), [N, F] = Me("Modal Role", ["dialog", "alertdialog"]);
  ke(async () => {
    await Pe(), R(h), B(g), F(w), window.addEventListener("keydown", O), b && (i(0, m = b), console.warn("`width` is deprecated. Please use `maxwidth` instead."));
  }), ct(() => {
    window.removeEventListener("keydown", O);
  });
  async function q() {
    await Pe(), i(13, T = !!(y != null && y.querySelector('[name="actions"]')));
  }
  function H(X) {
    n && (y == null || y.dispatchEvent(new CustomEvent("_close", { composed: !0 })), X.stopPropagation());
  }
  const O = (X) => {
    if (L)
      switch (X.key) {
        case "Escape":
          H(X), X.preventDefault();
          break;
      }
  };
  function W(X) {
    const ee = X.detail.scrollHeight > X.detail.offsetHeight;
    !L || !ee || (X.detail.scrollTop == 0 ? i(10, j = "top") : /* bottom */ Math.abs(X.detail.scrollHeight - X.detail.scrollTop - X.detail.offsetHeight) < 1 ? i(10, j = "bottom") : i(10, j = "middle"));
  }
  function K(X) {
    ue[X ? "unshift" : "push"](() => {
      M = X, i(8, M);
    });
  }
  function $() {
    S = this.clientHeight, i(14, S);
  }
  function ye(X) {
    ue[X ? "unshift" : "push"](() => {
      E = X, i(7, E);
    });
  }
  function Z() {
    V = this.clientHeight, i(12, V);
  }
  function Q(X) {
    ue[X ? "unshift" : "push"](() => {
      y = X, i(6, y);
    });
  }
  return t.$$set = (X) => {
    "heading" in X && i(1, d = X.heading), "closable" in X && i(21, u = X.closable), "open" in X && i(2, c = X.open), "transition" in X && i(22, g = X.transition), "calloutvariant" in X && i(3, h = X.calloutvariant), "maxwidth" in X && i(0, m = X.maxwidth), "testid" in X && i(4, v = X.testid), "width" in X && i(23, b = X.width), "role" in X && i(5, w = X.role), "$$scope" in X && i(24, a = X.$$scope);
  }, t.$$.update = () => {
    var X;
    if (t.$$.dirty[0] & /*closable*/
    2097152 && i(15, n = Ce(u)), t.$$.dirty[0] & /*open*/
    4 && setTimeout(() => i(9, L = Ce(c)), 1), t.$$.dirty[0] & /*_isOpen, _scrollEl*/
    640 && L && E) {
      const ee = E.scrollHeight > E.offsetHeight;
      i(10, j = ee ? "top" : null);
    }
    t.$$.dirty[0] & /*_isOpen, _rootEl, _headerEl*/
    832 && L && y && M && i(11, z = !!((X = M == null ? void 0 : M.querySelector("div.modal-title")) != null && X.textContent) || !!(M != null && M.querySelector("div.modal-close")) || lt(M).length > 0), t.$$.dirty[0] & /*transition*/
    4194304 && i(17, l = g === "none" ? 0 : g === "slow" ? 400 : 200), t.$$.dirty[0] & /*_isOpen*/
    512 && L && q(), t.$$.dirty[0] & /*calloutvariant*/
    8 && i(16, o = h === "emergency" ? "warning" : h === "important" ? "alert-circle" : h === "information" ? "information-circle" : h === "success" ? "checkmark-circle" : h === "event" ? "calendar" : "");
  }, [
    m,
    d,
    c,
    h,
    v,
    w,
    y,
    E,
    M,
    L,
    j,
    z,
    V,
    T,
    S,
    n,
    o,
    l,
    H,
    W,
    s,
    u,
    g,
    b,
    a,
    r,
    K,
    $,
    ye,
    Z,
    Q
  ];
}
class lg extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      ng,
      ig,
      ce,
      {
        heading: 1,
        closable: 21,
        open: 2,
        transition: 22,
        calloutvariant: 3,
        maxwidth: 0,
        testid: 4,
        width: 23,
        role: 5
      },
      K1,
      [-1, -1]
    );
  }
  get heading() {
    return this.$$.ctx[1];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get closable() {
    return this.$$.ctx[21];
  }
  set closable(e) {
    this.$$set({ closable: e }), k();
  }
  get open() {
    return this.$$.ctx[2];
  }
  set open(e) {
    this.$$set({ open: e }), k();
  }
  get transition() {
    return this.$$.ctx[22];
  }
  set transition(e) {
    this.$$set({ transition: e }), k();
  }
  get calloutvariant() {
    return this.$$.ctx[3];
  }
  set calloutvariant(e) {
    this.$$set({ calloutvariant: e }), k();
  }
  get maxwidth() {
    return this.$$.ctx[0];
  }
  set maxwidth(e) {
    this.$$set({ maxwidth: e }), k();
  }
  get testid() {
    return this.$$.ctx[4];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get width() {
    return this.$$.ctx[23];
  }
  set width(e) {
    this.$$set({ width: e }), k();
  }
  get role() {
    return this.$$.ctx[5];
  }
  set role(e) {
    this.$$set({ role: e }), k();
  }
}
customElements.define("goa-modal", he(lg, { heading: {}, closable: {}, open: {}, transition: {}, calloutvariant: {}, maxwidth: {}, testid: {}, width: {}, role: {} }, ["heading", "default", "content", "actions"], [], !0));
function og(t) {
  _e(t, "svelte-1832471", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}#container.svelte-1832471.svelte-1832471{container:self / inline-size}.notification.svelte-1832471.svelte-1832471{padding:var(--goa-notification-banner-padding-tb) var(--goa-notification-banner-padding-lr-small-screen);display:flex}@container self (min-width: 624px){.notification.svelte-1832471.svelte-1832471{padding:var(--goa-notification-banner-padding-tb) var(--goa-notification-banner-padding-lr-medium-screen)}}@container self (min-width: 1024px){.notification.svelte-1832471.svelte-1832471{padding:var(--goa-notification-banner-padding-tb) var(--goa-notification-banner-padding-lr-large-screen)}}.emergency.svelte-1832471.svelte-1832471{background-color:var(--goa-notification-banner-emergency-color-bg);color:var(--goa-notification-banner-emergency-color-text)}.important.svelte-1832471.svelte-1832471{background-color:var(--goa-notification-banner-important-color-bg);color:var(--goa-notification-banner-important-color-text)}.information.svelte-1832471.svelte-1832471{background-color:var(--goa-notification-banner-information-color-bg);color:var(--goa-notification-banner-information-color-text)}.event.svelte-1832471.svelte-1832471{background-color:var(--goa-notification-banner-event-color-bg);color:var(--goa-notification-banner-event-color-text)}.icon.svelte-1832471.svelte-1832471{flex:0 0 auto;margin-top:3px}.content-container.svelte-1832471.svelte-1832471{display:flex;flex-direction:row;flex:1 1 auto;gap:var(--goa-notification-banner-gap);margin:0 auto;max-width:min(var(--max-content-width), 100%)}.content.svelte-1832471.svelte-1832471{flex:1 1 auto;font:var(--goa-notification-banner-text-size)}::slotted(a){color:unset !important;outline:unset !important}::slotted(a:focus){outline:auto !important;border-radius:var(--goa-border-radius-m)}.notification.important.svelte-1832471 ::slotted(a:focus){outline:unset !important;box-shadow:0 0 0 3px var(--goa-color-greyscale-black);border-radius:var(--goa-border-radius-m)}.close.svelte-1832471.svelte-1832471{flex:0 0 auto}.close.svelte-1832471 button.svelte-1832471{background-color:transparent;border:none;cursor:pointer;padding:var(--goa-space-2xs);margin:0;outline:none;border-radius:var(--goa-border-radius-m);display:inline-flex;transition:transform 100ms ease-in-out}.close.svelte-1832471 button.svelte-1832471:active{transform:translateY(2px)}.close.svelte-1832471 button.information.svelte-1832471:hover,.close.svelte-1832471 button.information.svelte-1832471:focus-visible{background-color:var(--goa-color-info-dark)}.close.svelte-1832471 button.information.svelte-1832471:focus-visible{box-shadow:0 0 0 3px var(--goa-color-greyscale-white)}.close.svelte-1832471 button.event.svelte-1832471:hover,.close.svelte-1832471 button.event.svelte-1832471:focus-visible{background-color:var(--goa-color-info-dark)}.close.svelte-1832471 button.event.svelte-1832471:focus-visible{box-shadow:0 0 0 3px var(--goa-color-greyscale-white)}.close.svelte-1832471 button.important.svelte-1832471:hover,.close.svelte-1832471 button.important.svelte-1832471:focus-visible{background-color:var(--goa-color-warning-dark)}.close.svelte-1832471 button.important.svelte-1832471:focus-visible{box-shadow:0 0 0 3px var(--goa-color-greyscale-black)}.close.svelte-1832471 button.emergency.svelte-1832471:hover,.close.svelte-1832471 button.emergency.svelte-1832471:focus-visible{background-color:var(--goa-color-emergency-dark)}.close.svelte-1832471 button.emergency.svelte-1832471:focus-visible{box-shadow:0 0 0 3px var(--goa-color-greyscale-white)}");
}
function Oo(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m, v, b, w, y, j, E;
  const M = (
    /*#slots*/
    t[8].default
  ), L = oe(
    M,
    t,
    /*$$scope*/
    t[7],
    null
  );
  return {
    c() {
      e = C("div"), i = C("div"), n = C("div"), l = C("div"), o = C("goa-icon"), a = x(), s = C("div"), L && L.c(), d = x(), u = C("div"), c = C("button"), g = C("goa-icon"), p(
        o,
        "type",
        /*iconType*/
        t[5]
      ), p(o, "inverted", r = /*type*/
      t[0] === "important" ? "false" : "true"), f(l, "class", "icon svelte-1832471"), f(s, "class", "content svelte-1832471"), p(g, "type", "close"), p(g, "inverted", h = /*type*/
      t[0] === "important" ? "false" : "true"), p(g, "theme", "filled"), f(c, "class", m = Ee(
        /*type*/
        t[0]
      ) + " svelte-1832471"), f(u, "class", "close svelte-1832471"), f(n, "class", "content-container svelte-1832471"), f(n, "role", "alert"), f(
        n,
        "aria-live",
        /*arialive*/
        t[2]
      ), f(n, "aria-atomic", "true"), f(i, "class", v = "notification " + /*type*/
      t[0] + " svelte-1832471"), f(i, "style", b = `--max-content-width: ${/*maxcontentwidth*/
      t[1]}`), f(e, "id", "container"), f(
        e,
        "data-testid",
        /*testid*/
        t[3]
      ), f(e, "class", "svelte-1832471");
    },
    m(z, V) {
      D(z, e, V), _(e, i), _(i, n), _(n, l), _(l, o), _(n, a), _(n, s), L && L.m(s, null), _(n, d), _(n, u), _(u, c), _(c, g), y = !0, j || (E = te(
        c,
        "click",
        /*close*/
        t[6]
      ), j = !0);
    },
    p(z, V) {
      (!y || V & /*iconType*/
      32) && p(
        o,
        "type",
        /*iconType*/
        z[5]
      ), (!y || V & /*type*/
      1 && r !== (r = /*type*/
      z[0] === "important" ? "false" : "true")) && p(o, "inverted", r), L && L.p && (!y || V & /*$$scope*/
      128) && ae(
        L,
        M,
        z,
        /*$$scope*/
        z[7],
        y ? re(
          M,
          /*$$scope*/
          z[7],
          V,
          null
        ) : se(
          /*$$scope*/
          z[7]
        ),
        null
      ), (!y || V & /*type*/
      1 && h !== (h = /*type*/
      z[0] === "important" ? "false" : "true")) && p(g, "inverted", h), (!y || V & /*type*/
      1 && m !== (m = Ee(
        /*type*/
        z[0]
      ) + " svelte-1832471")) && f(c, "class", m), (!y || V & /*arialive*/
      4) && f(
        n,
        "aria-live",
        /*arialive*/
        z[2]
      ), (!y || V & /*type*/
      1 && v !== (v = "notification " + /*type*/
      z[0] + " svelte-1832471")) && f(i, "class", v), (!y || V & /*maxcontentwidth*/
      2 && b !== (b = `--max-content-width: ${/*maxcontentwidth*/
      z[1]}`)) && f(i, "style", b), (!y || V & /*testid*/
      8) && f(
        e,
        "data-testid",
        /*testid*/
        z[3]
      );
    },
    i(z) {
      y || (Y(L, z), z && We(() => {
        y && (w || (w = ci(i, xt, {}, !0)), w.run(1));
      }), y = !0);
    },
    o(z) {
      U(L, z), z && (w || (w = ci(i, xt, {}, !1)), w.run(0)), y = !1;
    },
    d(z) {
      z && P(e), L && L.d(z), z && w && w.end(), j = !1, E();
    }
  };
}
function rg(t) {
  let e, i, n = (
    /*show*/
    t[4] && Oo(t)
  );
  return {
    c() {
      n && n.c(), e = Ne();
    },
    m(l, o) {
      n && n.m(l, o), D(l, e, o), i = !0;
    },
    p(l, [o]) {
      /*show*/
      l[4] ? n ? (n.p(l, o), o & /*show*/
      16 && Y(n, 1)) : (n = Oo(l), n.c(), Y(n, 1), n.m(e.parentNode, e)) : n && (Oe(), U(n, 1, 1, () => {
        n = null;
      }), Fe());
    },
    i(l) {
      i || (Y(n), i = !0);
    },
    o(l) {
      U(n), i = !1;
    },
    d(l) {
      l && P(e), n && n.d(l);
    }
  };
}
function ag(t, e, i) {
  let n, { $$slots: l = {}, $$scope: o } = e;
  const [r, a] = Me("Notification type", ["emergency", "important", "information", "event"], !0), [s, d] = Me("Aria-Live type", ["assertive", "off", "polite"], !0);
  let { type: u = "" } = e, { maxcontentwidth: c = "100%" } = e, { arialive: g = "polite" } = e, { testid: h = "" } = e, m = !0;
  ke(() => {
    d(g), setTimeout(() => a(u), 1);
  });
  function v(b) {
    var w;
    i(4, m = !1), (w = b.target) == null || w.dispatchEvent(new CustomEvent("_dismiss", { composed: !0 })), b.stopPropagation();
  }
  return t.$$set = (b) => {
    "type" in b && i(0, u = b.type), "maxcontentwidth" in b && i(1, c = b.maxcontentwidth), "arialive" in b && i(2, g = b.arialive), "testid" in b && i(3, h = b.testid), "$$scope" in b && i(7, o = b.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*type*/
    1 && i(5, n = u === "emergency" ? "warning" : u === "important" ? "alert-circle" : u === "information" ? "information-circle" : u === "event" ? "calendar" : "");
  }, [u, c, g, h, m, n, v, o, l];
}
class sg extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      ag,
      rg,
      ce,
      {
        type: 0,
        maxcontentwidth: 1,
        arialive: 2,
        testid: 3
      },
      og
    );
  }
  get type() {
    return this.$$.ctx[0];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get maxcontentwidth() {
    return this.$$.ctx[1];
  }
  set maxcontentwidth(e) {
    this.$$set({ maxcontentwidth: e }), k();
  }
  get arialive() {
    return this.$$.ctx[2];
  }
  set arialive(e) {
    this.$$set({ arialive: e }), k();
  }
  get testid() {
    return this.$$.ctx[3];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-notification", he(sg, { type: {}, maxcontentwidth: {}, arialive: {}, testid: {} }, ["default"], [], !0));
function ug(t) {
  _e(t, "svelte-13nsbkv", ".page.svelte-13nsbkv{min-height:100vh;display:flex;flex-direction:column}.header.svelte-13nsbkv,.footer.svelte-13nsbkv{flex:0 0 auto}main.svelte-13nsbkv{flex:1 1 auto}");
}
const dg = (t) => ({}), Fo = (t) => ({}), cg = (t) => ({}), Ao = (t) => ({});
function fg(t) {
  let e, i, n, l, o, r, a;
  const s = (
    /*#slots*/
    t[1].header
  ), d = oe(
    s,
    t,
    /*$$scope*/
    t[0],
    Ao
  ), u = (
    /*#slots*/
    t[1].default
  ), c = oe(
    u,
    t,
    /*$$scope*/
    t[0],
    null
  ), g = (
    /*#slots*/
    t[1].footer
  ), h = oe(
    g,
    t,
    /*$$scope*/
    t[0],
    Fo
  );
  return {
    c() {
      e = C("div"), i = C("section"), d && d.c(), n = x(), l = C("main"), c && c.c(), o = x(), r = C("section"), h && h.c(), f(i, "class", "header svelte-13nsbkv"), f(l, "class", "svelte-13nsbkv"), f(r, "class", "footer svelte-13nsbkv"), f(e, "class", "page svelte-13nsbkv");
    },
    m(m, v) {
      D(m, e, v), _(e, i), d && d.m(i, null), _(e, n), _(e, l), c && c.m(l, null), _(e, o), _(e, r), h && h.m(r, null), a = !0;
    },
    p(m, [v]) {
      d && d.p && (!a || v & /*$$scope*/
      1) && ae(
        d,
        s,
        m,
        /*$$scope*/
        m[0],
        a ? re(
          s,
          /*$$scope*/
          m[0],
          v,
          cg
        ) : se(
          /*$$scope*/
          m[0]
        ),
        Ao
      ), c && c.p && (!a || v & /*$$scope*/
      1) && ae(
        c,
        u,
        m,
        /*$$scope*/
        m[0],
        a ? re(
          u,
          /*$$scope*/
          m[0],
          v,
          null
        ) : se(
          /*$$scope*/
          m[0]
        ),
        null
      ), h && h.p && (!a || v & /*$$scope*/
      1) && ae(
        h,
        g,
        m,
        /*$$scope*/
        m[0],
        a ? re(
          g,
          /*$$scope*/
          m[0],
          v,
          dg
        ) : se(
          /*$$scope*/
          m[0]
        ),
        Fo
      );
    },
    i(m) {
      a || (Y(d, m), Y(c, m), Y(h, m), a = !0);
    },
    o(m) {
      U(d, m), U(c, m), U(h, m), a = !1;
    },
    d(m) {
      m && P(e), d && d.d(m), c && c.d(m), h && h.d(m);
    }
  };
}
function gg(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e;
  return t.$$set = (o) => {
    "$$scope" in o && i(0, l = o.$$scope);
  }, [l, n];
}
class hg extends me {
  constructor(e) {
    super(), ge(this, e, gg, fg, ce, {}, ug);
  }
}
customElements.define("goa-one-column-layout", he(hg, {}, ["header", "default", "footer"], [], !0));
const mg = /^[1-9]+[0-9]*(px|em|rem|ch|vh|vw|%)$/;
function vg(t) {
  return mg.test(t);
}
function bg(t) {
  _e(t, "svelte-13np3sb", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}.page-content.svelte-13np3sb{max-width:var(--max-width);margin:0 auto;padding:0 var(--goa-space-m)}@media not (max-width: 623px){.page-content.svelte-13np3sb{padding:0 var(--goa-space-xl)}}@media(min-width: 1024px){.page-content.svelte-13np3sb{padding:0 var(--goa-space-3xl)}}");
}
function pg(t) {
  let e, i, n;
  const l = (
    /*#slots*/
    t[4].default
  ), o = oe(
    l,
    t,
    /*$$scope*/
    t[3],
    null
  );
  return {
    c() {
      e = C("div"), o && o.c(), f(e, "class", "page-content svelte-13np3sb"), f(e, "style", i = `--max-width: ${/*_width*/
      t[0]}`), f(
        e,
        "data-testid",
        /*testid*/
        t[1]
      );
    },
    m(r, a) {
      D(r, e, a), o && o.m(e, null), n = !0;
    },
    p(r, [a]) {
      o && o.p && (!n || a & /*$$scope*/
      8) && ae(
        o,
        l,
        r,
        /*$$scope*/
        r[3],
        n ? re(
          l,
          /*$$scope*/
          r[3],
          a,
          null
        ) : se(
          /*$$scope*/
          r[3]
        ),
        null
      ), (!n || a & /*_width*/
      1 && i !== (i = `--max-width: ${/*_width*/
      r[0]}`)) && f(e, "style", i), (!n || a & /*testid*/
      2) && f(
        e,
        "data-testid",
        /*testid*/
        r[1]
      );
    },
    i(r) {
      n || (Y(o, r), n = !0);
    },
    o(r) {
      U(o, r), n = !1;
    },
    d(r) {
      r && P(e), o && o.d(r);
    }
  };
}
function _g(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e;
  const o = { full: "100%" };
  let { width: r } = e, { testid: a = "" } = e, { _width: s } = e;
  function d(u) {
    return !!(["full"].includes(r) || vg(u));
  }
  return ke(() => {
    d(r) || console.error("Invalid PageBlock width"), i(0, s = o[r] || r);
  }), t.$$set = (u) => {
    "width" in u && i(2, r = u.width), "testid" in u && i(1, a = u.testid), "_width" in u && i(0, s = u._width), "$$scope" in u && i(3, l = u.$$scope);
  }, [s, a, r, l, n];
}
class wg extends me {
  constructor(e) {
    super(), ge(this, e, _g, pg, ce, { width: 2, testid: 1, _width: 0 }, bg);
  }
  get width() {
    return this.$$.ctx[2];
  }
  set width(e) {
    this.$$set({ width: e }), k();
  }
  get testid() {
    return this.$$.ctx[1];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get _width() {
    return this.$$.ctx[0];
  }
  set _width(e) {
    this.$$set({ _width: e }), k();
  }
}
customElements.define("goa-page-block", he(wg, { width: {}, testid: {}, _width: {} }, ["default"], [], !0));
function kg(t) {
  let e, i, n;
  const l = (
    /*#slots*/
    t[7].default
  ), o = oe(
    l,
    t,
    /*$$scope*/
    t[6],
    null
  );
  return {
    c() {
      e = C("div"), o && o.c(), f(e, "style", i = be(
        /*mt*/
        t[0],
        /*mr*/
        t[1],
        /*mb*/
        t[2],
        /*ml*/
        t[3]
      )), f(e, "class", "pages");
    },
    m(r, a) {
      D(r, e, a), o && o.m(e, null), t[8](e), n = !0;
    },
    p(r, [a]) {
      o && o.p && (!n || a & /*$$scope*/
      64) && ae(
        o,
        l,
        r,
        /*$$scope*/
        r[6],
        n ? re(
          l,
          /*$$scope*/
          r[6],
          a,
          null
        ) : se(
          /*$$scope*/
          r[6]
        ),
        null
      ), (!n || a & /*mt, mr, mb, ml*/
      15 && i !== (i = be(
        /*mt*/
        r[0],
        /*mr*/
        r[1],
        /*mb*/
        r[2],
        /*ml*/
        r[3]
      ))) && f(e, "style", i);
    },
    i(r) {
      n || (Y(o, r), n = !0);
    },
    o(r) {
      U(o, r), n = !1;
    },
    d(r) {
      r && P(e), o && o.d(r), t[8](null);
    }
  };
}
function yg(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { current: o = 1 } = e, { mt: r = null } = e, { mr: a = null } = e, { mb: s = null } = e, { ml: d = null } = e, u;
  ke(async () => {
    await Pe(), c(o);
  });
  function c(h) {
    if (!u) return;
    lt(u).forEach((v, b) => {
      const w = v;
      w.style.display = b + 1 === +h ? "block" : "none";
    });
  }
  function g(h) {
    ue[h ? "unshift" : "push"](() => {
      u = h, i(4, u);
    });
  }
  return t.$$set = (h) => {
    "current" in h && i(5, o = h.current), "mt" in h && i(0, r = h.mt), "mr" in h && i(1, a = h.mr), "mb" in h && i(2, s = h.mb), "ml" in h && i(3, d = h.ml), "$$scope" in h && i(6, l = h.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*current*/
    32 && c(o);
  }, [r, a, s, d, u, o, l, n, g];
}
class Cg extends me {
  constructor(e) {
    super(), ge(this, e, yg, kg, ce, { current: 5, mt: 0, mr: 1, mb: 2, ml: 3 });
  }
  get current() {
    return this.$$.ctx[5];
  }
  set current(e) {
    this.$$set({ current: e }), k();
  }
  get mt() {
    return this.$$.ctx[0];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[1];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[2];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[3];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-pages", he(Cg, { current: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function zg(t) {
  _e(t, "svelte-1wkmzn8", "span.svelte-1wkmzn8{white-space:nowrap}.controls.svelte-1wkmzn8{display:flex;gap:1rem;flex-direction:column;align-items:center;width:100%}@media(min-width: 624px){.controls.svelte-1wkmzn8{flex-direction:row;justify-content:space-between}}");
}
function Vo(t, e, i) {
  const n = t.slice();
  return n[20] = e[i], n[22] = i, n;
}
function Io(t) {
  let e, i, n, l, o, r = (
    /*_pageCount*/
    t[7]
  ), a, s, d, u, c = Bo(t);
  return {
    c() {
      e = C("goa-block"), i = C("span"), i.textContent = "Page", n = x(), l = C("input"), o = x(), c.c(), a = x(), s = C("span"), d = le("of "), u = le(
        /*_pageCount*/
        t[7]
      ), f(i, "class", "svelte-1wkmzn8"), f(l, "type", "hidden"), f(s, "class", "svelte-1wkmzn8"), p(e, "data-testid", "page-selector"), p(e, "alignment", "center"), p(e, "gap", "s");
    },
    m(g, h) {
      D(g, e, h), _(e, i), _(e, n), _(e, l), t[13](l), _(e, o), c.m(e, null), _(e, a), _(e, s), _(s, d), _(s, u);
    },
    p(g, h) {
      h & /*_pageCount*/
      128 && ce(r, r = /*_pageCount*/
      g[7]) ? (c.d(1), c = Bo(g), c.c(), c.m(e, a)) : c.p(g, h), h & /*_pageCount*/
      128 && pe(
        u,
        /*_pageCount*/
        g[7]
      );
    },
    d(g) {
      g && P(e), t[13](null), c.d(g);
    }
  };
}
function xo(t) {
  let e;
  return {
    c() {
      e = C("goa-dropdown-item"), p(
        e,
        "value",
        /*i*/
        t[22] + 1
      ), p(
        e,
        "label",
        /*i*/
        t[22] + 1
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p: ve,
    d(i) {
      i && P(e);
    }
  };
}
function Bo(t) {
  let e, i = Le({ length: (
    /*_pageCount*/
    t[7]
  ) }), n = [];
  for (let l = 0; l < i.length; l += 1)
    n[l] = xo(Vo(t, i, l));
  return {
    c() {
      e = C("goa-dropdown");
      for (let l = 0; l < n.length; l += 1)
        n[l].c();
      p(
        e,
        "value",
        /*pagenumber*/
        t[0]
      );
    },
    m(l, o) {
      D(l, e, o);
      for (let r = 0; r < n.length; r += 1)
        n[r] && n[r].m(e, null);
      t[14](e);
    },
    p(l, o) {
      if (o & /*_pageCount*/
      128) {
        i = Le({ length: (
          /*_pageCount*/
          l[7]
        ) });
        let r;
        for (r = 0; r < i.length; r += 1) {
          const a = Vo(l, i, r);
          n[r] ? n[r].p(a, o) : (n[r] = xo(a), n[r].c(), n[r].m(e, null));
        }
        for (; r < n.length; r += 1)
          n[r].d(1);
        n.length = i.length;
      }
      o & /*pagenumber*/
      1 && p(
        e,
        "value",
        /*pagenumber*/
        l[0]
      );
    },
    d(l) {
      l && P(e), Ye(n, l), t[14](null);
    }
  };
}
function jg(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m = (
    /*variant*/
    t[1] === "all" && Io(t)
  );
  return {
    c() {
      e = C("goa-block"), i = C("div"), m && m.c(), n = x(), l = C("goa-block"), o = C("goa-button"), r = le("Previous"), s = x(), d = C("goa-button"), u = le("Next"), p(o, "type", "tertiary"), p(o, "leadingicon", "arrow-back"), p(o, "disabled", a = /*pagenumber*/
      t[0] == 1 ? "true" : "false"), p(d, "type", "tertiary"), p(d, "trailingicon", "arrow-forward"), p(d, "disabled", c = /*pagenumber*/
      t[0] == /*_pageCount*/
      t[7] ? "true" : "false"), p(l, "alignment", "center"), p(l, "gap", "m"), p(l, "data-testid", "page-links"), f(i, "class", "controls svelte-1wkmzn8"), f(
        i,
        "data-testid",
        /*testid*/
        t[2]
      ), p(e, "id", "root"), p(
        e,
        "ml",
        /*ml*/
        t[6]
      ), p(
        e,
        "mr",
        /*mr*/
        t[4]
      ), p(
        e,
        "mb",
        /*mb*/
        t[5]
      ), p(
        e,
        "mt",
        /*mt*/
        t[3]
      );
    },
    m(v, b) {
      D(v, e, b), _(e, i), m && m.m(i, null), _(i, n), _(i, l), _(l, o), _(o, r), _(l, s), _(l, d), _(d, u), g || (h = [
        te(
          o,
          "click",
          /*click_handler*/
          t[15]
        ),
        te(
          d,
          "click",
          /*click_handler_1*/
          t[16]
        )
      ], g = !0);
    },
    p(v, [b]) {
      /*variant*/
      v[1] === "all" ? m ? m.p(v, b) : (m = Io(v), m.c(), m.m(i, n)) : m && (m.d(1), m = null), b & /*pagenumber*/
      1 && a !== (a = /*pagenumber*/
      v[0] == 1 ? "true" : "false") && p(o, "disabled", a), b & /*pagenumber, _pageCount*/
      129 && c !== (c = /*pagenumber*/
      v[0] == /*_pageCount*/
      v[7] ? "true" : "false") && p(d, "disabled", c), b & /*testid*/
      4 && f(
        i,
        "data-testid",
        /*testid*/
        v[2]
      ), b & /*ml*/
      64 && p(
        e,
        "ml",
        /*ml*/
        v[6]
      ), b & /*mr*/
      16 && p(
        e,
        "mr",
        /*mr*/
        v[4]
      ), b & /*mb*/
      32 && p(
        e,
        "mb",
        /*mb*/
        v[5]
      ), b & /*mt*/
      8 && p(
        e,
        "mt",
        /*mt*/
        v[3]
      );
    },
    i: ve,
    o: ve,
    d(v) {
      v && P(e), m && m.d(), g = !1, He(h);
    }
  };
}
function Eg(t, e, i) {
  let n;
  const [l, o] = Me("Pagination variant", ["all", "links-only"]);
  let { pagenumber: r } = e, { itemcount: a } = e, { perpagecount: s = 10 } = e, { variant: d = "all" } = e, { testid: u = "" } = e, { mt: c = "none" } = e, { mr: g = "none" } = e, { mb: h = "m" } = e, { ml: m = "none" } = e, v, b;
  ke(async () => {
    await Pe(), Kt("GoAPagination", { itemcount: a, pagenumber: r }), o(d), y();
  });
  function w(z, V) {
    var S;
    const T = Number.parseInt(r + "") + V;
    T > 0 && T <= n && ((S = z.target) == null || S.dispatchEvent(new CustomEvent(
      "_change",
      {
        composed: !0,
        bubbles: !0,
        detail: { page: T }
      }
    ))), z.preventDefault();
  }
  function y() {
    if (!v) {
      console.error("Missing pageDropdownEl");
      return;
    }
    v.addEventListener("_change", (z) => {
      const V = z, T = Number.parseInt(V.detail.value);
      z.stopPropagation(), b.dispatchEvent(new CustomEvent(
        "_change",
        {
          composed: !0,
          bubbles: !0,
          detail: { page: T }
        }
      ));
    });
  }
  function j(z) {
    ue[z ? "unshift" : "push"](() => {
      b = z, i(9, b);
    });
  }
  function E(z) {
    ue[z ? "unshift" : "push"](() => {
      v = z, i(8, v);
    });
  }
  const M = (z) => w(z, -1), L = (z) => w(z, 1);
  return t.$$set = (z) => {
    "pagenumber" in z && i(0, r = z.pagenumber), "itemcount" in z && i(11, a = z.itemcount), "perpagecount" in z && i(12, s = z.perpagecount), "variant" in z && i(1, d = z.variant), "testid" in z && i(2, u = z.testid), "mt" in z && i(3, c = z.mt), "mr" in z && i(4, g = z.mr), "mb" in z && i(5, h = z.mb), "ml" in z && i(6, m = z.ml);
  }, t.$$.update = () => {
    t.$$.dirty & /*itemcount, perpagecount*/
    6144 && i(7, n = Math.ceil(a / s)), t.$$.dirty & /*_pageCount*/
    128 && n && Pe().then(() => {
      y();
    });
  }, [
    r,
    d,
    u,
    c,
    g,
    h,
    m,
    n,
    v,
    b,
    w,
    a,
    s,
    j,
    E,
    M,
    L
  ];
}
class Mg extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Eg,
      jg,
      ce,
      {
        pagenumber: 0,
        itemcount: 11,
        perpagecount: 12,
        variant: 1,
        testid: 2,
        mt: 3,
        mr: 4,
        mb: 5,
        ml: 6
      },
      zg
    );
  }
  get pagenumber() {
    return this.$$.ctx[0];
  }
  set pagenumber(e) {
    this.$$set({ pagenumber: e }), k();
  }
  get itemcount() {
    return this.$$.ctx[11];
  }
  set itemcount(e) {
    this.$$set({ itemcount: e }), k();
  }
  get perpagecount() {
    return this.$$.ctx[12];
  }
  set perpagecount(e) {
    this.$$set({ perpagecount: e }), k();
  }
  get variant() {
    return this.$$.ctx[1];
  }
  set variant(e) {
    this.$$set({ variant: e }), k();
  }
  get testid() {
    return this.$$.ctx[2];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[3];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[4];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[5];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[6];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-pagination", he(Mg, { pagenumber: {}, itemcount: {}, perpagecount: {}, variant: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {} }, [], [], !0));
function Lg(t) {
  _e(t, "svelte-sq8e38", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans);font:var(--goa-typography-body-m);display:flex;align-items:center;height:100%}.popover-target.svelte-sq8e38{cursor:pointer;height:100%;outline:none}.popover-target.svelte-sq8e38:has(:focus-visible){outline:var(--goa-popover-border-focus)}.popover-content.svelte-sq8e38{color:var(--goa-color-text-default);position:absolute;width:-moz-fit-content;width:fit-content;list-style-type:none;background:var(--goa-popover-color-bg);border-radius:var(--goa-popover-border-radius);outline:none;filter:var(--goa-popover-shadow);z-index:99;margin-top:var(--offset-top, 3px);margin-bottom:var(--offset-bottom, 3px);margin-left:var(--offset-left, 0);margin-right:var(--offset-right, 0)}::slotted(ul){display:block;padding:0;margin:0;list-style-type:none;line-height:2rem}.popover-background.svelte-sq8e38{cursor:default;position:fixed;z-index:98;inset:0}");
}
const qg = (t) => ({}), No = (t) => ({});
function Wo(t) {
  let e, i, n, l, o, r, a, s, d, u, c;
  const g = (
    /*#slots*/
    t[30].default
  ), h = oe(
    g,
    t,
    /*$$scope*/
    t[29],
    null
  );
  return {
    c() {
      e = C("div"), i = x(), n = C("div"), l = C("section"), o = C("goa-focus-trap"), r = C("div"), h && h.c(), f(e, "data-testid", "popover-background"), f(e, "class", "popover-background svelte-sq8e38"), p(o, "open", "true"), f(l, "data-testid", "popover-content"), f(l, "class", "popover-content svelte-sq8e38"), f(l, "style", a = Ue(
        ze(
          "width",
          /*width*/
          t[3]
        ),
        ze(
          "min-width",
          /*minwidth*/
          t[2]
        ),
        ze(
          "max-width",
          /*width*/
          t[3] ? `max(${/*width*/
          t[3]}, ${/*maxwidth*/
          t[1]})` : (
            /*maxwidth*/
            t[1]
          )
        ),
        ze(
          "padding",
          /*_padded*/
          t[21] ? "var(--goa-space-m)" : "0"
        )
      )), We(() => (
        /*section_elementresize_handler*/
        t[33].call(l)
      )), f(n, "class", "popover-container");
    },
    m(m, v) {
      D(m, e, v), D(m, i, v), D(m, n, v), _(n, l), _(l, o), _(o, r), h && h.m(r, null), t[32](r), s = ki(
        l,
        /*section_elementresize_handler*/
        t[33].bind(l)
      ), t[34](l), d = !0, u || (c = te(
        e,
        "click",
        /*closePopover*/
        t[23]
      ), u = !0);
    },
    p(m, v) {
      h && h.p && (!d || v[0] & /*$$scope*/
      536870912) && ae(
        h,
        g,
        m,
        /*$$scope*/
        m[29],
        d ? re(
          g,
          /*$$scope*/
          m[29],
          v,
          null
        ) : se(
          /*$$scope*/
          m[29]
        ),
        null
      ), (!d || v[0] & /*width, minwidth, maxwidth, _padded*/
      2097166 && a !== (a = Ue(
        ze(
          "width",
          /*width*/
          m[3]
        ),
        ze(
          "min-width",
          /*minwidth*/
          m[2]
        ),
        ze(
          "max-width",
          /*width*/
          m[3] ? `max(${/*width*/
          m[3]}, ${/*maxwidth*/
          m[1]})` : (
            /*maxwidth*/
            m[1]
          )
        ),
        ze(
          "padding",
          /*_padded*/
          m[21] ? "var(--goa-space-m)" : "0"
        )
      ))) && f(l, "style", a);
    },
    i(m) {
      d || (Y(h, m), d = !0);
    },
    o(m) {
      U(h, m), d = !1;
    },
    d(m) {
      m && (P(e), P(i), P(n)), h && h.d(m), t[32](null), s(), t[34](null), u = !1, c();
    }
  };
}
function Sg(t) {
  let e, i, n, l, o, r, a, s;
  const d = (
    /*#slots*/
    t[30].target
  ), u = oe(
    d,
    t,
    /*$$scope*/
    t[29],
    No
  );
  let c = (
    /*_open*/
    t[15] && Wo(t)
  );
  return {
    c() {
      e = C("div"), i = C("div"), u && u.c(), l = x(), c && c.c(), f(i, "class", "popover-target svelte-sq8e38"), f(i, "tabindex", n = +/*tabindex*/
      t[9]), f(i, "data-testid", "popover-target"), f(
        e,
        "data-testid",
        /*testid*/
        t[0]
      ), f(e, "style", o = Ue(
        /*_relative*/
        t[20] && "position: relative",
        /*height*/
        t[4] === "full" && "height: 100%;",
        be(
          /*mt*/
          t[5],
          /*mr*/
          t[6],
          /*mb*/
          t[7],
          /*ml*/
          t[8]
        ),
        ze(
          "--offset-top",
          /*voffset*/
          t[10]
        ),
        ze(
          "--offset-bottom",
          /*voffset*/
          t[10]
        ),
        ze(
          "--offset-left",
          /*hoffset*/
          t[11]
        ),
        ze(
          "--offset-right",
          /*hoffset*/
          t[11]
        ),
        ze(
          "--focus-border-width",
          /*focusborderwidth*/
          t[12]
        ),
        ze(
          "--border-radius",
          /*borderradius*/
          t[13]
        ),
        ze(
          "width",
          /*width*/
          t[3]
        )
      ));
    },
    m(g, h) {
      D(g, e, h), _(e, i), u && u.m(i, null), t[31](i), _(e, l), c && c.m(e, null), t[35](e), r = !0, a || (s = te(
        i,
        "click",
        /*openPopover*/
        t[22]
      ), a = !0);
    },
    p(g, h) {
      u && u.p && (!r || h[0] & /*$$scope*/
      536870912) && ae(
        u,
        d,
        g,
        /*$$scope*/
        g[29],
        r ? re(
          d,
          /*$$scope*/
          g[29],
          h,
          qg
        ) : se(
          /*$$scope*/
          g[29]
        ),
        No
      ), (!r || h[0] & /*tabindex*/
      512 && n !== (n = +/*tabindex*/
      g[9])) && f(i, "tabindex", n), /*_open*/
      g[15] ? c ? (c.p(g, h), h[0] & /*_open*/
      32768 && Y(c, 1)) : (c = Wo(g), c.c(), Y(c, 1), c.m(e, null)) : c && (Oe(), U(c, 1, 1, () => {
        c = null;
      }), Fe()), (!r || h[0] & /*testid*/
      1) && f(
        e,
        "data-testid",
        /*testid*/
        g[0]
      ), (!r || h[0] & /*_relative, height, mt, mr, mb, ml, voffset, hoffset, focusborderwidth, borderradius, width*/
      1064440 && o !== (o = Ue(
        /*_relative*/
        g[20] && "position: relative",
        /*height*/
        g[4] === "full" && "height: 100%;",
        be(
          /*mt*/
          g[5],
          /*mr*/
          g[6],
          /*mb*/
          g[7],
          /*ml*/
          g[8]
        ),
        ze(
          "--offset-top",
          /*voffset*/
          g[10]
        ),
        ze(
          "--offset-bottom",
          /*voffset*/
          g[10]
        ),
        ze(
          "--offset-left",
          /*hoffset*/
          g[11]
        ),
        ze(
          "--offset-right",
          /*hoffset*/
          g[11]
        ),
        ze(
          "--focus-border-width",
          /*focusborderwidth*/
          g[12]
        ),
        ze(
          "--border-radius",
          /*borderradius*/
          g[13]
        ),
        ze(
          "width",
          /*width*/
          g[3]
        )
      ))) && f(e, "style", o);
    },
    i(g) {
      r || (Y(u, g), Y(c), r = !0);
    },
    o(g) {
      U(u, g), U(c), r = !1;
    },
    d(g) {
      g && P(e), u && u.d(g), t[31](null), c && c.d(), t[35](null), a = !1, s();
    }
  };
}
function Ro(t) {
  const e = t.getBoundingClientRect(), i = window.getComputedStyle(t), n = parseInt(i.marginTop, 10) || 0, l = parseInt(i.marginRight, 10) || 0, o = parseInt(i.marginBottom, 10) || 0, r = parseInt(i.marginLeft, 10) || 0;
  return {
    top: e.top - n,
    right: e.right + l,
    bottom: e.bottom + o,
    left: e.left - r,
    width: e.width + r + l,
    height: e.height + n + o,
    x: e.x - r,
    y: e.y - n
  };
}
function Tg(t, e, i) {
  let n, l, o, r, { $$slots: a = {}, $$scope: s } = e, { testid: d = "popover" } = e, { position: u = "auto" } = e, { maxwidth: c = "320px" } = e, { minwidth: g = "" } = e, { width: h = "" } = e, { height: m = "wrap-content" } = e, { padded: v = "true" } = e, { relative: b = "false" } = e, { mt: w = null } = e, { mr: y = null } = e, { mb: j = null } = e, { ml: E = null } = e, { open: M = "false" } = e, { disabled: L = "false" } = e, { tabindex: z = "0" } = e, { voffset: V = "" } = e, { hoffset: T = "" } = e, { focusborderwidth: S = "var(--goa-border-width-l)" } = e, { borderradius: A = "var(--goa-border-radius-m)" } = e, R, I, B, N, F, q;
  ke(async () => {
    await Pe(), I.addEventListener("keydown", O), F = lt(I).find((De) => De.tabIndex >= 0) || I;
  });
  function H(J) {
    $();
  }
  function O(J) {
    switch (J.key) {
      case " ":
      case "Enter":
        K();
        break;
      case "Escape":
        $();
        break;
    }
  }
  function W(J) {
    switch (J.key) {
      case "Escape":
        $();
        break;
    }
  }
  function K() {
    o || (async () => (i(15, l = !0), await Pe(), N.addEventListener("keydown", W, !0), R.dispatchEvent(new CustomEvent("_open", { composed: !0 }))))();
  }
  function $() {
    F.focus(), i(15, l = !1), window.removeEventListener("popstate", H, !0), R.dispatchEvent(new CustomEvent("_close", { composed: !0 }));
  }
  async function ye() {
    await Pe();
    const J = Ro(I), De = Ro(B);
    if (De.height < 20) return;
    const fe = J.top, Ae = window.innerHeight - J.bottom;
    (u === "auto" ? Ae < De.height && fe > De.height && fe > Ae : u === "above") ? i(
      18,
      B.style.top = r ? `${-De.height}px` : `${J.y - De.height + window.scrollY}px`,
      B
    ) : i(18, B.style.top = "", B), document.body.clientWidth - J.left < De.width && J.left > De.width && i(18, B.style.left = `${J.x - (De.width - J.width)}px`, B);
  }
  function Z(J) {
    ue[J ? "unshift" : "push"](() => {
      I = J, i(17, I);
    });
  }
  function Q(J) {
    ue[J ? "unshift" : "push"](() => {
      N = J, i(19, N);
    });
  }
  function X() {
    q = this.clientHeight, i(14, q);
  }
  function ee(J) {
    ue[J ? "unshift" : "push"](() => {
      B = J, i(18, B);
    });
  }
  function ie(J) {
    ue[J ? "unshift" : "push"](() => {
      R = J, i(16, R);
    });
  }
  return t.$$set = (J) => {
    "testid" in J && i(0, d = J.testid), "position" in J && i(24, u = J.position), "maxwidth" in J && i(1, c = J.maxwidth), "minwidth" in J && i(2, g = J.minwidth), "width" in J && i(3, h = J.width), "height" in J && i(4, m = J.height), "padded" in J && i(25, v = J.padded), "relative" in J && i(26, b = J.relative), "mt" in J && i(5, w = J.mt), "mr" in J && i(6, y = J.mr), "mb" in J && i(7, j = J.mb), "ml" in J && i(8, E = J.ml), "open" in J && i(27, M = J.open), "disabled" in J && i(28, L = J.disabled), "tabindex" in J && i(9, z = J.tabindex), "voffset" in J && i(10, V = J.voffset), "hoffset" in J && i(11, T = J.hoffset), "focusborderwidth" in J && i(12, S = J.focusborderwidth), "borderradius" in J && i(13, A = J.borderradius), "$$scope" in J && i(29, s = J.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*padded*/
    33554432 && i(21, n = Ce(v)), t.$$.dirty[0] & /*open*/
    134217728 && i(15, l = Ce(M)), t.$$.dirty[0] & /*disabled*/
    268435456 && (o = Ce(L)), t.$$.dirty[0] & /*relative*/
    67108864 && i(20, r = Ce(b)), t.$$.dirty[0] & /*_open*/
    32768 && (async () => l && await ye())(), t.$$.dirty[0] & /*_sectionHeight*/
    16384 && (async () => q && await ye())(), t.$$.dirty[0] & /*_open*/
    32768 && (l ? window.addEventListener("popstate", H, !0) : window.removeEventListener("popstate", H, !0));
  }, [
    d,
    c,
    g,
    h,
    m,
    w,
    y,
    j,
    E,
    z,
    V,
    T,
    S,
    A,
    q,
    l,
    R,
    I,
    B,
    N,
    r,
    n,
    K,
    $,
    u,
    v,
    b,
    M,
    L,
    s,
    a,
    Z,
    Q,
    X,
    ee,
    ie
  ];
}
class Pg extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Tg,
      Sg,
      ce,
      {
        testid: 0,
        position: 24,
        maxwidth: 1,
        minwidth: 2,
        width: 3,
        height: 4,
        padded: 25,
        relative: 26,
        mt: 5,
        mr: 6,
        mb: 7,
        ml: 8,
        open: 27,
        disabled: 28,
        tabindex: 9,
        voffset: 10,
        hoffset: 11,
        focusborderwidth: 12,
        borderradius: 13
      },
      Lg,
      [-1, -1]
    );
  }
  get testid() {
    return this.$$.ctx[0];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get position() {
    return this.$$.ctx[24];
  }
  set position(e) {
    this.$$set({ position: e }), k();
  }
  get maxwidth() {
    return this.$$.ctx[1];
  }
  set maxwidth(e) {
    this.$$set({ maxwidth: e }), k();
  }
  get minwidth() {
    return this.$$.ctx[2];
  }
  set minwidth(e) {
    this.$$set({ minwidth: e }), k();
  }
  get width() {
    return this.$$.ctx[3];
  }
  set width(e) {
    this.$$set({ width: e }), k();
  }
  get height() {
    return this.$$.ctx[4];
  }
  set height(e) {
    this.$$set({ height: e }), k();
  }
  get padded() {
    return this.$$.ctx[25];
  }
  set padded(e) {
    this.$$set({ padded: e }), k();
  }
  get relative() {
    return this.$$.ctx[26];
  }
  set relative(e) {
    this.$$set({ relative: e }), k();
  }
  get mt() {
    return this.$$.ctx[5];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[6];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[7];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[8];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get open() {
    return this.$$.ctx[27];
  }
  set open(e) {
    this.$$set({ open: e }), k();
  }
  get disabled() {
    return this.$$.ctx[28];
  }
  set disabled(e) {
    this.$$set({ disabled: e }), k();
  }
  get tabindex() {
    return this.$$.ctx[9];
  }
  set tabindex(e) {
    this.$$set({ tabindex: e }), k();
  }
  get voffset() {
    return this.$$.ctx[10];
  }
  set voffset(e) {
    this.$$set({ voffset: e }), k();
  }
  get hoffset() {
    return this.$$.ctx[11];
  }
  set hoffset(e) {
    this.$$set({ hoffset: e }), k();
  }
  get focusborderwidth() {
    return this.$$.ctx[12];
  }
  set focusborderwidth(e) {
    this.$$set({ focusborderwidth: e }), k();
  }
  get borderradius() {
    return this.$$.ctx[13];
  }
  set borderradius(e) {
    this.$$set({ borderradius: e }), k();
  }
}
customElements.define("goa-popover", he(Pg, { testid: {}, position: {}, maxwidth: {}, minwidth: {}, width: {}, height: {}, padded: {}, relative: {}, mt: {}, mr: {}, mb: {}, ml: {}, open: { reflect: !0, type: "String" }, disabled: {}, tabindex: {}, voffset: {}, hoffset: {}, focusborderwidth: {}, borderradius: {} }, ["target", "default"], [], !0));
function Dg(t) {
  _e(t, "svelte-10zf50u", '.radio.svelte-10zf50u.svelte-10zf50u.svelte-10zf50u{display:inline-flex}label.radio.svelte-10zf50u.svelte-10zf50u.svelte-10zf50u{box-sizing:border-box;display:inline-flex}.container.svelte-10zf50u.svelte-10zf50u.svelte-10zf50u{display:flex;flex-direction:column}.radio.svelte-10zf50u.svelte-10zf50u.svelte-10zf50u:hover{cursor:pointer}.radio.svelte-10zf50u .svelte-10zf50u.svelte-10zf50u,.radio.svelte-10zf50u .svelte-10zf50u.svelte-10zf50u:before,.radio.svelte-10zf50u .svelte-10zf50u.svelte-10zf50u:after{box-sizing:border-box}.radio.svelte-10zf50u input[type="radio"].svelte-10zf50u.svelte-10zf50u{width:0;min-height:28px;margin:0;opacity:0}.label.svelte-10zf50u.svelte-10zf50u.svelte-10zf50u{padding:0 var(--goa-space-xs);font:var(--goa-radio-label)}.description.svelte-10zf50u.svelte-10zf50u.svelte-10zf50u{font:var(--description);margin-left:var(--goa-space-xl);margin-top:var(--goa-space-2xs);color:var(--goa-color-text-default)}.reveal.svelte-10zf50u.svelte-10zf50u.svelte-10zf50u{display:none;height:0}.reveal.visible.svelte-10zf50u.svelte-10zf50u.svelte-10zf50u{border-left:4px solid var(--goa-color-greyscale-200);padding:var(--goa-space-m);margin:var(--goa-space-2xs) 0 0 calc(var(--goa-space-s) - 2px);display:block;height:-moz-fit-content;height:fit-content}.icon.svelte-10zf50u.svelte-10zf50u.svelte-10zf50u{display:inline-block;height:var(--goa-radio-size);width:var(--goa-radio-size);border-radius:var(--goa-radio-border-radius);background-color:var(--goa-radio-color-bg);transition:box-shadow 100ms ease-in-out;flex:0 0 auto;margin-top:var(--font-valign-fix)}.radio--disabled.svelte-10zf50u .label.svelte-10zf50u.svelte-10zf50u,.radio--disabled.svelte-10zf50u~.description.svelte-10zf50u.svelte-10zf50u{color:var(--goa-radio-label-color-disabled)}.radio--disabled.svelte-10zf50u.svelte-10zf50u.svelte-10zf50u:hover{cursor:default}input[type="radio"].svelte-10zf50u:not(:checked)~.icon.svelte-10zf50u.svelte-10zf50u{border:var(--goa-border-width-s) solid var(--goa-color-greyscale-700);margin-top:3px}input[type="radio"].svelte-10zf50u:hover~.icon.svelte-10zf50u.svelte-10zf50u{border:var(--goa-radio-border-hover)}input[type="radio"].svelte-10zf50u:focus-visible~.icon.svelte-10zf50u.svelte-10zf50u,input[type="radio"].svelte-10zf50u:hover:focus-visible~.icon.svelte-10zf50u.svelte-10zf50u{outline:var(--goa-radio-border-focus)}input[type="radio"].svelte-10zf50u:hover:focus-visible~.icon.svelte-10zf50u.svelte-10zf50u{border:var(--goa-radio-border)}input[type="radio"].svelte-10zf50u:checked~.icon.svelte-10zf50u.svelte-10zf50u{border:var(--goa-radio-border-checked);margin-top:3px}input[type="radio"].svelte-10zf50u:checked:hover~.icon.svelte-10zf50u.svelte-10zf50u{border:var(--goa-radio-border-checked-hover)}input[type="radio"].svelte-10zf50u:checked:hover:focus-visible~.icon.svelte-10zf50u.svelte-10zf50u{border:var(--goa-radio-border-checked)}input[type="radio"].svelte-10zf50u:disabled~.icon.svelte-10zf50u.svelte-10zf50u,input[type="radio"].svelte-10zf50u:disabled:focus-visible~.icon.svelte-10zf50u.svelte-10zf50u{border:var(--goa-radio-border-disabled)}input[type="radio"].svelte-10zf50u:disabled:checked~.icon.svelte-10zf50u.svelte-10zf50u,input[type="radio"].svelte-10zf50u:disabled:checked:focus-visible~.icon.svelte-10zf50u.svelte-10zf50u{border:var(--goa-radio-border-checked-disabled)}.radio--error.svelte-10zf50u input[type="radio"].svelte-10zf50u~.icon.svelte-10zf50u{border:var(--goa-radio-border-error)}.radio--error.svelte-10zf50u input[type="radio"].svelte-10zf50u:hover~.icon.svelte-10zf50u{border:var(--goa-radio-border-error-hover)}.radio--error.svelte-10zf50u input[type="radio"].svelte-10zf50u:hover:focus-visible~.icon.svelte-10zf50u{outline:var(--goa-radio-border-focus);border:var(--goa-radio-border-error)}.radio--error.svelte-10zf50u input[type="radio"].svelte-10zf50u:checked~.icon.svelte-10zf50u{border:var(--goa-radio-border-checked-error)}.radio--error.svelte-10zf50u input[type="radio"].svelte-10zf50u:checked:hover~.icon.svelte-10zf50u{border:var(--goa-radio-border-checked-error-hover)}.radio--error.svelte-10zf50u input[type="radio"].svelte-10zf50u:checked:hover:focus-visible~.icon.svelte-10zf50u{outline:var(--goa-radio-border-focus);border:var(--goa-radio-border-checked-error)}.radio--error.svelte-10zf50u input[type="radio"].svelte-10zf50u:disabled~.icon.svelte-10zf50u{border:var(--goa-radio-border-error-disabled)}.radio--error.svelte-10zf50u input[type="radio"].svelte-10zf50u:disabled:checked~.icon.svelte-10zf50u{border:var(--goa-radio-border-checked-error-disabled)}');
}
const Hg = (t) => ({}), Yo = (t) => ({}), Og = (t) => ({}), Zo = (t) => ({});
function Uo(t) {
  let e, i, n, l, o;
  const r = (
    /*#slots*/
    t[20].description
  ), a = oe(
    r,
    t,
    /*$$scope*/
    t[19],
    Zo
  );
  return {
    c() {
      e = C("div"), a && a.c(), i = x(), n = le(
        /*description*/
        t[1]
      ), f(e, "class", "description svelte-10zf50u"), f(e, "id", l = `${/*name*/
      t[0]}-${/*value*/
      t[2]}-description`);
    },
    m(s, d) {
      D(s, e, d), a && a.m(e, null), _(e, i), _(e, n), o = !0;
    },
    p(s, d) {
      a && a.p && (!o || d[0] & /*$$scope*/
      524288) && ae(
        a,
        r,
        s,
        /*$$scope*/
        s[19],
        o ? re(
          r,
          /*$$scope*/
          s[19],
          d,
          Og
        ) : se(
          /*$$scope*/
          s[19]
        ),
        Zo
      ), (!o || d[0] & /*description*/
      2) && pe(
        n,
        /*description*/
        s[1]
      ), (!o || d[0] & /*name, value*/
      5 && l !== (l = `${/*name*/
      s[0]}-${/*value*/
      s[2]}-description`)) && f(e, "id", l);
    },
    i(s) {
      o || (Y(a, s), o = !0);
    },
    o(s) {
      U(a, s), o = !1;
    },
    d(s) {
      s && P(e), a && a.d(s);
    }
  };
}
function Fg(t) {
  let e, i, n, l, o, r, a, s, d = (
    /*label*/
    (t[3] || /*value*/
    t[2]) + ""
  ), u, c, g, h, m, v, b, w, y, j = (
    /*$$slots*/
    (t[15].description || /*description*/
    t[1]) && Uo(t)
  );
  const E = (
    /*#slots*/
    t[20].reveal
  ), M = oe(
    E,
    t,
    /*$$scope*/
    t[19],
    Yo
  );
  return {
    c() {
      e = C("div"), i = C("label"), n = C("input"), o = x(), r = C("div"), a = x(), s = C("span"), u = le(d), g = x(), j && j.c(), h = x(), m = C("div"), M && M.c(), f(n, "type", "radio"), f(
        n,
        "name",
        /*name*/
        t[0]
      ), n.value = /*value*/
      t[2], n.disabled = /*isDisabled*/
      t[12], n.checked = /*isChecked*/
      t[11], f(
        n,
        "aria-label",
        /*arialabel*/
        t[4]
      ), f(n, "aria-describedby", l = /*$$slots*/
      t[15].description || /*description*/
      t[1] ? `${/*name*/
      t[0]}-${/*value*/
      t[2]}-description` : void 0), f(
        n,
        "aria-checked",
        /*isChecked*/
        t[11]
      ), f(n, "class", "svelte-10zf50u"), f(r, "class", "icon svelte-10zf50u"), f(s, "class", "label svelte-10zf50u"), f(i, "data-testid", c = "radio-option-" + /*value*/
      t[2]), f(i, "class", "radio svelte-10zf50u"), G(
        i,
        "radio--disabled",
        /*isDisabled*/
        t[12]
      ), G(
        i,
        "radio--error",
        /*isError*/
        t[13]
      ), f(m, "class", "reveal svelte-10zf50u"), G(
        m,
        "visible",
        /*$$slots*/
        t[15].reveal && /*isChecked*/
        t[11]
      ), f(e, "style", v = `
    ${be(
        /*mt*/
        t[6],
        /*mr*/
        t[7],
        /*mb*/
        t[8],
        /*ml*/
        t[9]
      )}
    max-width: ${/*maxwidth*/
      t[5]};
  `), f(e, "data-testid", "root"), f(e, "class", "container svelte-10zf50u");
    },
    m(L, z) {
      D(L, e, z), _(e, i), _(i, n), _(i, o), _(i, r), _(i, a), _(i, s), _(s, u), _(e, g), j && j.m(e, null), _(e, h), _(e, m), M && M.m(m, null), t[21](e), b = !0, w || (y = te(
        n,
        "click",
        /*onChange*/
        t[14]
      ), w = !0);
    },
    p(L, z) {
      (!b || z[0] & /*name*/
      1) && f(
        n,
        "name",
        /*name*/
        L[0]
      ), (!b || z[0] & /*value*/
      4) && (n.value = /*value*/
      L[2]), (!b || z[0] & /*isDisabled*/
      4096) && (n.disabled = /*isDisabled*/
      L[12]), (!b || z[0] & /*isChecked*/
      2048) && (n.checked = /*isChecked*/
      L[11]), (!b || z[0] & /*arialabel*/
      16) && f(
        n,
        "aria-label",
        /*arialabel*/
        L[4]
      ), (!b || z[0] & /*$$slots, description, name, value*/
      32775 && l !== (l = /*$$slots*/
      L[15].description || /*description*/
      L[1] ? `${/*name*/
      L[0]}-${/*value*/
      L[2]}-description` : void 0)) && f(n, "aria-describedby", l), (!b || z[0] & /*isChecked*/
      2048) && f(
        n,
        "aria-checked",
        /*isChecked*/
        L[11]
      ), (!b || z[0] & /*label, value*/
      12) && d !== (d = /*label*/
      (L[3] || /*value*/
      L[2]) + "") && pe(u, d), (!b || z[0] & /*value*/
      4 && c !== (c = "radio-option-" + /*value*/
      L[2])) && f(i, "data-testid", c), (!b || z[0] & /*isDisabled*/
      4096) && G(
        i,
        "radio--disabled",
        /*isDisabled*/
        L[12]
      ), (!b || z[0] & /*isError*/
      8192) && G(
        i,
        "radio--error",
        /*isError*/
        L[13]
      ), /*$$slots*/
      L[15].description || /*description*/
      L[1] ? j ? (j.p(L, z), z[0] & /*$$slots, description*/
      32770 && Y(j, 1)) : (j = Uo(L), j.c(), Y(j, 1), j.m(e, h)) : j && (Oe(), U(j, 1, 1, () => {
        j = null;
      }), Fe()), M && M.p && (!b || z[0] & /*$$scope*/
      524288) && ae(
        M,
        E,
        L,
        /*$$scope*/
        L[19],
        b ? re(
          E,
          /*$$scope*/
          L[19],
          z,
          Hg
        ) : se(
          /*$$scope*/
          L[19]
        ),
        Yo
      ), (!b || z[0] & /*$$slots, isChecked*/
      34816) && G(
        m,
        "visible",
        /*$$slots*/
        L[15].reveal && /*isChecked*/
        L[11]
      ), (!b || z[0] & /*mt, mr, mb, ml, maxwidth*/
      992 && v !== (v = `
    ${be(
        /*mt*/
        L[6],
        /*mr*/
        L[7],
        /*mb*/
        L[8],
        /*ml*/
        L[9]
      )}
    max-width: ${/*maxwidth*/
      L[5]};
  `)) && f(e, "style", v);
    },
    i(L) {
      b || (Y(j), Y(M, L), b = !0);
    },
    o(L) {
      U(j), U(M, L), b = !1;
    },
    d(L) {
      L && P(e), j && j.d(), M && M.d(L), t[21](null), w = !1, y();
    }
  };
}
function Ag(t, e, i) {
  let n, l, o, { $$slots: r = {}, $$scope: a } = e;
  const s = pt(r);
  let { value: d } = e, { name: u = "" } = e, { label: c = "" } = e, { description: g = "" } = e, { disabled: h = "false" } = e, { error: m = "false" } = e, { checked: v = "false" } = e, { arialabel: b = "" } = e, { maxwidth: w = "none" } = e, { mt: y = null } = e, { mr: j = null } = e, { mb: E = null } = e, { ml: M = null } = e, L, z, V = [];
  ke(() => {
    I(), B(), N(), T(), S();
  });
  function T() {
    Re(L, (O, W) => {
      switch (O) {
        case Qe:
          A(W);
          break;
      }
    });
  }
  function S() {
    Re(z, (O, W) => {
      switch (O) {
        case Qe:
          R(W);
          break;
      }
    });
  }
  function A(O) {
    O.name && s.reveal && (V = [...V, O.el]);
  }
  function R(O) {
    setTimeout(
      () => {
        i(17, v = !v && !!O.el.value);
      },
      1e3
    );
  }
  function I() {
    setTimeout(
      () => {
        L == null || L.dispatchEvent(new CustomEvent(
          "radio-item:mounted",
          {
            composed: !0,
            bubbles: !0,
            detail: {
              el: L,
              name: u,
              value: d,
              label: c,
              description: g,
              disabled: n,
              error: l,
              checked: o,
              ariaLabel: b,
              maxWidth: w
            }
          }
        ));
      },
      10
    );
  }
  function B() {
    L.addEventListener("radio-group:init", (O) => {
      const W = O.detail;
      i(12, n = W.disabled), i(16, m = vt(W.error)), i(17, v = vt(W.checked)), i(1, g = W.description), i(0, u = W.name);
    });
  }
  function N() {
    L.addEventListener("radio-group:select", (O) => {
      i(11, o = O.detail.checked);
    });
  }
  function F() {
    n || (qe(L, "_radioItemChange", d, { bubbles: !0 }), !o && s.reveal && q());
  }
  function q() {
    for (const O of V)
      je(O, zi);
  }
  function H(O) {
    ue[O ? "unshift" : "push"](() => {
      L = O, i(10, L);
    });
  }
  return t.$$set = (O) => {
    "value" in O && i(2, d = O.value), "name" in O && i(0, u = O.name), "label" in O && i(3, c = O.label), "description" in O && i(1, g = O.description), "disabled" in O && i(18, h = O.disabled), "error" in O && i(16, m = O.error), "checked" in O && i(17, v = O.checked), "arialabel" in O && i(4, b = O.arialabel), "maxwidth" in O && i(5, w = O.maxwidth), "mt" in O && i(6, y = O.mt), "mr" in O && i(7, j = O.mr), "mb" in O && i(8, E = O.mb), "ml" in O && i(9, M = O.ml), "$$scope" in O && i(19, a = O.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*disabled*/
    262144 && i(12, n = Ce(h)), t.$$.dirty[0] & /*error*/
    65536 && i(13, l = Ce(m)), t.$$.dirty[0] & /*checked*/
    131072 && i(11, o = Ce(v));
  }, [
    u,
    g,
    d,
    c,
    b,
    w,
    y,
    j,
    E,
    M,
    L,
    o,
    n,
    l,
    F,
    s,
    m,
    v,
    h,
    a,
    r,
    H
  ];
}
class Vg extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Ag,
      Fg,
      ce,
      {
        value: 2,
        name: 0,
        label: 3,
        description: 1,
        disabled: 18,
        error: 16,
        checked: 17,
        arialabel: 4,
        maxwidth: 5,
        mt: 6,
        mr: 7,
        mb: 8,
        ml: 9
      },
      Dg,
      [-1, -1]
    );
  }
  get value() {
    return this.$$.ctx[2];
  }
  set value(e) {
    this.$$set({ value: e }), k();
  }
  get name() {
    return this.$$.ctx[0];
  }
  set name(e) {
    this.$$set({ name: e }), k();
  }
  get label() {
    return this.$$.ctx[3];
  }
  set label(e) {
    this.$$set({ label: e }), k();
  }
  get description() {
    return this.$$.ctx[1];
  }
  set description(e) {
    this.$$set({ description: e }), k();
  }
  get disabled() {
    return this.$$.ctx[18];
  }
  set disabled(e) {
    this.$$set({ disabled: e }), k();
  }
  get error() {
    return this.$$.ctx[16];
  }
  set error(e) {
    this.$$set({ error: e }), k();
  }
  get checked() {
    return this.$$.ctx[17];
  }
  set checked(e) {
    this.$$set({ checked: e }), k();
  }
  get arialabel() {
    return this.$$.ctx[4];
  }
  set arialabel(e) {
    this.$$set({ arialabel: e }), k();
  }
  get maxwidth() {
    return this.$$.ctx[5];
  }
  set maxwidth(e) {
    this.$$set({ maxwidth: e }), k();
  }
  get mt() {
    return this.$$.ctx[6];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[7];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[8];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[9];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-radio-item", he(Vg, { value: { reflect: !0 }, name: {}, label: {}, description: { reflect: !0 }, disabled: {}, error: { reflect: !0 }, checked: { reflect: !0 }, arialabel: { reflect: !0 }, maxwidth: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["description", "reveal"], [], !0));
function Ig(t) {
  _e(t, "svelte-xd2d6m", ":host{font-family:var(--goa-font-family-sans)}.goa-radio-group--horizontal.svelte-xd2d6m{display:flex;flex-direction:row;gap:var(--goa-radio-group-gap-horizontal)}.goa-radio-group--vertical.svelte-xd2d6m{display:inline-flex;flex-direction:column;gap:var(--goa-radio-group-gap-vertical)}.goa-radio-group--horizontal.svelte-xd2d6m:focus,.goa-radio-group--vertical.svelte-xd2d6m:focus{outline:none}");
}
function xg(t) {
  let e, i, n, l, o, r, a;
  const s = (
    /*#slots*/
    t[16].default
  ), d = oe(
    s,
    t,
    /*$$scope*/
    t[15],
    null
  );
  return {
    c() {
      e = C("div"), d && d.c(), f(e, "style", i = be(
        /*mt*/
        t[3],
        /*mr*/
        t[4],
        /*mb*/
        t[5],
        /*ml*/
        t[6]
      )), f(e, "class", n = Ee(`goa-radio-group--${/*orientation*/
      t[0]}`) + " svelte-xd2d6m"), f(
        e,
        "data-testid",
        /*testid*/
        t[1]
      ), f(e, "role", "radiogroup"), f(
        e,
        "aria-label",
        /*arialabel*/
        t[2]
      ), f(e, "aria-invalid", l = /*_error*/
      t[7] ? "true" : "false");
    },
    m(u, c) {
      D(u, e, c), d && d.m(e, null), t[17](e), o = !0, r || (a = te(
        e,
        "focusin",
        /*onFocus*/
        t[9]
      ), r = !0);
    },
    p(u, [c]) {
      d && d.p && (!o || c & /*$$scope*/
      32768) && ae(
        d,
        s,
        u,
        /*$$scope*/
        u[15],
        o ? re(
          s,
          /*$$scope*/
          u[15],
          c,
          null
        ) : se(
          /*$$scope*/
          u[15]
        ),
        null
      ), (!o || c & /*mt, mr, mb, ml*/
      120 && i !== (i = be(
        /*mt*/
        u[3],
        /*mr*/
        u[4],
        /*mb*/
        u[5],
        /*ml*/
        u[6]
      ))) && f(e, "style", i), (!o || c & /*orientation*/
      1 && n !== (n = Ee(`goa-radio-group--${/*orientation*/
      u[0]}`) + " svelte-xd2d6m")) && f(e, "class", n), (!o || c & /*testid*/
      2) && f(
        e,
        "data-testid",
        /*testid*/
        u[1]
      ), (!o || c & /*arialabel*/
      4) && f(
        e,
        "aria-label",
        /*arialabel*/
        u[2]
      ), (!o || c & /*_error*/
      128 && l !== (l = /*_error*/
      u[7] ? "true" : "false")) && f(e, "aria-invalid", l);
    },
    i(u) {
      o || (Y(d, u), o = !0);
    },
    o(u) {
      U(d, u), o = !1;
    },
    d(u) {
      u && P(e), d && d.d(u), t[17](null), r = !1, a();
    }
  };
}
function Bg(t, e, i) {
  let n, { $$slots: l = {}, $$scope: o } = e;
  const [r, a] = Me("Radio group orientation", ["vertical", "horizontal"]);
  let { name: s } = e, { value: d } = e, { orientation: u = "vertical" } = e, { disabled: c = "false" } = e, { error: g = "false" } = e, { testid: h = "" } = e, { arialabel: m = "" } = e, { mt: v = null } = e, { mr: b = null } = e, { mb: w = null } = e, { ml: y = null } = e, j = Ce(g), E = j, M, L = [], z;
  ke(async () => {
    a(u), V(), A(), R(), M.addEventListener("_radioItemChange", (H) => {
      B(H.detail);
    });
  });
  function V() {
    Re(M, (H, O) => {
      switch (H) {
        case bt:
          S(O);
          break;
        case dt:
          T(O);
          break;
        case ut:
          i(11, g = "false");
          break;
      }
    });
  }
  function T(H) {
    i(11, g = H.error ? "true" : "false");
  }
  function S(H) {
    i(10, d = H.value), qe(M, "_change", { name: s, value: d }, { bubbles: !0 });
  }
  function A() {
    je(M, Qe, { name: s, el: M }, { bubbles: !0, timeout: 10 });
  }
  function R() {
    M.addEventListener("radio-item:mounted", (H) => {
      const O = H.detail;
      L = [...L, O], z && clearTimeout(z), z = setTimeout(
        () => {
          I();
        },
        1
      );
    });
  }
  function I() {
    L.forEach((H) => {
      H.el.dispatchEvent(new CustomEvent(
        "radio-group:init",
        {
          composed: !0,
          detail: {
            disabled: n,
            error: j,
            description: H.description,
            name: s,
            checked: H.value === d
          }
        }
      ));
    });
  }
  function B(H) {
    H !== d && (i(10, d = H), M.dispatchEvent(new CustomEvent(
      "_change",
      {
        composed: !0,
        bubbles: !0,
        detail: { name: s, value: d }
      }
    )), N(d));
  }
  function N(H) {
    L.forEach((O) => {
      O.el.dispatchEvent(new CustomEvent(
        "radio-group:select",
        {
          composed: !0,
          detail: { checked: O.value === H }
        }
      ));
    });
  }
  function F(H) {
    qe(M, "help-text::announce", void 0, { bubbles: !0 });
  }
  function q(H) {
    ue[H ? "unshift" : "push"](() => {
      M = H, i(8, M);
    });
  }
  return t.$$set = (H) => {
    "name" in H && i(12, s = H.name), "value" in H && i(10, d = H.value), "orientation" in H && i(0, u = H.orientation), "disabled" in H && i(13, c = H.disabled), "error" in H && i(11, g = H.error), "testid" in H && i(1, h = H.testid), "arialabel" in H && i(2, m = H.arialabel), "mt" in H && i(3, v = H.mt), "mr" in H && i(4, b = H.mr), "mb" in H && i(5, w = H.mb), "ml" in H && i(6, y = H.ml), "$$scope" in H && i(15, o = H.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*disabled*/
    8192 && (n = Ce(c)), t.$$.dirty & /*value*/
    1024 && d !== void 0 && N(d), t.$$.dirty & /*error, _error, _prevError, _rootEl*/
    18816 && (i(7, j = Ce(g)), j !== E && (qe(M, "error::change", { isError: j }, { bubbles: !0 }), i(14, E = j)), I());
  }, [
    u,
    h,
    m,
    v,
    b,
    w,
    y,
    j,
    M,
    F,
    d,
    g,
    s,
    c,
    E,
    o,
    l,
    q
  ];
}
class Ng extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Bg,
      xg,
      ce,
      {
        name: 12,
        value: 10,
        orientation: 0,
        disabled: 13,
        error: 11,
        testid: 1,
        arialabel: 2,
        mt: 3,
        mr: 4,
        mb: 5,
        ml: 6
      },
      Ig
    );
  }
  get name() {
    return this.$$.ctx[12];
  }
  set name(e) {
    this.$$set({ name: e }), k();
  }
  get value() {
    return this.$$.ctx[10];
  }
  set value(e) {
    this.$$set({ value: e }), k();
  }
  get orientation() {
    return this.$$.ctx[0];
  }
  set orientation(e) {
    this.$$set({ orientation: e }), k();
  }
  get disabled() {
    return this.$$.ctx[13];
  }
  set disabled(e) {
    this.$$set({ disabled: e }), k();
  }
  get error() {
    return this.$$.ctx[11];
  }
  set error(e) {
    this.$$set({ error: e }), k();
  }
  get testid() {
    return this.$$.ctx[1];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get arialabel() {
    return this.$$.ctx[2];
  }
  set arialabel(e) {
    this.$$set({ arialabel: e }), k();
  }
  get mt() {
    return this.$$.ctx[3];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[4];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[5];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[6];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-radio-group", he(Ng, { name: {}, value: {}, orientation: {}, disabled: {}, error: {}, testid: {}, arialabel: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function Wg(t) {
  _e(t, "svelte-1y2cug5", ".goa-scrollable.svelte-1y2cug5{scroll-behavior:smooth;margin:2px;width:auto}.goa-scrollable.svelte-1y2cug5::-webkit-scrollbar{width:var(--goa-space-xs)}.goa-scrollable.svelte-1y2cug5::-webkit-scrollbar-track{border-radius:var(--goa-border-radius-m)}.goa-scrollable.svelte-1y2cug5::-webkit-scrollbar-track:hover{background:var(--goa-color-greyscale-200)}.goa-scrollable.svelte-1y2cug5::-webkit-scrollbar-thumb{background:var(--goa-color-greyscale-400);border-radius:var(--goa-border-radius-m)}.goa-scrollable.svelte-1y2cug5::-webkit-scrollbar-thumb:hover{background:var(--goa-color-greyscale-600)}");
}
function Rg(t) {
  let e, i, n, l, o;
  const r = (
    /*#slots*/
    t[9].default
  ), a = oe(
    r,
    t,
    /*$$scope*/
    t[8],
    null
  );
  return {
    c() {
      e = C("div"), a && a.c(), f(e, "class", "goa-scrollable svelte-1y2cug5"), f(e, "style", i = `
  max-height: ${/*maxheight*/
      t[3] || "50vh"};
  overflow-y: ${/*direction*/
      t[0] === "vertical" ? "auto" : "hidden"};
  overflow-x: ${/*direction*/
      t[0] === "horizontal" ? "auto" : "hidden"};
  margin: ${/*vpadding*/
      t[2]};
  padding: 0 ${/*hpadding*/
      t[1]} 3px;
`);
    },
    m(s, d) {
      D(s, e, d), a && a.m(e, null), t[10](e), n = !0, l || (o = te(
        e,
        "scroll",
        /*onScroll*/
        t[5]
      ), l = !0);
    },
    p(s, [d]) {
      a && a.p && (!n || d & /*$$scope*/
      256) && ae(
        a,
        r,
        s,
        /*$$scope*/
        s[8],
        n ? re(
          r,
          /*$$scope*/
          s[8],
          d,
          null
        ) : se(
          /*$$scope*/
          s[8]
        ),
        null
      ), (!n || d & /*maxheight, direction, vpadding, hpadding*/
      15 && i !== (i = `
  max-height: ${/*maxheight*/
      s[3] || "50vh"};
  overflow-y: ${/*direction*/
      s[0] === "vertical" ? "auto" : "hidden"};
  overflow-x: ${/*direction*/
      s[0] === "horizontal" ? "auto" : "hidden"};
  margin: ${/*vpadding*/
      s[2]};
  padding: 0 ${/*hpadding*/
      s[1]} 3px;
`)) && f(e, "style", i);
    },
    i(s) {
      n || (Y(a, s), n = !0);
    },
    o(s) {
      U(a, s), n = !1;
    },
    d(s) {
      s && P(e), a && a.d(s), t[10](null), l = !1, o();
    }
  };
}
function Yg(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { direction: o = "vertical" } = e, { hpadding: r = "" } = e, { vpadding: a = "" } = e, { maxheight: s = "" } = e, { offsetHeight: d } = e, { scrollHeight: u } = e, c;
  function g(m) {
    m.target.dispatchEvent(new CustomEvent(
      "_scroll",
      {
        composed: !0,
        detail: {
          offsetHeight: c.offsetHeight,
          scrollHeight: c.scrollHeight,
          scrollTop: c.scrollTop
        }
      }
    )), m.stopPropagation();
  }
  ke(async () => {
    await Pe(), i(6, d = c.offsetHeight), i(7, u = c.scrollHeight);
  });
  function h(m) {
    ue[m ? "unshift" : "push"](() => {
      c = m, i(4, c);
    });
  }
  return t.$$set = (m) => {
    "direction" in m && i(0, o = m.direction), "hpadding" in m && i(1, r = m.hpadding), "vpadding" in m && i(2, a = m.vpadding), "maxheight" in m && i(3, s = m.maxheight), "offsetHeight" in m && i(6, d = m.offsetHeight), "scrollHeight" in m && i(7, u = m.scrollHeight), "$$scope" in m && i(8, l = m.$$scope);
  }, [
    o,
    r,
    a,
    s,
    c,
    g,
    d,
    u,
    l,
    n,
    h
  ];
}
class Zg extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Yg,
      Rg,
      ce,
      {
        direction: 0,
        hpadding: 1,
        vpadding: 2,
        maxheight: 3,
        offsetHeight: 6,
        scrollHeight: 7
      },
      Wg
    );
  }
  get direction() {
    return this.$$.ctx[0];
  }
  set direction(e) {
    this.$$set({ direction: e }), k();
  }
  get hpadding() {
    return this.$$.ctx[1];
  }
  set hpadding(e) {
    this.$$set({ hpadding: e }), k();
  }
  get vpadding() {
    return this.$$.ctx[2];
  }
  set vpadding(e) {
    this.$$set({ vpadding: e }), k();
  }
  get maxheight() {
    return this.$$.ctx[3];
  }
  set maxheight(e) {
    this.$$set({ maxheight: e }), k();
  }
  get offsetHeight() {
    return this.$$.ctx[6];
  }
  set offsetHeight(e) {
    this.$$set({ offsetHeight: e }), k();
  }
  get scrollHeight() {
    return this.$$.ctx[7];
  }
  set scrollHeight(e) {
    this.$$set({ scrollHeight: e }), k();
  }
}
customElements.define("goa-scrollable", he(Zg, { direction: {}, hpadding: {}, vpadding: {}, maxheight: {}, offsetHeight: {}, scrollHeight: {} }, ["default"], [], !0));
function Ug(t) {
  _e(t, "svelte-7du002", '::slotted(a),::slotted(goa-side-menu-heading),::slotted(a:visited){color:var(--goa-side-menu-color-menu-item) !important;display:block;font:var(--goa-side-menu-typography-item);margin-left:var(--goa-side-menu-child-margin);background-color:var(--goa-side-menu-group-color-bg)}::slotted(a),::slotted(a:visited){padding:var(--goa-side-menu-padding-child);text-decoration:none;border-left:var(--goa-side-menu-child-border-left)}::slotted(a.current){font:var(--goa-side-menu-typography-item-selected);border-left:var(--goa-side-menu-child-border-left-selected);background:var(--goa-side-menu-child-color-bg-selected);color:var(--goa-side-menu-child-color-text-selected)!important}::slotted(a:hover:not(.current)){background:var(--goa-side-menu-child-color-bg-hover);border-left:var(--goa-side-menu-child-border-left-hover)}::slotted(a:focus-visible),.heading.svelte-7du002.svelte-7du002:focus-visible{outline:var(--goa-side-menu-item-focus-border);outline-offset:-3px}.heading.svelte-7du002.svelte-7du002{gap:var(--goa-space-xs);display:flex;flex-direction:row;align-items:flex-start}goa-icon.svelte-7du002.svelte-7du002{margin-top:var(--goa-space-2xs)}:host([child="true"]) a.heading.svelte-7du002.svelte-7du002,.heading.svelte-7du002.svelte-7du002{color:var(--goa-side-menu-color-menu-item);display:flex;justify-content:space-between;font:var(--goa-side-menu-typography-item);padding:var(--goa-side-menu-parent-padding);text-decoration:none;font:var(--goa-side-menu-parent-text);border-radius:var(--goa-side-menu-group-border-radius)}.heading.open.svelte-7du002.svelte-7du002{font:var(--goa-side-menu-parent-text-active)}:host([child="true"]) a.heading.svelte-7du002.svelte-7du002{border-left:var(--goa-side-menu-child-border-left);padding:var(--goa-side-menu-padding-child);margin-left:var(--goa-side-menu-child-margin)}:host([child="true"]) a.heading.svelte-7du002.svelte-7du002:hover{border-left:var(--goa-side-menu-child-border-left-hover);background:var(--goa-side-menu-child-color-bg-hover)}:host([child="true"]) .side-menu-group.current a.heading.svelte-7du002.svelte-7du002{background:var(--goa-side-menu-child-color-bg-selected);border-left:var(--goa-side-menu-child-border-left)}.side-menu-group.svelte-7du002.svelte-7du002{background-color:var(--goa-side-menu-group-color-bg);border-radius:var(--goa-side-menu-group-border-radius);padding:var(--goa-side-menu-group-padding)}.side-menu-group.current.svelte-7du002 .heading.svelte-7du002{background:var(--goa-side-menu-parent-color-bg-selected)}.heading.svelte-7du002.svelte-7du002:hover{background:var(--goa-side-menu-color-bg-menu-item-hover)}.hidden.svelte-7du002.svelte-7du002{display:none}.group.svelte-7du002.svelte-7du002{padding-left:var(--goa-side-menu-child-margin)}.trailing-icon.svelte-7du002.svelte-7du002{margin-left:auto;height:var(--goa-icon-size-l)}.leading-icon.svelte-7du002.svelte-7du002{height:var(--goa-icon-size-l)}');
}
function Go(t) {
  let e, i;
  return {
    c() {
      e = C("div"), i = C("goa-icon"), p(
        i,
        "type",
        /*icon*/
        t[1]
      ), p(i, "class", "svelte-7du002"), f(e, "class", "leading-icon svelte-7du002");
    },
    m(n, l) {
      D(n, e, l), _(e, i);
    },
    p(n, l) {
      l & /*icon*/
      2 && p(
        i,
        "type",
        /*icon*/
        n[1]
      );
    },
    d(n) {
      n && P(e);
    }
  };
}
function Gg(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", "chevron-forward"), p(e, "class", "svelte-7du002");
    },
    m(i, n) {
      D(i, e, n);
    },
    d(i) {
      i && P(e);
    }
  };
}
function Kg(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", "chevron-down"), p(e, "class", "svelte-7du002");
    },
    m(i, n) {
      D(i, e, n);
    },
    d(i) {
      i && P(e);
    }
  };
}
function Xg(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m = (
    /*icon*/
    t[1] && Go(t)
  );
  function v(E, M) {
    return (
      /*_open*/
      E[7] ? Kg : Gg
    );
  }
  let b = v(t), w = b(t);
  const y = (
    /*#slots*/
    t[13].default
  ), j = oe(
    y,
    t,
    /*$$scope*/
    t[12],
    null
  );
  return {
    c() {
      e = C("div"), i = C("a"), m && m.c(), n = x(), l = le(
        /*heading*/
        t[0]
      ), o = x(), r = C("div"), w.c(), s = x(), d = C("div"), j && j.c(), f(r, "class", "trailing-icon svelte-7du002"), f(i, "href", a = `#${/*_slug*/
      t[10]}`), f(i, "class", "heading svelte-7du002"), G(
        i,
        "open",
        /*_open*/
        t[7]
      ), f(d, "class", "group svelte-7du002"), f(d, "data-testid", "group"), G(d, "hidden", !/*_open*/
      t[7]), f(e, "class", "side-menu-group svelte-7du002"), f(
        e,
        "data-testid",
        /*testid*/
        t[2]
      ), f(e, "style", u = `
    ${be(
        /*mt*/
        t[3],
        /*mr*/
        t[4],
        /*mb*/
        t[5],
        /*ml*/
        t[6]
      )};
  `), G(
        e,
        "current",
        /*_current*/
        t[8]
      );
    },
    m(E, M) {
      D(E, e, M), _(e, i), m && m.m(i, null), _(i, n), _(i, l), _(i, o), _(i, r), w.m(r, null), _(e, s), _(e, d), j && j.m(d, null), t[14](e), c = !0, g || (h = te(
        i,
        "click",
        /*handleClick*/
        t[11]
      ), g = !0);
    },
    p(E, [M]) {
      /*icon*/
      E[1] ? m ? m.p(E, M) : (m = Go(E), m.c(), m.m(i, n)) : m && (m.d(1), m = null), (!c || M & /*heading*/
      1) && pe(
        l,
        /*heading*/
        E[0]
      ), b !== (b = v(E)) && (w.d(1), w = b(E), w && (w.c(), w.m(r, null))), (!c || M & /*_slug*/
      1024 && a !== (a = `#${/*_slug*/
      E[10]}`)) && f(i, "href", a), (!c || M & /*_open*/
      128) && G(
        i,
        "open",
        /*_open*/
        E[7]
      ), j && j.p && (!c || M & /*$$scope*/
      4096) && ae(
        j,
        y,
        E,
        /*$$scope*/
        E[12],
        c ? re(
          y,
          /*$$scope*/
          E[12],
          M,
          null
        ) : se(
          /*$$scope*/
          E[12]
        ),
        null
      ), (!c || M & /*_open*/
      128) && G(d, "hidden", !/*_open*/
      E[7]), (!c || M & /*testid*/
      4) && f(
        e,
        "data-testid",
        /*testid*/
        E[2]
      ), (!c || M & /*mt, mr, mb, ml*/
      120 && u !== (u = `
    ${be(
        /*mt*/
        E[3],
        /*mr*/
        E[4],
        /*mb*/
        E[5],
        /*ml*/
        E[6]
      )};
  `)) && f(e, "style", u), (!c || M & /*_current*/
      256) && G(
        e,
        "current",
        /*_current*/
        E[8]
      );
    },
    i(E) {
      c || (Y(j, E), c = !0);
    },
    o(E) {
      U(j, E), c = !1;
    },
    d(E) {
      E && P(e), m && m.d(), w.d(), j && j.d(E), t[14](null), g = !1, h();
    }
  };
}
function Jg(t) {
  return t == null ? void 0 : t.toLowerCase().replace(/ /g, "-");
}
function Qg(t, e, i) {
  let n, { $$slots: l = {}, $$scope: o } = e, { heading: r } = e, { icon: a = null } = e, { testid: s = "" } = e, { mt: d = null } = e, { mr: u = null } = e, { mb: c = null } = e, { ml: g = null } = e, h = !1, m = !1, v;
  ke(() => {
    b(), w();
  });
  function b() {
    if (!v) return;
    const L = lt(v);
    if (L.length === 0) return;
    const z = L.filter((V) => V.tagName === "A").map((V) => (V.classList.remove("current"), V));
    setTimeout(
      () => {
        v.dispatchEvent(new CustomEvent(
          "sidemenugroup:mounted",
          {
            detail: { el: v, links: z },
            composed: !0,
            bubbles: !0
          }
        ));
      },
      1
    );
  }
  function w() {
    v.addEventListener("sidemenu:current:change", (L) => {
      const z = L.detail;
      y(z);
    }), v.addEventListener("_open", (L) => {
      i(7, h = i(8, m = L.detail.current));
    });
  }
  function y(L) {
    const z = lt(v);
    if (z.length === 0) return;
    let V = null;
    i(8, m = !1), z.forEach((T) => {
      T.getAttribute("href") === L && (V = T), T.classList.remove("current"), T.tagName === "GOA-SIDE-MENU-GROUP" && T.setAttribute("child", "true");
    }), V && V.classList.add("current"), i(8, m = i(7, h = !!V)), E(h);
  }
  function j(L) {
    i(7, h = !h), L.preventDefault();
  }
  function E(L) {
    v.dispatchEvent(new CustomEvent(
      "_open",
      {
        bubbles: !0,
        composed: !0,
        detail: { current: L }
      }
    ));
  }
  function M(L) {
    ue[L ? "unshift" : "push"](() => {
      v = L, i(9, v);
    });
  }
  return t.$$set = (L) => {
    "heading" in L && i(0, r = L.heading), "icon" in L && i(1, a = L.icon), "testid" in L && i(2, s = L.testid), "mt" in L && i(3, d = L.mt), "mr" in L && i(4, u = L.mr), "mb" in L && i(5, c = L.mb), "ml" in L && i(6, g = L.ml), "$$scope" in L && i(12, o = L.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*heading*/
    1 && i(10, n = Jg(r));
  }, [
    r,
    a,
    s,
    d,
    u,
    c,
    g,
    h,
    m,
    v,
    n,
    j,
    o,
    l,
    M
  ];
}
class $g extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Qg,
      Xg,
      ce,
      {
        heading: 0,
        icon: 1,
        testid: 2,
        mt: 3,
        mr: 4,
        mb: 5,
        ml: 6
      },
      Ug
    );
  }
  get heading() {
    return this.$$.ctx[0];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get icon() {
    return this.$$.ctx[1];
  }
  set icon(e) {
    this.$$set({ icon: e }), k();
  }
  get testid() {
    return this.$$.ctx[2];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[3];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[4];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[5];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[6];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-side-menu-group", he($g, { heading: {}, icon: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function eh(t) {
  _e(t, "svelte-z0jmg2", "::slotted(a),::slotted(a:visited){color:var(--goa-side-menu-text-color, var(--goa-color-text-default)) !important;display:block;font:var(--goa-side-menu-typography-item);padding:var(--goa-side-menu-padding-item);text-decoration:none}::slotted(a.current){font:var(--goa-side-menu-typography-item-active);background:var(--goa-side-menu-color-bg-menu-item-hover)}::slotted(a:hover:not(.current)){background:var(--goa-side-menu-color-bg-menu-item-hover)}::slotted(a:focus-visible){outline:var(--goa-side-menu-item-focus-border);outline-offset:-3px}.side-menu.svelte-z0jmg2{display:flex;height:100%;flex-direction:column;gap:var(--goa-side-menu-items-gap)}");
}
function th(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[3].default
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[2],
    null
  );
  return {
    c() {
      e = C("div"), l && l.c(), f(e, "class", "side-menu svelte-z0jmg2"), f(
        e,
        "data-testid",
        /*testid*/
        t[0]
      );
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null), t[4](e), i = !0;
    },
    p(o, [r]) {
      l && l.p && (!i || r & /*$$scope*/
      4) && ae(
        l,
        n,
        o,
        /*$$scope*/
        o[2],
        i ? re(
          n,
          /*$$scope*/
          o[2],
          r,
          null
        ) : se(
          /*$$scope*/
          o[2]
        ),
        null
      ), (!i || r & /*testid*/
      1) && f(
        e,
        "data-testid",
        /*testid*/
        o[0]
      );
    },
    i(o) {
      i || (Y(l, o), i = !0);
    },
    o(o) {
      U(l, o), i = !1;
    },
    d(o) {
      o && P(e), l && l.d(o), t[4](null);
    }
  };
}
function ih(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { testid: o = "" } = e, r, a = [], s = [], d = null;
  ke(async () => {
    await Pe(), u(), g(), m();
  }), ct(() => {
    v();
  });
  function u() {
    if (!r) return;
    const w = lt(r);
    w.length !== 0 && (a = w.filter((y) => y.tagName === "A").map((y) => (y.classList.remove("current"), y.addEventListener("click", g), y)), r.addEventListener("sidemenugroup:mounted", c));
  }
  function c(w) {
    const y = w.detail;
    s = [...s, y], g();
  }
  function g() {
    let w = [...a];
    s.forEach((j) => {
      w = [...w, ...j.links];
    }), w.forEach((j) => j.classList.remove("current"));
    const y = Mr(w, window.location);
    y == null || y.classList.add("current"), h((y == null ? void 0 : y.getAttribute("href")) || "");
  }
  function h(w) {
    s.forEach((y) => {
      y.el.dispatchEvent(new CustomEvent("sidemenu:current:change", { composed: !0, detail: w }));
    });
  }
  function m() {
    let w = document.location.href;
    d = new MutationObserver((y) => {
      Ni(document.location, w) && (w = document.location.href, g());
    }), d.observe(document.body, { childList: !0, subtree: !0 }), window.addEventListener("popstate", g);
  }
  function v() {
    d && (d.disconnect(), d = null), window.removeEventListener("popstate", g);
  }
  function b(w) {
    ue[w ? "unshift" : "push"](() => {
      r = w, i(1, r);
    });
  }
  return t.$$set = (w) => {
    "testid" in w && i(0, o = w.testid), "$$scope" in w && i(2, l = w.$$scope);
  }, [o, r, l, n, b];
}
class nh extends me {
  constructor(e) {
    super(), ge(this, e, ih, th, ce, { testid: 0 }, eh);
  }
  get testid() {
    return this.$$.ctx[0];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-side-menu", he(nh, { testid: {} }, ["default"], [], !0));
function lh(t) {
  _e(t, "svelte-xb12yz", "h2.icon.svelte-xb12yz{display:flex;align-items:center}goa-icon.svelte-xb12yz{color:var(--goa-side-menu-icon-color);font-size:var(--goa-side-menu-icon-size);margin-right:var(--goa-side-menu-heading-icon-gap)}h2.svelte-xb12yz{border-top:var(--goa-side-menu-heading-border);background:var(--goa-side-menu-heading-color-bg);padding:var(--goa-side-menu-heading-padding);color:var(--goa-side-menu-heading-color, #666);font:var(--goa-side-menu-heading-typography);display:flex;align-items:flex-start;margin:var(--goa-side-menu-heading-margin);gap:var(--goa-side-menu-heading-gap)}");
}
const oh = (t) => ({}), Ko = (t) => ({});
function Xo(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "id", "heading-icon"), p(
        e,
        "type",
        /*icon*/
        t[0]
      ), p(e, "theme", "filled"), p(e, "class", "svelte-xb12yz");
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n & /*icon*/
      1 && p(
        e,
        "type",
        /*icon*/
        i[0]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function rh(t) {
  let e, i, n, l, o = (
    /*icon*/
    t[0] && Xo(t)
  );
  const r = (
    /*#slots*/
    t[3].default
  ), a = oe(
    r,
    t,
    /*$$scope*/
    t[2],
    null
  ), s = (
    /*#slots*/
    t[3].meta
  ), d = oe(
    s,
    t,
    /*$$scope*/
    t[2],
    Ko
  );
  return {
    c() {
      e = C("h2"), o && o.c(), i = x(), a && a.c(), n = x(), d && d.c(), f(
        e,
        "data-testid",
        /*testid*/
        t[1]
      ), f(e, "class", "svelte-xb12yz"), G(
        e,
        "icon",
        /*icon*/
        t[0]
      );
    },
    m(u, c) {
      D(u, e, c), o && o.m(e, null), _(e, i), a && a.m(e, null), _(e, n), d && d.m(e, null), l = !0;
    },
    p(u, [c]) {
      /*icon*/
      u[0] ? o ? o.p(u, c) : (o = Xo(u), o.c(), o.m(e, i)) : o && (o.d(1), o = null), a && a.p && (!l || c & /*$$scope*/
      4) && ae(
        a,
        r,
        u,
        /*$$scope*/
        u[2],
        l ? re(
          r,
          /*$$scope*/
          u[2],
          c,
          null
        ) : se(
          /*$$scope*/
          u[2]
        ),
        null
      ), d && d.p && (!l || c & /*$$scope*/
      4) && ae(
        d,
        s,
        u,
        /*$$scope*/
        u[2],
        l ? re(
          s,
          /*$$scope*/
          u[2],
          c,
          oh
        ) : se(
          /*$$scope*/
          u[2]
        ),
        Ko
      ), (!l || c & /*testid*/
      2) && f(
        e,
        "data-testid",
        /*testid*/
        u[1]
      ), (!l || c & /*icon*/
      1) && G(
        e,
        "icon",
        /*icon*/
        u[0]
      );
    },
    i(u) {
      l || (Y(a, u), Y(d, u), l = !0);
    },
    o(u) {
      U(a, u), U(d, u), l = !1;
    },
    d(u) {
      u && P(e), o && o.d(), a && a.d(u), d && d.d(u);
    }
  };
}
function ah(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { icon: o = null } = e, { testid: r = "section-heading" } = e;
  return t.$$set = (a) => {
    "icon" in a && i(0, o = a.icon), "testid" in a && i(1, r = a.testid), "$$scope" in a && i(2, l = a.$$scope);
  }, [o, r, l, n];
}
class sh extends me {
  constructor(e) {
    super(), ge(this, e, ah, rh, ce, { icon: 0, testid: 1 }, lh);
  }
  get icon() {
    return this.$$.ctx[0];
  }
  set icon(e) {
    this.$$set({ icon: e }), k();
  }
  get testid() {
    return this.$$.ctx[1];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-side-menu-heading", he(sh, { icon: {}, testid: {} }, ["default", "meta"], [], !0));
function uh(t) {
  _e(t, "svelte-1e4jerw", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}@keyframes svelte-1e4jerw-pulse{0%{opacity:0.5}50%{opacity:1}100%{opacity:0.5}}.skeleton.svelte-1e4jerw.svelte-1e4jerw{background-color:var(--goa-skeleton-loading-color-bg);animation:svelte-1e4jerw-pulse 2s infinite ease-in-out;overflow:hidden;margin:10px 0}.image.svelte-1e4jerw.svelte-1e4jerw,.image-1.svelte-1e4jerw.svelte-1e4jerw{background-color:var(--goa-skeleton-loading-color-bg);flex:1 1 100px;height:100px;margin:0}.image-2.svelte-1e4jerw.svelte-1e4jerw{height:140px}.image-3.svelte-1e4jerw.svelte-1e4jerw{height:200px}.image-4.svelte-1e4jerw.svelte-1e4jerw{height:300px}.text.svelte-1e4jerw.svelte-1e4jerw,.text-1.svelte-1e4jerw.svelte-1e4jerw,.text-2.svelte-1e4jerw.svelte-1e4jerw,.text-3.svelte-1e4jerw.svelte-1e4jerw,.text-4.svelte-1e4jerw.svelte-1e4jerw{width:100%;height:12px;border-radius:0.25rem;margin:6px 0}.title.svelte-1e4jerw.svelte-1e4jerw,.title-1.svelte-1e4jerw.svelte-1e4jerw,.title-2.svelte-1e4jerw.svelte-1e4jerw{width:100%;height:0.75rem;border-radius:0.25rem}.title-3.svelte-1e4jerw.svelte-1e4jerw{height:0.8rem}.title-4.svelte-1e4jerw.svelte-1e4jerw{height:1rem}.text-small.svelte-1e4jerw.svelte-1e4jerw,.text-small-1.svelte-1e4jerw.svelte-1e4jerw{width:30%;height:6px;border-radius:2px}.text-small-2.svelte-1e4jerw.svelte-1e4jerw{width:40%;height:8px;border-radius:2px}.text-small-3.svelte-1e4jerw.svelte-1e4jerw{width:50%;height:10px;border-radius:3px}.text-small-4.svelte-1e4jerw.svelte-1e4jerw{width:70%;height:12px;border-radius:4px}.paragraph.svelte-1e4jerw.svelte-1e4jerw{width:100%;height:70px;border-radius:4px}.header.svelte-1e4jerw.svelte-1e4jerw,.header-1.svelte-1e4jerw.svelte-1e4jerw{width:50%;height:18px;margin:12px 0;border-radius:0.25rem}.header-2.svelte-1e4jerw.svelte-1e4jerw{width:60%;height:20px;margin:14px 0;border-radius:0.25rem}.header-3.svelte-1e4jerw.svelte-1e4jerw{width:70%;height:22px;margin:16px 0;border-radius:0.25rem}.header-4.svelte-1e4jerw.svelte-1e4jerw{width:80%;height:24px;margin:18px 0;border-radius:0.3rem}.avatar.svelte-1e4jerw.svelte-1e4jerw{display:inline-block}.avatar.svelte-1e4jerw.svelte-1e4jerw,.avatar-1.svelte-1e4jerw.svelte-1e4jerw{width:40px;height:40px;border-radius:50%}.avatar-2.svelte-1e4jerw.svelte-1e4jerw{width:60px;height:60px;border-radius:50%}.avatar-3.svelte-1e4jerw.svelte-1e4jerw{width:80px;height:80px;border-radius:50%}.avatar-4.svelte-1e4jerw.svelte-1e4jerw{width:120px;height:120px;border-radius:50%}.thumbnail.svelte-1e4jerw.svelte-1e4jerw{display:inline-block}.thumbnail.svelte-1e4jerw.svelte-1e4jerw,.thumbnail-1.svelte-1e4jerw.svelte-1e4jerw{width:40px;height:40px;border-radius:4px}.thumbnail-2.svelte-1e4jerw.svelte-1e4jerw{width:60px;height:60px;border-radius:4px}.thumbnail-3.svelte-1e4jerw.svelte-1e4jerw{width:80px;height:80px;border-radius:4px}.thumbnail-4.svelte-1e4jerw.svelte-1e4jerw{width:120px;height:120px;border-radius:4px}.card.svelte-1e4jerw.svelte-1e4jerw,.card-1.svelte-1e4jerw.svelte-1e4jerw,.card-2.svelte-1e4jerw.svelte-1e4jerw,.card-3.svelte-1e4jerw.svelte-1e4jerw,.card-4.svelte-1e4jerw.svelte-1e4jerw{border:1px solid var(--goa-color-greyscale-100);border-radius:4px}@container self (max-width: 623px){.card.svelte-1e4jerw.svelte-1e4jerw{width:100%}}@container self (min-width: 624px){.card.svelte-1e4jerw.svelte-1e4jerw{width:var(--max-width)}}.card-content.svelte-1e4jerw.svelte-1e4jerw{flex:1 1 auto;padding:1rem}.profile.svelte-1e4jerw.svelte-1e4jerw{display:flex;flex-direction:row;align-items:center;gap:1rem}.profile-1.svelte-1e4jerw.svelte-1e4jerw{max-width:280px}.profile-2.svelte-1e4jerw.svelte-1e4jerw{max-width:360px}.profile-3.svelte-1e4jerw.svelte-1e4jerw{max-width:480px}.profile-4.svelte-1e4jerw.svelte-1e4jerw{max-width:560px}.profile.svelte-1e4jerw .profile-avatar.svelte-1e4jerw{flex-shrink:0}.profile.svelte-1e4jerw .profile-name.svelte-1e4jerw{flex:1 1 auto}");
}
function Jo(t, e, i) {
  const n = t.slice();
  return n[13] = e[i], n;
}
function dh(t) {
  let e, i;
  return {
    c() {
      e = C("div"), f(e, "class", i = "skeleton " + /*type*/
      t[3] + ` ${/*type*/
      t[3]}-${/*size*/
      t[1]} svelte-1e4jerw`);
    },
    m(n, l) {
      D(n, e, l);
    },
    p(n, l) {
      l & /*type, size*/
      10 && i !== (i = "skeleton " + /*type*/
      n[3] + ` ${/*type*/
      n[3]}-${/*size*/
      n[1]} svelte-1e4jerw`) && f(e, "class", i);
    },
    i: ve,
    o: ve,
    d(n) {
      n && P(e);
    }
  };
}
function ch(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g;
  return l = new Je({
    props: { type: "image", size: (
      /*size*/
      t[1]
    ) }
  }), a = new Je({ props: { type: "header", size: "4" } }), d = new Je({ props: { type: "header", size: "1" } }), c = new Je({
    props: { type: "lines", size: (
      /*size*/
      t[1]
    ) }
  }), {
    c() {
      e = C("div"), i = C("div"), n = C("div"), et(l.$$.fragment), o = x(), r = C("div"), et(a.$$.fragment), s = x(), et(d.$$.fragment), u = x(), et(c.$$.fragment), Be(n, "flex", "1 1 auto"), Be(r, "flex", "2 2 auto"), Be(i, "display", "flex"), Be(i, "gap", "1rem");
    },
    m(h, m) {
      D(h, e, m), _(e, i), _(i, n), Ke(l, n, null), _(i, o), _(i, r), Ke(a, r, null), _(r, s), Ke(d, r, null), _(e, u), Ke(c, e, null), g = !0;
    },
    p(h, m) {
      const v = {};
      m & /*size*/
      2 && (v.size = /*size*/
      h[1]), l.$set(v);
      const b = {};
      m & /*size*/
      2 && (b.size = /*size*/
      h[1]), c.$set(b);
    },
    i(h) {
      g || (Y(l.$$.fragment, h), Y(a.$$.fragment, h), Y(d.$$.fragment, h), Y(c.$$.fragment, h), g = !0);
    },
    o(h) {
      U(l.$$.fragment, h), U(a.$$.fragment, h), U(d.$$.fragment, h), U(c.$$.fragment, h), g = !1;
    },
    d(h) {
      h && P(e), Xe(l), Xe(a), Xe(d), Xe(c);
    }
  };
}
function fh(t) {
  let e, i, n = Le(Array(Number.parseInt(
    /*linecount*/
    t[2] + ""
  ))), l = [];
  for (let r = 0; r < n.length; r += 1)
    l[r] = Qo(Jo(t, n, r));
  const o = (r) => U(l[r], 1, 1, () => {
    l[r] = null;
  });
  return {
    c() {
      for (let r = 0; r < l.length; r += 1)
        l[r].c();
      e = Ne();
    },
    m(r, a) {
      for (let s = 0; s < l.length; s += 1)
        l[s] && l[s].m(r, a);
      D(r, e, a), i = !0;
    },
    p(r, a) {
      if (a & /*size, linecount*/
      6) {
        n = Le(Array(Number.parseInt(
          /*linecount*/
          r[2] + ""
        )));
        let s;
        for (s = 0; s < n.length; s += 1) {
          const d = Jo(r, n, s);
          l[s] ? (l[s].p(d, a), Y(l[s], 1)) : (l[s] = Qo(d), l[s].c(), Y(l[s], 1), l[s].m(e.parentNode, e));
        }
        for (Oe(), s = n.length; s < l.length; s += 1)
          o(s);
        Fe();
      }
    },
    i(r) {
      if (!i) {
        for (let a = 0; a < n.length; a += 1)
          Y(l[a]);
        i = !0;
      }
    },
    o(r) {
      l = l.filter(Boolean);
      for (let a = 0; a < l.length; a += 1)
        U(l[a]);
      i = !1;
    },
    d(r) {
      r && P(e), Ye(l, r);
    }
  };
}
function gh(t) {
  let e, i, n, l, o, r, a, s, d, u;
  return n = new Je({
    props: { type: "avatar", size: (
      /*size*/
      t[1]
    ) }
  }), r = new Je({
    props: { type: "title", size: (
      /*size*/
      t[1]
    ) }
  }), s = new Je({
    props: {
      type: "text-small",
      size: (
        /*size*/
        t[1]
      )
    }
  }), {
    c() {
      e = C("div"), i = C("div"), et(n.$$.fragment), l = x(), o = C("div"), et(r.$$.fragment), a = x(), et(s.$$.fragment), f(i, "class", "profile-avatar svelte-1e4jerw"), f(o, "class", "profile-name svelte-1e4jerw"), f(e, "class", d = "profile profile-" + /*size*/
      t[1] + " svelte-1e4jerw");
    },
    m(c, g) {
      D(c, e, g), _(e, i), Ke(n, i, null), _(e, l), _(e, o), Ke(r, o, null), _(o, a), Ke(s, o, null), u = !0;
    },
    p(c, g) {
      const h = {};
      g & /*size*/
      2 && (h.size = /*size*/
      c[1]), n.$set(h);
      const m = {};
      g & /*size*/
      2 && (m.size = /*size*/
      c[1]), r.$set(m);
      const v = {};
      g & /*size*/
      2 && (v.size = /*size*/
      c[1]), s.$set(v), (!u || g & /*size*/
      2 && d !== (d = "profile profile-" + /*size*/
      c[1] + " svelte-1e4jerw")) && f(e, "class", d);
    },
    i(c) {
      u || (Y(n.$$.fragment, c), Y(r.$$.fragment, c), Y(s.$$.fragment, c), u = !0);
    },
    o(c) {
      U(n.$$.fragment, c), U(r.$$.fragment, c), U(s.$$.fragment, c), u = !1;
    },
    d(c) {
      c && P(e), Xe(n), Xe(r), Xe(s);
    }
  };
}
function hh(t) {
  let e, i, n, l, o, r, a, s, d;
  return i = new Je({
    props: { type: "image", size: (
      /*size*/
      t[1]
    ) }
  }), o = new Je({
    props: { type: "header", size: (
      /*size*/
      t[1]
    ) }
  }), a = new Je({
    props: {
      type: "lines",
      size: (
        /*size*/
        t[1]
      ),
      linecount: (
        /*linecount*/
        t[2]
      )
    }
  }), {
    c() {
      e = C("div"), et(i.$$.fragment), n = x(), l = C("div"), et(o.$$.fragment), r = x(), et(a.$$.fragment), f(l, "class", "card-content svelte-1e4jerw"), f(e, "class", s = "card card-" + /*size*/
      t[1] + " svelte-1e4jerw"), Be(
        e,
        "--max-width",
        /*maxwidth*/
        t[0]
      );
    },
    m(u, c) {
      D(u, e, c), Ke(i, e, null), _(e, n), _(e, l), Ke(o, l, null), _(l, r), Ke(a, l, null), d = !0;
    },
    p(u, c) {
      const g = {};
      c & /*size*/
      2 && (g.size = /*size*/
      u[1]), i.$set(g);
      const h = {};
      c & /*size*/
      2 && (h.size = /*size*/
      u[1]), o.$set(h);
      const m = {};
      c & /*size*/
      2 && (m.size = /*size*/
      u[1]), c & /*linecount*/
      4 && (m.linecount = /*linecount*/
      u[2]), a.$set(m), (!d || c & /*size*/
      2 && s !== (s = "card card-" + /*size*/
      u[1] + " svelte-1e4jerw")) && f(e, "class", s), (!d || c & /*maxwidth*/
      1) && Be(
        e,
        "--max-width",
        /*maxwidth*/
        u[0]
      );
    },
    i(u) {
      d || (Y(i.$$.fragment, u), Y(o.$$.fragment, u), Y(a.$$.fragment, u), d = !0);
    },
    o(u) {
      U(i.$$.fragment, u), U(o.$$.fragment, u), U(a.$$.fragment, u), d = !1;
    },
    d(u) {
      u && P(e), Xe(i), Xe(o), Xe(a);
    }
  };
}
function Qo(t) {
  let e, i;
  return e = new Je({
    props: {
      type: "text",
      size: (
        /*size*/
        t[1]
      ),
      linecount: (
        /*linecount*/
        t[2]
      )
    }
  }), {
    c() {
      et(e.$$.fragment);
    },
    m(n, l) {
      Ke(e, n, l), i = !0;
    },
    p(n, l) {
      const o = {};
      l & /*size*/
      2 && (o.size = /*size*/
      n[1]), l & /*linecount*/
      4 && (o.linecount = /*linecount*/
      n[2]), e.$set(o);
    },
    i(n) {
      i || (Y(e.$$.fragment, n), i = !0);
    },
    o(n) {
      U(e.$$.fragment, n), i = !1;
    },
    d(n) {
      Xe(e, n);
    }
  };
}
function mh(t) {
  let e, i, n, l, o;
  const r = [
    hh,
    gh,
    fh,
    ch,
    dh
  ], a = [];
  function s(d, u) {
    return (
      /*type*/
      d[3] === "card" ? 0 : (
        /*type*/
        d[3] === "profile" ? 1 : (
          /*type*/
          d[3] === "lines" ? 2 : (
            /*type*/
            d[3] === "article" ? 3 : 4
          )
        )
      )
    );
  }
  return i = s(t), n = a[i] = r[i](t), {
    c() {
      e = C("div"), n.c(), f(e, "id", "container"), f(
        e,
        "data-testid",
        /*testid*/
        t[4]
      ), f(e, "style", l = be(
        /*mt*/
        t[5],
        /*mr*/
        t[6],
        /*mb*/
        t[7],
        /*ml*/
        t[8]
      ));
    },
    m(d, u) {
      D(d, e, u), a[i].m(e, null), o = !0;
    },
    p(d, [u]) {
      let c = i;
      i = s(d), i === c ? a[i].p(d, u) : (Oe(), U(a[c], 1, 1, () => {
        a[c] = null;
      }), Fe(), n = a[i], n ? n.p(d, u) : (n = a[i] = r[i](d), n.c()), Y(n, 1), n.m(e, null)), (!o || u & /*testid*/
      16) && f(
        e,
        "data-testid",
        /*testid*/
        d[4]
      ), (!o || u & /*mt, mr, mb, ml*/
      480 && l !== (l = be(
        /*mt*/
        d[5],
        /*mr*/
        d[6],
        /*mb*/
        d[7],
        /*ml*/
        d[8]
      ))) && f(e, "style", l);
    },
    i(d) {
      o || (Y(n), o = !0);
    },
    o(d) {
      U(n), o = !1;
    },
    d(d) {
      d && P(e), a[i].d();
    }
  };
}
function vh(t, e, i) {
  const [n, l] = Me(
    "Skeleton type",
    [
      "image",
      "text",
      "title",
      "text-small",
      "avatar",
      "header",
      "paragraph",
      "thumbnail",
      "card",
      "lines",
      "profile",
      "article"
    ],
    !0
  ), [o, r] = Me("Skeleton size", ["1", "2", "3", "4"]);
  let { maxwidth: a = "300px" } = e, { size: s = "1" } = e, { linecount: d = 3 } = e, { type: u } = e, { testid: c = "" } = e, { mt: g = null } = e, { mr: h = null } = e, { mb: m = null } = e, { ml: v = null } = e;
  return ke(() => {
    setTimeout(() => l(u), 1), r(s);
  }), t.$$set = (b) => {
    "maxwidth" in b && i(0, a = b.maxwidth), "size" in b && i(1, s = b.size), "linecount" in b && i(2, d = b.linecount), "type" in b && i(3, u = b.type), "testid" in b && i(4, c = b.testid), "mt" in b && i(5, g = b.mt), "mr" in b && i(6, h = b.mr), "mb" in b && i(7, m = b.mb), "ml" in b && i(8, v = b.ml);
  }, [a, s, d, u, c, g, h, m, v];
}
class Je extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      vh,
      mh,
      ce,
      {
        maxwidth: 0,
        size: 1,
        linecount: 2,
        type: 3,
        testid: 4,
        mt: 5,
        mr: 6,
        mb: 7,
        ml: 8
      },
      uh
    );
  }
  get maxwidth() {
    return this.$$.ctx[0];
  }
  set maxwidth(e) {
    this.$$set({ maxwidth: e }), k();
  }
  get size() {
    return this.$$.ctx[1];
  }
  set size(e) {
    this.$$set({ size: e }), k();
  }
  get linecount() {
    return this.$$.ctx[2];
  }
  set linecount(e) {
    this.$$set({ linecount: e }), k();
  }
  get type() {
    return this.$$.ctx[3];
  }
  set type(e) {
    this.$$set({ type: e }), k();
  }
  get testid() {
    return this.$$.ctx[4];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[5];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[6];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[7];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[8];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-skeleton", he(Je, { maxwidth: {}, size: {}, linecount: {}, type: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {} }, [], [], !0));
function bh(t) {
  let e, i;
  return {
    c() {
      e = C("div"), f(e, "style", i = `
    height: var(--goa-space-${/*vspacing*/
      t[1]});
    width: var(--goa-space-${/*hspacing*/
      t[0]});
  `), f(
        e,
        "data-testid",
        /*testid*/
        t[2]
      );
    },
    m(n, l) {
      D(n, e, l), t[4](e);
    },
    p(n, [l]) {
      l & /*vspacing, hspacing*/
      3 && i !== (i = `
    height: var(--goa-space-${/*vspacing*/
      n[1]});
    width: var(--goa-space-${/*hspacing*/
      n[0]});
  `) && f(e, "style", i), l & /*testid*/
      4 && f(
        e,
        "data-testid",
        /*testid*/
        n[2]
      );
    },
    i: ve,
    o: ve,
    d(n) {
      n && P(e), t[4](null);
    }
  };
}
function ph(t, e, i) {
  let { hspacing: n = "none" } = e, { vspacing: l = "none" } = e, { testid: o = "" } = e, r;
  ke(() => {
    const s = `var(--goa-space-${l})`, d = n === "fill" ? "100%" : `var(--goa-space-${n})`;
    jr(r, ":host", { width: d, height: s });
  });
  function a(s) {
    ue[s ? "unshift" : "push"](() => {
      r = s, i(3, r);
    });
  }
  return t.$$set = (s) => {
    "hspacing" in s && i(0, n = s.hspacing), "vspacing" in s && i(1, l = s.vspacing), "testid" in s && i(2, o = s.testid);
  }, [n, l, o, r, a];
}
class _h extends me {
  constructor(e) {
    super(), ge(this, e, ph, bh, ce, { hspacing: 0, vspacing: 1, testid: 2 });
  }
  get hspacing() {
    return this.$$.ctx[0];
  }
  set hspacing(e) {
    this.$$set({ hspacing: e }), k();
  }
  get vspacing() {
    return this.$$.ctx[1];
  }
  set vspacing(e) {
    this.$$set({ vspacing: e }), k();
  }
  get testid() {
    return this.$$.ctx[2];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-spacer", he(_h, { hspacing: {}, vspacing: {}, testid: {} }, [], [], !0));
const St = [];
function wh(t, e = ve) {
  let i;
  const n = /* @__PURE__ */ new Set();
  function l(a) {
    if (ce(t, a) && (t = a, i)) {
      const s = !St.length;
      for (const d of n)
        d[1](), St.push(d, t);
      if (s) {
        for (let d = 0; d < St.length; d += 2)
          St[d][0](St[d + 1]);
        St.length = 0;
      }
    }
  }
  function o(a) {
    l(a(t));
  }
  function r(a, s = ve) {
    const d = [a, s];
    return n.add(d), n.size === 1 && (i = e(l, o) || ve), a(t), () => {
      n.delete(d), n.size === 0 && i && (i(), i = null);
    };
  }
  return { set: l, update: o, subscribe: r };
}
function $o(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function Oi(t, e) {
  if (t === e || t !== t) return () => t;
  const i = typeof t;
  if (i !== typeof e || Array.isArray(t) !== Array.isArray(e))
    throw new Error("Cannot interpolate values of different type");
  if (Array.isArray(t)) {
    const n = e.map((l, o) => Oi(t[o], l));
    return (l) => n.map((o) => o(l));
  }
  if (i === "object") {
    if (!t || !e) throw new Error("Object cannot be null");
    if ($o(t) && $o(e)) {
      t = t.getTime(), e = e.getTime();
      const o = e - t;
      return (r) => new Date(t + r * o);
    }
    const n = Object.keys(e), l = {};
    return n.forEach((o) => {
      l[o] = Oi(t[o], e[o]);
    }), (o) => {
      const r = {};
      return n.forEach((a) => {
        r[a] = l[a](o);
      }), r;
    };
  }
  if (i === "number") {
    const n = e - t;
    return (l) => t + l * n;
  }
  throw new Error(`Cannot interpolate ${i} values`);
}
function kh(t, e = {}) {
  const i = wh(t);
  let n, l = t;
  function o(r, a) {
    if (t == null)
      return i.set(t = r), Promise.resolve();
    l = r;
    let s = n, d = !1, {
      delay: u = 0,
      duration: c = 400,
      easing: g = Gt,
      interpolate: h = Oi
    } = oi(oi({}, e), a);
    if (c === 0)
      return s && (s.abort(), s = null), i.set(t = l), Promise.resolve();
    const m = _i() + u;
    let v;
    return n = wi((b) => {
      if (b < m) return !0;
      d || (v = h(t, r), typeof c == "function" && (c = c(t, r)), d = !0), s && (s.abort(), s = null);
      const w = b - m;
      return w > /** @type {number} */
      c ? (i.set(t = r), !1) : (i.set(t = v(g(w / c))), !0);
    }), n.promise;
  }
  return {
    set: o,
    update: (r, a) => o(r(l, t), a),
    subscribe: i.subscribe
  };
}
function yh(t) {
  _e(t, "svelte-1n1bmdf", ":host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}@keyframes svelte-1n1bmdf-rotate{100%{transform:rotate(360deg)}}.spinner-infinite.svelte-1n1bmdf{animation:svelte-1n1bmdf-rotate 2s linear infinite}");
}
function er(t) {
  let e, i, n, l, o, r, a, s, d;
  return {
    c() {
      e = kt("svg"), i = kt("circle"), o = kt("path"), f(
        i,
        "cx",
        /*radius*/
        t[3]
      ), f(
        i,
        "cy",
        /*radius*/
        t[3]
      ), f(i, "stroke", n = /*invert*/
      t[0] ? "var(--goa-color-info-hover)" : "var(--goa-color-brand-light)"), f(
        i,
        "stroke-width",
        /*strokewidth*/
        t[4]
      ), f(i, "r", l = /*radius*/
      t[3] - /*strokewidth*/
      t[4] / 2), f(o, "d", r = /*getArc*/
      t[9](
        /*$_progress*/
        t[7]
      )), f(
        o,
        "stroke-width",
        /*strokewidth*/
        t[4]
      ), f(o, "stroke", a = /*invert*/
      t[0] ? "var(--goa-color-brand-light)" : "var(--goa-color-info-default)"), f(o, "stroke-linecap", "round"), f(e, "class", s = Ee(`spinner-${/*type*/
      t[2]}`) + " svelte-1n1bmdf"), f(e, "fill", "none"), f(e, "viewBox", d = "0 0 " + /*diameter*/
      t[5] + " " + /*diameter*/
      t[5]), f(
        e,
        "width",
        /*diameter*/
        t[5]
      ), f(
        e,
        "height",
        /*diameter*/
        t[5]
      ), f(
        e,
        "data-testid",
        /*testid*/
        t[1]
      ), f(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(u, c) {
      D(u, e, c), _(e, i), _(e, o);
    },
    p(u, c) {
      c & /*radius*/
      8 && f(
        i,
        "cx",
        /*radius*/
        u[3]
      ), c & /*radius*/
      8 && f(
        i,
        "cy",
        /*radius*/
        u[3]
      ), c & /*invert*/
      1 && n !== (n = /*invert*/
      u[0] ? "var(--goa-color-info-hover)" : "var(--goa-color-brand-light)") && f(i, "stroke", n), c & /*strokewidth*/
      16 && f(
        i,
        "stroke-width",
        /*strokewidth*/
        u[4]
      ), c & /*radius, strokewidth*/
      24 && l !== (l = /*radius*/
      u[3] - /*strokewidth*/
      u[4] / 2) && f(i, "r", l), c & /*$_progress*/
      128 && r !== (r = /*getArc*/
      u[9](
        /*$_progress*/
        u[7]
      )) && f(o, "d", r), c & /*strokewidth*/
      16 && f(
        o,
        "stroke-width",
        /*strokewidth*/
        u[4]
      ), c & /*invert*/
      1 && a !== (a = /*invert*/
      u[0] ? "var(--goa-color-brand-light)" : "var(--goa-color-info-default)") && f(o, "stroke", a), c & /*type*/
      4 && s !== (s = Ee(`spinner-${/*type*/
      u[2]}`) + " svelte-1n1bmdf") && f(e, "class", s), c & /*diameter*/
      32 && d !== (d = "0 0 " + /*diameter*/
      u[5] + " " + /*diameter*/
      u[5]) && f(e, "viewBox", d), c & /*diameter*/
      32 && f(
        e,
        "width",
        /*diameter*/
        u[5]
      ), c & /*diameter*/
      32 && f(
        e,
        "height",
        /*diameter*/
        u[5]
      ), c & /*testid*/
      2 && f(
        e,
        "data-testid",
        /*testid*/
        u[1]
      );
    },
    d(u) {
      u && P(e);
    }
  };
}
function Ch(t) {
  let e, i = (
    /*ready*/
    t[6] && er(t)
  );
  return {
    c() {
      i && i.c(), e = Ne();
    },
    m(n, l) {
      i && i.m(n, l), D(n, e, l);
    },
    p(n, [l]) {
      /*ready*/
      n[6] ? i ? i.p(n, l) : (i = er(n), i.c(), i.m(e.parentNode, e)) : i && (i.d(1), i = null);
    },
    i: ve,
    o: ve,
    d(n) {
      n && P(e), i && i.d(n);
    }
  };
}
function zh(t, e, i) {
  let n, l, o, r, a, s, { size: d } = e, { invert: u = !1 } = e, { progress: c = -1 } = e, { testid: g = "" } = e, h = "infinite";
  const m = kh(0, { duration: 500, easing: vd });
  ma(t, m, (w) => i(7, s = w));
  function v(w) {
    const y = o + r * Math.cos(w), j = o + r * Math.sin(w);
    return y + " " + j;
  }
  function b(w) {
    switch (h) {
      case "progress": {
        const y = v(-Math.PI / 2), j = v(-Math.PI / 2 + 2 * Math.PI * (w / 100)), E = w % 100 < 50 ? 0 : 1;
        return `M ${y} A ${r} ${r} 0 ${E} 1 ${j}`;
      }
      case "infinite": {
        const y = v(Math.PI * 1.5), j = v(0);
        return `M ${y} A ${r} ${r} 0 1 0 ${j}`;
      }
    }
  }
  return t.$$set = (w) => {
    "size" in w && i(10, d = w.size), "invert" in w && i(0, u = w.invert), "progress" in w && i(11, c = w.progress), "testid" in w && i(1, g = w.testid);
  }, t.$$.update = () => {
    if (t.$$.dirty & /*progress*/
    2048) {
      const w = parseFloat(c + "");
      w >= 0 && (m.set(w || 1), i(2, h = "progress"));
    }
    t.$$.dirty & /*size*/
    1024 && i(5, n = d && {
      small: 16,
      medium: 32,
      large: 64,
      xlarge: 100
    }[d]), t.$$.dirty & /*size*/
    1024 && i(4, l = d && { small: 2, medium: 4, large: 7, xlarge: 9 }[d]), t.$$.dirty & /*diameter*/
    32 && i(3, o = n / 2), t.$$.dirty & /*radius, strokewidth*/
    24 && i(12, r = o - l / 2), t.$$.dirty & /*type, pathRadius, progress*/
    6148 && i(6, a = h === "infinite" ? r : r && c);
  }, [
    u,
    g,
    h,
    o,
    l,
    n,
    a,
    s,
    m,
    b,
    d,
    c,
    r
  ];
}
class jh extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      zh,
      Ch,
      ce,
      {
        size: 10,
        invert: 0,
        progress: 11,
        testid: 1
      },
      yh
    );
  }
  get size() {
    return this.$$.ctx[10];
  }
  set size(e) {
    this.$$set({ size: e }), k();
  }
  get invert() {
    return this.$$.ctx[0];
  }
  set invert(e) {
    this.$$set({ invert: e }), k();
  }
  get progress() {
    return this.$$.ctx[11];
  }
  set progress(e) {
    this.$$set({ progress: e }), k();
  }
  get testid() {
    return this.$$.ctx[1];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-spinner", he(jh, { size: {}, invert: { type: "Boolean" }, progress: {}, testid: {} }, [], [], !0));
const Eh = (t) => ({}), tr = (t) => ({});
function ir(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[5].default
  ), l = oe(
    n,
    t,
    /*$$scope*/
    t[4],
    null
  );
  return {
    c() {
      e = C("div"), l && l.c(), f(e, "role", "tabpanel");
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null), i = !0;
    },
    p(o, r) {
      l && l.p && (!i || r & /*$$scope*/
      16) && ae(
        l,
        n,
        o,
        /*$$scope*/
        o[4],
        i ? re(
          n,
          /*$$scope*/
          o[4],
          r,
          null
        ) : se(
          /*$$scope*/
          o[4]
        ),
        null
      );
    },
    i(o) {
      i || (Y(l, o), i = !0);
    },
    o(o) {
      U(l, o), i = !1;
    },
    d(o) {
      o && P(e), l && l.d(o);
    }
  };
}
function Mh(t) {
  let e, i, n, l, o, r;
  const a = (
    /*#slots*/
    t[5].heading
  ), s = oe(
    a,
    t,
    /*$$scope*/
    t[4],
    tr
  );
  let d = (
    /*open*/
    t[0] && ir(t)
  );
  return {
    c() {
      e = C("section"), i = C("div"), s && s.c(), n = x(), l = le(
        /*heading*/
        t[1]
      ), o = x(), d && d.c(), Be(i, "display", "none");
    },
    m(u, c) {
      D(u, e, c), _(e, i), s && s.m(i, null), _(i, n), _(i, l), t[6](i), _(e, o), d && d.m(e, null), t[7](e), r = !0;
    },
    p(u, [c]) {
      s && s.p && (!r || c & /*$$scope*/
      16) && ae(
        s,
        a,
        u,
        /*$$scope*/
        u[4],
        r ? re(
          a,
          /*$$scope*/
          u[4],
          c,
          Eh
        ) : se(
          /*$$scope*/
          u[4]
        ),
        tr
      ), (!r || c & /*heading*/
      2) && pe(
        l,
        /*heading*/
        u[1]
      ), /*open*/
      u[0] ? d ? (d.p(u, c), c & /*open*/
      1 && Y(d, 1)) : (d = ir(u), d.c(), Y(d, 1), d.m(e, null)) : d && (Oe(), U(d, 1, 1, () => {
        d = null;
      }), Fe());
    },
    i(u) {
      r || (Y(s, u), Y(d), r = !0);
    },
    o(u) {
      U(s, u), U(d), r = !1;
    },
    d(u) {
      u && P(e), s && s.d(u), t[6](null), d && d.d(), t[7](null);
    }
  };
}
function Lh(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e;
  const o = pt(n);
  let { heading: r = "" } = e, { open: a = !1 } = e, s, d;
  ke(() => {
    u(), g();
  });
  function u() {
    setTimeout(
      () => {
        const v = o.heading ? "slot" : "string";
        s == null || s.dispatchEvent(new CustomEvent(
          "tab:mounted",
          {
            composed: !0,
            bubbles: !0,
            detail: {
              el: s,
              headingType: v,
              heading: v === "string" ? r : c(),
              open: a
            }
          }
        ));
      },
      1
    );
  }
  function c() {
    return lt(d, "*")[0];
  }
  function g() {
    s.addEventListener("tabs:set-open", (v) => {
      const b = v.detail;
      i(0, a = !!b.open);
    });
  }
  function h(v) {
    ue[v ? "unshift" : "push"](() => {
      d = v, i(3, d);
    });
  }
  function m(v) {
    ue[v ? "unshift" : "push"](() => {
      s = v, i(2, s);
    });
  }
  return t.$$set = (v) => {
    "heading" in v && i(1, r = v.heading), "open" in v && i(0, a = v.open), "$$scope" in v && i(4, l = v.$$scope);
  }, [
    a,
    r,
    s,
    d,
    l,
    n,
    h,
    m
  ];
}
class qh extends me {
  constructor(e) {
    super(), ge(this, e, Lh, Mh, ce, { heading: 1, open: 0 });
  }
  get heading() {
    return this.$$.ctx[1];
  }
  set heading(e) {
    this.$$set({ heading: e }), k();
  }
  get open() {
    return this.$$.ctx[0];
  }
  set open(e) {
    this.$$set({ open: e }), k();
  }
}
customElements.define("goa-tab", he(qh, { heading: {}, open: { reflect: !0, type: "String" } }, ["heading", "default"], [], !0));
function Sh(t) {
  _e(t, "svelte-1wrp53x", ".goatable.svelte-1wrp53x{width:0}table.svelte-1wrp53x{border-collapse:collapse}");
}
function Th(t) {
  let e, i, n;
  const l = (
    /*#slots*/
    t[12].default
  ), o = oe(
    l,
    t,
    /*$$scope*/
    t[11],
    null
  );
  return {
    c() {
      e = C("table"), o && o.c(), f(e, "style", i = /*width*/
      t[0] && "width: 100%;"), f(e, "class", "svelte-1wrp53x");
    },
    m(r, a) {
      D(r, e, a), o && o.m(e, null), n = !0;
    },
    p(r, a) {
      o && o.p && (!n || a & /*$$scope*/
      2048) && ae(
        o,
        l,
        r,
        /*$$scope*/
        r[11],
        n ? re(
          l,
          /*$$scope*/
          r[11],
          a,
          null
        ) : se(
          /*$$scope*/
          r[11]
        ),
        null
      ), (!n || a & /*width*/
      1 && i !== (i = /*width*/
      r[0] && "width: 100%;")) && f(e, "style", i);
    },
    i(r) {
      n || (Y(o, r), n = !0);
    },
    o(r) {
      U(o, r), n = !1;
    },
    d(r) {
      r && P(e), o && o.d(r);
    }
  };
}
function Ph(t) {
  let e;
  const i = (
    /*#slots*/
    t[12].default
  ), n = oe(
    i,
    t,
    /*$$scope*/
    t[11],
    null
  );
  return {
    c() {
      n && n.c();
    },
    m(l, o) {
      n && n.m(l, o), e = !0;
    },
    p(l, o) {
      n && n.p && (!e || o & /*$$scope*/
      2048) && ae(
        n,
        i,
        l,
        /*$$scope*/
        l[11],
        e ? re(
          i,
          /*$$scope*/
          l[11],
          o,
          null
        ) : se(
          /*$$scope*/
          l[11]
        ),
        null
      );
    },
    i(l) {
      e || (Y(n, l), e = !0);
    },
    o(l) {
      U(n, l), e = !1;
    },
    d(l) {
      n && n.d(l);
    }
  };
}
function Dh(t) {
  let e, i, n, l, o, r;
  const a = [Ph, Th], s = [];
  function d(u, c) {
    return (
      /*_isTableRoot*/
      u[8] ? 0 : 1
    );
  }
  return i = d(t), n = s[i] = a[i](t), {
    c() {
      e = C("div"), n.c(), f(e, "class", l = Ee(`goatable ${/*variant*/
      t[1]}`) + " svelte-1wrp53x"), f(e, "style", o = `
    ${`width: ${/*width*/
      t[0] || "100%"};`}
    ${be(
        /*mt*/
        t[3],
        /*mr*/
        t[4],
        /*mb*/
        t[5],
        /*ml*/
        t[6]
      )}
  `), f(
        e,
        "data-testid",
        /*testid*/
        t[2]
      ), G(
        e,
        "sticky",
        /*_stickyHeader*/
        t[9]
      );
    },
    m(u, c) {
      D(u, e, c), s[i].m(e, null), t[13](e), r = !0;
    },
    p(u, [c]) {
      let g = i;
      i = d(u), i === g ? s[i].p(u, c) : (Oe(), U(s[g], 1, 1, () => {
        s[g] = null;
      }), Fe(), n = s[i], n ? n.p(u, c) : (n = s[i] = a[i](u), n.c()), Y(n, 1), n.m(e, null)), (!r || c & /*variant*/
      2 && l !== (l = Ee(`goatable ${/*variant*/
      u[1]}`) + " svelte-1wrp53x")) && f(e, "class", l), (!r || c & /*width, mt, mr, mb, ml*/
      121 && o !== (o = `
    ${`width: ${/*width*/
      u[0] || "100%"};`}
    ${be(
        /*mt*/
        u[3],
        /*mr*/
        u[4],
        /*mb*/
        u[5],
        /*ml*/
        u[6]
      )}
  `)) && f(e, "style", o), (!r || c & /*testid*/
      4) && f(
        e,
        "data-testid",
        /*testid*/
        u[2]
      ), (!r || c & /*variant, _stickyHeader*/
      514) && G(
        e,
        "sticky",
        /*_stickyHeader*/
        u[9]
      );
    },
    i(u) {
      r || (Y(n), r = !0);
    },
    o(u) {
      U(n), r = !1;
    },
    d(u) {
      u && P(e), s[i].d(), t[13](null);
    }
  };
}
function nr(t, e) {
  t.dispatchEvent(new CustomEvent(
    "_sort",
    {
      composed: !0,
      bubbles: !0,
      cancelable: !1,
      detail: e
    }
  ));
}
function Hh(t, e, i) {
  let n, { $$slots: l = {}, $$scope: o } = e;
  const [r, a] = Me("Table variant", ["normal", "relaxed"], !0);
  let { width: s = "" } = e, { stickyheader: d = "false" } = e, { variant: u = "normal" } = e, { testid: c = "" } = e, { mt: g = null } = e, { mr: h = null } = e, { mb: m = null } = e, { ml: v = null } = e, b, w = !1;
  ke(() => {
    a(u), setTimeout(y, 0);
    const E = b.querySelector("slot");
    !E || E.assignedElements().length === 0 || i(8, w = E.assignedElements()[0].tagName === "TABLE");
  });
  async function y() {
    var L;
    await Pe();
    const E = b == null ? void 0 : b.querySelector("slot"), M = (L = E == null ? void 0 : E.assignedElements().find((z) => z.tagName === "THEAD" || z.tagName === "TABLE")) == null ? void 0 : L.querySelectorAll("goa-table-sort-header");
    M == null || M.forEach((z) => {
      z.addEventListener("click", () => {
        const S = z.getAttribute("name");
        let A = 0;
        M.forEach((R) => {
          if (R.getAttribute("name") === S) {
            const B = R.direction === "asc" ? "desc" : "asc";
            A = B === "asc" ? 1 : -1, R.setAttribute("direction", B);
          } else
            R.setAttribute("direction", "none");
        }), S && A !== 0 && nr(z, { sortBy: S, sortDir: A });
      });
      const V = z.getAttribute("name"), T = z.direction;
      V && T && T !== "none" && setTimeout(
        () => {
          nr(z, {
            sortBy: V,
            sortDir: T === "asc" ? 1 : -1
          });
        },
        10
      );
    });
  }
  function j(E) {
    ue[E ? "unshift" : "push"](() => {
      b = E, i(7, b);
    });
  }
  return t.$$set = (E) => {
    "width" in E && i(0, s = E.width), "stickyheader" in E && i(10, d = E.stickyheader), "variant" in E && i(1, u = E.variant), "testid" in E && i(2, c = E.testid), "mt" in E && i(3, g = E.mt), "mr" in E && i(4, h = E.mr), "mb" in E && i(5, m = E.mb), "ml" in E && i(6, v = E.ml), "$$scope" in E && i(11, o = E.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*stickyheader*/
    1024 && i(9, n = Ce(d));
  }, [
    s,
    u,
    c,
    g,
    h,
    m,
    v,
    b,
    w,
    n,
    d,
    o,
    l,
    j
  ];
}
class Oh extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Hh,
      Dh,
      ce,
      {
        width: 0,
        stickyheader: 10,
        variant: 1,
        testid: 2,
        mt: 3,
        mr: 4,
        mb: 5,
        ml: 6
      },
      Sh
    );
  }
  get width() {
    return this.$$.ctx[0];
  }
  set width(e) {
    this.$$set({ width: e }), k();
  }
  get stickyheader() {
    return this.$$.ctx[10];
  }
  set stickyheader(e) {
    this.$$set({ stickyheader: e }), k();
  }
  get variant() {
    return this.$$.ctx[1];
  }
  set variant(e) {
    this.$$set({ variant: e }), k();
  }
  get testid() {
    return this.$$.ctx[2];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[3];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[4];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[5];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[6];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-table", he(Oh, { width: {}, stickyheader: {}, variant: { reflect: !0 }, testid: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function Fh(t) {
  _e(t, "svelte-nanrkk", ":host{display:flex;align-items:flex-end}button.svelte-nanrkk.svelte-nanrkk{border:none;background:none;display:flex;font-family:inherit;font-size:inherit;font-weight:inherit;color:inherit;width:100%;height:var(--goa-space-2xl);padding:var(--goa-space-s) var(--goa-space-m);justify-content:var(--header-text-align, flex-start);gap:var(--goa-space-2xs);align-items:flex-end;text-align:var(--header-align, left)}button.svelte-nanrkk.svelte-nanrkk:hover{background-color:var(--goa-color-greyscale-100);cursor:pointer;color:var(--goa-color-interactive-hover)}button.svelte-nanrkk goa-icon.svelte-nanrkk{color:var(--goa-color-interactive-default)}button.svelte-nanrkk:hover goa-icon.svelte-nanrkk{color:var(--goa-color-interactive-hover)}button.svelte-nanrkk .direction--none goa-icon.svelte-nanrkk{color:var(--goa-color-greyscale-400)}button.svelte-nanrkk:hover .direction--none goa-icon.svelte-nanrkk{color:var(--goa-color-interactive-hover)}goa-icon.svelte-nanrkk.svelte-nanrkk{scale:0.8}.direction--none.svelte-nanrkk goa-icon.svelte-nanrkk{height:0.625rem}.direction--none.svelte-nanrkk.svelte-nanrkk{display:inline-flex;flex-direction:column;align-items:center}");
}
function Ah(t) {
  let e;
  return {
    c() {
      e = C("div"), e.innerHTML = '<goa-icon type="caret-up" size="small" class="svelte-nanrkk"></goa-icon> <goa-icon type="caret-down" size="small" class="svelte-nanrkk"></goa-icon>', f(e, "class", "direction--none svelte-nanrkk");
    },
    m(i, n) {
      D(i, e, n);
    },
    d(i) {
      i && P(e);
    }
  };
}
function Vh(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", "caret-up"), p(e, "size", "small"), p(e, "class", "svelte-nanrkk");
    },
    m(i, n) {
      D(i, e, n);
    },
    d(i) {
      i && P(e);
    }
  };
}
function Ih(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", "caret-down"), p(e, "size", "small"), p(e, "class", "svelte-nanrkk");
    },
    m(i, n) {
      D(i, e, n);
    },
    d(i) {
      i && P(e);
    }
  };
}
function xh(t) {
  let e, i, n;
  const l = (
    /*#slots*/
    t[3].default
  ), o = oe(
    l,
    t,
    /*$$scope*/
    t[2],
    null
  );
  function r(d, u) {
    return (
      /*direction*/
      d[0] === "desc" ? Ih : (
        /*direction*/
        d[0] === "asc" ? Vh : Ah
      )
    );
  }
  let a = r(t), s = a(t);
  return {
    c() {
      e = C("button"), o && o.c(), i = x(), s.c(), f(e, "class", "svelte-nanrkk");
    },
    m(d, u) {
      D(d, e, u), o && o.m(e, null), _(e, i), s.m(e, null), t[4](e), n = !0;
    },
    p(d, [u]) {
      o && o.p && (!n || u & /*$$scope*/
      4) && ae(
        o,
        l,
        d,
        /*$$scope*/
        d[2],
        n ? re(
          l,
          /*$$scope*/
          d[2],
          u,
          null
        ) : se(
          /*$$scope*/
          d[2]
        ),
        null
      ), a !== (a = r(d)) && (s.d(1), s = a(d), s && (s.c(), s.m(e, null)));
    },
    i(d) {
      n || (Y(o, d), n = !0);
    },
    o(d) {
      U(o, d), n = !1;
    },
    d(d) {
      d && P(e), o && o.d(d), s.d(), t[4](null);
    }
  };
}
function Bh(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { direction: o = "none" } = e, r;
  ke(() => {
    if (r) {
      const s = r.getRootNode().host, d = s == null ? void 0 : s.closest("th");
      d == null || d.style.setProperty("--goa-table-header-padding", "0"), (s == null ? void 0 : s.closest("th.goa-table-number-header")) && (r.style.setProperty("--header-text-align", "flex-end"), r.style.setProperty("--header-align", "right"));
    }
  });
  function a(s) {
    ue[s ? "unshift" : "push"](() => {
      r = s, i(1, r);
    });
  }
  return t.$$set = (s) => {
    "direction" in s && i(0, o = s.direction), "$$scope" in s && i(2, l = s.$$scope);
  }, [o, r, l, n, a];
}
class Nh extends me {
  constructor(e) {
    super(), ge(this, e, Bh, xh, ce, { direction: 0 }, Fh);
  }
  get direction() {
    return this.$$.ctx[0];
  }
  set direction(e) {
    this.$$set({ direction: e }), k();
  }
}
customElements.define("goa-table-sort-header", he(Nh, { direction: {} }, ["default"], [], !0));
function Wh(t) {
  _e(t, "svelte-c3sc5b", ':host{box-sizing:border-box;font:var(--goa-tab-typography)}.tab{display:flex;align-items:center;gap:var(--goa-space-xs)}[role="tab"]{display:block;background:none;overflow:hidden;white-space:nowrap;cursor:pointer;border:none;font:var(--goa-tab-typography);color:var(--goa-tab-text-color);text-decoration:none}[role="tab"][aria-selected="true"]{font:var(--goa-tab-typography-selected)}[role="tab"]:focus-visible{outline:var(--goa-tab-border-focus)}[role="tab"]:hover:not([aria-selected="true"]){border-bottom:var(--goa-tab-border-hover)}[role="tabpanel"]:focus-visible{outline:var(--goa-tab-border-focus);outline-offset:4px}@media(min-width: 624px){.tabs.svelte-c3sc5b{border-bottom:var(--goa-tabs-bottom-border);display:flex;gap:var(--goa-tabs-gap);margin-bottom:2rem}[role="tab"]{padding:var(--goa-tab-padding);border-bottom:var(--goa-tab-border-not-selected);text-overflow:ellipsis;min-width:var(--goa-space-2xl);text-align:center}[role="tab"][aria-selected="true"]{border-bottom:var(--goa-tab-border-selected)}}@media(max-width: 623px){.tabs.svelte-c3sc5b{border-left:var(--goa-tabs-bottom-border);border-bottom:var(--goa-tabs-bottom-border);display:flex;flex-direction:column;gap:var(--goa-tabs-gap-small-screen);padding-bottom:var(--goa-space-m);margin-bottom:2rem}[role="tab"]{padding:var(--goa-tab-padding-mobile);border-left:var(--goa-tab-border-not-selected);text-overflow:wrap;white-space:normal;word-break:break-word;overflow-wrap:break-word}[role="tab"][aria-selected="true"]{border-left:var(--goa-tab-border-selected);background:var(--goa-tab-color-bg-selected-small-screen)}[role="tab"]:hover:not([aria-selected="true"]){border-left:var(--goa-tab-border-hover);border-bottom:none}}');
}
function Rh(t) {
  let e, i, n, l, o;
  const r = (
    /*#slots*/
    t[6].default
  ), a = oe(
    r,
    t,
    /*$$scope*/
    t[5],
    null
  );
  return {
    c() {
      e = C("div"), i = C("div"), n = x(), l = C("div"), a && a.c(), f(i, "class", "tabs svelte-c3sc5b"), f(l, "class", "tabpanel"), f(l, "tabindex", "0"), f(l, "role", "tabpanel"), f(e, "role", "tablist"), f(
        e,
        "data-testid",
        /*testid*/
        t[0]
      );
    },
    m(s, d) {
      D(s, e, d), _(e, i), t[7](i), _(e, n), _(e, l), a && a.m(l, null), t[8](l), t[9](e), o = !0;
    },
    p(s, [d]) {
      a && a.p && (!o || d & /*$$scope*/
      32) && ae(
        a,
        r,
        s,
        /*$$scope*/
        s[5],
        o ? re(
          r,
          /*$$scope*/
          s[5],
          d,
          null
        ) : se(
          /*$$scope*/
          s[5]
        ),
        null
      ), (!o || d & /*testid*/
      1) && f(
        e,
        "data-testid",
        /*testid*/
        s[0]
      );
    },
    i(s) {
      o || (Y(a, s), o = !0);
    },
    o(s) {
      U(a, s), o = !1;
    },
    d(s) {
      s && P(e), t[7](null), a && a.d(s), t[8](null), t[9](null);
    }
  };
}
function Yh(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { initialtab: o = 1 } = e, { testid: r = "" } = e, a, s, d, u = 1, c = [], g, h = !0;
  ke(() => {
    yi(a), v(), w();
  }), ct(() => {
    y();
  });
  function m() {
    const T = window.location.hash;
    if (!T) return null;
    const S = s == null ? void 0 : s.querySelectorAll('[role="tab"]');
    for (let A = 0; A < S.length; A++) {
      const I = S[A].getAttribute("href"), B = (I == null ? void 0 : I.split("#")[1]) || "", N = I == null ? void 0 : I.endsWith(T), F = T.endsWith(B);
      if (N || F)
        return A + 1;
    }
    return null;
  }
  function v() {
    a.addEventListener("tab:mounted", (T) => {
      const S = T.detail;
      c = [...c, { ...S, bound: !1 }], g && clearTimeout(g), g = setTimeout(
        () => {
          if (b(), h) {
            const A = m();
            j(A ?? (o || 1)), h = !1;
          }
        },
        1
      ), T.stopPropagation();
    });
  }
  function b() {
    const T = window.location.pathname, S = window.location.search;
    c.forEach((A, R) => {
      let I = "", B;
      if (A.bound) return;
      if (A.bound = !0, A.el.dispatchEvent(new CustomEvent(
        "tabs:set-open",
        {
          composed: !0,
          detail: { open: R + 1 === u }
        }
      )), A.headingType === "slot")
        B = A.heading;
      else {
        const F = A.heading;
        B = document.createElement("div"), B.textContent = F, I = F;
      }
      B.classList.add("tab"), I || (I = "tab-" + R);
      const N = document.createElement("a");
      N.setAttribute("id", `tab-${R + 1}`), N.setAttribute("data-testid", `tab-${R + 1}`), N.setAttribute("role", "tab"), N.setAttribute("href", `${T}${S}#${I}`), N.addEventListener("click", () => j(R + 1)), N.setAttribute("aria-controls", `tabpanel-${R + 1}`), N.appendChild(B), s == null || s.appendChild(N);
    });
  }
  function w() {
    a.addEventListener("focus", E, !0);
  }
  function y() {
    a.removeEventListener("focus", E, !0);
  }
  function j(T) {
    if (!s) return;
    const S = u;
    u = Aa(T, 1, c.length), S != u && a.dispatchEvent(new CustomEvent(
      "_change",
      {
        composed: !0,
        bubbles: !0,
        detail: { tab: u }
      }
    ));
    let A = "";
    [...s.querySelectorAll("[role=tab]")].map((R, I) => {
      const B = I + 1 === +u;
      R.setAttribute("aria-selected", vt(B)), R.setAttribute("tabindex", B ? "0" : "-1"), B && (A = R.href, R.focus());
    });
    for (const [R, I] of c.entries())
      I.el.dispatchEvent(new CustomEvent(
        "tabs:set-open",
        {
          composed: !0,
          detail: { open: R + 1 === +T }
        }
      ));
    if (d.setAttribute("aria-labelledby", `tab-${u}`), d.setAttribute("id", `tabpanel-${u}`), A) {
      const R = new URL(A);
      history.pushState({}, "", R.pathname + R.search + R.hash);
    }
  }
  function E() {
    a.addEventListener("keydown", M);
  }
  function M(T) {
    let S = !1;
    if (T.target && s.contains(T.target)) {
      switch (T.key) {
        case "ArrowUp":
        case "ArrowLeft":
          j(u === 1 ? c.length : u - 1), S = !0;
          break;
        case "ArrowDown":
        case "ArrowRight":
          u === c.length ? j(1) : j(u + 1), S = !0;
          break;
        case "Home":
          j(1), S = !0;
          break;
        case "End":
          j(c.length), S = !0;
          break;
      }
      S && (T.stopPropagation(), T.preventDefault());
    }
  }
  function L(T) {
    ue[T ? "unshift" : "push"](() => {
      s = T, i(2, s);
    });
  }
  function z(T) {
    ue[T ? "unshift" : "push"](() => {
      d = T, i(3, d);
    });
  }
  function V(T) {
    ue[T ? "unshift" : "push"](() => {
      a = T, i(1, a);
    });
  }
  return t.$$set = (T) => {
    "initialtab" in T && i(4, o = T.initialtab), "testid" in T && i(0, r = T.testid), "$$scope" in T && i(5, l = T.$$scope);
  }, [
    r,
    a,
    s,
    d,
    o,
    l,
    n,
    L,
    z,
    V
  ];
}
class Zh extends me {
  constructor(e) {
    super(), ge(this, e, Yh, Rh, ce, { initialtab: 4, testid: 0 }, Wh);
  }
  get initialtab() {
    return this.$$.ctx[4];
  }
  set initialtab(e) {
    this.$$set({ initialtab: e }), k();
  }
  get testid() {
    return this.$$.ctx[0];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
}
customElements.define("goa-tabs", he(Zh, { initialtab: {}, testid: {} }, ["default"], [], !0));
function Uh(t) {
  _e(t, "svelte-qirxao", "h1, h2, h3, h4, h5{margin:0}.heading-xl.svelte-qirxao{font:var(--goa-typography-heading-xl)}.heading-l.svelte-qirxao{font:var(--goa-typography-heading-l)}.heading-m.svelte-qirxao{font:var(--goa-typography-heading-m)}.heading-s.svelte-qirxao{font:var(--goa-typography-heading-s)}.heading-xs.svelte-qirxao{font:var(--goa-typography-heading-xs)}.body-l.svelte-qirxao{font:var(--goa-typography-body-l)}.body-m.svelte-qirxao{font:var(--goa-typography-body-m)}.body-s.svelte-qirxao{font:var(--goa-typography-body-s)}.body-xs.svelte-qirxao{font:var(--goa-typography-body-xs)}@media(max-width: 623px){.heading-xl.svelte-qirxao{font:var(--goa-typography-s-heading-xl)}.heading-l.svelte-qirxao{font:var(--goa-typography-s-heading-l)}.heading-m.svelte-qirxao{font:var(--goa-typography-s-heading-m)}.heading-s.svelte-qirxao{font:var(--goa-typography-s-heading-s)}.heading-xs.svelte-qirxao{font:var(--goa-typography-s-heading-xs)}.body-l.svelte-qirxao{font:var(--goa-typography-s-body-l)}.body-m.svelte-qirxao{font:var(--goa-typography-s-body-m)}.body-s.svelte-qirxao{font:var(--goa-typography-s-body-s)}.body-xs.svelte-qirxao{font:var(--goa-typography-s-body-xs)}}");
}
function Ti(t) {
  let e, i, n, l;
  const o = (
    /*#slots*/
    t[10].default
  ), r = oe(
    o,
    t,
    /*$$scope*/
    t[9],
    null
  );
  let a = [
    {
      class: i = Ee(
        /*size*/
        t[0]
      ) + " svelte-qirxao"
    },
    {
      style: n = Ue(
        ze(
          "color",
          /*color*/
          t[3] === "primary" ? "var(--goa-color-text-default)" : "var(--goa-color-text-secondary)"
        ),
        /*maxWidth*/
        t[2] === "none" ? "" : `max-width: ${/*maxWidth*/
        t[2]}`,
        be(
          /*mt*/
          t[4],
          /*mr*/
          t[5],
          /*getBottomMargin*/
          t[7](),
          /*ml*/
          t[6]
        )
      )
    }
  ], s = {};
  for (let d = 0; d < a.length; d += 1)
    s = oi(s, a[d]);
  return {
    c() {
      e = C(
        /*as*/
        t[1]
      ), r && r.c(), Gi(
        /*as*/
        t[1]
      )(e, s);
    },
    m(d, u) {
      D(d, e, u), r && r.m(e, null), l = !0;
    },
    p(d, u) {
      r && r.p && (!l || u & /*$$scope*/
      512) && ae(
        r,
        o,
        d,
        /*$$scope*/
        d[9],
        l ? re(
          o,
          /*$$scope*/
          d[9],
          u,
          null
        ) : se(
          /*$$scope*/
          d[9]
        ),
        null
      ), Gi(
        /*as*/
        d[1]
      )(e, s = Ta(a, [
        (!l || u & /*size*/
        1 && i !== (i = Ee(
          /*size*/
          d[0]
        ) + " svelte-qirxao")) && { class: i },
        (!l || u & /*color, maxWidth, mt, mr, ml*/
        124 && n !== (n = Ue(
          ze(
            "color",
            /*color*/
            d[3] === "primary" ? "var(--goa-color-text-default)" : "var(--goa-color-text-secondary)"
          ),
          /*maxWidth*/
          d[2] === "none" ? "" : `max-width: ${/*maxWidth*/
          d[2]}`,
          be(
            /*mt*/
            d[4],
            /*mr*/
            d[5],
            /*getBottomMargin*/
            d[7](),
            /*ml*/
            d[6]
          )
        ))) && { style: n }
      ]));
    },
    i(d) {
      l || (Y(r, d), l = !0);
    },
    o(d) {
      U(r, d), l = !1;
    },
    d(d) {
      d && P(e), r && r.d(d);
    }
  };
}
function Gh(t) {
  let e = (
    /*as*/
    t[1]
  ), i, n, l = (
    /*as*/
    t[1] && Ti(t)
  );
  return {
    c() {
      l && l.c(), i = Ne();
    },
    m(o, r) {
      l && l.m(o, r), D(o, i, r), n = !0;
    },
    p(o, [r]) {
      /*as*/
      o[1] ? e ? ce(
        e,
        /*as*/
        o[1]
      ) ? (l.d(1), l = Ti(o), e = /*as*/
      o[1], l.c(), l.m(i.parentNode, i)) : l.p(o, r) : (l = Ti(o), e = /*as*/
      o[1], l.c(), l.m(i.parentNode, i)) : e && (l.d(1), l = null, e = /*as*/
      o[1]);
    },
    i(o) {
      n || (Y(l, o), n = !0);
    },
    o(o) {
      U(l, o), n = !1;
    },
    d(o) {
      o && P(i), l && l.d(o);
    }
  };
}
function Kh(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { as: o = "div" } = e, { maxWidth: r = "65ch" } = e, { size: a = void 0 } = e, { color: s = "primary" } = e, { mt: d = null } = e, { mr: u = null } = e, { mb: c = null } = e, { ml: g = null } = e;
  const h = {
    h1: "heading-xl",
    h2: "heading-l",
    h3: "heading-m",
    h4: "heading-s",
    h5: "heading-xs",
    div: "body-m",
    p: "body-m",
    span: "body-m"
  };
  function m() {
    if (c)
      return c;
    switch (o) {
      case "h1":
        return "3xl";
      case "h2":
        return "2xl";
      case "h3":
        return "xl";
      case "h4":
        return "l";
      case "h5":
      case "h6":
      case "p":
        return "m";
    }
    return "3xs";
  }
  return ke(() => {
    i(0, a || (a = h[o]));
  }), t.$$set = (v) => {
    "as" in v && i(1, o = v.as), "maxWidth" in v && i(2, r = v.maxWidth), "size" in v && i(0, a = v.size), "color" in v && i(3, s = v.color), "mt" in v && i(4, d = v.mt), "mr" in v && i(5, u = v.mr), "mb" in v && i(8, c = v.mb), "ml" in v && i(6, g = v.ml), "$$scope" in v && i(9, l = v.$$scope);
  }, [a, o, r, s, d, u, g, m, c, l, n];
}
class Xh extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      Kh,
      Gh,
      ce,
      {
        as: 1,
        maxWidth: 2,
        size: 0,
        color: 3,
        mt: 4,
        mr: 5,
        mb: 8,
        ml: 6
      },
      Uh
    );
  }
  get as() {
    return this.$$.ctx[1];
  }
  set as(e) {
    this.$$set({ as: e }), k();
  }
  get maxWidth() {
    return this.$$.ctx[2];
  }
  set maxWidth(e) {
    this.$$set({ maxWidth: e }), k();
  }
  get size() {
    return this.$$.ctx[0];
  }
  set size(e) {
    this.$$set({ size: e }), k();
  }
  get color() {
    return this.$$.ctx[3];
  }
  set color(e) {
    this.$$set({ color: e }), k();
  }
  get mt() {
    return this.$$.ctx[4];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[5];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[8];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[6];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-text", he(Xh, { as: {}, maxWidth: {}, size: {}, color: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function Jh(t) {
  _e(t, "svelte-1vnny6q", `:host{box-sizing:border-box;font-family:var(--goa-font-family-sans);display:inline-block}#container.svelte-1vnny6q{container:self / inline-size;box-sizing:border-box}.root.svelte-1vnny6q{transition:box-shadow 0.05s ease-in;position:relative;max-width:var(--width, 100%);padding-bottom:var(--char-count-padding);box-shadow:var(--goa-text-area-border);border-radius:var(--goa-text-area-border-radius)}.root.svelte-1vnny6q:hover{box-shadow:var(--goa-text-area-border-hover)}.root.svelte-1vnny6q:focus-within{box-shadow:var(--goa-text-area-border),
      var(--goa-text-area-border-focus)}.error.svelte-1vnny6q,.error.svelte-1vnny6q:hover{box-shadow:var(--goa-text-area-border-error)}.error.svelte-1vnny6q:focus{box-shadow:var(--goa-text-area-border),
    var(--goa-text-area-border-focus)}.error.svelte-1vnny6q:focus-within:hover{box-shadow:var(--goa-text-area-border),
    var(--goa-text-area-border-focus);;}.disabled.svelte-1vnny6q,.disabled.svelte-1vnny6q:hover{background-color:var(--goa-text-area-color-bg-disabled);cursor:default;box-shadow:var(--goa-text-area-border-disabled);resize:none}textarea.svelte-1vnny6q:disabled{resize:none;color:var(--goa-text-area-color-text-disabled)}textarea[readonly].svelte-1vnny6q{cursor:pointer}textarea.svelte-1vnny6q{display:block;box-sizing:border-box;outline:none;border:none;border-radius:var(--goa-text-area-border-radius);color:var(--goa-text-area-color-text);padding:var(--goa-text-area-padding);font:var(--goa-text-area-typography);min-width:100%;max-width:100%;resize:none;height:auto;background:none}.counter.svelte-1vnny6q{position:absolute;right:var(--goa-space-m);bottom:var(--goa-space-s);font:var(--goa-text-area-typography-counter)}.counter-error.svelte-1vnny6q{color:var(--goa-text-area-color-text-counter-error)}textarea.svelte-1vnny6q{resize:none;scroll-behavior:smooth;max-height:calc(100vh * var(--max-height, 100) / 100);scrollbar-gutter:stable}textarea.svelte-1vnny6q::-webkit-scrollbar{width:var(--goa-space-xs)}textarea.svelte-1vnny6q::-webkit-scrollbar-track{border-radius:var(--goa-border-radius-m)}textarea.svelte-1vnny6q::-webkit-scrollbar-thumb{background:var(--goa-color-greyscale-400);border-radius:var(--goa-border-radius-m)}textarea.svelte-1vnny6q::-webkit-scrollbar-thumb:hover{background:var(--goa-color-greyscale-600)}.svelte-1vnny6q::-moz-placeholder{color:var(--goa-text-area-color-text-placeholder);opacity:1}.svelte-1vnny6q::placeholder{color:var(--goa-text-area-color-text-placeholder);opacity:1}@container self (max-width: 623px){textarea.svelte-1vnny6q{width:100%;min-width:100%}}@container self (min-width: 624px){textarea.svelte-1vnny6q{min-width:0;width:100%}}`);
}
function lr(t) {
  let e;
  function i(o, r) {
    if (
      /*countby*/
      o[7] && /*count*/
      o[17] > /*maxcount*/
      o[8]
    ) return $h;
    if (
      /*countby*/
      o[7] && /*count*/
      o[17] <= /*maxcount*/
      o[8]
    ) return Qh;
  }
  let n = i(t), l = n && n(t);
  return {
    c() {
      e = C("div"), l && l.c(), f(e, "class", "counter svelte-1vnny6q"), G(
        e,
        "counter-error",
        /*count*/
        t[17] > /*maxcount*/
        t[8]
      );
    },
    m(o, r) {
      D(o, e, r), l && l.m(e, null);
    },
    p(o, r) {
      n === (n = i(o)) && l ? l.p(o, r) : (l && l.d(1), l = n && n(o), l && (l.c(), l.m(e, null))), r[0] & /*count, maxcount*/
      131328 && G(
        e,
        "counter-error",
        /*count*/
        o[17] > /*maxcount*/
        o[8]
      );
    },
    d(o) {
      o && P(e), l && l.d();
    }
  };
}
function Qh(t) {
  let e = (
    /*maxcount*/
    t[8] - /*count*/
    t[17] + ""
  ), i, n, l = Ft(
    /*countby*/
    t[7],
    /*maxcount*/
    t[8] - /*count*/
    t[17]
  ) + "", o, r;
  return {
    c() {
      i = le(e), n = x(), o = le(l), r = le(" remaining");
    },
    m(a, s) {
      D(a, i, s), D(a, n, s), D(a, o, s), D(a, r, s);
    },
    p(a, s) {
      s[0] & /*maxcount, count*/
      131328 && e !== (e = /*maxcount*/
      a[8] - /*count*/
      a[17] + "") && pe(i, e), s[0] & /*countby, maxcount, count*/
      131456 && l !== (l = Ft(
        /*countby*/
        a[7],
        /*maxcount*/
        a[8] - /*count*/
        a[17]
      ) + "") && pe(o, l);
    },
    d(a) {
      a && (P(i), P(n), P(o), P(r));
    }
  };
}
function $h(t) {
  let e = (
    /*count*/
    t[17] - /*maxcount*/
    t[8] + ""
  ), i, n, l = Ft(
    /*countby*/
    t[7],
    /*count*/
    t[17] - /*maxcount*/
    t[8]
  ) + "", o, r;
  return {
    c() {
      i = le(e), n = x(), o = le(l), r = le(" too many");
    },
    m(a, s) {
      D(a, i, s), D(a, n, s), D(a, o, s), D(a, r, s);
    },
    p(a, s) {
      s[0] & /*count, maxcount*/
      131328 && e !== (e = /*count*/
      a[17] - /*maxcount*/
      a[8] + "") && pe(i, e), s[0] & /*countby, count, maxcount*/
      131456 && l !== (l = Ft(
        /*countby*/
        a[7],
        /*count*/
        a[17] - /*maxcount*/
        a[8]
      ) + "") && pe(o, l);
    },
    d(a) {
      a && (P(i), P(n), P(o), P(r));
    }
  };
}
function or(t) {
  let e, i, n, l = Ft(
    /*countby*/
    t[7],
    /*count*/
    t[17]
  ) + "", o;
  return {
    c() {
      e = C("div"), i = le(
        /*count*/
        t[17]
      ), n = x(), o = le(l), f(e, "class", "counter svelte-1vnny6q");
    },
    m(r, a) {
      D(r, e, a), _(e, i), _(e, n), _(e, o);
    },
    p(r, a) {
      a[0] & /*count*/
      131072 && pe(
        i,
        /*count*/
        r[17]
      ), a[0] & /*countby, count*/
      131200 && l !== (l = Ft(
        /*countby*/
        r[7],
        /*count*/
        r[17]
      ) + "") && pe(o, l);
    },
    d(r) {
      r && P(e);
    }
  };
}
function em(t) {
  let e, i, n, l, o, r, a, s, d, u, c = (
    /*maxcount*/
    t[8] > 0 && !/*isDisabled*/
    t[16] && lr(t)
  ), g = (
    /*countby*/
    t[7] && /*maxcount*/
    t[8] < 0 && /*count*/
    t[17] > 0 && !/*isDisabled*/
    t[16] && or(t)
  );
  return {
    c() {
      e = C("div"), i = C("div"), n = C("textarea"), r = x(), c && c.c(), a = x(), g && g.c(), f(
        n,
        "name",
        /*name*/
        t[1]
      ), f(
        n,
        "placeholder",
        /*placeholder*/
        t[2]
      ), f(
        n,
        "rows",
        /*rows*/
        t[3]
      ), f(n, "aria-label", l = /*arialabel*/
      t[6] || /*name*/
      t[1]), f(n, "aria-invalid", o = /*_error*/
      t[13] ? "true" : "false"), n.disabled = /*isDisabled*/
      t[16], n.readOnly = /*isReadonly*/
      t[18], f(
        n,
        "data-testid",
        /*testid*/
        t[4]
      ), f(n, "class", "svelte-1vnny6q"), f(i, "data-testid", "root"), f(i, "class", "root svelte-1vnny6q"), f(i, "style", s = `
      ${be(
        /*mt*/
        t[9],
        /*mr*/
        t[10],
        /*mb*/
        t[11],
        /*ml*/
        t[12]
      )};
      --width: ${/*width*/
      t[5]};
      --char-count-padding: ${/*countby*/
      t[7] ? "2rem" : "0"};
    `), G(
        i,
        "error",
        /*_error*/
        t[13] || /*maxcount*/
        t[8] > 0 && /*count*/
        t[17] > /*maxcount*/
        t[8]
      ), G(
        i,
        "disabled",
        /*isDisabled*/
        t[16]
      ), f(e, "id", "container"), f(e, "class", "svelte-1vnny6q");
    },
    m(h, m) {
      D(h, e, m), _(e, i), _(i, n), t[26](n), ri(
        n,
        /*value*/
        t[0]
      ), _(i, r), c && c.m(i, null), _(i, a), g && g.m(i, null), t[28](i), d || (u = [
        te(
          n,
          "input",
          /*textarea_input_handler*/
          t[27]
        ),
        te(
          n,
          "keyup",
          /*onKeyPress*/
          t[20]
        ),
        te(
          n,
          "change",
          /*onChange*/
          t[19]
        ),
        te(
          n,
          "focus",
          /*onFocus*/
          t[21]
        )
      ], d = !0);
    },
    p(h, m) {
      m[0] & /*name*/
      2 && f(
        n,
        "name",
        /*name*/
        h[1]
      ), m[0] & /*placeholder*/
      4 && f(
        n,
        "placeholder",
        /*placeholder*/
        h[2]
      ), m[0] & /*rows*/
      8 && f(
        n,
        "rows",
        /*rows*/
        h[3]
      ), m[0] & /*arialabel, name*/
      66 && l !== (l = /*arialabel*/
      h[6] || /*name*/
      h[1]) && f(n, "aria-label", l), m[0] & /*_error*/
      8192 && o !== (o = /*_error*/
      h[13] ? "true" : "false") && f(n, "aria-invalid", o), m[0] & /*isDisabled*/
      65536 && (n.disabled = /*isDisabled*/
      h[16]), m[0] & /*isReadonly*/
      262144 && (n.readOnly = /*isReadonly*/
      h[18]), m[0] & /*testid*/
      16 && f(
        n,
        "data-testid",
        /*testid*/
        h[4]
      ), m[0] & /*value*/
      1 && ri(
        n,
        /*value*/
        h[0]
      ), /*maxcount*/
      h[8] > 0 && !/*isDisabled*/
      h[16] ? c ? c.p(h, m) : (c = lr(h), c.c(), c.m(i, a)) : c && (c.d(1), c = null), /*countby*/
      h[7] && /*maxcount*/
      h[8] < 0 && /*count*/
      h[17] > 0 && !/*isDisabled*/
      h[16] ? g ? g.p(h, m) : (g = or(h), g.c(), g.m(i, null)) : g && (g.d(1), g = null), m[0] & /*mt, mr, mb, ml, width, countby*/
      7840 && s !== (s = `
      ${be(
        /*mt*/
        h[9],
        /*mr*/
        h[10],
        /*mb*/
        h[11],
        /*ml*/
        h[12]
      )};
      --width: ${/*width*/
      h[5]};
      --char-count-padding: ${/*countby*/
      h[7] ? "2rem" : "0"};
    `) && f(i, "style", s), m[0] & /*_error, maxcount, count*/
      139520 && G(
        i,
        "error",
        /*_error*/
        h[13] || /*maxcount*/
        h[8] > 0 && /*count*/
        h[17] > /*maxcount*/
        h[8]
      ), m[0] & /*isDisabled*/
      65536 && G(
        i,
        "disabled",
        /*isDisabled*/
        h[16]
      );
    },
    i: ve,
    o: ve,
    d(h) {
      h && P(e), t[26](null), c && c.d(), g && g.d(), t[28](null), d = !1, He(u);
    }
  };
}
function tm(t, e, i) {
  let n, l, o, { name: r } = e, { value: a = "" } = e, { placeholder: s = "" } = e, { rows: d = 3 } = e, { testid: u = "" } = e, { width: c = "60ch" } = e, { error: g = "false" } = e, { readonly: h = "false" } = e, { disabled: m = "false" } = e, { arialabel: v = "" } = e, { countby: b = "" } = e, { maxcount: w = -1 } = e, { mt: y = null } = e, { mr: j = null } = e, { mb: E = null } = e, { ml: M = null } = e, L = !1, z = !1, V, T;
  ke(() => {
    S(), I(), jr(T, ":host", {
      width: c.includes("%") ? c : `min(${c}, 100%)`
    });
  });
  function S() {
    Re(V, ($, ye) => {
      switch ($) {
        case bt:
          R(ye);
          break;
        case dt:
          A(ye);
          break;
        case ut:
          i(22, g = "false");
          break;
      }
    });
  }
  function A($) {
    i(22, g = $.error ? "true" : "false");
  }
  function R($) {
    i(0, a = $.value), qe(V, "_change", { name: r, value: a }, { bubbles: !0 });
  }
  function I() {
    je(V, Qe, { name: r, el: V }, { bubbles: !0, timeout: 10 });
  }
  function B($) {
    n || F();
  }
  function N($) {
    n || (q($), F());
  }
  function F($) {
    V.dispatchEvent(new CustomEvent(
      "_change",
      {
        composed: !0,
        detail: { name: r, value: V.value },
        bubbles: !0
      }
    ));
  }
  function q($) {
    V.dispatchEvent(new CustomEvent(
      "_keyPress",
      {
        composed: !0,
        detail: { name: r, value: a, key: $.key }
      }
    ));
  }
  function H($) {
    qe(T, "help-text::announce", void 0, { bubbles: !0 });
  }
  function O($) {
    ue[$ ? "unshift" : "push"](() => {
      V = $, i(15, V);
    });
  }
  function W() {
    a = this.value, i(0, a);
  }
  function K($) {
    ue[$ ? "unshift" : "push"](() => {
      T = $, i(14, T);
    });
  }
  return t.$$set = ($) => {
    "name" in $ && i(1, r = $.name), "value" in $ && i(0, a = $.value), "placeholder" in $ && i(2, s = $.placeholder), "rows" in $ && i(3, d = $.rows), "testid" in $ && i(4, u = $.testid), "width" in $ && i(5, c = $.width), "error" in $ && i(22, g = $.error), "readonly" in $ && i(23, h = $.readonly), "disabled" in $ && i(24, m = $.disabled), "arialabel" in $ && i(6, v = $.arialabel), "countby" in $ && i(7, b = $.countby), "maxcount" in $ && i(8, w = $.maxcount), "mt" in $ && i(9, y = $.mt), "mr" in $ && i(10, j = $.mr), "mb" in $ && i(11, E = $.mb), "ml" in $ && i(12, M = $.ml);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*error, _error, _prevError, _rootEl*/
    37773312 && (i(13, L = Ce(g)), L !== z && (qe(T, "error::change", { isError: L }, { bubbles: !0 }), i(25, z = L))), t.$$.dirty[0] & /*disabled*/
    16777216 && i(16, n = Ce(m)), t.$$.dirty[0] & /*readonly*/
    8388608 && i(18, l = Ce(h)), t.$$.dirty[0] & /*countby, value*/
    129 && i(17, o = b === "character" ? a == null ? void 0 : a.length : a == null ? void 0 : a.split(" ").filter(($) => $.trim().length > 0).length);
  }, [
    a,
    r,
    s,
    d,
    u,
    c,
    v,
    b,
    w,
    y,
    j,
    E,
    M,
    L,
    T,
    V,
    n,
    o,
    l,
    B,
    N,
    H,
    g,
    h,
    m,
    z,
    O,
    W,
    K
  ];
}
class im extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      tm,
      em,
      ce,
      {
        name: 1,
        value: 0,
        placeholder: 2,
        rows: 3,
        testid: 4,
        width: 5,
        error: 22,
        readonly: 23,
        disabled: 24,
        arialabel: 6,
        countby: 7,
        maxcount: 8,
        mt: 9,
        mr: 10,
        mb: 11,
        ml: 12
      },
      Jh,
      [-1, -1]
    );
  }
  get name() {
    return this.$$.ctx[1];
  }
  set name(e) {
    this.$$set({ name: e }), k();
  }
  get value() {
    return this.$$.ctx[0];
  }
  set value(e) {
    this.$$set({ value: e }), k();
  }
  get placeholder() {
    return this.$$.ctx[2];
  }
  set placeholder(e) {
    this.$$set({ placeholder: e }), k();
  }
  get rows() {
    return this.$$.ctx[3];
  }
  set rows(e) {
    this.$$set({ rows: e }), k();
  }
  get testid() {
    return this.$$.ctx[4];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get width() {
    return this.$$.ctx[5];
  }
  set width(e) {
    this.$$set({ width: e }), k();
  }
  get error() {
    return this.$$.ctx[22];
  }
  set error(e) {
    this.$$set({ error: e }), k();
  }
  get readonly() {
    return this.$$.ctx[23];
  }
  set readonly(e) {
    this.$$set({ readonly: e }), k();
  }
  get disabled() {
    return this.$$.ctx[24];
  }
  set disabled(e) {
    this.$$set({ disabled: e }), k();
  }
  get arialabel() {
    return this.$$.ctx[6];
  }
  set arialabel(e) {
    this.$$set({ arialabel: e }), k();
  }
  get countby() {
    return this.$$.ctx[7];
  }
  set countby(e) {
    this.$$set({ countby: e }), k();
  }
  get maxcount() {
    return this.$$.ctx[8];
  }
  set maxcount(e) {
    this.$$set({ maxcount: e }), k();
  }
  get mt() {
    return this.$$.ctx[9];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[10];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[11];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[12];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-textarea", he(im, { name: {}, value: {}, placeholder: {}, rows: {}, testid: {}, width: {}, error: {}, readonly: {}, disabled: {}, arialabel: {}, countby: {}, maxcount: {}, mt: {}, mr: {}, mb: {}, ml: {} }, [], [], !0));
function nm(t) {
  _e(t, "svelte-q0l82d", ".svelte-q0l82d.svelte-q0l82d{box-sizing:border-box}.page.svelte-q0l82d.svelte-q0l82d{min-height:100vh;display:flex;flex-direction:column}.content.svelte-q0l82d.svelte-q0l82d{flex:1 1 auto;display:flex;flex-direction:column;gap:2rem}.header.svelte-q0l82d.svelte-q0l82d,.footer.svelte-q0l82d.svelte-q0l82d{flex:0 0 auto}main.svelte-q0l82d.svelte-q0l82d{flex:1 1 auto;padding:0 1rem}.nav.svelte-q0l82d.svelte-q0l82d{transition:transform 200ms ease-in-out;background-color:var(--goa-color-greyscale-white)}.nav.svelte-q0l82d>.svelte-q0l82d{display:block;padding:0.5rem 0}@media not (max-width: 623px){.page.svelte-q0l82d.svelte-q0l82d{gap:2rem}.content.svelte-q0l82d.svelte-q0l82d{display:flex;flex-direction:row;justify-content:center;width:min(var(--max-content-width), 100vw);margin:0 auto}.nav.svelte-q0l82d.svelte-q0l82d{padding:0 2rem;transform:translateX(0)}.nav.svelte-q0l82d.svelte-q0l82d:not(.side-menu){flex:0 0 var(--nav-column-width)}.nav.side-menu.svelte-q0l82d.svelte-q0l82d{flex:0 0 var(--side-menu-column-width)}main.svelte-q0l82d.svelte-q0l82d{padding-right:2rem}}@media(min-width: 1024px){main.svelte-q0l82d.svelte-q0l82d{padding-right:4.5rem}}");
}
const lm = (t) => ({}), rr = (t) => ({}), om = (t) => ({}), ar = (t) => ({}), rm = (t) => ({}), sr = (t) => ({}), am = (t) => ({}), ur = (t) => ({}), sm = (t) => ({}), dr = (t) => ({});
function um(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h, m;
  const v = (
    /*#slots*/
    t[4].header
  ), b = oe(
    v,
    t,
    /*$$scope*/
    t[3],
    dr
  ), w = (
    /*#slots*/
    t[4].nav
  ), y = oe(
    w,
    t,
    /*$$scope*/
    t[3],
    ur
  ), j = (
    /*#slots*/
    t[4].default
  ), E = oe(
    j,
    t,
    /*$$scope*/
    t[3],
    null
  ), M = (
    /*#slots*/
    t[4].sidebar
  ), L = oe(
    M,
    t,
    /*$$scope*/
    t[3],
    sr
  ), z = (
    /*#slots*/
    t[4]["side-menu"]
  ), V = oe(
    z,
    t,
    /*$$scope*/
    t[3],
    ar
  ), T = (
    /*#slots*/
    t[4].footer
  ), S = oe(
    T,
    t,
    /*$$scope*/
    t[3],
    rr
  );
  return {
    c() {
      e = C("div"), i = C("header"), b && b.c(), n = x(), l = C("section"), o = C("nav"), y && y.c(), r = x(), a = C("main"), E && E.c(), s = x(), d = C("nav"), L && L.c(), u = x(), V && V.c(), c = x(), g = C("footer"), S && S.c(), f(i, "class", "header svelte-q0l82d"), f(o, "class", "nav svelte-q0l82d"), f(a, "class", "svelte-q0l82d"), f(d, "class", "nav side-menu svelte-q0l82d"), f(l, "class", "content svelte-q0l82d"), f(g, "class", "footer svelte-q0l82d"), f(e, "class", "page svelte-q0l82d"), f(e, "style", h = `
    --max-content-width: ${/*maxcontentwidth*/
      t[2] || "100%"};
    --nav-column-width: ${/*leftcolumnwidth*/
      t[0] || "256px"};
    --side-menu-column-width: ${/*rightcolumnwidth*/
      t[1] || "256px"}
  `);
    },
    m(A, R) {
      D(A, e, R), _(e, i), b && b.m(i, null), _(e, n), _(e, l), _(l, o), y && y.m(o, null), _(l, r), _(l, a), E && E.m(a, null), _(l, s), _(l, d), L && L.m(d, null), _(d, u), V && V.m(d, null), _(e, c), _(e, g), S && S.m(g, null), m = !0;
    },
    p(A, [R]) {
      b && b.p && (!m || R & /*$$scope*/
      8) && ae(
        b,
        v,
        A,
        /*$$scope*/
        A[3],
        m ? re(
          v,
          /*$$scope*/
          A[3],
          R,
          sm
        ) : se(
          /*$$scope*/
          A[3]
        ),
        dr
      ), y && y.p && (!m || R & /*$$scope*/
      8) && ae(
        y,
        w,
        A,
        /*$$scope*/
        A[3],
        m ? re(
          w,
          /*$$scope*/
          A[3],
          R,
          am
        ) : se(
          /*$$scope*/
          A[3]
        ),
        ur
      ), E && E.p && (!m || R & /*$$scope*/
      8) && ae(
        E,
        j,
        A,
        /*$$scope*/
        A[3],
        m ? re(
          j,
          /*$$scope*/
          A[3],
          R,
          null
        ) : se(
          /*$$scope*/
          A[3]
        ),
        null
      ), L && L.p && (!m || R & /*$$scope*/
      8) && ae(
        L,
        M,
        A,
        /*$$scope*/
        A[3],
        m ? re(
          M,
          /*$$scope*/
          A[3],
          R,
          rm
        ) : se(
          /*$$scope*/
          A[3]
        ),
        sr
      ), V && V.p && (!m || R & /*$$scope*/
      8) && ae(
        V,
        z,
        A,
        /*$$scope*/
        A[3],
        m ? re(
          z,
          /*$$scope*/
          A[3],
          R,
          om
        ) : se(
          /*$$scope*/
          A[3]
        ),
        ar
      ), S && S.p && (!m || R & /*$$scope*/
      8) && ae(
        S,
        T,
        A,
        /*$$scope*/
        A[3],
        m ? re(
          T,
          /*$$scope*/
          A[3],
          R,
          lm
        ) : se(
          /*$$scope*/
          A[3]
        ),
        rr
      ), (!m || R & /*maxcontentwidth, leftcolumnwidth, rightcolumnwidth*/
      7 && h !== (h = `
    --max-content-width: ${/*maxcontentwidth*/
      A[2] || "100%"};
    --nav-column-width: ${/*leftcolumnwidth*/
      A[0] || "256px"};
    --side-menu-column-width: ${/*rightcolumnwidth*/
      A[1] || "256px"}
  `)) && f(e, "style", h);
    },
    i(A) {
      m || (Y(b, A), Y(y, A), Y(E, A), Y(L, A), Y(V, A), Y(S, A), m = !0);
    },
    o(A) {
      U(b, A), U(y, A), U(E, A), U(L, A), U(V, A), U(S, A), m = !1;
    },
    d(A) {
      A && P(e), b && b.d(A), y && y.d(A), E && E.d(A), L && L.d(A), V && V.d(A), S && S.d(A);
    }
  };
}
function dm(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { leftcolumnwidth: o } = e, { rightcolumnwidth: r } = e, { maxcontentwidth: a } = e;
  return t.$$set = (s) => {
    "leftcolumnwidth" in s && i(0, o = s.leftcolumnwidth), "rightcolumnwidth" in s && i(1, r = s.rightcolumnwidth), "maxcontentwidth" in s && i(2, a = s.maxcontentwidth), "$$scope" in s && i(3, l = s.$$scope);
  }, [o, r, a, l, n];
}
class cm extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      dm,
      um,
      ce,
      {
        leftcolumnwidth: 0,
        rightcolumnwidth: 1,
        maxcontentwidth: 2
      },
      nm
    );
  }
  get leftcolumnwidth() {
    return this.$$.ctx[0];
  }
  set leftcolumnwidth(e) {
    this.$$set({ leftcolumnwidth: e }), k();
  }
  get rightcolumnwidth() {
    return this.$$.ctx[1];
  }
  set rightcolumnwidth(e) {
    this.$$set({ rightcolumnwidth: e }), k();
  }
  get maxcontentwidth() {
    return this.$$.ctx[2];
  }
  set maxcontentwidth(e) {
    this.$$set({ maxcontentwidth: e }), k();
  }
}
customElements.define("goa-three-column-layout", he(cm, { leftcolumnwidth: {}, rightcolumnwidth: {}, maxcontentwidth: {} }, ["header", "nav", "default", "sidebar", "side-menu", "footer"], [], !0));
const { window: Jr } = Vi;
function fm(t) {
  _e(t, "svelte-ajulxx", `:host{box-sizing:border-box;font-family:var(--goa-font-family-sans)}.tooltip.svelte-ajulxx.svelte-ajulxx{position:relative;display:inline-flex;justify-content:center;align-items:center}.tooltip.svelte-ajulxx.svelte-ajulxx:focus-visible{outline:var(--goa-tooltip-border-focus);outline-offset:-4px;border-radius:8px}.tooltip-text.svelte-ajulxx.svelte-ajulxx{visibility:hidden;font:var(--goa-tooltip-text-size);background-color:var(--goa-tooltip-color-bg);color:var(--goa-tooltip-color-text);text-align:center;border-radius:var(--goa-tooltip-border-radius);position:absolute;z-index:2;opacity:0;transition:opacity 0.3s;padding:var(--goa-tooltip-padding);text-align:left;white-space:nowrap;display:flex;flex-direction:column}.tooltip-target.svelte-ajulxx.svelte-ajulxx{margin:var(--goa-tooltip-gap);height:auto;display:flex}.tooltip-text.bottom.svelte-ajulxx.svelte-ajulxx{top:calc(100% + 10px)}.tooltip-text.top.svelte-ajulxx.svelte-ajulxx{bottom:calc(100% + 10px)}.tooltip-text.right.svelte-ajulxx.svelte-ajulxx{left:calc(100% + 10px)}.tooltip-text.left.svelte-ajulxx.svelte-ajulxx{right:calc(100% + 10px)}.tooltip.svelte-ajulxx:hover .tooltip-text.svelte-ajulxx,.tooltip.svelte-ajulxx:focus .tooltip-text.svelte-ajulxx{opacity:1}.tooltip-text.bottom.svelte-ajulxx.svelte-ajulxx::before,.tooltip-text.top.svelte-ajulxx.svelte-ajulxx::before,.tooltip-text.left.svelte-ajulxx.svelte-ajulxx::before,.tooltip-text.right.svelte-ajulxx.svelte-ajulxx::before{content:"";position:absolute;border-style:solid}.tooltip-text.bottom.svelte-ajulxx.svelte-ajulxx::before{top:-9px;left:50%;border-width:0 10px 10px 10px;transform:translateX(-50%);border-color:transparent transparent var(--goa-tooltip-color-bg)
      transparent}.tooltip-text.top.svelte-ajulxx.svelte-ajulxx::before{bottom:-9px;left:50%;transform:translateX(-50%);border-width:10px 10px 0 10px;border-color:var(--goa-tooltip-color-bg) transparent transparent
      transparent}.tooltip-text.left.svelte-ajulxx.svelte-ajulxx::before{top:50%;right:-9px;transform:translateY(-50%);border-width:10px 0 10px 10px;border-color:transparent transparent transparent
      var(--goa-tooltip-color-bg)}.tooltip-text.right.svelte-ajulxx.svelte-ajulxx::before{top:50%;left:-9px;transform:translateY(-50%);border-width:10px 10px 10px 0;border-style:solid;border-color:transparent var(--goa-tooltip-color-bg) transparent
      transparent}.tooltip-text.bottom.align-left.svelte-ajulxx.svelte-ajulxx::before,.tooltip-text.top.align-left.svelte-ajulxx.svelte-ajulxx::before{left:calc(100% - (var(--target-width) + 1rem))}.tooltip-text.bottom.align-right.svelte-ajulxx.svelte-ajulxx::before,.tooltip-text.top.align-right.svelte-ajulxx.svelte-ajulxx::before{left:calc(var(--target-width) + 1rem)}.tooltip.align-right.svelte-ajulxx.svelte-ajulxx{justify-content:flex-start}.tooltip.align-left.svelte-ajulxx.svelte-ajulxx{justify-content:flex-end}.tooltip-text.align-right.svelte-ajulxx.svelte-ajulxx{left:0;margin-left:-1rem}.tooltip-text.align-left.svelte-ajulxx.svelte-ajulxx{right:0;margin-right:-1rem}`);
}
function gm(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g, h;
  We(
    /*onwindowresize*/
    t[18]
  );
  const m = (
    /*#slots*/
    t[17].default
  ), v = oe(
    m,
    t,
    /*$$scope*/
    t[16],
    null
  );
  return {
    c() {
      e = C("div"), i = C("div"), v && v.c(), n = x(), l = C("span"), o = le(
        /*content*/
        t[2]
      ), f(i, "class", "tooltip-target svelte-ajulxx"), f(l, "id", r = /*_tooltipInstanceId*/
      t[13] + "-tooltip"), f(l, "class", a = "tooltip-text " + /*position*/
      t[0] + " align-" + /*halign*/
      t[1] + " svelte-ajulxx"), Be(
        l,
        "visibility",
        /*_tooltipVisible*/
        t[11] ? "visible" : "hidden"
      ), f(e, "class", s = "tooltip align-" + /*halign*/
      t[1] + " svelte-ajulxx"), f(
        e,
        "data-testid",
        /*testid*/
        t[3]
      ), f(e, "role", "tooltip"), f(e, "aria-describedby", d = /*_tooltipInstanceId*/
      t[13] + "-tooltip"), f(e, "tabindex", "0"), f(e, "style", u = be(
        /*mt*/
        t[4],
        /*mr*/
        t[5],
        /*mb*/
        t[6],
        /*ml*/
        t[7]
      ));
    },
    m(b, w) {
      D(b, e, w), _(e, i), v && v.m(i, null), _(e, n), _(e, l), _(l, o), t[19](l), t[20](e), c = !0, g || (h = [
        te(
          Jr,
          "resize",
          /*onwindowresize*/
          t[18]
        ),
        te(
          e,
          "mouseenter",
          /*mouseenter_handler*/
          t[21]
        ),
        te(
          e,
          "mouseleave",
          /*hideTooltip*/
          t[15]
        ),
        te(
          e,
          "focus",
          /*focus_handler*/
          t[22]
        ),
        te(
          e,
          "blur",
          /*hideTooltip*/
          t[15]
        )
      ], g = !0);
    },
    p(b, [w]) {
      v && v.p && (!c || w & /*$$scope*/
      65536) && ae(
        v,
        m,
        b,
        /*$$scope*/
        b[16],
        c ? re(
          m,
          /*$$scope*/
          b[16],
          w,
          null
        ) : se(
          /*$$scope*/
          b[16]
        ),
        null
      ), (!c || w & /*content*/
      4) && pe(
        o,
        /*content*/
        b[2]
      ), (!c || w & /*_tooltipInstanceId*/
      8192 && r !== (r = /*_tooltipInstanceId*/
      b[13] + "-tooltip")) && f(l, "id", r), (!c || w & /*position, halign*/
      3 && a !== (a = "tooltip-text " + /*position*/
      b[0] + " align-" + /*halign*/
      b[1] + " svelte-ajulxx")) && f(l, "class", a), (!c || w & /*_tooltipVisible*/
      2048) && Be(
        l,
        "visibility",
        /*_tooltipVisible*/
        b[11] ? "visible" : "hidden"
      ), (!c || w & /*halign*/
      2 && s !== (s = "tooltip align-" + /*halign*/
      b[1] + " svelte-ajulxx")) && f(e, "class", s), (!c || w & /*testid*/
      8) && f(
        e,
        "data-testid",
        /*testid*/
        b[3]
      ), (!c || w & /*_tooltipInstanceId*/
      8192 && d !== (d = /*_tooltipInstanceId*/
      b[13] + "-tooltip")) && f(e, "aria-describedby", d), (!c || w & /*mt, mr, mb, ml*/
      240 && u !== (u = be(
        /*mt*/
        b[4],
        /*mr*/
        b[5],
        /*mb*/
        b[6],
        /*ml*/
        b[7]
      ))) && f(e, "style", u);
    },
    i(b) {
      c || (Y(v, b), c = !0);
    },
    o(b) {
      U(v, b), c = !1;
    },
    d(b) {
      b && P(e), v && v.d(b), t[19](null), t[20](null), g = !1, He(h);
    }
  };
}
function hm(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { content: o = "" } = e, { testid: r = "" } = e, { position: a = "top" } = e, { halign: s = "center" } = e, { mt: d = null } = e, { mr: u = null } = e, { mb: c = null } = e, { ml: g = null } = e;
  const [h, m] = Me("Tooltip positions", ["top", "bottom", "left", "right"], !1), [v, b] = Me("Tooltip alignment", ["left", "right", "center"], !1), w = (H, O) => {
    (H === "left" || H === "right") && O !== "center" && console.error(`[${O}] is an invalid option for position ${H}`);
  };
  let y = 0, j, E, M, L = !1, z, V, T;
  ke(() => {
    setTimeout(
      () => {
        m(a), b(s), w(a, s);
      },
      1
    ), M = a, i(13, T = Math.random().toString(36)), window.addEventListener("resize", R), R();
  }), ct(() => {
    window.removeEventListener("resize", R), clearTimeout(z), clearTimeout(V);
  });
  const S = () => {
    z = setTimeout(
      () => {
        i(11, L = !0), R();
      },
      300
    );
  }, A = () => {
    clearTimeout(z), i(12, V = setTimeout(
      () => {
        i(11, L = !1), i(0, a = M);
      },
      500
    ));
  };
  async function R() {
    if (await Pe(), !E || !j)
      return;
    const H = E.getBoundingClientRect(), O = j.getBoundingClientRect(), W = O.top, K = window.innerHeight - O.bottom, $ = O.left, ye = window.innerWidth - O.right, Z = Math.min(y * 0.8, 400, H.width, Math.max($, ye) - 10), Q = Z > O.width || Z > $ || Z > ye;
    i(9, E.style.width = `${Z - 32}px`, E), Q ? i(9, E.style.whiteSpace = "normal", E) : i(9, E.style.whiteSpace = "nowrap", E);
    let X = a, ee = s;
    a === "bottom" && H.height > K ? X = "top" : a === "top" && H.height > W && (X = "bottom"), a === "right" && H.width > ye ? X = "left" : a === "left" && H.width > $ && (X = "right"), s === "right" && H.width > ye ? ee = "left" : s === "left" && H.width > $ ? ee = "right" : s === "center" && (a === "top" || a === "bottom") && (H.width / 2 > $ || H.width / 2 > ye) && (ee = $ > ye ? "left" : "right"), i(0, a = X), i(1, s = ee);
  }
  function I() {
    i(10, y = Jr.innerWidth);
  }
  function B(H) {
    ue[H ? "unshift" : "push"](() => {
      E = H, i(9, E);
    });
  }
  function N(H) {
    ue[H ? "unshift" : "push"](() => {
      j = H, i(8, j);
    });
  }
  const F = () => {
    clearTimeout(V), S();
  }, q = () => {
    clearTimeout(V), S();
  };
  return t.$$set = (H) => {
    "content" in H && i(2, o = H.content), "testid" in H && i(3, r = H.testid), "position" in H && i(0, a = H.position), "halign" in H && i(1, s = H.halign), "mt" in H && i(4, d = H.mt), "mr" in H && i(5, u = H.mr), "mb" in H && i(6, c = H.mb), "ml" in H && i(7, g = H.ml), "$$scope" in H && i(16, l = H.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*_rootEl, _tooltipEl*/
    768 && j && E && j.style.setProperty("--target-width", `${j.getBoundingClientRect().width / 2}px`), t.$$.dirty & /*content*/
    4 && o && R();
  }, [
    a,
    s,
    o,
    r,
    d,
    u,
    c,
    g,
    j,
    E,
    y,
    L,
    V,
    T,
    S,
    A,
    l,
    n,
    I,
    B,
    N,
    F,
    q
  ];
}
class mm extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      hm,
      gm,
      ce,
      {
        content: 2,
        testid: 3,
        position: 0,
        halign: 1,
        mt: 4,
        mr: 5,
        mb: 6,
        ml: 7
      },
      fm
    );
  }
  get content() {
    return this.$$.ctx[2];
  }
  set content(e) {
    this.$$set({ content: e }), k();
  }
  get testid() {
    return this.$$.ctx[3];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get position() {
    return this.$$.ctx[0];
  }
  set position(e) {
    this.$$set({ position: e }), k();
  }
  get halign() {
    return this.$$.ctx[1];
  }
  set halign(e) {
    this.$$set({ halign: e }), k();
  }
  get mt() {
    return this.$$.ctx[4];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[5];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[6];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[7];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
}
customElements.define("goa-tooltip", he(mm, { content: {}, testid: {}, position: {}, halign: {}, mt: {}, mr: {}, mb: {}, ml: {} }, ["default"], [], !0));
function vm(t) {
  _e(t, "svelte-luwgzc", ".svelte-luwgzc.svelte-luwgzc{box-sizing:border-box}.page.svelte-luwgzc.svelte-luwgzc{min-height:100vh;display:flex;flex-direction:column}.content.svelte-luwgzc.svelte-luwgzc{flex:1 1 auto;display:flex;flex-direction:column;gap:2rem}.header.svelte-luwgzc.svelte-luwgzc,.footer.svelte-luwgzc.svelte-luwgzc{flex:0 0 auto}main.svelte-luwgzc.svelte-luwgzc{flex:1 1 auto;padding:0 1rem}.nav.svelte-luwgzc.svelte-luwgzc{padding:0;transition:transform 200ms ease-in-out;background-color:var(--goa-color-greyscale-white)}.nav.svelte-luwgzc>.svelte-luwgzc{display:block;padding:0.5rem 0}@media not (max-width: 623px){.page.svelte-luwgzc.svelte-luwgzc{gap:2rem}.content.svelte-luwgzc.svelte-luwgzc{display:flex;flex-direction:row;justify-content:center;width:min(var(--max-content-width), 100vw);margin:0 auto}.nav.svelte-luwgzc.svelte-luwgzc{padding:0 2rem;transform:translateX(0);flex:0 0 var(--nav-column-width)}main.svelte-luwgzc.svelte-luwgzc{padding-right:2rem}}@media(min-width: 1024px){main.svelte-luwgzc.svelte-luwgzc{padding-right:4.5rem}}");
}
const bm = (t) => ({}), cr = (t) => ({}), pm = (t) => ({}), fr = (t) => ({}), _m = (t) => ({}), gr = (t) => ({});
function wm(t) {
  let e, i, n, l, o, r, a, s, d, u, c;
  const g = (
    /*#slots*/
    t[3].header
  ), h = oe(
    g,
    t,
    /*$$scope*/
    t[2],
    gr
  ), m = (
    /*#slots*/
    t[3].nav
  ), v = oe(
    m,
    t,
    /*$$scope*/
    t[2],
    fr
  ), b = (
    /*#slots*/
    t[3].default
  ), w = oe(
    b,
    t,
    /*$$scope*/
    t[2],
    null
  ), y = (
    /*#slots*/
    t[3].footer
  ), j = oe(
    y,
    t,
    /*$$scope*/
    t[2],
    cr
  );
  return {
    c() {
      e = C("div"), i = C("header"), h && h.c(), n = x(), l = C("section"), o = C("nav"), v && v.c(), r = x(), a = C("main"), w && w.c(), s = x(), d = C("footer"), j && j.c(), f(i, "class", "header svelte-luwgzc"), f(o, "class", "nav svelte-luwgzc"), f(a, "class", "svelte-luwgzc"), f(l, "class", "content svelte-luwgzc"), f(d, "class", "footer svelte-luwgzc"), f(e, "class", "page svelte-luwgzc"), f(e, "style", u = `
    --max-content-width: ${/*maxcontentwidth*/
      t[1] || "100%"};
    --nav-column-width: ${/*navcolumnwidth*/
      t[0] || "256px"};
  `);
    },
    m(E, M) {
      D(E, e, M), _(e, i), h && h.m(i, null), _(e, n), _(e, l), _(l, o), v && v.m(o, null), _(l, r), _(l, a), w && w.m(a, null), _(e, s), _(e, d), j && j.m(d, null), c = !0;
    },
    p(E, [M]) {
      h && h.p && (!c || M & /*$$scope*/
      4) && ae(
        h,
        g,
        E,
        /*$$scope*/
        E[2],
        c ? re(
          g,
          /*$$scope*/
          E[2],
          M,
          _m
        ) : se(
          /*$$scope*/
          E[2]
        ),
        gr
      ), v && v.p && (!c || M & /*$$scope*/
      4) && ae(
        v,
        m,
        E,
        /*$$scope*/
        E[2],
        c ? re(
          m,
          /*$$scope*/
          E[2],
          M,
          pm
        ) : se(
          /*$$scope*/
          E[2]
        ),
        fr
      ), w && w.p && (!c || M & /*$$scope*/
      4) && ae(
        w,
        b,
        E,
        /*$$scope*/
        E[2],
        c ? re(
          b,
          /*$$scope*/
          E[2],
          M,
          null
        ) : se(
          /*$$scope*/
          E[2]
        ),
        null
      ), j && j.p && (!c || M & /*$$scope*/
      4) && ae(
        j,
        y,
        E,
        /*$$scope*/
        E[2],
        c ? re(
          y,
          /*$$scope*/
          E[2],
          M,
          bm
        ) : se(
          /*$$scope*/
          E[2]
        ),
        cr
      ), (!c || M & /*maxcontentwidth, navcolumnwidth*/
      3 && u !== (u = `
    --max-content-width: ${/*maxcontentwidth*/
      E[1] || "100%"};
    --nav-column-width: ${/*navcolumnwidth*/
      E[0] || "256px"};
  `)) && f(e, "style", u);
    },
    i(E) {
      c || (Y(h, E), Y(v, E), Y(w, E), Y(j, E), c = !0);
    },
    o(E) {
      U(h, E), U(v, E), U(w, E), U(j, E), c = !1;
    },
    d(E) {
      E && P(e), h && h.d(E), v && v.d(E), w && w.d(E), j && j.d(E);
    }
  };
}
function km(t, e, i) {
  let { $$slots: n = {}, $$scope: l } = e, { navcolumnwidth: o = "" } = e, { maxcontentwidth: r = "" } = e;
  return t.$$set = (a) => {
    "navcolumnwidth" in a && i(0, o = a.navcolumnwidth), "maxcontentwidth" in a && i(1, r = a.maxcontentwidth), "$$scope" in a && i(2, l = a.$$scope);
  }, [o, r, l, n];
}
class ym extends me {
  constructor(e) {
    super(), ge(this, e, km, wm, ce, { navcolumnwidth: 0, maxcontentwidth: 1 }, vm);
  }
  get navcolumnwidth() {
    return this.$$.ctx[0];
  }
  set navcolumnwidth(e) {
    this.$$set({ navcolumnwidth: e }), k();
  }
  get maxcontentwidth() {
    return this.$$.ctx[1];
  }
  set maxcontentwidth(e) {
    this.$$set({ maxcontentwidth: e }), k();
  }
}
customElements.define("goa-two-column-layout", he(ym, { navcolumnwidth: {}, maxcontentwidth: {} }, ["header", "nav", "default", "footer"], [], !0));
function Cm(t) {
  _e(t, "svelte-vthlw2", `.goa-grid.svelte-vthlw2.svelte-vthlw2{display:grid;grid-template-columns:repeat(
        auto-fit,
        minmax(var(--min-child-width), 1fr)
      )}.goa-grid.mobile.svelte-vthlw2.svelte-vthlw2{display:flex;justify-content:space-around}.slots.svelte-vthlw2.svelte-vthlw2{position:relative;inset:0;z-index:2}#container.svelte-vthlw2.svelte-vthlw2{container:self / inline-size}.form-stepper.mobile.svelte-vthlw2.svelte-vthlw2{justify-content:center;padding-left:8px;padding-right:8px}.form-stepper.mobile.svelte-vthlw2 progress.svelte-vthlw2{position:absolute;z-index:1}.form-stepper.mobile.svelte-vthlw2 progress.horizontal.svelte-vthlw2{margin-top:0px;top:43px;width:var(--form-stepper-width);height:1px}progress.svelte-vthlw2.svelte-vthlw2{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:2px;border:none;background:var(--goa-color-greyscale-200);pointer-events:none}progress.horizontal.svelte-vthlw2.svelte-vthlw2{margin-top:-28px;width:100%}.form-stepper.svelte-vthlw2.svelte-vthlw2{padding-bottom:24px}progress.horizontal.svelte-vthlw2.svelte-vthlw2{display:block}.form-stepper.svelte-vthlw2.svelte-vthlw2{position:relative}progress.svelte-vthlw2.svelte-vthlw2::-webkit-progress-value{background:var(--goa-color-interactive-default)}progress.svelte-vthlw2.svelte-vthlw2::-webkit-progress-bar{background:var(--goa-color-greyscale-200)}progress.svelte-vthlw2.svelte-vthlw2::-moz-progress-bar{background:var(--goa-color-interactive-default)}`);
}
function hr(t) {
  let e;
  return {
    c() {
      e = C("progress"), f(e, "class", "horizontal svelte-vthlw2"), e.value = /*_progress*/
      t[12], f(e, "max", "100"), G(
        e,
        "mobile",
        /*_isMobile*/
        t[14]
      );
    },
    m(i, n) {
      D(i, e, n);
    },
    p(i, n) {
      n[0] & /*_progress*/
      4096 && (e.value = /*_progress*/
      i[12]), n[0] & /*_isMobile*/
      16384 && G(
        e,
        "mobile",
        /*_isMobile*/
        i[14]
      );
    },
    d(i) {
      i && P(e);
    }
  };
}
function zm(t) {
  let e, i, n, l, o, r, a, s;
  const d = (
    /*#slots*/
    t[21].default
  ), u = oe(
    d,
    t,
    /*$$scope*/
    t[20],
    null
  );
  let c = (
    /*_steps*/
    t[7].length > 0 && /*_showProgressBars*/
    t[13] && hr(t)
  );
  return {
    c() {
      e = C("div"), i = C("div"), n = C("div"), l = C("div"), u && u.c(), r = x(), c && c.c(), f(l, "class", "goa-grid svelte-vthlw2"), f(l, "style", o = `--min-child-width: ${/*_isMobile*/
      t[14] ? "40px" : "180px"};
        gap: var(--goa-space-${/*_isMobile*/
      t[14] ? "xs" : "none"});`), G(
        l,
        "mobile",
        /*_isMobile*/
        t[14]
      ), f(n, "class", "slots svelte-vthlw2"), f(i, "class", "form-stepper svelte-vthlw2"), f(i, "style", a = `
      ${be(
        /*mt*/
        t[1],
        /*mr*/
        t[2],
        /*mb*/
        t[3],
        /*ml*/
        t[4]
      )};
      --progress: ${/*_progress*/
      t[12]}%;
      --step-width: ${/*_stepWidth*/
      t[8]}px;
      --step-height: ${/*_stepHeight*/
      t[9]}px;
      --form-stepper-width: ${/*_formStepperWidth*/
      t[10]}px;
      --height: ${/*_progressHeight*/
      t[11]}px;
    `), f(i, "role", "list"), f(
        i,
        "data-testid",
        /*testid*/
        t[0]
      ), G(
        i,
        "mobile",
        /*_isMobile*/
        t[14]
      ), f(e, "id", "container"), f(e, "class", "svelte-vthlw2");
    },
    m(g, h) {
      D(g, e, h), _(e, i), _(i, n), _(n, l), u && u.m(l, null), t[22](n), _(i, r), c && c.m(i, null), t[23](i), s = !0;
    },
    p(g, h) {
      u && u.p && (!s || h[0] & /*$$scope*/
      1048576) && ae(
        u,
        d,
        g,
        /*$$scope*/
        g[20],
        s ? re(
          d,
          /*$$scope*/
          g[20],
          h,
          null
        ) : se(
          /*$$scope*/
          g[20]
        ),
        null
      ), (!s || h[0] & /*_isMobile*/
      16384 && o !== (o = `--min-child-width: ${/*_isMobile*/
      g[14] ? "40px" : "180px"};
        gap: var(--goa-space-${/*_isMobile*/
      g[14] ? "xs" : "none"});`)) && f(l, "style", o), (!s || h[0] & /*_isMobile*/
      16384) && G(
        l,
        "mobile",
        /*_isMobile*/
        g[14]
      ), /*_steps*/
      g[7].length > 0 && /*_showProgressBars*/
      g[13] ? c ? c.p(g, h) : (c = hr(g), c.c(), c.m(i, null)) : c && (c.d(1), c = null), (!s || h[0] & /*mt, mr, mb, ml, _progress, _stepWidth, _stepHeight, _formStepperWidth, _progressHeight*/
      7966 && a !== (a = `
      ${be(
        /*mt*/
        g[1],
        /*mr*/
        g[2],
        /*mb*/
        g[3],
        /*ml*/
        g[4]
      )};
      --progress: ${/*_progress*/
      g[12]}%;
      --step-width: ${/*_stepWidth*/
      g[8]}px;
      --step-height: ${/*_stepHeight*/
      g[9]}px;
      --form-stepper-width: ${/*_formStepperWidth*/
      g[10]}px;
      --height: ${/*_progressHeight*/
      g[11]}px;
    `)) && f(i, "style", a), (!s || h[0] & /*testid*/
      1) && f(
        i,
        "data-testid",
        /*testid*/
        g[0]
      ), (!s || h[0] & /*_isMobile*/
      16384) && G(
        i,
        "mobile",
        /*_isMobile*/
        g[14]
      );
    },
    i(g) {
      s || (Y(u, g), s = !0);
    },
    o(g) {
      U(u, g), s = !1;
    },
    d(g) {
      g && P(e), u && u.d(g), t[22](null), c && c.d(), t[23](null);
    }
  };
}
function jm(t, e, i) {
  let n, l, { $$slots: o = {}, $$scope: r } = e, { step: a = -1 } = e, { testid: s = "" } = e, { mt: d = null } = e, { mr: u = null } = e, { mb: c = null } = e, { ml: g = null } = e, { mobile: h = "false" } = e, { backgroundcolor: m = "inherit" } = e, v, b, w = [], y, j, E, M, L, z = 0, V, T = 1, S = !1, A, R;
  ke(async () => {
    await Pe(), M = +a == -1 ? "free" : "constrained", I(), R = q(), R.observe(v);
  }), ct(() => {
    window.removeEventListener("orientationchange", W), R.unobserve(v);
  });
  function I() {
    v.addEventListener("formstep:mounted", (Z) => {
      const Q = Z, { el: X, status: ee } = Q.detail;
      i(7, w = [...w, { el: X, status: ee }]), A && clearTimeout(A), A = setTimeout(() => {
        B(), W(), F(), N(), i(18, V = a < 1 ? 1 : a), K();
      });
    });
  }
  function B() {
    for (const [Z, Q] of w.entries()) {
      const X = Z + 1, ee = {
        ariaLabel: `Step ${X} of ${w.length}`,
        childIndex: X,
        current: a === -1 ? X === 1 : X === a,
        enabled: X <= a || M === "free",
        status: Q.status,
        mobile: n,
        backgroundColor: l
      };
      Q.el.dispatchEvent(new CustomEvent("formstepper:init", { composed: !0, detail: ee }));
    }
  }
  function N() {
    window.addEventListener("orientationchange", W);
  }
  function F() {
    v == null || v.addEventListener("_click", (Z) => {
      const Q = Z.detail.step;
      H(Q);
    });
  }
  function q() {
    return new ResizeObserver((Z) => {
      if (Z.length === 1) {
        W(), Z[0].contentRect.width;
        for (const Q of w)
          Q.el.dispatchEvent(new CustomEvent(
            "form-stepper:resized",
            {
              bubbles: !0,
              composed: !0,
              detail: { testid: s, mobile: n }
            }
          ));
      }
    });
  }
  function H(Z) {
    w.length !== 0 && (V > 0 && w[V - 1].el.dispatchEvent(new CustomEvent(
      "formstepper:current:changed",
      {
        detail: { current: !1 },
        composed: !0
      }
    )), w[Z - 1].el.dispatchEvent(new CustomEvent(
      "formstepper:current:changed",
      {
        detail: { current: !0 },
        composed: !0
      }
    )), i(18, V = Z), O(), K());
  }
  function O() {
    i(12, z = n ? 100 : V / (w.length - 1) * 100);
  }
  function W() {
    var Q;
    const Z = (Q = w == null ? void 0 : w[0]) == null ? void 0 : Q.el;
    i(8, y = (Z == null ? void 0 : Z.offsetWidth) ?? 0), i(9, j = (Z == null ? void 0 : Z.offsetHeight) ?? 0), i(11, L = b == null ? void 0 : b.offsetHeight), i(10, E = b == null ? void 0 : b.offsetWidth), setTimeout(() => i(13, S = !0), 100);
  }
  function K() {
    v == null || v.dispatchEvent(new CustomEvent(
      "_change",
      {
        composed: !0,
        bubbles: !0,
        detail: {
          step: +V,
          stepIndex: +V - 1
        }
      }
    ));
  }
  function $(Z) {
    ue[Z ? "unshift" : "push"](() => {
      b = Z, i(6, b);
    });
  }
  function ye(Z) {
    ue[Z ? "unshift" : "push"](() => {
      v = Z, i(5, v);
    });
  }
  return t.$$set = (Z) => {
    "step" in Z && i(15, a = Z.step), "testid" in Z && i(0, s = Z.testid), "mt" in Z && i(1, d = Z.mt), "mr" in Z && i(2, u = Z.mr), "mb" in Z && i(3, c = Z.mb), "ml" in Z && i(4, g = Z.ml), "mobile" in Z && i(16, h = Z.mobile), "backgroundcolor" in Z && i(17, m = Z.backgroundcolor), "$$scope" in Z && i(20, r = Z.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*_currentStep, _maxAllowedStep*/
    786432 && i(19, T = Math.max(V || 1, T || 1)), t.$$.dirty[0] & /*mobile*/
    65536 && i(14, n = Ce(h)), t.$$.dirty[0] & /*backgroundcolor*/
    131072 && (l = m), t.$$.dirty[0] & /*step*/
    32768 && i(15, a = +a), t.$$.dirty[0] & /*step, _currentStep*/
    294912 && a > 0 && V !== a && H(a), t.$$.dirty[0] & /*_currentStep*/
    262144 && V && O();
  }, [
    s,
    d,
    u,
    c,
    g,
    v,
    b,
    w,
    y,
    j,
    E,
    L,
    z,
    S,
    n,
    a,
    h,
    m,
    V,
    T,
    r,
    o,
    $,
    ye
  ];
}
class Em extends me {
  constructor(e) {
    super(), ge(
      this,
      e,
      jm,
      zm,
      ce,
      {
        step: 15,
        testid: 0,
        mt: 1,
        mr: 2,
        mb: 3,
        ml: 4,
        mobile: 16,
        backgroundcolor: 17
      },
      Cm,
      [-1, -1]
    );
  }
  get step() {
    return this.$$.ctx[15];
  }
  set step(e) {
    this.$$set({ step: e }), k();
  }
  get testid() {
    return this.$$.ctx[0];
  }
  set testid(e) {
    this.$$set({ testid: e }), k();
  }
  get mt() {
    return this.$$.ctx[1];
  }
  set mt(e) {
    this.$$set({ mt: e }), k();
  }
  get mr() {
    return this.$$.ctx[2];
  }
  set mr(e) {
    this.$$set({ mr: e }), k();
  }
  get mb() {
    return this.$$.ctx[3];
  }
  set mb(e) {
    this.$$set({ mb: e }), k();
  }
  get ml() {
    return this.$$.ctx[4];
  }
  set ml(e) {
    this.$$set({ ml: e }), k();
  }
  get mobile() {
    return this.$$.ctx[16];
  }
  set mobile(e) {
    this.$$set({ mobile: e }), k();
  }
  get backgroundcolor() {
    return this.$$.ctx[17];
  }
  set backgroundcolor(e) {
    this.$$set({ backgroundcolor: e }), k();
  }
}
customElements.define("goax-form-stepper", he(Em, { step: {}, testid: {}, mt: {}, mr: {}, mb: {}, ml: {}, mobile: {}, backgroundcolor: {} }, ["default"], [], !0));
function Mm(t) {
  _e(t, "svelte-6d3t92", `input[type="checkbox"].svelte-6d3t92.svelte-6d3t92{position:absolute;left:-9999px}label.svelte-6d3t92.svelte-6d3t92{display:flex;box-sizing:border-box;height:100%;width:100%;padding:24px 12px 48px}label.mobile.svelte-6d3t92.svelte-6d3t92{padding-bottom:24px;justify-content:center;background-color:var(--background-color, inherit);padding-left:8px;padding-right:8px;max-width:-moz-fit-content;max-width:fit-content}label.desktop.svelte-6d3t92.svelte-6d3t92{text-align:center;flex-direction:column;align-items:center}label.desktop.svelte-6d3t92 .details.svelte-6d3t92{margin-top:24px}label.mobile.svelte-6d3t92.svelte-6d3t92{flex-direction:row;align-items:center;text-align:start}.status.svelte-6d3t92.svelte-6d3t92{flex:0 0 auto;display:flex;align-items:center;justify-content:center;box-sizing:border-box;border-radius:999px;border:2px solid var(--goa-color-interactive-default);background:var(--goa-color-greyscale-white);height:2.5rem;width:2.5rem}.status.incomplete.svelte-6d3t92.svelte-6d3t92{background:var(--goa-color-greyscale-200);border:2px solid var(--goa-color-greyscale-200)}.status.current.svelte-6d3t92.svelte-6d3t92{background:var(--goa-color-greyscale-white);border:2px solid var(--goa-color-interactive-default)}.status.svelte-6d3t92>.svelte-6d3t92{fill:var(--fill-color, var(--goa-color-interactive-default));color:var(--fill-color, var(--goa-color-interactive-default))}[aria-current="step"].svelte-6d3t92 .text.svelte-6d3t92{font-weight:var(--goa-font-weight-bold)}[data-status="complete"].svelte-6d3t92 .status.svelte-6d3t92{background:var(--goa-color-interactive-default)}[aria-current="step"][data-status="complete"].svelte-6d3t92 .status.svelte-6d3t92{background:var(--goa-color-greyscale-white)}.step-number.svelte-6d3t92.svelte-6d3t92{margin-bottom:var(--font-valign-fix);font-weight:var(--goa-font-weight-bold);color:var(--goa-color-text-secondary)}.status.current.svelte-6d3t92 .step-number.svelte-6d3t92{color:var(--goa-color-interactive-default)}label.svelte-6d3t92:not(
      [data-status="complete"],
      [data-status="incomplete"],
      [aria-current="step"]
    ) .status.svelte-6d3t92{border-color:var(--goa-color-greyscale-500)}.text.svelte-6d3t92.svelte-6d3t92{font-size:16px;line-height:20px;font-weight:400}`);
}
function Lm(t) {
  let e, i = (
    /*childindex*/
    (t[3] || "") + ""
  ), n;
  return {
    c() {
      e = C("div"), n = le(i), f(e, "data-testid", "step-number"), f(e, "class", "step-number svelte-6d3t92");
    },
    m(l, o) {
      D(l, e, o), _(e, n);
    },
    p(l, o) {
      o & /*childindex*/
      8 && i !== (i = /*childindex*/
      (l[3] || "") + "") && pe(n, i);
    },
    d(l) {
      l && P(e);
    }
  };
}
function qm(t) {
  let e;
  return {
    c() {
      e = C("goa-icon"), p(e, "type", "checkmark"), p(e, "inverted", ""), p(e, "class", "svelte-6d3t92");
    },
    m(i, n) {
      D(i, e, n);
    },
    p: ve,
    d(i) {
      i && P(e);
    }
  };
}
function mr(t) {
  let e, i, n;
  return {
    c() {
      e = C("div"), i = C("div"), n = le(
        /*text*/
        t[1]
      ), f(i, "class", "text svelte-6d3t92"), f(i, "data-testid", "text"), f(e, "class", "details svelte-6d3t92");
    },
    m(l, o) {
      D(l, e, o), _(e, i), _(i, n);
    },
    p(l, o) {
      o & /*text*/
      2 && pe(
        n,
        /*text*/
        l[1]
      );
    },
    d(l) {
      l && P(e);
    }
  };
}
function Sm(t) {
  let e, i, n, l, o, r, a, s, d, u, c, g;
  function h(w, y) {
    return !/*current*/
    w[2] && /*status*/
    w[0] === "complete" ? qm : Lm;
  }
  let m = h(t), v = m(t), b = !/*_isMobile*/
  t[7] && mr(t);
  return {
    c() {
      e = C("label"), i = C("input"), o = x(), r = C("div"), v.c(), a = x(), b && b.c(), f(
        i,
        "id",
        /*text*/
        t[1]
      ), f(i, "type", "checkbox"), i.checked = /*current*/
      t[2], f(i, "aria-disabled", n = !/*_isEnabled*/
      t[9]), i.disabled = l = !/*_isEnabled*/
      t[9], f(i, "data-testid", "checkbox"), f(i, "class", "svelte-6d3t92"), f(r, "data-testid", "status"), f(r, "class", "status svelte-6d3t92"), G(
        r,
        "incomplete",
        /*status*/
        t[0] === "incomplete"
      ), G(
        r,
        "current",
        /*current*/
        t[2]
      ), f(
        e,
        "id",
        /*arialabel*/
        t[4]
      ), f(e, "role", "listitem"), f(e, "tabindex", "-1"), f(
        e,
        "for",
        /*text*/
        t[1]
      ), f(
        e,
        "data-status",
        /*status*/
        t[0]
      ), f(e, "aria-current", s = /*current*/
      t[2] ? "step" : "false"), f(e, "aria-label", d = /*arialabel*/
      t[4] || `${/*text*/
      t[1]} ${/*status*/
      t[0] || ""}`), f(e, "data-testid", "label"), f(e, "style", u = `
      --background-color: ${/*_backgroundColor*/
      t[8]};
    `), f(e, "class", "svelte-6d3t92"), G(
        e,
        "mobile",
        /*_isMobile*/
        t[7]
      ), G(e, "desktop", !/*_isMobile*/
      t[7]);
    },
    m(w, y) {
      D(w, e, y), _(e, i), t[12](i), _(e, o), _(e, r), v.m(r, null), _(e, a), b && b.m(e, null), t[13](e), c || (g = te(
        i,
        "click",
        /*onClick*/
        t[10]
      ), c = !0);
    },
    p(w, [y]) {
      y & /*text*/
      2 && f(
        i,
        "id",
        /*text*/
        w[1]
      ), y & /*current*/
      4 && (i.checked = /*current*/
      w[2]), y & /*_isEnabled*/
      512 && n !== (n = !/*_isEnabled*/
      w[9]) && f(i, "aria-disabled", n), y & /*_isEnabled*/
      512 && l !== (l = !/*_isEnabled*/
      w[9]) && (i.disabled = l), m === (m = h(w)) && v ? v.p(w, y) : (v.d(1), v = m(w), v && (v.c(), v.m(r, null))), y & /*status*/
      1 && G(
        r,
        "incomplete",
        /*status*/
        w[0] === "incomplete"
      ), y & /*current*/
      4 && G(
        r,
        "current",
        /*current*/
        w[2]
      ), /*_isMobile*/
      w[7] ? b && (b.d(1), b = null) : b ? b.p(w, y) : (b = mr(w), b.c(), b.m(e, null)), y & /*arialabel*/
      16 && f(
        e,
        "id",
        /*arialabel*/
        w[4]
      ), y & /*text*/
      2 && f(
        e,
        "for",
        /*text*/
        w[1]
      ), y & /*status*/
      1 && f(
        e,
        "data-status",
        /*status*/
        w[0]
      ), y & /*current*/
      4 && s !== (s = /*current*/
      w[2] ? "step" : "false") && f(e, "aria-current", s), y & /*arialabel, text, status*/
      19 && d !== (d = /*arialabel*/
      w[4] || `${/*text*/
      w[1]} ${/*status*/
      w[0] || ""}`) && f(e, "aria-label", d), y & /*_backgroundColor*/
      256 && u !== (u = `
      --background-color: ${/*_backgroundColor*/
      w[8]};
    `) && f(e, "style", u), y & /*_isMobile*/
      128 && G(
        e,
        "mobile",
        /*_isMobile*/
        w[7]
      ), y & /*_isMobile*/
      128 && G(e, "desktop", !/*_isMobile*/
      w[7]);
    },
    i: ve,
    o: ve,
    d(w) {
      w && P(e), t[12](null), v.d(), b && b.d(), t[13](null), c = !1, g();
    }
  };
}
function Tm(t, e, i) {
  let n, { text: l } = e, { status: o = void 0 } = e, r = !1, a = !1, s, d = "", u, c, g, h;
  ke(() => {
    u.addEventListener("form-stepper:resized", (y) => {
      const { mobile: j } = y.detail;
      i(7, g = j);
    }), u.addEventListener("formstepper:init", (y) => {
      const j = y;
      i(4, d = j.detail.ariaLabel), i(11, a = j.detail.enabled), i(3, s = j.detail.childIndex), i(2, r = j.detail.current), i(0, o = j.detail.status), i(7, g = j.detail.mobile), i(8, h = j.detail.backgroundColor);
    }), u.addEventListener("formstepper:enabled:changed", (y) => {
      i(11, a = y.detail.enabled);
    }), u.addEventListener("formstepper:current:changed", (y) => {
      const j = y;
      i(11, a = !0), i(2, r = j.detail.current);
    }), m(u);
  });
  function m(y) {
    setTimeout(
      () => {
        y.dispatchEvent(new CustomEvent(
          "formstep:mounted",
          {
            detail: { el: u, status: o },
            composed: !0,
            bubbles: !0
          }
        ));
      },
      10
    );
  }
  function v(y) {
    n && (i(6, c.checked = !c.checked, c), u.dispatchEvent(new CustomEvent(
      "_click",
      {
        composed: !0,
        bubbles: !0,
        detail: { step: +s }
      }
    )), y.stopPropagation());
  }
  function b(y) {
    ue[y ? "unshift" : "push"](() => {
      c = y, i(6, c);
    });
  }
  function w(y) {
    ue[y ? "unshift" : "push"](() => {
      u = y, i(5, u);
    });
  }
  return t.$$set = (y) => {
    "text" in y && i(1, l = y.text), "status" in y && i(0, o = y.status);
  }, t.$$.update = () => {
    t.$$.dirty & /*enabled, status*/
    2049 && i(9, n = a || o === "complete");
  }, [
    o,
    l,
    r,
    s,
    d,
    u,
    c,
    g,
    h,
    n,
    v,
    a,
    b,
    w
  ];
}
class Pm extends me {
  constructor(e) {
    super(), ge(this, e, Tm, Sm, ce, { text: 1, status: 0 }, Mm);
  }
  get text() {
    return this.$$.ctx[1];
  }
  set text(e) {
    this.$$set({ text: e }), k();
  }
  get status() {
    return this.$$.ctx[0];
  }
  set status(e) {
    this.$$set({ status: e }), k();
  }
}
customElements.define("goax-form-step", he(Pm, { text: {}, status: {} }, [], [], !0));
export {
  Na as Accordian,
  es as AppHeader,
  Ga as AppHeaderMenu,
  rs as Badge,
  ds as Block,
  vs as Button,
  ws as ButtonGroup,
  Su as Calendar,
  Hu as Callout,
  Yu as Card,
  Au as CardActions,
  Bu as CardContent,
  Ku as CardGroup,
  $u as CardImage,
  dd as Checkbox,
  hd as Chip,
  yd as CircularProgress,
  Ld as Container,
  Dd as DatePicker,
  Ad as Details,
  Bd as Divider,
  Zd as Drawer,
  oc as Dropdown,
  Kd as DropdownItem,
  Pm as ExperimentalFormStep,
  Em as ExperimentalFormStepper,
  Jc as Fieldset,
  pc as FileUploadCard,
  Cc as FileUploadInput,
  Mc as FilterChip,
  Tc as FocusTrap,
  Ic as Footer,
  Wc as FooterMetaSection,
  Uc as FooterNavSection,
  ef as Form,
  Af as FormItem,
  rf as FormPage,
  Yf as FormStep,
  Kf as FormStepper,
  ff as FormSummary,
  i1 as FullScreenNavbarLayout,
  r1 as Grid,
  c1 as HeroBanner,
  C1 as Icon,
  v1 as IconButton,
  S1 as Input,
  H1 as Link,
  V1 as LinkButton,
  G1 as MicrositeHeader,
  lg as Modal,
  sg as Notification,
  hg as OneColumnLayout,
  wg as PageBlock,
  Cg as Pages,
  Mg as Pagination,
  Pg as Popover,
  Ng as RadioGroup,
  Vg as RadioItem,
  Zg as Scrollable,
  nh as SideMenu,
  $g as SideMenuGroup,
  sh as SideMenuHeading,
  Je as Skeleton,
  _h as Spacer,
  jh as Spinner,
  bf as SubForm,
  wf as SubFormIndex,
  qh as Tab,
  Oh as Table,
  Nh as TableSortHeader,
  Zh as Tabs,
  zf as Task,
  Lf as TaskList,
  Xh as Text,
  im as TextArea,
  cm as ThreeColumnLayout,
  mm as Tooltip,
  ym as TwoColumnLayout
};
